(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core-core-api'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core-core-api'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'core-core-api'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'core-core-api'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'core-core-api'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'core-core-api'.");
    }
    root['core-core-api'] = factory(typeof this['core-core-api'] === 'undefined' ? {} : this['core-core-api'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlinx-serialization-kotlinx-serialization-json']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var sign = Math.sign;
  var protoOf = kotlin_kotlin.$_$.u9;
  var interfaceMeta = kotlin_kotlin.$_$.b9;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var THROW_IAE = kotlin_kotlin.$_$.bd;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var Enum = kotlin_kotlin.$_$.sc;
  var defineProp = kotlin_kotlin.$_$.s8;
  var classMeta = kotlin_kotlin.$_$.q8;
  var VOID = kotlin_kotlin.$_$.e;
  var Exception = kotlin_kotlin.$_$.uc;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.y;
  var captureStack = kotlin_kotlin.$_$.k8;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.s;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var charSequenceLength = kotlin_kotlin.$_$.o8;
  var sortedWith = kotlin_kotlin.$_$.n7;
  var isBlank = kotlin_kotlin.$_$.nb;
  var to = kotlin_kotlin.$_$.be;
  var Comparator = kotlin_kotlin.$_$.pc;
  var compareValues = kotlin_kotlin.$_$.d8;
  var toList = kotlin_kotlin.$_$.u7;
  var toMap = kotlin_kotlin.$_$.w7;
  var toMutableMap = kotlin_kotlin.$_$.z7;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var emptyList = kotlin_kotlin.$_$.o5;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var getStringHashCode = kotlin_kotlin.$_$.z8;
  var toString = kotlin_kotlin.$_$.z9;
  var getBooleanHashCode = kotlin_kotlin.$_$.v8;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var objectCreate = kotlin_kotlin.$_$.s9;
  var joinToString = kotlin_kotlin.$_$.e6;
  var hashCode = kotlin_kotlin.$_$.a9;
  var equals = kotlin_kotlin.$_$.t8;
  var mapCapacity = kotlin_kotlin.$_$.q6;
  var coerceAtLeast = kotlin_kotlin.$_$.fa;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.p;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.g;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var ensureNotNull = kotlin_kotlin.$_$.qd;
  var joinToString_0 = kotlin_kotlin.$_$.f6;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.v4;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.h3;
  var emptyMap = kotlin_kotlin.$_$.p5;
  var plus = kotlin_kotlin.$_$.y6;
  var listOf = kotlin_kotlin.$_$.o6;
  var plus_0 = kotlin_kotlin.$_$.b7;
  var addAll = kotlin_kotlin.$_$.m4;
  var isInterface = kotlin_kotlin.$_$.j9;
  var contentEquals = kotlin_kotlin.$_$.z4;
  var contentHashCode = kotlin_kotlin.$_$.a5;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.h1;
  var get_lastIndex = kotlin_kotlin.$_$.i6;
  var compareTo = kotlin_kotlin.$_$.r8;
  var first = kotlin_kotlin.$_$.v5;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.q;
  var Map = kotlin_kotlin.$_$.g4;
  var firstOrNull = kotlin_kotlin.$_$.u5;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.g1;
  var asSequence = kotlin_kotlin.$_$.ra;
  var toList_0 = kotlin_kotlin.$_$.fb;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.k1;
  var sequenceOf = kotlin_kotlin.$_$.db;
  var mapNotNull = kotlin_kotlin.$_$.ya;
  var flatten = kotlin_kotlin.$_$.xa;
  var filter = kotlin_kotlin.$_$.ua;
  var asSequence_0 = kotlin_kotlin.$_$.t4;
  var listOfNotNull = kotlin_kotlin.$_$.n6;
  var any = kotlin_kotlin.$_$.p4;
  var toString_0 = kotlin_kotlin.$_$.ae;
  var asSequence_1 = kotlin_kotlin.$_$.s4;
  var map = kotlin_kotlin.$_$.za;
  var firstOrNull_0 = kotlin_kotlin.$_$.va;
  var Collection = kotlin_kotlin.$_$.z3;
  var addAll_0 = kotlin_kotlin.$_$.n4;
  var toSet = kotlin_kotlin.$_$.gb;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.n;
  var lazy = kotlin_kotlin.$_$.wd;
  var setOf = kotlin_kotlin.$_$.h7;
  var subtract = kotlin_kotlin.$_$.r7;
  var KProperty1 = kotlin_kotlin.$_$.na;
  var getPropertyCallableRef = kotlin_kotlin.$_$.y8;
  var distinct = kotlin_kotlin.$_$.n5;
  var Pair = kotlin_kotlin.$_$.yc;
  var NotImplementedError = kotlin_kotlin.$_$.xc;
  var contains = kotlin_kotlin.$_$.x4;
  var emptySequence = kotlin_kotlin.$_$.ta;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.d1;
  var any_0 = kotlin_kotlin.$_$.o4;
  var sortedWith_0 = kotlin_kotlin.$_$.m7;
  var asIterable = kotlin_kotlin.$_$.q4;
  var flatMap = kotlin_kotlin.$_$.wa;
  var none = kotlin_kotlin.$_$.w6;
  var firstOrNull_1 = kotlin_kotlin.$_$.t5;
  var fillArrayVal = kotlin_kotlin.$_$.u8;
  var isArray = kotlin_kotlin.$_$.c9;
  var getNumberHashCode = kotlin_kotlin.$_$.x8;
  var numberToInt = kotlin_kotlin.$_$.q9;
  var until = kotlin_kotlin.$_$.ka;
  var round = kotlin_kotlin.$_$.ca;
  var KProperty0 = kotlin_kotlin.$_$.ma;
  var get_indices = kotlin_kotlin.$_$.d6;
  var contentDeepEquals = kotlin_kotlin.$_$.y4;
  var filterNotNull = kotlin_kotlin.$_$.r5;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.z;
  var MutableList = kotlin_kotlin.$_$.h4;
  var reversedArray = kotlin_kotlin.$_$.g7;
  var first_0 = kotlin_kotlin.$_$.w5;
  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.f3;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var toList_1 = kotlin_kotlin.$_$.v7;
  var mutableListOf = kotlin_kotlin.$_$.u6;
  var sequence = kotlin_kotlin.$_$.eb;
  var CoroutineImpl = kotlin_kotlin.$_$.f8;
  var SequenceScope = kotlin_kotlin.$_$.pa;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.e8;
  var addAll_1 = kotlin_kotlin.$_$.l4;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.o1;
  var charArrayOf = kotlin_kotlin.$_$.l8;
  var split = kotlin_kotlin.$_$.ub;
  var contains_0 = kotlin_kotlin.$_$.hb;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var isFinite = kotlin_kotlin.$_$.sd;
  var get_PI = kotlin_kotlin.$_$.aa;
  var NoSuchElementException_init_$Create$_0 = kotlin_kotlin.$_$.i1;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var isNaN_0 = kotlin_kotlin.$_$.ud;
  var checkIndexOverflow = kotlin_kotlin.$_$.u4;
  var distinct_0 = kotlin_kotlin.$_$.sa;
  var toMutableList = kotlin_kotlin.$_$.y7;
  var minus = kotlin_kotlin.$_$.t6;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var toIntOrNull = kotlin_kotlin.$_$.dc;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var toInt = kotlin_kotlin.$_$.ec;
  var removeFirst = kotlin_kotlin.$_$.e7;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var toMutableList_0 = kotlin_kotlin.$_$.x7;
  var removeAll = kotlin_kotlin.$_$.d7;
  var plus_1 = kotlin_kotlin.$_$.c7;
  var asList = kotlin_kotlin.$_$.r4;
  var zip = kotlin_kotlin.$_$.c8;
  var listOf_0 = kotlin_kotlin.$_$.p6;
  var plus_2 = kotlin_kotlin.$_$.z6;
  var reversed = kotlin_kotlin.$_$.ia;
  var roundToInt = kotlin_kotlin.$_$.ba;
  var println = kotlin_kotlin.$_$.h8;
  var Monotonic_instance = kotlin_kotlin.$_$.p3;
  var ValueTimeMark = kotlin_kotlin.$_$.nc;
  var Duration = kotlin_kotlin.$_$.mc;
  var Triple = kotlin_kotlin.$_$.dd;
  var numberToLong = kotlin_kotlin.$_$.r9;
  var _Duration___get_inWholeNanoseconds__impl__r5x4mr = kotlin_kotlin.$_$.l1;
  var sort = kotlin_kotlin.$_$.q7;
  var Companion_getInstance = kotlin_kotlin.$_$.o3;
  var Duration__plus_impl_yu9v8f = kotlin_kotlin.$_$.m1;
  var last = kotlin_kotlin.$_$.l6;
  var startsWith = kotlin_kotlin.$_$.vb;
  var endsWith = kotlin_kotlin.$_$.jb;
  var indexOf = kotlin_kotlin.$_$.lb;
  var numberRangeToNumber = kotlin_kotlin.$_$.o9;
  var substring = kotlin_kotlin.$_$.yb;
  var Long = kotlin_kotlin.$_$.wc;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.xd;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Action, 'Action', interfaceMeta);
  function get_isDone() {
    return this.state.equals(ActionState_DONE_getInstance());
  }
  setMetadataFor(ActionCandidate, 'ActionCandidate', interfaceMeta);
  setMetadataFor(ActionState, 'ActionState', classMeta, Enum);
  function setLogModule(logger, basePackageName, $super) {
    logger = logger === VOID ? null : logger;
    basePackageName = basePackageName === VOID ? null : basePackageName;
    return this.k1i(logger, basePackageName);
  }
  function addHistoryModule(history, historySize, $super) {
    history = history === VOID ? null : history;
    historySize = historySize === VOID ? 500 : historySize;
    return this.l1i(history, historySize);
  }
  setMetadataFor(Core, 'Core', interfaceMeta);
  setMetadataFor(CoreFactory, 'CoreFactory', interfaceMeta);
  setMetadataFor(CoreModules, 'CoreModules', interfaceMeta);
  setMetadataFor(CoreServices, 'CoreServices', classMeta);
  setMetadataFor(MissingCriticalModuleException, 'MissingCriticalModuleException', classMeta, Exception);
  setMetadataFor(AddPartAction, 'AddPartAction', classMeta, VOID, [Action]);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(AssemblyBuilder, 'AssemblyBuilder', classMeta, VOID, VOID, AssemblyBuilder);
  setMetadataFor(AssemblyPart, 'AssemblyPart', classMeta);
  setMetadataFor(AssemblyPartSnapInfo, 'AssemblyPartSnapInfo', classMeta, VOID, VOID, AssemblyPartSnapInfo);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AssemblyPartConnectorInfo, 'AssemblyPartConnectorInfo', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  function get_serializable() {
    return false;
  }
  function get_doStoreInSnapshot() {
    return true;
  }
  setMetadataFor(Component, 'Component', interfaceMeta);
  setMetadataFor(AssemblyPartIdsComponent, 'AssemblyPartIdsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AssemblyPartsComponent, 'AssemblyPartsComponent', classMeta, VOID, [Component], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(AssemblyStructureComponent, 'AssemblyStructureComponent', classMeta, VOID, [Component]);
  setMetadataFor(PartPair, 'PartPair', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(Serialized, 'Serialized', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(JsonSerializable, 'JsonSerializable', interfaceMeta);
  function get_serializable_0() {
    return true;
  }
  setMetadataFor(SerializableComponent, 'SerializableComponent', interfaceMeta, VOID, [JsonSerializable, Component]);
  setMetadataFor(ProductPartComponent, 'ProductPartComponent', classMeta, VOID, [SerializableComponent]);
  setMetadataFor(RemovePartAction, 'RemovePartAction', classMeta, VOID, [Action]);
  function beforeDeserialize(json, catalogVersion) {
    return json;
  }
  function beforeParsingComponents(serializableTree, catalogVersion) {
  }
  function beforeBuildingEntities(serializableTree, catalogVersion) {
  }
  function afterDeserializeComplete(root, catalogVersion) {
  }
  setMetadataFor(SerializableCatalogInterceptor, 'SerializableCatalogInterceptor', interfaceMeta);
  function createCustomAssembly(originalProduct, newParts, productManager) {
    var newSpecification = this.createCustomAssemblySpecification(originalProduct, newParts);
    var tmp;
    if (newSpecification == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.catalog.ProductCatalog.createCustomAssembly.<anonymous>' call
      tmp = productManager.createFromSpecification(originalProduct, newSpecification);
    }
    return tmp;
  }
  function createCustomAssemblySpecification(originalProduct, newParts) {
    var specification = this.productSpecification(originalProduct);
    var tmp;
    if (specification == null) {
      tmp = null;
    } else {
      Companion_getInstance_3();
      tmp = specification._findComponentKt(43);
    }
    var partsComponent = tmp;
    var tmp2_safe_receiver = partsComponent == null ? null : partsComponent.i1l_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(tmp2_safe_receiver.n());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = tmp2_safe_receiver.q2().t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.core.catalog.ProductCatalog.createCustomAssemblySpecification.<anonymous>' call
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable = 0;
          var last = newParts.length;
          while (inductionVariable < last) {
            var element = newParts[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.catalog.ProductCatalog.createCustomAssemblySpecification.<anonymous>.<anonymous>' call
            if (element.partKey === item.t2()) {
              tmp$ret$2 = element;
              break $l$block;
            }
          }
          tmp$ret$2 = null;
        }
        var tmp0_safe_receiver = tmp$ret$2;
        var newPartProductRef = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.productRef;
        var tmp_1;
        if (!(newPartProductRef == null)) {
          tmp_1 = to(item.t2(), newPartProductRef);
        } else {
          tmp_1 = to(item.t2(), item.u2());
        }
        var tmp$ret$4 = tmp_1;
        destination.q(tmp$ret$4);
      }
      tmp_0 = destination;
    }
    var tmp3_safe_receiver = tmp_0;
    var newPartsMap = tmp3_safe_receiver == null ? null : toMap(tmp3_safe_receiver);
    var tmp_2;
    if (!(newPartsMap == null)) {
      tmp_2 = specification.addComponent(new AssemblyPartsComponent(newPartsMap));
    } else {
      tmp_2 = specification;
    }
    return tmp_2;
  }
  setMetadataFor(ProductCatalog, 'ProductCatalog', interfaceMeta, VOID, [SerializableCatalogInterceptor]);
  setMetadataFor(ProductCatalogFunctions, 'ProductCatalogFunctions', objectMeta);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(ProductComponent, 'ProductComponent', classMeta, VOID, [Component]);
  function createEntity(productRef, entityId, parent, $super) {
    entityId = entityId === VOID ? null : entityId;
    parent = parent === VOID ? null : parent;
    return this.e1m(productRef, entityId, parent);
  }
  function createEntityInternal(productRef, entityId, parent, $super) {
    entityId = entityId === VOID ? null : entityId;
    parent = parent === VOID ? null : parent;
    return this.f1m(productRef, entityId, parent);
  }
  function createFromSpecification(productRef, specification, entityId, $super) {
    entityId = entityId === VOID ? null : entityId;
    return this.g1m(productRef, specification, entityId);
  }
  function createFromSpecificationInternal(productRef, specification, entityId, $super) {
    entityId = entityId === VOID ? null : entityId;
    return this.h1m(productRef, specification, entityId);
  }
  setMetadataFor(ProductManager, 'ProductManager', interfaceMeta);
  setMetadataFor(ProductSpecification, 'ProductSpecification', classMeta);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(ProductStructureBuilder, 'ProductStructureBuilder', classMeta, VOID, VOID, ProductStructureBuilder);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(ProductStructureComponent, 'ProductStructureComponent', classMeta, VOID, [Component]);
  setMetadataFor(ProductStructureConnection, 'ProductStructureConnection', classMeta);
  setMetadataFor(ProductStructureItem, 'ProductStructureItem', classMeta);
  setMetadataFor(CircularBuffer$iterator$1, VOID, classMeta);
  setMetadataFor(CircularBuffer, 'CircularBuffer', classMeta);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(ColliderComponent, 'ColliderComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(ColliderShapeComponent, 'ColliderShapeComponent', classMeta, VOID, [Component]);
  setMetadataFor(ColliderUtils, 'ColliderUtils', objectMeta);
  setMetadataFor(Collision, 'Collision', classMeta);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor(CollisionConstants, 'CollisionConstants', classMeta, VOID, VOID, CollisionConstants);
  setMetadataFor(CollisionUtils, 'CollisionUtils', objectMeta);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  function findRoot(snapActionCandidate, entity) {
    var tmp1_elvis_lhs = snapActionCandidate == null ? null : snapActionCandidate.host;
    var mainEntity = tmp1_elvis_lhs == null ? entity : tmp1_elvis_lhs;
    return HierarchyUtils_instance.rootOf(mainEntity);
  }
  setMetadataFor(Validation, 'Validation', interfaceMeta);
  setMetadataFor(ValidationImpl, 'ValidationImpl', classMeta, VOID, [Validation]);
  setMetadataFor(CollisionValidation, 'CollisionValidation', classMeta, ValidationImpl, VOID, CollisionValidation);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(ValidationResult, 'ValidationResult', classMeta);
  setMetadataFor(CollisionValidationResult, 'CollisionValidationResult', classMeta, ValidationResult);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(System, 'System', interfaceMeta);
  setMetadataFor(EcsSystem, 'EcsSystem', interfaceMeta, VOID, [System]);
  setMetadataFor(EcsSystemImpl, 'EcsSystemImpl', classMeta, VOID, [EcsSystem]);
  setMetadataFor(SystemBase, 'SystemBase', classMeta, EcsSystemImpl);
  setMetadataFor(SystemBase2, 'SystemBase2', classMeta, SystemBase);
  setMetadataFor(WorldColliderUpdateSystem, 'WorldColliderUpdateSystem', classMeta, SystemBase2, VOID, WorldColliderUpdateSystem);
  setMetadataFor(ComponentIdSpan, 'ComponentIdSpan', objectMeta);
  setMetadataFor(ComponentIds, 'ComponentIds', objectMeta);
  setMetadataFor(ComponentUtils, 'ComponentUtils', objectMeta);
  setMetadataFor(AlignmentConnection, 'AlignmentConnection', classMeta);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(ChildConnectionValidation, 'ChildConnectionValidation', classMeta, ValidationImpl, VOID, ChildConnectionValidation);
  setMetadataFor(Connection, 'Connection', classMeta);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor(ConnectionRootComponent, 'ConnectionRootComponent', classMeta, VOID, [Component], ConnectionRootComponent);
  setMetadataFor(ConnectionUtils, 'ConnectionUtils', objectMeta);
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor(GuestConnectionsComponent, 'GuestConnectionsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_18, 'Companion', objectMeta);
  setMetadataFor(HostConnectionsComponent, 'HostConnectionsComponent', classMeta, VOID, [Component], HostConnectionsComponent);
  setMetadataFor(Companion_19, 'Companion', objectMeta);
  setMetadataFor(TemporarilyPauseConnectionParentingComponent, 'TemporarilyPauseConnectionParentingComponent', classMeta, VOID, [Component], TemporarilyPauseConnectionParentingComponent);
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor(UpdateHostConnectionsSystem, 'UpdateHostConnectionsSystem', classMeta, SystemBase, VOID, UpdateHostConnectionsSystem);
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor(Connector, 'Connector', classMeta);
  setMetadataFor(ConnectorTagConstants, 'ConnectorTagConstants', objectMeta);
  setMetadataFor(ConnectorType, 'ConnectorType', objectMeta);
  setMetadataFor(ConnectorUtils, 'ConnectorUtils', objectMeta);
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ConnectorsComponent, 'ConnectorsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor(DisableConnectorsSystem, 'DisableConnectorsSystem', classMeta, SystemBase, VOID, DisableConnectorsSystem);
  setMetadataFor(Companion_24, 'Companion', objectMeta);
  setMetadataFor(DisabledConnectorsComponent, 'DisabledConnectorsComponent', classMeta, VOID, [Component]);
  setMetadataFor(EdgeConnector, 'EdgeConnector', classMeta, Connector);
  setMetadataFor(PointConnector, 'PointConnector', classMeta, Connector);
  setMetadataFor(PointSeriesConnector, 'PointSeriesConnector', classMeta, Connector);
  setMetadataFor(PointSeriesSubConnector, 'PointSeriesSubConnector', classMeta, Connector);
  setMetadataFor(RelativeConnectorData, 'RelativeConnectorData', classMeta);
  setMetadataFor(RelativeConnectorRepositioner, 'RelativeConnectorRepositioner', objectMeta);
  setMetadataFor(Companion_25, 'Companion', objectMeta);
  setMetadataFor(RelativeConnectorsComponent, 'RelativeConnectorsComponent', classMeta, VOID, [Component]);
  setMetadataFor(RotationDegreeOfFreedom, 'RotationDegreeOfFreedom', classMeta, Enum);
  setMetadataFor(RotationDegreeOfFreedomImpostor, 'RotationDegreeOfFreedomImpostor', objectMeta);
  setMetadataFor(Companion_26, 'Companion', objectMeta);
  setMetadataFor(SurfaceConnector, 'SurfaceConnector', classMeta, Connector);
  setMetadataFor(DebugLine, 'DebugLine', classMeta);
  setMetadataFor(Companion_27, 'Companion', objectMeta);
  setMetadataFor(DebugLinesComponent, 'DebugLinesComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor(DebugSurfacesComponent, 'DebugSurfacesComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor(DragSurfacesComponent, 'DragSurfacesComponent', classMeta, VOID, [Component]);
  setMetadataFor(DragSurface, 'DragSurface', classMeta);
  setMetadataFor(Companion_30, 'Companion', objectMeta);
  setMetadataFor(DraggableComponent, 'DraggableComponent', classMeta, VOID, [Component], DraggableComponent);
  setMetadataFor(Companion_31, 'Companion', objectMeta);
  setMetadataFor(SomethingIsDraggedComponent, 'SomethingIsDraggedComponent', classMeta, VOID, [Component]);
  setMetadataFor(DragType, 'DragType', classMeta, Enum);
  setMetadataFor(Companion_32, 'Companion', objectMeta);
  setMetadataFor(ViewerDragEventComponent, 'ViewerDragEventComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_33, 'Companion', objectMeta);
  setMetadataFor(WorldDragSurfaceUpdateSystem, 'WorldDragSurfaceUpdateSystem', classMeta, SystemBase2, VOID, WorldDragSurfaceUpdateSystem);
  setMetadataFor(Companion_34, 'Companion', objectMeta);
  setMetadataFor(WorldDragSurfacesComponent, 'WorldDragSurfacesComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_35, 'Companion', objectMeta);
  setMetadataFor(WorldSpaceDragEventComponent, 'WorldSpaceDragEventComponent', classMeta, VOID, [Component]);
  setMetadataFor(ComponentHolder, 'ComponentHolder', classMeta, VOID, VOID, ComponentHolder);
  setMetadataFor(ComponentListener, 'ComponentListener', interfaceMeta);
  setMetadataFor(Companion_36, 'Companion', objectMeta);
  setMetadataFor(Entity, 'Entity', classMeta);
  setMetadataFor(EntityManager, 'EntityManager', interfaceMeta);
  setMetadataFor(Companion_37, 'Companion', objectMeta);
  setMetadataFor(EntityManagerImpl, 'EntityManagerImpl', classMeta, VOID, [EntityManager], EntityManagerImpl);
  setMetadataFor(EntityManagerWatcher, 'EntityManagerWatcher', interfaceMeta);
  setMetadataFor(EntityManagerWatcherList, 'EntityManagerWatcherList', classMeta, VOID, [MutableList, EntityManagerWatcher], EntityManagerWatcherList);
  setMetadataFor(ComponentListenerImpl, 'ComponentListenerImpl', classMeta, VOID, [ComponentListener]);
  setMetadataFor(Companion_38, 'Companion', objectMeta);
  setMetadataFor(SystemBase3, 'SystemBase3', classMeta, SystemBase2);
  setMetadataFor(SystemBase4, 'SystemBase4', classMeta, SystemBase3);
  setMetadataFor(SystemBase5, 'SystemBase5', classMeta, SystemBase4);
  setMetadataFor(SystemGraphHelper, 'SystemGraphHelper', objectMeta);
  setMetadataFor(Companion_39, 'Companion', objectMeta);
  setMetadataFor(AutomaticGroupBuilderSystem, 'AutomaticGroupBuilderSystem', classMeta, SystemBase);
  setMetadataFor(Companion_40, 'Companion', objectMeta);
  setMetadataFor(AutomaticGroupComponent, 'AutomaticGroupComponent', classMeta, VOID, [Component, SerializableComponent], AutomaticGroupComponent);
  setMetadataFor(Companion_41, 'Companion', objectMeta);
  setMetadataFor(AutomaticGroupIdCountComponent, 'AutomaticGroupIdCountComponent', classMeta, VOID, [Component]);
  setMetadataFor(EntityGroupUtils, 'EntityGroupUtils', objectMeta);
  setMetadataFor(Companion_42, 'Companion', objectMeta);
  setMetadataFor(ManualEntityGroupBuilderService, 'ManualEntityGroupBuilderService', classMeta);
  setMetadataFor(Companion_43, 'Companion', objectMeta);
  setMetadataFor(ManualGroupComponent, 'ManualGroupComponent', classMeta, VOID, [SerializableComponent], ManualGroupComponent);
  setMetadataFor(Companion_44, 'Companion', objectMeta);
  setMetadataFor(ManualGroupConnectorValidation, 'ManualGroupConnectorValidation', classMeta, ValidationImpl);
  setMetadataFor(Companion_45, 'Companion', objectMeta);
  setMetadataFor(ManualGroupIdCountComponent, 'ManualGroupIdCountComponent', classMeta, VOID, [Component]);
  setMetadataFor(StaticComponent, 'StaticComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_46, 'Companion', objectMeta);
  setMetadataFor(ChildComponent, 'ChildComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_47, 'Companion', objectMeta);
  setMetadataFor(ConnectionParentingSystem, 'ConnectionParentingSystem', classMeta, SystemBase, VOID, ConnectionParentingSystem);
  setMetadataFor(Companion_48, 'Companion', objectMeta);
  setMetadataFor(HierarchySystem, 'HierarchySystem', classMeta, SystemBase);
  setMetadataFor(HierarchyUtils, 'HierarchyUtils', objectMeta);
  setMetadataFor(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda, 'hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda, 'hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(InSceneComponent, 'InSceneComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_49, 'Companion', objectMeta);
  setMetadataFor(ParentComponent, 'ParentComponent', classMeta, VOID, [Component]);
  setMetadataFor(SceneComponent, 'SceneComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_50, 'Companion', objectMeta);
  setMetadataFor(SceneGraphSystem, 'SceneGraphSystem', classMeta, SystemBase);
  setMetadataFor(SceneManager, 'SceneManager', interfaceMeta);
  function takeSnapshot(snapshotName, $super) {
    snapshotName = snapshotName === VOID ? '' : snapshotName;
    return this.h2a(snapshotName);
  }
  setMetadataFor(History, 'History', interfaceMeta);
  setMetadataFor(HistoryEventType, 'HistoryEventType', classMeta, Enum);
  setMetadataFor(HistoryEvent, 'HistoryEvent', objectMeta);
  setMetadataFor(Companion_51, 'Companion', objectMeta);
  setMetadataFor(HistoryChangedEventComponent, 'HistoryChangedEventComponent', classMeta, VOID, [Component]);
  setMetadataFor(HistoryImpl, 'HistoryImpl', classMeta, VOID, [History]);
  setMetadataFor(LogLevel, 'LogLevel', classMeta, Enum);
  setMetadataFor(LogLevelJavascriptImpostor, 'LogLevelJavascriptImpostor', objectMeta);
  function set_logLevel(newLevel) {
    this.level = values_3()[newLevel];
  }
  function get_logLevel() {
    return this.level.x9_1;
  }
  setMetadataFor(Logger, 'Logger', interfaceMeta);
  setMetadataFor(LoggerImpl, 'LoggerImpl', classMeta, VOID, [Logger], LoggerImpl);
  setMetadataFor(LoggerWrap, 'LoggerWrap', classMeta, VOID, [Logger]);
  setMetadataFor(LoggerState, 'LoggerState', objectMeta);
  setMetadataFor(MockLogger, 'MockLogger', classMeta, VOID, [Logger], MockLogger);
  setMetadataFor(AxisAngle, 'AxisAngle', classMeta);
  setMetadataFor(Degrees, 'Degrees', classMeta);
  function alignBottom(outer) {
    return new Vector(0.0, -this.height / 2 + outer.height / 2, 0.0);
  }
  function alignTop(outer) {
    return this.alignBottom(outer).unaryMinus();
  }
  function alignRight(outer) {
    return new Vector(this.width / 2 - outer.width / 2, 0.0, 0.0);
  }
  function alignLeft(outer) {
    return this.alignRight(outer).unaryMinus();
  }
  function alignFront(outer) {
    return new Vector(0.0, 0.0, this.depth / 2 - outer.depth / 2);
  }
  function alignBack(outer) {
    return this.alignFront(outer).unaryMinus();
  }
  setMetadataFor(Dimension, 'Dimension', interfaceMeta);
  setMetadataFor(DualDouble, 'DualDouble', classMeta);
  setMetadataFor(Companion_52, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Margin, 'Margin', classMeta, VOID, VOID, Margin, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Axis, 'Axis', classMeta, Enum);
  setMetadataFor(MathUtils, 'MathUtils', objectMeta);
  setMetadataFor(Companion_53, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ModelTransform, 'ModelTransform', classMeta, VOID, VOID, ModelTransform, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_54, 'Companion', objectMeta);
  setMetadataFor(Raycastable, 'Raycastable', interfaceMeta);
  setMetadataFor(Plane, 'Plane', classMeta, VOID, [Raycastable]);
  setMetadataFor(Companion_55, 'Companion', objectMeta);
  setMetadataFor(Polygon, 'Polygon', classMeta, VOID, [Raycastable]);
  setMetadataFor(Companion_56, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Quaternion, 'Quaternion', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Radians, 'Radians', classMeta);
  setMetadataFor(RelativeBoxOffset, 'RelativeBoxOffset', classMeta);
  setMetadataFor(RelationOriginAlongX, 'RelationOriginAlongX', classMeta, Enum);
  setMetadataFor(RelationOriginAlongXImpostor, 'RelationOriginAlongXImpostor', objectMeta);
  setMetadataFor(RelationOriginAlongY, 'RelationOriginAlongY', classMeta, Enum);
  setMetadataFor(RelationOriginAlongYImpostor, 'RelationOriginAlongYImpostor', objectMeta);
  setMetadataFor(RelationOriginAlongZ, 'RelationOriginAlongZ', classMeta, Enum);
  setMetadataFor(RelationOriginAlongZImpostor, 'RelationOriginAlongZImpostor', objectMeta);
  setMetadataFor(Companion_57, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RelationOrigin, 'RelationOrigin', classMeta, VOID, VOID, RelationOrigin, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_58, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Size, 'Size', classMeta, VOID, [Dimension], Size, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_59, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Transform, 'Transform', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_60, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Vector, 'Vector', classMeta, VOID, [Dimension], Vector, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(VectorConstants, 'VectorConstants', objectMeta);
  setMetadataFor(InnerMeasurement, 'InnerMeasurement', classMeta);
  setMetadataFor(MeasurementUtils, 'MeasurementUtils', objectMeta);
  setMetadataFor(Companion_61, 'Companion', objectMeta);
  setMetadataFor(DisplayNameComponent, 'DisplayNameComponent', classMeta, VOID, [Component]);
  setMetadataFor(ProductUtils, 'ProductUtils', objectMeta);
  setMetadataFor(ProppingComponent, 'ProppingComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_62, 'Companion', objectMeta);
  setMetadataFor(TemplateDataComponent, 'TemplateDataComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_63, 'Companion', objectMeta);
  setMetadataFor(Ray, 'Ray', classMeta);
  setMetadataFor(RaycastHit, 'RaycastHit', classMeta);
  setMetadataFor(RaycastResult, 'RaycastResult', classMeta);
  setMetadataFor(RaycastUtils, 'RaycastUtils', objectMeta);
  setMetadataFor(Companion_64, 'Companion', objectMeta);
  setMetadataFor(LoadedModelInfoComponent, 'LoadedModelInfoComponent', classMeta, VOID, [Component], LoadedModelInfoComponent);
  setMetadataFor(Companion_65, 'Companion', objectMeta);
  setMetadataFor(ModelInfoComponent, 'ModelInfoComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_66, 'Companion', objectMeta);
  setMetadataFor(ModelLoaderSystem, 'ModelLoaderSystem', classMeta, SystemBase4);
  setMetadataFor(Companion_67, 'Companion', objectMeta);
  setMetadataFor(ModelTransformComponent, 'ModelTransformComponent', classMeta, VOID, [Component]);
  setMetadataFor(ModelUtils, 'ModelUtils', objectMeta);
  setMetadataFor(Companion_68, 'Companion', objectMeta);
  setMetadataFor(OutlineableComponent, 'OutlineableComponent', classMeta, VOID, [Component], OutlineableComponent);
  setMetadataFor(Companion_69, 'Companion', objectMeta);
  setMetadataFor(PauseViewerUpdatesComponent, 'PauseViewerUpdatesComponent', classMeta, VOID, [Component], PauseViewerUpdatesComponent);
  setMetadataFor(Companion_70, 'Companion', objectMeta);
  setMetadataFor(RenderSystem, 'RenderSystem', classMeta, SystemBase, VOID, RenderSystem);
  setMetadataFor(RenderedComponent, 'RenderedComponent', objectMeta, VOID, [Component]);
  function createSphere(radius, entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.x2i(radius, entity);
  }
  function cloneObject(vo, entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.y2i(vo, entity);
  }
  function createBox(width, height, depth, entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.z2i(width, height, depth, entity);
  }
  function createPlane(width, depth, entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.a2j(width, depth, entity);
  }
  function createSurface(vertices, normal, entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.b2j(vertices, normal, entity);
  }
  function groupMeshes(meshes, entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.c2j(meshes, entity);
  }
  function createUiLine(start, end, color, thickness, $super) {
    color = color === VOID ? Companion_getInstance_61().ZERO : color;
    return this.d2j(start, end, color, thickness);
  }
  function createUiDashedLine(start, end, color, thickness, $super) {
    color = color === VOID ? Companion_getInstance_61().ZERO : color;
    return this.e2j(start, end, color, thickness);
  }
  function updateUiLine(id, start, end, color, thickness, $super) {
    color = color === VOID ? Companion_getInstance_61().ZERO : color;
    return this.f2j(id, start, end, color, thickness);
  }
  function loadModel(entity, url, textureFile, modelLoaded, modelLoadFailed, loadingBoxSize, loadingBoxCenter, $super) {
    loadingBoxSize = loadingBoxSize === VOID ? null : loadingBoxSize;
    loadingBoxCenter = loadingBoxCenter === VOID ? null : loadingBoxCenter;
    return this.g2j(entity, url, textureFile, modelLoaded, modelLoadFailed, loadingBoxSize, loadingBoxCenter);
  }
  function debug(enable, $super) {
    enable = enable === VOID ? false : enable;
    return this.h2j(enable);
  }
  function createEmpty(entity, $super) {
    entity = entity === VOID ? null : entity;
    return this.i2j(entity);
  }
  function createGhostModel(modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize, $super) {
    r = r === VOID ? 0.0 : r;
    g = g === VOID ? 0.0 : g;
    b = b === VOID ? 1.0 : b;
    alpha = alpha === VOID ? 0.5 : alpha;
    loadingBoxSize = loadingBoxSize === VOID ? null : loadingBoxSize;
    return this.j2j(modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize);
  }
  setMetadataFor(Viewer, 'Viewer', interfaceMeta);
  setMetadataFor(Companion_71, 'Companion', objectMeta);
  setMetadataFor(ViewerComponent, 'ViewerComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_72, 'Companion', objectMeta);
  setMetadataFor(ViewerLineIdsComponent, 'ViewerLineIdsComponent', classMeta, VOID, [Component]);
  function setPosition(v) {
    return this.setPositionPrimitive(v.X, v.Y, v.Z);
  }
  function setScaleV(v) {
    return this.setScale(v.X, v.Y, v.Z);
  }
  setMetadataFor(ViewerObject, 'ViewerObject', interfaceMeta);
  setMetadataFor(Companion_73, 'Companion', objectMeta);
  setMetadataFor(ViewerObjectComponent, 'ViewerObjectComponent', classMeta, VOID, [Component]);
  setMetadataFor(ViewerObjectTransformSystem, 'ViewerObjectTransformSystem', classMeta, SystemBase4, VOID, ViewerObjectTransformSystem);
  setMetadataFor(ViewerObjectVisibilitySystem, 'ViewerObjectVisibilitySystem', classMeta, SystemBase3, VOID, ViewerObjectVisibilitySystem);
  setMetadataFor(ViewerPresenceSystem, 'ViewerPresenceSystem', classMeta, SystemBase);
  setMetadataFor(ViewerMock, 'ViewerMock', classMeta, VOID, [Viewer], ViewerMock);
  setMetadataFor(Companion_74, 'Companion', objectMeta);
  setMetadataFor(MockDragGenerator, 'MockDragGenerator', classMeta);
  setMetadataFor(Companion_75, 'Companion', objectMeta);
  setMetadataFor(ViewerObjectMock, 'ViewerObjectMock', classMeta, VOID, [ViewerObject], ViewerObjectMock);
  setMetadataFor(Companion_76, 'Companion', objectMeta);
  setMetadataFor(EntityReplaceHelper, 'EntityReplaceHelper', classMeta);
  setMetadataFor(Companion_77, 'Companion', objectMeta);
  setMetadataFor(FastReplaceAction, 'FastReplaceAction', classMeta, VOID, [Action]);
  setMetadataFor(ReplaceAction, 'ReplaceAction', classMeta, VOID, [Action]);
  setMetadataFor(ReplacePartAction, 'ReplacePartAction', classMeta, VOID, [Action]);
  setMetadataFor(Companion_78, 'Companion', objectMeta);
  setMetadataFor(ClickEventComponent, 'ClickEventComponent', classMeta, VOID, [Component]);
  setMetadataFor(MultiSelectionEnabledComponent, 'MultiSelectionEnabledComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_79, 'Companion', objectMeta);
  setMetadataFor(SelectableComponent, 'SelectableComponent', classMeta, VOID, [Component], SelectableComponent);
  setMetadataFor(SelectedComponent, 'SelectedComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_80, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CatalogsHeader, 'CatalogsHeader', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(ComponentDeserializer, 'ComponentDeserializer', interfaceMeta);
  setMetadataFor(ComponentDeserializerRegistry, 'ComponentDeserializerRegistry', classMeta, VOID, VOID, ComponentDeserializerRegistry);
  setMetadataFor(Companion_81, 'Companion', objectMeta);
  setMetadataFor(Serializer, 'Serializer', interfaceMeta);
  setMetadataFor(JsonSerializer, 'JsonSerializer', classMeta, VOID, [Serializer], JsonSerializer);
  setMetadataFor(Companion_82, 'Companion', objectMeta);
  setMetadataFor(PreviouslySerializedIdComponent, 'PreviouslySerializedIdComponent', classMeta, VOID, [Component]);
  setMetadataFor(SceneReloadingComponent, 'SceneReloadingComponent', objectMeta, VOID, [Component]);
  function addComponent(key, json) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = ensureNotNull(this.serializedComponents);
    var value = Default_getInstance().m15(json);
    this_0.r2(key, value);
  }
  setMetadataFor(SerializableEntity, 'SerializableEntity', interfaceMeta);
  setMetadataFor(Companion_83, 'Companion', objectMeta);
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Companion_84, 'Companion', objectMeta);
  setMetadataFor(SerializableConnection, 'SerializableConnection', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SerializableGuestConnectionsComponent, 'SerializableGuestConnectionsComponent', classMeta, VOID, [SerializableComponent], VOID, VOID, {0: $serializer_getInstance_11});
  function entitiesArray() {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.entities;
    return copyToArray(this_0);
  }
  setMetadataFor(SerializableTree, 'SerializableTree', interfaceMeta);
  setMetadataFor(Companion_85, 'Companion', objectMeta);
  setMetadataFor(UnserializableEntityComponent, 'UnserializableEntityComponent', classMeta, VOID, [Component], UnserializableEntityComponent);
  setMetadataFor(Companion_86, 'Companion', objectMeta);
  setMetadataFor($serializer_12, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(VersionHeader, 'VersionHeader', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  setMetadataFor(Companion_87, 'Companion', objectMeta);
  setMetadataFor(ConnectionGraphBuildOrder, 'ConnectionGraphBuildOrder', classMeta, VOID, VOID, ConnectionGraphBuildOrder);
  setMetadataFor(ShadowEntityWithParent, 'ShadowEntityWithParent', classMeta);
  setMetadataFor(NewEntityWithShadowChildren, 'NewEntityWithShadowChildren', classMeta);
  setMetadataFor(InterceptingAssemblyPartCatalog, 'InterceptingAssemblyPartCatalog', classMeta, VOID, [ProductCatalog]);
  setMetadataFor(Companion_88, 'Companion', objectMeta);
  setMetadataFor(EntityTreeBuilder, 'EntityTreeBuilder', classMeta);
  setMetadataFor(Companion_89, 'Companion', objectMeta);
  setMetadataFor($serializer_13, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SerializableEntityV13, 'SerializableEntityV13', classMeta, VOID, [SerializableEntity], SerializableEntityV13, VOID, {0: $serializer_getInstance_13});
  setMetadataFor(Companion_90, 'Companion', objectMeta);
  setMetadataFor($serializer_14, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SerializableTreeV13, 'SerializableTreeV13', classMeta, VOID, [SerializableTree], VOID, VOID, {0: $serializer_getInstance_14});
  setMetadataFor(ProductRefLevel, 'ProductRefLevel', classMeta);
  setMetadataFor(Companion_91, 'Companion', objectMeta);
  setMetadataFor(EntityAndDO, 'EntityAndDO', classMeta);
  setMetadataFor(EntityPartKey, 'EntityPartKey', classMeta);
  setMetadataFor(SerializerV13, 'SerializerV13', classMeta);
  setMetadataFor(Companion_92, 'Companion', objectMeta);
  setMetadataFor(AxisAlignedBox, 'AxisAlignedBox', classMeta);
  setMetadataFor(Companion_93, 'Companion', objectMeta);
  function transform(transform) {
    return this.rotate(transform.rotation).move(transform.position);
  }
  setMetadataFor(Polyhedron, 'Polyhedron', interfaceMeta, VOID, [Raycastable]);
  setMetadataFor(ConvexPolyhedron, 'ConvexPolyhedron', classMeta, VOID, [Polyhedron, Raycastable]);
  setMetadataFor(Face, 'Face', classMeta);
  setMetadataFor(Companion_94, 'Companion', objectMeta);
  setMetadataFor(Cuboid, 'Cuboid', classMeta, ConvexPolyhedron);
  setMetadataFor(PolyhedronGroup, 'PolyhedronGroup', classMeta, VOID, [Polyhedron, Raycastable]);
  setMetadataFor(PolyhedronUtils, 'PolyhedronUtils', objectMeta);
  setMetadataFor(Companion_95, 'Companion', objectMeta);
  setMetadataFor(MovedToCandidateSnapPositionComponent, 'MovedToCandidateSnapPositionComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_96, 'Companion', objectMeta);
  setMetadataFor(MovedToValidSnapPositionComponent, 'MovedToValidSnapPositionComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_97, 'Companion', objectMeta);
  setMetadataFor(RestrictAllowedRequiredHostsComponent, 'RestrictAllowedRequiredHostsComponent', classMeta, VOID, [Component]);
  function get_isAlignmentSnap() {
    var tmp = this.guestConnector.type;
    return tmp === 2;
  }
  setMetadataFor(SnapActionCandidate, 'SnapActionCandidate', interfaceMeta, VOID, [ActionCandidate]);
  setMetadataFor(SnapActionCandidateImpl, 'SnapActionCandidateImpl', classMeta, VOID, [SnapActionCandidate]);
  setMetadataFor(SnapAction, 'SnapAction', classMeta, SnapActionCandidateImpl, [SnapActionCandidateImpl, Action]);
  setMetadataFor(SnapActionCandidateSortAndSelectStrategies, 'SnapActionCandidateSortAndSelectStrategies', objectMeta);
  setMetadataFor(SnapActionCandidateSortAndSelectStrategy, 'SnapActionCandidateSortAndSelectStrategy', interfaceMeta);
  setMetadataFor(SelectAll, 'SelectAll', objectMeta, VOID, [SnapActionCandidateSortAndSelectStrategy]);
  setMetadataFor(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(SortByPriorityInActivationDistanceThenDistance, 'SortByPriorityInActivationDistanceThenDistance', objectMeta, VOID, [SnapActionCandidateSortAndSelectStrategy]);
  setMetadataFor(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(SortByPriorityThenDistance, 'SortByPriorityThenDistance', objectMeta, VOID, [SnapActionCandidateSortAndSelectStrategy]);
  setMetadataFor(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(SortByDistance, 'SortByDistance', objectMeta, VOID, [SnapActionCandidateSortAndSelectStrategy]);
  setMetadataFor(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(Companion_98, 'Companion', objectMeta);
  setMetadataFor(SnapActionInProgressComponent, 'SnapActionInProgressComponent', classMeta, VOID, [Component], SnapActionInProgressComponent);
  setMetadataFor(Companion_99, 'Companion', objectMeta);
  setMetadataFor(SnapCandidateComponent, 'SnapCandidateComponent', classMeta, VOID, [Component], SnapCandidateComponent);
  setMetadataFor(Companion_100, 'Companion', objectMeta);
  setMetadataFor(SnapRootComponent, 'SnapRootComponent', classMeta, VOID, [Component], SnapRootComponent);
  setMetadataFor(SnapSettings, 'SnapSettings', classMeta, VOID, VOID, SnapSettings);
  setMetadataFor(AlternativeSnapCandidate, 'AlternativeSnapCandidate', classMeta);
  setMetadataFor(SnapUtils, 'SnapUtils', objectMeta);
  setMetadataFor(EntityState, 'EntityState', classMeta);
  setMetadataFor(Companion_101, 'Companion', objectMeta);
  setMetadataFor(IsLoadingSnapshotComponent, 'IsLoadingSnapshotComponent', classMeta, VOID, [Component], IsLoadingSnapshotComponent);
  setMetadataFor(Companion_102, 'Companion', objectMeta);
  setMetadataFor(SnapshotIgnoreComponent, 'SnapshotIgnoreComponent', classMeta, VOID, [Component], SnapshotIgnoreComponent);
  setMetadataFor(Companion_103, 'Companion', objectMeta);
  setMetadataFor(SnapshotService, 'SnapshotService', classMeta);
  setMetadataFor(Snapshot, 'Snapshot', classMeta);
  setMetadataFor(Companion_104, 'Companion', objectMeta);
  setMetadataFor(UpdatedFromSnapshotEventComponent, 'UpdatedFromSnapshotEventComponent', classMeta, VOID, [Component]);
  setMetadataFor(ApiSystemIds, 'ApiSystemIds', objectMeta);
  setMetadataFor(AlwaysHangDownComponent, 'AlwaysHangDownComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_105, 'Companion', objectMeta);
  setMetadataFor($serializer_15, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Serialized_0, 'Serialized', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  setMetadataFor(Companion_106, 'Companion', objectMeta);
  setMetadataFor(LocalTransformComponent, 'LocalTransformComponent', classMeta, VOID, [JsonSerializable, Component]);
  setMetadataFor(Companion_107, 'Companion', objectMeta);
  setMetadataFor(TransformSystem, 'TransformSystem', classMeta, SystemBase, VOID, TransformSystem);
  setMetadataFor(TransformUtils, 'TransformUtils', objectMeta);
  setMetadataFor(Companion_108, 'Companion', objectMeta);
  setMetadataFor($serializer_16, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Serialized_1, 'Serialized', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
  setMetadataFor(Companion_109, 'Companion', objectMeta);
  setMetadataFor(WorldTransformComponent, 'WorldTransformComponent', classMeta, VOID, [SerializableComponent]);
  setMetadataFor(Measurable, 'Measurable', interfaceMeta);
  setMetadataFor(Measurer, 'Measurer', classMeta, VOID, VOID, Measurer);
  setMetadataFor(MutableStack, 'MutableStack', classMeta);
  setMetadataFor(UrlHelper, 'UrlHelper', objectMeta);
  setMetadataFor(UrlDetails, 'UrlDetails', classMeta);
  setMetadataFor(Companion_110, 'Companion', objectMeta);
  setMetadataFor(NoValidConnectorAvailableValidationResult, 'NoValidConnectorAvailableValidationResult', classMeta, ValidationResult);
  setMetadataFor(Companion_111, 'Companion', objectMeta);
  setMetadataFor(UnknownErrorValidationResult, 'UnknownErrorValidationResult', classMeta, ValidationResult);
  setMetadataFor(Companion_112, 'Companion', objectMeta);
  setMetadataFor(ValidSnapActionCandidateOrErrors, 'ValidSnapActionCandidateOrErrors', classMeta);
  setMetadataFor(ValidationResultType, 'ValidationResultType', classMeta, Enum);
  setMetadataFor(Companion_113, 'Companion', objectMeta);
  setMetadataFor(ValidationResultFail, 'ValidationResultFail', classMeta, ValidationResult);
  setMetadataFor(ValidationResultWarning, 'ValidationResultWarning', classMeta, ValidationResult);
  setMetadataFor(Companion_114, 'Companion', objectMeta);
  function validateCurrentState(entity, earlyOut, $super) {
    earlyOut = earlyOut === VOID ? true : earlyOut;
    return this.a2u(entity, earlyOut);
  }
  function validateSnap(snapActionCandidate, earlyOut, $super) {
    earlyOut = earlyOut === VOID ? true : earlyOut;
    return this.b2u(snapActionCandidate, earlyOut);
  }
  function validateSnaps(snapActionCandidates, earlyOut, $super) {
    earlyOut = earlyOut === VOID ? true : earlyOut;
    return this.c2u(snapActionCandidates, earlyOut);
  }
  function getFirstValidSnapAction(snapActionCandidates, sortByWarnings, $super) {
    sortByWarnings = sortByWarnings === VOID ? true : sortByWarnings;
    return this.d2u(snapActionCandidates, sortByWarnings);
  }
  function evaluateSnapCandidate(snapActionCandidate, earlyOut, $super) {
    earlyOut = earlyOut === VOID ? false : earlyOut;
    return this.e2u(snapActionCandidate, earlyOut);
  }
  function evaluateSnapCandidates(snapActionCandidates, earlyOut, $super) {
    earlyOut = earlyOut === VOID ? false : earlyOut;
    return this.f2u(snapActionCandidates, earlyOut);
  }
  setMetadataFor(ValidationService, 'ValidationService', interfaceMeta, VOID, [Measurable]);
  //endregion
  function Action() {
  }
  function ActionCandidate() {
  }
  var ActionState_NOT_DONE_instance;
  var ActionState_DONE_instance;
  function values() {
    return [ActionState_NOT_DONE_getInstance(), ActionState_DONE_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'NOT_DONE':
        return ActionState_NOT_DONE_getInstance();
      case 'DONE':
        return ActionState_DONE_getInstance();
      default:
        ActionState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ActionState_entriesInitialized;
  function ActionState_initEntries() {
    if (ActionState_entriesInitialized)
      return Unit_instance;
    ActionState_entriesInitialized = true;
    ActionState_NOT_DONE_instance = new ActionState('NOT_DONE', 0);
    ActionState_DONE_instance = new ActionState('DONE', 1);
  }
  function ActionState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ActionState_NOT_DONE_getInstance() {
    ActionState_initEntries();
    return ActionState_NOT_DONE_instance;
  }
  function ActionState_DONE_getInstance() {
    ActionState_initEntries();
    return ActionState_DONE_instance;
  }
  function Core() {
  }
  function CoreFactory() {
  }
  function CoreModules() {
  }
  function CoreServices(coreModules, entityManager, sceneManager, componentDeserializerRegistry, validations, serializer, productManager, snapshotService, coreFactory) {
    this.coreModules = coreModules;
    this.entityManager = entityManager;
    this.sceneManager = sceneManager;
    this.componentDeserializerRegistry = componentDeserializerRegistry;
    this.validations = validations;
    this.serializer = serializer;
    this.productManager = productManager;
    this.snapshotService = snapshotService;
    this.coreFactory = coreFactory;
  }
  protoOf(CoreServices).o1i = function () {
    return this.coreModules;
  };
  protoOf(CoreServices).p1i = function () {
    return this.entityManager;
  };
  protoOf(CoreServices).q1i = function () {
    return this.sceneManager;
  };
  protoOf(CoreServices).r1i = function () {
    return this.componentDeserializerRegistry;
  };
  protoOf(CoreServices).s1i = function () {
    return this.validations;
  };
  protoOf(CoreServices).t1i = function () {
    return this.serializer;
  };
  protoOf(CoreServices).u1i = function () {
    return this.productManager;
  };
  protoOf(CoreServices).v1i = function () {
    return this.snapshotService;
  };
  protoOf(CoreServices).w1i = function () {
    return this.coreFactory;
  };
  protoOf(CoreServices).x1i = function () {
    return LoggerState_getInstance().a1j();
  };
  function MissingCriticalModuleException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, MissingCriticalModuleException);
  }
  function connectPartToAssembly($this, entity) {
    Companion_instance.connectChildPart($this.c1j_1, entity, $this.b1j_1);
  }
  function AddPartAction(newEntity, assemblyPart, parent, entityManager, validationService) {
    this.newEntity = newEntity;
    this.b1j_1 = assemblyPart;
    this.c1j_1 = parent;
    this.entityManager = entityManager;
    this.d1j_1 = new EntityReplaceHelper(this.newEntity, null, this.c1j_1, validationService);
  }
  protoOf(AddPartAction).e1j = function () {
    return this.newEntity;
  };
  protoOf(AddPartAction).p1i = function () {
    return this.entityManager;
  };
  protoOf(AddPartAction).rollback = function () {
    this.d1j_1.v();
  };
  protoOf(AddPartAction).perform = function () {
    connectPartToAssembly(this, this.newEntity);
  };
  protoOf(AddPartAction).toString = function () {
    return 'Add part action for new ' + this.newEntity;
  };
  function assembleChildren($this, parent, assemblyPart, partsMap, productManager, entityManager, partIds) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var usedHostConnections = LinkedHashSet_init_$Create$();
    var tmp0_safe_receiver = assemblyPart.children;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'com.ikea.core.assemblies.Companion.assembleChildren.<anonymous>' call
          var tmp0_elvis_lhs = partsMap.b3(element.partKey);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$1 = null;
            break $l$block_1;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var productRefForPart = tmp_0;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(productRefForPart) === 0) {
            tmp$ret$1 = null;
            break $l$block_1;
          }
          var tmp2_safe_receiver = partIds == null ? null : partIds.parts;
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b3(element.partKey);
          var id = tmp3_elvis_lhs == null ? entityManager.getNextId() : tmp3_elvis_lhs;
          var tmp4_elvis_lhs = productManager.createEntityInternal(productRefForPart, id, parent);
          var tmp_1;
          if (tmp4_elvis_lhs == null) {
            tmp$ret$1 = null;
            break $l$block_1;
          } else {
            tmp_1 = tmp4_elvis_lhs;
          }
          var childEntity = tmp_1;
          Companion_instance.connectChildPart(parent, childEntity, element, usedHostConnections);
          if (element.children == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            assembleChildren(Companion_instance, childEntity, element, partsMap, productManager, entityManager, partIds);
          }
          tmp$ret$1 = childEntity;
        }
        var tmp0_safe_receiver_0 = tmp$ret$1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver_0);
        }
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_iterator = tmp1_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.assemblies.Companion.assembleChildren.<anonymous>.<anonymous>' call
        HierarchyUtils_instance.setParent(element_0, parent);
      }
    }
  }
  function assembleChildren$default($this, parent, assemblyPart, partsMap, productManager, entityManager, partIds, $super) {
    partIds = partIds === VOID ? null : partIds;
    return assembleChildren($this, parent, assemblyPart, partsMap, productManager, entityManager, partIds);
  }
  function findEntityInHierarchyThatHasConnector($this, childEntity, connectorKey) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_hierarchy(childEntity);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.assemblies.Companion.findEntityInHierarchyThatHasConnector.<anonymous>' call
        var tmp0_safe_receiver = get_connectorsComponent(element);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.any' call
            var inductionVariable_0 = 0;
            var last_0 = tmp1_safe_receiver.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = tmp1_safe_receiver[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.assemblies.Companion.findEntityInHierarchyThatHasConnector.<anonymous>.<anonymous>' call
              if (element_0.key === connectorKey) {
                tmp$ret$1 = true;
                break $l$block;
              }
            }
            tmp$ret$1 = false;
          }
          tmp = tmp$ret$1;
        }
        var tmp2_elvis_lhs = tmp;
        if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
          tmp$ret$3 = element;
          break $l$block_0;
        }
      }
      tmp$ret$3 = null;
    }
    return tmp$ret$3;
  }
  function transferAnyParentConnectionToTheConnectionRoot($this, childEntity, parent) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.assemblies.Companion.transferAnyParentConnectionToTheConnectionRoot.<anonymous>' call
    var hostedConnections = childEntity.__getComponentForKotlin(105);
    var tmp0_elvis_lhs = get_connectionRootEntity(parent);
    var parentRoot = tmp0_elvis_lhs == null ? parent : tmp0_elvis_lhs;
    var tmp2_safe_receiver = hostedConnections == null ? null : hostedConnections.connections;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.assemblies.Companion.transferAnyParentConnectionToTheConnectionRoot.<anonymous>.<anonymous>' call
        addHostedConnection(parentRoot, element);
      }
    }
    childEntity.removeComponent(105);
  }
  function findClosestSnap($this, hostEntity, childEntity, assemblyPart, usedHostConnectors) {
    var settings = new SnapSettings(false, true, false, true);
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = SnapUtils_instance.matchingSnapActionCandidates(childEntity, hostEntity, settings);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = AssemblyBuilder$Companion$findClosestSnap$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var snaps = sortedWith(this_0, tmp$ret$0);
    var tmp0_safe_receiver = assemblyPart.snapInfo;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>' call
      var tmp_1;
      if (assemblyPart.snapInfo.useClosest) {
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = snaps.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>.<anonymous>' call
            if (!usedHostConnectors.p(element.hostConnector)) {
              tmp$ret$3 = element;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        tmp_1 = tmp$ret$3;
      } else {
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_0 = snaps.t();
          while (tmp0_iterator_0.u()) {
            var element_0 = tmp0_iterator_0.w();
            // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>.<anonymous>' call
            if ((isBlank(tmp0_safe_receiver.connectorOnHost) ? true : element_0.hostConnector.key === tmp0_safe_receiver.connectorOnHost) ? isBlank(tmp0_safe_receiver.connector) ? true : element_0.guestConnector.key === tmp0_safe_receiver.connector : false) {
              tmp$ret$5 = element_0;
              break $l$block_0;
            }
          }
          tmp$ret$5 = null;
        }
        tmp_1 = tmp$ret$5;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function transformPart($this, entity, transform) {
    if (!(transform == null)) {
      TransformUtils_instance.moveInParentSpace(entity, transform.position);
      TransformUtils_instance.rotate(entity, transform.rotation);
    }
  }
  function partKeyToProductRefForEntity($this, entity) {
    var partKey = get_partKey(entity);
    var productRef = get_productRef(entity);
    var tmp;
    if (partKey == null ? true : productRef == null) {
      tmp = null;
    } else {
      tmp = to(partKey, productRef);
    }
    return tmp;
  }
  function partKeyToEntityIdForEntity($this, entity) {
    var partKey = get_partKey(entity);
    var entityId = entity.id;
    var tmp;
    if (partKey == null) {
      tmp = null;
    } else {
      tmp = to(partKey, entityId);
    }
    return tmp;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.t1j_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).u1j = function (a, b) {
    return this.t1j_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function AssemblyBuilder$Companion$findClosestSnap$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>' call
    var tmp = a.movement.size;
    // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>' call
    var tmp$ret$1 = b.movement.size;
    return compareValues(tmp, tmp$ret$1);
  }
  function Companion() {
  }
  protoOf(Companion).v1j = function (entity, assemblyPart, partsMap, productManager, entityManager, partIds) {
    assembleChildren(this, entity, assemblyPart, partsMap, productManager, entityManager, partIds);
    RelativeConnectorRepositioner_instance.repositionRelativeConnectorsFromBounds(entity);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_descendants(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.assemblies.Companion.buildAssembly.<anonymous>' call
      productManager.notifyCreatedListeners(element);
    }
  };
  protoOf(Companion).buildAssembly = function (entity, assemblyPart, partsMap, productManager, entityManager, partIds, $super) {
    partIds = partIds === VOID ? null : partIds;
    return this.v1j(entity, assemblyPart, partsMap, productManager, entityManager, partIds);
  };
  protoOf(Companion).w1j = function (parent, childEntity, childPart, usedHostConnections) {
    Companion_getInstance_110();
    if (!childEntity.hasComponent(10)) {
      TransformUtils_instance.setWorldTransform(childEntity, get_worldTransform(parent));
    }
    transformPart(this, childEntity, childPart.relativeTransform);
    var tmp;
    if (!(childPart.snapInfo == null)) {
      var shouldSearchForSnap = (childPart.snapInfo.useClosest ? true : isBlank(childPart.snapInfo.connector)) ? true : isBlank(childPart.snapInfo.connectorOnHost);
      var hadSnapRootComponent = childEntity.hasComponent(47);
      childEntity.addComponentInternal(new SnapRootComponent());
      var tmp_0;
      if (shouldSearchForSnap) {
        tmp_0 = findClosestSnap(this, parent, childEntity, childPart, toList(usedHostConnections));
      } else {
        var host = findEntityInHierarchyThatHasConnector(this, parent, childPart.snapInfo.connectorOnHost);
        var guest = findEntityInHierarchyThatHasConnector(this, childEntity, childPart.snapInfo.connector);
        var tmp_1 = SnapUtils_instance;
        var tmp_2 = host == null ? parent : host;
        tmp_0 = tmp_1.createForcedSnapActionCandidate(tmp_2, guest == null ? childEntity : guest, childPart.snapInfo.connectorOnHost, childPart.snapInfo.connector);
      }
      var snap = tmp_0;
      if (!hadSnapRootComponent) {
        childEntity.removeComponentInternal(47);
      }
      tmp = snap;
    } else {
      tmp = null;
    }
    var snap_0 = tmp;
    if (snap_0 == null ? true : childPart.locked) {
      childEntity.removeComponent(3);
      childEntity.removeComponent(1);
      childEntity.addComponent(new ProductPartComponent(childPart.partKey));
      childEntity.removeComponent(28);
      childEntity.removeComponent(47);
      transferAnyParentConnectionToTheConnectionRoot(this, childEntity, parent);
    } else {
      var connectorsDeltaTransform = snap_0.hostConnector.getDeltaTransformToGuestConnectorEntity(parent, childEntity, snap_0.guestConnector);
      var connection = new Connection(childEntity, snap_0.guestConnector, parent, snap_0.hostConnector, connectorsDeltaTransform);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [connection];
      childEntity.addComponent(new GuestConnectionsComponent(tmp$ret$3));
    }
    setParentMaintainWorldTransform(childEntity, parent);
    if (snap_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      usedHostConnections.q(snap_0.hostConnector);
      snap_0.doInitialAssemblySnap();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = childPart.additionalComponents.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.assemblies.Companion.connectChildPart.<anonymous>' call
      childEntity.addComponent(element);
    }
    return childEntity;
  };
  protoOf(Companion).connectChildPart = function (parent, childEntity, childPart, usedHostConnections, $super) {
    var tmp;
    if (usedHostConnections === VOID) {
      // Inline function 'kotlin.collections.mutableSetOf' call
      tmp = LinkedHashSet_init_$Create$();
    } else {
      tmp = usedHostConnections;
    }
    usedHostConnections = tmp;
    return this.w1j(parent, childEntity, childPart, usedHostConnections);
  };
  protoOf(Companion).x1j = function (entity, includeSubAssemblies) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
      if (get_isProductPart(element)) {
        destination.q(element);
      }
    }
    var childParts = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = childParts.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
      var tmp0_safe_receiver = partKeyToProductRefForEntity(Companion_instance, element_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver);
      }
    }
    var partsMap = toMutableMap(toMap(destination_0));
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = childParts.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
      var tmp;
      if (includeSubAssemblies) {
        tmp = true;
      } else {
        tmp = !element_1.hasComponent(12);
      }
      if (tmp) {
        destination_1.q(element_1);
      }
    }
    var accumulator = partsMap;
    var tmp0_iterator_1 = destination_1.t();
    while (tmp0_iterator_1.u()) {
      var element_2 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
      var total = accumulator;
      var childrenPartsMap = Companion_instance.partsMapForEntity(element_2, includeSubAssemblies);
      total.s2(childrenPartsMap);
      accumulator = total;
    }
    return partsMap;
  };
  protoOf(Companion).partsMapForEntity = function (entity, includeSubAssemblies, $super) {
    includeSubAssemblies = includeSubAssemblies === VOID ? true : includeSubAssemblies;
    return this.x1j(entity, includeSubAssemblies);
  };
  protoOf(Companion).y1j = function (entity, includeSubAssemblies) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
      if (get_isProductPart(element)) {
        destination.q(element);
      }
    }
    var childParts = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = childParts.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
      var tmp0_safe_receiver = partKeyToEntityIdForEntity(Companion_instance, element_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver);
      }
    }
    var idsMap = toMutableMap(toMap(destination_0));
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = childParts.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
      var tmp;
      if (includeSubAssemblies) {
        tmp = true;
      } else {
        tmp = !element_1.hasComponent(12);
      }
      if (tmp) {
        destination_1.q(element_1);
      }
    }
    var accumulator = idsMap;
    var tmp0_iterator_1 = destination_1.t();
    while (tmp0_iterator_1.u()) {
      var element_2 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
      var total = accumulator;
      var childrenIdsMap = Companion_instance.partIdsMapForEntity(element_2, includeSubAssemblies);
      total.s2(childrenIdsMap);
      accumulator = total;
    }
    return idsMap;
  };
  protoOf(Companion).partIdsMapForEntity = function (entity, includeSubAssemblies, $super) {
    includeSubAssemblies = includeSubAssemblies === VOID ? true : includeSubAssemblies;
    return this.y1j(entity, includeSubAssemblies);
  };
  var Companion_instance;
  function Companion_getInstance_0() {
    return Companion_instance;
  }
  function AssemblyBuilder() {
  }
  function AssemblyPart(partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents) {
    relativeTransform = relativeTransform === VOID ? null : relativeTransform;
    snapInfo = snapInfo === VOID ? null : snapInfo;
    children = children === VOID ? null : children;
    locked = locked === VOID ? true : locked;
    variant = variant === VOID ? null : variant;
    additionalComponents = additionalComponents === VOID ? emptyList() : additionalComponents;
    this.partKey = partKey;
    this.relativeTransform = relativeTransform;
    this.snapInfo = snapInfo;
    this.children = children;
    this.locked = locked;
    this.variant = variant;
    this.additionalComponents = additionalComponents;
  }
  protoOf(AssemblyPart).z1j = function () {
    return this.partKey;
  };
  protoOf(AssemblyPart).a1k = function () {
    return this.relativeTransform;
  };
  protoOf(AssemblyPart).b1k = function () {
    return this.snapInfo;
  };
  protoOf(AssemblyPart).c1k = function () {
    return this.children;
  };
  protoOf(AssemblyPart).d1k = function () {
    return this.locked;
  };
  protoOf(AssemblyPart).e1k = function () {
    return this.variant;
  };
  protoOf(AssemblyPart).f1k = function () {
    return this.additionalComponents;
  };
  protoOf(AssemblyPart).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AssemblyPart))
      THROW_CCE();
    if (!(this.partKey === other.partKey))
      return false;
    return true;
  };
  protoOf(AssemblyPart).hashCode = function () {
    return getStringHashCode(this.partKey);
  };
  protoOf(AssemblyPart).af = function () {
    return this.partKey;
  };
  protoOf(AssemblyPart).bf = function () {
    return this.relativeTransform;
  };
  protoOf(AssemblyPart).g1k = function () {
    return this.snapInfo;
  };
  protoOf(AssemblyPart).h1k = function () {
    return this.children;
  };
  protoOf(AssemblyPart).i1k = function () {
    return this.locked;
  };
  protoOf(AssemblyPart).j1k = function () {
    return this.variant;
  };
  protoOf(AssemblyPart).k1k = function () {
    return this.additionalComponents;
  };
  protoOf(AssemblyPart).l1k = function (partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents) {
    return new AssemblyPart(partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents);
  };
  protoOf(AssemblyPart).copy = function (partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents, $super) {
    partKey = partKey === VOID ? this.partKey : partKey;
    relativeTransform = relativeTransform === VOID ? this.relativeTransform : relativeTransform;
    snapInfo = snapInfo === VOID ? this.snapInfo : snapInfo;
    children = children === VOID ? this.children : children;
    locked = locked === VOID ? this.locked : locked;
    variant = variant === VOID ? this.variant : variant;
    additionalComponents = additionalComponents === VOID ? this.additionalComponents : additionalComponents;
    return this.l1k(partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents);
  };
  protoOf(AssemblyPart).toString = function () {
    return 'AssemblyPart(partKey=' + this.partKey + ', relativeTransform=' + this.relativeTransform + ', snapInfo=' + this.snapInfo + ', children=' + toString(this.children) + ', locked=' + this.locked + ', variant=' + this.variant + ', additionalComponents=' + this.additionalComponents + ')';
  };
  function AssemblyPartSnapInfo(connectorOnHost, connector, useClosest) {
    connectorOnHost = connectorOnHost === VOID ? '' : connectorOnHost;
    connector = connector === VOID ? '' : connector;
    useClosest = useClosest === VOID ? false : useClosest;
    this.connectorOnHost = connectorOnHost;
    this.connector = connector;
    this.useClosest = useClosest;
  }
  protoOf(AssemblyPartSnapInfo).m1k = function () {
    return this.connectorOnHost;
  };
  protoOf(AssemblyPartSnapInfo).n1k = function () {
    return this.connector;
  };
  protoOf(AssemblyPartSnapInfo).o1k = function () {
    return this.useClosest;
  };
  protoOf(AssemblyPartSnapInfo).af = function () {
    return this.connectorOnHost;
  };
  protoOf(AssemblyPartSnapInfo).bf = function () {
    return this.connector;
  };
  protoOf(AssemblyPartSnapInfo).g1k = function () {
    return this.useClosest;
  };
  protoOf(AssemblyPartSnapInfo).p1k = function (connectorOnHost, connector, useClosest) {
    return new AssemblyPartSnapInfo(connectorOnHost, connector, useClosest);
  };
  protoOf(AssemblyPartSnapInfo).copy = function (connectorOnHost, connector, useClosest, $super) {
    connectorOnHost = connectorOnHost === VOID ? this.connectorOnHost : connectorOnHost;
    connector = connector === VOID ? this.connector : connector;
    useClosest = useClosest === VOID ? this.useClosest : useClosest;
    return this.p1k(connectorOnHost, connector, useClosest);
  };
  protoOf(AssemblyPartSnapInfo).toString = function () {
    return 'AssemblyPartSnapInfo(connectorOnHost=' + this.connectorOnHost + ', connector=' + this.connector + ', useClosest=' + this.useClosest + ')';
  };
  protoOf(AssemblyPartSnapInfo).hashCode = function () {
    var result = getStringHashCode(this.connectorOnHost);
    result = imul(result, 31) + getStringHashCode(this.connector) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.useClosest) | 0;
    return result;
  };
  protoOf(AssemblyPartSnapInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AssemblyPartSnapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AssemblyPartSnapInfo ? other : THROW_CCE();
    if (!(this.connectorOnHost === tmp0_other_with_cast.connectorOnHost))
      return false;
    if (!(this.connector === tmp0_other_with_cast.connector))
      return false;
    if (!(this.useClosest === tmp0_other_with_cast.useClosest))
      return false;
    return true;
  };
  function Companion_0() {
  }
  protoOf(Companion_0).l17 = function () {
    return $serializer_getInstance();
  };
  var Companion_instance_0;
  function Companion_getInstance_1() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.assemblies.AssemblyPartConnectorInfo', this, 7);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('main', false);
    tmp0_serialDesc.cv('connector', true);
    tmp0_serialDesc.cv('connectorOnHost', true);
    tmp0_serialDesc.cv('translation', true);
    tmp0_serialDesc.cv('rotation', true);
    tmp0_serialDesc.cv('children', true);
    this.q1k_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ok = function () {
    return this.q1k_1;
  };
  protoOf($serializer).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_4()), get_nullable(new ArrayListSerializer($serializer_getInstance()))];
  };
  protoOf($serializer).qk = function (decoder) {
    var tmp0_desc = this.q1k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.nn(tmp0_desc);
    if (tmp11_input.do()) {
      tmp4_local0 = tmp11_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.pn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.bo(tmp0_desc, 4, $serializer_getInstance_8(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.bo(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.bo(tmp0_desc, 6, new ArrayListSerializer($serializer_getInstance()), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.pn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.bo(tmp0_desc, 4, $serializer_getInstance_8(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.bo(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.bo(tmp0_desc, 6, new ArrayListSerializer($serializer_getInstance()), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.on(tmp0_desc);
    return AssemblyPartConnectorInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer).r1k = function (encoder, value) {
    var tmp0_desc = this.q1k_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.uo(tmp0_desc, 1, value.main);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.connector == null)) {
      tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.connector);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.connectorOnHost == null)) {
      tmp1_output.gp(tmp0_desc, 3, StringSerializer_getInstance(), value.connectorOnHost);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.translation == null)) {
      tmp1_output.gp(tmp0_desc, 4, $serializer_getInstance_8(), value.translation);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !(value.rotation == null)) {
      tmp1_output.gp(tmp0_desc, 5, $serializer_getInstance_4(), value.rotation);
    }
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.children == null)) {
      tmp1_output.gp(tmp0_desc, 6, new ArrayListSerializer($serializer_getInstance()), value.children);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer).pk = function (encoder, value) {
    return this.r1k(encoder, value instanceof AssemblyPartConnectorInfo ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function AssemblyPartConnectorInfo_init_$Init$(seen1, id, main, connector, connectorOnHost, translation, rotation, children, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance().q1k_1);
    }
    $this.id = id;
    $this.main = main;
    if (0 === (seen1 & 4))
      $this.connector = null;
    else
      $this.connector = connector;
    if (0 === (seen1 & 8))
      $this.connectorOnHost = null;
    else
      $this.connectorOnHost = connectorOnHost;
    if (0 === (seen1 & 16))
      $this.translation = null;
    else
      $this.translation = translation;
    if (0 === (seen1 & 32))
      $this.rotation = null;
    else
      $this.rotation = rotation;
    if (0 === (seen1 & 64))
      $this.children = null;
    else
      $this.children = children;
    return $this;
  }
  function AssemblyPartConnectorInfo_init_$Create$(seen1, id, main, connector, connectorOnHost, translation, rotation, children, serializationConstructorMarker) {
    return AssemblyPartConnectorInfo_init_$Init$(seen1, id, main, connector, connectorOnHost, translation, rotation, children, serializationConstructorMarker, objectCreate(protoOf(AssemblyPartConnectorInfo)));
  }
  function AssemblyPartConnectorInfo(id, main, connector, connectorOnHost, translation, rotation, children) {
    connector = connector === VOID ? null : connector;
    connectorOnHost = connectorOnHost === VOID ? null : connectorOnHost;
    translation = translation === VOID ? null : translation;
    rotation = rotation === VOID ? null : rotation;
    children = children === VOID ? null : children;
    this.id = id;
    this.main = main;
    this.connector = connector;
    this.connectorOnHost = connectorOnHost;
    this.translation = translation;
    this.rotation = rotation;
    this.children = children;
  }
  protoOf(AssemblyPartConnectorInfo).s1k = function () {
    return this.id;
  };
  protoOf(AssemblyPartConnectorInfo).t1k = function () {
    return this.main;
  };
  protoOf(AssemblyPartConnectorInfo).n1k = function () {
    return this.connector;
  };
  protoOf(AssemblyPartConnectorInfo).m1k = function () {
    return this.connectorOnHost;
  };
  protoOf(AssemblyPartConnectorInfo).u1k = function () {
    return this.translation;
  };
  protoOf(AssemblyPartConnectorInfo).v1k = function () {
    return this.rotation;
  };
  protoOf(AssemblyPartConnectorInfo).c1k = function () {
    return this.children;
  };
  function Companion_1() {
    this.id = 96;
  }
  protoOf(Companion_1).s1k = function () {
    return this.id;
  };
  var Companion_instance_1;
  function Companion_getInstance_2() {
    return Companion_instance_1;
  }
  function AssemblyPartIdsComponent$toString$lambda(it) {
    return it.t2() + ':' + it.u2();
  }
  function AssemblyPartIdsComponent(parts) {
    this.parts = parts;
  }
  protoOf(AssemblyPartIdsComponent).w1k = function () {
    return this.parts;
  };
  protoOf(AssemblyPartIdsComponent).x1k = function () {
    return 96;
  };
  protoOf(AssemblyPartIdsComponent).eq = function (other) {
    return false;
  };
  protoOf(AssemblyPartIdsComponent).toString = function () {
    var tmp = this.parts.q2();
    return 'AssemblyPartsIdsComponent(' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, AssemblyPartIdsComponent$toString$lambda) + ')';
  };
  protoOf(AssemblyPartIdsComponent).af = function () {
    return this.parts;
  };
  protoOf(AssemblyPartIdsComponent).y1k = function (parts) {
    return new AssemblyPartIdsComponent(parts);
  };
  protoOf(AssemblyPartIdsComponent).copy = function (parts, $super) {
    parts = parts === VOID ? this.parts : parts;
    return this.y1k(parts);
  };
  protoOf(AssemblyPartIdsComponent).hashCode = function () {
    return hashCode(this.parts);
  };
  protoOf(AssemblyPartIdsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AssemblyPartIdsComponent))
      return false;
    var tmp0_other_with_cast = other instanceof AssemblyPartIdsComponent ? other : THROW_CCE();
    if (!equals(this.parts, tmp0_other_with_cast.parts))
      return false;
    return true;
  };
  function AssemblyPartsComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function AssemblyPartsComponent_init_$Init$(partPairs, $this) {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(partPairs.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var inductionVariable = 0;
    var last = partPairs.length;
    while (inductionVariable < last) {
      var element = partPairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.core.assemblies.AssemblyPartsComponent.<init>.<anonymous>' call
      var pair = to(element.partKey, element.productRef);
      destination.r2(pair.ye_1, pair.ze_1);
    }
    AssemblyPartsComponent.call($this, destination);
    return $this;
  }
  function AssemblyPartsComponent_init_$Create$(partPairs) {
    return AssemblyPartsComponent_init_$Init$(partPairs, objectCreate(protoOf(AssemblyPartsComponent)));
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b1l_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
    this.c1l_1 = 43;
    this.d1l_1 = 'AssemblyPartsComponent';
    var tmp_0 = this;
    tmp_0.e1l_1 = Json(VOID, AssemblyPartsComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_2).f1l = function (json) {
    return this.e1l_1.l15(this.l17(), json);
  };
  protoOf(Companion_2).l17 = function () {
    return $serializer_getInstance_0();
  };
  var Companion_instance_2;
  function Companion_getInstance_3() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.assemblies.AssemblyPartsComponent', this, 1);
    tmp0_serialDesc.cv('parts', false);
    this.g1l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ok = function () {
    return this.g1l_1;
  };
  protoOf($serializer_0).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_3().b1l_1[0]];
  };
  protoOf($serializer_0).qk = function (decoder) {
    var tmp0_desc = this.g1l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.nn(tmp0_desc);
    var tmp6_cached = Companion_getInstance_3().b1l_1;
    if (tmp5_input.do()) {
      tmp4_local0 = tmp5_input.zn(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zn(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.on(tmp0_desc);
    return AssemblyPartsComponent_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_0).h1l = function (encoder, value) {
    var tmp0_desc = this.g1l_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().b1l_1;
    tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.i1l_1);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_0).pk = function (encoder, value) {
    return this.h1l(encoder, value instanceof AssemblyPartsComponent ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function AssemblyPartsComponent_init_$Init$_0(seen1, parts, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().g1l_1);
    }
    $this.i1l_1 = parts;
    return $this;
  }
  function AssemblyPartsComponent_init_$Create$_0(seen1, parts, serializationConstructorMarker) {
    return AssemblyPartsComponent_init_$Init$_0(seen1, parts, serializationConstructorMarker, objectCreate(protoOf(AssemblyPartsComponent)));
  }
  function AssemblyPartsComponent$toString$lambda(it) {
    return it.t2() + ':' + it.u2();
  }
  function AssemblyPartsComponent(parts) {
    Companion_getInstance_3();
    this.i1l_1 = parts;
  }
  protoOf(AssemblyPartsComponent).x1k = function () {
    return 43;
  };
  protoOf(AssemblyPartsComponent).eq = function (other) {
    return false;
  };
  protoOf(AssemblyPartsComponent).toString = function () {
    var tmp = this.i1l_1.q2();
    return 'AssemblyPartsComponent(' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, AssemblyPartsComponent$toString$lambda) + ')';
  };
  protoOf(AssemblyPartsComponent).asArray = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.i1l_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.assemblies.AssemblyPartsComponent.asArray.<anonymous>' call
      var tmp$ret$1 = new PartPair(item.t2(), item.u2());
      destination.q(tmp$ret$1);
    }
    return copyToArray(destination);
  };
  protoOf(AssemblyPartsComponent).hashCode = function () {
    return hashCode(this.i1l_1);
  };
  protoOf(AssemblyPartsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AssemblyPartsComponent))
      return false;
    var tmp0_other_with_cast = other instanceof AssemblyPartsComponent ? other : THROW_CCE();
    if (!equals(this.i1l_1, tmp0_other_with_cast.i1l_1))
      return false;
    return true;
  };
  function Companion_3() {
    this.id = 12;
  }
  protoOf(Companion_3).s1k = function () {
    return this.id;
  };
  var Companion_instance_3;
  function Companion_getInstance_4() {
    return Companion_instance_3;
  }
  function toString$withChildren(ap) {
    var tmp = ensureNotNull(ap.children);
    return ap.partKey + '(' + joinToString_0(tmp, VOID, VOID, VOID, VOID, VOID, AssemblyStructureComponent$toString$withChildren$lambda) + ')';
  }
  function toString$noChildren(ap) {
    return ap.partKey + ':0';
  }
  function AssemblyStructureComponent$toString$lambda(ap) {
    var tmp;
    if (!(ap.children == null)) {
      tmp = toString$withChildren(ap);
    } else {
      tmp = toString$noChildren(ap);
    }
    return tmp;
  }
  function AssemblyStructureComponent$toString$withChildren$lambda(it) {
    return it.partKey;
  }
  function AssemblyStructureComponent(parts) {
    this.parts = parts;
  }
  protoOf(AssemblyStructureComponent).w1k = function () {
    return this.parts;
  };
  protoOf(AssemblyStructureComponent).x1k = function () {
    return 12;
  };
  protoOf(AssemblyStructureComponent).eq = function (other) {
    return false;
  };
  protoOf(AssemblyStructureComponent).toString = function () {
    var partsStr = joinToString_0(this.parts, VOID, VOID, VOID, VOID, VOID, AssemblyStructureComponent$toString$lambda);
    return 'AssemblyStructureComponent(' + partsStr + ')';
  };
  function get_isAssembly(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(12);
  }
  function PartPair(partKey, productRef) {
    this.partKey = partKey;
    this.productRef = productRef;
  }
  protoOf(PartPair).z1j = function () {
    return this.partKey;
  };
  protoOf(PartPair).j1l = function () {
    return this.productRef;
  };
  protoOf(PartPair).af = function () {
    return this.partKey;
  };
  protoOf(PartPair).bf = function () {
    return this.productRef;
  };
  protoOf(PartPair).k1l = function (partKey, productRef) {
    return new PartPair(partKey, productRef);
  };
  protoOf(PartPair).copy = function (partKey, productRef, $super) {
    partKey = partKey === VOID ? this.partKey : partKey;
    productRef = productRef === VOID ? this.productRef : productRef;
    return this.k1l(partKey, productRef);
  };
  protoOf(PartPair).toString = function () {
    return 'PartPair(partKey=' + this.partKey + ', productRef=' + this.productRef + ')';
  };
  protoOf(PartPair).hashCode = function () {
    var result = getStringHashCode(this.partKey);
    result = imul(result, 31) + getStringHashCode(this.productRef) | 0;
    return result;
  };
  protoOf(PartPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PartPair))
      return false;
    var tmp0_other_with_cast = other instanceof PartPair ? other : THROW_CCE();
    if (!(this.partKey === tmp0_other_with_cast.partKey))
      return false;
    if (!(this.productRef === tmp0_other_with_cast.productRef))
      return false;
    return true;
  };
  function ProductPartComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function Companion_4() {
  }
  protoOf(Companion_4).l17 = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_4;
  function Companion_getInstance_5() {
    return Companion_instance_4;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.assemblies.ProductPartComponent.Serialized', this, 1);
    tmp0_serialDesc.cv('partKey', false);
    this.l1l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ok = function () {
    return this.l1l_1;
  };
  protoOf($serializer_1).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_1).qk = function (decoder) {
    var tmp0_desc = this.l1l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.nn(tmp0_desc);
    if (tmp5_input.do()) {
      tmp4_local0 = tmp5_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.on(tmp0_desc);
    return Serialized_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).m1l = function (encoder, value) {
    var tmp0_desc = this.l1l_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.n1l_1);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_1).pk = function (encoder, value) {
    return this.m1l(encoder, value instanceof Serialized ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function Serialized_init_$Init$(seen1, partKey, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_1().l1l_1);
    }
    $this.n1l_1 = partKey;
    return $this;
  }
  function Serialized_init_$Create$(seen1, partKey, serializationConstructorMarker) {
    return Serialized_init_$Init$(seen1, partKey, serializationConstructorMarker, objectCreate(protoOf(Serialized)));
  }
  function Companion_5() {
    Companion_instance_5 = this;
    this.id = 44;
    this.serializationKey = 'ProductPartComponent';
    var tmp = this;
    tmp.o1l_1 = Json(VOID, ProductPartComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_5).s1k = function () {
    return this.id;
  };
  protoOf(Companion_5).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_5).fromJson = function (json) {
    var result = this.o1l_1.l15(Companion_instance_4.l17(), json);
    return new ProductPartComponent(result.n1l_1);
  };
  var Companion_instance_5;
  function Companion_getInstance_6() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function Serialized(partKey) {
    this.n1l_1 = partKey;
  }
  function ProductPartComponent(partKey) {
    Companion_getInstance_6();
    this.partKey = partKey;
  }
  protoOf(ProductPartComponent).z1j = function () {
    return this.partKey;
  };
  protoOf(ProductPartComponent).toJson = function (parse) {
    return Companion_getInstance_6().o1l_1.k15(Companion_instance_4.l17(), new Serialized(this.partKey));
  };
  protoOf(ProductPartComponent).eq = function (other) {
    return (other instanceof ProductPartComponent ? other : THROW_CCE()).partKey === this.partKey;
  };
  protoOf(ProductPartComponent).serializationKey = function () {
    return 'ProductPartComponent';
  };
  protoOf(ProductPartComponent).x1k = function () {
    return 44;
  };
  protoOf(ProductPartComponent).toJsonElement = function () {
    return Companion_getInstance_6().o1l_1.k15(Companion_instance_4.l17(), new Serialized(this.partKey));
  };
  protoOf(ProductPartComponent).af = function () {
    return this.partKey;
  };
  protoOf(ProductPartComponent).q1l = function (partKey) {
    return new ProductPartComponent(partKey);
  };
  protoOf(ProductPartComponent).copy = function (partKey, $super) {
    partKey = partKey === VOID ? this.partKey : partKey;
    return this.q1l(partKey);
  };
  protoOf(ProductPartComponent).toString = function () {
    return 'ProductPartComponent(partKey=' + this.partKey + ')';
  };
  protoOf(ProductPartComponent).hashCode = function () {
    return getStringHashCode(this.partKey);
  };
  protoOf(ProductPartComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductPartComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductPartComponent ? other : THROW_CCE();
    if (!(this.partKey === tmp0_other_with_cast.partKey))
      return false;
    return true;
  };
  function get_isProductPart(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(44);
  }
  function get_partKey(_this__u8e3s4) {
    var tmp0_safe_receiver = get_productPart(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.partKey;
  }
  function get_productPart(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(44);
  }
  function connectPartToAssembly_0($this, entity) {
    Companion_instance.connectChildPart($this.s1l_1, entity, $this.r1l_1);
  }
  function RemovePartAction(oldEntity, assemblyPart, parent, entityManager, validationService) {
    this.oldEntity = oldEntity;
    this.r1l_1 = assemblyPart;
    this.s1l_1 = parent;
    this.entityManager = entityManager;
    this.t1l_1 = validationService;
    this.u1l_1 = Companion_instance_76.x1l(this.oldEntity, null, this.t1l_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_immediateConnectionRootDescendants(this.oldEntity);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.assemblies.RemovePartAction.descendantEntityHelpers.<anonymous>' call
      var tmp$ret$0 = EntityReplaceHelper_init_$Create$(item, null, this.t1l_1, 1.7976931348623157E308);
      destination.q(tmp$ret$0);
    }
    tmp.v1l_1 = destination;
    this.w1l_1 = EntityReplaceHelper_init_$Create$(this.oldEntity, null, this.t1l_1);
  }
  protoOf(RemovePartAction).y1l = function () {
    return this.oldEntity;
  };
  protoOf(RemovePartAction).p1i = function () {
    return this.entityManager;
  };
  protoOf(RemovePartAction).rollback = function () {
    connectPartToAssembly_0(this, this.oldEntity);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.v1l_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.assemblies.RemovePartAction.rollback.<anonymous>' call
      element.z1l();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.u1l_1.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.assemblies.RemovePartAction.rollback.<anonymous>' call
      element_0.z1l();
    }
  };
  protoOf(RemovePartAction).perform = function () {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.u1l_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.assemblies.RemovePartAction.perform.<anonymous>' call
      element.v();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.v1l_1.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.assemblies.RemovePartAction.perform.<anonymous>' call
      element_0.v();
    }
    this.w1l_1.v();
  };
  protoOf(RemovePartAction).toString = function () {
    return 'Remove part Action old ' + this.oldEntity;
  };
  function ProductCatalog() {
  }
  function generatePartHierarchy($this, entity, parts) {
    var tmp;
    if (parts == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(parts.length), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$(capacity);
      var inductionVariable = 0;
      var last = parts.length;
      while (inductionVariable < last) {
        var element = parts[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.generatePartHierarchy.<anonymous>' call
        var pair = to(element.partKey, element.productRef);
        destination.r2(pair.ye_1, pair.ze_1);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    var newPartsMap = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = $this.getPartsMap(entity);
    var capacity_0 = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.generatePartHierarchy.<anonymous>' call
      var pair_0 = to(element_0.partKey, element_0.productRef);
      destination_0.r2(pair_0.ye_1, pair_0.ze_1);
    }
    var oldPartsMap = destination_0;
    return plus(oldPartsMap, newPartsMap);
  }
  function generatePartHierarchy$default($this, entity, parts, $super) {
    parts = parts === VOID ? null : parts;
    return generatePartHierarchy($this, entity, parts);
  }
  function generatePartHierarchyFromStructure($this, entity, parts) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(12);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.generatePartHierarchyFromStructure.<anonymous>' call
      tmp = generatePartHierarchyFromStructure$_anonymous_$traverse_4layzz(tmp0_safe_receiver.parts);
    }
    var tmp1_elvis_lhs = tmp;
    var allPartKeys = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    var partsMap = Companion_instance.partsMapForEntity(entity, false);
    // Inline function 'kotlin.collections.associateWith' call
    var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(allPartKeys, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator = allPartKeys.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.generatePartHierarchyFromStructure.<anonymous>' call
      var tmp_0;
      if (parts == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable = 0;
          var last = parts.length;
          while (inductionVariable < last) {
            var element_0 = parts[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.generatePartHierarchyFromStructure.<anonymous>.<anonymous>' call
            if (element_0.partKey === element) {
              tmp$ret$3 = element_0;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        tmp_0 = tmp$ret$3;
      }
      var tmp1_safe_receiver = tmp_0;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.productRef;
      var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? partsMap.b3(element) : tmp2_elvis_lhs;
      var ref = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      result.r2(element, ref);
    }
    return result;
  }
  function generatePartHierarchyFromStructure$default($this, entity, parts, $super) {
    parts = parts === VOID ? null : parts;
    return generatePartHierarchyFromStructure($this, entity, parts);
  }
  function generatePartHierarchyFromStructure$_anonymous_$traverse_4layzz(parts) {
    var tmp;
    if (parts == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = parts.length;
      while (inductionVariable < last) {
        var element = parts[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.generatePartHierarchyFromStructure.<anonymous>$traverse.<anonymous>' call
        var list = plus_0(listOf(element.partKey), generatePartHierarchyFromStructure$_anonymous_$traverse_4layzz(element.children));
        addAll(destination, list);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function ProductCatalogFunctions() {
  }
  protoOf(ProductCatalogFunctions).getPartsMap = function (assembly) {
    var partsMap = Companion_instance.partsMapForEntity(assembly, false);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(partsMap.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = partsMap.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.getPartsMap.<anonymous>' call
      var tmp$ret$1 = new PartPair(item.t2(), item.u2());
      destination.q(tmp$ret$1);
    }
    return copyToArray(destination);
  };
  protoOf(ProductCatalogFunctions).b1m = function (entity, parts) {
    return new AssemblyPartsComponent(generatePartHierarchy(this, entity, parts));
  };
  protoOf(ProductCatalogFunctions).createAssemblyPartsComponent = function (entity, parts, $super) {
    parts = parts === VOID ? null : parts;
    return this.b1m(entity, parts);
  };
  protoOf(ProductCatalogFunctions).c1m = function (entity, parts, includeUnused) {
    var tmp;
    if (includeUnused) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = generatePartHierarchyFromStructure(this, entity, parts);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.n());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this_0.q2().t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.createAssemblyParts.<anonymous>' call
        var tmp$ret$1 = new PartPair(item.t2(), item.u2());
        destination.q(tmp$ret$1);
      }
      tmp = copyToArray(destination);
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = generatePartHierarchy(this, entity, parts);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(this_1.n());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_0 = this_1.q2().t();
      while (tmp0_iterator_0.u()) {
        var item_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.catalog.ProductCatalogFunctions.createAssemblyParts.<anonymous>' call
        var tmp$ret$6 = new PartPair(item_0.t2(), item_0.u2());
        destination_0.q(tmp$ret$6);
      }
      tmp = copyToArray(destination_0);
    }
    return tmp;
  };
  protoOf(ProductCatalogFunctions).createAssemblyParts = function (entity, parts, includeUnused, $super) {
    parts = parts === VOID ? null : parts;
    includeUnused = includeUnused === VOID ? false : includeUnused;
    return this.c1m(entity, parts, includeUnused);
  };
  var ProductCatalogFunctions_instance;
  function ProductCatalogFunctions_getInstance() {
    return ProductCatalogFunctions_instance;
  }
  function Companion_6() {
    this.id = 18;
  }
  protoOf(Companion_6).s1k = function () {
    return this.id;
  };
  var Companion_instance_6;
  function Companion_getInstance_7() {
    return Companion_instance_6;
  }
  function ProductComponent(productRef) {
    this.productRef = productRef;
  }
  protoOf(ProductComponent).j1l = function () {
    return this.productRef;
  };
  protoOf(ProductComponent).x1k = function () {
    return 18;
  };
  protoOf(ProductComponent).eq = function (other) {
    return (other instanceof ProductComponent ? other : THROW_CCE()).productRef === this.productRef;
  };
  protoOf(ProductComponent).equals = function (other) {
    var tmp;
    if (other instanceof ProductComponent) {
      tmp = other.productRef === this.productRef;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductComponent).hashCode = function () {
    return getStringHashCode(this.productRef);
  };
  protoOf(ProductComponent).af = function () {
    return this.productRef;
  };
  protoOf(ProductComponent).q1l = function (productRef) {
    return new ProductComponent(productRef);
  };
  protoOf(ProductComponent).copy = function (productRef, $super) {
    productRef = productRef === VOID ? this.productRef : productRef;
    return this.q1l(productRef);
  };
  protoOf(ProductComponent).toString = function () {
    return 'ProductComponent(productRef=' + this.productRef + ')';
  };
  function get_productRef(_this__u8e3s4) {
    var tmp0_safe_receiver = get_productComponent(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.productRef;
  }
  function get_productComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(18);
  }
  function get_productRefOrEmptyString(_this__u8e3s4) {
    var tmp0_elvis_lhs = get_productRef(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  function ProductManager() {
  }
  function ProductSpecification(components) {
    this.components = components;
    this.i1m_1 = 0;
  }
  protoOf(ProductSpecification).j1m = function () {
    return this.components;
  };
  protoOf(ProductSpecification).hasComponent = function (componentId) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.components;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.catalog.ProductSpecification.hasComponent.<anonymous>' call
        if (element.typeId === componentId) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(ProductSpecification).addComponent = function (component) {
    var specWithoutComponent = this.removeComponent(component.typeId);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = specWithoutComponent.components;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [component];
    var newComponents = tmp$ret$0.concat(tmp$ret$3);
    return new ProductSpecification(newComponents);
  };
  protoOf(ProductSpecification).addComponents = function (components) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = this;
    var tmp0_iterator = components.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.catalog.ProductSpecification.addComponents.<anonymous>' call
      accumulator = accumulator.addComponent(element);
    }
    return accumulator;
  };
  protoOf(ProductSpecification).removeComponent = function (componentId) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filterNot' call
    // Inline function 'kotlin.collections.filterNotTo' call
    var this_0 = this.components;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.catalog.ProductSpecification.removeComponent.<anonymous>' call
      if (!(element.typeId === componentId)) {
        destination.q(element);
      }
    }
    var newComponents = copyToArray(destination);
    return this.copy(newComponents);
  };
  protoOf(ProductSpecification)._findComponentKt = function (componentId) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.components;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.catalog.ProductSpecification.findComponent.<anonymous>' call
        if (element.typeId === componentId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp = tmp$ret$1;
    return (!(tmp == null) ? isInterface(tmp, Component) : false) ? tmp : null;
  };
  protoOf(ProductSpecification).findComponent = function (componentId) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.components;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.catalog.ProductSpecification.findComponentJS.<anonymous>' call
        if (element.typeId === componentId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(ProductSpecification).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ProductSpecification))
      THROW_CCE();
    if (!contentEquals(this.components, other.components))
      return false;
    return true;
  };
  protoOf(ProductSpecification).hashCode = function () {
    if (this.i1m_1 === 0)
      this.i1m_1 = contentHashCode(this.components);
    return this.i1m_1;
  };
  protoOf(ProductSpecification).af = function () {
    return this.components;
  };
  protoOf(ProductSpecification).k1m = function (components) {
    return new ProductSpecification(components);
  };
  protoOf(ProductSpecification).copy = function (components, $super) {
    components = components === VOID ? this.components : components;
    return this.k1m(components);
  };
  protoOf(ProductSpecification).toString = function () {
    return 'ProductSpecification(components=' + toString(this.components) + ')';
  };
  function addChild($this, parent, root, productStructureItem, productManager) {
    var childEntity = productManager.createEntity(productStructureItem.productRef, VOID, parent);
    if (childEntity == null) {
      $this.l1m_1.warn(ProductStructureBuilder$Companion$addChild$lambda(productStructureItem));
      return null;
    }
    Companion_getInstance_110();
    if (!childEntity.hasComponent(10)) {
      TransformUtils_instance.setWorldTransform(childEntity, get_worldTransform(parent));
    }
    transformPart_0($this, childEntity, productStructureItem.relativeTransform);
    var snap = createSnapCandidate($this, childEntity, parent, productStructureItem);
    if (snap == null) {
      $this.l1m_1.warn(ProductStructureBuilder$Companion$addChild$lambda_0(productStructureItem, parent));
      childEntity.dispose();
      return null;
    }
    var tmp;
    var tmp_0 = snap.guestConnector.type;
    if (tmp_0 === 2) {
      tmp = true;
    } else {
      var tmp_1 = snap.hostConnector.type;
      tmp = tmp_1 === 2;
    }
    if (tmp) {
      snap.perform();
      var nonAlignmentSnapInThisPosition = findSnapToNonAlignmentConnector($this, childEntity, root);
      if (!(nonAlignmentSnapInThisPosition == null)) {
        nonAlignmentSnapInThisPosition.createAction().perform();
      } else {
        addAsChildToRoot($this, snap.guestRoot, root);
      }
    } else {
      snap.createAction().perform();
    }
    return childEntity;
  }
  function findSnapToNonAlignmentConnector($this, childEntity, root) {
    var allConnections = ConnectionUtils_instance.calculateAllConnectionsToHierarchy(childEntity, root);
    // Inline function 'kotlin.collections.isEmpty' call
    if (allConnections.length === 0) {
      return null;
    }
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.maxBy' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (allConnections.length === 0)
        throw NoSuchElementException_init_$Create$();
      var maxElem = allConnections[0];
      var lastIndex = get_lastIndex(allConnections);
      if (lastIndex === 0) {
        tmp$ret$2 = maxElem;
        break $l$block;
      }
      // Inline function 'com.ikea.core.catalog.Companion.findSnapToNonAlignmentConnector.<anonymous>' call
      var maxValue = maxElem.priority;
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = allConnections[i];
          // Inline function 'com.ikea.core.catalog.Companion.findSnapToNonAlignmentConnector.<anonymous>' call
          var v = e.priority;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$2 = maxElem;
    }
    var highestPriorityConnection = tmp$ret$2;
    return SnapUtils_instance.createSnapCandidate(highestPriorityConnection.guestConnectorEntity, highestPriorityConnection.guestConnector, highestPriorityConnection.hostConnectorEntity, highestPriorityConnection.hostConnector);
  }
  function createSnapCandidate($this, demandingEntity, offeringEntity, productStructureItem) {
    var tmp0_elvis_lhs = productStructureItem.snap;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var connectionData = tmp;
    var demandingConnectorKey = connectionData.demandingConnector;
    var offeringConnectorKey = connectionData.offeringConnector;
    // Inline function 'kotlin.sequences.find' call
    var this_0 = get_snappingEntitiesSequence(demandingEntity);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.catalog.Companion.createSnapCandidate.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var indexedObject = get_connectors(element);
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var element_0 = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.catalog.Companion.createSnapCandidate.<anonymous>.<anonymous>' call
            if (element_0.key === demandingConnectorKey) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        if (tmp$ret$1) {
          tmp$ret$3 = element;
          break $l$block_0;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$3;
    var realDemandingEntity = tmp1_elvis_lhs == null ? demandingEntity : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.find' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = hierarchyExceptSubTreesWithComponentArray(offeringEntity, 47);
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_1 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.catalog.Companion.createSnapCandidate.<anonymous>' call
      Companion_getInstance_23();
      if (element_1.hasComponent(11)) {
        destination.q(element_1);
      }
    }
    var tmp$ret$11;
    $l$block_2: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator_0 = destination.t();
      while (tmp0_iterator_0.u()) {
        var element_2 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.catalog.Companion.createSnapCandidate.<anonymous>' call
        var tmp$ret$9;
        $l$block_1: {
          // Inline function 'kotlin.collections.any' call
          var indexedObject_0 = get_connectors(element_2);
          var inductionVariable_1 = 0;
          var last_1 = indexedObject_0.length;
          while (inductionVariable_1 < last_1) {
            var element_3 = indexedObject_0[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.ikea.core.catalog.Companion.createSnapCandidate.<anonymous>.<anonymous>' call
            if (element_3.key === offeringConnectorKey) {
              tmp$ret$9 = true;
              break $l$block_1;
            }
          }
          tmp$ret$9 = false;
        }
        if (tmp$ret$9) {
          tmp$ret$11 = element_2;
          break $l$block_2;
        }
      }
      tmp$ret$11 = null;
    }
    var tmp2_elvis_lhs = tmp$ret$11;
    var realOfferingEntity = tmp2_elvis_lhs == null ? offeringEntity : tmp2_elvis_lhs;
    var tmp3_safe_receiver = get_connectorsComponent(realDemandingEntity);
    var demandingConnector = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getConnectorByKey(demandingConnectorKey);
    var tmp4_safe_receiver = get_connectorsComponent(realOfferingEntity);
    var offeringConnector = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.getConnectorByKey(offeringConnectorKey);
    if (demandingConnector == null) {
      $this.l1m_1.warn(ProductStructureBuilder$Companion$createSnapCandidate$lambda(demandingConnectorKey, productStructureItem));
      return null;
    }
    if (offeringConnector == null) {
      $this.l1m_1.warn(ProductStructureBuilder$Companion$createSnapCandidate$lambda_0(offeringConnectorKey, realOfferingEntity));
      return null;
    }
    return SnapUtils_instance.createSnapCandidate(realDemandingEntity, demandingConnector, realOfferingEntity, offeringConnector);
  }
  function addAsChildToRoot($this, entity, root) {
    setParentMaintainWorldTransform(entity, root);
  }
  function transformPart_0($this, entity, transform) {
    if (!(transform == null)) {
      TransformUtils_instance.moveInParentSpace(entity, transform.position);
      TransformUtils_instance.rotate(entity, transform.rotation);
    }
  }
  function ProductStructureBuilder$Companion$buildProductStructure$lambda() {
    return 'Product structure has more than one root. Is this a manual group? This is not supported yet! ';
  }
  function ProductStructureBuilder$Companion$buildProductStructure$lambda_0() {
    return 'The product has no root. Exactly one item must be without the snap property.';
  }
  function ProductStructureBuilder$Companion$buildProductStructure$lambda_1($firstProductData) {
    return function () {
      return 'Could not find the product for the root of the product structure: ' + $firstProductData.productRef;
    };
  }
  function ProductStructureBuilder$Companion$buildProductStructure$lambda_2() {
    return 'Product structure resulted in more than one root entities. This is not allowed yet.';
  }
  function ProductStructureBuilder$Companion$addChild$lambda($productStructureItem) {
    return function () {
      return 'Could not find the product for a product structure item (' + $productStructureItem.partKey + '): ' + $productStructureItem.productRef;
    };
  }
  function ProductStructureBuilder$Companion$addChild$lambda_0($productStructureItem, $parent) {
    return function () {
      return 'Could not snap ' + $productStructureItem.productRef + ' to ' + ProductUtils_instance.productRef($parent) + '. Will not add part ' + $productStructureItem.partKey + ' to product structure.';
    };
  }
  function ProductStructureBuilder$Companion$createSnapCandidate$lambda($demandingConnectorKey, $productStructureItem) {
    return function () {
      return 'Could not find demanding connector ' + $demandingConnectorKey + ' in ' + $productStructureItem.productRef + '.';
    };
  }
  function ProductStructureBuilder$Companion$createSnapCandidate$lambda_0($offeringConnectorKey, $realOfferingEntity) {
    return function () {
      return 'Could not find offering connector ' + $offeringConnectorKey + ' in entity ' + get_productRef($realOfferingEntity) + '.';
    };
  }
  function Companion_7() {
    Companion_instance_7 = this;
    this.l1m_1 = LoggerState_getInstance().m1m('ProductStructureBuilder');
  }
  protoOf(Companion_7).buildProductStructure = function (structure, productManager, entityManager) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = structure.products;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.catalog.Companion.buildProductStructure.<anonymous>' call
      if (element.snap == null) {
        destination.q(element);
      }
    }
    var roots = destination;
    if (roots.n() > 1) {
      this.l1m_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda);
      return null;
    } else if (roots.b1()) {
      this.l1m_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda_0);
      return null;
    }
    var firstProductData = first(roots);
    var firstProduct = productManager.createEntityInternal(firstProductData.productRef);
    if (firstProduct == null) {
      this.l1m_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda_1(firstProductData));
      return null;
    }
    var temporarySceneRoot = entityManager.createEntity();
    temporarySceneRoot.addComponent(new SnapRootComponent());
    addAsChildToRoot(this, firstProduct, temporarySceneRoot);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var createdEntitiesMap = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.set' call
    var key = firstProductData.partKey;
    createdEntitiesMap.r2(key, firstProduct);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = structure.products;
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.catalog.Companion.buildProductStructure.<anonymous>' call
      if (!(element_0.partKey === firstProductData.partKey)) {
        destination_0.q(element_0);
      }
    }
    var tmp0_iterator = destination_0.t();
    while (tmp0_iterator.u()) {
      var element_1 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.catalog.Companion.buildProductStructure.<anonymous>' call
      // Inline function 'kotlin.collections.get' call
      var tmp0_safe_receiver = element_1.snap;
      var key_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.offeringPartKey;
      var parent = (isInterface(createdEntitiesMap, Map) ? createdEntitiesMap : THROW_CCE()).b3(key_0);
      var tmp = Companion_getInstance_8();
      var newEntity = addChild(tmp, parent == null ? firstProduct : parent, temporarySceneRoot, element_1, productManager);
      if (newEntity == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var key_1 = element_1.partKey;
        createdEntitiesMap.r2(key_1, newEntity);
      }
    }
    var tmp_0;
    if (get_children(temporarySceneRoot).length > 1) {
      entityManager.disposeEntity(temporarySceneRoot);
      this.l1m_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda_2);
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = firstOrNull(get_children(temporarySceneRoot));
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        var message = 'No child found';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var onlyChild = tmp_1;
      setParent(onlyChild, null);
      temporarySceneRoot.removeComponent(16);
      entityManager.disposeEntity(temporarySceneRoot);
      tmp_0 = onlyChild;
    }
    return tmp_0;
  };
  var Companion_instance_7;
  function Companion_getInstance_8() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function ProductStructureBuilder() {
    Companion_getInstance_8();
  }
  function Companion_8() {
  }
  protoOf(Companion_8).s1k = function () {
    return 118;
  };
  var Companion_instance_8;
  function Companion_getInstance_9() {
    return Companion_instance_8;
  }
  function ProductStructureComponent(products) {
    this.products = products;
  }
  protoOf(ProductStructureComponent).n1m = function () {
    return this.products;
  };
  protoOf(ProductStructureComponent).x1k = function () {
    return Companion_instance_8.id;
  };
  protoOf(ProductStructureComponent).eq = function (other) {
    var otherStructure = other instanceof ProductStructureComponent ? other : THROW_CCE();
    return contentEquals(otherStructure.products, this.products);
  };
  function ProductStructureConnection(offeringPartKey, demandingConnector, offeringConnector) {
    this.offeringPartKey = offeringPartKey;
    this.demandingConnector = demandingConnector;
    this.offeringConnector = offeringConnector;
  }
  protoOf(ProductStructureConnection).o1m = function () {
    return this.offeringPartKey;
  };
  protoOf(ProductStructureConnection).p1m = function () {
    return this.demandingConnector;
  };
  protoOf(ProductStructureConnection).q1m = function () {
    return this.offeringConnector;
  };
  protoOf(ProductStructureConnection).af = function () {
    return this.offeringPartKey;
  };
  protoOf(ProductStructureConnection).bf = function () {
    return this.demandingConnector;
  };
  protoOf(ProductStructureConnection).g1k = function () {
    return this.offeringConnector;
  };
  protoOf(ProductStructureConnection).r1m = function (offeringPartKey, demandingConnector, offeringConnector) {
    return new ProductStructureConnection(offeringPartKey, demandingConnector, offeringConnector);
  };
  protoOf(ProductStructureConnection).copy = function (offeringPartKey, demandingConnector, offeringConnector, $super) {
    offeringPartKey = offeringPartKey === VOID ? this.offeringPartKey : offeringPartKey;
    demandingConnector = demandingConnector === VOID ? this.demandingConnector : demandingConnector;
    offeringConnector = offeringConnector === VOID ? this.offeringConnector : offeringConnector;
    return this.r1m(offeringPartKey, demandingConnector, offeringConnector);
  };
  protoOf(ProductStructureConnection).toString = function () {
    return 'ProductStructureConnection(offeringPartKey=' + this.offeringPartKey + ', demandingConnector=' + this.demandingConnector + ', offeringConnector=' + this.offeringConnector + ')';
  };
  protoOf(ProductStructureConnection).hashCode = function () {
    var result = getStringHashCode(this.offeringPartKey);
    result = imul(result, 31) + getStringHashCode(this.demandingConnector) | 0;
    result = imul(result, 31) + getStringHashCode(this.offeringConnector) | 0;
    return result;
  };
  protoOf(ProductStructureConnection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductStructureConnection))
      return false;
    var tmp0_other_with_cast = other instanceof ProductStructureConnection ? other : THROW_CCE();
    if (!(this.offeringPartKey === tmp0_other_with_cast.offeringPartKey))
      return false;
    if (!(this.demandingConnector === tmp0_other_with_cast.demandingConnector))
      return false;
    if (!(this.offeringConnector === tmp0_other_with_cast.offeringConnector))
      return false;
    return true;
  };
  function ProductStructureItem(partKey, productRef, snap, relativeTransform) {
    snap = snap === VOID ? null : snap;
    relativeTransform = relativeTransform === VOID ? null : relativeTransform;
    this.partKey = partKey;
    this.productRef = productRef;
    this.snap = snap;
    this.relativeTransform = relativeTransform;
  }
  protoOf(ProductStructureItem).z1j = function () {
    return this.partKey;
  };
  protoOf(ProductStructureItem).j1l = function () {
    return this.productRef;
  };
  protoOf(ProductStructureItem).s1m = function () {
    return this.snap;
  };
  protoOf(ProductStructureItem).a1k = function () {
    return this.relativeTransform;
  };
  function start($this) {
    return $this.u1m_1 - ($this.size - 1 | 0) | 0;
  }
  function wrappedIndex($this, index) {
    return (index + $this.t1m_1.n() | 0) % $this.t1m_1.n() | 0;
  }
  function CircularBuffer$iterator$1(this$0) {
    this.x1m_1 = this$0;
    this.w1m_1 = 0;
  }
  protoOf(CircularBuffer$iterator$1).u = function () {
    return this.w1m_1 < this.x1m_1.size;
  };
  protoOf(CircularBuffer$iterator$1).w = function () {
    var tmp1 = this.w1m_1;
    this.w1m_1 = tmp1 + 1 | 0;
    return this.x1m_1.get(tmp1);
  };
  function CircularBuffer(size) {
    var tmp = this;
    // Inline function 'kotlin.collections.MutableList' call
    var list = ArrayList_init_$Create$_0(size);
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.MutableList.<anonymous>' call
        // Inline function 'com.ikea.core.collections.CircularBuffer.internalArray.<anonymous>' call
        list.q(null);
      }
       while (inductionVariable < size);
    tmp.t1m_1 = list;
    this.u1m_1 = -1;
    this.v1m_1 = 0;
  }
  protoOf(CircularBuffer).n = function () {
    return this.v1m_1;
  };
  protoOf(CircularBuffer).add = function (item) {
    if ((this.v1m_1 + 1 | 0) > this.t1m_1.n()) {
      throw IndexOutOfBoundsException_init_$Create$('Not allowed to add more item than size');
    }
    this.u1m_1 = wrappedIndex(this, this.u1m_1 + 1 | 0);
    this.t1m_1.o(this.u1m_1, item);
    this.v1m_1 = this.v1m_1 + 1 | 0;
  };
  protoOf(CircularBuffer).get = function (index) {
    var tmp;
    if ((this.u1m_1 < 0 ? true : index < 0) ? true : index >= this.size) {
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds for length ' + this.size);
    } else {
      var tmp0_elvis_lhs = this.t1m_1.f1(wrappedIndex(this, start(this) + index | 0));
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' is not assigned');
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(CircularBuffer).removeLast = function () {
    var tmp;
    switch (this.v1m_1) {
      case 0:
        tmp = null;
        break;
      case 1:
        var removed = this.get(0);
        this.clear();
        tmp = removed;
        break;
      default:
        var removed_0 = this.get(this.size - 1 | 0);
        this.u1m_1 = wrappedIndex(this, this.u1m_1 - 1 | 0);
        this.v1m_1 = this.v1m_1 - 1 | 0;
        tmp = removed_0;
        break;
    }
    return tmp;
  };
  protoOf(CircularBuffer).clear = function () {
    this.u1m_1 = -1;
    this.v1m_1 = 0;
  };
  protoOf(CircularBuffer).removeFirst = function () {
    var tmp;
    if (this.v1m_1 === 0) {
      tmp = null;
    } else {
      var removed = this.get(0);
      if (this.v1m_1 === 1) {
        this.clear();
      } else {
        this.v1m_1 = this.v1m_1 - 1 | 0;
      }
      tmp = removed;
    }
    return tmp;
  };
  protoOf(CircularBuffer).t = function () {
    return new CircularBuffer$iterator$1(this);
  };
  protoOf(CircularBuffer).toList = function () {
    return toList_0(asSequence(this.t()));
  };
  function objectOrientedBoundingBoxForEntityHierarchy($this, entity, onlyAssembly) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var vertices = ArrayList_init_$Create$();
    objectOrientedBoundingBoxForEntityHierarchy$extractEntity(vertices, onlyAssembly, entity, Companion_getInstance_60().IDENTITY);
    var tmp;
    if (vertices.b1()) {
      tmp = Companion_getInstance_95().ZERO;
    } else {
      var tmp_0 = Companion_getInstance_95();
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$1 = copyToArray(vertices);
      tmp = tmp_0.fromNonCuboidVertices(tmp$ret$1);
    }
    return tmp;
  }
  function objectOrientedBoundingBoxForEntityHierarchy$extractEntity(vertices, $onlyAssembly, innerEntity, localTransform) {
    var tmp0_safe_receiver = get_colliderShapeComponent(innerEntity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.collision.Companion.objectOrientedBoundingBoxForEntityHierarchy.extractEntity.<anonymous>' call
      vertices.x(PolyhedronUtils_getInstance().transformAndExtractVerticesFromPolyhedron(tmp0_safe_receiver.polyhedron, localTransform));
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(innerEntity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.collision.Companion.objectOrientedBoundingBoxForEntityHierarchy.extractEntity.<anonymous>' call
      var tmp;
      if (!$onlyAssembly) {
        tmp = true;
      } else {
        Companion_getInstance_6();
        tmp = element.hasComponent(44);
      }
      if (tmp) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.collision.Companion.objectOrientedBoundingBoxForEntityHierarchy.extractEntity.<anonymous>' call
      objectOrientedBoundingBoxForEntityHierarchy$extractEntity(vertices, $onlyAssembly, element_0, localTransform.concatenate(get_localTransform(element_0)));
    }
  }
  function ColliderComponent$Companion$axisAlignedBoundingBoxForEntityHierarchies$lambda($set) {
    return function (it) {
      $set.q(it);
      return Unit_instance;
    };
  }
  function Companion_9() {
    this.id = 24;
  }
  protoOf(Companion_9).s1k = function () {
    return this.id;
  };
  protoOf(Companion_9).axisAlignedBoundingBoxForEntityHierarchies = function (entities) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var set = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = entities.length;
    while (inductionVariable < last) {
      var element = entities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntityHierarchies.<anonymous>' call
      forEachInHierarchy(element, ColliderComponent$Companion$axisAlignedBoundingBoxForEntityHierarchies$lambda(set));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$1 = copyToArray(set);
    return this.axisAlignedBoundingBoxForEntities(tmp$ret$1);
  };
  protoOf(Companion_9).axisAlignedBoundingBoxForEntities = function (entities) {
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = entities.length;
    while (inductionVariable < last) {
      var element = entities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntities.<anonymous>' call
      var tmp0_safe_receiver = get_collider(element);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver_0);
      }
    }
    var tmp;
    if (destination.b1()) {
      // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntities.<anonymous>' call
      tmp = null;
    } else {
      tmp = destination;
    }
    var tmp0_safe_receiver_1 = tmp;
    var tmp_0;
    if (tmp0_safe_receiver_1 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.reduceRight' call
      var iterator = tmp0_safe_receiver_1.d2(tmp0_safe_receiver_1.n());
      if (!iterator.o1())
        throw UnsupportedOperationException_init_$Create$("Empty list can't be reduced.");
      var accumulator = iterator.q1();
      while (iterator.o1()) {
        // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntities.<anonymous>' call
        var combined = iterator.q1();
        var next = accumulator;
        accumulator = combined.createCombined(next);
      }
      tmp_0 = accumulator;
    }
    return tmp_0;
  };
  protoOf(Companion_9).objectOrientedBoundingBoxForEntityHierarchy = function (entity) {
    return objectOrientedBoundingBoxForEntityHierarchy(this, entity, false);
  };
  protoOf(Companion_9).objectOrientedBoundingBoxForAssemblyHierarchy = function (entity) {
    return objectOrientedBoundingBoxForEntityHierarchy(this, entity, true);
  };
  var Companion_instance_9;
  function Companion_getInstance_10() {
    return Companion_instance_9;
  }
  function ColliderComponent(worldPolyhedron) {
    this.worldPolyhedron = worldPolyhedron;
  }
  protoOf(ColliderComponent).g1n = function () {
    return this.worldPolyhedron;
  };
  protoOf(ColliderComponent).x1k = function () {
    return 24;
  };
  protoOf(ColliderComponent).eq = function (other) {
    return equals((other instanceof ColliderComponent ? other : THROW_CCE()).worldPolyhedron, this.worldPolyhedron);
  };
  protoOf(ColliderComponent).af = function () {
    return this.worldPolyhedron;
  };
  protoOf(ColliderComponent).h1n = function (worldPolyhedron) {
    return new ColliderComponent(worldPolyhedron);
  };
  protoOf(ColliderComponent).copy = function (worldPolyhedron, $super) {
    worldPolyhedron = worldPolyhedron === VOID ? this.worldPolyhedron : worldPolyhedron;
    return this.h1n(worldPolyhedron);
  };
  protoOf(ColliderComponent).toString = function () {
    return 'ColliderComponent(worldPolyhedron=' + this.worldPolyhedron + ')';
  };
  protoOf(ColliderComponent).hashCode = function () {
    return hashCode(this.worldPolyhedron);
  };
  protoOf(ColliderComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColliderComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ColliderComponent ? other : THROW_CCE();
    if (!equals(this.worldPolyhedron, tmp0_other_with_cast.worldPolyhedron))
      return false;
    return true;
  };
  function get_collider(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(24);
  }
  function get_axisAlignedBoundingBoxForHierarchy(_this__u8e3s4) {
    var tmp = Companion_instance_9;
    var tmp0_elvis_lhs = get_snapRoot(_this__u8e3s4);
    return tmp.axisAlignedBoundingBoxForEntities(get_hierarchy(tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs));
  }
  function get_objectOrientedBoundingBoxForHierarchy(_this__u8e3s4) {
    return Companion_instance_9.objectOrientedBoundingBoxForEntityHierarchy(_this__u8e3s4);
  }
  function get_objectOrientedBoundingBoxForAssemblyHierarchy(_this__u8e3s4) {
    return Companion_instance_9.objectOrientedBoundingBoxForAssemblyHierarchy(_this__u8e3s4);
  }
  function get_axisAlignedBoundingBoxForSnappableHierarchy(_this__u8e3s4) {
    if (!(get_snapRoot(_this__u8e3s4) == null)) {
      return Companion_instance_9.axisAlignedBoundingBoxForEntities(get_snapRootSubTree(_this__u8e3s4));
    }
    return get_axisAlignedBoundingBoxForHierarchy(_this__u8e3s4);
  }
  function Companion_10() {
    this.id = 19;
  }
  protoOf(Companion_10).s1k = function () {
    return this.id;
  };
  var Companion_instance_10;
  function Companion_getInstance_11() {
    return Companion_instance_10;
  }
  function ColliderShapeComponent(polyhedron, ids) {
    ids = ids === VOID ? null : ids;
    this.polyhedron = polyhedron;
    this.ids = ids;
  }
  protoOf(ColliderShapeComponent).i1n = function () {
    return this.polyhedron;
  };
  protoOf(ColliderShapeComponent).j1n = function () {
    return this.ids;
  };
  protoOf(ColliderShapeComponent).x1k = function () {
    return 19;
  };
  protoOf(ColliderShapeComponent).eq = function (other) {
    return equals((other instanceof ColliderShapeComponent ? other : THROW_CCE()).polyhedron, this.polyhedron);
  };
  protoOf(ColliderShapeComponent).hashCode = function () {
    return hashCode(this.polyhedron);
  };
  protoOf(ColliderShapeComponent).equals = function (other) {
    var tmp;
    if (other instanceof ColliderShapeComponent) {
      tmp = equals(this.polyhedron, other.polyhedron);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ColliderShapeComponent).af = function () {
    return this.polyhedron;
  };
  protoOf(ColliderShapeComponent).bf = function () {
    return this.ids;
  };
  protoOf(ColliderShapeComponent).k1n = function (polyhedron, ids) {
    return new ColliderShapeComponent(polyhedron, ids);
  };
  protoOf(ColliderShapeComponent).copy = function (polyhedron, ids, $super) {
    polyhedron = polyhedron === VOID ? this.polyhedron : polyhedron;
    ids = ids === VOID ? this.ids : ids;
    return this.k1n(polyhedron, ids);
  };
  protoOf(ColliderShapeComponent).toString = function () {
    return 'ColliderShapeComponent(polyhedron=' + this.polyhedron + ', ids=' + toString(this.ids) + ')';
  };
  function get_colliderShapeComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(19);
  }
  function ColliderUtils() {
  }
  protoOf(ColliderUtils).colliderShapeComponent = function (entity) {
    return get_colliderShapeComponent(entity);
  };
  protoOf(ColliderUtils).colliderComponent = function (entity) {
    return get_collider(entity);
  };
  protoOf(ColliderUtils).axisAlignedBoundingBoxForHierarchy = function (entity) {
    return get_axisAlignedBoundingBoxForHierarchy(entity);
  };
  protoOf(ColliderUtils).objectOrientedBoundingBoxForHierarchy = function (entity) {
    return get_objectOrientedBoundingBoxForHierarchy(entity);
  };
  protoOf(ColliderUtils).objectOrientedBoundingBoxForAssemblyHierarchy = function (entity) {
    return get_objectOrientedBoundingBoxForAssemblyHierarchy(entity);
  };
  var ColliderUtils_instance;
  function ColliderUtils_getInstance() {
    return ColliderUtils_instance;
  }
  function Collision(self_0, other, interpenetration) {
    this.self = self_0;
    this.other = other;
    this.interpenetration = interpenetration;
    this.selfWorldTransformAtTimeOfCollision = get_worldTransform(this.self);
  }
  protoOf(Collision).l1n = function () {
    return this.self;
  };
  protoOf(Collision).m1n = function () {
    return this.other;
  };
  protoOf(Collision).n1n = function () {
    return this.interpenetration;
  };
  protoOf(Collision).o1n = function () {
    return this.selfWorldTransformAtTimeOfCollision;
  };
  protoOf(Collision).toString = function () {
    return '' + this.self + ' collision at ' + this.selfWorldTransformAtTimeOfCollision + ' with ' + this.other + ' interpenetration ' + this.interpenetration;
  };
  protoOf(Collision).af = function () {
    return this.self;
  };
  protoOf(Collision).bf = function () {
    return this.other;
  };
  protoOf(Collision).g1k = function () {
    return this.interpenetration;
  };
  protoOf(Collision).p1n = function (self_0, other, interpenetration) {
    return new Collision(self_0, other, interpenetration);
  };
  protoOf(Collision).copy = function (self_0, other, interpenetration, $super) {
    self_0 = self_0 === VOID ? this.self : self_0;
    other = other === VOID ? this.other : other;
    interpenetration = interpenetration === VOID ? this.interpenetration : interpenetration;
    return this.p1n(self_0, other, interpenetration);
  };
  protoOf(Collision).hashCode = function () {
    var result = this.self.hashCode();
    result = imul(result, 31) + this.other.hashCode() | 0;
    result = imul(result, 31) + this.interpenetration.hashCode() | 0;
    return result;
  };
  protoOf(Collision).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Collision))
      return false;
    var tmp0_other_with_cast = other instanceof Collision ? other : THROW_CCE();
    if (!this.self.equals(tmp0_other_with_cast.self))
      return false;
    if (!this.other.equals(tmp0_other_with_cast.other))
      return false;
    if (!this.interpenetration.equals(tmp0_other_with_cast.interpenetration))
      return false;
    return true;
  };
  function Companion_11() {
    this.INTERPENETRATION_THRESHOLD = 0.1;
  }
  protoOf(Companion_11).q1n = function () {
    return this.INTERPENETRATION_THRESHOLD;
  };
  var Companion_instance_11;
  function Companion_getInstance_12() {
    return Companion_instance_11;
  }
  function CollisionConstants() {
  }
  function getPenetrations($this, entity, disposition, otherEntities, checkMyChildren) {
    var entitiesInSubTree = checkMyChildren ? get_hierarchySequence(entity) : sequenceOf([entity]);
    return flatten(mapNotNull(entitiesInSubTree, CollisionUtils$getPenetrations$lambda(otherEntities, entity, disposition)));
  }
  function getPenetrations$default($this, entity, disposition, otherEntities, checkMyChildren, $super) {
    disposition = disposition === VOID ? null : disposition;
    return getPenetrations($this, entity, disposition, otherEntities, checkMyChildren);
  }
  function CollisionUtils$getFirstCollision$lambda($otherEntities, $entity, $disposition, $res) {
    return function (current) {
      var tmp0_safe_receiver = get_collider(current);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var indexedObject = $otherEntities;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.collision.CollisionUtils.getFirstCollision.<anonymous>.<anonymous>.<anonymous>' call
          if (!(element.id === $entity.id)) {
            var tmp;
            if ($disposition == null) {
              var tmp0_safe_receiver_0 = get_collider(element);
              var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.worldPolyhedron;
              var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.penetration(tmp1_safe_receiver);
              tmp = tmp2_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp2_elvis_lhs;
            } else {
              var tmp3_safe_receiver = get_collider(element);
              var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.worldPolyhedron;
              var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.penetrationAlongAxis(tmp1_safe_receiver, $disposition);
              tmp = tmp5_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp5_elvis_lhs;
            }
            var interpenetration = tmp;
            if (!interpenetration.equals(Companion_getInstance_61().ZERO)) {
              $res._v = new Collision(current, element, interpenetration);
              return true;
            }
          }
        }
      }
      return false;
    };
  }
  function CollisionUtils$getPenetrations$lambda$lambda($entity) {
    return function (other) {
      return !other.equals($entity);
    };
  }
  function CollisionUtils$getPenetrations$lambda$lambda_0($disposition, $worldPoly, $current) {
    return function (other) {
      var tmp;
      if ($disposition == null) {
        var tmp0_safe_receiver = get_collider(other);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.penetration($worldPoly);
        tmp = tmp2_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp2_elvis_lhs;
      } else {
        var tmp3_safe_receiver = get_collider(other);
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.worldPolyhedron;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.penetrationAlongAxis($worldPoly, $disposition);
        tmp = tmp5_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp5_elvis_lhs;
      }
      var interpenetration = tmp;
      return !interpenetration.equals(Companion_getInstance_61().ZERO) ? new Collision($current, other, interpenetration) : null;
    };
  }
  function CollisionUtils$getPenetrations$lambda($otherEntities, $entity, $disposition) {
    return function (current) {
      var tmp0_safe_receiver = get_collider(current);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.collision.CollisionUtils.getPenetrations.<anonymous>.<anonymous>' call
        var tmp_0 = filter($otherEntities, CollisionUtils$getPenetrations$lambda$lambda($entity));
        tmp = mapNotNull(tmp_0, CollisionUtils$getPenetrations$lambda$lambda_0($disposition, tmp1_safe_receiver, current));
      }
      return tmp;
    };
  }
  function CollisionUtils() {
  }
  protoOf(CollisionUtils).getAllCollisions = function (entity, disposition, otherEntities) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = toList_0(getPenetrations(this, entity, disposition, asSequence_0(otherEntities), true));
    return copyToArray(this_0);
  };
  protoOf(CollisionUtils).getFirstCollision = function (entity, disposition, otherEntities) {
    var res = {_v: null};
    findInHierarchy(entity, CollisionUtils$getFirstCollision$lambda(otherEntities, entity, disposition, res));
    return res._v;
  };
  var CollisionUtils_instance;
  function CollisionUtils_getInstance() {
    return CollisionUtils_instance;
  }
  function validate($this, entity, snapActionCandidate, earlyOut) {
    var otherEntities = hierarchyExceptSubTreeArray($this.findRoot(snapActionCandidate, entity), entity);
    var tmp;
    if (earlyOut) {
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = listOfNotNull(CollisionUtils_instance.getFirstCollision(entity, null, otherEntities));
      tmp = copyToArray(this_0);
    } else {
      tmp = CollisionUtils_instance.getAllCollisions(entity, null, otherEntities);
    }
    var collisions = tmp;
    return any(collisions) ? new CollisionValidationResult(collisions, get_productRefOrEmptyString(entity), $this.severity, $this) : null;
  }
  function Companion_12() {
    this.ID = 'Collision';
  }
  protoOf(Companion_12).u1n = function () {
    return this.ID;
  };
  var Companion_instance_12;
  function Companion_getInstance_13() {
    return Companion_instance_12;
  }
  function CollisionValidation() {
    ValidationImpl.call(this);
    this.s1n_1 = 'Collision';
    this.t1n_1 = false;
    this.severity = ValidationResultType_FAIL_getInstance();
  }
  protoOf(CollisionValidation).s1k = function () {
    return this.s1n_1;
  };
  protoOf(CollisionValidation).v1n = function (_set____db54di) {
    this.severity = _set____db54di;
  };
  protoOf(CollisionValidation).w1n = function () {
    return this.severity;
  };
  protoOf(CollisionValidation).enableExhaustiveValidation = function () {
    this.t1n_1 = true;
  };
  protoOf(CollisionValidation).disableExhaustiveValidation = function () {
    this.t1n_1 = false;
  };
  protoOf(CollisionValidation).validateCurrentState = function (entity) {
    return validate(this, entity, null, !this.t1n_1);
  };
  protoOf(CollisionValidation).validateSnap = function (snapActionCandidate) {
    return validate(this, snapActionCandidate.guestRoot, snapActionCandidate, !this.t1n_1);
  };
  function Companion_13() {
    this.ID = 'CollisionValidationResult';
  }
  protoOf(Companion_13).u1n = function () {
    return this.ID;
  };
  var Companion_instance_13;
  function Companion_getInstance_14() {
    return Companion_instance_13;
  }
  function CollisionValidationResult$toString$lambda(collision) {
    return collision.toString();
  }
  function CollisionValidationResult(collisions, productRef, severity, rule) {
    ValidationResult.call(this, severity, productRef, rule);
    this.collisions = collisions;
  }
  protoOf(CollisionValidationResult).z1n = function () {
    return this.collisions;
  };
  protoOf(CollisionValidationResult).s1k = function () {
    return 'CollisionValidationResult';
  };
  protoOf(CollisionValidationResult).toString = function () {
    var collizions = joinToString_0(this.collisions, VOID, VOID, VOID, VOID, VOID, CollisionValidationResult$toString$lambda);
    return 'CollisionValidationResult [' + this.productRef + '] has collisions [' + collizions + ']';
  };
  protoOf(CollisionValidationResult).a1o = function () {
    var tmp0_safe_receiver = firstOrNull(this.collisions);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.other;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_collider(tmp1_safe_receiver);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.worldPolyhedron;
    var totalAabb = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.axisAlignedBoundingBox;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.collisions;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.collision.CollisionValidationResult.<get-aabbOfAllCollidedWith>.<anonymous>' call
      var otherAabb = get_axisAlignedBoundingBoxForSnappableHierarchy(element.other);
      var tmp;
      if (totalAabb == null) {
        tmp = otherAabb;
      } else {
        var tmp0_safe_receiver_0 = totalAabb;
        tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.createCombined(otherAabb);
      }
      totalAabb = tmp;
    }
    var tmp4_elvis_lhs = totalAabb;
    return tmp4_elvis_lhs == null ? new AxisAlignedBox(Companion_getInstance_61().ZERO, Companion_getInstance_61().ZERO) : tmp4_elvis_lhs;
  };
  function Companion_14() {
    this.ID = 'WorldColliderUpdateSystem';
  }
  protoOf(Companion_14).u1n = function () {
    return this.ID;
  };
  var Companion_instance_14;
  function Companion_getInstance_15() {
    return Companion_instance_14;
  }
  function updateWorldCollider($this, entity) {
    var tmp0_safe_receiver = calculateWorldCollider($this, entity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.collision.WorldColliderUpdateSystem.updateWorldCollider.<anonymous>' call
      entity.addComponent(tmp0_safe_receiver);
    }
  }
  function calculateWorldCollider($this, entity) {
    var tmp0_safe_receiver = get_colliderShapeComponent(entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var basePolyhedron = tmp;
    var transformedPolyhedron = TransformUtils_instance.applyWorldTransform(basePolyhedron, entity);
    return new ColliderComponent(transformedPolyhedron);
  }
  function WorldColliderUpdateSystem() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [24];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['TransformSystem'];
    SystemBase2.call(this, 'WorldColliderUpdateSystem', 10, 19, tmp, tmp$ret$5, null);
  }
  protoOf(WorldColliderUpdateSystem).onAddComponent = function (entity, newComponent) {
    updateWorldCollider(this, entity);
  };
  protoOf(WorldColliderUpdateSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    updateWorldCollider(this, entity);
  };
  protoOf(WorldColliderUpdateSystem).onRemoveComponent = function (entity, oldComponent) {
    updateWorldCollider(this, entity);
  };
  protoOf(WorldColliderUpdateSystem).onAddComponent2 = function (entity, newComponent) {
    updateWorldCollider(this, entity);
  };
  protoOf(WorldColliderUpdateSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    updateWorldCollider(this, entity);
  };
  protoOf(WorldColliderUpdateSystem).onRemoveComponent2 = function (entity, oldComponent) {
    entity.removeComponent(24);
  };
  function ComponentIdSpan() {
    this.CORE_BASE_ID = 0;
    this.PAX_RANGE_BASE_ID = 1000;
    this.BESTA_RANGE_BASE_ID = 1500;
    this.STORAGEONE_RANGE_BASE_ID = 2000;
    this.SNYGGIS_BASE_ID = 90000;
    this.CONCEPT_PLANNER_BASE_ID = 100000;
    this.PAX_PLANNER_BASE_ID = 101000;
    this.BESTA_PLANNER_BASE_ID = 101500;
    this.SPACE_PLANNER_BASE_ID = 102000;
    this.SKYTTA_PLANNER_BASE_ID = 103000;
    this.WALL_DECO_PLANNER_BASE_ID = 104000;
    this.CORE_TOOLBOX_BASE_ID = 105000;
    this.CORE_TOOLBOX_EXPERIMENTAL_BASE_ID = 106000;
    this.KVADRAT_BASE_ID = 107000;
    this.CORE_COMMUNITY_BASE_ID = 108000;
    this.SOFA_BASE_ID = 109000;
    this.KITCHEN_CONFIGURATOR_BASE_ID = 110000;
  }
  protoOf(ComponentIdSpan).d1p = function () {
    return this.CORE_BASE_ID;
  };
  protoOf(ComponentIdSpan).e1p = function () {
    return this.PAX_RANGE_BASE_ID;
  };
  protoOf(ComponentIdSpan).f1p = function () {
    return this.BESTA_RANGE_BASE_ID;
  };
  protoOf(ComponentIdSpan).g1p = function () {
    return this.STORAGEONE_RANGE_BASE_ID;
  };
  protoOf(ComponentIdSpan).h1p = function () {
    return this.SNYGGIS_BASE_ID;
  };
  protoOf(ComponentIdSpan).i1p = function () {
    return this.CONCEPT_PLANNER_BASE_ID;
  };
  protoOf(ComponentIdSpan).j1p = function () {
    return this.PAX_PLANNER_BASE_ID;
  };
  protoOf(ComponentIdSpan).k1p = function () {
    return this.BESTA_PLANNER_BASE_ID;
  };
  protoOf(ComponentIdSpan).l1p = function () {
    return this.SPACE_PLANNER_BASE_ID;
  };
  protoOf(ComponentIdSpan).m1p = function () {
    return this.SKYTTA_PLANNER_BASE_ID;
  };
  protoOf(ComponentIdSpan).n1p = function () {
    return this.WALL_DECO_PLANNER_BASE_ID;
  };
  protoOf(ComponentIdSpan).o1p = function () {
    return this.CORE_TOOLBOX_BASE_ID;
  };
  protoOf(ComponentIdSpan).p1p = function () {
    return this.CORE_TOOLBOX_EXPERIMENTAL_BASE_ID;
  };
  protoOf(ComponentIdSpan).q1p = function () {
    return this.KVADRAT_BASE_ID;
  };
  protoOf(ComponentIdSpan).r1p = function () {
    return this.CORE_COMMUNITY_BASE_ID;
  };
  protoOf(ComponentIdSpan).s1p = function () {
    return this.SOFA_BASE_ID;
  };
  protoOf(ComponentIdSpan).t1p = function () {
    return this.KITCHEN_CONFIGURATOR_BASE_ID;
  };
  var ComponentIdSpan_instance;
  function ComponentIdSpan_getInstance() {
    return ComponentIdSpan_instance;
  }
  function ComponentIds() {
    this.SELECTED_COMPONENT_ID = 0;
    this.SELECTABLE_COMPONENT_ID = 1;
    this.PROPPING_HOST_CONNECTORS_COMPONENT_ID = 2;
    this.DRAGGABLE_COMPONENT_ID = 3;
    this.COLLISION_VISUALIZATION_SCENE_DATA_COMPONENT_ID = 4;
    this.IN_SCENE_COMPONENT_ID = 5;
    this.LOCAL_TRANSFORM_COMPONENT_ID = 6;
    this.PROPPING_COMPONENT_ID = 7;
    this.RESTRICT_ALLOWED_REQUIRED_HOSTS_COMPONENT_ID = 8;
    this.RENDERED_COMPONENT_ID = 9;
    this.WORLD_TRANSFORM_COMPONENT_ID = 10;
    this.CONNECTORS_COMPONENT_ID = 11;
    this.ASSEMBLY_STRUCTURE_COMPONENT_ID = 12;
    this.MODEL_INFO_COMPONENT_ID = 13;
    this.OUTLINED_COMPONENT_ID = 14;
    this.DISPLAY_NAME_COMPONENT_ID = 15;
    this.PARENT_COMPONENT_ID = 16;
    this.CHILD_COMPONENT_ID = 17;
    this.PRODUCT_COMPONENT_ID = 18;
    this.COLLIDER_SHAPE_COMPONENT_ID = 19;
    this.LOADED_MODEL_INFO_COMPONENT_ID = 20;
    this.SNAP_CANDIDATE_COMPONENT_ID = 21;
    this.CONNECTOR_VISUALIZATION_NODE_COMPONENT_ID = 22;
    this.COLLIDER_VISUALIZATION_NODE_COMPONENT_ID = 23;
    this.COLLIDER_COMPONENT_ID = 24;
    this.UNSERIALIZABLE_ENTITY_COMPONENT_ID = 25;
    this.ALWAYS_HANG_DOWN_COMPONENT_ID = 26;
    this.VIEWER_CAMERA_STATE_COMPONENT_ID = 27;
    this.CONNECTION_ROOT_COMPONENT = 28;
    this.ALLOWED_DOOR_PAIRS_COMPONENT_ID = 29;
    this.DOOR_COMPONENT_ID = 30;
    this.FRAME_COMPONENT_ID = 31;
    this.DOOR_FRONT_COMPONENT_ID = 32;
    this.COMMUNICATION_SIZE_COMPONENT_ID = 33;
    this.SNAP_ACTION_IN_PROGRESS_COMPONENT = 34;
    this.VIEWER_OBJECT_COMPONENT_ID = 35;
    this.IS_LOADING_SNAPSHOT_COMPONENT_ID = 36;
    this.MANUAL_ENTITY_GROUP_COMPONENT_ID = 37;
    this.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID = 38;
    this.HANDLE_COMPONENT_ID = 39;
    this.META_DATA_COMPONENT_ID = 40;
    this.ROOM_DIMENSIONS_COMPONENT_ID = 41;
    this.RELATIVE_CONNECTORS_COMPONENT_ID = 42;
    this.ASSEMBLY_PARTS_COMPONENT_ID = 43;
    this.PRODUCT_PART_COMPONENT_ID = 44;
    this.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID = 45;
    this.INCLUDED_HANDLE_COMPONENT_ID = 46;
    this.SNAP_ROOT_COMPONENT_ID = 47;
    this.LEG_COMPONENT_ID = 48;
    this.TEMPLATE_DATA_COMPONENT_ID = 49;
    this.DRAWER_COMPONENT_ID = 50;
    this.ALIGNMENT_CONNECTIONS_COMPONENT_ID = 51;
    this.HANDLE_UNDER_ALIGNMENT_COMPONENT_ID = 52;
    this.ROOM_COMPONENT_ID = 53;
    this.ROOM_ACTIVE_CONNECTORS_COMPONENT_ID = 54;
    this.MULTISELECTION_ENABLED_COMPONENT_ID = 56;
    this.OUTLINEABLE_COMPONENT_ID = 57;
    this.PLACEMENT_ZONE_BY_HEIGHT_COMPONENT_ID = 58;
    this.RECOMMENDED_INITIAL_POSITION_FROM_FLOOR_COMPONENT_ID = 59;
    this.RECOMMENDED_INITIAL_POSITION_FROM_PARENT_COMPONENT_ID = 60;
    this.FUNCTIONAL_MARGIN_SHAPE_COMPONENT_ID = 61;
    this.FUNCTIONAL_MARGIN_COMPONENT_ID = 62;
    this.LIGHT_COMPONENT_ID = 63;
    this.ROOM_ALIGNMENT_EDGES_COMPONENT_ID = 64;
    this.IS_DRAGGED_COMPONENT_ID = 65;
    this.SOMETHING_IS_DRAGGED_COMPONENT_ID = 66;
    this.FREE_MOVE_COMPONENT_ID = 67;
    this.MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID = 68;
    this.DRAG_STATE_COMPONENT = 69;
    this.ROOM_GEOMETRY_COMPONENT_ID = 70;
    this.DISABLED_CONNECTOR_KEYS_COMPONENT_ID = 71;
    this.VISUAL_LIGHT_SOURCE_COMPONENT_ID = 72;
    this.SCENE_RELOADING_COMPONENT_ID = 73;
    this.DRAG_SURFACES_COMPONENT_ID = 74;
    this.DISABLED_ROOM_CONNECTORS_COMPONENT_ID = 75;
    this.ROOM_CONNECTOR_RELATIONS_COMPONENT_ID = 76;
    this.ENTITY_CONNECTOR_VISUALIZATION_COMPONENT_ID = 77;
    this.ENTITY_COLLIDER_VISUALIZATION_COMPONENT_ID = 78;
    this.ENTITY_HOST_ZONE_VISUALIZATION_COMPONENT_ID = 79;
    this.ENTITY_FUNCTIONAL_ZONE_VISUALIZATION_COMPONENT_ID = 80;
    this.DRAG_SURFACE_ENTITY_PAIR_CACHE_COMPONENT = 81;
    this.VIEWER_COMPONENT_ID = 82;
    this.DECORATOR_COMPONENT_ID = 83;
    this.VIEWER_DRAG_EVENT_COMPONENT_ID = 84;
    this.WORLD_SPACE_DRAG_EVENT_COMPONENT_ID = 85;
    this.CLICK_EVENT_COMPONENT_ID = 86;
    this.PROPPING_INFO_COMPONENT_ID = 87;
    this.HISTORY_CHANGED_EVENT_COMPONENT_ID = 88;
    this.PAUSE_VIEWER_UPDATES_COMPONENT = 90;
    this.WORLD_DRAG_SURFACES_COMPONENT_ID = 91;
    this.DEBUG_LINES_COMPONENT = 92;
    this.VIEWER_LINE_IDS_COMPONENT = 93;
    this.GRAB_OFFSET_COMPONENT_ID = 94;
    this.SNAPSHOT_IGNORE_COMPONENT = 95;
    this.ASSEMBLY_PART_IDS_COMPONENT_ID = 96;
    this.SCENE_COMPONENT_ID = 97;
    this.COLLIDER_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID = 98;
    this.CONNECTOR_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID = 99;
    this.PREVIOUSLY_SERIALIZED_ID_COMPONENT_ID = 100;
    this.STATIC_COMPONENT_ID = 101;
    this.POLYHEDRON_VISUALIZATION_HOLDER_COMPONENT_ID = 102;
    this.ROOM_PART_COMPONENT_ID = 103;
    this.GUEST_CONNECTIONS_COMPONENT_ID = 104;
    this.HOST_CONNECTIONS_COMPONENT_ID = 105;
    this.SERIALIZABLE_CONNECTIONS_COMPONENT_ID = 106;
    this.TEMPORARILY_PAUSE_CONNECTIONS_PARENTING_COMPONENT_ID = 107;
    this.POLYHEDRON_VISUALIZATION_NODE_COMPONENT_ID = 108;
    this.COLLIDER_VISUALIZATION_CONFIG_COMPONENT_ID = 109;
    this.CONNECTOR_VISUALIZATION_CONFIG_COMPONENT_ID = 110;
    this.OUTLINE_BLOCKING_COMPONENT_ID = 111;
    this.LABEL_COMPONENT_ID = 112;
    this.DRAG_PROJECTION_POINT_COMPONENT_ID = 113;
    this.COLORED_OUTLINE_COMPONENT_ID = 114;
    this.MANUAL_GROUP_ID_COUNT_COMPONENT_ID = 115;
    this.AUTOMATIC_GROUP_ID_COUNT_COMPONENT_ID = 116;
    this.SCENE_MANAGER_CACHE_COMPONENT_ID = 117;
    this.PRODUCT_STRUCTURE_COMPONENT_ID = 118;
    this.CAMERA_COMPONENT_ID = 119;
    this.DEBUG_SURFACES_COMPONENT = 120;
    this.FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID = 121;
    this.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID = 122;
    this.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID = 123;
    this.MODEL_TRANSFORM_COMPONENT_ID = 124;
    this.AUTO_ADAPT_SESSION_COMPONENT_ID = 125;
    this.AUTO_ADAPT_GUEST_COMPONENT_ID = 126;
    this.AUTO_ADAPT_HOST_COMPONENT_ID = 127;
    this.AUTO_ADAPT_CACHED_VARIANTS_COMPONENT_ID = 128;
    this.AUTO_ADAPT_VARIANT_COMPONENT_ID = 129;
    this.FORCE_AUTO_ADAPT_WHEN_PARENT_IS_DRAGGED_COMPONENT_ID = 130;
    this.REPLACED_ENTITY_WITH_AUTO_ADAPT_EVENT_COMPONENT_ID = 131;
    this.AUTO_ADAPT_CHILD_FAILED_EVENT_COMPONENT_ID = 132;
    this.AUTO_ADAPT_PRODUCT_SPECIFICATIONS_COMPONENT_ID = 133;
    this.highestCoreComponentId = 133;
  }
  protoOf(ComponentIds).u1p = function () {
    return this.SELECTED_COMPONENT_ID;
  };
  protoOf(ComponentIds).v1p = function () {
    return this.SELECTABLE_COMPONENT_ID;
  };
  protoOf(ComponentIds).w1p = function () {
    return this.PROPPING_HOST_CONNECTORS_COMPONENT_ID;
  };
  protoOf(ComponentIds).x1p = function () {
    return this.DRAGGABLE_COMPONENT_ID;
  };
  protoOf(ComponentIds).y1p = function () {
    return this.COLLISION_VISUALIZATION_SCENE_DATA_COMPONENT_ID;
  };
  protoOf(ComponentIds).z1p = function () {
    return this.IN_SCENE_COMPONENT_ID;
  };
  protoOf(ComponentIds).a1q = function () {
    return this.LOCAL_TRANSFORM_COMPONENT_ID;
  };
  protoOf(ComponentIds).b1q = function () {
    return this.PROPPING_COMPONENT_ID;
  };
  protoOf(ComponentIds).c1q = function () {
    return this.RESTRICT_ALLOWED_REQUIRED_HOSTS_COMPONENT_ID;
  };
  protoOf(ComponentIds).d1q = function () {
    return this.RENDERED_COMPONENT_ID;
  };
  protoOf(ComponentIds).e1q = function () {
    return this.WORLD_TRANSFORM_COMPONENT_ID;
  };
  protoOf(ComponentIds).f1q = function () {
    return this.CONNECTORS_COMPONENT_ID;
  };
  protoOf(ComponentIds).g1q = function () {
    return this.ASSEMBLY_STRUCTURE_COMPONENT_ID;
  };
  protoOf(ComponentIds).h1q = function () {
    return this.MODEL_INFO_COMPONENT_ID;
  };
  protoOf(ComponentIds).i1q = function () {
    return this.OUTLINED_COMPONENT_ID;
  };
  protoOf(ComponentIds).j1q = function () {
    return this.DISPLAY_NAME_COMPONENT_ID;
  };
  protoOf(ComponentIds).k1q = function () {
    return this.PARENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).l1q = function () {
    return this.CHILD_COMPONENT_ID;
  };
  protoOf(ComponentIds).m1q = function () {
    return this.PRODUCT_COMPONENT_ID;
  };
  protoOf(ComponentIds).n1q = function () {
    return this.COLLIDER_SHAPE_COMPONENT_ID;
  };
  protoOf(ComponentIds).o1q = function () {
    return this.LOADED_MODEL_INFO_COMPONENT_ID;
  };
  protoOf(ComponentIds).p1q = function () {
    return this.SNAP_CANDIDATE_COMPONENT_ID;
  };
  protoOf(ComponentIds).q1q = function () {
    return this.CONNECTOR_VISUALIZATION_NODE_COMPONENT_ID;
  };
  protoOf(ComponentIds).r1q = function () {
    return this.COLLIDER_VISUALIZATION_NODE_COMPONENT_ID;
  };
  protoOf(ComponentIds).s1q = function () {
    return this.COLLIDER_COMPONENT_ID;
  };
  protoOf(ComponentIds).t1q = function () {
    return this.UNSERIALIZABLE_ENTITY_COMPONENT_ID;
  };
  protoOf(ComponentIds).u1q = function () {
    return this.ALWAYS_HANG_DOWN_COMPONENT_ID;
  };
  protoOf(ComponentIds).v1q = function () {
    return this.VIEWER_CAMERA_STATE_COMPONENT_ID;
  };
  protoOf(ComponentIds).w1q = function () {
    return this.CONNECTION_ROOT_COMPONENT;
  };
  protoOf(ComponentIds).x1q = function () {
    return this.ALLOWED_DOOR_PAIRS_COMPONENT_ID;
  };
  protoOf(ComponentIds).y1q = function () {
    return this.DOOR_COMPONENT_ID;
  };
  protoOf(ComponentIds).z1q = function () {
    return this.FRAME_COMPONENT_ID;
  };
  protoOf(ComponentIds).a1r = function () {
    return this.DOOR_FRONT_COMPONENT_ID;
  };
  protoOf(ComponentIds).b1r = function () {
    return this.COMMUNICATION_SIZE_COMPONENT_ID;
  };
  protoOf(ComponentIds).c1r = function () {
    return this.SNAP_ACTION_IN_PROGRESS_COMPONENT;
  };
  protoOf(ComponentIds).d1r = function () {
    return this.VIEWER_OBJECT_COMPONENT_ID;
  };
  protoOf(ComponentIds).e1r = function () {
    return this.IS_LOADING_SNAPSHOT_COMPONENT_ID;
  };
  protoOf(ComponentIds).f1r = function () {
    return this.MANUAL_ENTITY_GROUP_COMPONENT_ID;
  };
  protoOf(ComponentIds).g1r = function () {
    return this.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID;
  };
  protoOf(ComponentIds).h1r = function () {
    return this.HANDLE_COMPONENT_ID;
  };
  protoOf(ComponentIds).i1r = function () {
    return this.META_DATA_COMPONENT_ID;
  };
  protoOf(ComponentIds).j1r = function () {
    return this.ROOM_DIMENSIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).k1r = function () {
    return this.RELATIVE_CONNECTORS_COMPONENT_ID;
  };
  protoOf(ComponentIds).l1r = function () {
    return this.ASSEMBLY_PARTS_COMPONENT_ID;
  };
  protoOf(ComponentIds).m1r = function () {
    return this.PRODUCT_PART_COMPONENT_ID;
  };
  protoOf(ComponentIds).n1r = function () {
    return this.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID;
  };
  protoOf(ComponentIds).o1r = function () {
    return this.INCLUDED_HANDLE_COMPONENT_ID;
  };
  protoOf(ComponentIds).p1r = function () {
    return this.SNAP_ROOT_COMPONENT_ID;
  };
  protoOf(ComponentIds).q1r = function () {
    return this.LEG_COMPONENT_ID;
  };
  protoOf(ComponentIds).r1r = function () {
    return this.TEMPLATE_DATA_COMPONENT_ID;
  };
  protoOf(ComponentIds).s1r = function () {
    return this.DRAWER_COMPONENT_ID;
  };
  protoOf(ComponentIds).t1r = function () {
    return this.ALIGNMENT_CONNECTIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).u1r = function () {
    return this.HANDLE_UNDER_ALIGNMENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).v1r = function () {
    return this.ROOM_COMPONENT_ID;
  };
  protoOf(ComponentIds).w1r = function () {
    return this.ROOM_ACTIVE_CONNECTORS_COMPONENT_ID;
  };
  protoOf(ComponentIds).x1r = function () {
    return this.MULTISELECTION_ENABLED_COMPONENT_ID;
  };
  protoOf(ComponentIds).y1r = function () {
    return this.OUTLINEABLE_COMPONENT_ID;
  };
  protoOf(ComponentIds).z1r = function () {
    return this.PLACEMENT_ZONE_BY_HEIGHT_COMPONENT_ID;
  };
  protoOf(ComponentIds).a1s = function () {
    return this.RECOMMENDED_INITIAL_POSITION_FROM_FLOOR_COMPONENT_ID;
  };
  protoOf(ComponentIds).b1s = function () {
    return this.RECOMMENDED_INITIAL_POSITION_FROM_PARENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).c1s = function () {
    return this.FUNCTIONAL_MARGIN_SHAPE_COMPONENT_ID;
  };
  protoOf(ComponentIds).d1s = function () {
    return this.FUNCTIONAL_MARGIN_COMPONENT_ID;
  };
  protoOf(ComponentIds).e1s = function () {
    return this.LIGHT_COMPONENT_ID;
  };
  protoOf(ComponentIds).f1s = function () {
    return this.ROOM_ALIGNMENT_EDGES_COMPONENT_ID;
  };
  protoOf(ComponentIds).g1s = function () {
    return this.IS_DRAGGED_COMPONENT_ID;
  };
  protoOf(ComponentIds).h1s = function () {
    return this.SOMETHING_IS_DRAGGED_COMPONENT_ID;
  };
  protoOf(ComponentIds).i1s = function () {
    return this.FREE_MOVE_COMPONENT_ID;
  };
  protoOf(ComponentIds).j1s = function () {
    return this.MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID;
  };
  protoOf(ComponentIds).k1s = function () {
    return this.DRAG_STATE_COMPONENT;
  };
  protoOf(ComponentIds).l1s = function () {
    return this.ROOM_GEOMETRY_COMPONENT_ID;
  };
  protoOf(ComponentIds).m1s = function () {
    return this.DISABLED_CONNECTOR_KEYS_COMPONENT_ID;
  };
  protoOf(ComponentIds).n1s = function () {
    return this.VISUAL_LIGHT_SOURCE_COMPONENT_ID;
  };
  protoOf(ComponentIds).o1s = function () {
    return this.SCENE_RELOADING_COMPONENT_ID;
  };
  protoOf(ComponentIds).p1s = function () {
    return this.DRAG_SURFACES_COMPONENT_ID;
  };
  protoOf(ComponentIds).q1s = function () {
    return this.DISABLED_ROOM_CONNECTORS_COMPONENT_ID;
  };
  protoOf(ComponentIds).r1s = function () {
    return this.ROOM_CONNECTOR_RELATIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).s1s = function () {
    return this.ENTITY_CONNECTOR_VISUALIZATION_COMPONENT_ID;
  };
  protoOf(ComponentIds).t1s = function () {
    return this.ENTITY_COLLIDER_VISUALIZATION_COMPONENT_ID;
  };
  protoOf(ComponentIds).u1s = function () {
    return this.ENTITY_HOST_ZONE_VISUALIZATION_COMPONENT_ID;
  };
  protoOf(ComponentIds).v1s = function () {
    return this.ENTITY_FUNCTIONAL_ZONE_VISUALIZATION_COMPONENT_ID;
  };
  protoOf(ComponentIds).w1s = function () {
    return this.DRAG_SURFACE_ENTITY_PAIR_CACHE_COMPONENT;
  };
  protoOf(ComponentIds).x1s = function () {
    return this.VIEWER_COMPONENT_ID;
  };
  protoOf(ComponentIds).y1s = function () {
    return this.DECORATOR_COMPONENT_ID;
  };
  protoOf(ComponentIds).z1s = function () {
    return this.VIEWER_DRAG_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).a1t = function () {
    return this.WORLD_SPACE_DRAG_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).b1t = function () {
    return this.CLICK_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).c1t = function () {
    return this.PROPPING_INFO_COMPONENT_ID;
  };
  protoOf(ComponentIds).d1t = function () {
    return this.HISTORY_CHANGED_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).e1t = function () {
    return this.PAUSE_VIEWER_UPDATES_COMPONENT;
  };
  protoOf(ComponentIds).f1t = function () {
    return this.WORLD_DRAG_SURFACES_COMPONENT_ID;
  };
  protoOf(ComponentIds).g1t = function () {
    return this.DEBUG_LINES_COMPONENT;
  };
  protoOf(ComponentIds).h1t = function () {
    return this.VIEWER_LINE_IDS_COMPONENT;
  };
  protoOf(ComponentIds).i1t = function () {
    return this.GRAB_OFFSET_COMPONENT_ID;
  };
  protoOf(ComponentIds).j1t = function () {
    return this.SNAPSHOT_IGNORE_COMPONENT;
  };
  protoOf(ComponentIds).k1t = function () {
    return this.ASSEMBLY_PART_IDS_COMPONENT_ID;
  };
  protoOf(ComponentIds).l1t = function () {
    return this.SCENE_COMPONENT_ID;
  };
  protoOf(ComponentIds).m1t = function () {
    return this.COLLIDER_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID;
  };
  protoOf(ComponentIds).n1t = function () {
    return this.CONNECTOR_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID;
  };
  protoOf(ComponentIds).o1t = function () {
    return this.PREVIOUSLY_SERIALIZED_ID_COMPONENT_ID;
  };
  protoOf(ComponentIds).p1t = function () {
    return this.STATIC_COMPONENT_ID;
  };
  protoOf(ComponentIds).q1t = function () {
    return this.POLYHEDRON_VISUALIZATION_HOLDER_COMPONENT_ID;
  };
  protoOf(ComponentIds).r1t = function () {
    return this.ROOM_PART_COMPONENT_ID;
  };
  protoOf(ComponentIds).s1t = function () {
    return this.GUEST_CONNECTIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).t1t = function () {
    return this.HOST_CONNECTIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).u1t = function () {
    return this.SERIALIZABLE_CONNECTIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).v1t = function () {
    return this.TEMPORARILY_PAUSE_CONNECTIONS_PARENTING_COMPONENT_ID;
  };
  protoOf(ComponentIds).w1t = function () {
    return this.POLYHEDRON_VISUALIZATION_NODE_COMPONENT_ID;
  };
  protoOf(ComponentIds).x1t = function () {
    return this.COLLIDER_VISUALIZATION_CONFIG_COMPONENT_ID;
  };
  protoOf(ComponentIds).y1t = function () {
    return this.CONNECTOR_VISUALIZATION_CONFIG_COMPONENT_ID;
  };
  protoOf(ComponentIds).z1t = function () {
    return this.OUTLINE_BLOCKING_COMPONENT_ID;
  };
  protoOf(ComponentIds).a1u = function () {
    return this.LABEL_COMPONENT_ID;
  };
  protoOf(ComponentIds).b1u = function () {
    return this.DRAG_PROJECTION_POINT_COMPONENT_ID;
  };
  protoOf(ComponentIds).c1u = function () {
    return this.COLORED_OUTLINE_COMPONENT_ID;
  };
  protoOf(ComponentIds).d1u = function () {
    return this.MANUAL_GROUP_ID_COUNT_COMPONENT_ID;
  };
  protoOf(ComponentIds).e1u = function () {
    return this.AUTOMATIC_GROUP_ID_COUNT_COMPONENT_ID;
  };
  protoOf(ComponentIds).f1u = function () {
    return this.SCENE_MANAGER_CACHE_COMPONENT_ID;
  };
  protoOf(ComponentIds).g1u = function () {
    return this.PRODUCT_STRUCTURE_COMPONENT_ID;
  };
  protoOf(ComponentIds).h1u = function () {
    return this.CAMERA_COMPONENT_ID;
  };
  protoOf(ComponentIds).i1u = function () {
    return this.DEBUG_SURFACES_COMPONENT;
  };
  protoOf(ComponentIds).j1u = function () {
    return this.FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID;
  };
  protoOf(ComponentIds).k1u = function () {
    return this.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID;
  };
  protoOf(ComponentIds).l1u = function () {
    return this.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).m1u = function () {
    return this.MODEL_TRANSFORM_COMPONENT_ID;
  };
  protoOf(ComponentIds).n1u = function () {
    return this.AUTO_ADAPT_SESSION_COMPONENT_ID;
  };
  protoOf(ComponentIds).o1u = function () {
    return this.AUTO_ADAPT_GUEST_COMPONENT_ID;
  };
  protoOf(ComponentIds).p1u = function () {
    return this.AUTO_ADAPT_HOST_COMPONENT_ID;
  };
  protoOf(ComponentIds).q1u = function () {
    return this.AUTO_ADAPT_CACHED_VARIANTS_COMPONENT_ID;
  };
  protoOf(ComponentIds).r1u = function () {
    return this.AUTO_ADAPT_VARIANT_COMPONENT_ID;
  };
  protoOf(ComponentIds).s1u = function () {
    return this.FORCE_AUTO_ADAPT_WHEN_PARENT_IS_DRAGGED_COMPONENT_ID;
  };
  protoOf(ComponentIds).t1u = function () {
    return this.REPLACED_ENTITY_WITH_AUTO_ADAPT_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).u1u = function () {
    return this.AUTO_ADAPT_CHILD_FAILED_EVENT_COMPONENT_ID;
  };
  protoOf(ComponentIds).v1u = function () {
    return this.AUTO_ADAPT_PRODUCT_SPECIFICATIONS_COMPONENT_ID;
  };
  protoOf(ComponentIds).w1u = function () {
    return this.highestCoreComponentId;
  };
  protoOf(ComponentIds).debugToString = function (id) {
    switch (id) {
      case 0:
        return 'Selected';
      case 10:
        return 'WorldTransform';
      case 6:
        return 'LocalTransform';
      case 5:
        return 'InScene';
      case 17:
        return 'Child';
      case 41:
        return 'RoomDimensions';
      case 54:
        return 'RoomActiveConnectors';
      default:
        return id.toString();
    }
  };
  protoOf(ComponentIds).isCoreComponent = function (component) {
    return component.typeId <= 133;
  };
  protoOf(ComponentIds).isCoreComponentId = function (componentId) {
    return componentId <= 133;
  };
  var ComponentIds_instance;
  function ComponentIds_getInstance() {
    return ComponentIds_instance;
  }
  function ComponentUtils() {
  }
  protoOf(ComponentUtils).isSelected = function (entity) {
    return get_isSelected(entity);
  };
  protoOf(ComponentUtils).selectableComponent = function (entity) {
    return get_selectableComponent(entity);
  };
  protoOf(ComponentUtils).isSelectable = function (entity) {
    return get_isSelectable(entity);
  };
  protoOf(ComponentUtils).displayName = function (entity) {
    return get_displayName(entity);
  };
  protoOf(ComponentUtils).connectorsComponent = function (entity) {
    return get_connectorsComponent(entity);
  };
  protoOf(ComponentUtils).connectors = function (entity) {
    var tmp0_safe_receiver = get_connectorsComponent(entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ComponentUtils).connection = function (entity) {
    return get_highestPriorityConnection(entity);
  };
  protoOf(ComponentUtils).snapRoot = function (entity) {
    return findWithComponentInUpwardsHierarchy(entity, 47);
  };
  protoOf(ComponentUtils).isRoom = function (entity) {
    return entity.hasComponent(53);
  };
  protoOf(ComponentUtils).draggableRootEntity = function (entity) {
    var draggable = findWithComponentInUpwardsHierarchy(entity, 3);
    var tmp;
    if (draggable == null) {
      tmp = null;
    } else {
      tmp = findWithComponentInUpwardsHierarchy(draggable, 47);
    }
    var snapRoot = tmp;
    return snapRoot;
  };
  protoOf(ComponentUtils).selectableRoot = function (entity) {
    return findWithComponentInUpwardsHierarchy(entity, 1);
  };
  protoOf(ComponentUtils).previousId = function (entity) {
    return get_previousId(entity);
  };
  var ComponentUtils_instance;
  function ComponentUtils_getInstance() {
    return ComponentUtils_instance;
  }
  function get_snapRoot(_this__u8e3s4) {
    return ComponentUtils_instance.snapRoot(_this__u8e3s4);
  }
  function get_draggableRootEntity(_this__u8e3s4) {
    return ComponentUtils_instance.draggableRootEntity(_this__u8e3s4);
  }
  function get_selectableRoot(_this__u8e3s4) {
    return ComponentUtils_instance.selectableRoot(_this__u8e3s4);
  }
  function isSameConnector($this, otherEntity1, otherEntity2, otherConnector1, otherConnector2) {
    return (($this.demandingEntity === otherEntity1 ? $this.demandingConnector.key === otherConnector1.key : false) ? $this.offeringEntity === otherEntity2 : false) ? $this.offeringConnector.key === otherConnector2.key : false;
  }
  function AlignmentConnection(demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform) {
    this.demandingEntity = demandingEntity;
    this.demandingConnector = demandingConnector;
    this.offeringEntity = offeringEntity;
    this.offeringConnector = offeringConnector;
    this.offeringDemandingConnectorDeltaTransform = offeringDemandingConnectorDeltaTransform;
  }
  protoOf(AlignmentConnection).x1u = function () {
    return this.demandingEntity;
  };
  protoOf(AlignmentConnection).p1m = function () {
    return this.demandingConnector;
  };
  protoOf(AlignmentConnection).y1u = function () {
    return this.offeringEntity;
  };
  protoOf(AlignmentConnection).q1m = function () {
    return this.offeringConnector;
  };
  protoOf(AlignmentConnection).z1u = function () {
    return this.offeringDemandingConnectorDeltaTransform;
  };
  protoOf(AlignmentConnection).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AlignmentConnection))
      THROW_CCE();
    return (isSameConnector(this, other.demandingEntity, other.offeringEntity, other.demandingConnector, other.offeringConnector) ? this.offeringDemandingConnectorDeltaTransform.almostEquals(other.offeringDemandingConnectorDeltaTransform) : false) ? true : isSameConnector(this, other.offeringEntity, other.demandingEntity, other.offeringConnector, other.demandingConnector) ? this.offeringDemandingConnectorDeltaTransform.almostEquals(other.offeringDemandingConnectorDeltaTransform.inverse()) : false;
  };
  protoOf(AlignmentConnection).toString = function () {
    return '' + get_displayName(this.demandingEntity) + ', ' + this.demandingConnector.key + ', ' + get_displayName(this.offeringEntity) + ', ' + this.offeringConnector.key;
  };
  protoOf(AlignmentConnection).hashCode = function () {
    var result = this.demandingEntity.hashCode();
    result = imul(31, result) + this.offeringEntity.hashCode() | 0;
    return result;
  };
  protoOf(AlignmentConnection).af = function () {
    return this.demandingEntity;
  };
  protoOf(AlignmentConnection).bf = function () {
    return this.demandingConnector;
  };
  protoOf(AlignmentConnection).g1k = function () {
    return this.offeringEntity;
  };
  protoOf(AlignmentConnection).h1k = function () {
    return this.offeringConnector;
  };
  protoOf(AlignmentConnection).i1k = function () {
    return this.offeringDemandingConnectorDeltaTransform;
  };
  protoOf(AlignmentConnection).a1v = function (demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform) {
    return new AlignmentConnection(demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform);
  };
  protoOf(AlignmentConnection).copy = function (demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform, $super) {
    demandingEntity = demandingEntity === VOID ? this.demandingEntity : demandingEntity;
    demandingConnector = demandingConnector === VOID ? this.demandingConnector : demandingConnector;
    offeringEntity = offeringEntity === VOID ? this.offeringEntity : offeringEntity;
    offeringConnector = offeringConnector === VOID ? this.offeringConnector : offeringConnector;
    offeringDemandingConnectorDeltaTransform = offeringDemandingConnectorDeltaTransform === VOID ? this.offeringDemandingConnectorDeltaTransform : offeringDemandingConnectorDeltaTransform;
    return this.a1v(demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform);
  };
  function Companion_15() {
    this.ID = 'ChildConnection';
  }
  protoOf(Companion_15).u1n = function () {
    return this.ID;
  };
  var Companion_instance_15;
  function Companion_getInstance_16() {
    return Companion_instance_15;
  }
  function validate_0($this, entity, snapActionCandidate) {
    var productRef = toString_0(get_productRef(entity));
    if (!(snapActionCandidate == null))
      return null;
    var tmp0_elvis_lhs = get_highestPriorityConnection(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var connection = tmp;
    var host = connection.hostConnectorEntity;
    var oldHostConnector_0 = oldHostConnector($this, connection);
    var tmp1_safe_receiver = get_connectorsComponent(host);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hostConnectors;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp2_safe_receiver.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.core.connections.ChildConnectionValidation.validate.<anonymous>' call
          if (element.key === oldHostConnector_0.key) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_0 = tmp$ret$1;
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      return Companion_instance_114.fail('The host connector ' + connection.hostConnector.key + ' could no longer be found on ' + host, productRef, $this);
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var hostConnector = tmp_1;
    var hostConnectorStillContainsGuest = hostConnector.containsConnector(get_worldTransform(host), get_worldTransform(connection.guestConnectorEntity), connection.guestConnector);
    return hostConnectorStillContainsGuest ? null : Companion_instance_114.fail('The host connector ' + connection.hostConnector.key + ' could no longer supports the guest connector position', productRef, $this);
  }
  function oldHostConnector($this, connection) {
    var hostConnector = connection.hostConnector;
    var tmp;
    if (hostConnector instanceof PointSeriesSubConnector) {
      tmp = hostConnector.series;
    } else {
      tmp = hostConnector;
    }
    return tmp;
  }
  function ChildConnectionValidation() {
    ValidationImpl.call(this);
    this.n1v_1 = 'ChildConnection';
  }
  protoOf(ChildConnectionValidation).s1k = function () {
    return this.n1v_1;
  };
  protoOf(ChildConnectionValidation).validateCurrentState = function (entity) {
    return validate_0(this, entity, null);
  };
  protoOf(ChildConnectionValidation).validateSnap = function (snapActionCandidate) {
    return validate_0(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function Connection(guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform) {
    this.guestConnectorEntity = guestConnectorEntity;
    this.guestConnector = guestConnector;
    this.hostConnectorEntity = hostConnectorEntity;
    this.hostConnector = hostConnector;
    this.hostGuestConnectorDeltaTransform = hostGuestConnectorDeltaTransform;
    this.hostGuestDeltaTransform = get_worldTransform(this.guestConnectorEntity).delta(get_worldTransform(this.hostConnectorEntity));
  }
  protoOf(Connection).o1v = function () {
    return this.guestConnectorEntity;
  };
  protoOf(Connection).p1v = function () {
    return this.guestConnector;
  };
  protoOf(Connection).q1v = function () {
    return this.hostConnectorEntity;
  };
  protoOf(Connection).r1v = function () {
    return this.hostConnector;
  };
  protoOf(Connection).s1v = function () {
    return this.hostGuestConnectorDeltaTransform;
  };
  protoOf(Connection).t1v = function () {
    var tmp0_elvis_lhs = get_connectionRootEntity(this.guestConnectorEntity);
    return tmp0_elvis_lhs == null ? this.guestConnectorEntity : tmp0_elvis_lhs;
  };
  protoOf(Connection).u1v = function () {
    var tmp0_elvis_lhs = get_connectionRootEntity(this.hostConnectorEntity);
    return tmp0_elvis_lhs == null ? this.hostConnectorEntity : tmp0_elvis_lhs;
  };
  protoOf(Connection).v1v = function () {
    return this.hostConnector.priority + this.guestConnector.priority | 0;
  };
  protoOf(Connection).w1v = function () {
    return this.hostGuestDeltaTransform;
  };
  protoOf(Connection).x1v = function () {
    return this.guestConnectionRoot.equals(this.guestConnectorEntity);
  };
  protoOf(Connection).y1v = function () {
    return get_worldTransform(this.guestConnectorEntity).transformPosition(this.guestConnector.transform.position);
  };
  protoOf(Connection).z1v = function () {
    return get_worldTransform(this.hostConnectorEntity).transformPosition(this.hostConnector.transform.position);
  };
  protoOf(Connection).toString = function () {
    return 'Connection[' + get_displayName(this.hostConnectionRoot) + ' ' + this.hostConnector.key + '<->' + get_displayName(this.guestConnectionRoot) + ' ' + this.guestConnector.key + ' delta: ' + this.hostGuestConnectorDeltaTransform + ']';
  };
  protoOf(Connection).af = function () {
    return this.guestConnectorEntity;
  };
  protoOf(Connection).bf = function () {
    return this.guestConnector;
  };
  protoOf(Connection).g1k = function () {
    return this.hostConnectorEntity;
  };
  protoOf(Connection).h1k = function () {
    return this.hostConnector;
  };
  protoOf(Connection).i1k = function () {
    return this.hostGuestConnectorDeltaTransform;
  };
  protoOf(Connection).a1v = function (guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform) {
    return new Connection(guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform);
  };
  protoOf(Connection).copy = function (guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform, $super) {
    guestConnectorEntity = guestConnectorEntity === VOID ? this.guestConnectorEntity : guestConnectorEntity;
    guestConnector = guestConnector === VOID ? this.guestConnector : guestConnector;
    hostConnectorEntity = hostConnectorEntity === VOID ? this.hostConnectorEntity : hostConnectorEntity;
    hostConnector = hostConnector === VOID ? this.hostConnector : hostConnector;
    hostGuestConnectorDeltaTransform = hostGuestConnectorDeltaTransform === VOID ? this.hostGuestConnectorDeltaTransform : hostGuestConnectorDeltaTransform;
    return this.a1v(guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform);
  };
  protoOf(Connection).hashCode = function () {
    var result = this.guestConnectorEntity.hashCode();
    result = imul(result, 31) + this.guestConnector.hashCode() | 0;
    result = imul(result, 31) + this.hostConnectorEntity.hashCode() | 0;
    result = imul(result, 31) + this.hostConnector.hashCode() | 0;
    result = imul(result, 31) + this.hostGuestConnectorDeltaTransform.hashCode() | 0;
    return result;
  };
  protoOf(Connection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Connection))
      return false;
    var tmp0_other_with_cast = other instanceof Connection ? other : THROW_CCE();
    if (!this.guestConnectorEntity.equals(tmp0_other_with_cast.guestConnectorEntity))
      return false;
    if (!this.guestConnector.equals(tmp0_other_with_cast.guestConnector))
      return false;
    if (!this.hostConnectorEntity.equals(tmp0_other_with_cast.hostConnectorEntity))
      return false;
    if (!this.hostConnector.equals(tmp0_other_with_cast.hostConnector))
      return false;
    if (!this.hostGuestConnectorDeltaTransform.equals(tmp0_other_with_cast.hostGuestConnectorDeltaTransform))
      return false;
    return true;
  };
  function Companion_16() {
    this.id = 28;
  }
  protoOf(Companion_16).s1k = function () {
    return this.id;
  };
  var Companion_instance_16;
  function Companion_getInstance_17() {
    return Companion_instance_16;
  }
  function ConnectionRootComponent() {
  }
  protoOf(ConnectionRootComponent).x1k = function () {
    return 28;
  };
  protoOf(ConnectionRootComponent).eq = function (other) {
    return true;
  };
  function get_isConnectionRoot(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(28);
  }
  function get_highestPriorityConnection(_this__u8e3s4) {
    Companion_getInstance_18();
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(104);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.highestPriorityConnection;
  }
  function get_guestConnections(_this__u8e3s4) {
    Companion_getInstance_18();
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(104);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryCreatePartConnection($this, hostPart, guestPart, guestConnector) {
    var tmp0_safe_receiver = get_connectorsComponent(hostPart);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : asSequence_1(tmp1_safe_receiver);
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = filter(tmp2_safe_receiver, ConnectionUtils$tryCreatePartConnection$lambda(guestConnector));
    }
    var tmp3_safe_receiver = tmp;
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = filter(tmp3_safe_receiver, ConnectionUtils$tryCreatePartConnection$lambda_0(hostPart, guestConnector, guestPart));
    }
    var tmp4_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp4_safe_receiver == null) {
      tmp_1 = null;
    } else {
      tmp_1 = map(tmp4_safe_receiver, ConnectionUtils$tryCreatePartConnection$lambda_1(hostPart, guestPart, guestConnector));
    }
    var tmp5_safe_receiver = tmp_1;
    var connection = tmp5_safe_receiver == null ? null : firstOrNull_0(tmp5_safe_receiver);
    return connection;
  }
  function tryAligning($this, guestAlignment, hostAlignment, hostEntity, guestEntity, result) {
    var canAlign = guestAlignment.hasMatchingTags(hostAlignment) ? hostAlignment.containsConnector(get_worldTransform(hostEntity), get_worldTransform(guestEntity), guestAlignment) : false;
    if (canAlign) {
      var connectorsDeltaTransform = hostAlignment.getDeltaTransformToGuestConnectorEntity(hostEntity, guestEntity, guestAlignment);
      result.q(new AlignmentConnection(guestEntity, guestAlignment, hostEntity, hostAlignment, connectorsDeltaTransform));
    }
  }
  function getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly($this, entity) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var list = ArrayList_init_$Create$();
    getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly$searchEntityRecursive(entity, list, entity);
    return list;
  }
  function getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly$searchEntityRecursive($entity, list, host) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_hostedConnections(host);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.ConnectionUtils.getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly.searchEntityRecursive.<anonymous>' call
      var tmp0_safe_receiver = get_parent(element.guestConnectionRoot);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_connectionRootEntity(tmp0_safe_receiver);
      var parentOrAssembly = tmp1_elvis_lhs == null ? get_parent(element.guestConnectionRoot) : tmp1_elvis_lhs;
      if (!equals(parentOrAssembly, host)) {
        getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly$searchEntityRecursive($entity, list, element.guestConnectionRoot);
      }
    }
    var isOriginalEntityButNotEntityGroup = host.equals($entity) ? !get_isAutomaticGroup($entity) : false;
    var tmp;
    var tmp_0;
    Companion_getInstance_18();
    if (host.hasComponent(104)) {
      tmp_0 = true;
    } else {
      tmp_0 = isOriginalEntityButNotEntityGroup;
    }
    if (tmp_0) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_1;
        if (isInterface(list, Collection)) {
          tmp_1 = list.b1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp0_iterator = list.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.connections.ConnectionUtils.getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly.searchEntityRecursive.<anonymous>' call
          if (element_0.equals(host)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    if (tmp) {
      list.q(host);
    }
  }
  function ConnectionUtils$calculateAllConnectionsToHierarchies$lambda($guestPart) {
    return function (host) {
      return !host.equals($guestPart);
    };
  }
  function ConnectionUtils$calculateAllConnectionsToHierarchies$lambda_0($guestPart, $guestConnector) {
    return function (host) {
      var partConnection = tryCreatePartConnection(ConnectionUtils_instance, host, $guestPart, $guestConnector);
      return partConnection;
    };
  }
  function ConnectionUtils$tryCreatePartConnection$lambda($guestConnector) {
    return function (hostConnector) {
      return $guestConnector.hasMatchingTags(hostConnector);
    };
  }
  function ConnectionUtils$tryCreatePartConnection$lambda_0($hostPart, $guestConnector, $guestPart) {
    return function (hostConnector) {
      return hostConnector.closestSubConnectorFromOwnerEntity($hostPart, $guestConnector.getWorldPositionFromOwnerEntity($guestPart)).containsConnector(get_worldTransform($hostPart), get_worldTransform($guestPart), $guestConnector);
    };
  }
  function ConnectionUtils$tryCreatePartConnection$lambda_1($hostPart, $guestPart, $guestConnector) {
    return function (hostConnector) {
      var connectorsDeltaTransform = hostConnector.getDeltaTransformToGuestConnectorEntity($hostPart, $guestPart, $guestConnector);
      var hostConnectorPossiblySubConnector = hostConnector.closestSubConnectorFromOwnerEntity($hostPart, $guestConnector.getWorldPositionFromOwnerEntity($guestPart));
      return new Connection($guestPart, $guestConnector, $hostPart, hostConnectorPossiblySubConnector, connectorsDeltaTransform);
    };
  }
  function ConnectionUtils$matchingAlignmentConnections$lambda(it) {
    return !(get_alignmentConnectors(it) == null);
  }
  function ConnectionUtils() {
  }
  protoOf(ConnectionUtils).getGuestConnections = function (entity) {
    return get_guestConnections(entity);
  };
  protoOf(ConnectionUtils).getHighestPriorityConnection = function (entity) {
    return get_highestPriorityConnection(entity);
  };
  protoOf(ConnectionUtils).getExistingOutgoingGuestConnections = function (entity) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var snapRoot = tmp;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = get_snappingEntitiesArray(snapRoot);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.ConnectionUtils.getExistingOutgoingGuestConnections.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = get_guestConnections(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.connections.ConnectionUtils.getExistingOutgoingGuestConnections.<anonymous>.<anonymous>' call
        if (!equals(get_snapRoot(element_0.hostConnectorEntity), snapRoot)) {
          destination_0.q(element_0);
        }
      }
      var list = destination_0;
      addAll(destination, list);
    }
    return copyToArray(destination);
  };
  protoOf(ConnectionUtils).calculateAllConnectionsToHierarchy = function (guestSnapRoot, hostRoot) {
    var snappingEntities = get_snappingHierarchyEntitiesList(guestSnapRoot);
    if (snappingEntities.b1()) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var res = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = snappingEntities.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connections.ConnectionUtils.calculateAllConnectionsToHierarchy.<anonymous>' call
      var tmp0_safe_receiver = get_connectorsComponent(element);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = tmp1_safe_receiver.t();
        while (tmp0_iterator_0.u()) {
          var element_0 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.connections.ConnectionUtils.calculateAllConnectionsToHierarchy.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.sequences.forEach' call
          var tmp0_iterator_1 = hierarchyExceptSubTreeSequence(hostRoot, guestSnapRoot).t();
          while (tmp0_iterator_1.u()) {
            var element_1 = tmp0_iterator_1.w();
            // Inline function 'com.ikea.core.connections.ConnectionUtils.calculateAllConnectionsToHierarchy.<anonymous>.<anonymous>.<anonymous>' call
            var partConnection = tryCreatePartConnection(ConnectionUtils_instance, element_1, element, element_0);
            if (!(partConnection == null)) {
              res.q(partConnection);
            }
          }
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(res);
  };
  protoOf(ConnectionUtils).calculateAllConnectionsToHierarchies = function (guestSnapRoot, hostRoots) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = hostRoots.length;
    while (inductionVariable < last) {
      var element = hostRoots[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.ConnectionUtils.calculateAllConnectionsToHierarchies.<anonymous>' call
      var list = hierarchyExceptSubTreeSequence(element, guestSnapRoot);
      addAll_0(destination, list);
    }
    var others = asSequence_1(destination);
    var snappingEntities = get_snappingHierarchyEntitiesList(guestSnapRoot);
    if (snappingEntities.b1()) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var res = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = snappingEntities.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connections.ConnectionUtils.calculateAllConnectionsToHierarchies.<anonymous>' call
      var tmp0_safe_receiver = get_connectorsComponent(element_0);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = tmp1_safe_receiver.t();
        while (tmp0_iterator_0.u()) {
          var element_1 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.connections.ConnectionUtils.calculateAllConnectionsToHierarchies.<anonymous>.<anonymous>' call
          var tmp = filter(others, ConnectionUtils$calculateAllConnectionsToHierarchies$lambda(element_0));
          var partConnection = firstOrNull_0(mapNotNull(tmp, ConnectionUtils$calculateAllConnectionsToHierarchies$lambda_0(element_0, element_1)));
          if (!(partConnection == null)) {
            res.q(partConnection);
          }
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(res);
  };
  protoOf(ConnectionUtils).refreshConnections = function (connectionsRoot, hostRoot) {
    var guestHierarchyRoot = HierarchyUtils_instance.rootOf(connectionsRoot);
    var isPartOfSameHierarchy = hostRoot.equals(guestHierarchyRoot);
    var tmp;
    if (isPartOfSameHierarchy) {
      tmp = this.calculateAllConnectionsToHierarchy(connectionsRoot, hostRoot);
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [hostRoot, guestHierarchyRoot];
      tmp = this.calculateAllConnectionsToHierarchies(connectionsRoot, tmp$ret$2);
    }
    var connections = tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(connections.length === 0)) {
      var guestConnections = new GuestConnectionsComponent(connections);
      connectionsRoot.addComponent(guestConnections);
    } else {
      Companion_getInstance_18();
      connectionsRoot.removeComponent(104);
    }
  };
  protoOf(ConnectionUtils).matchingAlignmentConnections = function (entity, otherEntities) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var tmp = get_snappingHierarchyEntitiesSequence(entity);
    var guestAssemblyHierarchy = toSet(filter(tmp, ConnectionUtils$matchingAlignmentConnections$lambda));
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = otherEntities.length;
    while (inductionVariable < last) {
      var element = otherEntities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.ConnectionUtils.matchingAlignmentConnections.<anonymous>' call
      if (!guestAssemblyHierarchy.p(element)) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = guestAssemblyHierarchy.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.connections.ConnectionUtils.matchingAlignmentConnections.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver = get_alignmentConnectors(element_0);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator_0 = tmp0_safe_receiver.t();
            while (tmp0_iterator_0.u()) {
              var element_1 = tmp0_iterator_0.w();
              // Inline function 'com.ikea.core.connections.ConnectionUtils.matchingAlignmentConnections.<anonymous>.<anonymous>.<anonymous>' call
              var tmp0_safe_receiver_0 = get_alignmentConnectors(element);
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                // Inline function 'kotlin.collections.forEach' call
                var tmp0_iterator_1 = tmp0_safe_receiver_0.t();
                while (tmp0_iterator_1.u()) {
                  var element_2 = tmp0_iterator_1.w();
                  // Inline function 'com.ikea.core.connections.ConnectionUtils.matchingAlignmentConnections.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  tryAligning(ConnectionUtils_instance, element_1, element_2, element, element_0, result);
                }
              }
              var tmp1_safe_receiver = get_hostConnectors(element);
              if (tmp1_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.collections.forEach' call
                var tmp0_iterator_2 = tmp1_safe_receiver.t();
                while (tmp0_iterator_2.u()) {
                  var element_3 = tmp0_iterator_2.w();
                  // Inline function 'com.ikea.core.connections.ConnectionUtils.matchingAlignmentConnections.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  tryAligning(ConnectionUtils_instance, element_1, element_3, element, element_0, result);
                }
              }
            }
          }
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(result);
  };
  protoOf(ConnectionUtils).disconnect = function (entity) {
    var guestsThatAreNotChildren = getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly(this, entity);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = guestsThatAreNotChildren.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connections.ConnectionUtils.disconnect.<anonymous>' call
      Companion_getInstance_18();
      element.removeComponent(104);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator_0 = guestsThatAreNotChildren.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.connections.ConnectionUtils.disconnect.<anonymous>' call
      if (!element_0.isDisposed) {
        destination.q(element_0);
      }
    }
    return copyToArray(destination);
  };
  protoOf(ConnectionUtils).disconnectAndDisposeEntityAndHierarchy = function (entity) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [entity];
    this.disconnectAndDisposeEntitiesAndHierarchies(tmp$ret$2);
    return entity;
  };
  protoOf(ConnectionUtils).disconnectAndDisposeEntitiesAndHierarchies = function (entities) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = entities.length;
    while (inductionVariable < last) {
      var element = entities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $l$block: {
        // Inline function 'com.ikea.core.connections.ConnectionUtils.disconnectAndDisposeEntitiesAndHierarchies.<anonymous>' call
        if (element.isDisposed) {
          break $l$block;
        }
        var disconnectedEntities = ConnectionUtils_instance.disconnect(element);
        element.dispose();
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = disconnectedEntities.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = disconnectedEntities[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.connections.ConnectionUtils.disconnectAndDisposeEntitiesAndHierarchies.<anonymous>.<anonymous>' call
          if (!element_0.isDisposed) {
            destination.q(element_0);
          }
        }
        var tmp0_iterator = destination.t();
        while (tmp0_iterator.u()) {
          var element_1 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.connections.ConnectionUtils.disconnectAndDisposeEntitiesAndHierarchies.<anonymous>.<anonymous>' call
          element_1.dispose();
        }
      }
    }
    return entities;
  };
  var ConnectionUtils_instance;
  function ConnectionUtils_getInstance() {
    return ConnectionUtils_instance;
  }
  function Companion_17() {
    Companion_instance_17 = this;
    this.id = 104;
    this.c1w_1 = LoggerState_getInstance().m1m('GuestConnectionsComponent');
  }
  protoOf(Companion_17).s1k = function () {
    return this.id;
  };
  var Companion_instance_17;
  function Companion_getInstance_18() {
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function GuestConnectionsComponent$hasMultipleHosts$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.count' call
      // Inline function 'kotlin.collections.distinctBy' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.connections;
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.hasMultipleHosts$delegate.<anonymous>.<anonymous>' call
        if (!get_isStatic(element.hostConnectorEntity)) {
          destination.q(element);
        }
      }
      var set = HashSet_init_$Create$();
      var list = ArrayList_init_$Create$();
      var tmp0_iterator = destination.t();
      while (tmp0_iterator.u()) {
        var e = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.hasMultipleHosts$delegate.<anonymous>.<anonymous>' call
        var key = get_connectionRootEntity(e.hostConnectorEntity);
        if (set.q(key)) {
          list.q(e);
        }
      }
      return list.n() > 1;
    };
  }
  function GuestConnectionsComponent$withReplacedConnection$lambda($newConnection) {
    return function () {
      return "couldn't find a connection matching " + $newConnection + ' to replace on ' + get_displayName($newConnection.guestConnectorEntity);
    };
  }
  function GuestConnectionsComponent(connections) {
    Companion_getInstance_18();
    this.connections = connections;
    this.a1w_1 = 104;
    var tmp = this;
    tmp.b1w_1 = lazy(GuestConnectionsComponent$hasMultipleHosts$delegate$lambda(this));
  }
  protoOf(GuestConnectionsComponent).d1w = function () {
    return this.connections;
  };
  protoOf(GuestConnectionsComponent).x1k = function () {
    return this.a1w_1;
  };
  protoOf(GuestConnectionsComponent).eq = function (other) {
    if (this === other)
      return true;
    var that = unsafeCast(other);
    return contentEquals(this.connections, that.connections);
  };
  protoOf(GuestConnectionsComponent).e1w = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b1w_1;
    hasMultipleHosts$factory();
    return this_0.u2();
  };
  protoOf(GuestConnectionsComponent).f1w = function () {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var this_0 = this.connections;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var maxElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = maxElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.<get-highestPriorityConnection>.<anonymous>' call
      var maxValue = maxElem.priority;
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.<get-highestPriorityConnection>.<anonymous>' call
          var v = e.priority;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = maxElem;
    }
    return tmp$ret$1;
  };
  protoOf(GuestConnectionsComponent).withReplacedConnection = function (newConnection) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.connections;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.withReplacedConnection.<anonymous>' call
        if ((element.guestConnectorEntity.equals(newConnection.guestConnectorEntity) ? element.guestConnector.key === newConnection.guestConnector.key : false) ? element.hostConnector.key === newConnection.hostConnector.key : false) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var connectionToRemove = tmp$ret$1;
    if (connectionToRemove == null) {
      var tmp = Companion_getInstance_18().c1w_1;
      tmp.warn(GuestConnectionsComponent$withReplacedConnection$lambda(newConnection));
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = this.connections;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [newConnection];
      var tmp$ret$7 = tmp$ret$3.concat(tmp$ret$6);
      return new GuestConnectionsComponent(tmp$ret$7);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = subtract(this.connections, setOf(connectionToRemove));
    var connectionsWithoutConnectionToRemove = copyToArray(this_1);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [newConnection];
    var connectionsWithReplaced = connectionsWithoutConnectionToRemove.concat(tmp$ret$12);
    return new GuestConnectionsComponent(connectionsWithReplaced);
  };
  function get_hasMultipleHosts(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(104);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasMultipleHosts;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function centerOfConnections(connections) {
    var centerOfConnections = Companion_getInstance_61().ZERO;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = connections.length;
    while (inductionVariable < last) {
      var element = connections[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.centerOfConnections.<anonymous>' call
      centerOfConnections = centerOfConnections.plus(element.guestConnectorWorldPosition);
    }
    var tmp = centerOfConnections;
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$0 = connections.length;
    centerOfConnections = tmp.__divIntForKotlin(tmp$ret$0);
    return centerOfConnections;
  }
  function hasMultipleHosts$factory() {
    return getPropertyCallableRef('hasMultipleHosts', 1, KProperty1, function (receiver) {
      return receiver.hasMultipleHosts;
    }, null);
  }
  function Companion_18() {
    this.id = 105;
  }
  protoOf(Companion_18).s1k = function () {
    return this.id;
  };
  var Companion_instance_18;
  function Companion_getInstance_19() {
    return Companion_instance_18;
  }
  function HostConnectionsComponent(connections) {
    var tmp;
    if (connections === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = connections;
    }
    connections = tmp;
    this.connections = connections;
    this.s1j_1 = 105;
  }
  protoOf(HostConnectionsComponent).d1w = function () {
    return this.connections;
  };
  protoOf(HostConnectionsComponent).x1k = function () {
    return this.s1j_1;
  };
  protoOf(HostConnectionsComponent).eq = function (other) {
    if (this === other)
      return true;
    var that = unsafeCast(other);
    return contentEquals(this.connections, that.connections);
  };
  protoOf(HostConnectionsComponent).hashCode = function () {
    var result = contentHashCode(this.connections);
    result = imul(31, result) + this.s1j_1 | 0;
    return result;
  };
  protoOf(HostConnectionsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof HostConnectionsComponent))
      THROW_CCE();
    return this.eq(other);
  };
  protoOf(HostConnectionsComponent).af = function () {
    return this.connections;
  };
  protoOf(HostConnectionsComponent).g1w = function (connections) {
    return new HostConnectionsComponent(connections);
  };
  protoOf(HostConnectionsComponent).copy = function (connections, $super) {
    connections = connections === VOID ? this.connections : connections;
    return this.g1w(connections);
  };
  protoOf(HostConnectionsComponent).toString = function () {
    return 'HostConnectionsComponent(connections=' + toString(this.connections) + ')';
  };
  function addHostedConnection(_this__u8e3s4, connection) {
    var oldHostConnections = get_hostedConnections(_this__u8e3s4);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [connection];
    var newHostConnections = oldHostConnections.concat(tmp$ret$3);
    _this__u8e3s4.addComponent(new HostConnectionsComponent(newHostConnections));
  }
  function get_hostedConnections(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(105);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function removeHostedConnection(_this__u8e3s4, connection) {
    var oldHostConnections = get_hostedConnections(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = oldHostConnections.length;
    while (inductionVariable < last) {
      var element = oldHostConnections[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.removeHostedConnection.<anonymous>' call
      if (!element.equals(connection)) {
        destination.q(element);
      }
    }
    var newHostConnections = copyToArray(destination);
    // Inline function 'kotlin.collections.isEmpty' call
    if (newHostConnections.length === 0) {
      _this__u8e3s4.removeComponent(105);
    } else {
      _this__u8e3s4.addComponent(new HostConnectionsComponent(newHostConnections));
    }
  }
  function isHostingEntityWithMultipleHosts(_this__u8e3s4) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_hostedConnections(_this__u8e3s4);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.length);
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var item = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connections.isHostingEntityWithMultipleHosts.<anonymous>' call
        var tmp$ret$0 = item.guestConnectionRoot;
        destination.q(tmp$ret$0);
      }
      var this_1 = distinct(destination);
      var tmp;
      if (isInterface(this_1, Collection)) {
        tmp = this_1.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connections.isHostingEntityWithMultipleHosts.<anonymous>' call
        if (get_hasMultipleHosts(element) ? true : isHostingEntityWithMultipleHosts(element)) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
      }
      tmp$ret$3 = false;
    }
    return tmp$ret$3;
  }
  function get_guests(_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_hostedConnections(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.<get-guests>.<anonymous>' call
      var tmp$ret$0 = item.guestConnectionRoot;
      destination.q(tmp$ret$0);
    }
    return distinct(destination);
  }
  function Companion_19() {
    this.id = 107;
  }
  protoOf(Companion_19).s1k = function () {
    return this.id;
  };
  var Companion_instance_19;
  function Companion_getInstance_20() {
    return Companion_instance_19;
  }
  function TemporarilyPauseConnectionParentingComponent() {
    this.h1w_1 = 107;
  }
  protoOf(TemporarilyPauseConnectionParentingComponent).x1k = function () {
    return this.h1w_1;
  };
  protoOf(TemporarilyPauseConnectionParentingComponent).eq = function (other) {
    return true;
  };
  function Companion_20() {
    this.ID = 'UpdateHostConnectionsSystem';
  }
  protoOf(Companion_20).u1n = function () {
    return this.ID;
  };
  var Companion_instance_20;
  function Companion_getInstance_21() {
    return Companion_instance_20;
  }
  function UpdateHostConnectionsSystem() {
    Companion_getInstance_18();
    SystemBase.call(this, 'UpdateHostConnectionsSystem', 104);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q1w_1 = [105];
    this.r1w_1 = ['ConnectionParentingSystem'];
  }
  protoOf(UpdateHostConnectionsSystem).w1o = function () {
    return this.q1w_1;
  };
  protoOf(UpdateHostConnectionsSystem).x1o = function () {
    return this.r1w_1;
  };
  protoOf(UpdateHostConnectionsSystem).onAddComponent = function (entity, newComponent) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = newComponent.connections;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.UpdateHostConnectionsSystem.onAddComponent.<anonymous>' call
      var tmp0_safe_receiver = get_connectionRootEntity(element.hostConnectorEntity);
      if (tmp0_safe_receiver == null)
        null;
      else {
        addHostedConnection(tmp0_safe_receiver, element);
      }
    }
  };
  protoOf(UpdateHostConnectionsSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    this.onRemoveComponent(entity, oldComponent);
    this.onAddComponent(entity, newComponent);
  };
  protoOf(UpdateHostConnectionsSystem).onRemoveComponent = function (entity, oldComponent) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = oldComponent.connections;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.UpdateHostConnectionsSystem.onRemoveComponent.<anonymous>' call
      var tmp0_safe_receiver = get_connectionRootEntity(element.hostConnectorEntity);
      if (tmp0_safe_receiver == null)
        null;
      else {
        removeHostedConnection(tmp0_safe_receiver, element);
      }
    }
  };
  function closestOnEdge(_this__u8e3s4, vertices) {
    var minDist = 1.7976931348623157E308;
    var p = vertices[0];
    var tmp;
    if (vertices.length <= 2) {
      tmp = 1;
    } else {
      tmp = vertices.length;
    }
    var edgesCnt = tmp;
    var inductionVariable = 0;
    if (inductionVariable < edgesCnt)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var p1 = vertices[i];
        var p2 = vertices[(i + 1 | 0) % vertices.length | 0];
        var tmp1_container = closestPointOnSegment(_this__u8e3s4, p1, p2);
        var dist = tmp1_container.af();
        var pp = tmp1_container.bf();
        if (dist < minDist) {
          minDist = dist;
          p = pp;
        }
      }
       while (inductionVariable < edgesCnt);
    return p;
  }
  function closestPointOnSegment(guest, p1, p2) {
    var r = p2.minus(p1).normalize().__timesOperatorKotlin(guest.minus(p1));
    var tmp;
    if (r < 0.0) {
      tmp = new Pair(guest.minus(p1).size, p1);
    } else if (r > p2.minus(p1).size) {
      tmp = new Pair(guest.minus(p2).size, p2);
    } else {
      var e = p2.minus(p1).normalize();
      tmp = new Pair(e.cross(guest.minus(p1)).size, e.times(r).plus(p1));
    }
    return tmp;
  }
  function calculateRotationForGuestToSnapToMe($this, hostTransform, guestTransform, guestConnector) {
    var tmp0_subject = guestConnector.rotationalDegreeOfFreedom;
    if (tmp0_subject === RotationDegreeOfFreedom_NONE_getInstance().x9_1) {
      return guestTransform.rotation.inverse().times(guestConnector.transform.rotation.inverse()).times($this.transform.rotation).times(hostTransform.rotation);
    } else if (tmp0_subject === RotationDegreeOfFreedom_ONE_getInstance().x9_1) {
      var rotationAxisLS = $this.transform.up;
      var rotationAxisWS = hostTransform.transformVector(rotationAxisLS);
      var currentGuestRotationAxisWS = guestTransform.transformVector(guestConnector.transform.up);
      return currentGuestRotationAxisWS.getRotationTo(rotationAxisWS);
    } else
      throw new NotImplementedError('Rotational degree of freedom: ' + guestConnector.rotationalDegreeOfFreedom);
  }
  function calculateMovement($this, hostTransform, hostConnector, guestTransform, rotation, guestRootTransform) {
    var guestConnectorWorldSpace = guestTransform.transformPosition($this.transform.position);
    var guestConnectorPosAfterRotation = guestConnectorWorldSpace.rotateAroundPivot(rotation, guestRootTransform.position);
    var closestHostConnectorInWorldSpace = hostConnector.closestWhenUsingTransform(hostTransform, guestConnectorPosAfterRotation);
    return closestHostConnectorInWorldSpace.minus(guestConnectorPosAfterRotation);
  }
  function Companion_21() {
    this.DEFAULT_GUEST_ACTIVATION_DISTANCE = 200.0;
    this.DEFAULT_HOST_ACTIVATION_DISTANCE = 0.0;
  }
  protoOf(Companion_21).s1w = function () {
    return this.DEFAULT_GUEST_ACTIVATION_DISTANCE;
  };
  protoOf(Companion_21).t1w = function () {
    return this.DEFAULT_HOST_ACTIVATION_DISTANCE;
  };
  var Companion_instance_21;
  function Companion_getInstance_22() {
    return Companion_instance_21;
  }
  function Connector$findHostConnectorsWithMatchingTags$lambda(this$0) {
    return function (hostConnector) {
      return this$0.hasMatchingTags(hostConnector);
    };
  }
  function Connector$allSubConnectors$delegate$lambda(this$0) {
    return function () {
      return sequenceOf([this$0]);
    };
  }
  function Connector() {
    this.u1w_1 = RotationDegreeOfFreedom_NONE_getInstance().x9_1;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v1w_1 = [];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.w1w_1 = [];
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1.x1w_1 = [];
    var tmp_2 = this;
    tmp_2.y1w_1 = lazy(Connector$allSubConnectors$delegate$lambda(this));
    this.z1w_1 = false;
  }
  protoOf(Connector).e1x = function () {
    return this.u1w_1;
  };
  protoOf(Connector).f1x = function (_set____db54di) {
    this.v1w_1 = _set____db54di;
  };
  protoOf(Connector).g1x = function () {
    return this.v1w_1;
  };
  protoOf(Connector).h1x = function (_set____db54di) {
    this.w1w_1 = _set____db54di;
  };
  protoOf(Connector).i1x = function () {
    return this.w1w_1;
  };
  protoOf(Connector).j1x = function (_set____db54di) {
    this.x1w_1 = _set____db54di;
  };
  protoOf(Connector).k1x = function () {
    return this.x1w_1;
  };
  protoOf(Connector).setDemands = function (tag) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.demandsArray = tag.slice();
    return this;
  };
  protoOf(Connector).setOffers = function (tag) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.offersArray = tag.slice();
    return this;
  };
  protoOf(Connector).withTag = function (name) {
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.tagArray;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [name];
    var newTags = tmp$ret$0.concat(tmp$ret$3);
    this.tagArray = newTags;
    return this;
  };
  protoOf(Connector).removeTag = function (name) {
    if (contains(this.tagArray, name)) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this.tagArray;
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connectors.Connector.removeTag.<anonymous>' call
        if (!(element === name)) {
          destination.q(element);
        }
      }
      this.tagArray = copyToArray(destination);
    }
    return this;
  };
  protoOf(Connector).tags = function () {
    return this.tagArray;
  };
  protoOf(Connector).offers = function () {
    return this.offersArray;
  };
  protoOf(Connector).demands = function () {
    return this.demandsArray;
  };
  protoOf(Connector).closestWhenUsingTransform = function (ownerTransform, pointWorldSpace) {
    var pointInLocalSpace = ownerTransform.inverseTransformPosition(pointWorldSpace);
    var closestInLocalSpace = this.closest(pointInLocalSpace);
    return ownerTransform.transformPosition(closestInLocalSpace);
  };
  protoOf(Connector).calculateRotation = function (hostTransform, hostConnector, guestTransform) {
    return calculateRotationForGuestToSnapToMe(hostConnector, hostTransform, guestTransform, this);
  };
  protoOf(Connector).calculateEndTransform = function (hostTransform, hostConnector, guestConnectorEntityTransform, guestSnappingRootTransform) {
    var rotation = this.calculateRotation(hostTransform, hostConnector, guestConnectorEntityTransform);
    var movement = calculateMovement(this, hostTransform, hostConnector, guestConnectorEntityTransform, rotation, guestSnappingRootTransform);
    var newWorldPosition = guestSnappingRootTransform.position.plus(movement);
    var newWorldRotation = guestSnappingRootTransform.rotation.times(rotation);
    return new Transform(newWorldPosition, newWorldRotation);
  };
  protoOf(Connector).isOffering = function (tag) {
    return contains(this.offers(), tag);
  };
  protoOf(Connector).isDemanding = function (tag) {
    return contains(this.demands(), tag);
  };
  protoOf(Connector).hasTag = function (tag) {
    return contains(this.tags(), tag);
  };
  protoOf(Connector).findHostConnectorsWithMatchingTags = function (hostConnectors) {
    var tmp1_safe_receiver = hostConnectors == null ? null : hostConnectors.enabledConnectors;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : asSequence_1(tmp1_safe_receiver);
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = filter(tmp2_safe_receiver, Connector$findHostConnectorsWithMatchingTags$lambda(this));
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? emptySequence() : tmp3_elvis_lhs;
  };
  protoOf(Connector).hasMatchingTags = function (offeringConnector) {
    var tmp;
    if (ConnectorType_instance.matches(this.type, offeringConnector.type)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var indexedObject = this.demands();
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.connectors.Connector.hasMatchingTags.<anonymous>' call
          if (!offeringConnector.isOffering(element)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Connector).containsConnector = function (ownerTransform, guestTransform, guestConnector) {
    var rotationNeededToSnap = guestConnector.calculateRotation(ownerTransform, this, guestTransform);
    if (!rotationNeededToSnap.equals(Companion_getInstance_57().IDENTITY))
      return false;
    var movement = calculateMovement(guestConnector, ownerTransform, this, guestTransform, rotationNeededToSnap, guestTransform);
    return movement.equals(Companion_getInstance_61().ZERO);
  };
  protoOf(Connector).o1x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y1w_1;
    allSubConnectors$factory();
    return this_0.u2();
  };
  protoOf(Connector).p1x = function () {
    return this.z1w_1;
  };
  protoOf(Connector).closestSubConnector = function (localSpacePoint) {
    return this;
  };
  protoOf(Connector).closestSubConnectorFromOwnerEntity = function (owner, worldSpacePoint) {
    var positionLocalSpace = get_worldTransform(owner).inverseTransformPosition(worldSpacePoint);
    return this.closestSubConnector(positionLocalSpace);
  };
  protoOf(Connector).getWorldPositionFromOwnerEntity = function (ownerEntity) {
    return this.getWorldPositionFromOwnerTransform(get_worldTransform(ownerEntity));
  };
  protoOf(Connector).getWorldPositionFromOwnerTransform = function (ownerTransform) {
    return ownerTransform.transformPosition(this.transform.position);
  };
  protoOf(Connector).equals = function (other) {
    return this === other;
  };
  protoOf(Connector).hashCode = function () {
    return getStringHashCode(this.key) + this.type | 0;
  };
  protoOf(Connector).getWorldRotation = function (transform) {
    return transform.transformRotation(this.transform.rotation);
  };
  protoOf(Connector).getDeltaTransformToGuestConnectorEntity = function (ownerEntity, guest, guestConnector) {
    return this.getDeltaTransformToGuestConnectorTransform(get_worldTransform(ownerEntity), get_worldTransform(guest), guestConnector);
  };
  protoOf(Connector).getDeltaTransformToGuestConnectorTransform = function (ownerTransform, guestTransform, guestConnector) {
    var hostConnectorTransform = ownerTransform.concatenate(this.transform);
    var guestConnectorTransform = guestTransform.concatenate(guestConnector.transform);
    return guestConnectorTransform.delta(hostConnectorTransform);
  };
  protoOf(Connector).isRotatedUpward = function (ownerEntity) {
    var totalRotation = get_worldRotation(ownerEntity).times(this.transform.rotation);
    var dotProduct = Companion_getInstance_61().UP.rotate(totalRotation).__timesOperatorKotlin(Companion_getInstance_61().UP);
    return dotProduct >= 0.0;
  };
  protoOf(Connector).isInActivationDistance = function (guestTransform, hostConnector, hostTransform) {
    var positionWorldSpace = this.getWorldPositionFromOwnerTransform(guestTransform);
    var closestPointInHostConnector = hostConnector.closestWhenUsingTransform(hostTransform, positionWorldSpace);
    var distance = positionWorldSpace.distanceTo(closestPointInHostConnector);
    return distance <= this.activationDistance + hostConnector.activationDistance;
  };
  function allSubConnectors$factory() {
    return getPropertyCallableRef('allSubConnectors', 1, KProperty1, function (receiver) {
      return receiver.allSubConnectors;
    }, null);
  }
  function ConnectorTagConstants() {
    this.REQUIRE_UPWARD_PARENT = 'requireUpwardParent';
    this.REQUIRE_DOWNWARD_PARENT = 'requireDownwardParent';
  }
  protoOf(ConnectorTagConstants).q1x = function () {
    return this.REQUIRE_UPWARD_PARENT;
  };
  protoOf(ConnectorTagConstants).r1x = function () {
    return this.REQUIRE_DOWNWARD_PARENT;
  };
  var ConnectorTagConstants_instance;
  function ConnectorTagConstants_getInstance() {
    return ConnectorTagConstants_instance;
  }
  function ConnectorType() {
    this.GUEST = 0;
    this.HOST = 1;
    this.ALIGNMENT = 2;
    this.INTERNAL = 3;
  }
  protoOf(ConnectorType).s1x = function () {
    return this.GUEST;
  };
  protoOf(ConnectorType).t1x = function () {
    return this.HOST;
  };
  protoOf(ConnectorType).u1x = function () {
    return this.ALIGNMENT;
  };
  protoOf(ConnectorType).v1x = function () {
    return this.INTERNAL;
  };
  protoOf(ConnectorType).matches = function (demanding, offering) {
    var tmp;
    switch (demanding) {
      case 0:
        tmp = offering === 1;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        tmp = offering === 2 ? true : offering === 1;
        break;
      case 3:
        tmp = false;
        break;
      default:
        throw IllegalArgumentException_init_$Create$('There are only 4 connector types. Do not try to cheat CORE!');
    }
    return tmp;
  };
  var ConnectorType_instance;
  function ConnectorType_getInstance() {
    return ConnectorType_instance;
  }
  function get_snappingEntitiesSequence(_this__u8e3s4) {
    return ConnectorUtils_instance.snappingEntitiesSequence(_this__u8e3s4);
  }
  function get_snappingEntitiesArray(_this__u8e3s4) {
    return ConnectorUtils_instance.snappingEntitiesArray(_this__u8e3s4);
  }
  function checkRequiredConnectorsOnParts($this, hostPart, guestPart, requiredConnector) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = requiredConnector.findHostConnectorsWithMatchingTags(get_connectorsComponent(hostPart)).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connectors.ConnectorUtils.checkRequiredConnectorsOnParts.<anonymous>' call
        if (element.containsConnector(get_worldTransform(hostPart), get_worldTransform(guestPart), requiredConnector)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost_pjpnxs($guestPart, $connector, host) {
    return !(findInHierarchyExceptHierarchyOfIgnored(host, $guestPart, ConnectorUtils$findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost$lambda_xfnpmt($guestPart, $connector)) == null);
  }
  function ConnectorUtils$snappingEntitiesSequence$lambda(it) {
    Companion_getInstance_23();
    return it.hasComponent(11);
  }
  function ConnectorUtils$snappingEntitiesSequence$lambda_0(it) {
    var tmp;
    var tmp0_safe_receiver = get_connectorsComponent(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
      tmp = true;
    } else {
      var tmp2_safe_receiver = get_connectorsComponent(it);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
      tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
    }
    return tmp;
  }
  function ConnectorUtils$findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost$lambda_xfnpmt($$guestPart, $$connector) {
    return function (hostPart) {
      return checkRequiredConnectorsOnParts(ConnectorUtils_instance, hostPart, $$guestPart, $$connector);
    };
  }
  function ConnectorUtils() {
  }
  protoOf(ConnectorUtils).snappingEntitiesSequence = function (entity) {
    var tmp = hierarchyExceptSubTreesWithComponentSequence(entity, 47);
    var tmp_0 = filter(tmp, ConnectorUtils$snappingEntitiesSequence$lambda);
    return filter(tmp_0, ConnectorUtils$snappingEntitiesSequence$lambda_0);
  };
  protoOf(ConnectorUtils).snappingEntitiesArray = function (entity) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = hierarchyExceptSubTreesWithComponentArray(entity, 47);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.ConnectorUtils.snappingEntitiesArray.<anonymous>' call
      Companion_getInstance_23();
      if (element.hasComponent(11)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connectors.ConnectorUtils.snappingEntitiesArray.<anonymous>' call
      var tmp;
      var tmp0_safe_receiver = get_connectorsComponent(element_0);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
      if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
        tmp = true;
      } else {
        var tmp2_safe_receiver = get_connectorsComponent(element_0);
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
        tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
      }
      if (tmp) {
        destination_0.q(element_0);
      }
    }
    return copyToArray(destination_0);
  };
  protoOf(ConnectorUtils).findUnfulfilledRequiredConnectors = function (hosts, guest) {
    var tmp0_safe_receiver = guest.__getComponentForKotlin(Companion_instance_97.id);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allowedHosts;
    var eligibleHosts = tmp1_elvis_lhs == null ? hosts : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = hierarchyExceptSubTreesWithComponentArray(guest, 47);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.ConnectorUtils.findUnfulfilledRequiredConnectors.<anonymous>' call
      var tmp0_safe_receiver_0 = get_connectorsComponent(element);
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.requiredConnectors;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !tmp1_safe_receiver.b1();
      }
      if (tmp === true) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connectors.ConnectorUtils.findUnfulfilledRequiredConnectors.<anonymous>' call
      var tmp0_safe_receiver_1 = get_connectorsComponent(element_0);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.requiredConnectors;
      var tmp_0;
      if (tmp1_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination_1 = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = tmp1_safe_receiver_0.t();
        while (tmp0_iterator_0.u()) {
          var element_1 = tmp0_iterator_0.w();
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'com.ikea.core.connectors.ConnectorUtils.findUnfulfilledRequiredConnectors.<anonymous>.<anonymous>' call
          var tmp_1;
          var tmp$ret$5;
          $l$block: {
            // Inline function 'kotlin.collections.any' call
            var inductionVariable_0 = 0;
            var last_0 = eligibleHosts.length;
            while (inductionVariable_0 < last_0) {
              var element_2 = eligibleHosts[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.connectors.ConnectorUtils.findUnfulfilledRequiredConnectors.<anonymous>.<anonymous>.<anonymous>' call
              if (findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost_pjpnxs(element_0, element_1, element_2)) {
                tmp$ret$5 = true;
                break $l$block;
              }
            }
            tmp$ret$5 = false;
          }
          if (tmp$ret$5) {
            tmp_1 = true;
          } else {
            tmp_1 = findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost_pjpnxs(element_0, element_1, guest);
          }
          var wasFulfilled = tmp_1;
          var tmp_2;
          if (!wasFulfilled) {
            tmp_2 = element_1;
          } else {
            tmp_2 = null;
          }
          var tmp0_safe_receiver_2 = tmp_2;
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination_1.q(tmp0_safe_receiver_2);
          }
        }
        tmp_0 = destination_1;
      }
      var tmp2_elvis_lhs = tmp_0;
      var unfulfilledConnectors = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
      var list = unfulfilledConnectors;
      addAll(destination_0, list);
    }
    return copyToArray(destination_0);
  };
  protoOf(ConnectorUtils).isEdgeConnector = function (connector) {
    return connector instanceof EdgeConnector;
  };
  protoOf(ConnectorUtils).isPointConnector = function (connector) {
    return connector instanceof PointConnector;
  };
  protoOf(ConnectorUtils).isPointSeriesConnector = function (connector) {
    return connector instanceof PointSeriesConnector;
  };
  protoOf(ConnectorUtils).isPointSeriesSubConnector = function (connector) {
    return connector instanceof PointSeriesSubConnector;
  };
  protoOf(ConnectorUtils).isSurfaceConnector = function (connector) {
    return connector instanceof SurfaceConnector;
  };
  var ConnectorUtils_instance;
  function ConnectorUtils_getInstance() {
    return ConnectorUtils_instance;
  }
  function Companion_22() {
    Companion_instance_22 = this;
    this.id = 11;
    this.x1x_1 = LoggerState_getInstance().m1m('ConnectorsComponent');
  }
  protoOf(Companion_22).s1k = function () {
    return this.id;
  };
  var Companion_instance_22;
  function Companion_getInstance_23() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.y1x_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).u1j = function (a, b) {
    return this.y1x_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_1(function_0) {
    this.z1x_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).u1j = function (a, b) {
    return this.z1x_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function ConnectorsComponent$hostConnectors$delegate$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.hostConnectors$delegate.<anonymous>.<anonymous>' call
    var tmp = -a.priority | 0;
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.hostConnectors$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$1 = -b.priority | 0;
    return compareValues(tmp, tmp$ret$1);
  }
  function ConnectorsComponent$hostConnectors$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.enabledConnectors;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connectors.ConnectorsComponent.hostConnectors$delegate.<anonymous>.<anonymous>' call
        var tmp = element.type;
        if (tmp === 1) {
          destination.q(element);
        }
      }
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ConnectorsComponent$hostConnectors$delegate$lambda$lambda;
      var tmp$ret$3 = new sam$kotlin_Comparator$0_0(tmp_0);
      return sortedWith_0(destination, tmp$ret$3);
    };
  }
  function ConnectorsComponent$guestConnectors$delegate$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.guestConnectors$delegate.<anonymous>.<anonymous>' call
    var tmp = -a.priority | 0;
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.guestConnectors$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$1 = -b.priority | 0;
    return compareValues(tmp, tmp$ret$1);
  }
  function ConnectorsComponent$guestConnectors$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.enabledConnectors;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connectors.ConnectorsComponent.guestConnectors$delegate.<anonymous>.<anonymous>' call
        var tmp = element.type;
        if (tmp === 0) {
          destination.q(element);
        }
      }
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ConnectorsComponent$guestConnectors$delegate$lambda$lambda;
      var tmp$ret$3 = new sam$kotlin_Comparator$0_1(tmp_0);
      return sortedWith_0(destination, tmp$ret$3);
    };
  }
  function ConnectorsComponent$alignmentConnectors$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.enabledConnectors;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connectors.ConnectorsComponent.alignmentConnectors$delegate.<anonymous>.<anonymous>' call
        var tmp = element.type;
        if (tmp === 2) {
          destination.q(element);
        }
      }
      return destination;
    };
  }
  function ConnectorsComponent$requiredConnectors$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this$0.enabledConnectors;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.connectors.ConnectorsComponent.requiredConnectors$delegate.<anonymous>.<anonymous>' call
        if (element.required) {
          destination.q(element);
        }
      }
      return destination;
    };
  }
  function ConnectorsComponent$getConnectorByKey$lambda($connectorKey) {
    return function () {
      return 'Found more than one value when getting connector by key ' + $connectorKey + '. Keys must be uniquely defined in the range.';
    };
  }
  function ConnectorsComponent$getConnectorByKey$lambda_0(it) {
    return it.allSubConnectors;
  }
  function ConnectorsComponent$getConnectorByKey$lambda_1($connectorKey) {
    return function (it) {
      return it.key === $connectorKey;
    };
  }
  function ConnectorsComponent(connectors) {
    Companion_getInstance_23();
    this.connectors = connectors;
    var tmp = this;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.connectors;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.enabledConnectors.<anonymous>' call
      if (element.enabled) {
        destination.q(element);
      }
    }
    tmp.enabledConnectors = destination;
    var tmp_0 = this;
    tmp_0.o1j_1 = lazy(ConnectorsComponent$hostConnectors$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.p1j_1 = lazy(ConnectorsComponent$guestConnectors$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.q1j_1 = lazy(ConnectorsComponent$alignmentConnectors$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.r1j_1 = lazy(ConnectorsComponent$requiredConnectors$delegate$lambda(this));
    this.requiredConnectorsSequence = asSequence_1(this.requiredConnectors);
  }
  protoOf(ConnectorsComponent).a1y = function () {
    return this.connectors;
  };
  protoOf(ConnectorsComponent).x1k = function () {
    return 11;
  };
  protoOf(ConnectorsComponent).b1y = function () {
    return this.enabledConnectors;
  };
  protoOf(ConnectorsComponent).c1y = function () {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.enabledConnectors;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.<get-tags>.<anonymous>' call
      var list = asIterable(element.tags());
      addAll(destination, list);
    }
    return destination;
  };
  protoOf(ConnectorsComponent).d1y = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o1j_1;
    hostConnectors$factory();
    return this_0.u2();
  };
  protoOf(ConnectorsComponent).e1y = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p1j_1;
    guestConnectors$factory();
    return this_0.u2();
  };
  protoOf(ConnectorsComponent).f1y = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q1j_1;
    alignmentConnectors$factory();
    return this_0.u2();
  };
  protoOf(ConnectorsComponent).g1y = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r1j_1;
    requiredConnectors$factory();
    return this_0.u2();
  };
  protoOf(ConnectorsComponent).h1y = function () {
    return this.requiredConnectorsSequence;
  };
  protoOf(ConnectorsComponent).eq = function (other) {
    return false;
  };
  protoOf(ConnectorsComponent).getConnectorByKey = function (connectorKey) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.connectors;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.getConnectorByKey.<anonymous>' call
      if (element.key === connectorKey) {
        destination.q(element);
      }
    }
    var listOfConnectors = destination;
    // Inline function 'kotlin.collections.count' call
    if (listOfConnectors.n() > 1) {
      var tmp = Companion_getInstance_23().x1x_1;
      tmp.error(ConnectorsComponent$getConnectorByKey$lambda(connectorKey));
    } else {
      if (none(listOfConnectors)) {
        var tmp_0 = asSequence_0(this.connectors);
        var tmp_1 = flatMap(tmp_0, ConnectorsComponent$getConnectorByKey$lambda_0);
        listOfConnectors = toList_0(filter(tmp_1, ConnectorsComponent$getConnectorByKey$lambda_1(connectorKey)));
      }
    }
    return firstOrNull_1(listOfConnectors);
  };
  protoOf(ConnectorsComponent).plusConnectors = function (connectorsToAdd) {
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.connectors.concat(connectorsToAdd);
    return new ConnectorsComponent(tmp$ret$1);
  };
  protoOf(ConnectorsComponent).minusConnectors = function (connectorsToRemove) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.connectors;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.minusConnectors.<anonymous>' call
      if (!contains(connectorsToRemove, element)) {
        destination.q(element);
      }
    }
    var tmp$ret$3 = copyToArray(destination);
    return new ConnectorsComponent(tmp$ret$3);
  };
  function get_connectorsComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(11);
  }
  function get_connectors(_this__u8e3s4) {
    var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function get_alignmentConnectors(_this__u8e3s4) {
    var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.alignmentConnectors;
  }
  function get_hostConnectors(_this__u8e3s4) {
    var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
  }
  function get_guestConnectors(_this__u8e3s4) {
    var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
  }
  function hostConnectors$factory() {
    return getPropertyCallableRef('hostConnectors', 1, KProperty1, function (receiver) {
      return receiver.hostConnectors;
    }, null);
  }
  function guestConnectors$factory() {
    return getPropertyCallableRef('guestConnectors', 1, KProperty1, function (receiver) {
      return receiver.guestConnectors;
    }, null);
  }
  function alignmentConnectors$factory() {
    return getPropertyCallableRef('alignmentConnectors', 1, KProperty1, function (receiver) {
      return receiver.alignmentConnectors;
    }, null);
  }
  function requiredConnectors$factory() {
    return getPropertyCallableRef('requiredConnectors', 1, KProperty1, function (receiver) {
      return receiver.requiredConnectors;
    }, null);
  }
  function Companion_23() {
    this.ID = 'DisableConnectorsSystem';
  }
  protoOf(Companion_23).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_23).updateConnectors = function (entity) {
    Companion_getInstance_23();
    var tmp0_elvis_lhs = entity.__getComponentForKotlin(11);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var connectorsComponent = tmp;
    var tmp1_safe_receiver = entity.__getComponentForKotlin(71);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.disabledConnectorKeys;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var disabledConnectors = tmp_0;
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = connectorsComponent.connectors;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connectors.Companion.updateConnectors.<anonymous>' call
        var it = this_0[i];
        var enable = !contains(disabledConnectors, it.key);
        arr[i] = it.enable(enable);
      }
       while (inductionVariable <= last);
    var updatedConnectors = isArray(arr) ? arr : THROW_CCE();
    entity.addComponent(new ConnectorsComponent(updatedConnectors));
  };
  var Companion_instance_23;
  function Companion_getInstance_24() {
    return Companion_instance_23;
  }
  function DisableConnectorsSystem() {
    SystemBase.call(this, 'DisableConnectorsSystem', 71);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q1y_1 = [11];
  }
  protoOf(DisableConnectorsSystem).onAddComponent = function (entity, newComponent) {
    Companion_instance_23.updateConnectors(entity);
  };
  protoOf(DisableConnectorsSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    Companion_instance_23.updateConnectors(entity);
  };
  protoOf(DisableConnectorsSystem).onRemoveComponent = function (entity, oldComponent) {
    Companion_instance_23.updateConnectors(entity);
  };
  protoOf(DisableConnectorsSystem).w1o = function () {
    return this.q1y_1;
  };
  function Companion_24() {
    this.id = 71;
  }
  protoOf(Companion_24).s1k = function () {
    return this.id;
  };
  var Companion_instance_24;
  function Companion_getInstance_25() {
    return Companion_instance_24;
  }
  function DisabledConnectorsComponent(disabledConnectorKeys) {
    this.disabledConnectorKeys = disabledConnectorKeys;
  }
  protoOf(DisabledConnectorsComponent).r1y = function () {
    return this.disabledConnectorKeys;
  };
  protoOf(DisabledConnectorsComponent).x1k = function () {
    return 71;
  };
  protoOf(DisabledConnectorsComponent).eq = function (other) {
    return contentEquals((other instanceof DisabledConnectorsComponent ? other : THROW_CCE()).disabledConnectorKeys, this.disabledConnectorKeys);
  };
  function EdgeConnector(key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
    rotation = rotation === VOID ? Companion_getInstance_57().IDENTITY : rotation;
    priority = priority === VOID ? 0 : priority;
    var tmp;
    if (activationDistance === VOID) {
      var tmp_0;
      if (type === 1) {
        tmp_0 = 0.0;
      } else {
        tmp_0 = 200.0;
      }
      tmp = tmp_0;
    } else {
      tmp = activationDistance;
    }
    activationDistance = tmp;
    enabled = enabled === VOID ? true : enabled;
    var tmp_1;
    if (tagArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = [];
    } else {
      tmp_1 = tagArray;
    }
    tagArray = tmp_1;
    var tmp_2;
    if (offersArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = [];
    } else {
      tmp_2 = offersArray;
    }
    offersArray = tmp_2;
    var tmp_3;
    if (demandsArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = [];
    } else {
      tmp_3 = demandsArray;
    }
    demandsArray = tmp_3;
    required = required === VOID ? false : required;
    Connector.call(this);
    this.y1y_1 = key;
    this.z1y_1 = type;
    this.p1 = p1;
    this.p2 = p2;
    this.a1z_1 = rotation;
    this.b1z_1 = priority;
    this.c1z_1 = activationDistance;
    this.d1z_1 = enabled;
    this.e1z_1 = tagArray;
    this.f1z_1 = offersArray;
    this.g1z_1 = demandsArray;
    this.h1z_1 = required;
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.i1z_1 = [this.p1, this.p2];
    this.j1z_1 = true;
    this.direction = this.p2.minus(this.p1).normalize();
    this.k1z_1 = this.p1.plus(this.p2).div(2.0);
    this.l1z_1 = new Transform(this.k1z_1, this.a1z_1);
  }
  protoOf(EdgeConnector).t2 = function () {
    return this.y1y_1;
  };
  protoOf(EdgeConnector).a1x = function () {
    return this.z1y_1;
  };
  protoOf(EdgeConnector).m1z = function () {
    return this.p1;
  };
  protoOf(EdgeConnector).n1z = function () {
    return this.p2;
  };
  protoOf(EdgeConnector).v1v = function () {
    return this.b1z_1;
  };
  protoOf(EdgeConnector).l1x = function () {
    return this.c1z_1;
  };
  protoOf(EdgeConnector).m1x = function () {
    return this.d1z_1;
  };
  protoOf(EdgeConnector).f1x = function (_set____db54di) {
    this.e1z_1 = _set____db54di;
  };
  protoOf(EdgeConnector).g1x = function () {
    return this.e1z_1;
  };
  protoOf(EdgeConnector).h1x = function (_set____db54di) {
    this.f1z_1 = _set____db54di;
  };
  protoOf(EdgeConnector).i1x = function () {
    return this.f1z_1;
  };
  protoOf(EdgeConnector).j1x = function (_set____db54di) {
    this.g1z_1 = _set____db54di;
  };
  protoOf(EdgeConnector).k1x = function () {
    return this.g1z_1;
  };
  protoOf(EdgeConnector).b1x = function () {
    return this.h1z_1;
  };
  protoOf(EdgeConnector).equalsByValue = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    var tmp_7;
    var tmp_8;
    if (other instanceof EdgeConnector) {
      tmp_8 = other.y1y_1 === this.y1y_1;
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      tmp_7 = other.p1.equals(this.p1);
    } else {
      tmp_7 = false;
    }
    if (tmp_7) {
      tmp_6 = other.p2.equals(this.p2);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      tmp_5 = other.a1z_1.equals(this.a1z_1);
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = other.b1z_1 === this.b1z_1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = other.c1z_1 === this.c1z_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = other.d1z_1 === this.d1z_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = contentEquals(other.e1z_1, this.e1z_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = contentEquals(other.offers(), this.offers());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(other.demands(), this.demands());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EdgeConnector).n1x = function () {
    return this.j1z_1;
  };
  protoOf(EdgeConnector).o1z = function () {
    return this.direction;
  };
  protoOf(EdgeConnector).c1x = function () {
    return 0.0;
  };
  protoOf(EdgeConnector).reposition = function (newPositions) {
    if (newPositions.length < 2) {
      throw IllegalArgumentException_init_$Create$('Can not reposition edge connector with ' + newPositions.length + ' point(s).');
    }
    return this.copy(VOID, VOID, newPositions[0], newPositions[1]);
  };
  protoOf(EdgeConnector).move = function (movementDelta) {
    return this.copy(VOID, VOID, this.p1.plus(movementDelta), this.p2.plus(movementDelta));
  };
  protoOf(EdgeConnector).rotate = function (rotationDelta) {
    return this.copy(VOID, VOID, VOID, VOID, this.a1z_1.times(rotationDelta));
  };
  protoOf(EdgeConnector).enable = function (enable) {
    return this.copy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, enable);
  };
  protoOf(EdgeConnector).d1x = function () {
    return this.l1z_1;
  };
  protoOf(EdgeConnector).closest = function (child) {
    return closestOnEdge(child, this.i1z_1);
  };
  protoOf(EdgeConnector).contains = function (localSpacePoint) {
    return localSpacePoint.pointOnLine(this.p1, this.p2);
  };
  protoOf(EdgeConnector).shift = function (name, transition) {
    return this.copy(name, VOID, this.p1.plus(transition), this.p2.plus(transition));
  };
  protoOf(EdgeConnector).af = function () {
    return this.y1y_1;
  };
  protoOf(EdgeConnector).bf = function () {
    return this.z1y_1;
  };
  protoOf(EdgeConnector).g1k = function () {
    return this.p1;
  };
  protoOf(EdgeConnector).h1k = function () {
    return this.p2;
  };
  protoOf(EdgeConnector).j1k = function () {
    return this.b1z_1;
  };
  protoOf(EdgeConnector).k1k = function () {
    return this.c1z_1;
  };
  protoOf(EdgeConnector).p1z = function () {
    return this.d1z_1;
  };
  protoOf(EdgeConnector).q1z = function () {
    return this.e1z_1;
  };
  protoOf(EdgeConnector).r1z = function () {
    return this.f1z_1;
  };
  protoOf(EdgeConnector).s1z = function () {
    return this.g1z_1;
  };
  protoOf(EdgeConnector).t1z = function () {
    return this.h1z_1;
  };
  protoOf(EdgeConnector).u1z = function (key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
    return new EdgeConnector(key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
  };
  protoOf(EdgeConnector).copy = function (key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required, $super) {
    key = key === VOID ? this.y1y_1 : key;
    type = type === VOID ? this.z1y_1 : type;
    p1 = p1 === VOID ? this.p1 : p1;
    p2 = p2 === VOID ? this.p2 : p2;
    rotation = rotation === VOID ? this.a1z_1 : rotation;
    priority = priority === VOID ? this.b1z_1 : priority;
    activationDistance = activationDistance === VOID ? this.c1z_1 : activationDistance;
    enabled = enabled === VOID ? this.d1z_1 : enabled;
    tagArray = tagArray === VOID ? this.e1z_1 : tagArray;
    offersArray = offersArray === VOID ? this.f1z_1 : offersArray;
    demandsArray = demandsArray === VOID ? this.g1z_1 : demandsArray;
    required = required === VOID ? this.h1z_1 : required;
    return this.u1z(key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
  };
  protoOf(EdgeConnector).toString = function () {
    return 'EdgeConnector(key=' + this.y1y_1 + ', type=' + this.z1y_1 + ', p1=' + this.p1 + ', p2=' + this.p2 + ', rotation=' + this.a1z_1 + ', priority=' + this.b1z_1 + ', activationDistance=' + this.c1z_1 + ', enabled=' + this.d1z_1 + ', tagArray=' + toString(this.e1z_1) + ', offersArray=' + toString(this.f1z_1) + ', demandsArray=' + toString(this.g1z_1) + ', required=' + this.h1z_1 + ')';
  };
  protoOf(EdgeConnector).hashCode = function () {
    var result = getStringHashCode(this.y1y_1);
    result = imul(result, 31) + this.z1y_1 | 0;
    result = imul(result, 31) + this.p1.hashCode() | 0;
    result = imul(result, 31) + this.p2.hashCode() | 0;
    result = imul(result, 31) + this.a1z_1.hashCode() | 0;
    result = imul(result, 31) + this.b1z_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.c1z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d1z_1) | 0;
    result = imul(result, 31) + hashCode(this.e1z_1) | 0;
    result = imul(result, 31) + hashCode(this.f1z_1) | 0;
    result = imul(result, 31) + hashCode(this.g1z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h1z_1) | 0;
    return result;
  };
  protoOf(EdgeConnector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EdgeConnector))
      return false;
    var tmp0_other_with_cast = other instanceof EdgeConnector ? other : THROW_CCE();
    if (!(this.y1y_1 === tmp0_other_with_cast.y1y_1))
      return false;
    if (!(this.z1y_1 === tmp0_other_with_cast.z1y_1))
      return false;
    if (!this.p1.equals(tmp0_other_with_cast.p1))
      return false;
    if (!this.p2.equals(tmp0_other_with_cast.p2))
      return false;
    if (!this.a1z_1.equals(tmp0_other_with_cast.a1z_1))
      return false;
    if (!(this.b1z_1 === tmp0_other_with_cast.b1z_1))
      return false;
    if (!equals(this.c1z_1, tmp0_other_with_cast.c1z_1))
      return false;
    if (!(this.d1z_1 === tmp0_other_with_cast.d1z_1))
      return false;
    if (!equals(this.e1z_1, tmp0_other_with_cast.e1z_1))
      return false;
    if (!equals(this.f1z_1, tmp0_other_with_cast.f1z_1))
      return false;
    if (!equals(this.g1z_1, tmp0_other_with_cast.g1z_1))
      return false;
    if (!(this.h1z_1 === tmp0_other_with_cast.h1z_1))
      return false;
    return true;
  };
  function PointConnector(key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required) {
    transform = transform === VOID ? Companion_getInstance_60().IDENTITY : transform;
    priority = priority === VOID ? 0 : priority;
    var tmp;
    if (activationDistance === VOID) {
      var tmp_0;
      if (type === 1) {
        tmp_0 = 0.0;
      } else {
        tmp_0 = 200.0;
      }
      tmp = tmp_0;
    } else {
      tmp = activationDistance;
    }
    activationDistance = tmp;
    enabled = enabled === VOID ? true : enabled;
    var tmp_1;
    if (tagArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = [];
    } else {
      tmp_1 = tagArray;
    }
    tagArray = tmp_1;
    var tmp_2;
    if (offersArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = [];
    } else {
      tmp_2 = offersArray;
    }
    offersArray = tmp_2;
    var tmp_3;
    if (demandsArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = [];
    } else {
      tmp_3 = demandsArray;
    }
    demandsArray = tmp_3;
    worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? 0.0 : worldSpaceOffsetOnHanging;
    rotationalDegreeOfFreedom = rotationalDegreeOfFreedom === VOID ? RotationDegreeOfFreedom_NONE_getInstance().x9_1 : rotationalDegreeOfFreedom;
    required = required === VOID ? false : required;
    Connector.call(this);
    this.b20_1 = key;
    this.c20_1 = type;
    this.d20_1 = transform;
    this.e20_1 = priority;
    this.f20_1 = activationDistance;
    this.g20_1 = enabled;
    this.h20_1 = tagArray;
    this.i20_1 = offersArray;
    this.j20_1 = demandsArray;
    this.k20_1 = worldSpaceOffsetOnHanging;
    this.l20_1 = rotationalDegreeOfFreedom;
    this.m20_1 = required;
    this.n20_1 = false;
  }
  protoOf(PointConnector).t2 = function () {
    return this.b20_1;
  };
  protoOf(PointConnector).a1x = function () {
    return this.c20_1;
  };
  protoOf(PointConnector).d1x = function () {
    return this.d20_1;
  };
  protoOf(PointConnector).v1v = function () {
    return this.e20_1;
  };
  protoOf(PointConnector).l1x = function () {
    return this.f20_1;
  };
  protoOf(PointConnector).m1x = function () {
    return this.g20_1;
  };
  protoOf(PointConnector).f1x = function (_set____db54di) {
    this.h20_1 = _set____db54di;
  };
  protoOf(PointConnector).g1x = function () {
    return this.h20_1;
  };
  protoOf(PointConnector).h1x = function (_set____db54di) {
    this.i20_1 = _set____db54di;
  };
  protoOf(PointConnector).i1x = function () {
    return this.i20_1;
  };
  protoOf(PointConnector).j1x = function (_set____db54di) {
    this.j20_1 = _set____db54di;
  };
  protoOf(PointConnector).k1x = function () {
    return this.j20_1;
  };
  protoOf(PointConnector).c1x = function () {
    return this.k20_1;
  };
  protoOf(PointConnector).e1x = function () {
    return this.l20_1;
  };
  protoOf(PointConnector).b1x = function () {
    return this.m20_1;
  };
  protoOf(PointConnector).equalsByValue = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    if (other instanceof PointConnector) {
      tmp_6 = other.b20_1 === this.b20_1;
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      tmp_5 = other.d20_1.equals(this.d20_1);
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = other.e20_1 === this.e20_1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = other.f20_1 === this.f20_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = other.g20_1 === this.g20_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = contentEquals(other.h20_1, this.h20_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = contentEquals(other.offers(), this.offers());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(other.demands(), this.demands());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(PointConnector).n1x = function () {
    return this.n20_1;
  };
  protoOf(PointConnector).move = function (movementDelta) {
    return this.copy(VOID, VOID, (new Transform(movementDelta)).concatenate(this.d20_1));
  };
  protoOf(PointConnector).rotate = function (rotationDelta) {
    return this.copy(VOID, VOID, this.d20_1.copy(VOID, this.d20_1.rotation.times(rotationDelta)));
  };
  protoOf(PointConnector).contains = function (localSpacePoint) {
    return this.d20_1.position.equals(localSpacePoint);
  };
  protoOf(PointConnector).closest = function (child) {
    return this.d20_1.position;
  };
  protoOf(PointConnector).closestWhenUsingTransform = function (ownerTransform, pointWorldSpace) {
    return this.getWorldPositionFromOwnerTransform(ownerTransform);
  };
  protoOf(PointConnector).enable = function (enable) {
    return this.copy(VOID, VOID, VOID, VOID, VOID, enable);
  };
  protoOf(PointConnector).reposition = function (newPositions) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (newPositions.length === 0) {
      throw IllegalArgumentException_init_$Create$('Can not reposition a point connector with 0 points.');
    }
    return this.copy(VOID, VOID, this.d20_1.copy(newPositions[0]));
  };
  protoOf(PointConnector).toString = function () {
    return '' + getKClassFromExpression(this).v6() + ' ' + this.b20_1;
  };
  protoOf(PointConnector).af = function () {
    return this.b20_1;
  };
  protoOf(PointConnector).bf = function () {
    return this.c20_1;
  };
  protoOf(PointConnector).g1k = function () {
    return this.d20_1;
  };
  protoOf(PointConnector).h1k = function () {
    return this.e20_1;
  };
  protoOf(PointConnector).i1k = function () {
    return this.f20_1;
  };
  protoOf(PointConnector).j1k = function () {
    return this.g20_1;
  };
  protoOf(PointConnector).k1k = function () {
    return this.h20_1;
  };
  protoOf(PointConnector).p1z = function () {
    return this.i20_1;
  };
  protoOf(PointConnector).q1z = function () {
    return this.j20_1;
  };
  protoOf(PointConnector).r1z = function () {
    return this.k20_1;
  };
  protoOf(PointConnector).s1z = function () {
    return this.l20_1;
  };
  protoOf(PointConnector).t1z = function () {
    return this.m20_1;
  };
  protoOf(PointConnector).o20 = function (key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required) {
    return new PointConnector(key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required);
  };
  protoOf(PointConnector).copy = function (key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required, $super) {
    key = key === VOID ? this.b20_1 : key;
    type = type === VOID ? this.c20_1 : type;
    transform = transform === VOID ? this.d20_1 : transform;
    priority = priority === VOID ? this.e20_1 : priority;
    activationDistance = activationDistance === VOID ? this.f20_1 : activationDistance;
    enabled = enabled === VOID ? this.g20_1 : enabled;
    tagArray = tagArray === VOID ? this.h20_1 : tagArray;
    offersArray = offersArray === VOID ? this.i20_1 : offersArray;
    demandsArray = demandsArray === VOID ? this.j20_1 : demandsArray;
    worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? this.k20_1 : worldSpaceOffsetOnHanging;
    rotationalDegreeOfFreedom = rotationalDegreeOfFreedom === VOID ? this.l20_1 : rotationalDegreeOfFreedom;
    required = required === VOID ? this.m20_1 : required;
    return this.o20(key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required);
  };
  protoOf(PointConnector).hashCode = function () {
    var result = getStringHashCode(this.b20_1);
    result = imul(result, 31) + this.c20_1 | 0;
    result = imul(result, 31) + this.d20_1.hashCode() | 0;
    result = imul(result, 31) + this.e20_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.f20_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g20_1) | 0;
    result = imul(result, 31) + hashCode(this.h20_1) | 0;
    result = imul(result, 31) + hashCode(this.i20_1) | 0;
    result = imul(result, 31) + hashCode(this.j20_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k20_1) | 0;
    result = imul(result, 31) + this.l20_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m20_1) | 0;
    return result;
  };
  protoOf(PointConnector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointConnector))
      return false;
    var tmp0_other_with_cast = other instanceof PointConnector ? other : THROW_CCE();
    if (!(this.b20_1 === tmp0_other_with_cast.b20_1))
      return false;
    if (!(this.c20_1 === tmp0_other_with_cast.c20_1))
      return false;
    if (!this.d20_1.equals(tmp0_other_with_cast.d20_1))
      return false;
    if (!(this.e20_1 === tmp0_other_with_cast.e20_1))
      return false;
    if (!equals(this.f20_1, tmp0_other_with_cast.f20_1))
      return false;
    if (!(this.g20_1 === tmp0_other_with_cast.g20_1))
      return false;
    if (!equals(this.h20_1, tmp0_other_with_cast.h20_1))
      return false;
    if (!equals(this.i20_1, tmp0_other_with_cast.i20_1))
      return false;
    if (!equals(this.j20_1, tmp0_other_with_cast.j20_1))
      return false;
    if (!equals(this.k20_1, tmp0_other_with_cast.k20_1))
      return false;
    if (!(this.l20_1 === tmp0_other_with_cast.l20_1))
      return false;
    if (!(this.m20_1 === tmp0_other_with_cast.m20_1))
      return false;
    return true;
  };
  function _get_direction__hwzary($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.f21_1;
    direction$factory();
    return this_0.u2();
  }
  function getNumberOfSubConnectors($this, first, last, spacing) {
    return numberToInt(last.minus(first).size / spacing) + 1 | 0;
  }
  function PointSeriesConnector$direction$delegate$lambda(this$0) {
    return function () {
      return !this$0.last.equals(this$0.first) ? this$0.last.minus(this$0.first).normalize() : Companion_getInstance_61().UP;
    };
  }
  function PointSeriesConnector$allSubConnectors$delegate$lambda$lambda(this$0) {
    return function (pos) {
      return new PointSeriesSubConnector(pos, this$0);
    };
  }
  function PointSeriesConnector$allSubConnectors$delegate$lambda(this$0) {
    return function () {
      return map(this$0.j21_1, PointSeriesConnector$allSubConnectors$delegate$lambda$lambda(this$0));
    };
  }
  function PointSeriesConnector(key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required) {
    rotation = rotation === VOID ? Companion_getInstance_57().IDENTITY : rotation;
    priority = priority === VOID ? 0 : priority;
    var tmp;
    if (activationDistance === VOID) {
      var tmp_0;
      if (type === 1) {
        tmp_0 = 0.0;
      } else {
        tmp_0 = 200.0;
      }
      tmp = tmp_0;
    } else {
      tmp = activationDistance;
    }
    activationDistance = tmp;
    enabled = enabled === VOID ? true : enabled;
    var tmp_1;
    if (tagArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = [];
    } else {
      tmp_1 = tagArray;
    }
    tagArray = tmp_1;
    var tmp_2;
    if (offersArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = [];
    } else {
      tmp_2 = offersArray;
    }
    offersArray = tmp_2;
    var tmp_3;
    if (demandsArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = [];
    } else {
      tmp_3 = demandsArray;
    }
    demandsArray = tmp_3;
    worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? 0.0 : worldSpaceOffsetOnHanging;
    subConnectorSpacing = subConnectorSpacing === VOID ? 30.0 : subConnectorSpacing;
    required = required === VOID ? false : required;
    Connector.call(this);
    this.v20_1 = key;
    this.w20_1 = type;
    this.first = first;
    this.last = last;
    this.rotation = rotation;
    this.x20_1 = priority;
    this.y20_1 = activationDistance;
    this.z20_1 = enabled;
    this.a21_1 = tagArray;
    this.b21_1 = offersArray;
    this.c21_1 = demandsArray;
    this.d21_1 = worldSpaceOffsetOnHanging;
    this.subConnectorSpacing = subConnectorSpacing;
    this.e21_1 = required;
    this.subConnectorCount = getNumberOfSubConnectors(this, this.first, this.last, this.subConnectorSpacing);
    var tmp_4 = this;
    tmp_4.f21_1 = lazy(PointSeriesConnector$direction$delegate$lambda(this));
    this.g21_1 = _get_direction__hwzary(this).times(this.subConnectorSpacing);
    this.h21_1 = this.last.minus(this.first).size;
    this.i21_1 = false;
    this.j21_1 = asSequence_1(until(0, this.subConnectorCount));
    this.k21_1 = this.offset(this.subConnectorCount / 2 | 0);
    this.l21_1 = new Transform(this.k21_1, this.rotation);
    this.m21_1 = true;
    var tmp_5 = this;
    tmp_5.n21_1 = lazy(PointSeriesConnector$allSubConnectors$delegate$lambda(this));
  }
  protoOf(PointSeriesConnector).t2 = function () {
    return this.v20_1;
  };
  protoOf(PointSeriesConnector).a1x = function () {
    return this.w20_1;
  };
  protoOf(PointSeriesConnector).o21 = function () {
    return this.first;
  };
  protoOf(PointSeriesConnector).p21 = function () {
    return this.last;
  };
  protoOf(PointSeriesConnector).v1k = function () {
    return this.rotation;
  };
  protoOf(PointSeriesConnector).v1v = function () {
    return this.x20_1;
  };
  protoOf(PointSeriesConnector).l1x = function () {
    return this.y20_1;
  };
  protoOf(PointSeriesConnector).m1x = function () {
    return this.z20_1;
  };
  protoOf(PointSeriesConnector).f1x = function (_set____db54di) {
    this.a21_1 = _set____db54di;
  };
  protoOf(PointSeriesConnector).g1x = function () {
    return this.a21_1;
  };
  protoOf(PointSeriesConnector).h1x = function (_set____db54di) {
    this.b21_1 = _set____db54di;
  };
  protoOf(PointSeriesConnector).i1x = function () {
    return this.b21_1;
  };
  protoOf(PointSeriesConnector).j1x = function (_set____db54di) {
    this.c21_1 = _set____db54di;
  };
  protoOf(PointSeriesConnector).k1x = function () {
    return this.c21_1;
  };
  protoOf(PointSeriesConnector).c1x = function () {
    return this.d21_1;
  };
  protoOf(PointSeriesConnector).q21 = function () {
    return this.subConnectorSpacing;
  };
  protoOf(PointSeriesConnector).b1x = function () {
    return this.e21_1;
  };
  protoOf(PointSeriesConnector).equalsByValue = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    var tmp_7;
    var tmp_8;
    if (other instanceof PointSeriesConnector) {
      tmp_8 = other.v20_1 === this.v20_1;
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      tmp_7 = other.first.equals(this.first);
    } else {
      tmp_7 = false;
    }
    if (tmp_7) {
      tmp_6 = other.last.equals(this.last);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      tmp_5 = other.rotation.equals(this.rotation);
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = other.x20_1 === this.x20_1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = other.y20_1 === this.y20_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = other.z20_1 === this.z20_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = contentEquals(other.a21_1, this.a21_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = contentEquals(other.offers(), this.offers());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(other.demands(), this.demands());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(PointSeriesConnector).r21 = function () {
    return this.subConnectorCount;
  };
  protoOf(PointSeriesConnector).n1x = function () {
    return this.i21_1;
  };
  protoOf(PointSeriesConnector).d1x = function () {
    return this.l21_1;
  };
  protoOf(PointSeriesConnector).p1x = function () {
    return this.m21_1;
  };
  protoOf(PointSeriesConnector).reposition = function (newPositions) {
    if (newPositions.length < 2) {
      throw IllegalArgumentException_init_$Create$('Can not reposition point series connector with ' + newPositions.length + ' point(s).');
    }
    var newFirst = newPositions[0];
    var newLast = newPositions[1];
    var subConnectorCount = getNumberOfSubConnectors(this, newFirst, newLast, this.subConnectorSpacing);
    var step = newLast.minus(newFirst).normalize().times(this.subConnectorSpacing);
    var calculatedLast = newFirst.plus(step.__timesIntForKotlin(subConnectorCount - 1 | 0));
    return this.copy(VOID, VOID, newFirst, calculatedLast, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.subConnectorSpacing);
  };
  protoOf(PointSeriesConnector).move = function (movementDelta) {
    return this.copy(VOID, VOID, this.first.plus(movementDelta), this.last.plus(movementDelta));
  };
  protoOf(PointSeriesConnector).rotate = function (rotationDelta) {
    return this.copy(VOID, VOID, VOID, VOID, this.rotation.times(rotationDelta));
  };
  protoOf(PointSeriesConnector).contains = function (localSpacePoint) {
    var lengthToConnection = localSpacePoint.minus(this.first).size;
    if (lengthToConnection > this.h21_1)
      return false;
    var steps = round(lengthToConnection / this.subConnectorSpacing);
    var diffVec = this.first.plus(this.g21_1.times(steps)).minus(localSpacePoint);
    return diffVec.equals(Companion_getInstance_61().ZERO);
  };
  protoOf(PointSeriesConnector).enable = function (enable) {
    return this.copy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, enable);
  };
  protoOf(PointSeriesConnector).closest = function (child) {
    if (child.equals(this.first))
      return this.first;
    if (this.first.equals(this.last))
      return this.first;
    var projection = child.minus(this.first).size * (child.minus(this.first).__timesOperatorKotlin(this.last.minus(this.first)) / (child.minus(this.first).size * this.last.minus(this.first).size));
    var connectionPoint = round(projection / this.subConnectorSpacing);
    var closest = connectionPoint < 0.0 ? 0.0 : connectionPoint >= this.subConnectorCount ? this.subConnectorCount - 1 : connectionPoint;
    return this.last.minus(this.first).div(this.last.minus(this.first).size).times(closest).times(this.subConnectorSpacing).plus(this.first);
  };
  protoOf(PointSeriesConnector).shift = function (name, transition) {
    return this.copy(name, VOID, transition.plus(this.first), this.last.plus(transition));
  };
  protoOf(PointSeriesConnector).offset = function (offset) {
    if (this.first.equals(this.last))
      return Companion_getInstance_61().ZERO;
    return this.last.minus(this.first).setSize(1.0).times(this.subConnectorSpacing * offset);
  };
  protoOf(PointSeriesConnector).o1x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n21_1;
    allSubConnectors$factory_0();
    return this_0.u2();
  };
  protoOf(PointSeriesConnector).closestSubConnector = function (localSpacePoint) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.sequences.minByOrNull' call
      var iterator = this.j21_1.t();
      if (!iterator.u()) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      var minElem = iterator.w();
      if (!iterator.u()) {
        tmp$ret$0 = minElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.connectors.PointSeriesConnector.closestSubConnector.<anonymous>' call
      var it = minElem;
      var minValue = this.getSubConnectorPosition(it).distanceTo(localSpacePoint);
      do {
        var e = iterator.w();
        // Inline function 'com.ikea.core.connectors.PointSeriesConnector.closestSubConnector.<anonymous>' call
        var v = this.getSubConnectorPosition(e).distanceTo(localSpacePoint);
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$0 = minElem;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    var pos = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    return new PointSeriesSubConnector(pos, this);
  };
  protoOf(PointSeriesConnector).getSubConnectorPosition = function (subConnectorIndex) {
    return this.first.plus(this.g21_1.__timesIntForKotlin(subConnectorIndex));
  };
  protoOf(PointSeriesConnector).af = function () {
    return this.v20_1;
  };
  protoOf(PointSeriesConnector).bf = function () {
    return this.w20_1;
  };
  protoOf(PointSeriesConnector).g1k = function () {
    return this.first;
  };
  protoOf(PointSeriesConnector).h1k = function () {
    return this.last;
  };
  protoOf(PointSeriesConnector).i1k = function () {
    return this.rotation;
  };
  protoOf(PointSeriesConnector).j1k = function () {
    return this.x20_1;
  };
  protoOf(PointSeriesConnector).k1k = function () {
    return this.y20_1;
  };
  protoOf(PointSeriesConnector).p1z = function () {
    return this.z20_1;
  };
  protoOf(PointSeriesConnector).q1z = function () {
    return this.a21_1;
  };
  protoOf(PointSeriesConnector).r1z = function () {
    return this.b21_1;
  };
  protoOf(PointSeriesConnector).s1z = function () {
    return this.c21_1;
  };
  protoOf(PointSeriesConnector).t1z = function () {
    return this.d21_1;
  };
  protoOf(PointSeriesConnector).s21 = function () {
    return this.subConnectorSpacing;
  };
  protoOf(PointSeriesConnector).t21 = function () {
    return this.e21_1;
  };
  protoOf(PointSeriesConnector).u21 = function (key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required) {
    return new PointSeriesConnector(key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required);
  };
  protoOf(PointSeriesConnector).copy = function (key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required, $super) {
    key = key === VOID ? this.v20_1 : key;
    type = type === VOID ? this.w20_1 : type;
    first = first === VOID ? this.first : first;
    last = last === VOID ? this.last : last;
    rotation = rotation === VOID ? this.rotation : rotation;
    priority = priority === VOID ? this.x20_1 : priority;
    activationDistance = activationDistance === VOID ? this.y20_1 : activationDistance;
    enabled = enabled === VOID ? this.z20_1 : enabled;
    tagArray = tagArray === VOID ? this.a21_1 : tagArray;
    offersArray = offersArray === VOID ? this.b21_1 : offersArray;
    demandsArray = demandsArray === VOID ? this.c21_1 : demandsArray;
    worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? this.d21_1 : worldSpaceOffsetOnHanging;
    subConnectorSpacing = subConnectorSpacing === VOID ? this.subConnectorSpacing : subConnectorSpacing;
    required = required === VOID ? this.e21_1 : required;
    return this.u21(key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required);
  };
  protoOf(PointSeriesConnector).toString = function () {
    return 'PointSeriesConnector(key=' + this.v20_1 + ', type=' + this.w20_1 + ', first=' + this.first + ', last=' + this.last + ', rotation=' + this.rotation + ', priority=' + this.x20_1 + ', activationDistance=' + this.y20_1 + ', enabled=' + this.z20_1 + ', tagArray=' + toString(this.a21_1) + ', offersArray=' + toString(this.b21_1) + ', demandsArray=' + toString(this.c21_1) + ', worldSpaceOffsetOnHanging=' + this.d21_1 + ', subConnectorSpacing=' + this.subConnectorSpacing + ', required=' + this.e21_1 + ')';
  };
  protoOf(PointSeriesConnector).hashCode = function () {
    var result = getStringHashCode(this.v20_1);
    result = imul(result, 31) + this.w20_1 | 0;
    result = imul(result, 31) + this.first.hashCode() | 0;
    result = imul(result, 31) + this.last.hashCode() | 0;
    result = imul(result, 31) + this.rotation.hashCode() | 0;
    result = imul(result, 31) + this.x20_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.y20_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z20_1) | 0;
    result = imul(result, 31) + hashCode(this.a21_1) | 0;
    result = imul(result, 31) + hashCode(this.b21_1) | 0;
    result = imul(result, 31) + hashCode(this.c21_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d21_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.subConnectorSpacing) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e21_1) | 0;
    return result;
  };
  protoOf(PointSeriesConnector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointSeriesConnector))
      return false;
    var tmp0_other_with_cast = other instanceof PointSeriesConnector ? other : THROW_CCE();
    if (!(this.v20_1 === tmp0_other_with_cast.v20_1))
      return false;
    if (!(this.w20_1 === tmp0_other_with_cast.w20_1))
      return false;
    if (!this.first.equals(tmp0_other_with_cast.first))
      return false;
    if (!this.last.equals(tmp0_other_with_cast.last))
      return false;
    if (!this.rotation.equals(tmp0_other_with_cast.rotation))
      return false;
    if (!(this.x20_1 === tmp0_other_with_cast.x20_1))
      return false;
    if (!equals(this.y20_1, tmp0_other_with_cast.y20_1))
      return false;
    if (!(this.z20_1 === tmp0_other_with_cast.z20_1))
      return false;
    if (!equals(this.a21_1, tmp0_other_with_cast.a21_1))
      return false;
    if (!equals(this.b21_1, tmp0_other_with_cast.b21_1))
      return false;
    if (!equals(this.c21_1, tmp0_other_with_cast.c21_1))
      return false;
    if (!equals(this.d21_1, tmp0_other_with_cast.d21_1))
      return false;
    if (!equals(this.subConnectorSpacing, tmp0_other_with_cast.subConnectorSpacing))
      return false;
    if (!(this.e21_1 === tmp0_other_with_cast.e21_1))
      return false;
    return true;
  };
  function direction$factory() {
    return getPropertyCallableRef('direction', 1, KProperty1, function (receiver) {
      return _get_direction__hwzary(receiver);
    }, null);
  }
  function allSubConnectors$factory_0() {
    return getPropertyCallableRef('allSubConnectors', 1, KProperty1, function (receiver) {
      return receiver.allSubConnectors;
    }, null);
  }
  function PointSeriesSubConnector$_init_$ref_dzni41() {
    var l = function (p0, p1) {
      return new PointSeriesSubConnector(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PointSeriesSubConnector$_init_$ref_dzni41_0() {
    var l = function (p0, p1) {
      return new PointSeriesSubConnector(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PointSeriesSubConnector$_init_$ref_dzni41_1() {
    var l = function (p0, p1) {
      return new PointSeriesSubConnector(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PointSeriesSubConnector(hole, series) {
    Connector.call(this);
    this.hole = hole;
    this.series = series;
    this.positionInSeries = this.series.getSubConnectorPosition(this.hole);
    this.h1v_1 = new PointConnector(this.series.v20_1 + '-' + this.hole, this.series.w20_1, new Transform(this.positionInSeries, this.series.rotation), this.series.x20_1, this.series.y20_1, this.series.z20_1, this.series.tags());
    this.i1v_1 = this.series.e21_1;
    this.j1v_1 = this.h1v_1.d20_1;
    this.k1v_1 = this.h1v_1.g20_1;
    this.l1v_1 = this.h1v_1.n20_1;
  }
  protoOf(PointSeriesSubConnector).v21 = function () {
    return this.hole;
  };
  protoOf(PointSeriesSubConnector).w21 = function () {
    return this.series;
  };
  protoOf(PointSeriesSubConnector).x21 = function () {
    return this.positionInSeries;
  };
  protoOf(PointSeriesSubConnector).t2 = function () {
    return this.h1v_1.b20_1;
  };
  protoOf(PointSeriesSubConnector).a1x = function () {
    return this.series.w20_1;
  };
  protoOf(PointSeriesSubConnector).b1x = function () {
    return this.i1v_1;
  };
  protoOf(PointSeriesSubConnector).c1x = function () {
    return this.h1v_1.k20_1;
  };
  protoOf(PointSeriesSubConnector).contains = function (localSpacePoint) {
    return this.h1v_1.contains(localSpacePoint);
  };
  protoOf(PointSeriesSubConnector).enable = function (enable) {
    return this.h1v_1.enable(enable);
  };
  protoOf(PointSeriesSubConnector).d1x = function () {
    return this.j1v_1;
  };
  protoOf(PointSeriesSubConnector).tags = function () {
    return this.h1v_1.tags();
  };
  protoOf(PointSeriesSubConnector).offers = function () {
    return this.series.offers();
  };
  protoOf(PointSeriesSubConnector).demands = function () {
    return this.series.demands();
  };
  protoOf(PointSeriesSubConnector).l1x = function () {
    return this.h1v_1.f20_1;
  };
  protoOf(PointSeriesSubConnector).m1x = function () {
    return this.k1v_1;
  };
  protoOf(PointSeriesSubConnector).n1x = function () {
    return this.l1v_1;
  };
  protoOf(PointSeriesSubConnector).closest = function (child) {
    return this.h1v_1.closest(child);
  };
  protoOf(PointSeriesSubConnector).v1v = function () {
    return this.h1v_1.e20_1;
  };
  protoOf(PointSeriesSubConnector).move = function (movementDelta) {
    throw UnsupportedOperationException_init_$Create$('' + PointSeriesSubConnector$_init_$ref_dzni41() + ' is not allowed to move, any changes must be applied to its ' + series$factory(this));
  };
  protoOf(PointSeriesSubConnector).rotate = function (rotationDelta) {
    throw UnsupportedOperationException_init_$Create$('' + PointSeriesSubConnector$_init_$ref_dzni41_0() + ' is not allowed to move, any changes must be applied to its ' + series$factory_0(this));
  };
  protoOf(PointSeriesSubConnector).reposition = function (newPositions) {
    throw UnsupportedOperationException_init_$Create$('' + PointSeriesSubConnector$_init_$ref_dzni41_1() + ' is not allowed to move, any changes must be applied to its ' + series$factory_1(this));
  };
  protoOf(PointSeriesSubConnector).toString = function () {
    return '' + getKClassFromExpression(this).v6() + ' ' + this.key;
  };
  protoOf(PointSeriesSubConnector).equalsByValue = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof PointSeriesSubConnector) {
      tmp_1 = other.h1v_1.equalsByValue(this.h1v_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = other.positionInSeries.equals(this.positionInSeries);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.series.equalsByValue(this.series);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(PointSeriesSubConnector).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof PointSeriesSubConnector))
      THROW_CCE();
    if (!(this.hole === other.hole))
      return false;
    if (!this.series.equals(other.series))
      return false;
    return true;
  };
  protoOf(PointSeriesSubConnector).hashCode = function () {
    var result = protoOf(Connector).hashCode.call(this);
    result = imul(31, result) + this.hole | 0;
    result = imul(31, result) + this.series.hashCode() | 0;
    return result;
  };
  protoOf(PointSeriesSubConnector).af = function () {
    return this.hole;
  };
  protoOf(PointSeriesSubConnector).bf = function () {
    return this.series;
  };
  protoOf(PointSeriesSubConnector).y21 = function (hole, series) {
    return new PointSeriesSubConnector(hole, series);
  };
  protoOf(PointSeriesSubConnector).copy = function (hole, series, $super) {
    hole = hole === VOID ? this.hole : hole;
    series = series === VOID ? this.series : series;
    return this.y21(hole, series);
  };
  function series$factory($b0) {
    return getPropertyCallableRef('series', 0, KProperty0, function () {
      return $b0.series;
    }, null);
  }
  function series$factory_0($b0) {
    return getPropertyCallableRef('series', 0, KProperty0, function () {
      return $b0.series;
    }, null);
  }
  function series$factory_1($b0) {
    return getPropertyCallableRef('series', 0, KProperty0, function () {
      return $b0.series;
    }, null);
  }
  function RelativeConnectorData(connectorKey, relativePositions) {
    this.connectorKey = connectorKey;
    this.relativePositions = relativePositions;
  }
  protoOf(RelativeConnectorData).z21 = function () {
    return this.connectorKey;
  };
  protoOf(RelativeConnectorData).a22 = function () {
    return this.relativePositions;
  };
  protoOf(RelativeConnectorData).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof RelativeConnectorData))
      THROW_CCE();
    if (!(this.connectorKey === other.connectorKey))
      return false;
    return true;
  };
  protoOf(RelativeConnectorData).hashCode = function () {
    return getStringHashCode(this.connectorKey);
  };
  protoOf(RelativeConnectorData).af = function () {
    return this.connectorKey;
  };
  protoOf(RelativeConnectorData).bf = function () {
    return this.relativePositions;
  };
  protoOf(RelativeConnectorData).b22 = function (connectorKey, relativePositions) {
    return new RelativeConnectorData(connectorKey, relativePositions);
  };
  protoOf(RelativeConnectorData).copy = function (connectorKey, relativePositions, $super) {
    connectorKey = connectorKey === VOID ? this.connectorKey : connectorKey;
    relativePositions = relativePositions === VOID ? this.relativePositions : relativePositions;
    return this.b22(connectorKey, relativePositions);
  };
  protoOf(RelativeConnectorData).toString = function () {
    return 'RelativeConnectorData(connectorKey=' + this.connectorKey + ', relativePositions=' + toString(this.relativePositions) + ')';
  };
  function productBounds($this, entity) {
    return Companion_instance_9.objectOrientedBoundingBoxForAssemblyHierarchy(entity).axisAlignedBoundingBox;
  }
  function RelativeConnectorRepositioner() {
  }
  protoOf(RelativeConnectorRepositioner).repositionRelativeConnectorsFromBounds = function (entity) {
    var tmp0_elvis_lhs = get_relativeConnectorsComponent(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var relativeConnectors = tmp;
    var bounds = productBounds(this, entity);
    if ((bounds.width === 0.0 ? bounds.height === 0.0 : false) ? bounds.depth === 0.0 : false)
      return Unit_instance;
    var newSnappableComponent = this.repositionRelativeConnectors(get_connectorsComponent(entity), relativeConnectors, bounds);
    if (!(newSnappableComponent == null)) {
      entity.addComponent(newSnappableComponent);
    }
  };
  protoOf(RelativeConnectorRepositioner).repositionRelativeConnectors = function (connectorsComponent, relativeConnectorsComponent, aabb) {
    var tmp;
    if (connectorsComponent == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.connectors.RelativeConnectorRepositioner.repositionRelativeConnectors.<anonymous>' call
      // Inline function 'com.ikea.core.utils.mapToArray' call
      var this_0 = connectorsComponent.connectors;
      // Inline function 'kotlin.arrayOfNulls' call
      var size = this_0.length;
      var arr = fillArrayVal(Array(size), null);
      var inductionVariable = 0;
      var last = this_0.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'com.ikea.core.connectors.RelativeConnectorRepositioner.repositionRelativeConnectors.<anonymous>.<anonymous>' call
            var connector = this_0[i];
            // Inline function 'kotlin.collections.find' call
            var this_1 = relativeConnectorsComponent.connectors;
            var tmp$ret$2;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              while (inductionVariable_0 < last_0) {
                var element = this_1[inductionVariable_0];
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'com.ikea.core.connectors.RelativeConnectorRepositioner.repositionRelativeConnectors.<anonymous>.<anonymous>.<anonymous>' call
                if (element.connectorKey === connector.key) {
                  tmp$ret$2 = element;
                  break $l$block;
                }
              }
              tmp$ret$2 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$2;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$4 = connector;
              break $l$block_0;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            var relativeConnectorInfo = tmp_0;
            tmp$ret$4 = RelativeConnectorRepositioner_instance.repositionConnector(connector, relativeConnectorInfo, aabb);
          }
          arr[i] = tmp$ret$4;
        }
         while (inductionVariable <= last);
      tmp = isArray(arr) ? arr : THROW_CCE();
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var translatedConnectors = tmp_1;
    var tmp_2;
    var tmp_3;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(translatedConnectors.length === 0)) {
      tmp_3 = !(connectorsComponent == null);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = new ConnectorsComponent(translatedConnectors);
    } else {
      tmp_2 = connectorsComponent;
    }
    return tmp_2;
  };
  protoOf(RelativeConnectorRepositioner).repositionConnector = function (connector, relativeConnectorData, aabb) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = relativeConnectorData.relativePositions;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.RelativeConnectorRepositioner.repositionConnector.<anonymous>' call
      var tmp$ret$0 = item.applyToBox(aabb);
      destination.q(tmp$ret$0);
    }
    var movedConnectorPoints = copyToArray(destination);
    var newConnector = connector.reposition(movedConnectorPoints);
    var tmp;
    if (newConnector.equalsByValue(connector)) {
      tmp = connector;
    } else {
      tmp = newConnector;
    }
    return tmp;
  };
  protoOf(RelativeConnectorRepositioner).localBounds = function (entity) {
    return get_objectOrientedBoundingBoxForHierarchy(entity).axisAlignedBoundingBox;
  };
  var RelativeConnectorRepositioner_instance;
  function RelativeConnectorRepositioner_getInstance() {
    return RelativeConnectorRepositioner_instance;
  }
  function Companion_25() {
    this.id = 42;
  }
  protoOf(Companion_25).s1k = function () {
    return this.id;
  };
  var Companion_instance_25;
  function Companion_getInstance_26() {
    return Companion_instance_25;
  }
  function RelativeConnectorsComponent(connectors) {
    this.connectors = connectors;
    this.c22_1 = 42;
    this.d22_1 = 0;
  }
  protoOf(RelativeConnectorsComponent).a1y = function () {
    return this.connectors;
  };
  protoOf(RelativeConnectorsComponent).x1k = function () {
    return this.c22_1;
  };
  protoOf(RelativeConnectorsComponent).eq = function (other) {
    return false;
  };
  protoOf(RelativeConnectorsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof RelativeConnectorsComponent))
      THROW_CCE();
    if (!contentEquals(this.connectors, other.connectors))
      return false;
    return true;
  };
  protoOf(RelativeConnectorsComponent).hashCode = function () {
    if (this.d22_1 === 0) {
      this.d22_1 = contentHashCode(this.connectors);
    }
    return this.d22_1;
  };
  protoOf(RelativeConnectorsComponent).af = function () {
    return this.connectors;
  };
  protoOf(RelativeConnectorsComponent).e22 = function (connectors) {
    return new RelativeConnectorsComponent(connectors);
  };
  protoOf(RelativeConnectorsComponent).copy = function (connectors, $super) {
    connectors = connectors === VOID ? this.connectors : connectors;
    return this.e22(connectors);
  };
  protoOf(RelativeConnectorsComponent).toString = function () {
    return 'RelativeConnectorsComponent(connectors=' + toString(this.connectors) + ')';
  };
  function get_relativeConnectorsComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(42);
  }
  var RotationDegreeOfFreedom_NONE_instance;
  var RotationDegreeOfFreedom_ONE_instance;
  function values_0() {
    return [RotationDegreeOfFreedom_NONE_getInstance(), RotationDegreeOfFreedom_ONE_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'NONE':
        return RotationDegreeOfFreedom_NONE_getInstance();
      case 'ONE':
        return RotationDegreeOfFreedom_ONE_getInstance();
      default:
        RotationDegreeOfFreedom_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RotationDegreeOfFreedom_entriesInitialized;
  function RotationDegreeOfFreedom_initEntries() {
    if (RotationDegreeOfFreedom_entriesInitialized)
      return Unit_instance;
    RotationDegreeOfFreedom_entriesInitialized = true;
    RotationDegreeOfFreedom_NONE_instance = new RotationDegreeOfFreedom('NONE', 0);
    RotationDegreeOfFreedom_ONE_instance = new RotationDegreeOfFreedom('ONE', 1);
  }
  function RotationDegreeOfFreedom(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RotationDegreeOfFreedomImpostor() {
    this.NONE = 0;
    this.ONE = 1;
  }
  protoOf(RotationDegreeOfFreedomImpostor).h22 = function () {
    return this.NONE;
  };
  protoOf(RotationDegreeOfFreedomImpostor).i22 = function () {
    return this.ONE;
  };
  var RotationDegreeOfFreedomImpostor_instance;
  function RotationDegreeOfFreedomImpostor_getInstance() {
    return RotationDegreeOfFreedomImpostor_instance;
  }
  function RotationDegreeOfFreedom_NONE_getInstance() {
    RotationDegreeOfFreedom_initEntries();
    return RotationDegreeOfFreedom_NONE_instance;
  }
  function RotationDegreeOfFreedom_ONE_getInstance() {
    RotationDegreeOfFreedom_initEntries();
    return RotationDegreeOfFreedom_ONE_instance;
  }
  function validateNoCollinearPointsInSurfaceConnector($this) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var listOfVerticesToRemove = ArrayList_init_$Create$();
    var previousIndex = $this.vertices.length - 1 | 0;
    var inductionVariable = 0;
    var last = $this.vertices.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.vertices[index].minus($this.vertices[previousIndex]).cross($this.vertices[(index + 1 | 0) % $this.vertices.length | 0].minus($this.vertices[index])).size < 0.001) {
          var tmp = Companion_getInstance_27().logger;
          tmp.warn(SurfaceConnector$validateNoCollinearPointsInSurfaceConnector$lambda(index));
          listOfVerticesToRemove.q(index);
        }
        previousIndex = index;
      }
       while (inductionVariable <= last);
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_indices($this.vertices);
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.connectors.SurfaceConnector.validateNoCollinearPointsInSurfaceConnector.<anonymous>' call
      if (!listOfVerticesToRemove.p(element)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.t();
    while (tmp0_iterator_0.u()) {
      var item = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.connectors.SurfaceConnector.validateNoCollinearPointsInSurfaceConnector.<anonymous>' call
      var tmp$ret$4 = $this.vertices[item];
      destination_0.q(tmp$ret$4);
    }
    tmp_0.vertices = copyToArray(destination_0);
  }
  function Companion_26() {
    Companion_instance_26 = this;
    this.logger = LoggerState_getInstance().m1m('Surface Connector');
  }
  protoOf(Companion_26).x1i = function () {
    return this.logger;
  };
  var Companion_instance_26;
  function Companion_getInstance_27() {
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function SurfaceConnector$validateNoCollinearPointsInSurfaceConnector$lambda($index) {
    return function () {
      return 'Vertex supplied to surface connector at index ' + $index + ' is collinear, removing vertex.';
    };
  }
  function SurfaceConnector(key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
    Companion_getInstance_27();
    priority = priority === VOID ? 0 : priority;
    var tmp;
    if (activationDistance === VOID) {
      var tmp_0;
      if (type === 1) {
        tmp_0 = 0.0;
      } else {
        tmp_0 = 200.0;
      }
      tmp = tmp_0;
    } else {
      tmp = activationDistance;
    }
    activationDistance = tmp;
    enabled = enabled === VOID ? true : enabled;
    var tmp_1;
    if (tagArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = [];
    } else {
      tmp_1 = tagArray;
    }
    tagArray = tmp_1;
    var tmp_2;
    if (offersArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = [];
    } else {
      tmp_2 = offersArray;
    }
    offersArray = tmp_2;
    var tmp_3;
    if (demandsArray === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = [];
    } else {
      tmp_3 = demandsArray;
    }
    demandsArray = tmp_3;
    required = required === VOID ? false : required;
    Connector.call(this);
    this.p22_1 = key;
    this.q22_1 = type;
    this.vertices = vertices;
    this.r22_1 = priority;
    this.s22_1 = activationDistance;
    this.t22_1 = enabled;
    this.u22_1 = tagArray;
    this.v22_1 = offersArray;
    this.w22_1 = demandsArray;
    this.x22_1 = required;
    if (this.vertices.length < 3) {
      throw IllegalArgumentException_init_$Create$('A surface connector needs at least 3 vertices. Provided vertices: ' + this.vertices);
    }
    this.anchor = get_geometricMean(this.vertices);
    this.normal = PolyhedronUtils_getInstance().surfaceNormal(this.vertices);
    validateNoCollinearPointsInSurfaceConnector(this);
    var upProjection = this.normal.dot(Companion_getInstance_61().UP);
    var up = upProjection < -0.999 ? Companion_getInstance_61().BACK : upProjection > 0.999 ? Companion_getInstance_61().FORWARD : Companion_getInstance_61().UP;
    var rotation = Companion_getInstance_57().fromEulerDegrees(new Degrees(90.0)).times(Companion_getInstance_57().fromLookDirectionUnsafe(this.normal.unaryMinus(), up));
    this.y22_1 = new Transform(this.anchor, rotation);
    this.z22_1 = true;
    this.plane = new Plane(this.anchor, this.normal);
  }
  protoOf(SurfaceConnector).t2 = function () {
    return this.p22_1;
  };
  protoOf(SurfaceConnector).a1x = function () {
    return this.q22_1;
  };
  protoOf(SurfaceConnector).a23 = function (_set____db54di) {
    this.vertices = _set____db54di;
  };
  protoOf(SurfaceConnector).b23 = function () {
    return this.vertices;
  };
  protoOf(SurfaceConnector).v1v = function () {
    return this.r22_1;
  };
  protoOf(SurfaceConnector).l1x = function () {
    return this.s22_1;
  };
  protoOf(SurfaceConnector).m1x = function () {
    return this.t22_1;
  };
  protoOf(SurfaceConnector).f1x = function (_set____db54di) {
    this.u22_1 = _set____db54di;
  };
  protoOf(SurfaceConnector).g1x = function () {
    return this.u22_1;
  };
  protoOf(SurfaceConnector).h1x = function (_set____db54di) {
    this.v22_1 = _set____db54di;
  };
  protoOf(SurfaceConnector).i1x = function () {
    return this.v22_1;
  };
  protoOf(SurfaceConnector).j1x = function (_set____db54di) {
    this.w22_1 = _set____db54di;
  };
  protoOf(SurfaceConnector).k1x = function () {
    return this.w22_1;
  };
  protoOf(SurfaceConnector).b1x = function () {
    return this.x22_1;
  };
  protoOf(SurfaceConnector).c23 = function () {
    return this.anchor;
  };
  protoOf(SurfaceConnector).d23 = function () {
    return this.normal;
  };
  protoOf(SurfaceConnector).d1x = function () {
    return this.y22_1;
  };
  protoOf(SurfaceConnector).equalsByValue = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    var tmp_7;
    if (other instanceof SurfaceConnector) {
      tmp_7 = other.p22_1 === this.p22_1;
    } else {
      tmp_7 = false;
    }
    if (tmp_7) {
      tmp_6 = contentEquals(other.vertices, this.vertices);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      tmp_5 = other.y22_1.equals(this.y22_1);
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = other.r22_1 === this.r22_1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = other.s22_1 === this.s22_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = other.t22_1 === this.t22_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = contentEquals(other.u22_1, this.u22_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = contentEquals(other.offers(), this.offers());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(other.demands(), this.demands());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SurfaceConnector).n1x = function () {
    return this.z22_1;
  };
  protoOf(SurfaceConnector).c1x = function () {
    return 0.0;
  };
  protoOf(SurfaceConnector).e23 = function () {
    return this.plane;
  };
  protoOf(SurfaceConnector).reposition = function (newPositions) {
    return new SurfaceConnector(this.p22_1, this.q22_1, newPositions, this.r22_1, this.s22_1, this.t22_1, this.u22_1, this.v22_1);
  };
  protoOf(SurfaceConnector).move = function (movementDelta) {
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.vertices;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connectors.SurfaceConnector.move.<anonymous>' call
        arr[i] = this_0[i].plus(movementDelta);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return this.copy(VOID, VOID, tmp$ret$2);
  };
  protoOf(SurfaceConnector).rotate = function (rotationDelta) {
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.vertices;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connectors.SurfaceConnector.rotate.<anonymous>' call
        arr[i] = this_0[i].rotate(rotationDelta);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return this.copy(VOID, VOID, tmp$ret$2);
  };
  protoOf(SurfaceConnector).enable = function (enable) {
    return this.copy(VOID, VOID, VOID, VOID, VOID, enable);
  };
  protoOf(SurfaceConnector).closest = function (child) {
    var pE = child.projectOnPlaneFromPoints(this.vertices[0], this.vertices[1], this.vertices[2]);
    return this.contains(pE) ? pE : closestOnEdge(child, this.vertices);
  };
  protoOf(SurfaceConnector).contains = function (localSpacePoint) {
    var tmp;
    if (closestOnEdge(localSpacePoint, this.vertices).distanceTo(localSpacePoint) < 1.0E-4) {
      tmp = true;
    } else {
      tmp = PolyhedronUtils_getInstance().pointInPolygon(localSpacePoint, this.vertices, this.normal);
    }
    return tmp;
  };
  protoOf(SurfaceConnector).af = function () {
    return this.p22_1;
  };
  protoOf(SurfaceConnector).bf = function () {
    return this.q22_1;
  };
  protoOf(SurfaceConnector).g1k = function () {
    return this.vertices;
  };
  protoOf(SurfaceConnector).h1k = function () {
    return this.r22_1;
  };
  protoOf(SurfaceConnector).i1k = function () {
    return this.s22_1;
  };
  protoOf(SurfaceConnector).j1k = function () {
    return this.t22_1;
  };
  protoOf(SurfaceConnector).k1k = function () {
    return this.u22_1;
  };
  protoOf(SurfaceConnector).p1z = function () {
    return this.v22_1;
  };
  protoOf(SurfaceConnector).q1z = function () {
    return this.w22_1;
  };
  protoOf(SurfaceConnector).r1z = function () {
    return this.x22_1;
  };
  protoOf(SurfaceConnector).f23 = function (key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
    return new SurfaceConnector(key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
  };
  protoOf(SurfaceConnector).copy = function (key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required, $super) {
    key = key === VOID ? this.p22_1 : key;
    type = type === VOID ? this.q22_1 : type;
    vertices = vertices === VOID ? this.vertices : vertices;
    priority = priority === VOID ? this.r22_1 : priority;
    activationDistance = activationDistance === VOID ? this.s22_1 : activationDistance;
    enabled = enabled === VOID ? this.t22_1 : enabled;
    tagArray = tagArray === VOID ? this.u22_1 : tagArray;
    offersArray = offersArray === VOID ? this.v22_1 : offersArray;
    demandsArray = demandsArray === VOID ? this.w22_1 : demandsArray;
    required = required === VOID ? this.x22_1 : required;
    return this.f23(key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
  };
  protoOf(SurfaceConnector).toString = function () {
    return 'SurfaceConnector(key=' + this.p22_1 + ', type=' + this.q22_1 + ', vertices=' + toString(this.vertices) + ', priority=' + this.r22_1 + ', activationDistance=' + this.s22_1 + ', enabled=' + this.t22_1 + ', tagArray=' + toString(this.u22_1) + ', offersArray=' + toString(this.v22_1) + ', demandsArray=' + toString(this.w22_1) + ', required=' + this.x22_1 + ')';
  };
  protoOf(SurfaceConnector).hashCode = function () {
    var result = getStringHashCode(this.p22_1);
    result = imul(result, 31) + this.q22_1 | 0;
    result = imul(result, 31) + hashCode(this.vertices) | 0;
    result = imul(result, 31) + this.r22_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.s22_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t22_1) | 0;
    result = imul(result, 31) + hashCode(this.u22_1) | 0;
    result = imul(result, 31) + hashCode(this.v22_1) | 0;
    result = imul(result, 31) + hashCode(this.w22_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x22_1) | 0;
    return result;
  };
  protoOf(SurfaceConnector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SurfaceConnector))
      return false;
    var tmp0_other_with_cast = other instanceof SurfaceConnector ? other : THROW_CCE();
    if (!(this.p22_1 === tmp0_other_with_cast.p22_1))
      return false;
    if (!(this.q22_1 === tmp0_other_with_cast.q22_1))
      return false;
    if (!equals(this.vertices, tmp0_other_with_cast.vertices))
      return false;
    if (!(this.r22_1 === tmp0_other_with_cast.r22_1))
      return false;
    if (!equals(this.s22_1, tmp0_other_with_cast.s22_1))
      return false;
    if (!(this.t22_1 === tmp0_other_with_cast.t22_1))
      return false;
    if (!equals(this.u22_1, tmp0_other_with_cast.u22_1))
      return false;
    if (!equals(this.v22_1, tmp0_other_with_cast.v22_1))
      return false;
    if (!equals(this.w22_1, tmp0_other_with_cast.w22_1))
      return false;
    if (!(this.x22_1 === tmp0_other_with_cast.x22_1))
      return false;
    return true;
  };
  function DebugLine(start, end, color, thickness) {
    this.start = start;
    this.end = end;
    this.color = color;
    this.thickness = thickness;
  }
  protoOf(DebugLine).s9 = function () {
    return this.start;
  };
  protoOf(DebugLine).g23 = function () {
    return this.end;
  };
  protoOf(DebugLine).h23 = function () {
    return this.color;
  };
  protoOf(DebugLine).i23 = function () {
    return this.thickness;
  };
  protoOf(DebugLine).af = function () {
    return this.start;
  };
  protoOf(DebugLine).bf = function () {
    return this.end;
  };
  protoOf(DebugLine).g1k = function () {
    return this.color;
  };
  protoOf(DebugLine).h1k = function () {
    return this.thickness;
  };
  protoOf(DebugLine).j23 = function (start, end, color, thickness) {
    return new DebugLine(start, end, color, thickness);
  };
  protoOf(DebugLine).copy = function (start, end, color, thickness, $super) {
    start = start === VOID ? this.start : start;
    end = end === VOID ? this.end : end;
    color = color === VOID ? this.color : color;
    thickness = thickness === VOID ? this.thickness : thickness;
    return this.j23(start, end, color, thickness);
  };
  protoOf(DebugLine).toString = function () {
    return 'DebugLine(start=' + this.start + ', end=' + this.end + ', color=' + this.color + ', thickness=' + this.thickness + ')';
  };
  protoOf(DebugLine).hashCode = function () {
    var result = this.start.hashCode();
    result = imul(result, 31) + this.end.hashCode() | 0;
    result = imul(result, 31) + this.color.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.thickness) | 0;
    return result;
  };
  protoOf(DebugLine).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DebugLine))
      return false;
    var tmp0_other_with_cast = other instanceof DebugLine ? other : THROW_CCE();
    if (!this.start.equals(tmp0_other_with_cast.start))
      return false;
    if (!this.end.equals(tmp0_other_with_cast.end))
      return false;
    if (!this.color.equals(tmp0_other_with_cast.color))
      return false;
    if (!equals(this.thickness, tmp0_other_with_cast.thickness))
      return false;
    return true;
  };
  function Companion_27() {
    this.id = 92;
  }
  protoOf(Companion_27).s1k = function () {
    return this.id;
  };
  var Companion_instance_27;
  function Companion_getInstance_28() {
    return Companion_instance_27;
  }
  function DebugLinesComponent(lines) {
    this.lines = lines;
  }
  protoOf(DebugLinesComponent).k23 = function () {
    return this.lines;
  };
  protoOf(DebugLinesComponent).x1k = function () {
    return 92;
  };
  protoOf(DebugLinesComponent).eq = function (other) {
    return contentDeepEquals(this.lines, (other instanceof DebugLinesComponent ? other : THROW_CCE()).lines);
  };
  function Companion_28() {
    this.id = 120;
  }
  protoOf(Companion_28).s1k = function () {
    return this.id;
  };
  var Companion_instance_28;
  function Companion_getInstance_29() {
    return Companion_instance_28;
  }
  function DebugSurfacesComponent(surfaces) {
    this.surfaces = surfaces;
  }
  protoOf(DebugSurfacesComponent).l23 = function () {
    return this.surfaces;
  };
  protoOf(DebugSurfacesComponent).x1k = function () {
    return 120;
  };
  protoOf(DebugSurfacesComponent).eq = function (other) {
    return contentDeepEquals(this.surfaces, (other instanceof DebugSurfacesComponent ? other : THROW_CCE()).surfaces);
  };
  function Companion_29() {
    this.id = 74;
  }
  protoOf(Companion_29).s1k = function () {
    return this.id;
  };
  var Companion_instance_29;
  function Companion_getInstance_30() {
    return Companion_instance_29;
  }
  function DragSurfacesComponent(surfaces, basedOnCollider) {
    basedOnCollider = basedOnCollider === VOID ? false : basedOnCollider;
    this.surfaces = surfaces;
    this.basedOnCollider = basedOnCollider;
  }
  protoOf(DragSurfacesComponent).l23 = function () {
    return this.surfaces;
  };
  protoOf(DragSurfacesComponent).m23 = function () {
    return this.basedOnCollider;
  };
  protoOf(DragSurfacesComponent).x1k = function () {
    return 74;
  };
  protoOf(DragSurfacesComponent).eq = function (other) {
    var tmp;
    if (contentDeepEquals(this.surfaces, (other instanceof DragSurfacesComponent ? other : THROW_CCE()).surfaces)) {
      tmp = this.basedOnCollider === other.basedOnCollider;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DragSurfacesComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof DragSurfacesComponent))
      THROW_CCE();
    if (!contentEquals(this.surfaces, other.surfaces))
      return false;
    if (!(this.basedOnCollider === other.basedOnCollider))
      return false;
    return true;
  };
  protoOf(DragSurfacesComponent).hashCode = function () {
    var result = contentHashCode(this.surfaces);
    result = imul(31, result) + getBooleanHashCode(this.basedOnCollider) | 0;
    return result;
  };
  protoOf(DragSurfacesComponent).af = function () {
    return this.surfaces;
  };
  protoOf(DragSurfacesComponent).bf = function () {
    return this.basedOnCollider;
  };
  protoOf(DragSurfacesComponent).n23 = function (surfaces, basedOnCollider) {
    return new DragSurfacesComponent(surfaces, basedOnCollider);
  };
  protoOf(DragSurfacesComponent).copy = function (surfaces, basedOnCollider, $super) {
    surfaces = surfaces === VOID ? this.surfaces : surfaces;
    basedOnCollider = basedOnCollider === VOID ? this.basedOnCollider : basedOnCollider;
    return this.n23(surfaces, basedOnCollider);
  };
  protoOf(DragSurfacesComponent).toString = function () {
    return 'DragSurfacesComponent(surfaces=' + toString(this.surfaces) + ', basedOnCollider=' + this.basedOnCollider + ')';
  };
  function DragSurface(surface, connectorKeys) {
    this.surface = surface;
    this.connectorKeys = connectorKeys;
  }
  protoOf(DragSurface).o23 = function () {
    return this.surface;
  };
  protoOf(DragSurface).p23 = function () {
    return this.connectorKeys;
  };
  protoOf(DragSurface).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof DragSurface))
      THROW_CCE();
    if (!equals(this.surface, other.surface))
      return false;
    if (!(this.connectorKeys == null)) {
      if (other.connectorKeys == null)
        return false;
      if (!contentEquals(this.connectorKeys, other.connectorKeys))
        return false;
    } else if (!(other.connectorKeys == null))
      return false;
    return true;
  };
  protoOf(DragSurface).hashCode = function () {
    var result = hashCode(this.surface);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.connectorKeys;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contentHashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(DragSurface).af = function () {
    return this.surface;
  };
  protoOf(DragSurface).bf = function () {
    return this.connectorKeys;
  };
  protoOf(DragSurface).k1n = function (surface, connectorKeys) {
    return new DragSurface(surface, connectorKeys);
  };
  protoOf(DragSurface).copy = function (surface, connectorKeys, $super) {
    surface = surface === VOID ? this.surface : surface;
    connectorKeys = connectorKeys === VOID ? this.connectorKeys : connectorKeys;
    return this.k1n(surface, connectorKeys);
  };
  protoOf(DragSurface).toString = function () {
    return 'DragSurface(surface=' + this.surface + ', connectorKeys=' + toString(this.connectorKeys) + ')';
  };
  function get_dragSurfacesComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(74);
  }
  function Companion_30() {
    this.id = 3;
  }
  protoOf(Companion_30).s1k = function () {
    return this.id;
  };
  var Companion_instance_30;
  function Companion_getInstance_31() {
    return Companion_instance_30;
  }
  function DraggableComponent() {
  }
  protoOf(DraggableComponent).x1k = function () {
    return 3;
  };
  protoOf(DraggableComponent).eq = function (other) {
    return true;
  };
  function Companion_31() {
    this.id = 66;
  }
  protoOf(Companion_31).s1k = function () {
    return this.id;
  };
  var Companion_instance_31;
  function Companion_getInstance_32() {
    return Companion_instance_31;
  }
  function SomethingIsDraggedComponent(entity) {
    this.entity = entity;
    this.q23_1 = false;
  }
  protoOf(SomethingIsDraggedComponent).r23 = function () {
    return this.entity;
  };
  protoOf(SomethingIsDraggedComponent).x1k = function () {
    return 66;
  };
  protoOf(SomethingIsDraggedComponent).eq = function (other) {
    return (other instanceof SomethingIsDraggedComponent ? other : THROW_CCE()).entity.equals(this.entity);
  };
  protoOf(SomethingIsDraggedComponent).a1l = function () {
    return this.q23_1;
  };
  var DragType_DragStart_instance;
  var DragType_DragMove_instance;
  var DragType_DragEnd_instance;
  function values_1() {
    return [DragType_DragStart_getInstance(), DragType_DragMove_getInstance(), DragType_DragEnd_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'DragStart':
        return DragType_DragStart_getInstance();
      case 'DragMove':
        return DragType_DragMove_getInstance();
      case 'DragEnd':
        return DragType_DragEnd_getInstance();
      default:
        DragType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var DragType_entriesInitialized;
  function DragType_initEntries() {
    if (DragType_entriesInitialized)
      return Unit_instance;
    DragType_entriesInitialized = true;
    DragType_DragStart_instance = new DragType('DragStart', 0);
    DragType_DragMove_instance = new DragType('DragMove', 1);
    DragType_DragEnd_instance = new DragType('DragEnd', 2);
  }
  function DragType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_32() {
    this.id = 84;
  }
  protoOf(Companion_32).s1k = function () {
    return this.id;
  };
  var Companion_instance_32;
  function Companion_getInstance_33() {
    return Companion_instance_32;
  }
  function ViewerDragEventComponent$rayFromCameraToDragEnd$delegate$lambda(this$0) {
    return function () {
      var rayDir = this$0.planePoint.minus(this$0.cameraPosition).normalize();
      var ray = new Ray(this$0.cameraPosition, rayDir);
      return ray;
    };
  }
  function ViewerDragEventComponent(planePoint, planeNormal, delta, cameraPosition) {
    this.planePoint = planePoint;
    this.planeNormal = planeNormal;
    this.delta = delta;
    this.cameraPosition = cameraPosition;
    var tmp = this;
    tmp.u23_1 = lazy(ViewerDragEventComponent$rayFromCameraToDragEnd$delegate$lambda(this));
    this.v23_1 = 84;
    this.w23_1 = false;
  }
  protoOf(ViewerDragEventComponent).x23 = function () {
    return this.planePoint;
  };
  protoOf(ViewerDragEventComponent).y23 = function () {
    return this.planeNormal;
  };
  protoOf(ViewerDragEventComponent).z23 = function () {
    return this.delta;
  };
  protoOf(ViewerDragEventComponent).a24 = function () {
    return this.cameraPosition;
  };
  protoOf(ViewerDragEventComponent).b24 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u23_1;
    rayFromCameraToDragEnd$factory();
    return this_0.u2();
  };
  protoOf(ViewerDragEventComponent).x1k = function () {
    return this.v23_1;
  };
  protoOf(ViewerDragEventComponent).eq = function (other) {
    if (!(other instanceof ViewerDragEventComponent))
      return false;
    return ((other.planePoint.equals(this.planePoint) ? other.planeNormal.equals(this.planeNormal) : false) ? other.delta.equals(this.delta) : false) ? other.cameraPosition.equals(this.cameraPosition) : false;
  };
  protoOf(ViewerDragEventComponent).a1l = function () {
    return this.w23_1;
  };
  protoOf(ViewerDragEventComponent).af = function () {
    return this.planePoint;
  };
  protoOf(ViewerDragEventComponent).bf = function () {
    return this.planeNormal;
  };
  protoOf(ViewerDragEventComponent).g1k = function () {
    return this.delta;
  };
  protoOf(ViewerDragEventComponent).h1k = function () {
    return this.cameraPosition;
  };
  protoOf(ViewerDragEventComponent).c24 = function (planePoint, planeNormal, delta, cameraPosition) {
    return new ViewerDragEventComponent(planePoint, planeNormal, delta, cameraPosition);
  };
  protoOf(ViewerDragEventComponent).copy = function (planePoint, planeNormal, delta, cameraPosition, $super) {
    planePoint = planePoint === VOID ? this.planePoint : planePoint;
    planeNormal = planeNormal === VOID ? this.planeNormal : planeNormal;
    delta = delta === VOID ? this.delta : delta;
    cameraPosition = cameraPosition === VOID ? this.cameraPosition : cameraPosition;
    return this.c24(planePoint, planeNormal, delta, cameraPosition);
  };
  protoOf(ViewerDragEventComponent).toString = function () {
    return 'ViewerDragEventComponent(planePoint=' + this.planePoint + ', planeNormal=' + this.planeNormal + ', delta=' + this.delta + ', cameraPosition=' + this.cameraPosition + ')';
  };
  protoOf(ViewerDragEventComponent).hashCode = function () {
    var result = this.planePoint.hashCode();
    result = imul(result, 31) + this.planeNormal.hashCode() | 0;
    result = imul(result, 31) + this.delta.hashCode() | 0;
    result = imul(result, 31) + this.cameraPosition.hashCode() | 0;
    return result;
  };
  protoOf(ViewerDragEventComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ViewerDragEventComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ViewerDragEventComponent ? other : THROW_CCE();
    if (!this.planePoint.equals(tmp0_other_with_cast.planePoint))
      return false;
    if (!this.planeNormal.equals(tmp0_other_with_cast.planeNormal))
      return false;
    if (!this.delta.equals(tmp0_other_with_cast.delta))
      return false;
    if (!this.cameraPosition.equals(tmp0_other_with_cast.cameraPosition))
      return false;
    return true;
  };
  function DragType_DragStart_getInstance() {
    DragType_initEntries();
    return DragType_DragStart_instance;
  }
  function DragType_DragMove_getInstance() {
    DragType_initEntries();
    return DragType_DragMove_instance;
  }
  function DragType_DragEnd_getInstance() {
    DragType_initEntries();
    return DragType_DragEnd_instance;
  }
  function rayFromCameraToDragEnd$factory() {
    return getPropertyCallableRef('rayFromCameraToDragEnd', 1, KProperty1, function (receiver) {
      return receiver.rayFromCameraToDragEnd;
    }, null);
  }
  function Companion_33() {
    this.ID = 'WorldDragSurfaceUpdateSystem';
  }
  protoOf(Companion_33).u1n = function () {
    return this.ID;
  };
  var Companion_instance_33;
  function Companion_getInstance_34() {
    return Companion_instance_33;
  }
  function updateDragSurfaces($this, entity) {
    var tmp0_safe_receiver = calculateWorldDragSurfaces($this, entity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.dragging.WorldDragSurfaceUpdateSystem.updateDragSurfaces.<anonymous>' call
      entity.addComponent(tmp0_safe_receiver);
    }
  }
  function calculateWorldDragSurfaces($this, entity) {
    var tmp0_safe_receiver = get_dragSurfacesComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.surfaces;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.dragging.WorldDragSurfaceUpdateSystem.calculateWorldDragSurfaces.<anonymous>' call
        var transformedPoly = TransformUtils_instance.applyWorldTransform(item.surface, entity);
        var tmp$ret$0 = item.copy(transformedPoly);
        destination.q(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp2_safe_receiver);
    }
    var transformedSurfaces = tmp_0;
    var tmp_1;
    if (transformedSurfaces == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.dragging.WorldDragSurfaceUpdateSystem.calculateWorldDragSurfaces.<anonymous>' call
      tmp_1 = new WorldDragSurfacesComponent(transformedSurfaces);
    }
    return tmp_1;
  }
  function WorldDragSurfaceUpdateSystem() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [91];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['TransformSystem'];
    SystemBase2.call(this, 'WorldDragSurfaceUpdateSystem', 10, 74, tmp, tmp$ret$5, null);
  }
  protoOf(WorldDragSurfaceUpdateSystem).onAddComponent = function (entity, newComponent) {
    updateDragSurfaces(this, entity);
  };
  protoOf(WorldDragSurfaceUpdateSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    updateDragSurfaces(this, entity);
  };
  protoOf(WorldDragSurfaceUpdateSystem).onRemoveComponent = function (entity, oldComponent) {
    updateDragSurfaces(this, entity);
  };
  protoOf(WorldDragSurfaceUpdateSystem).onAddComponent2 = function (entity, newComponent) {
    updateDragSurfaces(this, entity);
  };
  protoOf(WorldDragSurfaceUpdateSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    updateDragSurfaces(this, entity);
  };
  protoOf(WorldDragSurfaceUpdateSystem).onRemoveComponent2 = function (entity, oldComponent) {
    entity.removeComponent(91);
  };
  function Companion_34() {
    this.id = 91;
  }
  protoOf(Companion_34).s1k = function () {
    return this.id;
  };
  var Companion_instance_34;
  function Companion_getInstance_35() {
    return Companion_instance_34;
  }
  function WorldDragSurfacesComponent(surfaces) {
    this.surfaces = surfaces;
  }
  protoOf(WorldDragSurfacesComponent).l23 = function () {
    return this.surfaces;
  };
  protoOf(WorldDragSurfacesComponent).x1k = function () {
    return 91;
  };
  protoOf(WorldDragSurfacesComponent).eq = function (other) {
    return contentDeepEquals(this.surfaces, (other instanceof WorldDragSurfacesComponent ? other : THROW_CCE()).surfaces);
  };
  protoOf(WorldDragSurfacesComponent).hashCode = function () {
    return hashCode(this.surfaces);
  };
  protoOf(WorldDragSurfacesComponent).equals = function (other) {
    var tmp;
    if (other instanceof WorldDragSurfacesComponent) {
      tmp = contentDeepEquals(this.surfaces, other.surfaces);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(WorldDragSurfacesComponent).af = function () {
    return this.surfaces;
  };
  protoOf(WorldDragSurfacesComponent).d24 = function (surfaces) {
    return new WorldDragSurfacesComponent(surfaces);
  };
  protoOf(WorldDragSurfacesComponent).copy = function (surfaces, $super) {
    surfaces = surfaces === VOID ? this.surfaces : surfaces;
    return this.d24(surfaces);
  };
  protoOf(WorldDragSurfacesComponent).toString = function () {
    return 'WorldDragSurfacesComponent(surfaces=' + toString(this.surfaces) + ')';
  };
  function Companion_35() {
    this.id = 85;
  }
  protoOf(Companion_35).s1k = function () {
    return this.id;
  };
  var Companion_instance_35;
  function Companion_getInstance_36() {
    return Companion_instance_35;
  }
  function WorldSpaceDragEventComponent(point, rayFromCameraToDragPoint) {
    this.point = point;
    this.rayFromCameraToDragPoint = rayFromCameraToDragPoint;
    this.e24_1 = 85;
    this.f24_1 = false;
  }
  protoOf(WorldSpaceDragEventComponent).g24 = function () {
    return this.point;
  };
  protoOf(WorldSpaceDragEventComponent).h24 = function () {
    return this.rayFromCameraToDragPoint;
  };
  protoOf(WorldSpaceDragEventComponent).x1k = function () {
    return this.e24_1;
  };
  protoOf(WorldSpaceDragEventComponent).eq = function (other) {
    if (!(other instanceof WorldSpaceDragEventComponent))
      return false;
    return other.point.equals(this.point) ? other.rayFromCameraToDragPoint.equals(this.rayFromCameraToDragPoint) : false;
  };
  protoOf(WorldSpaceDragEventComponent).a1l = function () {
    return this.f24_1;
  };
  protoOf(WorldSpaceDragEventComponent).af = function () {
    return this.point;
  };
  protoOf(WorldSpaceDragEventComponent).bf = function () {
    return this.rayFromCameraToDragPoint;
  };
  protoOf(WorldSpaceDragEventComponent).i24 = function (point, rayFromCameraToDragPoint) {
    return new WorldSpaceDragEventComponent(point, rayFromCameraToDragPoint);
  };
  protoOf(WorldSpaceDragEventComponent).copy = function (point, rayFromCameraToDragPoint, $super) {
    point = point === VOID ? this.point : point;
    rayFromCameraToDragPoint = rayFromCameraToDragPoint === VOID ? this.rayFromCameraToDragPoint : rayFromCameraToDragPoint;
    return this.i24(point, rayFromCameraToDragPoint);
  };
  protoOf(WorldSpaceDragEventComponent).toString = function () {
    return 'WorldSpaceDragEventComponent(point=' + this.point + ', rayFromCameraToDragPoint=' + this.rayFromCameraToDragPoint + ')';
  };
  protoOf(WorldSpaceDragEventComponent).hashCode = function () {
    var result = this.point.hashCode();
    result = imul(result, 31) + this.rayFromCameraToDragPoint.hashCode() | 0;
    return result;
  };
  protoOf(WorldSpaceDragEventComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WorldSpaceDragEventComponent))
      return false;
    var tmp0_other_with_cast = other instanceof WorldSpaceDragEventComponent ? other : THROW_CCE();
    if (!this.point.equals(tmp0_other_with_cast.point))
      return false;
    if (!this.rayFromCameraToDragPoint.equals(tmp0_other_with_cast.rayFromCameraToDragPoint))
      return false;
    return true;
  };
  function Component() {
  }
  function ComponentHolder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.j24_1 = LinkedHashMap_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = 133 + 1 | 0;
    tmp_0.k24_1 = fillArrayVal(Array(size), null);
  }
  protoOf(ComponentHolder).components = function () {
    var core = filterNotNull(this.k24_1);
    var rest = this.j24_1.p2();
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = plus_0(core, rest);
    return copyToArray(this_0);
  };
  protoOf(ComponentHolder).getComponent = function (componentId) {
    var tmp;
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      tmp = this.k24_1[componentId];
    } else {
      tmp = this.j24_1.b3(componentId);
    }
    return tmp;
  };
  protoOf(ComponentHolder).addComponent = function (c) {
    var typeId = c.typeId;
    var old = this.getComponent(typeId);
    if (old == null ? true : !old.eq(c)) {
      if (ComponentIds_instance.isCoreComponent(c)) {
        this.k24_1[typeId] = c;
      } else {
        // Inline function 'kotlin.collections.set' call
        this.j24_1.r2(typeId, c);
      }
    }
    return old;
  };
  protoOf(ComponentHolder).removeComponent = function (componentId) {
    var tmp;
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      var tmp_0;
      if (!(this.k24_1[componentId] == null)) {
        var c = ensureNotNull(this.k24_1[componentId]);
        this.k24_1[componentId] = null;
        tmp_0 = c;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    } else {
      tmp = this.j24_1.v2(componentId);
    }
    return tmp;
  };
  protoOf(ComponentHolder).__getComponentForKotlin = function (componentId) {
    return fastComponent(this, componentId);
  };
  protoOf(ComponentHolder).getComponentUnsafe = function (componentId) {
    var tmp0_elvis_lhs = this.__getComponentForKotlin(componentId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw Exception_init_$Create$('Component with id ' + componentId + ' does not exist on ' + this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ComponentHolder).hasComponent = function (componentId) {
    var tmp;
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      tmp = !(this.k24_1[componentId] == null);
    } else {
      tmp = this.j24_1.y2(componentId);
    }
    return tmp;
  };
  function ComponentListener() {
  }
  function EcsSystem() {
  }
  function System() {
  }
  function Companion_36() {
    Companion_instance_36 = this;
    this.logger = LoggerState_getInstance().m1m('Entity');
  }
  protoOf(Companion_36).x1i = function () {
    return this.logger;
  };
  var Companion_instance_36;
  function Companion_getInstance_37() {
    if (Companion_instance_36 == null)
      new Companion_36();
    return Companion_instance_36;
  }
  function Entity(id, entityManager) {
    Companion_getInstance_37();
    this.id = id;
    this.entityManager = entityManager;
  }
  protoOf(Entity).s1k = function () {
    return this.id;
  };
  protoOf(Entity).p1i = function () {
    return this.entityManager;
  };
  protoOf(Entity).m24 = function () {
    return this.components();
  };
  protoOf(Entity).n24 = function () {
    return this.entityManager.isDisposed(this);
  };
  protoOf(Entity).addComponent = function (c) {
    return this.entityManager.addComponent(this, c);
  };
  protoOf(Entity).removeComponent = function (componentId) {
    return this.entityManager.removeComponent(this, componentId);
  };
  protoOf(Entity).components = function () {
    return this.entityManager.getComponents(this);
  };
  protoOf(Entity).getComponent = function (componentId) {
    return this.entityManager.getComponent(this, componentId);
  };
  protoOf(Entity).addComponentInternal = function (c) {
    return this.entityManager.addComponentInternal(this, c);
  };
  protoOf(Entity).removeComponentInternal = function (componentId) {
    return this.entityManager.removeComponentInternal(this, componentId);
  };
  protoOf(Entity).dispose = function () {
    this.entityManager.disposeEntity(this);
  };
  protoOf(Entity).__getComponentForKotlin = function (componentId) {
    return this.entityManager.__getComponentForKotlin(this, componentId);
  };
  protoOf(Entity).getComponentUnsafe = function (componentId) {
    return this.entityManager.getComponentUnsafe(this, componentId);
  };
  protoOf(Entity).hasComponent = function (componentId) {
    return this.entityManager.hasComponent(this, componentId);
  };
  protoOf(Entity).toString = function () {
    if (this.isDisposed)
      return '' + this.id + ':-disposed-';
    var productComponent = this.__getComponentForKotlin(18);
    var tmp1_elvis_lhs = productComponent == null ? null : productComponent.productRef;
    var ref = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    var displayNameComponent = this.__getComponentForKotlin(15);
    var tmp3_elvis_lhs = displayNameComponent == null ? null : displayNameComponent.name;
    var displayName = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    return ref + ':' + this.id + ':' + displayName;
  };
  protoOf(Entity).equals = function (other) {
    var tmp;
    if (other instanceof Entity) {
      tmp = other.id === this.id;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Entity).hashCode = function () {
    return this.id;
  };
  function EntityManager() {
  }
  function validateInput($this, entity, componentId) {
    if (entity.id < 0) {
      throw IllegalArgumentException_init_$Create$('Entities are not allowed to have an id lower than 0');
    }
    if (componentId < 0) {
      throw IllegalArgumentException_init_$Create$('Components are not allowed to have an id lower than 0. ComponentId: ' + componentId);
    }
    return true;
  }
  function componentHolder($this, entityId) {
    if (entityId < 0 ? true : entityId > $this.s24_1.n()) {
      return null;
    }
    return $this.s24_1.f1(entityId);
  }
  function removeComponentHolder($this, entityId) {
    $this.s24_1.o(entityId, null);
  }
  function componentListeners($this, componentId) {
    return componentId < $this.t24_1.length ? $this.t24_1[componentId] : $this.u24_1.b3(componentId);
  }
  function growComponentsTo($this, minSize) {
    var newSize = minSize + $this.p24_1 | 0;
    $this.s24_1.i3(newSize);
    while ($this.s24_1.n() < newSize) {
      $this.s24_1.q(null);
    }
  }
  function doEntityPassSystemFilter($this, entity, system) {
    if (system == null)
      return true;
    var tmp0_elvis_lhs = system.mandatoryComponents;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return true;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var componentFilter = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = componentFilter.length;
    while (inductionVariable < last) {
      var element = componentFilter[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.doEntityPassSystemFilter.<anonymous>' call
      if (!$this.hasComponent(entity, element))
        return false;
    }
    return true;
  }
  function doEntityIgnoreSystemFilter($this, entity, system) {
    if (system == null)
      return false;
    var tmp0_elvis_lhs = system.ignoreEntitiesWithComponents;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ignoreComponentFilter = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = ignoreComponentFilter.length;
    while (inductionVariable < last) {
      var element = ignoreComponentFilter[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.doEntityIgnoreSystemFilter.<anonymous>' call
      if ($this.hasComponent(entity, element))
        return true;
    }
    return false;
  }
  function shouldSystemActOnEvent($this, entity, system) {
    if (system == null)
      return true;
    if (system.isEnabled) {
      if (doEntityIgnoreSystemFilter($this, entity, system))
        return false;
      if (doEntityPassSystemFilter($this, entity, system))
        return true;
    }
    return false;
  }
  function notifyComponentAdded($this, entity, comp) {
    var tmp0_safe_receiver = componentListeners($this, comp.typeId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentAdded.<anonymous>' call
        if (!entity.isDisposed ? shouldSystemActOnEvent($this, entity, element.ownerSystem) : false) {
          $this.d25_1.beforeNotifyOnAdd(element);
          element.onAdd(entity, comp);
          $this.d25_1.afterNotifyOnAdd(element);
        }
      }
    }
    if (ComponentIds_instance.isCoreComponentId(comp.typeId)) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = ensureNotNull($this.v24_1[comp.typeId]);
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentAdded.<anonymous>' call
        if (!entity.isDisposed)
          element_0(entity, comp);
      }
    } else {
      var tmp1_safe_receiver = $this.w24_1.b3(comp.typeId);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = tmp1_safe_receiver.length;
        while (inductionVariable_1 < last_1) {
          var element_1 = tmp1_safe_receiver[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentAdded.<anonymous>' call
          if (!entity.isDisposed)
            element_1(entity, comp);
        }
      }
    }
  }
  function notifyComponentRemoved($this, entity, comp) {
    var tmp0_safe_receiver = componentListeners($this, comp.typeId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentRemoved.<anonymous>' call
        if (!entity.isDisposed ? shouldSystemActOnEvent($this, entity, element.ownerSystem) : false) {
          $this.d25_1.beforeNotifyOnRemove(element);
          element.onRemove(entity, comp);
          $this.d25_1.afterNotifyOnRemove(element);
        }
      }
    }
    if (ComponentIds_instance.isCoreComponentId(comp.typeId)) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = ensureNotNull($this.z24_1[comp.typeId]);
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentRemoved.<anonymous>' call
        if (!entity.isDisposed)
          element_0(entity, comp);
      }
    } else {
      var tmp1_safe_receiver = $this.a25_1.b3(comp.typeId);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = tmp1_safe_receiver.length;
        while (inductionVariable_1 < last_1) {
          var element_1 = tmp1_safe_receiver[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentRemoved.<anonymous>' call
          if (!entity.isDisposed)
            element_1(entity, comp);
        }
      }
    }
  }
  function notifyComponentUpdated($this, entity, old, comp) {
    var tmp0_safe_receiver = componentListeners($this, comp.typeId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentUpdated.<anonymous>' call
        if (!entity.isDisposed ? shouldSystemActOnEvent($this, entity, element.ownerSystem) : false) {
          $this.d25_1.beforeNotifyOnUpdate(element);
          element.onUpdate(entity, old, comp);
          $this.d25_1.afterNotifyOnUpdate(element);
        }
      }
    }
    if (ComponentIds_instance.isCoreComponentId(comp.typeId)) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = ensureNotNull($this.x24_1[comp.typeId]);
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentUpdated.<anonymous>' call
        if (!entity.isDisposed)
          element_0(entity, old, comp);
      }
    } else {
      var tmp1_safe_receiver = $this.y24_1.b3(comp.typeId);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = tmp1_safe_receiver.length;
        while (inductionVariable_1 < last_1) {
          var element_1 = tmp1_safe_receiver[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentUpdated.<anonymous>' call
          if (!entity.isDisposed)
            element_1(entity, old, comp);
        }
      }
    }
  }
  function addComponentWithNotifyCallback($this, entity, component, onUpdate, onAdd) {
    validateInput($this, entity, component.typeId);
    $this.d25_1.beforeAddComponent(entity, component);
    var old = null;
    var componentHolder_0 = componentHolder($this, entity.id);
    if (!(componentHolder_0 == null)) {
      old = componentHolder_0.addComponent(component);
      if (old == null) {
        if (onAdd == null)
          null;
        else
          onAdd(entity, component);
      } else if (!old.eq(component)) {
        if (onUpdate == null)
          null;
        else
          onUpdate(entity, component, old);
      }
    } else {
      var tmp = Companion_getInstance_38().logger;
      tmp.error(EntityManagerImpl$addComponentWithNotifyCallback$lambda(component, entity));
    }
    $this.d25_1.afterAddComponent(entity, component);
    return old;
  }
  function removeFromComponentHolder($this, entity, componentId, onRemove) {
    validateInput($this, entity, componentId);
    $this.d25_1.beforeRemoveComponent(entity, componentId);
    var old = null;
    var componentHolder_0 = componentHolder($this, entity.id);
    if (!(componentHolder_0 == null)) {
      old = componentHolder_0.removeComponent(componentId);
      if (onRemove == null)
        null;
      else
        onRemove(entity, old);
    } else {
      var tmp = Companion_getInstance_38().logger;
      tmp.error(EntityManagerImpl$removeFromComponentHolder$lambda(componentId, entity));
    }
    $this.d25_1.afterRemoveComponent(entity, componentId);
    return old;
  }
  function Companion_37() {
    Companion_instance_37 = this;
    this.DEFAULT_ENTITIES_ARRAY_GROW_SIZE = 1000;
    this.logger = LoggerState_getInstance().m1m('EntityManagerImpl');
  }
  protoOf(Companion_37).e25 = function () {
    return this.DEFAULT_ENTITIES_ARRAY_GROW_SIZE;
  };
  protoOf(Companion_37).x1i = function () {
    return this.logger;
  };
  var Companion_instance_37;
  function Companion_getInstance_38() {
    if (Companion_instance_37 == null)
      new Companion_37();
    return Companion_instance_37;
  }
  function EntityManagerImpl$createEntityInternal$lambda() {
    return 'Warning: Duplicate Entity added by EntityManager.createEntity()';
  }
  function EntityManagerImpl$addComponent$lambda(this$0) {
    return function (e, c, oldComponent) {
      notifyComponentUpdated(this$0, e, oldComponent, c);
      return Unit_instance;
    };
  }
  function EntityManagerImpl$addComponent$lambda_0(this$0) {
    return function (e, c) {
      notifyComponentAdded(this$0, e, c);
      return Unit_instance;
    };
  }
  function EntityManagerImpl$addComponentWithNotifyCallback$lambda($component, $entity) {
    return function () {
      return "Can't add component (id: " + $component.typeId + ') to a disposed entity (id: ' + $entity.id + ')';
    };
  }
  function EntityManagerImpl$removeComponent$lambda(this$0) {
    return function (e, oldComponent) {
      if (oldComponent == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        notifyComponentRemoved(this$0, e, oldComponent);
      }
      return Unit_instance;
    };
  }
  function EntityManagerImpl$removeFromComponentHolder$lambda($componentId, $entity) {
    return function () {
      return 'Trying to remove component with componentId ' + $componentId + ' from entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
    };
  }
  function EntityManagerImpl$getComponents$lambda($entity) {
    return function () {
      return 'Trying to get components of entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
    };
  }
  function EntityManagerImpl$getUncastComponent$lambda($componentId, $entity) {
    return function () {
      return 'Trying to get component with componentId ' + $componentId + ' of entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
    };
  }
  function EntityManagerImpl$getComponent$lambda($componentId, $entity) {
    return function () {
      return 'Trying to get component with componentId ' + $componentId + ' of entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
    };
  }
  function EntityManagerImpl$hasComponent$lambda($entity, $componentId) {
    return function () {
      return 'Trying to check if entity ' + $entity.id + ' has a component with componentId ' + $componentId + ", but the entity doesn't exist in the EntityManager";
    };
  }
  function EntityManagerImpl$registerSystem$lambda($system) {
    return function () {
      return $system.id + ' is already registered';
    };
  }
  function EntityManagerImpl(entitiesArrayGrowSize) {
    Companion_getInstance_38();
    entitiesArrayGrowSize = entitiesArrayGrowSize === VOID ? 1000 : entitiesArrayGrowSize;
    this.p24_1 = entitiesArrayGrowSize;
    this.q24_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.r24_1 = LinkedHashSet_init_$Create$();
    this.s24_1 = ArrayList_init_$Create$_0(this.p24_1);
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = 133 + 1 | 0;
    tmp_0.t24_1 = fillArrayVal(Array(size), null);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.u24_1 = LinkedHashMap_init_$Create$_0();
    var tmp_2 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_0 = 133 + 1 | 0;
    tmp_2.v24_1 = fillArrayVal(Array(size_0), null);
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.w24_1 = LinkedHashMap_init_$Create$_0();
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_1 = 133 + 1 | 0;
    tmp_4.x24_1 = fillArrayVal(Array(size_1), null);
    var tmp_5 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_5.y24_1 = LinkedHashMap_init_$Create$_0();
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_2 = 133 + 1 | 0;
    tmp_6.z24_1 = fillArrayVal(Array(size_2), null);
    var tmp_7 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_7.a25_1 = LinkedHashMap_init_$Create$_0();
    var tmp_8 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_8.b25_1 = [];
    var tmp_9 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_9.c25_1 = [];
    this.d25_1 = new EntityManagerWatcherList();
    var inductionVariable = 0;
    if (inductionVariable <= 133)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$11 = [];
        this.v24_1[i] = tmp$ret$11;
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$12 = [];
        this.x24_1[i] = tmp$ret$12;
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$13 = [];
        this.z24_1[i] = tmp$ret$13;
      }
       while (!(i === 133));
  }
  protoOf(EntityManagerImpl).o24 = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.r24_1;
    return copyToArray(this_0);
  };
  protoOf(EntityManagerImpl).getNextId = function () {
    this.q24_1 = this.q24_1 + 1 | 0;
    return this.q24_1;
  };
  protoOf(EntityManagerImpl).allListeners = function () {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var map = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = this.t24_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.allListeners.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      if ((item == null ? null : any(item)) === true) {
        // Inline function 'kotlin.collections.set' call
        map.r2(tmp1, item);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.u24_1.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.allListeners.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var key = element.t2();
      var value = element.u2();
      map.r2(key, value);
    }
    return map;
  };
  protoOf(EntityManagerImpl).createEntity = function () {
    return this.createEntityInternal(this.getNextId());
  };
  protoOf(EntityManagerImpl).createEntityInternal = function (entityId) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var b = this.q24_1;
    tmp.q24_1 = Math.max(entityId, b);
    if (entityId >= this.s24_1.n()) {
      growComponentsTo(this, entityId);
    }
    var entity = this.createEntityObject(entityId);
    if (!this.r24_1.q(entity)) {
      var tmp_0 = Companion_getInstance_38().logger;
      tmp_0.error(EntityManagerImpl$createEntityInternal$lambda);
      throw IllegalArgumentException_init_$Create$('Entity with id ' + entityId + ' already exists.');
    }
    this.s24_1.o(entityId, new ComponentHolder());
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.b25_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.createEntityInternal.<anonymous>' call
      element(entity);
    }
    return entity;
  };
  protoOf(EntityManagerImpl).createEntityObject = function (uniqueId) {
    return new Entity(uniqueId, this);
  };
  protoOf(EntityManagerImpl).disposeEntity = function (entity) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.getComponents(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.disposeEntity.<anonymous>' call
      notifyComponentRemoved(this, entity, element);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = this.c25_1;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.disposeEntity.<anonymous>' call
      element_0(entity);
    }
    this.removeEntityInternal(entity);
  };
  protoOf(EntityManagerImpl).removeEntityInternal = function (entity) {
    this.r24_1.r(entity);
    removeComponentHolder(this, entity.id);
  };
  protoOf(EntityManagerImpl).findEntity = function (entityId) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.r24_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.findEntity.<anonymous>' call
        if (element.id === entityId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(EntityManagerImpl).addComponent = function (entity, component) {
    var tmp = EntityManagerImpl$addComponent$lambda(this);
    return addComponentWithNotifyCallback(this, entity, component, tmp, EntityManagerImpl$addComponent$lambda_0(this));
  };
  protoOf(EntityManagerImpl).addComponentInternal = function (entity, c) {
    return addComponentWithNotifyCallback(this, entity, c, null, null);
  };
  protoOf(EntityManagerImpl).removeComponent = function (entity, componentId) {
    return removeFromComponentHolder(this, entity, componentId, EntityManagerImpl$removeComponent$lambda(this));
  };
  protoOf(EntityManagerImpl).removeComponentInternal = function (entity, componentId) {
    return removeFromComponentHolder(this, entity, componentId, null);
  };
  protoOf(EntityManagerImpl).getComponents = function (entity) {
    var componentHolder_0 = componentHolder(this, entity.id);
    if (componentHolder_0 == null) {
      var tmp = Companion_getInstance_38().logger;
      tmp.error(EntityManagerImpl$getComponents$lambda(entity));
    }
    var tmp1_elvis_lhs = componentHolder_0 == null ? null : componentHolder_0.components();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(EntityManagerImpl).getComponent = function (entity, componentId) {
    validateInput(this, entity, componentId);
    var componentHolder_0 = componentHolder(this, entity.id);
    if (componentHolder_0 == null) {
      var tmp = Companion_getInstance_38().logger;
      tmp.error(EntityManagerImpl$getUncastComponent$lambda(componentId, entity));
    }
    return componentHolder_0 == null ? null : componentHolder_0.getComponent(componentId);
  };
  protoOf(EntityManagerImpl).__getComponentForKotlin = function (entity, componentId) {
    validateInput(this, entity, componentId);
    var componentHolder_0 = componentHolder(this, entity.id);
    if (componentHolder_0 == null) {
      var tmp = Companion_getInstance_38().logger;
      tmp.error(EntityManagerImpl$getComponent$lambda(componentId, entity));
    }
    var tmp_0;
    if (componentHolder_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getComponent.<anonymous>' call
      tmp_0 = fastComponent(componentHolder_0, componentId);
    }
    return tmp_0;
  };
  protoOf(EntityManagerImpl).getComponentUnsafe = function (entity, componentId) {
    var tmp0_elvis_lhs = this.__getComponentForKotlin(entity, componentId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw Exception_init_$Create$('Component with id ' + componentId + ' does not exist on ' + this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(EntityManagerImpl).hasComponent = function (entity, componentId) {
    validateInput(this, entity, componentId);
    var componentHolder_0 = componentHolder(this, entity.id);
    if (componentHolder_0 == null) {
      var tmp = Companion_getInstance_38().logger;
      tmp.error(EntityManagerImpl$hasComponent$lambda(entity, componentId));
    }
    var tmp1_elvis_lhs = componentHolder_0 == null ? null : componentHolder_0.hasComponent(componentId);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(EntityManagerImpl).isDisposed = function (entity) {
    return componentHolder(this, entity.id) == null;
  };
  protoOf(EntityManagerImpl).subscribeAdd = function (componentId, listener) {
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      // Inline function 'kotlin.collections.plus' call
      var this_0 = ensureNotNull(this.v24_1[componentId]);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [typeof listener === 'function' ? listener : THROW_CCE()];
      var tmp$ret$4 = this_0.concat(tmp$ret$3);
      this.v24_1[componentId] = tmp$ret$4;
    } else {
      var list = this.w24_1.b3(componentId);
      var tmp0_safe_receiver = list;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [typeof listener === 'function' ? listener : THROW_CCE()];
        tmp = tmp0_safe_receiver.concat(tmp$ret$8);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [typeof listener === 'function' ? listener : THROW_CCE()];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      list = tmp_0;
      // Inline function 'kotlin.collections.set' call
      var this_1 = this.w24_1;
      var value = list;
      this_1.r2(componentId, value);
    }
    return listener;
  };
  protoOf(EntityManagerImpl).unsubscribeAdd = function (componentId, listener) {
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = ensureNotNull(this.v24_1[componentId]);
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeAdd.<anonymous>' call
        if (!equals(element, listener)) {
          destination.q(element);
        }
      }
      var tmp$ret$3 = copyToArray(destination);
      this.v24_1[componentId] = tmp$ret$3;
    } else {
      var tmp0_safe_receiver = this.w24_1.b3(componentId);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var this_1 = this.w24_1;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = tmp0_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp0_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeAdd.<anonymous>.<anonymous>' call
          if (!equals(element_0, listener)) {
            destination_0.q(element_0);
          }
        }
        var value = copyToArray(destination_0);
        this_1.r2(componentId, value);
      }
    }
  };
  protoOf(EntityManagerImpl).subscribeUpdate = function (componentId, listener) {
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      // Inline function 'kotlin.collections.plus' call
      var this_0 = ensureNotNull(this.x24_1[componentId]);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [typeof listener === 'function' ? listener : THROW_CCE()];
      var tmp$ret$4 = this_0.concat(tmp$ret$3);
      this.x24_1[componentId] = tmp$ret$4;
    } else {
      var list = this.y24_1.b3(componentId);
      var tmp0_safe_receiver = list;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [typeof listener === 'function' ? listener : THROW_CCE()];
        tmp = tmp0_safe_receiver.concat(tmp$ret$8);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [typeof listener === 'function' ? listener : THROW_CCE()];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      list = tmp_0;
      // Inline function 'kotlin.collections.set' call
      var this_1 = this.y24_1;
      var value = list;
      this_1.r2(componentId, value);
    }
    return listener;
  };
  protoOf(EntityManagerImpl).unsubscribeUpdate = function (componentId, listener) {
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = ensureNotNull(this.x24_1[componentId]);
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeUpdate.<anonymous>' call
        if (!equals(element, listener)) {
          destination.q(element);
        }
      }
      var tmp$ret$3 = copyToArray(destination);
      this.x24_1[componentId] = tmp$ret$3;
    } else {
      var tmp0_safe_receiver = this.y24_1.b3(componentId);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var this_1 = this.y24_1;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = tmp0_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp0_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeUpdate.<anonymous>.<anonymous>' call
          if (!equals(element_0, listener)) {
            destination_0.q(element_0);
          }
        }
        var value = copyToArray(destination_0);
        this_1.r2(componentId, value);
      }
    }
  };
  protoOf(EntityManagerImpl).subscribeRemove = function (componentId, listener) {
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      // Inline function 'kotlin.collections.plus' call
      var this_0 = ensureNotNull(this.z24_1[componentId]);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [typeof listener === 'function' ? listener : THROW_CCE()];
      var tmp$ret$4 = this_0.concat(tmp$ret$3);
      this.z24_1[componentId] = tmp$ret$4;
    } else {
      var list = this.a25_1.b3(componentId);
      var tmp0_safe_receiver = list;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [typeof listener === 'function' ? listener : THROW_CCE()];
        tmp = tmp0_safe_receiver.concat(tmp$ret$8);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [typeof listener === 'function' ? listener : THROW_CCE()];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      list = tmp_0;
      // Inline function 'kotlin.collections.set' call
      var this_1 = this.a25_1;
      var value = list;
      this_1.r2(componentId, value);
    }
    return listener;
  };
  protoOf(EntityManagerImpl).unsubscribeRemove = function (componentId, listener) {
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = ensureNotNull(this.z24_1[componentId]);
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeRemove.<anonymous>' call
        if (!equals(element, listener)) {
          destination.q(element);
        }
      }
      var tmp$ret$3 = copyToArray(destination);
      this.z24_1[componentId] = tmp$ret$3;
    } else {
      var tmp0_safe_receiver = this.a25_1.b3(componentId);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var this_1 = this.a25_1;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = tmp0_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp0_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeRemove.<anonymous>.<anonymous>' call
          if (!equals(element_0, listener)) {
            destination_0.q(element_0);
          }
        }
        var value = copyToArray(destination_0);
        this_1.r2(componentId, value);
      }
    }
  };
  protoOf(EntityManagerImpl).subscribeEntityCreated = function (listener) {
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.b25_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [listener];
    tmp.b25_1 = tmp$ret$0.concat(tmp$ret$3);
  };
  protoOf(EntityManagerImpl).unsubscribeEntityCreated = function (listener) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.b25_1;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeEntityCreated.<anonymous>' call
      if (!equals(element, listener)) {
        destination.q(element);
      }
    }
    tmp.b25_1 = copyToArray(destination);
  };
  protoOf(EntityManagerImpl).subscribeEntityRemoved = function (listener) {
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.c25_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [listener];
    tmp.c25_1 = tmp$ret$0.concat(tmp$ret$3);
  };
  protoOf(EntityManagerImpl).unsubscribeEntityRemoved = function (listener) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.c25_1;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeEntityRemoved.<anonymous>' call
      if (!equals(element, listener)) {
        destination.q(element);
      }
    }
    tmp.c25_1 = copyToArray(destination);
  };
  protoOf(EntityManagerImpl).removeAllComponents = function (entity) {
    var components = this.getComponents(entity);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = components.length;
    while (inductionVariable < last) {
      var element = components[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.removeAllComponents.<anonymous>' call
      notifyComponentRemoved(this, entity, element);
    }
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = components.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = components[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.removeAllComponents.<anonymous>' call
      this.removeComponentInternal(entity, element_0.typeId);
    }
    return components;
  };
  protoOf(EntityManagerImpl).registerSystem = function (system) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.getSystemsRegistered();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.registerSystem.<anonymous>' call
        if (equals(element, system)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    if (tmp$ret$1) {
      var tmp = Companion_getInstance_38().logger;
      tmp.warn(EntityManagerImpl$registerSystem$lambda(system));
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = system.componentListeners;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.registerSystem.<anonymous>' call
      if (element_0.componentId < this.t24_1.length) {
        if (this.t24_1[element_0.componentId] == null) {
          var tmp_0 = element_0.componentId;
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$4 = [element_0];
          this.t24_1[tmp_0] = tmp$ret$4;
        } else {
          var tmp_1 = element_0.componentId;
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$5 = ensureNotNull(this.t24_1[element_0.componentId]);
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$8 = [element_0];
          var tmp$ret$9 = tmp$ret$5.concat(tmp$ret$8);
          this.t24_1[tmp_1] = tmp$ret$9;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var sorted = SystemGraphHelper_getInstance().sortListeners(ensureNotNull(this.t24_1[element_0.componentId]));
          this.t24_1[element_0.componentId] = sorted;
        }
      } else {
        if (!this.u24_1.y2(element_0.componentId)) {
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.u24_1;
          var key = element_0.componentId;
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var value = [element_0];
          this_0.r2(key, value);
        } else {
          // Inline function 'kotlin.collections.set' call
          var this_1 = this.u24_1;
          var key_0 = element_0.componentId;
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$14 = ensureNotNull(this.u24_1.b3(element_0.componentId));
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$17 = [element_0];
          var value_0 = tmp$ret$14.concat(tmp$ret$17);
          this_1.r2(key_0, value_0);
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var sorted_0 = SystemGraphHelper_getInstance().sortListeners(ensureNotNull(this.u24_1.b3(element_0.componentId)));
          var this_2 = this.u24_1;
          var key_1 = element_0.componentId;
          this_2.r2(key_1, sorted_0);
        }
      }
    }
    system.onRegister();
  };
  protoOf(EntityManagerImpl).unregisterSystem = function (system) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = system.componentListeners;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unregisterSystem.<anonymous>' call
      if (element.componentId < this.t24_1.length) {
        if (!(this.t24_1[element.componentId] == null)) {
          var tmp = element.componentId;
          // Inline function 'kotlin.collections.toTypedArray' call
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var this_0 = ensureNotNull(this.t24_1[element.componentId]);
          var destination = ArrayList_init_$Create$();
          var inductionVariable_0 = 0;
          var last_0 = this_0.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = this_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unregisterSystem.<anonymous>.<anonymous>' call
            if (!equals(element_0, element)) {
              destination.q(element_0);
            }
          }
          var tmp$ret$3 = copyToArray(destination);
          this.t24_1[tmp] = tmp$ret$3;
        }
      } else {
        if (this.u24_1.y2(element.componentId)) {
          // Inline function 'kotlin.collections.set' call
          var this_1 = this.u24_1;
          var key = element.componentId;
          // Inline function 'kotlin.collections.toTypedArray' call
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var this_2 = ensureNotNull(this.u24_1.b3(element.componentId));
          var destination_0 = ArrayList_init_$Create$();
          var inductionVariable_1 = 0;
          var last_1 = this_2.length;
          while (inductionVariable_1 < last_1) {
            var element_1 = this_2[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unregisterSystem.<anonymous>.<anonymous>' call
            if (!equals(element_1, element)) {
              destination_0.q(element_1);
            }
          }
          var value = copyToArray(destination_0);
          this_1.r2(key, value);
        }
      }
    }
    system.onUnregister();
  };
  protoOf(EntityManagerImpl).getSystem = function (systemId) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.getSystemsRegistered();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystem.<anonymous>' call
        if (element.id === systemId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(EntityManagerImpl).getSystemsRegisteredForComponent = function (componentId) {
    var tmp0_elvis_lhs = componentListeners(this, componentId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listeners = tmp;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = listeners.length;
    while (inductionVariable < last) {
      var element = listeners[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegisteredForComponent.<anonymous>' call
      var tmp0_safe_receiver = element.ownerSystem;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    var systems = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(systems);
  };
  protoOf(EntityManagerImpl).getSystemsRegistered = function () {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var all = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.t24_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>' call
      if (element == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = element.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = element[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver = element_0.ownerSystem;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            all.q(tmp0_safe_receiver);
          }
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.u24_1.q2().t();
    while (tmp0_iterator.u()) {
      var element_1 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_0 = element_1.u2();
      var inductionVariable_1 = 0;
      var last_1 = indexedObject_0.length;
      while (inductionVariable_1 < last_1) {
        var element_2 = indexedObject_0[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = element_2.ownerSystem;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          all.q(tmp0_safe_receiver_0);
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(all);
  };
  protoOf(EntityManagerImpl).anonymousListenersCountForAddComponent = function (componentId) {
    var tmp;
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      var tmp0_safe_receiver = this.v24_1[componentId];
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.length;
      tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    } else {
      var tmp2_safe_receiver = this.w24_1.b3(componentId);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.length;
      tmp = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    }
    return tmp;
  };
  protoOf(EntityManagerImpl).anonymousListenersCountForUpdateComponent = function (componentId) {
    var tmp;
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      var tmp0_safe_receiver = this.x24_1[componentId];
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.length;
      tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    } else {
      var tmp2_safe_receiver = this.y24_1.b3(componentId);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.length;
      tmp = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    }
    return tmp;
  };
  protoOf(EntityManagerImpl).anonymousListenersCountForRemoveComponent = function (componentId) {
    var tmp;
    if (ComponentIds_instance.isCoreComponentId(componentId)) {
      var tmp0_safe_receiver = this.z24_1[componentId];
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.length;
      tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    } else {
      var tmp2_safe_receiver = this.a25_1.b3(componentId);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.length;
      tmp = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    }
    return tmp;
  };
  protoOf(EntityManagerImpl).addWatcher = function (watcher) {
    this.d25_1.g25(watcher);
  };
  protoOf(EntityManagerImpl).removeWatcher = function (watcher) {
    this.d25_1.h25(watcher);
  };
  function EntityManagerWatcher() {
  }
  function EntityManagerWatcherList() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.f25_1 = ArrayList_init_$Create$();
  }
  protoOf(EntityManagerWatcherList).n = function () {
    return this.f25_1.n();
  };
  protoOf(EntityManagerWatcherList).g25 = function (element) {
    return this.f25_1.q(element);
  };
  protoOf(EntityManagerWatcherList).q = function (element) {
    return this.g25((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).i25 = function (index, element) {
    this.f25_1.w1(index, element);
  };
  protoOf(EntityManagerWatcherList).w1 = function (index, element) {
    return this.i25(index, (!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).j25 = function (index, elements) {
    return this.f25_1.y1(index, elements);
  };
  protoOf(EntityManagerWatcherList).y1 = function (index, elements) {
    return this.j25(index, elements);
  };
  protoOf(EntityManagerWatcherList).k25 = function (elements) {
    return this.f25_1.x(elements);
  };
  protoOf(EntityManagerWatcherList).x = function (elements) {
    return this.k25(elements);
  };
  protoOf(EntityManagerWatcherList).z = function () {
    this.f25_1.z();
  };
  protoOf(EntityManagerWatcherList).l25 = function (element) {
    return this.f25_1.p(element);
  };
  protoOf(EntityManagerWatcherList).p = function (element) {
    if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
      return false;
    return this.l25((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).m25 = function (elements) {
    return this.f25_1.a1(elements);
  };
  protoOf(EntityManagerWatcherList).a1 = function (elements) {
    return this.m25(elements);
  };
  protoOf(EntityManagerWatcherList).f1 = function (index) {
    return this.f25_1.f1(index);
  };
  protoOf(EntityManagerWatcherList).n25 = function (element) {
    return this.f25_1.a2(element);
  };
  protoOf(EntityManagerWatcherList).a2 = function (element) {
    if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
      return -1;
    return this.n25((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).b1 = function () {
    return this.f25_1.b1();
  };
  protoOf(EntityManagerWatcherList).t = function () {
    return this.f25_1.t();
  };
  protoOf(EntityManagerWatcherList).o25 = function (element) {
    return this.f25_1.b2(element);
  };
  protoOf(EntityManagerWatcherList).b2 = function (element) {
    if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
      return -1;
    return this.o25((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).c2 = function () {
    return this.f25_1.c2();
  };
  protoOf(EntityManagerWatcherList).d2 = function (index) {
    return this.f25_1.d2(index);
  };
  protoOf(EntityManagerWatcherList).h25 = function (element) {
    return this.f25_1.r(element);
  };
  protoOf(EntityManagerWatcherList).r = function (element) {
    if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
      return false;
    return this.h25((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).p25 = function (elements) {
    return this.f25_1.y(elements);
  };
  protoOf(EntityManagerWatcherList).y = function (elements) {
    return this.p25(elements);
  };
  protoOf(EntityManagerWatcherList).h1 = function (index) {
    return this.f25_1.h1(index);
  };
  protoOf(EntityManagerWatcherList).q25 = function (elements) {
    return this.f25_1.z1(elements);
  };
  protoOf(EntityManagerWatcherList).z1 = function (elements) {
    return this.q25(elements);
  };
  protoOf(EntityManagerWatcherList).r25 = function (index, element) {
    return this.f25_1.o(index, element);
  };
  protoOf(EntityManagerWatcherList).o = function (index, element) {
    return this.r25(index, (!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
  };
  protoOf(EntityManagerWatcherList).e2 = function (fromIndex, toIndex) {
    return this.f25_1.e2(fromIndex, toIndex);
  };
  protoOf(EntityManagerWatcherList).beforeAddComponent = function (entity, component) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeAddComponent.<anonymous>' call
      element.beforeAddComponent(entity, component);
    }
  };
  protoOf(EntityManagerWatcherList).afterAddComponent = function (entity, component) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterAddComponent.<anonymous>' call
      element.afterAddComponent(entity, component);
    }
  };
  protoOf(EntityManagerWatcherList).beforeRemoveComponent = function (entity, componentId) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeRemoveComponent.<anonymous>' call
      element.beforeRemoveComponent(entity, componentId);
    }
  };
  protoOf(EntityManagerWatcherList).afterRemoveComponent = function (entity, componentId) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterRemoveComponent.<anonymous>' call
      element.afterRemoveComponent(entity, componentId);
    }
  };
  protoOf(EntityManagerWatcherList).beforeNotifyOnAdd = function (componentListener) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeNotifyOnAdd.<anonymous>' call
      element.beforeNotifyOnAdd(componentListener);
    }
  };
  protoOf(EntityManagerWatcherList).afterNotifyOnAdd = function (componentListener) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterNotifyOnAdd.<anonymous>' call
      element.afterNotifyOnAdd(componentListener);
    }
  };
  protoOf(EntityManagerWatcherList).beforeNotifyOnUpdate = function (componentListener) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeNotifyOnUpdate.<anonymous>' call
      element.beforeNotifyOnUpdate(componentListener);
    }
  };
  protoOf(EntityManagerWatcherList).afterNotifyOnUpdate = function (componentListener) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterNotifyOnUpdate.<anonymous>' call
      element.afterNotifyOnUpdate(componentListener);
    }
  };
  protoOf(EntityManagerWatcherList).beforeNotifyOnRemove = function (componentListener) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeNotifyOnRemove.<anonymous>' call
      element.beforeNotifyOnRemove(componentListener);
    }
  };
  protoOf(EntityManagerWatcherList).afterNotifyOnRemove = function (componentListener) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterNotifyOnRemove.<anonymous>' call
      element.afterNotifyOnRemove(componentListener);
    }
  };
  function EcsSystemImpl() {
    this.c1p_1 = true;
  }
  protoOf(EcsSystemImpl).y1n = function () {
    return this.c1p_1;
  };
  protoOf(EcsSystemImpl).enable = function () {
    this.c1p_1 = true;
  };
  protoOf(EcsSystemImpl).disable = function () {
    this.c1p_1 = false;
  };
  protoOf(EcsSystemImpl).register = function (entityManager) {
    entityManager.registerSystem(this);
  };
  protoOf(EcsSystemImpl).unregister = function (entityManager) {
    entityManager.unregisterSystem(this);
  };
  protoOf(EcsSystemImpl).onRegister = function () {
  };
  protoOf(EcsSystemImpl).onUnregister = function () {
  };
  function ComponentListenerImpl(ownerSystem, componentId, onComponentAddedRef, onComponentUpdatedRef, onComponentRemovedRef) {
    this.s25_1 = ownerSystem;
    this.t25_1 = componentId;
    this.u25_1 = onComponentAddedRef;
    this.v25_1 = onComponentUpdatedRef;
    this.w25_1 = onComponentRemovedRef;
  }
  protoOf(ComponentListenerImpl).l24 = function () {
    return this.s25_1;
  };
  protoOf(ComponentListenerImpl).v1o = function () {
    return this.t25_1;
  };
  protoOf(ComponentListenerImpl).onAdd = function (entity, newComponent) {
    this.u25_1(entity, unsafeCast(newComponent));
  };
  protoOf(ComponentListenerImpl).onUpdate = function (entity, oldComponent, newComponent) {
    this.v25_1(entity, unsafeCast(oldComponent), unsafeCast(newComponent));
  };
  protoOf(ComponentListenerImpl).onRemove = function (entity, oldComponent) {
    this.w25_1(entity, unsafeCast(oldComponent));
  };
  function Companion_38() {
    Companion_instance_38 = this;
    this.logger = LoggerState_getInstance().m1m('SystemBase');
  }
  protoOf(Companion_38).x1i = function () {
    return this.logger;
  };
  var Companion_instance_38;
  function Companion_getInstance_39() {
    if (Companion_instance_38 == null)
      new Companion_38();
    return Companion_instance_38;
  }
  function SystemBase$onAddComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent';
    return l;
  }
  function SystemBase$onUpdateComponent$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent';
    return l;
  }
  function SystemBase$onRemoveComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent';
    return l;
  }
  function SystemBase$printDependencies$lambda(this$0) {
    return function () {
      return this$0.id;
    };
  }
  function SystemBase$printDependencies$lambda_0(this$0) {
    return function () {
      return ' listens to: ' + this$0.componentId;
    };
  }
  function SystemBase$printDependencies$lambda_1(this$0) {
    return function () {
      return ' changes:   ' + joinToString_0(this$0.doingChangesOnComponent, ', ');
    };
  }
  function SystemBase$printDependencies$lambda_2($before) {
    return function () {
      return ' before me: ' + joinToString_0($before, ', ');
    };
  }
  function SystemBase$printDependencies$lambda_3($before) {
    return function () {
      return ' after me:  ' + joinToString_0($before, ', ');
    };
  }
  function SystemBase(id, componentId, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe, mandatoryComponents, ignoreEntitiesWithComponents) {
    Companion_getInstance_39();
    var tmp;
    if (doingChangesOnComponent === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = doingChangesOnComponent;
    }
    doingChangesOnComponent = tmp;
    systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
    systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
    mandatoryComponents = mandatoryComponents === VOID ? null : mandatoryComponents;
    ignoreEntitiesWithComponents = ignoreEntitiesWithComponents === VOID ? null : ignoreEntitiesWithComponents;
    EcsSystemImpl.call(this);
    this.o1o_1 = id;
    this.componentId = componentId;
    this.p1o_1 = doingChangesOnComponent;
    this.q1o_1 = systemsBeforeMe;
    this.r1o_1 = systemsAfterMe;
    this.s1o_1 = mandatoryComponents;
    this.t1o_1 = ignoreEntitiesWithComponents;
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.u1o_1 = [];
  }
  protoOf(SystemBase).s1k = function () {
    return this.o1o_1;
  };
  protoOf(SystemBase).v1o = function () {
    return this.componentId;
  };
  protoOf(SystemBase).w1o = function () {
    return this.p1o_1;
  };
  protoOf(SystemBase).x1o = function () {
    return this.q1o_1;
  };
  protoOf(SystemBase).y1o = function () {
    return this.r1o_1;
  };
  protoOf(SystemBase).z1o = function () {
    return this.s1o_1;
  };
  protoOf(SystemBase).a1p = function () {
    return this.t1o_1;
  };
  protoOf(SystemBase).onAddComponent = function (entity, newComponent) {
  };
  protoOf(SystemBase).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(SystemBase).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(SystemBase).b1p = function () {
    // Inline function 'kotlin.collections.isEmpty' call
    if (this.u1o_1.length === 0) {
      this.u1o_1 = this.createComponentListeners();
    }
    return this.u1o_1;
  };
  protoOf(SystemBase).createComponentListeners = function () {
    // Inline function 'kotlin.arrayOf' call
    var tmp = SystemBase$onAddComponent$ref(this);
    var tmp_0 = SystemBase$onUpdateComponent$ref(this);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new ComponentListenerImpl(this, this.componentId, tmp, tmp_0, SystemBase$onRemoveComponent$ref(this))];
  };
  protoOf(SystemBase).printDependencies = function () {
    var tmp = Companion_getInstance_39().logger;
    tmp.info(SystemBase$printDependencies$lambda(this));
    var tmp_0 = Companion_getInstance_39().logger;
    tmp_0.info(SystemBase$printDependencies$lambda_0(this));
    var tmp_1 = Companion_getInstance_39().logger;
    tmp_1.info(SystemBase$printDependencies$lambda_1(this));
    var tmp0_safe_receiver = this.systemsBeforeMe;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_2 = Companion_getInstance_39().logger;
      tmp_2.info(SystemBase$printDependencies$lambda_2(tmp0_safe_receiver));
    }
    var tmp1_safe_receiver = this.systemsAfterMe;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_3 = Companion_getInstance_39().logger;
      tmp_3.info(SystemBase$printDependencies$lambda_3(tmp1_safe_receiver));
    }
  };
  function SystemBase2$onAddComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent';
    return l;
  }
  function SystemBase2$onUpdateComponent$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent';
    return l;
  }
  function SystemBase2$onRemoveComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent';
    return l;
  }
  function SystemBase2$onAddComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent2';
    return l;
  }
  function SystemBase2$onUpdateComponent2$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent2(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent2';
    return l;
  }
  function SystemBase2$onRemoveComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent2';
    return l;
  }
  function SystemBase2(id, component1Id, component2Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
    var tmp;
    if (doingChangesOnComponent === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = doingChangesOnComponent;
    }
    doingChangesOnComponent = tmp;
    systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
    systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
    SystemBase.call(this, id, component1Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
    this.component1Id = component1Id;
    this.component2Id = component2Id;
  }
  protoOf(SystemBase2).l1o = function () {
    return this.component1Id;
  };
  protoOf(SystemBase2).m1o = function () {
    return this.component2Id;
  };
  protoOf(SystemBase2).onAddComponent2 = function (entity, newComponent) {
  };
  protoOf(SystemBase2).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(SystemBase2).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(SystemBase2).createComponentListeners = function () {
    // Inline function 'kotlin.arrayOf' call
    var tmp = SystemBase2$onAddComponent$ref(this);
    var tmp_0 = SystemBase2$onUpdateComponent$ref(this);
    var tmp_1 = new ComponentListenerImpl(this, this.component1Id, tmp, tmp_0, SystemBase2$onRemoveComponent$ref(this));
    var tmp_2 = SystemBase2$onAddComponent2$ref(this);
    var tmp_3 = SystemBase2$onUpdateComponent2$ref(this);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp_1, new ComponentListenerImpl(this, this.component2Id, tmp_2, tmp_3, SystemBase2$onRemoveComponent2$ref(this))];
  };
  function SystemBase3$onAddComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent';
    return l;
  }
  function SystemBase3$onUpdateComponent$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent';
    return l;
  }
  function SystemBase3$onRemoveComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent';
    return l;
  }
  function SystemBase3$onAddComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent2';
    return l;
  }
  function SystemBase3$onUpdateComponent2$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent2(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent2';
    return l;
  }
  function SystemBase3$onRemoveComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent2';
    return l;
  }
  function SystemBase3$onAddComponent3$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent3(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent3';
    return l;
  }
  function SystemBase3$onUpdateComponent3$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent3(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent3';
    return l;
  }
  function SystemBase3$onRemoveComponent3$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent3(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent3';
    return l;
  }
  function SystemBase3(id, component1Id, component2Id, component3Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
    var tmp;
    if (doingChangesOnComponent === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = doingChangesOnComponent;
    }
    doingChangesOnComponent = tmp;
    systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
    systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
    SystemBase2.call(this, id, component1Id, component2Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
    this.component3Id = component3Id;
  }
  protoOf(SystemBase3).f26 = function () {
    return this.component3Id;
  };
  protoOf(SystemBase3).onAddComponent3 = function (entity, newComponent) {
  };
  protoOf(SystemBase3).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(SystemBase3).onRemoveComponent3 = function (entity, oldComponent) {
  };
  protoOf(SystemBase3).createComponentListeners = function () {
    // Inline function 'kotlin.arrayOf' call
    var tmp = SystemBase3$onAddComponent$ref(this);
    var tmp_0 = SystemBase3$onUpdateComponent$ref(this);
    var tmp_1 = new ComponentListenerImpl(this, this.component1Id, tmp, tmp_0, SystemBase3$onRemoveComponent$ref(this));
    var tmp_2 = SystemBase3$onAddComponent2$ref(this);
    var tmp_3 = SystemBase3$onUpdateComponent2$ref(this);
    var tmp_4 = new ComponentListenerImpl(this, this.component2Id, tmp_2, tmp_3, SystemBase3$onRemoveComponent2$ref(this));
    var tmp_5 = SystemBase3$onAddComponent3$ref(this);
    var tmp_6 = SystemBase3$onUpdateComponent3$ref(this);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp_1, tmp_4, new ComponentListenerImpl(this, this.component3Id, tmp_5, tmp_6, SystemBase3$onRemoveComponent3$ref(this))];
  };
  function SystemBase4$onAddComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent';
    return l;
  }
  function SystemBase4$onUpdateComponent$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent';
    return l;
  }
  function SystemBase4$onRemoveComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent';
    return l;
  }
  function SystemBase4$onAddComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent2';
    return l;
  }
  function SystemBase4$onUpdateComponent2$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent2(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent2';
    return l;
  }
  function SystemBase4$onRemoveComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent2';
    return l;
  }
  function SystemBase4$onAddComponent3$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent3(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent3';
    return l;
  }
  function SystemBase4$onUpdateComponent3$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent3(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent3';
    return l;
  }
  function SystemBase4$onRemoveComponent3$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent3(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent3';
    return l;
  }
  function SystemBase4$onAddComponent4$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent4(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent4';
    return l;
  }
  function SystemBase4$onUpdateComponent4$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent4(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent4';
    return l;
  }
  function SystemBase4$onRemoveComponent4$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent4(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent4';
    return l;
  }
  function SystemBase4(id, component1Id, component2Id, component3Id, component4Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
    var tmp;
    if (doingChangesOnComponent === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = doingChangesOnComponent;
    }
    doingChangesOnComponent = tmp;
    systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
    systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
    SystemBase3.call(this, id, component1Id, component2Id, component3Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
    this.component4Id = component4Id;
  }
  protoOf(SystemBase4).o26 = function () {
    return this.component4Id;
  };
  protoOf(SystemBase4).onAddComponent4 = function (entity, newComponent) {
  };
  protoOf(SystemBase4).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(SystemBase4).onRemoveComponent4 = function (entity, oldComponent) {
  };
  protoOf(SystemBase4).createComponentListeners = function () {
    // Inline function 'kotlin.arrayOf' call
    var tmp = SystemBase4$onAddComponent$ref(this);
    var tmp_0 = SystemBase4$onUpdateComponent$ref(this);
    var tmp_1 = new ComponentListenerImpl(this, this.component1Id, tmp, tmp_0, SystemBase4$onRemoveComponent$ref(this));
    var tmp_2 = SystemBase4$onAddComponent2$ref(this);
    var tmp_3 = SystemBase4$onUpdateComponent2$ref(this);
    var tmp_4 = new ComponentListenerImpl(this, this.component2Id, tmp_2, tmp_3, SystemBase4$onRemoveComponent2$ref(this));
    var tmp_5 = SystemBase4$onAddComponent3$ref(this);
    var tmp_6 = SystemBase4$onUpdateComponent3$ref(this);
    var tmp_7 = new ComponentListenerImpl(this, this.component3Id, tmp_5, tmp_6, SystemBase4$onRemoveComponent3$ref(this));
    var tmp_8 = SystemBase4$onAddComponent4$ref(this);
    var tmp_9 = SystemBase4$onUpdateComponent4$ref(this);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp_1, tmp_4, tmp_7, new ComponentListenerImpl(this, this.component4Id, tmp_8, tmp_9, SystemBase4$onRemoveComponent4$ref(this))];
  };
  function SystemBase5$onAddComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent';
    return l;
  }
  function SystemBase5$onUpdateComponent$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent';
    return l;
  }
  function SystemBase5$onRemoveComponent$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent';
    return l;
  }
  function SystemBase5$onAddComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent2';
    return l;
  }
  function SystemBase5$onUpdateComponent2$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent2(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent2';
    return l;
  }
  function SystemBase5$onRemoveComponent2$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent2(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent2';
    return l;
  }
  function SystemBase5$onAddComponent3$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent3(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent3';
    return l;
  }
  function SystemBase5$onUpdateComponent3$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent3(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent3';
    return l;
  }
  function SystemBase5$onRemoveComponent3$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent3(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent3';
    return l;
  }
  function SystemBase5$onAddComponent4$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent4(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent4';
    return l;
  }
  function SystemBase5$onUpdateComponent4$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent4(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent4';
    return l;
  }
  function SystemBase5$onRemoveComponent4$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent4(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent4';
    return l;
  }
  function SystemBase5$onAddComponent5$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onAddComponent5(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onAddComponent5';
    return l;
  }
  function SystemBase5$onUpdateComponent5$ref($boundThis) {
    var l = function (p0, p1, p2) {
      $boundThis.onUpdateComponent5(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'onUpdateComponent5';
    return l;
  }
  function SystemBase5$onRemoveComponent5$ref($boundThis) {
    var l = function (p0, p1) {
      $boundThis.onRemoveComponent5(p0, p1);
      return Unit_instance;
    };
    l.callableName = 'onRemoveComponent5';
    return l;
  }
  function SystemBase5(id, component1Id, component2Id, component3Id, component4Id, component5Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
    var tmp;
    if (doingChangesOnComponent === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = doingChangesOnComponent;
    }
    doingChangesOnComponent = tmp;
    systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
    systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
    SystemBase4.call(this, id, component1Id, component2Id, component3Id, component4Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
    this.component5Id = component5Id;
  }
  protoOf(SystemBase5).x26 = function () {
    return this.component5Id;
  };
  protoOf(SystemBase5).onAddComponent5 = function (entity, newComponent) {
  };
  protoOf(SystemBase5).onUpdateComponent5 = function (entity, oldComponent, newComponent) {
  };
  protoOf(SystemBase5).onRemoveComponent5 = function (entity, oldComponent) {
  };
  protoOf(SystemBase5).createComponentListeners = function () {
    // Inline function 'kotlin.arrayOf' call
    var tmp = SystemBase5$onAddComponent$ref(this);
    var tmp_0 = SystemBase5$onUpdateComponent$ref(this);
    var tmp_1 = new ComponentListenerImpl(this, this.component1Id, tmp, tmp_0, SystemBase5$onRemoveComponent$ref(this));
    var tmp_2 = SystemBase5$onAddComponent2$ref(this);
    var tmp_3 = SystemBase5$onUpdateComponent2$ref(this);
    var tmp_4 = new ComponentListenerImpl(this, this.component2Id, tmp_2, tmp_3, SystemBase5$onRemoveComponent2$ref(this));
    var tmp_5 = SystemBase5$onAddComponent3$ref(this);
    var tmp_6 = SystemBase5$onUpdateComponent3$ref(this);
    var tmp_7 = new ComponentListenerImpl(this, this.component3Id, tmp_5, tmp_6, SystemBase5$onRemoveComponent3$ref(this));
    var tmp_8 = SystemBase5$onAddComponent4$ref(this);
    var tmp_9 = SystemBase5$onUpdateComponent4$ref(this);
    var tmp_10 = new ComponentListenerImpl(this, this.component4Id, tmp_8, tmp_9, SystemBase5$onRemoveComponent4$ref(this));
    var tmp_11 = SystemBase5$onAddComponent5$ref(this);
    var tmp_12 = SystemBase5$onUpdateComponent5$ref(this);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp_1, tmp_4, tmp_7, tmp_10, new ComponentListenerImpl(this, this.component5Id, tmp_11, tmp_12, SystemBase5$onRemoveComponent5$ref(this))];
  };
  function convertGraphToArray($this, listeners, edges) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var resultingList = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = listeners.length;
    while (inductionVariable < last) {
      var element = listeners[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.SystemGraphHelper.convertGraphToArray.<anonymous>' call
      // Inline function 'kotlin.collections.find' call
      var this_0 = edges.p2();
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.ecs.SystemGraphHelper.convertGraphToArray.<anonymous>.<anonymous>' call
          if (contains(element_0, element)) {
            tmp$ret$2 = element_0;
            break $l$block;
          }
        }
        tmp$ret$2 = null;
      }
      if (tmp$ret$2 == null) {
        convertGraphToArray$iterateGraph(resultingList, edges, element);
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(resultingList);
  }
  function extractOrderOfRegistrationEdgesArr($this, listeners, edges) {
    var previous = null;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = listeners.length;
    while (inductionVariable < last) {
      var element = listeners[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractOrderOfRegistrationEdgesArr.<anonymous>' call
      var tmp;
      if (!(previous == null) ? edges.b3(element) == null : false) {
        // Inline function 'kotlin.collections.find' call
        var this_0 = edges.p2();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = this_0.t();
          while (tmp0_iterator.u()) {
            var element_0 = tmp0_iterator.w();
            // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractOrderOfRegistrationEdgesArr.<anonymous>.<anonymous>' call
            if (contains(element_0, element)) {
              tmp$ret$1 = element_0;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp = tmp$ret$1 == null;
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlin.collections.getOrElse' call
        var key = ensureNotNull(previous);
        var tmp0_elvis_lhs = edges.b3(key);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractOrderOfRegistrationEdgesArr.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.emptyArray' call
          tmp_0 = [];
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var list = tmp_0;
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = list;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$9 = [element];
        list = tmp$ret$6.concat(tmp$ret$9);
        // Inline function 'kotlin.collections.set' call
        var key_0 = ensureNotNull(previous);
        var value = list;
        edges.r2(key_0, value);
      }
      previous = element;
    }
  }
  function extractRealEdgesArr($this, listeners) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var edges = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = listeners.length;
    while (inductionVariable < last) {
      var element = listeners[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>' call
      var tmp0_safe_receiver = element.ownerSystem;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.systemsAfterMe;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_1 = 0;
            var last_1 = listeners.length;
            while (inductionVariable_1 < last_1) {
              var element_1 = listeners[inductionVariable_1];
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>' call
              var tmp0_safe_receiver_0 = element_1.ownerSystem;
              if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.id) === element_0) {
                tmp$ret$2 = element_1;
                break $l$block;
              }
            }
            tmp$ret$2 = null;
          }
          var tmp0_safe_receiver_1 = tmp$ret$2;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.getOrElse' call
            var tmp0_elvis_lhs = edges.b3(element);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.emptyArray' call
              tmp = [];
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var list = tmp;
            // Inline function 'kotlin.collections.plus' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$7 = list;
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$10 = [tmp0_safe_receiver_1];
            list = tmp$ret$7.concat(tmp$ret$10);
            var value = list;
            edges.r2(element, value);
          }
        }
      }
      var tmp2_safe_receiver = element.ownerSystem;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.systemsBeforeMe;
      if (tmp3_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_2 = 0;
        var last_2 = tmp3_safe_receiver.length;
        while (inductionVariable_2 < last_2) {
          var element_2 = tmp3_safe_receiver[inductionVariable_2];
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$14;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_3 = 0;
            var last_3 = listeners.length;
            while (inductionVariable_3 < last_3) {
              var element_3 = listeners[inductionVariable_3];
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>' call
              var tmp0_safe_receiver_2 = element_3.ownerSystem;
              if ((tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.id) === element_2) {
                tmp$ret$14 = element_3;
                break $l$block_0;
              }
            }
            tmp$ret$14 = null;
          }
          var tmp0_safe_receiver_3 = tmp$ret$14;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.getOrElse' call
            var tmp0_elvis_lhs_0 = edges.b3(tmp0_safe_receiver_3);
            var tmp_0;
            if (tmp0_elvis_lhs_0 == null) {
              // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.emptyArray' call
              tmp_0 = [];
            } else {
              tmp_0 = tmp0_elvis_lhs_0;
            }
            var list_0 = tmp_0;
            // Inline function 'kotlin.collections.plus' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$19 = list_0;
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$22 = [element];
            list_0 = tmp$ret$19.concat(tmp$ret$22);
            var value_0 = list_0;
            edges.r2(tmp0_safe_receiver_3, value_0);
          }
        }
      }
    }
    return edges;
  }
  function convertGraphToArray$iterateGraph(resultingList, $edges, listener) {
    if (!resultingList.p(listener)) {
      var tmp0_safe_receiver = $edges.b3(listener);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.ecs.SystemGraphHelper.convertGraphToArray.iterateGraph.<anonymous>' call
          if (!resultingList.p(element)) {
            convertGraphToArray$iterateGraph(resultingList, $edges, element);
          }
        }
      }
      if (!resultingList.p(listener)) {
        resultingList.q(listener);
      }
    }
  }
  function SystemGraphHelper$sortListeners$lambda() {
    return 'There is a cyclic dependency between your systems!';
  }
  function SystemGraphHelper() {
    SystemGraphHelper_instance = this;
    this.y26_1 = LoggerState_getInstance().m1m('SystemGraphHelper');
  }
  protoOf(SystemGraphHelper).sortListeners = function (listeners) {
    if (listeners.length === 1)
      return listeners;
    var edges = extractRealEdgesArr(this, listeners);
    if (edges.b1())
      return listeners;
    extractOrderOfRegistrationEdgesArr(this, listeners, edges);
    var resultingList = convertGraphToArray(this, listeners, edges);
    var tmp;
    if (resultingList.length === listeners.length) {
      tmp = reversedArray(resultingList);
    } else {
      this.y26_1.warn(SystemGraphHelper$sortListeners$lambda);
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = listeners.length;
      while (inductionVariable < last) {
        var element = listeners[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.SystemGraphHelper.sortListeners.<anonymous>' call
        if (element instanceof SystemBase) {
          element.printDependencies();
        }
      }
      throw IllegalStateException_init_$Create$('There is a cyclic dependency between your systems! You can get more information if you enable the logger INFO-level output.');
    }
    return tmp;
  };
  var SystemGraphHelper_instance;
  function SystemGraphHelper_getInstance() {
    if (SystemGraphHelper_instance == null)
      new SystemGraphHelper();
    return SystemGraphHelper_instance;
  }
  function handleLockedMemberOfGroup($this, entityGroup, potentiallyLockedMember) {
    if (EntityGroupUtils_instance.isHostingMemberInThisAutomaticGroup(potentiallyLockedMember, entityGroup)) {
      potentiallyLockedMember.removeComponent(47);
    }
  }
  function AutomaticGroupBuilderSystem$Companion$removeFromEntityGroup$lambda($child) {
    return function () {
      return '' + get_displayName($child) + ' was not a member of an entity group';
    };
  }
  function hasOnlyOneHostAndItIsStatic($this, entity) {
    return !get_hasMultipleHosts(entity) ? !get_isInGroupWithNonStaticHosts(entity) : false;
  }
  function productEntities($this, connectionRoot) {
    return hierarchyExceptSubTreesWithComponentArray(connectionRoot, 28);
  }
  function findEntityGroupAmongConnections($this, connectionsComponent) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = connectionsComponent.connections;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findEntityGroupAmongConnections.<anonymous>' call
        if (!(get_automaticEntityGroup(element.hostConnectorEntity) == null)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectorEntity;
    return tmp1_safe_receiver == null ? null : get_automaticEntityGroup(tmp1_safe_receiver);
  }
  function buildEntityGroup($this, newGuest) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var entities = LinkedHashSet_init_$Create$();
    findEntitiesToPutInEntityGroup($this, newGuest, entities);
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = entities.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.buildEntityGroup.<anonymous>' call
        var tmp0_safe_receiver = get_parent(element);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          Companion_getInstance_41();
          tmp = tmp0_safe_receiver.hasComponent(38);
        }
        if (tmp === true) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver_0 = tmp$ret$2;
    var existingEntityGroup = tmp0_safe_receiver_0 == null ? null : get_parent(tmp0_safe_receiver_0);
    var tmp_0;
    if (!(existingEntityGroup == null)) {
      tmp_0 = get_parent(existingEntityGroup);
    } else {
      var tmp1_elvis_lhs = findStaticHost($this, entities);
      tmp_0 = tmp1_elvis_lhs == null ? findAParentOutsideTheGroup($this, entities) : tmp1_elvis_lhs;
    }
    var parent = tmp_0;
    var entityGroup = EntityGroupUtils_instance.createAutomaticEntityGroup($this.i27_1, parent, $this.h27_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = entities.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.buildEntityGroup.<anonymous>' call
      assignEntityToEntityGroup($this, element_0, entityGroup);
    }
    Companion_getInstance_40().recenterGroup(entityGroup);
  }
  function findAParentOutsideTheGroup($this, entities) {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$3;
    $l$block_1: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = entities.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findAParentOutsideTheGroup.<anonymous>' call
        var tmp;
        if (get_parent(element) == null) {
          tmp = false;
        } else {
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_0;
            if (isInterface(entities, Collection)) {
              tmp_0 = entities.b1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var tmp0_iterator_0 = entities.t();
            while (tmp0_iterator_0.u()) {
              var element_0 = tmp0_iterator_0.w();
              // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findAParentOutsideTheGroup.<anonymous>.<anonymous>' call
              if (contains(hierarchyExceptSubTreesWithComponentArray(element_0, 28), get_parent(element))) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          var hasParentInGroup = tmp$ret$0;
          tmp = !hasParentInGroup;
        }
        if (tmp) {
          tmp$ret$3 = element;
          break $l$block_1;
        }
      }
      tmp$ret$3 = null;
    }
    var entityWithParentOutsideGroup = tmp$ret$3;
    return entityWithParentOutsideGroup == null ? null : get_parent(entityWithParentOutsideGroup);
  }
  function findStaticHost($this, entities) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = entities.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findStaticHost.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = get_guestConnections(element);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element_0 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findStaticHost.<anonymous>.<anonymous>' call
        if (get_isStatic(element_0.hostConnectorEntity))
          return element_0.hostConnectorEntity;
      }
    }
    return null;
  }
  function findEntitiesToPutInEntityGroup($this, entity, entities) {
    if (entity.hasComponent(101))
      return Unit_instance;
    var tmp0_elvis_lhs = get_connectionRootEntity(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entityRoot = tmp;
    if (entities.p(entityRoot))
      return Unit_instance;
    entities.q(entityRoot);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = productEntities($this, entityRoot);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findEntitiesToPutInEntityGroup.<anonymous>' call
      var list = asIterable(get_guestConnections(element));
      addAll(destination, list);
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findEntitiesToPutInEntityGroup.<anonymous>' call
      findEntitiesToPutInEntityGroup($this, element_0.hostConnectorEntity, entities);
    }
  }
  function assignEntityToEntityGroup($this, entity, entityGroup) {
    var otherEntityGroup = get_automaticEntityGroup(entity);
    if (equals(otherEntityGroup, entityGroup)) {
      return Unit_instance;
    }
    Companion_getInstance_41();
    var tmp0_safe_receiver = entityGroup.__getComponentForKotlin(38);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.withNewGroupMember(entity);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [entity];
      tmp = new AutomaticGroupComponent(tmp$ret$2);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newAutomaticEntityGroupComponent = tmp;
    entityGroup.addComponent(newAutomaticEntityGroupComponent);
    handleLockedMemberOfGroup(Companion_getInstance_40(), entityGroup, entity);
    Companion_getInstance_40().setGroupMemberComponents(entity, entityGroup);
    if (otherEntityGroup == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var children = get_children(otherEntityGroup);
      detachEntityGroup($this, otherEntityGroup);
      var inductionVariable = 0;
      var last = children.length;
      while (inductionVariable < last) {
        var element = children[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.assignEntityToEntityGroup.<anonymous>.<anonymous>' call
        assignEntityToEntityGroup($this, element, entityGroup);
      }
    }
  }
  function detachEntityGroup($this, entityGroup) {
    if (!get_isInScene(entityGroup))
      return Unit_instance;
    setParent(entityGroup, null);
  }
  function Companion_39() {
    Companion_instance_39 = this;
    this.ID = 'AutomaticGroupBuilderSystem';
    this.j27_1 = LoggerState_getInstance().m1m('AutomaticGroupBuilderSystem');
  }
  protoOf(Companion_39).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_39).handleLockedMembersOfGroup = function (entityGroup) {
    Companion_getInstance_41();
    var tmp0_safe_receiver = entityGroup.__getComponentForKotlin(38);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.members;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var members = tmp;
    var inductionVariable = 0;
    var last = members.length;
    while (inductionVariable < last) {
      var member = members[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      handleLockedMemberOfGroup(this, entityGroup, member);
    }
  };
  protoOf(Companion_39).removeFromEntityGroup = function (child) {
    var entityGroup = get_parent(child);
    if (entityGroup == null) {
      this.j27_1.warn(AutomaticGroupBuilderSystem$Companion$removeFromEntityGroup$lambda(child));
      return Unit_instance;
    }
    var tmp0_safe_receiver = get_highestPriorityConnection(child);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectionRoot;
    var newParent = tmp1_elvis_lhs == null ? get_parent(entityGroup) : tmp1_elvis_lhs;
    setParentMaintainWorldTransform(child, newParent);
    if (get_isConnectionRoot(child)) {
      child.addComponent(new SnapRootComponent());
    }
    if (!child.hasComponent(107)) {
      this.recenterGroup(entityGroup);
    }
  };
  protoOf(Companion_39).recenterGroup = function (entityGroup) {
    if (!any(get_children(entityGroup)))
      return Unit_instance;
    var newGroupCenter = Companion_getInstance_61().ZERO;
    var newRotation = get_worldRotation(first_0(get_children(entityGroup)));
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entityGroup);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
      newGroupCenter = newGroupCenter.plus(get_worldPosition(element));
    }
    var tmp = newGroupCenter;
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$0 = get_children(entityGroup).length;
    newGroupCenter = tmp.__divIntForKotlin(tmp$ret$0);
    if (!get_worldPosition(entityGroup).equals(newGroupCenter)) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_children(entityGroup);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.length);
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var item = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
        destination.q(item);
      }
      var children = destination;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = children.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
        setParentMaintainWorldTransform(element_0, null);
      }
      TransformUtils_instance.setWorldTransform(entityGroup, new Transform(newGroupCenter, newRotation));
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = children.t();
      while (tmp0_iterator_0.u()) {
        var element_1 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
        setParentMaintainWorldTransform(element_1, entityGroup);
      }
    }
  };
  protoOf(Companion_39).setGroupMemberComponents = function (entity, entityGroup) {
    setParentMaintainWorldTransform(entity, entityGroup);
  };
  var Companion_instance_39;
  function Companion_getInstance_40() {
    if (Companion_instance_39 == null)
      new Companion_39();
    return Companion_instance_39;
  }
  function AutomaticGroupBuilderSystem(entityManager) {
    Companion_getInstance_40();
    Companion_getInstance_18();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [3, 1, 47, 17, 38, 10];
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_48();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['ConnectionParentingSystem', 'UpdateHostConnectionsSystem'];
    SystemBase.call(this, 'AutomaticGroupBuilderSystem', 104, tmp, tmp$ret$5, null);
    this.h27_1 = entityManager;
    this.i27_1 = this.h27_1.createEntity();
  }
  protoOf(AutomaticGroupBuilderSystem).onAddComponent = function (entity, newComponent) {
    if (entity.hasComponent(107))
      return Unit_instance;
    if (hasOnlyOneHostAndItIsStatic(this, entity))
      return Unit_instance;
    buildEntityGroup(this, entity);
  };
  protoOf(AutomaticGroupBuilderSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    this.onRemoveComponent(entity, oldComponent);
    this.onAddComponent(entity, newComponent);
  };
  protoOf(AutomaticGroupBuilderSystem).onRemoveComponent = function (entity, oldComponent) {
    if (entity.hasComponent(107))
      return Unit_instance;
    if (!oldComponent.hasMultipleHosts)
      return Unit_instance;
    var tmp0_elvis_lhs = findEntityGroupAmongConnections(this, oldComponent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldEntityGroup = tmp;
    var children = get_children(oldEntityGroup);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = children.length;
    while (inductionVariable < last) {
      var element = children[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.onRemoveComponent.<anonymous>' call
      element.addComponent(new TemporarilyPauseConnectionParentingComponent());
      Companion_getInstance_40().removeFromEntityGroup(element);
      element.removeComponent(107);
    }
    detachEntityGroup(this, oldEntityGroup);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = children.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = children[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.onRemoveComponent.<anonymous>' call
      if (get_hasMultipleHosts(element_0)) {
        destination.q(element_0);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_1 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.onRemoveComponent.<anonymous>' call
      buildEntityGroup(this, element_1);
    }
  };
  function AutomaticGroupComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function Companion_40() {
    Companion_instance_40 = this;
    this.id = 38;
    this.serializationKey = 'EntityGroupParentComponent';
    var tmp = this;
    tmp.k27_1 = Json(VOID, AutomaticGroupComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_40).s1k = function () {
    return this.id;
  };
  protoOf(Companion_40).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_40).fromJson = function () {
    return new AutomaticGroupComponent();
  };
  var Companion_instance_40;
  function Companion_getInstance_41() {
    if (Companion_instance_40 == null)
      new Companion_40();
    return Companion_instance_40;
  }
  function AutomaticGroupComponent(members) {
    Companion_getInstance_41();
    var tmp;
    if (members === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = members;
    }
    members = tmp;
    this.members = members;
  }
  protoOf(AutomaticGroupComponent).l27 = function () {
    return this.members;
  };
  protoOf(AutomaticGroupComponent).x1k = function () {
    return 38;
  };
  protoOf(AutomaticGroupComponent).toJson = function (parse) {
    return Companion_getInstance_41().k27_1.k15(serializer(BooleanCompanionObject_instance), true);
  };
  protoOf(AutomaticGroupComponent).serializationKey = function () {
    return 'EntityGroupParentComponent';
  };
  protoOf(AutomaticGroupComponent).eq = function (other) {
    var otherEntityGroup = other instanceof AutomaticGroupComponent ? other : THROW_CCE();
    return contentEquals(this.members, otherEntityGroup.members);
  };
  protoOf(AutomaticGroupComponent).toString = function () {
    return 'EntityGroupParentComponent';
  };
  protoOf(AutomaticGroupComponent).withNewGroupMember = function (entity) {
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.members;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [entity];
    var tmp$ret$4 = tmp$ret$0.concat(tmp$ret$3);
    return new AutomaticGroupComponent(tmp$ret$4);
  };
  protoOf(AutomaticGroupComponent).withoutOldGroupMember = function (entity) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = subtract(this.members, setOf(entity));
    var tmp$ret$0 = copyToArray(this_0);
    return new AutomaticGroupComponent(tmp$ret$0);
  };
  function get_isAutomaticGroup(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(38);
  }
  function get_isInGroupWithNonStaticHosts(_this__u8e3s4) {
    var tmp0_safe_receiver = get_automaticEntityGroup(_this__u8e3s4);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_children(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
        var list = toList_1(get_guestConnections(element));
        addAll(destination, list);
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = tmp2_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
        if (!get_isStatic(element_0.hostConnectorEntity)) {
          destination_0.q(element_0);
        }
      }
      tmp_0 = destination_0;
    }
    var tmp3_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_safe_receiver, 10));
      var tmp0_iterator_0 = tmp3_safe_receiver.t();
      while (tmp0_iterator_0.u()) {
        var item = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
        var tmp$ret$6 = item.hostConnectorEntity;
        destination_1.q(tmp$ret$6);
      }
      tmp_1 = destination_1;
    }
    var tmp4_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$();
      var tmp0_iterator_1 = tmp4_safe_receiver.t();
      while (tmp0_iterator_1.u()) {
        var element_1 = tmp0_iterator_1.w();
        // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
        if (!equals(get_automaticEntityGroup(element_1), get_automaticEntityGroup(_this__u8e3s4))) {
          destination_2.q(element_1);
        }
      }
      tmp_2 = destination_2;
    }
    var hosts = tmp_2;
    return !(hosts == null) ? any_0(hosts) : false;
  }
  function get_automaticEntityGroup(_this__u8e3s4) {
    if (get_isAutomaticGroup(_this__u8e3s4))
      return _this__u8e3s4;
    var tmp;
    var tmp0_safe_receiver = get_connectionRootEntity(_this__u8e3s4);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver);
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hasComponent(38)) === true) {
      var tmp2_safe_receiver = get_connectionRootEntity(_this__u8e3s4);
      tmp = tmp2_safe_receiver == null ? null : get_parent(tmp2_safe_receiver);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function get_isMemberOfAutomaticGroup(_this__u8e3s4) {
    var tmp0_safe_receiver = get_parent(_this__u8e3s4);
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(38)) === true;
  }
  function addAutomaticGroupMember(_this__u8e3s4, newMember) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(38);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.withNewGroupMember(newMember);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newGroupComponent = tmp;
    _this__u8e3s4.addComponent(newGroupComponent);
  }
  function removeAutomaticGroupMember(_this__u8e3s4, oldMember) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(38);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.withoutOldGroupMember(oldMember);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newGroupComponent = tmp;
    _this__u8e3s4.addComponent(newGroupComponent);
  }
  function setAutomaticGroupParentToHighestPrioConnectionOutsideGroup(_this__u8e3s4) {
    var tmp0_elvis_lhs = get_highestPrioConnectionOutsideGroup(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var highestPrioConnection = tmp;
    var tmp1_elvis_lhs = get_snapRoot(highestPrioConnection.hostConnectorEntity);
    var newParent = tmp1_elvis_lhs == null ? highestPrioConnection.hostConnectorEntity : tmp1_elvis_lhs;
    var tmp2_safe_receiver = get_automaticEntityGroup(_this__u8e3s4);
    if (tmp2_safe_receiver == null)
      null;
    else {
      setParentMaintainWorldTransform(tmp2_safe_receiver, newParent);
    }
  }
  function get_highestPrioConnectionOutsideGroup(_this__u8e3s4) {
    var tmp0_safe_receiver = get_automaticEntityGroup(_this__u8e3s4);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_children(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
        var list = toList_1(get_guestConnections(element));
        addAll(destination, list);
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = tmp2_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
        if (!equals(get_automaticEntityGroup(element_0.hostConnectorEntity), get_automaticEntityGroup(_this__u8e3s4))) {
          destination_0.q(element_0);
        }
      }
      tmp_0 = destination_0;
    }
    var groupConnections = tmp_0;
    if (groupConnections == null)
      return null;
    if (!any_0(groupConnections))
      return null;
    var tmp$ret$6;
    $l$block: {
      // Inline function 'kotlin.collections.maxBy' call
      var iterator = groupConnections.t();
      if (!iterator.u())
        throw NoSuchElementException_init_$Create$();
      var maxElem = iterator.w();
      if (!iterator.u()) {
        tmp$ret$6 = maxElem;
        break $l$block;
      }
      // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
      var maxValue = maxElem.priority;
      do {
        var e = iterator.w();
        // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
        var v = e.priority;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$6 = maxElem;
    }
    return tmp$ret$6;
  }
  function Companion_41() {
    this.Id = 116;
  }
  protoOf(Companion_41).m27 = function () {
    return this.Id;
  };
  var Companion_instance_41;
  function Companion_getInstance_42() {
    return Companion_instance_41;
  }
  function AutomaticGroupIdCountComponent(nextAutomaticGroupId) {
    this.nextAutomaticGroupId = nextAutomaticGroupId;
    this.n27_1 = 116;
  }
  protoOf(AutomaticGroupIdCountComponent).o27 = function () {
    return this.nextAutomaticGroupId;
  };
  protoOf(AutomaticGroupIdCountComponent).x1k = function () {
    return this.n27_1;
  };
  protoOf(AutomaticGroupIdCountComponent).eq = function (other) {
    return (other instanceof AutomaticGroupIdCountComponent ? other : THROW_CCE()).nextAutomaticGroupId === this.nextAutomaticGroupId;
  };
  protoOf(AutomaticGroupIdCountComponent).withIncrementedId = function () {
    return new AutomaticGroupIdCountComponent(this.nextAutomaticGroupId + 1 | 0);
  };
  function incrementNextAutomaticGroupId($this, stateHolderEntity, entityManager) {
    var component = stateHolderEntity.__getComponentForKotlin(116);
    var tmp1_elvis_lhs = component == null ? null : component.withIncrementedId();
    var newComponent = tmp1_elvis_lhs == null ? new AutomaticGroupIdCountComponent(1) : tmp1_elvis_lhs;
    entityManager.addComponent(stateHolderEntity, newComponent);
    return newComponent.nextAutomaticGroupId;
  }
  function EntityGroupUtils() {
  }
  protoOf(EntityGroupUtils).isAutomaticGroup = function (entity) {
    return get_isAutomaticGroup(entity);
  };
  protoOf(EntityGroupUtils).isManualGroup = function (entity) {
    return get_isManualGroup(entity);
  };
  protoOf(EntityGroupUtils).isEntityLockedInAutomaticGroup = function (potentiallyLockedMember) {
    if (get_isAutomaticGroup(potentiallyLockedMember))
      return true;
    return this.isHostingMemberInThisAutomaticGroup(potentiallyLockedMember, get_automaticEntityGroup(potentiallyLockedMember)) ? true : isHostingEntityWithMultipleHosts(potentiallyLockedMember);
  };
  protoOf(EntityGroupUtils).isHostingMemberInThisAutomaticGroup = function (potentialHost, entityGroup) {
    var tmp1_safe_receiver = entityGroup == null ? get_automaticEntityGroup(potentialHost) : entityGroup;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.sequences.any' call
        var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(potentialHost, 28).t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.core.groups.EntityGroupUtils.isHostingMemberInThisAutomaticGroup.<anonymous>.<anonymous>' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.any' call
            var indexedObject = get_hostedConnections(element);
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var element_0 = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.ikea.core.groups.EntityGroupUtils.isHostingMemberInThisAutomaticGroup.<anonymous>.<anonymous>.<anonymous>' call
              var tmp0_safe_receiver = get_connectionRootEntity(element_0.guestConnectorEntity);
              if (equals(tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver), tmp1_safe_receiver)) {
                tmp$ret$1 = true;
                break $l$block;
              }
            }
            tmp$ret$1 = false;
          }
          if (tmp$ret$1) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      return tmp$ret$3;
    }
    return false;
  };
  protoOf(EntityGroupUtils).getAutomaticEntityGroupOfEntity = function (entity) {
    return get_automaticEntityGroup(entity);
  };
  protoOf(EntityGroupUtils).incrementNextManualGroupId = function (scene, entityManager) {
    var component = scene.__getComponentForKotlin(115);
    var tmp1_elvis_lhs = component == null ? null : component.withIncrementedId();
    var newComponent = tmp1_elvis_lhs == null ? new ManualGroupIdCountComponent(1) : tmp1_elvis_lhs;
    entityManager.addComponent(scene, newComponent);
    return newComponent.nextManualGroupId;
  };
  protoOf(EntityGroupUtils).createAutomaticEntityGroup = function (stateHolderEntity, parent, entityManager) {
    var entityGroup = entityManager.createEntity();
    var groupId = incrementNextAutomaticGroupId(this, stateHolderEntity, entityManager);
    entityGroup.addComponent(new DisplayNameComponent('Automatic Entity Group ' + groupId));
    setParent(entityGroup, parent);
    entityGroup.addComponent(new DraggableComponent());
    entityGroup.addComponent(new SelectableComponent());
    entityGroup.addComponent(new SnapRootComponent());
    entityGroup.addComponent(new AutomaticGroupComponent());
    return entityGroup;
  };
  protoOf(EntityGroupUtils).attachManualGroup = function (group) {
    Companion_getInstance_44();
    var tmp0_safe_receiver = group.__getComponentForKotlin(37);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.members;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var members = tmp;
    var inductionVariable = 0;
    var last = members.length;
    while (inductionVariable < last) {
      var member = members[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.configureComponentsForMemberInManualGroup(member, group);
    }
  };
  protoOf(EntityGroupUtils).configureComponentsForMemberInManualGroup = function (entity, group) {
    var tmp0_elvis_lhs = get_connectionRootEntity(entity);
    var connectionRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    setParentMaintainWorldTransform(connectionRoot, group);
    connectionRoot.removeComponent(SelectedComponent_instance.id);
    connectionRoot.removeComponent(1);
    connectionRoot.removeComponent(47);
  };
  var EntityGroupUtils_instance;
  function EntityGroupUtils_getInstance() {
    return EntityGroupUtils_instance;
  }
  function createNewEntityGroup($this, entityManager, sceneManager) {
    var entityGroup = entityManager.createEntity();
    nameManualGroup($this, sceneManager, entityManager, entityGroup);
    return entityGroup;
  }
  function nameManualGroup($this, sceneManager, entityManager, entityGroup) {
    var groupId = EntityGroupUtils_instance.incrementNextManualGroupId(sceneManager.scene, entityManager);
    entityGroup.addComponent(new DisplayNameComponent('Manual Entity Group ' + groupId));
  }
  function ManualEntityGroupBuilderService$Companion$disconnectFromEntityGroupParent$lambda($entityRoot, $entityGroup) {
    return function () {
      return 'ConnectionSystem could not find a snap for ' + $entityRoot + ' to snap it back to scene when disconnecting it from its entity group ' + $entityGroup;
    };
  }
  function Companion_42() {
    Companion_instance_42 = this;
    this.logger = LoggerState_getInstance().m1m('ManualEntityGroupBuilderService');
  }
  protoOf(Companion_42).q27 = function (hosts, existingEntityGroup, entityManager, sceneManager) {
    var entityGroup = existingEntityGroup == null ? createNewEntityGroup(this, entityManager, sceneManager) : existingEntityGroup;
    var position = Companion_getInstance_61().ZERO;
    var rotationEulerRadians = Companion_getInstance_61().ZERO;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = hosts.length;
    while (inductionVariable < last) {
      var element = hosts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.Companion.createManualEntityGroup.<anonymous>' call
      position = position.plus(get_worldPosition(element));
      rotationEulerRadians = rotationEulerRadians.plus(get_worldRotation(element).toEuler());
    }
    var tmp = position;
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$0 = hosts.length;
    position = tmp.__divIntForKotlin(tmp$ret$0);
    var tmp_0 = rotationEulerRadians;
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$1 = hosts.length;
    rotationEulerRadians = tmp_0.__divIntForKotlin(tmp$ret$1);
    var tmp1_safe_receiver = firstOrNull(hosts);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_connectionRootEntity(tmp1_safe_receiver);
    var first = tmp2_elvis_lhs == null ? firstOrNull(hosts) : tmp2_elvis_lhs;
    var tmp4_safe_receiver = first == null ? null : get_parent(first);
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      setParent(entityGroup, tmp4_safe_receiver);
    }
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable_0 = 0;
      var last_0 = hosts.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = hosts[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.groups.Companion.createManualEntityGroup.<anonymous>' call
        if (element_0.hasComponent(0)) {
          tmp$ret$4 = true;
          break $l$block;
        }
      }
      tmp$ret$4 = false;
    }
    var addSelected = tmp$ret$4;
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable_1 = 0;
      var last_1 = hosts.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = hosts[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.groups.Companion.createManualEntityGroup.<anonymous>' call
        var tmp0_elvis_lhs = get_connectionRootEntity(element_1);
        var tmp_1 = tmp0_elvis_lhs == null ? element_1 : tmp0_elvis_lhs;
        if (tmp_1.hasComponent(1)) {
          tmp$ret$6 = true;
          break $l$block_0;
        }
      }
      tmp$ret$6 = false;
    }
    var addSelectable = tmp$ret$6;
    var tmp$ret$8;
    $l$block_1: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable_2 = 0;
      var last_2 = hosts.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = hosts[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.ikea.core.groups.Companion.createManualEntityGroup.<anonymous>' call
        var tmp0_elvis_lhs_0 = get_connectionRootEntity(element_2);
        var tmp_2 = tmp0_elvis_lhs_0 == null ? element_2 : tmp0_elvis_lhs_0;
        if (tmp_2.hasComponent(3)) {
          tmp$ret$8 = true;
          break $l$block_1;
        }
      }
      tmp$ret$8 = false;
    }
    var addDraggable = tmp$ret$8;
    var rotation = Companion_getInstance_57().fromEuler(new Radians(rotationEulerRadians.X), new Radians(rotationEulerRadians.Y), new Radians(rotationEulerRadians.Z));
    entityGroup.addComponent(new LocalTransformComponent(new Transform(position, rotation)));
    entityGroup.addComponent(new SnapRootComponent());
    entityGroup.addComponent(new ManualGroupComponent(hosts));
    entityGroup.addComponent(new OutlineableComponent());
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_3 = 0;
    var last_3 = hosts.length;
    while (inductionVariable_3 < last_3) {
      var element_3 = hosts[inductionVariable_3];
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      // Inline function 'com.ikea.core.groups.Companion.createManualEntityGroup.<anonymous>' call
      EntityGroupUtils_instance.configureComponentsForMemberInManualGroup(element_3, entityGroup);
    }
    if (addSelected) {
      entityGroup.addComponent(SelectedComponent_instance);
    }
    if (addSelectable) {
      entityGroup.addComponent(new SelectableComponent());
    }
    if (addDraggable) {
      entityGroup.addComponent(new DraggableComponent());
    }
    return entityGroup;
  };
  protoOf(Companion_42).createManualEntityGroup = function (hosts, existingEntityGroup, entityManager, sceneManager, $super) {
    existingEntityGroup = existingEntityGroup === VOID ? null : existingEntityGroup;
    return this.q27(hosts, existingEntityGroup, entityManager, sceneManager);
  };
  protoOf(Companion_42).disconnectFromEntityGroupParent = function (entity, sceneManager) {
    var tmp0_elvis_lhs = get_connectionRootEntity(entity);
    var entityRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    var tmp1_safe_receiver = get_parent(entityRoot);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      Companion_getInstance_44();
      if (!tmp1_safe_receiver.hasComponent(37))
        return Unit_instance;
      if (get_isConnectionRoot(entityRoot)) {
        entityRoot.addComponent(new SelectableComponent());
        entityRoot.addComponent(new SnapRootComponent());
      }
      var entityGroupParent = get_parent(tmp1_safe_receiver);
      var tmp;
      if (get_isInScene(entityRoot) ? !(entityGroupParent == null) : false) {
        setParentMaintainWorldTransform(entityRoot, get_parent(tmp1_safe_receiver));
        var candidate = firstOrNull(SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(entity, entityGroupParent)));
        var tmp1_safe_receiver_0 = candidate == null ? null : candidate.createAction();
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          tmp1_safe_receiver_0.perform();
        }
        var tmp_0;
        if (candidate == null) {
          var tmp_1 = Companion_getInstance_43().logger;
          tmp_1.warn(ManualEntityGroupBuilderService$Companion$disconnectFromEntityGroupParent$lambda(entityRoot, tmp1_safe_receiver));
          setParentMaintainWorldTransform(entityRoot, sceneManager.scene);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        setParentMaintainWorldTransform(entityRoot, null);
        tmp = Unit_instance;
      }
    }
  };
  protoOf(Companion_42).x1i = function () {
    return this.logger;
  };
  var Companion_instance_42;
  function Companion_getInstance_43() {
    if (Companion_instance_42 == null)
      new Companion_42();
    return Companion_instance_42;
  }
  function ManualEntityGroupBuilderService(entityManager, sceneManager) {
    Companion_getInstance_43();
    this.r27_1 = entityManager;
    this.s27_1 = sceneManager;
  }
  protoOf(ManualEntityGroupBuilderService).disconnectFromEntityGroupParent = function (entity) {
    Companion_getInstance_43().disconnectFromEntityGroupParent(entity, this.s27_1);
  };
  protoOf(ManualEntityGroupBuilderService).createManualEntityGroup = function (hosts) {
    return Companion_getInstance_43().createManualEntityGroup(hosts, null, this.r27_1, this.s27_1);
  };
  function ManualGroupComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function Companion_43() {
    Companion_instance_43 = this;
    this.id = 37;
    this.serializationKey = 'ManualGroupComponent';
    var tmp = this;
    tmp.t27_1 = Json(VOID, ManualGroupComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_43).s1k = function () {
    return this.id;
  };
  protoOf(Companion_43).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_43).fromJson = function () {
    return new ManualGroupComponent();
  };
  var Companion_instance_43;
  function Companion_getInstance_44() {
    if (Companion_instance_43 == null)
      new Companion_43();
    return Companion_instance_43;
  }
  function ManualGroupComponent(members) {
    Companion_getInstance_44();
    var tmp;
    if (members === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = members;
    }
    members = tmp;
    this.members = members;
  }
  protoOf(ManualGroupComponent).l27 = function () {
    return this.members;
  };
  protoOf(ManualGroupComponent).toJson = function (parse) {
    return Companion_getInstance_44().t27_1.k15(serializer(BooleanCompanionObject_instance), true);
  };
  protoOf(ManualGroupComponent).serializationKey = function () {
    return 'ManualGroupComponent';
  };
  protoOf(ManualGroupComponent).x1k = function () {
    return 37;
  };
  protoOf(ManualGroupComponent).eq = function (other) {
    var otherEntityGroup = other instanceof ManualGroupComponent ? other : THROW_CCE();
    return contentEquals(this.members, otherEntityGroup.members);
  };
  function get_isManualGroup(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(37);
  }
  function get_isInManualGroup(_this__u8e3s4) {
    var tmp0_safe_receiver = get_manualGroup(_this__u8e3s4);
    return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.__getComponentForKotlin(37)) == null);
  }
  function get_manualGroup(_this__u8e3s4) {
    if (get_isManualGroup(_this__u8e3s4))
      return _this__u8e3s4;
    var tmp0_safe_receiver = get_connectionRootEntity(_this__u8e3s4);
    var parent = tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver);
    var tmp;
    if ((parent == null ? null : parent.hasComponent(37)) === true) {
      tmp = parent;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function Companion_44() {
    this.ID = 'ManualGroupConnectorValidation';
  }
  protoOf(Companion_44).u1n = function () {
    return this.ID;
  };
  var Companion_instance_44;
  function Companion_getInstance_45() {
    return Companion_instance_44;
  }
  function checkConnectorsOnParts($this, hostPart, guestPart, connector) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = connector.findHostConnectorsWithMatchingTags(get_connectorsComponent(hostPart)).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.checkConnectorsOnParts.<anonymous>' call
        if (element.containsConnector(get_worldTransform(hostPart), get_worldTransform(guestPart), connector)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function hasAtLeastOneConnectorFulfilled($this, hosts, guest) {
    var tmp0_safe_receiver = guest.__getComponentForKotlin(Companion_instance_97.id);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allowedHosts;
    var eligibleHosts = tmp1_elvis_lhs == null ? hosts : tmp1_elvis_lhs;
    var tmp$ret$5;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = hierarchyExceptSubTreesWithComponentArray(guest, 47);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.hasAtLeastOneConnectorFulfilled.<anonymous>' call
        var tmp0_safe_receiver_0 = get_connectorsComponent(element);
        var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.guestConnectors;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_0;
            if (isInterface(tmp1_safe_receiver, Collection)) {
              tmp_0 = tmp1_safe_receiver.b1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            var tmp0_iterator = tmp1_safe_receiver.t();
            while (tmp0_iterator.u()) {
              var element_0 = tmp0_iterator.w();
              // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.hasAtLeastOneConnectorFulfilled.<anonymous>.<anonymous>' call
              var tmp$ret$2;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var inductionVariable_0 = 0;
                var last_0 = eligibleHosts.length;
                while (inductionVariable_0 < last_0) {
                  var element_1 = eligibleHosts[inductionVariable_0];
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.hasAtLeastOneConnectorFulfilled.<anonymous>.<anonymous>.<anonymous>' call
                  if (hasAtLeastOneConnectorFulfilled$_anonymous_$_anonymous_$checkHost_6hog06(element, $this, element_0, element_1)) {
                    tmp$ret$2 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$2 = false;
              }
              if (tmp$ret$2) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
            }
            tmp$ret$0 = false;
          }
          tmp = tmp$ret$0;
        }
        var tmp2_elvis_lhs = tmp;
        if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
          tmp$ret$5 = true;
          break $l$block_2;
        }
      }
      tmp$ret$5 = false;
    }
    return tmp$ret$5;
  }
  function hasAtLeastOneConnectorFulfilled$_anonymous_$_anonymous_$checkHost_6hog06($guestPart, this$0, $connector, host) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var tmp = hierarchyExceptSubTreeSequence(host, $guestPart);
      var tmp0_iterator = filter(tmp, ManualGroupConnectorValidation$hasAtLeastOneConnectorFulfilled$_anonymous_$_anonymous_$checkHost$lambda_qf62wo($guestPart)).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.hasAtLeastOneConnectorFulfilled.<anonymous>$<anonymous>$checkHost.<anonymous>' call
        if (checkConnectorsOnParts(this$0, element, $guestPart, $connector)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function ManualGroupConnectorValidation$hasAtLeastOneConnectorFulfilled$_anonymous_$_anonymous_$checkHost$lambda_qf62wo($$guestPart) {
    return function (hostPart) {
      return !equals(get_snapRoot(hostPart), get_snapRoot($$guestPart));
    };
  }
  function ManualGroupConnectorValidation(validationService, coreModules) {
    ValidationImpl.call(this);
    this.validationService = validationService;
    this.coreModules = coreModules;
    this.v27_1 = 'ManualGroupConnectorValidation';
  }
  protoOf(ManualGroupConnectorValidation).w27 = function () {
    return this.validationService;
  };
  protoOf(ManualGroupConnectorValidation).o1i = function () {
    return this.coreModules;
  };
  protoOf(ManualGroupConnectorValidation).s1k = function () {
    return this.v27_1;
  };
  protoOf(ManualGroupConnectorValidation).validateCurrentState = function (entity) {
    if (entity.hasComponent(37)) {
      var warn = null;
      var tmp0_safe_receiver = get_parent(entity);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.validateCurrentState.<anonymous>' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var groupParent = [tmp0_safe_receiver];
        var tmp0_safe_receiver_0 = get_parentComponent(entity);
        var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.children;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.validateCurrentState.<anonymous>.<anonymous>' call
            var snapRes = ConnectorUtils_instance.findUnfulfilledRequiredConnectors(groupParent, element);
            if (any(snapRes)) {
              var tmp_0 = Companion_instance_114;
              var tmp0_elvis_lhs = get_productRef(entity);
              return tmp_0.fail('No snap on EntityGroup test', tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this);
            }
            // Inline function 'kotlin.collections.forEach' call
            var indexedObject = this.validationService.validateCurrentState(element);
            var inductionVariable_0 = 0;
            var last_0 = indexedObject.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = indexedObject[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.validateCurrentState.<anonymous>.<anonymous>.<anonymous>' call
              if (element_0.resultType.equals(ValidationResultType_FAIL_getInstance())) {
                return element_0;
              } else if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
                warn = element_0;
              }
            }
          }
          tmp = Unit_instance;
        }
      }
      return warn;
    }
    return null;
  };
  protoOf(ManualGroupConnectorValidation).validateSnap = function (snapActionCandidate) {
    var tmp = snapActionCandidate.guestRoot;
    if (tmp.hasComponent(37)) {
      var warn = null;
      var gp = snapActionCandidate.host;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var groupParent = [gp];
      var tmp0_safe_receiver = get_parentComponent(snapActionCandidate.guestRoot);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.validateSnap.<anonymous>' call
          var snapRes = hasAtLeastOneConnectorFulfilled(this, groupParent, element);
          if (!snapRes) {
            var tmp_0 = Companion_instance_114;
            var tmp0_elvis_lhs = get_productRef(snapActionCandidate.guestRoot);
            return tmp_0.fail('No snap on ManualGroup test', tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this);
          }
          // Inline function 'kotlin.collections.forEach' call
          var indexedObject = this.validationService.validateCurrentState(element);
          var inductionVariable_0 = 0;
          var last_0 = indexedObject.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.groups.ManualGroupConnectorValidation.validateSnap.<anonymous>.<anonymous>' call
            if (element_0.resultType.equals(ValidationResultType_FAIL_getInstance())) {
              return element_0;
            } else if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
              warn = element_0;
            }
          }
        }
      }
      return warn;
    }
    return null;
  };
  function Companion_45() {
    this.Id = 115;
  }
  protoOf(Companion_45).m27 = function () {
    return this.Id;
  };
  var Companion_instance_45;
  function Companion_getInstance_46() {
    return Companion_instance_45;
  }
  function ManualGroupIdCountComponent(nextManualGroupId) {
    this.nextManualGroupId = nextManualGroupId;
    this.p27_1 = 115;
  }
  protoOf(ManualGroupIdCountComponent).x27 = function () {
    return this.nextManualGroupId;
  };
  protoOf(ManualGroupIdCountComponent).x1k = function () {
    return this.p27_1;
  };
  protoOf(ManualGroupIdCountComponent).eq = function (other) {
    return (other instanceof ManualGroupIdCountComponent ? other : THROW_CCE()).nextManualGroupId === this.nextManualGroupId;
  };
  protoOf(ManualGroupIdCountComponent).withIncrementedId = function () {
    return new ManualGroupIdCountComponent(this.nextManualGroupId + 1 | 0);
  };
  function StaticComponent() {
    StaticComponent_instance = this;
    this.y27_1 = this.id;
  }
  protoOf(StaticComponent).x1k = function () {
    return this.y27_1;
  };
  protoOf(StaticComponent).s1k = function () {
    return 101;
  };
  protoOf(StaticComponent).eq = function (other) {
    return true;
  };
  var StaticComponent_instance;
  function StaticComponent_getInstance() {
    if (StaticComponent_instance == null)
      new StaticComponent();
    return StaticComponent_instance;
  }
  function get_isStatic(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(101);
  }
  function Companion_46() {
    this.id = 17;
  }
  protoOf(Companion_46).s1k = function () {
    return this.id;
  };
  var Companion_instance_46;
  function Companion_getInstance_47() {
    return Companion_instance_46;
  }
  function ChildComponent(parent) {
    this.parent = parent;
  }
  protoOf(ChildComponent).z27 = function () {
    return this.parent;
  };
  protoOf(ChildComponent).eq = function (other) {
    return unsafeCast(other).parent.equals(this.parent);
  };
  protoOf(ChildComponent).equals = function (other) {
    var tmp;
    if (other instanceof ChildComponent) {
      tmp = other.parent.equals(this.parent);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ChildComponent).hashCode = function () {
    return this.parent.hashCode();
  };
  protoOf(ChildComponent).x1k = function () {
    return 17;
  };
  protoOf(ChildComponent).af = function () {
    return this.parent;
  };
  protoOf(ChildComponent).a28 = function (parent) {
    return new ChildComponent(parent);
  };
  protoOf(ChildComponent).copy = function (parent, $super) {
    parent = parent === VOID ? this.parent : parent;
    return this.a28(parent);
  };
  protoOf(ChildComponent).toString = function () {
    return 'ChildComponent(parent=' + this.parent + ')';
  };
  function get_parent(_this__u8e3s4) {
    var tmp0_safe_receiver = get_childComponent(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
  }
  function get_childComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(17);
  }
  function updateParent($this, entity, guestConnectionsComponent) {
    var tmp;
    var tmp_0;
    if (get_isInGroupWithNonStaticHosts(entity)) {
      tmp_0 = true;
    } else {
      var tmp0_safe_receiver = get_snapRoot(entity);
      tmp_0 = (tmp0_safe_receiver == null ? null : get_isAutomaticGroup(tmp0_safe_receiver)) === true;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = get_isInManualGroup(entity);
    }
    if (tmp)
      return Unit_instance;
    var mainConnection = guestConnectionsComponent.highestPriorityConnection;
    if (mainConnection == null) {
      var tmp_1 = Companion_getInstance_48().b28_1;
      tmp_1.error(ConnectionParentingSystem$updateParent$lambda);
      return Unit_instance;
    }
    setParentMaintainWorldTransform(entity, mainConnection.hostConnectorEntity);
  }
  function unParent($this, guestRoot) {
    if (get_isMemberOfAutomaticGroup(guestRoot) ? isHostingEntityWithMultipleHosts(guestRoot) : false) {
      return Unit_instance;
    }
    setParentMaintainWorldTransform(guestRoot, null);
  }
  function Companion_47() {
    Companion_instance_47 = this;
    this.ID = 'ConnectionParentingSystem';
    this.b28_1 = LoggerState_getInstance().m1m('ConnectionSystem');
  }
  protoOf(Companion_47).u1n = function () {
    return this.ID;
  };
  var Companion_instance_47;
  function Companion_getInstance_48() {
    if (Companion_instance_47 == null)
      new Companion_47();
    return Companion_instance_47;
  }
  function ConnectionParentingSystem$updateParent$lambda() {
    return 'Added a connections component without connections, something is broken';
  }
  function ConnectionParentingSystem() {
    Companion_getInstance_48();
    Companion_getInstance_18();
    SystemBase.call(this, 'ConnectionParentingSystem', 104);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k28_1 = [16, 17, 10];
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.l28_1 = [];
  }
  protoOf(ConnectionParentingSystem).w1o = function () {
    return this.k28_1;
  };
  protoOf(ConnectionParentingSystem).y1o = function () {
    return this.l28_1;
  };
  protoOf(ConnectionParentingSystem).onAddComponent = function (entity, newComponent) {
    if (entity.hasComponent(107))
      return Unit_instance;
    updateParent(this, entity, newComponent);
  };
  protoOf(ConnectionParentingSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (entity.hasComponent(107))
      return Unit_instance;
    updateParent(this, entity, newComponent);
  };
  protoOf(ConnectionParentingSystem).onRemoveComponent = function (entity, oldComponent) {
    if (entity.hasComponent(107))
      return Unit_instance;
    unParent(this, entity);
  };
  function entityRemoved($this, entity) {
    if (entity.hasComponent(16)) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.HierarchySystem.entityRemoved.<anonymous>' call
        $this.u28_1.disposeEntity(element);
      }
    }
  }
  function onUpdateChild($this, child, oldComponent, newComponent) {
    var newParent = newComponent.parent;
    var tmp0_elvis_lhs = get_parentComponent(newParent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$0 = [];
      tmp = new ParentComponent(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parentComponent = tmp;
    var siblings = parentComponent.children;
    if (contains(siblings, child))
      return Unit_instance;
    var oldParent = oldComponent == null ? null : oldComponent.parent;
    var tmp3_safe_receiver = oldParent == null ? null : get_parentComponent(oldParent);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (contains(tmp3_safe_receiver.children, child)) {
        var oldParentComponentWithoutMe = tmp3_safe_receiver.removeChild(child);
        oldParent.addComponent(oldParentComponentWithoutMe);
        tmp_0 = Unit_instance;
      }
    }
    if (newParent.id === child.id)
      throw IllegalStateException_init_$Create$('HierarchySystem do not allow an entity to be its own child: ' + newParent);
    var newParentComponentWithMe = parentComponent.addChild(child);
    newParent.addComponent(newParentComponentWithMe);
  }
  function Companion_48() {
    this.ID = 'HierarchySystem';
  }
  protoOf(Companion_48).u1n = function () {
    return this.ID;
  };
  var Companion_instance_48;
  function Companion_getInstance_49() {
    return Companion_instance_48;
  }
  function HierarchySystem$entityRemoved$ref($boundThis) {
    var l = function (p0) {
      entityRemoved($boundThis, p0);
      return Unit_instance;
    };
    l.callableName = 'entityRemoved';
    return l;
  }
  function HierarchySystem(entityManager) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [6, 16];
    SystemBase.call(this, 'HierarchySystem', 17, tmp$ret$2, null, null);
    this.u28_1 = entityManager;
    this.u28_1.subscribeEntityRemoved(HierarchySystem$entityRemoved$ref(this));
  }
  protoOf(HierarchySystem).onAddComponent = function (entity, newComponent) {
    Companion_getInstance_107();
    if (!entity.hasComponent(6)) {
      entity.addComponent(Companion_getInstance_107().IDENTITY);
    }
    onUpdateChild(this, entity, newComponent, newComponent);
  };
  protoOf(HierarchySystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    onUpdateChild(this, entity, oldComponent, newComponent);
  };
  protoOf(HierarchySystem).onRemoveComponent = function (entity, oldComponent) {
    var parent = oldComponent.parent;
    if (!parent.isDisposed) {
      var tmp0_safe_receiver = get_parentComponent(parent);
      var newChildren = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.removeChild(entity);
      if (newChildren == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.hierarchies.HierarchySystem.onRemoveComponent.<anonymous>' call
        parent.addComponent(newChildren);
      }
    }
  };
  function generateAssemblyHierarchy($this, me) {
    var res = ArrayList_init_$Create$_0(20);
    generateAssemblyHierarchy$add(res, me);
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(res);
  }
  function generateAssemblyHierarchy$add(res, e) {
    res.q(e);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(e);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.HierarchyUtils.generateAssemblyHierarchy.add.<anonymous>' call
      Companion_getInstance_6();
      if (element.hasComponent(44)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      generateAssemblyHierarchy$add(res, element_0);
    }
  }
  function hierarchyExceptSubTreesWithComponent$add($componentId, $entity, l, e) {
    if (!e.hasComponent($componentId) ? true : e.equals($entity)) {
      l.q(e);
      var tmp0_safe_receiver = get_parentComponent(e);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          hierarchyExceptSubTreesWithComponent$add($componentId, $entity, l, element);
        }
      }
    }
  }
  function forEachInHierarchy$iterate($func, e) {
    $func(e);
    var tmp0_safe_receiver = e.__getComponentForKotlin(16);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        forEachInHierarchy$iterate($func, element);
      }
    }
  }
  function forEachInHierarchyExceptHierarchyOfIgnored$iterate($ignored, $func, e) {
    if (!e.equals($ignored)) {
      $func(e);
      var tmp0_safe_receiver = e.__getComponentForKotlin(16);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          forEachInHierarchyExceptHierarchyOfIgnored$iterate($ignored, $func, element);
        }
      }
    }
  }
  function forEachInHierarchyExceptSubHierarchiesWithComponent$iterate($componentId, $func, e) {
    if (!e.hasComponent($componentId)) {
      $func(e);
      var tmp0_safe_receiver = e.__getComponentForKotlin(16);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          forEachInHierarchyExceptSubHierarchiesWithComponent$iterate($componentId, $func, element);
        }
      }
    }
  }
  function findInHierarchy$iterate(res, $finder, e) {
    if (res._v == null) {
      if ($finder(e)) {
        res._v = e;
      } else {
        var tmp0_safe_receiver = e.__getComponentForKotlin(16);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            findInHierarchy$iterate(res, $finder, element);
          }
        }
      }
    }
  }
  function findInHierarchyExceptHierarchyOfIgnored$iterate(res, $ignored, $finder, e) {
    if (res._v == null ? !e.equals($ignored) : false) {
      if ($finder(e)) {
        res._v = e;
      } else {
        var tmp0_safe_receiver = e.__getComponentForKotlin(16);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            findInHierarchyExceptHierarchyOfIgnored$iterate(res, $ignored, $finder, element);
          }
        }
      }
    }
  }
  function filterInHierarchy$iterate($finder, res, e) {
    if ($finder(e)) {
      var tmp;
      if (res._v == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [e];
      } else {
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = ensureNotNull(res._v);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = [e];
        tmp = tmp$ret$3.concat(tmp$ret$6);
      }
      res._v = tmp;
    }
    var tmp0_safe_receiver = e.__getComponentForKotlin(16);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        filterInHierarchy$iterate($finder, res, element);
      }
    }
  }
  function findInUpwardsHierarchy$iterate(res, $finder, e) {
    if (res._v == null) {
      if ($finder(e)) {
        res._v = e;
      } else {
        var tmp0_safe_receiver = e.__getComponentForKotlin(17);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          findInUpwardsHierarchy$iterate(res, $finder, tmp1_safe_receiver);
        }
      }
    }
  }
  function HierarchyUtils$getHierarchyWithComponent$lambda($componentId) {
    return function (it) {
      return it.hasComponent($componentId);
    };
  }
  function HierarchyUtils() {
  }
  protoOf(HierarchyUtils).duplicateEntity = function (original, services) {
    var serialized = toJsonString(original);
    var deserialized = (new JsonSerializer()).deserializeToEntityHierarchies(serialized, services);
    return first_0(deserialized);
  };
  protoOf(HierarchyUtils).parentComponent = function (entity) {
    return get_parentComponent(entity);
  };
  protoOf(HierarchyUtils).childComponent = function (entity) {
    return get_childComponent(entity);
  };
  protoOf(HierarchyUtils).parent = function (entity) {
    return get_parent(entity);
  };
  protoOf(HierarchyUtils).rootOf = function (entity) {
    var current = entity;
    while (!(get_parent(current) == null)) {
      current = ensureNotNull(get_parent(current));
    }
    return current;
  };
  protoOf(HierarchyUtils).setParent = function (entity, parent) {
    setParent(entity, parent);
  };
  protoOf(HierarchyUtils).setParentMaintainTransform = function (entity, parent) {
    setParentMaintainWorldTransform(entity, parent);
  };
  protoOf(HierarchyUtils).isAssembly = function (entity) {
    return get_isAssembly(entity);
  };
  protoOf(HierarchyUtils).getAssemblyEntities = function (assemblyRoot) {
    return generateAssemblyHierarchy(this, assemblyRoot);
  };
  protoOf(HierarchyUtils).getAssemblyChildren = function (assemblyRoot) {
    var assemblyEntities = HierarchyUtils_instance.getAssemblyEntities(assemblyRoot);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = assemblyEntities.length;
    while (inductionVariable < last) {
      var element = assemblyEntities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.HierarchyUtils.getAssemblyChildren.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = get_children(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.HierarchyUtils.getAssemblyChildren.<anonymous>.<anonymous>' call
        if (!contains(assemblyEntities, element_0)) {
          destination_0.q(element_0);
        }
      }
      var list = destination_0;
      addAll(destination, list);
    }
    var children = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(children);
  };
  protoOf(HierarchyUtils).descendants = function (entity) {
    var parentComponent = entity.__getComponentForKotlin(16);
    var tmp1_elvis_lhs = parentComponent == null ? null : parentComponent.allDescendants();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HierarchyUtils).children = function (entity) {
    var parentComponent = entity.__getComponentForKotlin(16);
    var tmp1_elvis_lhs = parentComponent == null ? null : parentComponent.children;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HierarchyUtils).hierarchy = function (entity) {
    var parentComponent = entity.__getComponentForKotlin(16);
    var tmp1_elvis_lhs = parentComponent == null ? null : parentComponent.hierarchy(entity);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [entity];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HierarchyUtils).hierarchyExceptSubTreesWithComponent = function (entity, componentId) {
    var l = ArrayList_init_$Create$_0(20);
    hierarchyExceptSubTreesWithComponent$add(componentId, entity, l, entity);
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(l);
  };
  protoOf(HierarchyUtils).forEachInHierarchy = function (entity, func) {
    forEachInHierarchy$iterate(func, entity);
  };
  protoOf(HierarchyUtils).forEachInHierarchyExceptHierarchyOfIgnored = function (entity, ignored, func) {
    forEachInHierarchyExceptHierarchyOfIgnored$iterate(ignored, func, entity);
  };
  protoOf(HierarchyUtils).forEachInHierarchyExceptSubHierarchiesWithComponent = function (entity, componentId, func) {
    func(entity);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.HierarchyUtils.forEachInHierarchyExceptSubHierarchiesWithComponent.<anonymous>' call
      forEachInHierarchyExceptSubHierarchiesWithComponent$iterate(componentId, func, element);
    }
  };
  protoOf(HierarchyUtils).findInHierarchy = function (entity, finder) {
    var res = {_v: null};
    findInHierarchy$iterate(res, finder, entity);
    return res._v;
  };
  protoOf(HierarchyUtils).findInHierarchyExceptHierarchyOfIgnored = function (entity, ignored, finder) {
    var res = {_v: null};
    findInHierarchyExceptHierarchyOfIgnored$iterate(res, ignored, finder, entity);
    return res._v;
  };
  protoOf(HierarchyUtils).filterInHierarchy = function (entity, finder) {
    var res = {_v: null};
    filterInHierarchy$iterate(finder, res, entity);
    var tmp0_elvis_lhs = res._v;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HierarchyUtils).isDescendantOf = function (entity, other) {
    var currentEntity = get_parent(entity);
    while (!(currentEntity == null)) {
      if (equals(currentEntity, other))
        return true;
      currentEntity = get_parent(currentEntity);
    }
    return false;
  };
  protoOf(HierarchyUtils).findWithComponentInUpwardsHierarchy = function (entity, componentId) {
    var currentEntity = entity;
    while (!(currentEntity == null) ? !currentEntity.isDisposed : false) {
      if (currentEntity.hasComponent(componentId))
        return currentEntity;
      var tmp0_safe_receiver = get_childComponent(currentEntity);
      currentEntity = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
    }
    return null;
  };
  protoOf(HierarchyUtils).getDescendantsWithComponent = function (entity, componentId) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_descendants(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.HierarchyUtils.getDescendantsWithComponent.<anonymous>' call
      if (element.hasComponent(componentId)) {
        destination.q(element);
      }
    }
    return copyToArray(destination);
  };
  protoOf(HierarchyUtils).getDescendantWithComponent = function (entity, componentId) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_descendants(entity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.HierarchyUtils.getDescendantWithComponent.<anonymous>' call
        if (element.hasComponent(componentId)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(HierarchyUtils).getHierarchyWithComponent = function (entity, componentId) {
    return filterInHierarchy(entity, HierarchyUtils$getHierarchyWithComponent$lambda(componentId));
  };
  protoOf(HierarchyUtils).hasComponentInUpwardsHierarchy = function (entity, componentId) {
    var tmp;
    if (entity.hasComponent(componentId)) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = get_parent(entity);
      tmp = (tmp0_safe_receiver == null ? null : hasComponentInUpwardsHierarchy(tmp0_safe_receiver, componentId)) === true;
    }
    return tmp;
  };
  protoOf(HierarchyUtils).hasAncestor = function (entity, ancestor) {
    var currentEntity = entity;
    while (!(currentEntity == null)) {
      if (equals(currentEntity, ancestor))
        return true;
      currentEntity = get_parent(currentEntity);
    }
    return false;
  };
  protoOf(HierarchyUtils).getAncestors = function (entity) {
    var parent = get_parent(entity);
    var entities = mutableListOf([entity]);
    while (!(parent == null)) {
      entities.q(parent);
      parent = get_parent(parent);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(entities);
  };
  protoOf(HierarchyUtils).findInUpwardsHierarchy = function (entity, finder) {
    var res = {_v: null};
    findInUpwardsHierarchy$iterate(res, finder, entity);
    return res._v;
  };
  var HierarchyUtils_instance;
  function HierarchyUtils_getInstance() {
    return HierarchyUtils_instance;
  }
  function get_descendants(_this__u8e3s4) {
    return HierarchyUtils_instance.descendants(_this__u8e3s4);
  }
  function setParentMaintainWorldTransform(_this__u8e3s4, parent) {
    var pos = get_worldPosition(_this__u8e3s4);
    var rot = get_worldRotation(_this__u8e3s4);
    setParent(_this__u8e3s4, parent);
    TransformUtils_instance.setWorldTransform(_this__u8e3s4, new Transform(pos, rot));
  }
  function get_hierarchy(_this__u8e3s4) {
    return HierarchyUtils_instance.hierarchy(_this__u8e3s4);
  }
  function get_children(_this__u8e3s4) {
    return HierarchyUtils_instance.children(_this__u8e3s4);
  }
  function setParent(_this__u8e3s4, parent) {
    if (!(parent == null)) {
      _this__u8e3s4.addComponent(new ChildComponent(parent));
    } else {
      _this__u8e3s4.removeComponent(17);
    }
  }
  function hierarchyExceptSubTreesWithComponentArray(_this__u8e3s4, componentId) {
    return HierarchyUtils_instance.hierarchyExceptSubTreesWithComponent(_this__u8e3s4, componentId);
  }
  function forEachInHierarchy(_this__u8e3s4, func) {
    return HierarchyUtils_instance.forEachInHierarchy(_this__u8e3s4, func);
  }
  function findInHierarchy(_this__u8e3s4, finder) {
    return HierarchyUtils_instance.findInHierarchy(_this__u8e3s4, finder);
  }
  function get_hierarchySequence(_this__u8e3s4) {
    return hierarchyExceptSubTreeSequence(_this__u8e3s4, null);
  }
  function hierarchyExceptSubTreeArray(_this__u8e3s4, subTreeRoot) {
    var l = ArrayList_init_$Create$_0(20);
    hierarchyExceptSubTreeArray$add(subTreeRoot, l, _this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(l);
  }
  function findWithComponentInUpwardsHierarchy(_this__u8e3s4, componentId) {
    return HierarchyUtils_instance.findWithComponentInUpwardsHierarchy(_this__u8e3s4, componentId);
  }
  function hierarchyExceptSubTreeSequence(_this__u8e3s4, subtreeRoot) {
    return hierarchyExceptSubTreeSequence$iterateHierarchySequence(subtreeRoot, _this__u8e3s4);
  }
  function hierarchyExceptSubTreesWithComponentSequence(_this__u8e3s4, componentId) {
    return hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence(_this__u8e3s4, componentId, _this__u8e3s4);
  }
  function findInHierarchyExceptHierarchyOfIgnored(_this__u8e3s4, ignored, func) {
    return HierarchyUtils_instance.findInHierarchyExceptHierarchyOfIgnored(_this__u8e3s4, ignored, func);
  }
  function filterInHierarchy(_this__u8e3s4, finder) {
    return HierarchyUtils_instance.filterInHierarchy(_this__u8e3s4, finder);
  }
  function hasComponentInUpwardsHierarchy(_this__u8e3s4, componentId) {
    return HierarchyUtils_instance.hasComponentInUpwardsHierarchy(_this__u8e3s4, componentId);
  }
  function get_childrenSequence(_this__u8e3s4) {
    var parentComponent = _this__u8e3s4.__getComponentForKotlin(16);
    var tmp1_safe_receiver = parentComponent == null ? null : parentComponent.children;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : asSequence_0(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? emptySequence() : tmp2_elvis_lhs;
  }
  function forEachInHierarchyExceptHierarchyOfIgnored(_this__u8e3s4, ignored, func) {
    return HierarchyUtils_instance.forEachInHierarchyExceptHierarchyOfIgnored(_this__u8e3s4, ignored, func);
  }
  function hierarchyContains(_this__u8e3s4, entity) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = get_hierarchySequence(_this__u8e3s4).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.hierarchies.hierarchyContains.<anonymous>' call
        if (element.equals(entity)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function get_upwardsHierarchy(_this__u8e3s4) {
    return HierarchyUtils_instance.getAncestors(_this__u8e3s4);
  }
  function getHierarchyWithComponent(_this__u8e3s4, componentId) {
    return HierarchyUtils_instance.getHierarchyWithComponent(_this__u8e3s4, componentId);
  }
  function isDescendantOf(_this__u8e3s4, other) {
    return HierarchyUtils_instance.isDescendantOf(_this__u8e3s4, other);
  }
  function forEachInHierarchyExceptSubHierarchiesWithComponent(_this__u8e3s4, componentId, func) {
    return HierarchyUtils_instance.forEachInHierarchyExceptSubHierarchiesWithComponent(_this__u8e3s4, componentId, func);
  }
  function hierarchyExceptSubTreeArray$add($subTreeRoot, l, e) {
    if (!(e.id === $subTreeRoot.id)) {
      l.q(e);
      var tmp0_safe_receiver = get_parentComponent(e);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          hierarchyExceptSubTreeArray$add($subTreeRoot, l, element);
        }
      }
    }
  }
  function hierarchyExceptSubTreeSequence$iterateHierarchySequence($subtreeRoot, e) {
    if (!e.equals($subtreeRoot)) {
      return sequence(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda_0(e, $subtreeRoot, null));
    }
    return emptySequence();
  }
  function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence($this_hierarchyExceptSubTreesWithComponentSequence, $componentId, e) {
    if (e.equals($this_hierarchyExceptSubTreesWithComponentSequence) ? true : !e.hasComponent($componentId)) {
      return sequence(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda_0(e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, null));
    }
    return emptySequence();
  }
  function hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda$lambda($subtreeRoot) {
    return function (it) {
      return hierarchyExceptSubTreeSequence$iterateHierarchySequence($subtreeRoot, it);
    };
  }
  function hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda($e, $subtreeRoot, resultContinuation) {
    this.e29_1 = $e;
    this.f29_1 = $subtreeRoot;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).h29 = function ($this$sequence, $completion) {
    var tmp = this.i29($this$sequence, $completion);
    tmp.pc_1 = Unit_instance;
    tmp.qc_1 = null;
    return tmp.yc();
  };
  protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).ld = function (p1, $completion) {
    return this.h29(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).yc = function () {
    var suspendResult = this.pc_1;
    $sm: do
      try {
        var tmp = this.nc_1;
        switch (tmp) {
          case 0:
            this.oc_1 = 3;
            this.nc_1 = 1;
            suspendResult = this.g29_1.df(this.e29_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.nc_1 = 2;
            var tmp_0 = get_childrenSequence(this.e29_1);
            suspendResult = this.g29_1.ff(flatMap(tmp_0, hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda$lambda(this.f29_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.qc_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.oc_1 === 3) {
          throw e;
        } else {
          this.nc_1 = this.oc_1;
          this.qc_1 = e;
        }
      }
     while (true);
  };
  protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).i29 = function ($this$sequence, completion) {
    var i = new hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda(this.e29_1, this.f29_1, completion);
    i.g29_1 = $this$sequence;
    return i;
  };
  function hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda_0($e, $subtreeRoot, resultContinuation) {
    var i = new hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda($e, $subtreeRoot, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.h29($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda$lambda($this_hierarchyExceptSubTreesWithComponentSequence, $componentId) {
    return function (it) {
      return hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence($this_hierarchyExceptSubTreesWithComponentSequence, $componentId, it);
    };
  }
  function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda($e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, resultContinuation) {
    this.r29_1 = $e;
    this.s29_1 = $this_hierarchyExceptSubTreesWithComponentSequence;
    this.t29_1 = $componentId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).h29 = function ($this$sequence, $completion) {
    var tmp = this.i29($this$sequence, $completion);
    tmp.pc_1 = Unit_instance;
    tmp.qc_1 = null;
    return tmp.yc();
  };
  protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).ld = function (p1, $completion) {
    return this.h29(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).yc = function () {
    var suspendResult = this.pc_1;
    $sm: do
      try {
        var tmp = this.nc_1;
        switch (tmp) {
          case 0:
            this.oc_1 = 3;
            this.nc_1 = 1;
            suspendResult = this.u29_1.df(this.r29_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.nc_1 = 2;
            var tmp_0 = get_childrenSequence(this.r29_1);
            suspendResult = this.u29_1.ff(flatMap(tmp_0, hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda$lambda(this.s29_1, this.t29_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.qc_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.oc_1 === 3) {
          throw e;
        } else {
          this.nc_1 = this.oc_1;
          this.qc_1 = e;
        }
      }
     while (true);
  };
  protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).i29 = function ($this$sequence, completion) {
    var i = new hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda(this.r29_1, this.s29_1, this.t29_1, completion);
    i.u29_1 = $this$sequence;
    return i;
  };
  function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda_0($e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, resultContinuation) {
    var i = new hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda($e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.h29($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function InSceneComponent() {
  }
  protoOf(InSceneComponent).x1k = function () {
    return this.id;
  };
  protoOf(InSceneComponent).s1k = function () {
    return 5;
  };
  protoOf(InSceneComponent).eq = function (other) {
    return true;
  };
  var InSceneComponent_instance;
  function InSceneComponent_getInstance() {
    return InSceneComponent_instance;
  }
  function get_isInScene(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(InSceneComponent_instance.id) ? true : _this__u8e3s4.hasComponent(SceneComponent_instance.id);
  }
  function generateHierarchy($this, me) {
    var res = ArrayList_init_$Create$_0(20);
    if (me == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.hierarchies.ParentComponent.generateHierarchy.<anonymous>' call
      res.q(me);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.children;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      generateHierarchy$add(res, element);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(res);
  }
  function generateHierarchy$default($this, me, $super) {
    me = me === VOID ? null : me;
    return generateHierarchy($this, me);
  }
  function Companion_49() {
    this.id = 16;
  }
  protoOf(Companion_49).s1k = function () {
    return this.id;
  };
  var Companion_instance_49;
  function Companion_getInstance_50() {
    return Companion_instance_49;
  }
  function generateHierarchy$add(res, e) {
    res.q(e);
    var tmp0_safe_receiver = get_parentComponent(e);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        generateHierarchy$add(res, element);
      }
    }
  }
  function ParentComponent(children) {
    this.children = children;
  }
  protoOf(ParentComponent).c1k = function () {
    return this.children;
  };
  protoOf(ParentComponent).x1k = function () {
    return 16;
  };
  protoOf(ParentComponent).addChild = function (c) {
    var tmp;
    if (contains(this.children, c)) {
      tmp = this;
    } else {
      // Inline function 'kotlin.collections.plusElement' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = this.children;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [c];
      var tmp$ret$4 = tmp$ret$0.concat(tmp$ret$3);
      tmp = new ParentComponent(tmp$ret$4);
    }
    return tmp;
  };
  protoOf(ParentComponent).removeChild = function (c) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.children;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.ParentComponent.removeChild.<anonymous>' call
      if (!c.equals(element)) {
        destination.q(element);
      }
    }
    var tmp$ret$3 = copyToArray(destination);
    return new ParentComponent(tmp$ret$3);
  };
  protoOf(ParentComponent).addChildren = function (newChildren) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var setOfChildren = LinkedHashSet_init_$Create$();
    addAll_1(setOfChildren, this.children);
    addAll_1(setOfChildren, newChildren);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$1 = copyToArray(setOfChildren);
    return new ParentComponent(tmp$ret$1);
  };
  protoOf(ParentComponent).hierarchy = function (me) {
    return generateHierarchy(this, me);
  };
  protoOf(ParentComponent).allDescendants = function () {
    return generateHierarchy$default(this);
  };
  protoOf(ParentComponent).eq = function (other) {
    var otherParent = other instanceof ParentComponent ? other : THROW_CCE();
    var tmp;
    if (otherParent.children.length === this.children.length) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var indexedObject = this.children;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.hierarchies.ParentComponent.eq.<anonymous>' call
          if (!contains(otherParent.children, element)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ParentComponent).equals = function (other) {
    var tmp;
    if (other instanceof ParentComponent) {
      var tmp_0;
      if (other.children.length === this.children.length) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.all' call
          var indexedObject = this.children;
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var element = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.hierarchies.ParentComponent.equals.<anonymous>' call
            if (!contains(other.children, element)) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        tmp_0 = tmp$ret$1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ParentComponent).hashCode = function () {
    return hashCode(this.children);
  };
  protoOf(ParentComponent).af = function () {
    return this.children;
  };
  protoOf(ParentComponent).v29 = function (children) {
    return new ParentComponent(children);
  };
  protoOf(ParentComponent).copy = function (children, $super) {
    children = children === VOID ? this.children : children;
    return this.v29(children);
  };
  protoOf(ParentComponent).toString = function () {
    return 'ParentComponent(children=' + toString(this.children) + ')';
  };
  function get_parentComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(16);
  }
  function SceneComponent() {
  }
  protoOf(SceneComponent).x1k = function () {
    return this.id;
  };
  protoOf(SceneComponent).s1k = function () {
    return 97;
  };
  protoOf(SceneComponent).eq = function (other) {
    return true;
  };
  var SceneComponent_instance;
  function SceneComponent_getInstance() {
    return SceneComponent_instance;
  }
  function Companion_50() {
    this.ID = 'SceneGraphSystem';
  }
  protoOf(Companion_50).u1n = function () {
    return this.ID;
  };
  var Companion_instance_50;
  function Companion_getInstance_51() {
    return Companion_instance_50;
  }
  function updateWithInfoFromParent($this, entity) {
    var tmp = HierarchyUtils_instance;
    tmp.forEachInHierarchy(entity, SceneGraphSystem$updateWithInfoFromParent$update$ref($this));
  }
  function isScene($this, entity) {
    return entity.hasComponent(SceneComponent_instance.id);
  }
  function removeInSceneComponent($this, entity) {
    if (isInScene($this, entity)) {
      entity.removeComponent(InSceneComponent_instance.id);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.SceneGraphSystem.removeInSceneComponent.<anonymous>' call
        removeInSceneComponent($this, element);
      }
    }
  }
  function isInScene($this, entity) {
    return !(entity == null) ? get_isInScene(entity) : false;
  }
  function updateWithInfoFromParent$update(this$0, e) {
    if (e.isDisposed)
      return Unit_instance;
    var tmp;
    if (isScene(this$0, e)) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp0_safe_receiver = get_parent(e);
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isDisposed) === false) {
        tmp_0 = isInScene(this$0, get_parent(e));
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      if (!isInScene(this$0, e)) {
        e.addComponent(InSceneComponent_instance);
      }
    } else {
      removeInSceneComponent(this$0, e);
    }
  }
  function SceneGraphSystem$updateWithInfoFromParent$update$ref(this$0) {
    var l = function (p0) {
      updateWithInfoFromParent$update(this$0, p0);
      return Unit_instance;
    };
    l.callableName = 'update';
    return l;
  }
  function SceneGraphSystem(sceneManager) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [5];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['HierarchySystem'];
    SystemBase.call(this, 'SceneGraphSystem', 17, tmp, tmp$ret$5, null);
    this.sceneManager = sceneManager;
  }
  protoOf(SceneGraphSystem).q1i = function () {
    return this.sceneManager;
  };
  protoOf(SceneGraphSystem).onAddComponent = function (entity, newComponent) {
    updateWithInfoFromParent(this, entity);
  };
  protoOf(SceneGraphSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    updateWithInfoFromParent(this, entity);
  };
  protoOf(SceneGraphSystem).onRemoveComponent = function (entity, oldComponent) {
    entity.removeComponent(InSceneComponent_instance.id);
    updateWithInfoFromParent(this, entity);
  };
  function SceneManager() {
  }
  function History() {
  }
  var HistoryEventType_TAKE_SNAPSHOT_instance;
  var HistoryEventType_UNDO_instance;
  var HistoryEventType_REDO_instance;
  var HistoryEventType_CLEAR_instance;
  var HistoryEventType_DISCARD_SNAPSHOT_instance;
  function values_2() {
    return [HistoryEventType_TAKE_SNAPSHOT_getInstance(), HistoryEventType_UNDO_getInstance(), HistoryEventType_REDO_getInstance(), HistoryEventType_CLEAR_getInstance(), HistoryEventType_DISCARD_SNAPSHOT_getInstance()];
  }
  function valueOf_2(value) {
    switch (value) {
      case 'TAKE_SNAPSHOT':
        return HistoryEventType_TAKE_SNAPSHOT_getInstance();
      case 'UNDO':
        return HistoryEventType_UNDO_getInstance();
      case 'REDO':
        return HistoryEventType_REDO_getInstance();
      case 'CLEAR':
        return HistoryEventType_CLEAR_getInstance();
      case 'DISCARD_SNAPSHOT':
        return HistoryEventType_DISCARD_SNAPSHOT_getInstance();
      default:
        HistoryEventType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var HistoryEventType_entriesInitialized;
  function HistoryEventType_initEntries() {
    if (HistoryEventType_entriesInitialized)
      return Unit_instance;
    HistoryEventType_entriesInitialized = true;
    HistoryEventType_TAKE_SNAPSHOT_instance = new HistoryEventType('TAKE_SNAPSHOT', 0);
    HistoryEventType_UNDO_instance = new HistoryEventType('UNDO', 1);
    HistoryEventType_REDO_instance = new HistoryEventType('REDO', 2);
    HistoryEventType_CLEAR_instance = new HistoryEventType('CLEAR', 3);
    HistoryEventType_DISCARD_SNAPSHOT_instance = new HistoryEventType('DISCARD_SNAPSHOT', 4);
  }
  function HistoryEventType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function HistoryEvent() {
    this.TAKE_SNAPSHOT = 'TAKE_SNAPSHOT';
    this.UNDO = 'UNDO';
    this.REDO = 'REDO';
    this.CLEAR = 'CLEAR';
    this.DISCARD_SNAPSHOT = 'DISCARD_SNAPSHOT';
  }
  protoOf(HistoryEvent).k2a = function () {
    return this.TAKE_SNAPSHOT;
  };
  protoOf(HistoryEvent).l2a = function () {
    return this.UNDO;
  };
  protoOf(HistoryEvent).m2a = function () {
    return this.REDO;
  };
  protoOf(HistoryEvent).n2a = function () {
    return this.CLEAR;
  };
  protoOf(HistoryEvent).o2a = function () {
    return this.DISCARD_SNAPSHOT;
  };
  var HistoryEvent_instance;
  function HistoryEvent_getInstance() {
    return HistoryEvent_instance;
  }
  function Companion_51() {
    this.id = 88;
  }
  protoOf(Companion_51).s1k = function () {
    return this.id;
  };
  var Companion_instance_51;
  function Companion_getInstance_52() {
    return Companion_instance_51;
  }
  function HistoryChangedEventComponent(historyEventType) {
    this.historyEventType = historyEventType;
    this.p2a_1 = 88;
  }
  protoOf(HistoryChangedEventComponent).q2a = function () {
    return this.historyEventType;
  };
  protoOf(HistoryChangedEventComponent).x1k = function () {
    return this.p2a_1;
  };
  protoOf(HistoryChangedEventComponent).r2a = function () {
    return this.historyEventType.w9_1;
  };
  protoOf(HistoryChangedEventComponent).eq = function (other) {
    return true;
  };
  function triggerHistoryChangedEvent(_this__u8e3s4, type, entityManager) {
    entityManager.addComponent(_this__u8e3s4, new HistoryChangedEventComponent(type));
    entityManager.removeComponent(_this__u8e3s4, 88);
  }
  function HistoryEventType_TAKE_SNAPSHOT_getInstance() {
    HistoryEventType_initEntries();
    return HistoryEventType_TAKE_SNAPSHOT_instance;
  }
  function HistoryEventType_UNDO_getInstance() {
    HistoryEventType_initEntries();
    return HistoryEventType_UNDO_instance;
  }
  function HistoryEventType_REDO_getInstance() {
    HistoryEventType_initEntries();
    return HistoryEventType_REDO_instance;
  }
  function HistoryEventType_CLEAR_getInstance() {
    HistoryEventType_initEntries();
    return HistoryEventType_CLEAR_instance;
  }
  function HistoryEventType_DISCARD_SNAPSHOT_getInstance() {
    HistoryEventType_initEntries();
    return HistoryEventType_DISCARD_SNAPSHOT_instance;
  }
  function makeFreeSlots($this) {
    if ($this.v2a_1.size >= $this.maxHistorySize) {
      removeOld($this);
    }
  }
  function purgeFutureSnapshots($this) {
    while ($this.v2a_1.size > 0 ? $this.v2a_1.size > $this.u2a_1 : false) {
      $this.v2a_1.removeLast();
      triggerHistoryChangedEvent($this.t2a_1, HistoryEventType_DISCARD_SNAPSHOT_getInstance(), $this.entityManager);
    }
  }
  function removeOld($this) {
    $this.v2a_1.removeFirst();
    $this.u2a_1 = $this.u2a_1 - 1 | 0;
  }
  function _get_isAtTopOfStack__ylrnny($this) {
    return $this.u2a_1 >= ($this.v2a_1.size - 1 | 0);
  }
  function HistoryImpl(entityManager, snapshotService, maxHistorySize) {
    maxHistorySize = maxHistorySize === VOID ? 500 : maxHistorySize;
    this.entityManager = entityManager;
    this.snapshotService = snapshotService;
    this.maxHistorySize = maxHistorySize;
    if (this.maxHistorySize < 1) {
      throw Exception_init_$Create$('History was initialized with size ' + this.maxHistorySize + ', please initialize with at least size 2.');
    }
    this.s2a_1 = false;
    this.t2a_1 = this.entityManager.createEntity();
    this.u2a_1 = 0;
    this.v2a_1 = new CircularBuffer(this.maxHistorySize);
  }
  protoOf(HistoryImpl).p1i = function () {
    return this.entityManager;
  };
  protoOf(HistoryImpl).v1i = function () {
    return this.snapshotService;
  };
  protoOf(HistoryImpl).w2a = function () {
    return this.maxHistorySize;
  };
  protoOf(HistoryImpl).g2a = function () {
    return this.s2a_1;
  };
  protoOf(HistoryImpl).h2a = function (snapshotName) {
    if (this.isPaused)
      return Unit_instance;
    makeFreeSlots(this);
    purgeFutureSnapshots(this);
    this.v2a_1.add(this.snapshotService.takeSnapshot(snapshotName));
    this.u2a_1 = this.u2a_1 + 1 | 0;
    triggerHistoryChangedEvent(this.t2a_1, HistoryEventType_TAKE_SNAPSHOT_getInstance(), this.entityManager);
  };
  protoOf(HistoryImpl).getSnapshots = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.v2a_1.toList();
    return copyToArray(this_0);
  };
  protoOf(HistoryImpl).discardLatestSnapshot = function () {
    this.v2a_1.removeLast();
    if (this.v2a_1.size < this.u2a_1) {
      this.u2a_1 = this.u2a_1 - 1 | 0;
    }
    triggerHistoryChangedEvent(this.t2a_1, HistoryEventType_DISCARD_SNAPSHOT_getInstance(), this.entityManager);
  };
  protoOf(HistoryImpl).clear = function () {
    this.u2a_1 = 0;
    this.v2a_1.clear();
    this.s2a_1 = false;
    triggerHistoryChangedEvent(this.t2a_1, HistoryEventType_CLEAR_getInstance(), this.entityManager);
  };
  protoOf(HistoryImpl).redo = function () {
    if (this.isPaused)
      return Unit_instance;
    if (this.canRedo()) {
      this.u2a_1 = this.u2a_1 + 1 | 0;
      var snapshot = this.v2a_1.get(this.u2a_1);
      this.snapshotService.loadSnapshot(snapshot);
      if (_get_isAtTopOfStack__ylrnny(this)) {
        this.discardLatestSnapshot();
      }
      triggerHistoryChangedEvent(this.t2a_1, HistoryEventType_REDO_getInstance(), this.entityManager);
    }
  };
  protoOf(HistoryImpl).undo = function () {
    if (this.isPaused)
      return Unit_instance;
    if (this.canUndo()) {
      if (_get_isAtTopOfStack__ylrnny(this)) {
        this.takeSnapshot('undo temp snapshot');
        this.u2a_1 = this.u2a_1 - 1 | 0;
      }
      this.u2a_1 = this.u2a_1 - 1 | 0;
      var snapshot = this.v2a_1.get(this.u2a_1);
      this.snapshotService.loadSnapshot(snapshot);
      triggerHistoryChangedEvent(this.t2a_1, HistoryEventType_UNDO_getInstance(), this.entityManager);
    }
  };
  protoOf(HistoryImpl).canUndo = function () {
    return this.u2a_1 > 0;
  };
  protoOf(HistoryImpl).pause = function () {
    this.s2a_1 = true;
  };
  protoOf(HistoryImpl).unPause = function () {
    this.s2a_1 = false;
  };
  protoOf(HistoryImpl).canRedo = function () {
    return !_get_isAtTopOfStack__ylrnny(this);
  };
  protoOf(HistoryImpl).historySize = function () {
    return this.v2a_1.size;
  };
  protoOf(HistoryImpl).getHistory = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.v2a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.history.HistoryImpl.getHistory.<anonymous>' call
      var tmp$ret$0 = item.name;
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(HistoryImpl).remainingItemsToUndo = function () {
    return this.u2a_1;
  };
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARN_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_NONE_instance;
  function values_3() {
    return [LogLevel_DEBUG_getInstance(), LogLevel_INFO_getInstance(), LogLevel_WARN_getInstance(), LogLevel_ERROR_getInstance(), LogLevel_NONE_getInstance()];
  }
  function valueOf_3(value) {
    switch (value) {
      case 'DEBUG':
        return LogLevel_DEBUG_getInstance();
      case 'INFO':
        return LogLevel_INFO_getInstance();
      case 'WARN':
        return LogLevel_WARN_getInstance();
      case 'ERROR':
        return LogLevel_ERROR_getInstance();
      case 'NONE':
        return LogLevel_NONE_getInstance();
      default:
        LogLevel_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 0);
    LogLevel_INFO_instance = new LogLevel('INFO', 1);
    LogLevel_WARN_instance = new LogLevel('WARN', 2);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 3);
    LogLevel_NONE_instance = new LogLevel('NONE', 4);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LogLevelJavascriptImpostor() {
    this.DEBUG = 0;
    this.INFO = 1;
    this.WARN = 2;
    this.ERROR = 3;
    this.NONE = 4;
  }
  protoOf(LogLevelJavascriptImpostor).z2a = function () {
    return this.DEBUG;
  };
  protoOf(LogLevelJavascriptImpostor).a2b = function () {
    return this.INFO;
  };
  protoOf(LogLevelJavascriptImpostor).b2b = function () {
    return this.WARN;
  };
  protoOf(LogLevelJavascriptImpostor).c2b = function () {
    return this.ERROR;
  };
  protoOf(LogLevelJavascriptImpostor).h22 = function () {
    return this.NONE;
  };
  var LogLevelJavascriptImpostor_instance;
  function LogLevelJavascriptImpostor_getInstance() {
    return LogLevelJavascriptImpostor_instance;
  }
  function LogLevel_DEBUG_getInstance() {
    LogLevel_initEntries();
    return LogLevel_DEBUG_instance;
  }
  function LogLevel_INFO_getInstance() {
    LogLevel_initEntries();
    return LogLevel_INFO_instance;
  }
  function LogLevel_WARN_getInstance() {
    LogLevel_initEntries();
    return LogLevel_WARN_instance;
  }
  function LogLevel_ERROR_getInstance() {
    LogLevel_initEntries();
    return LogLevel_ERROR_instance;
  }
  function LogLevel_NONE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_NONE_instance;
  }
  function Logger() {
  }
  function LoggerImpl() {
    this.h2b_1 = LogLevel_ERROR_getInstance();
  }
  protoOf(LoggerImpl).d2b = function (_set____db54di) {
    this.h2b_1 = _set____db54di;
  };
  protoOf(LoggerImpl).e2b = function () {
    return this.h2b_1;
  };
  protoOf(LoggerImpl).debug = function (f) {
    if (this.h2b_1.y9(LogLevel_DEBUG_getInstance()) <= 0) {
      echoStandardConsole(f());
    }
  };
  protoOf(LoggerImpl).error = function (f) {
    if (this.h2b_1.y9(LogLevel_ERROR_getInstance()) <= 0) {
      echoStandardConsole(f());
    }
  };
  protoOf(LoggerImpl).warn = function (f) {
    if (this.h2b_1.y9(LogLevel_WARN_getInstance()) <= 0) {
      echoStandardConsole(f());
    }
  };
  protoOf(LoggerImpl).info = function (f) {
    if (this.h2b_1.y9(LogLevel_INFO_getInstance()) <= 0) {
      echoStandardConsole(f());
    }
  };
  function LoggerState$LoggerWrap$debug$lambda(this$0, $f) {
    return function () {
      return this$0.i2b_1 + $f();
    };
  }
  function LoggerState$LoggerWrap$error$lambda(this$0, $f) {
    return function () {
      return this$0.i2b_1 + $f();
    };
  }
  function LoggerState$LoggerWrap$warn$lambda(this$0, $f) {
    return function () {
      return this$0.i2b_1 + $f();
    };
  }
  function LoggerState$LoggerWrap$info$lambda(this$0, $f) {
    return function () {
      return this$0.i2b_1 + $f();
    };
  }
  function LoggerWrap(packageColon) {
    this.i2b_1 = packageColon;
  }
  protoOf(LoggerWrap).d2b = function (_anonymous_parameter_0__qggqh8) {
  };
  protoOf(LoggerWrap).e2b = function () {
    return LoggerState_getInstance().y1i_1.level;
  };
  protoOf(LoggerWrap).debug = function (f) {
    var tmp = LoggerState_getInstance().y1i_1;
    tmp.debug(LoggerState$LoggerWrap$debug$lambda(this, f));
  };
  protoOf(LoggerWrap).error = function (f) {
    var tmp = LoggerState_getInstance().y1i_1;
    tmp.error(LoggerState$LoggerWrap$error$lambda(this, f));
  };
  protoOf(LoggerWrap).warn = function (f) {
    var tmp = LoggerState_getInstance().y1i_1;
    tmp.warn(LoggerState$LoggerWrap$warn$lambda(this, f));
  };
  protoOf(LoggerWrap).info = function (f) {
    var tmp = LoggerState_getInstance().y1i_1;
    tmp.info(LoggerState$LoggerWrap$info$lambda(this, f));
  };
  function LoggerState() {
    LoggerState_instance = this;
    this.y1i_1 = new LoggerImpl();
    this.z1i_1 = 'com.ikea';
  }
  protoOf(LoggerState).j2b = function (level) {
    this.y1i_1.level = level;
  };
  protoOf(LoggerState).k2b = function (logger, basePackageName) {
    this.y1i_1 = logger;
    this.z1i_1 = basePackageName;
  };
  protoOf(LoggerState).m1m = function (packageName) {
    return this.z1i_1 === '' ? new LoggerWrap(packageName + ':') : new LoggerWrap(this.z1i_1 + '.' + packageName + ':');
  };
  protoOf(LoggerState).a1j = function () {
    return this.y1i_1;
  };
  var LoggerState_instance;
  function LoggerState_getInstance() {
    if (LoggerState_instance == null)
      new LoggerState();
    return LoggerState_instance;
  }
  function MockLogger() {
    this.l2b_1 = LogLevel_DEBUG_getInstance();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.debugLog = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.errorLog = ArrayList_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.warnLog = ArrayList_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.infoLog = ArrayList_init_$Create$();
  }
  protoOf(MockLogger).d2b = function (_set____db54di) {
    this.l2b_1 = _set____db54di;
  };
  protoOf(MockLogger).e2b = function () {
    return this.l2b_1;
  };
  protoOf(MockLogger).m2b = function () {
    return this.debugLog;
  };
  protoOf(MockLogger).debug = function (f) {
    if (this.l2b_1.y9(LogLevel_DEBUG_getInstance()) <= 0) {
      this.debugLog.q(f());
    }
  };
  protoOf(MockLogger).n2b = function () {
    return this.errorLog;
  };
  protoOf(MockLogger).error = function (f) {
    if (this.l2b_1.y9(LogLevel_ERROR_getInstance()) <= 0) {
      this.errorLog.q(f());
    }
  };
  protoOf(MockLogger).o2b = function () {
    return this.warnLog;
  };
  protoOf(MockLogger).warn = function (f) {
    if (this.l2b_1.y9(LogLevel_WARN_getInstance()) <= 0) {
      this.warnLog.q(f());
    }
  };
  protoOf(MockLogger).p2b = function () {
    return this.infoLog;
  };
  protoOf(MockLogger).info = function (f) {
    if (this.l2b_1.y9(LogLevel_INFO_getInstance()) <= 0) {
      this.infoLog.q(f());
    }
  };
  protoOf(MockLogger).getDebugLogFor = function (packageName) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.debugLog;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.logging.MockLogger.getDebugLogFor.<anonymous>' call
      var tmp0_safe_receiver = firstOrNull_1(split(toString_0(element), charArrayOf([_Char___init__impl__6a9atx(58)])));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contains_0(tmp0_safe_receiver, packageName);
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        destination.q(element);
      }
    }
    return destination;
  };
  protoOf(MockLogger).getInfoLogFor = function (packageName) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.infoLog;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.logging.MockLogger.getInfoLogFor.<anonymous>' call
      var tmp0_safe_receiver = firstOrNull_1(split(toString_0(element), charArrayOf([_Char___init__impl__6a9atx(58)])));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contains_0(tmp0_safe_receiver, packageName);
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        destination.q(element);
      }
    }
    return destination;
  };
  protoOf(MockLogger).getWarnLogFor = function (packageName) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.warnLog;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.logging.MockLogger.getWarnLogFor.<anonymous>' call
      var tmp0_safe_receiver = firstOrNull_1(split(toString_0(element), charArrayOf([_Char___init__impl__6a9atx(58)])));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contains_0(tmp0_safe_receiver, packageName);
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        destination.q(element);
      }
    }
    return destination;
  };
  protoOf(MockLogger).getErrorLogFor = function (packageName) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.errorLog;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.logging.MockLogger.getErrorLogFor.<anonymous>' call
      var tmp0_safe_receiver = firstOrNull_1(split(toString_0(element), charArrayOf([_Char___init__impl__6a9atx(58)])));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contains_0(tmp0_safe_receiver, packageName);
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        destination.q(element);
      }
    }
    return destination;
  };
  protoOf(MockLogger).resetMockLogger = function () {
    this.debugLog.z();
    this.errorLog.z();
    this.warnLog.z();
    this.infoLog.z();
  };
  function AxisAngle(axis, angle) {
    this.axis = axis;
    this.angle = angle;
  }
  protoOf(AxisAngle).q2b = function () {
    return this.axis;
  };
  protoOf(AxisAngle).r2b = function () {
    return this.angle;
  };
  protoOf(AxisAngle).af = function () {
    return this.axis;
  };
  protoOf(AxisAngle).bf = function () {
    return this.angle;
  };
  protoOf(AxisAngle).s2b = function (axis, angle) {
    return new AxisAngle(axis, angle);
  };
  protoOf(AxisAngle).copy = function (axis, angle, $super) {
    axis = axis === VOID ? this.axis : axis;
    angle = angle === VOID ? this.angle : angle;
    return this.s2b(axis, angle);
  };
  protoOf(AxisAngle).toString = function () {
    return 'AxisAngle(axis=' + this.axis + ', angle=' + this.angle + ')';
  };
  protoOf(AxisAngle).hashCode = function () {
    var result = this.axis.hashCode();
    result = imul(result, 31) + this.angle.hashCode() | 0;
    return result;
  };
  protoOf(AxisAngle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AxisAngle))
      return false;
    var tmp0_other_with_cast = other instanceof AxisAngle ? other : THROW_CCE();
    if (!this.axis.equals(tmp0_other_with_cast.axis))
      return false;
    if (!this.angle.equals(tmp0_other_with_cast.angle))
      return false;
    return true;
  };
  function Degrees(value) {
    this.value = value;
  }
  protoOf(Degrees).u2 = function () {
    return this.value;
  };
  protoOf(Degrees).toRadian = function () {
    Companion_getInstance_57();
    return new Radians(this.value * 0.017453292519943295);
  };
  protoOf(Degrees).af = function () {
    return this.value;
  };
  protoOf(Degrees).t2b = function (value) {
    return new Degrees(value);
  };
  protoOf(Degrees).copy = function (value, $super) {
    value = value === VOID ? this.value : value;
    return this.t2b(value);
  };
  protoOf(Degrees).toString = function () {
    return 'Degrees(value=' + this.value + ')';
  };
  protoOf(Degrees).hashCode = function () {
    return getNumberHashCode(this.value);
  };
  protoOf(Degrees).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Degrees))
      return false;
    var tmp0_other_with_cast = other instanceof Degrees ? other : THROW_CCE();
    if (!equals(this.value, tmp0_other_with_cast.value))
      return false;
    return true;
  };
  function Dimension() {
  }
  function DualDouble(first, last) {
    this.first = first;
    this.last = last;
  }
  protoOf(DualDouble).x2b = function (_set____db54di) {
    this.first = _set____db54di;
  };
  protoOf(DualDouble).o21 = function () {
    return this.first;
  };
  protoOf(DualDouble).y2b = function (_set____db54di) {
    this.last = _set____db54di;
  };
  protoOf(DualDouble).p21 = function () {
    return this.last;
  };
  protoOf(DualDouble).z2b = function () {
    return (this.first + this.last) / 2;
  };
  protoOf(DualDouble).a = function () {
    return this.last - this.first;
  };
  function Companion_52() {
  }
  protoOf(Companion_52).l17 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_52;
  function Companion_getInstance_53() {
    return Companion_instance_52;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Margin', this, 6);
    tmp0_serialDesc.cv('top', true);
    tmp0_serialDesc.cv('right', true);
    tmp0_serialDesc.cv('bottom', true);
    tmp0_serialDesc.cv('left', true);
    tmp0_serialDesc.cv('back', true);
    tmp0_serialDesc.cv('front', true);
    this.a2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ok = function () {
    return this.a2c_1;
  };
  protoOf($serializer_2).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  protoOf($serializer_2).qk = function (decoder) {
    var tmp0_desc = this.a2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_input = decoder.nn(tmp0_desc);
    if (tmp10_input.do()) {
      tmp4_local0 = tmp10_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.vn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.vn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.vn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.vn(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.vn(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.vn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.vn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.vn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.vn(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.vn(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.on(tmp0_desc);
    return Margin_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_2).b2c = function (encoder, value) {
    var tmp0_desc = this.a2c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !equals(value.top, 0.0)) {
      tmp1_output.ap(tmp0_desc, 0, value.top);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !equals(value.right, 0.0)) {
      tmp1_output.ap(tmp0_desc, 1, value.right);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !equals(value.bottom, 0.0)) {
      tmp1_output.ap(tmp0_desc, 2, value.bottom);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !equals(value.left, 0.0)) {
      tmp1_output.ap(tmp0_desc, 3, value.left);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !equals(value.back, 0.0)) {
      tmp1_output.ap(tmp0_desc, 4, value.back);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !equals(value.front, 0.0)) {
      tmp1_output.ap(tmp0_desc, 5, value.front);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_2).pk = function (encoder, value) {
    return this.b2c(encoder, value instanceof Margin ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function Margin_init_$Init$(seen1, top, right, bottom, left, back, front, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_2().a2c_1);
    }
    if (0 === (seen1 & 1))
      $this.top = 0.0;
    else
      $this.top = top;
    if (0 === (seen1 & 2))
      $this.right = 0.0;
    else
      $this.right = right;
    if (0 === (seen1 & 4))
      $this.bottom = 0.0;
    else
      $this.bottom = bottom;
    if (0 === (seen1 & 8))
      $this.left = 0.0;
    else
      $this.left = left;
    if (0 === (seen1 & 16))
      $this.back = 0.0;
    else
      $this.back = back;
    if (0 === (seen1 & 32))
      $this.front = 0.0;
    else
      $this.front = front;
    return $this;
  }
  function Margin_init_$Create$(seen1, top, right, bottom, left, back, front, serializationConstructorMarker) {
    return Margin_init_$Init$(seen1, top, right, bottom, left, back, front, serializationConstructorMarker, objectCreate(protoOf(Margin)));
  }
  function Margin(top, right, bottom, left, back, front) {
    top = top === VOID ? 0.0 : top;
    right = right === VOID ? 0.0 : right;
    bottom = bottom === VOID ? 0.0 : bottom;
    left = left === VOID ? 0.0 : left;
    back = back === VOID ? 0.0 : back;
    front = front === VOID ? 0.0 : front;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
    this.left = left;
    this.back = back;
    this.front = front;
  }
  protoOf(Margin).c2c = function () {
    return this.top;
  };
  protoOf(Margin).d2c = function () {
    return this.right;
  };
  protoOf(Margin).e2c = function () {
    return this.bottom;
  };
  protoOf(Margin).f2c = function () {
    return this.left;
  };
  protoOf(Margin).g2c = function () {
    return this.back;
  };
  protoOf(Margin).h2c = function () {
    return this.front;
  };
  protoOf(Margin).innerSize = function (size) {
    return new Vector(size.X - (this.left + this.right), size.Y - (this.top + this.bottom), size.Z - (this.front + this.back));
  };
  protoOf(Margin).innerOrigin = function () {
    return new Vector((this.left - this.right) / 2, (this.bottom - this.top) / 2, (this.back - this.front) / 2);
  };
  protoOf(Margin).outerSize = function (box) {
    return new Vector(box.X + (this.left + this.right), box.Y + (this.top + this.bottom), box.Z + (this.front + this.back));
  };
  protoOf(Margin).equal = function (value) {
    return new Margin(value, value, value, value, value, value);
  };
  protoOf(Margin).equals = function (other) {
    var tmp;
    if (other instanceof Margin) {
      tmp = ((((other.top === this.top ? other.right === this.right : false) ? other.bottom === this.bottom : false) ? other.left === this.left : false) ? other.back === this.back : false) ? other.front === this.front : false;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Margin).hashCode = function () {
    return numberToInt(this.top * 3 + this.right * 13 + this.bottom * 23 + this.left * 37 + this.back * 61 + this.front * 97);
  };
  protoOf(Margin).backBox = function (outerSize) {
    return new Vector(outerSize.width, outerSize.height, this.back);
  };
  protoOf(Margin).frontBox = function (outerSize) {
    return new Vector(outerSize.width, outerSize.height, this.front);
  };
  protoOf(Margin).rightBox = function (outerSize) {
    return new Vector(this.right, outerSize.height, outerSize.depth);
  };
  protoOf(Margin).leftBox = function (outerSize) {
    return new Vector(this.left, outerSize.height, outerSize.depth);
  };
  protoOf(Margin).topBox = function (outerSize) {
    return new Vector(outerSize.width, this.top, outerSize.depth);
  };
  protoOf(Margin).bottomBox = function (outerSize) {
    return new Vector(outerSize.width, this.bottom, outerSize.depth);
  };
  protoOf(Margin).af = function () {
    return this.top;
  };
  protoOf(Margin).bf = function () {
    return this.right;
  };
  protoOf(Margin).g1k = function () {
    return this.bottom;
  };
  protoOf(Margin).h1k = function () {
    return this.left;
  };
  protoOf(Margin).i1k = function () {
    return this.back;
  };
  protoOf(Margin).j1k = function () {
    return this.front;
  };
  protoOf(Margin).i2c = function (top, right, bottom, left, back, front) {
    return new Margin(top, right, bottom, left, back, front);
  };
  protoOf(Margin).copy = function (top, right, bottom, left, back, front, $super) {
    top = top === VOID ? this.top : top;
    right = right === VOID ? this.right : right;
    bottom = bottom === VOID ? this.bottom : bottom;
    left = left === VOID ? this.left : left;
    back = back === VOID ? this.back : back;
    front = front === VOID ? this.front : front;
    return this.i2c(top, right, bottom, left, back, front);
  };
  protoOf(Margin).toString = function () {
    return 'Margin(top=' + this.top + ', right=' + this.right + ', bottom=' + this.bottom + ', left=' + this.left + ', back=' + this.back + ', front=' + this.front + ')';
  };
  var Axis_X_instance;
  var Axis_Y_instance;
  var Axis_Z_instance;
  function values_4() {
    return [Axis_X_getInstance(), Axis_Y_getInstance(), Axis_Z_getInstance()];
  }
  function valueOf_4(value) {
    switch (value) {
      case 'X':
        return Axis_X_getInstance();
      case 'Y':
        return Axis_Y_getInstance();
      case 'Z':
        return Axis_Z_getInstance();
      default:
        Axis_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var Axis_entriesInitialized;
  function Axis_initEntries() {
    if (Axis_entriesInitialized)
      return Unit_instance;
    Axis_entriesInitialized = true;
    Axis_X_instance = new Axis('X', 0);
    Axis_Y_instance = new Axis('Y', 1);
    Axis_Z_instance = new Axis('Z', 2);
  }
  function Axis(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Axis_X_getInstance() {
    Axis_initEntries();
    return Axis_X_instance;
  }
  function Axis_Y_getInstance() {
    Axis_initEntries();
    return Axis_Y_instance;
  }
  function Axis_Z_getInstance() {
    Axis_initEntries();
    return Axis_Z_instance;
  }
  function MathUtils() {
    MathUtils_instance = this;
    this.transformIdentity = Companion_getInstance_60().IDENTITY;
    this.quaternionIdentity = Companion_getInstance_57().IDENTITY;
  }
  protoOf(MathUtils).l2c = function () {
    return this.transformIdentity;
  };
  protoOf(MathUtils).m2c = function () {
    return this.quaternionIdentity;
  };
  protoOf(MathUtils).quaternionFromAxisAngle = function (axis, angleDegrees) {
    return Companion_getInstance_57().fromAxisAngle(axis, (new Degrees(angleDegrees)).toRadian());
  };
  protoOf(MathUtils).quaternionFromLookDirection = function (forward, up) {
    return Companion_getInstance_57().fromLookDirection(forward, up);
  };
  protoOf(MathUtils).quaternionFromLookDirectionUnsafe = function (forward, up) {
    return Companion_getInstance_57().fromLookDirectionUnsafe(forward, up);
  };
  protoOf(MathUtils).quaternionFromBaseVectors = function (right, up, forward) {
    return Companion_getInstance_57().quaternionFromBaseVectors(right, up, forward);
  };
  protoOf(MathUtils).quaternionFromEulerDegrees = function (angles) {
    return Companion_getInstance_57().fromEulerDegreesVector(angles);
  };
  protoOf(MathUtils).quaternionFromEulerRadians = function (x, y, z) {
    return Companion_getInstance_57().fromEuler(new Radians(x), new Radians(y), new Radians(z));
  };
  protoOf(MathUtils).axisAlignedBoxFromVertices = function (vertices) {
    return Companion_getInstance_93().fromVertices(vertices);
  };
  protoOf(MathUtils).geometricMeanFromPoints = function (points) {
    return get_geometricMean(points);
  };
  protoOf(MathUtils).circularIndex = function (index, length) {
    var tmp;
    if (index >= length) {
      tmp = index % length | 0;
    } else if (index < 0) {
      tmp = (index % length | 0) + length | 0;
    } else {
      tmp = index;
    }
    return tmp;
  };
  var MathUtils_instance;
  function MathUtils_getInstance() {
    if (MathUtils_instance == null)
      new MathUtils();
    return MathUtils_instance;
  }
  function Companion_53() {
  }
  protoOf(Companion_53).l17 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_53;
  function Companion_getInstance_54() {
    return Companion_instance_53;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.ModelTransform', this, 3);
    tmp0_serialDesc.cv('p', true);
    tmp0_serialDesc.cv('r', true);
    tmp0_serialDesc.cv('s', true);
    this.n2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ok = function () {
    return this.n2c_1;
  };
  protoOf($serializer_3).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_8())];
  };
  protoOf($serializer_3).qk = function (decoder) {
    var tmp0_desc = this.n2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return ModelTransform_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_3).o2c = function (encoder, value) {
    var tmp0_desc = this.n2c_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.position == null)) {
      tmp1_output.gp(tmp0_desc, 0, $serializer_getInstance_8(), value.position);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.rotation == null)) {
      tmp1_output.gp(tmp0_desc, 1, $serializer_getInstance_8(), value.rotation);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.scale == null)) {
      tmp1_output.gp(tmp0_desc, 2, $serializer_getInstance_8(), value.scale);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_3).pk = function (encoder, value) {
    return this.o2c(encoder, value instanceof ModelTransform ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function ModelTransform_init_$Init$(seen1, position, rotation, scale, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_3().n2c_1);
    }
    if (0 === (seen1 & 1))
      $this.position = null;
    else
      $this.position = position;
    if (0 === (seen1 & 2))
      $this.rotation = null;
    else
      $this.rotation = rotation;
    if (0 === (seen1 & 4))
      $this.scale = null;
    else
      $this.scale = scale;
    return $this;
  }
  function ModelTransform_init_$Create$(seen1, position, rotation, scale, serializationConstructorMarker) {
    return ModelTransform_init_$Init$(seen1, position, rotation, scale, serializationConstructorMarker, objectCreate(protoOf(ModelTransform)));
  }
  function ModelTransform(position, rotation, scale) {
    position = position === VOID ? null : position;
    rotation = rotation === VOID ? null : rotation;
    scale = scale === VOID ? null : scale;
    this.position = position;
    this.rotation = rotation;
    this.scale = scale;
  }
  protoOf(ModelTransform).ct = function () {
    return this.position;
  };
  protoOf(ModelTransform).v1k = function () {
    return this.rotation;
  };
  protoOf(ModelTransform).p2c = function () {
    return this.scale;
  };
  protoOf(ModelTransform).d1x = function () {
    var tmp0_elvis_lhs = this.position;
    var tmp = tmp0_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp0_elvis_lhs;
    var tmp_0 = Companion_getInstance_57();
    var tmp1_elvis_lhs = this.rotation;
    return new Transform(tmp, tmp_0.fromEulerDegreesVector(tmp1_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp1_elvis_lhs));
  };
  protoOf(ModelTransform).applyInverse = function (aab) {
    var tmp0_elvis_lhs = this.scale;
    var scale = tmp0_elvis_lhs == null ? Companion_getInstance_61().ONE : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = this.position;
    var position = tmp1_elvis_lhs == null ? Companion_getInstance_61().ZERO : tmp1_elvis_lhs;
    var rotation = this.rotation;
    var cuboid = Companion_getInstance_95().fromAABB(aab);
    cuboid = cuboid.scale(new Vector(1 / scale.X, 1 / scale.Y, 1 / scale.Z));
    cuboid = cuboid.move(position.unaryMinus());
    if (!(rotation == null)) {
      cuboid = cuboid.rotate(Companion_getInstance_57().fromEulerDegreesVector(rotation).inverse());
    }
    return cuboid.axisAlignedBoundingBox;
  };
  protoOf(ModelTransform).applyTo = function (vo) {
    vo.setPosition(Companion_getInstance_61().ZERO);
    vo.setRotation(Companion_getInstance_57().IDENTITY);
    var tmp0_safe_receiver = this.rotation;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.math.ModelTransform.applyTo.<anonymous>' call
      vo.setRotationEulerAngleDegrees(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = this.position;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.math.ModelTransform.applyTo.<anonymous>' call
      vo.setPosition(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = this.scale;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.math.ModelTransform.applyTo.<anonymous>' call
      vo.setScaleV(tmp2_safe_receiver);
    }
  };
  protoOf(ModelTransform).af = function () {
    return this.position;
  };
  protoOf(ModelTransform).bf = function () {
    return this.rotation;
  };
  protoOf(ModelTransform).g1k = function () {
    return this.scale;
  };
  protoOf(ModelTransform).q2c = function (position, rotation, scale) {
    return new ModelTransform(position, rotation, scale);
  };
  protoOf(ModelTransform).copy = function (position, rotation, scale, $super) {
    position = position === VOID ? this.position : position;
    rotation = rotation === VOID ? this.rotation : rotation;
    scale = scale === VOID ? this.scale : scale;
    return this.q2c(position, rotation, scale);
  };
  protoOf(ModelTransform).toString = function () {
    return 'ModelTransform(position=' + this.position + ', rotation=' + this.rotation + ', scale=' + this.scale + ')';
  };
  protoOf(ModelTransform).hashCode = function () {
    var result = this.position == null ? 0 : this.position.hashCode();
    result = imul(result, 31) + (this.rotation == null ? 0 : this.rotation.hashCode()) | 0;
    result = imul(result, 31) + (this.scale == null ? 0 : this.scale.hashCode()) | 0;
    return result;
  };
  protoOf(ModelTransform).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModelTransform))
      return false;
    var tmp0_other_with_cast = other instanceof ModelTransform ? other : THROW_CCE();
    if (!equals(this.position, tmp0_other_with_cast.position))
      return false;
    if (!equals(this.rotation, tmp0_other_with_cast.rotation))
      return false;
    if (!equals(this.scale, tmp0_other_with_cast.scale))
      return false;
    return true;
  };
  function Companion_54() {
    this.r2c_1 = 1.0E-4;
  }
  protoOf(Companion_54).createFromPoints = function (p1, p2, p3) {
    var point = p1.plus(p2).plus(p3).times(0.3333333333333333);
    var a1 = p2.minus(p1);
    var a2 = p3.minus(p1);
    var normal = a1.cross(a2).normalize();
    return new Plane(point, normal);
  };
  var Companion_instance_54;
  function Companion_getInstance_55() {
    return Companion_instance_54;
  }
  function Plane(pointInPlane, normal) {
    this.pointInPlane = pointInPlane;
    this.normal = normal;
  }
  protoOf(Plane).s2c = function () {
    return this.pointInPlane;
  };
  protoOf(Plane).d23 = function () {
    return this.normal;
  };
  protoOf(Plane).raycast = function (ray) {
    var tmp0_elvis_lhs = this.raycastDistance(ray);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var s = tmp;
    return new RaycastResult(ray.getPointAlongRay(s), this.normal);
  };
  protoOf(Plane).raycastDistance = function (ray) {
    var denominator = ray.direction.__timesOperatorKotlin(this.normal);
    if (denominator > 0.0)
      return null;
    // Inline function 'kotlin.math.absoluteValue' call
    if (Math.abs(denominator) < 1.0E-4)
      return null;
    var s = this.pointInPlane.minus(ray.origin).__timesOperatorKotlin(this.normal) * (1.0 / denominator);
    if (s < 0.0)
      return null;
    return s;
  };
  protoOf(Plane).t2c = function (point, epsilon) {
    var diff = point.minus(this.pointInPlane);
    // Inline function 'kotlin.math.abs' call
    var x = diff.dot(this.normal);
    return Math.abs(x) <= epsilon;
  };
  protoOf(Plane).contains = function (point, epsilon, $super) {
    epsilon = epsilon === VOID ? 1.0 : epsilon;
    return this.t2c(point, epsilon);
  };
  protoOf(Plane).projectOnPlane = function (vectorToProject) {
    return vectorToProject.minus(times(vectorToProject.dot(this.normal), this.normal));
  };
  protoOf(Plane).af = function () {
    return this.pointInPlane;
  };
  protoOf(Plane).bf = function () {
    return this.normal;
  };
  protoOf(Plane).u2c = function (pointInPlane, normal) {
    return new Plane(pointInPlane, normal);
  };
  protoOf(Plane).copy = function (pointInPlane, normal, $super) {
    pointInPlane = pointInPlane === VOID ? this.pointInPlane : pointInPlane;
    normal = normal === VOID ? this.normal : normal;
    return this.u2c(pointInPlane, normal);
  };
  protoOf(Plane).toString = function () {
    return 'Plane(pointInPlane=' + this.pointInPlane + ', normal=' + this.normal + ')';
  };
  protoOf(Plane).hashCode = function () {
    var result = this.pointInPlane.hashCode();
    result = imul(result, 31) + this.normal.hashCode() | 0;
    return result;
  };
  protoOf(Plane).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Plane))
      return false;
    var tmp0_other_with_cast = other instanceof Plane ? other : THROW_CCE();
    if (!this.pointInPlane.equals(tmp0_other_with_cast.pointInPlane))
      return false;
    if (!this.normal.equals(tmp0_other_with_cast.normal))
      return false;
    return true;
  };
  function Companion_55() {
  }
  protoOf(Companion_55).createPolygonAndCalculateNormal = function (vertices) {
    // Inline function 'kotlin.collections.count' call
    if (vertices.length < 3) {
      return null;
    }
    var normal = PolyhedronUtils_getInstance().surfaceNormal(vertices);
    return new Polygon(vertices, normal);
  };
  var Companion_instance_55;
  function Companion_getInstance_56() {
    return Companion_instance_55;
  }
  function Polygon(vertices, normal) {
    this.vertices = vertices;
    this.normal = normal;
  }
  protoOf(Polygon).b23 = function () {
    return this.vertices;
  };
  protoOf(Polygon).d23 = function () {
    return this.normal;
  };
  protoOf(Polygon).validateCoplanarPoints = function () {
    var firstDirection = this.vertices[1].minus(this.vertices[0]);
    var inductionVariable = 2;
    // Inline function 'kotlin.collections.count' call
    var last = this.vertices.length;
    if (inductionVariable < last)
      do {
        var vertexIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var currentDirection = this.vertices[vertexIndex].minus(this.vertices[0]);
        var currentNormal = firstDirection.cross(currentDirection).normalize();
        // Inline function 'kotlin.math.abs' call
        var x = currentNormal.__timesOperatorKotlin(this.normal);
        var tmp$ret$1 = Math.abs(x);
        if (!almostEquals(tmp$ret$1, 1.0)) {
          return false;
        }
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(Polygon).raycast = function (ray) {
    var polygonPlane = new Plane(this.vertices[0], this.normal);
    var hit = polygonPlane.raycast(ray);
    var hitPoint = hit == null ? null : hit.point;
    var tmp;
    if (hitPoint == null) {
      tmp = hit;
    } else if (almostEquals(closestOnEdge(hitPoint, this.vertices).distanceTo(hitPoint), 0.0, 1.0E-4) ? true : PolyhedronUtils_getInstance().pointInPolygon(hitPoint, this.vertices, this.normal)) {
      tmp = hit;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(Polygon).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Polygon))
      THROW_CCE();
    if (!contentEquals(this.vertices, other.vertices))
      return false;
    if (!this.normal.equals(other.normal))
      return false;
    return true;
  };
  protoOf(Polygon).hashCode = function () {
    var result = contentHashCode(this.vertices);
    result = imul(31, result) + this.normal.hashCode() | 0;
    return result;
  };
  protoOf(Polygon).af = function () {
    return this.vertices;
  };
  protoOf(Polygon).bf = function () {
    return this.normal;
  };
  protoOf(Polygon).v2c = function (vertices, normal) {
    return new Polygon(vertices, normal);
  };
  protoOf(Polygon).copy = function (vertices, normal, $super) {
    vertices = vertices === VOID ? this.vertices : vertices;
    normal = normal === VOID ? this.normal : normal;
    return this.v2c(vertices, normal);
  };
  protoOf(Polygon).toString = function () {
    return 'Polygon(vertices=' + toString(this.vertices) + ', normal=' + this.normal + ')';
  };
  function Quaternion_init_$Init$(iw, ix, iy, iz, $this) {
    Quaternion_init_$Init$_0(iw, ix, iy, iz, $this);
    return $this;
  }
  function QuaternionFromInts(iw, ix, iy, iz) {
    return Quaternion_init_$Init$(iw, ix, iy, iz, objectCreate(protoOf(Quaternion)));
  }
  function Quaternion_init_$Init$_0(w, x, y, z, $this) {
    Quaternion.call($this, w, x, y, z, false);
    return $this;
  }
  function QuaternionFromDouble(w, x, y, z) {
    return Quaternion_init_$Init$_0(w, x, y, z, objectCreate(protoOf(Quaternion)));
  }
  function toRotationMatrix($this) {
    var te = new Float64Array(16);
    var x2 = $this.x + $this.x;
    var y2 = $this.y + $this.y;
    var z2 = $this.z + $this.z;
    var xx = $this.x * x2;
    var xy = $this.x * y2;
    var xz = $this.x * z2;
    var yy = $this.y * y2;
    var yz = $this.y * z2;
    var zz = $this.z * z2;
    var wx = $this.w * x2;
    var wy = $this.w * y2;
    var wz = $this.w * z2;
    te[0] = 1 - (yy + zz);
    te[1] = xy + wz;
    te[2] = xz - wy;
    te[5] = 1 - (xx + zz);
    te[8] = xz + wy;
    te[9] = yz - wx;
    te[10] = 1 - (xx + yy);
    return te;
  }
  function Companion_56() {
    Companion_instance_56 = this;
    this.IDENTITY = new Quaternion(1.0, 0.0, 0.0, 0.0, true);
    this.PI2 = 6.283185307179586;
    this.RADIANS_TO_DEGREES = 57.29577951308232;
    this.PI2_DIV_360 = 0.017453292519943295;
  }
  protoOf(Companion_56).x2c = function () {
    return this.IDENTITY;
  };
  protoOf(Companion_56).y2c = function () {
    return this.PI2;
  };
  protoOf(Companion_56).z2c = function () {
    return this.RADIANS_TO_DEGREES;
  };
  protoOf(Companion_56).a2d = function () {
    return this.PI2_DIV_360;
  };
  protoOf(Companion_56).toAxisAngle = function (q1) {
    var q = q1;
    if (q.w > 1.0)
      q = q.normalize();
    // Inline function 'kotlin.math.acos' call
    var x = q.w;
    var tmp$ret$0 = Math.acos(x);
    var angle = new Radians(2 * tmp$ret$0);
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = 1 - q.w * q.w;
    var s = Math.sqrt(x_0);
    var tmp;
    if (s < 0.001) {
      var x_1 = q.x;
      var y = q.y;
      var z = q.z;
      tmp = new AxisAngle(new Vector(x_1, y, z), angle);
    } else {
      var x_2 = q.x / s;
      var y_0 = q.y / s;
      var z_0 = q.z / s;
      tmp = new AxisAngle(new Vector(x_2, y_0, z_0), angle);
    }
    return tmp;
  };
  protoOf(Companion_56).b2d = function (lookDirection, up) {
    var backward = lookDirection.__timesIntForKotlin(-1);
    var backwardLengthSq = backward.dot(backward);
    var upLengthSq = up.dot(up);
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$0 = Math.sqrt(backwardLengthSq);
    var backwardRsqrt = backward.times(1.0 / tmp$ret$0);
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$1 = Math.sqrt(upLengthSq);
    var upRsqrt = up.times(1.0 / tmp$ret$1);
    var t = upRsqrt.cross(backward).normalize();
    var tLengthSq = t.dot(t);
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$2 = Math.sqrt(tLengthSq);
    var tRsqrt = t.times(1.0 / tmp$ret$2);
    // Inline function 'kotlin.math.min' call
    // Inline function 'kotlin.math.min' call
    var a = Math.min(backwardLengthSq, upLengthSq);
    var mn = Math.min(a, tLengthSq);
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.max' call
    var a_0 = Math.max(backwardLengthSq, upLengthSq);
    var mx = Math.max(a_0, tLengthSq);
    var accept = (((mn > 1.0E-35 ? mx < 1.0E35 : false) ? isFinite(backwardLengthSq) : false) ? isFinite(upLengthSq) : false) ? isFinite(tLengthSq) : false;
    if (accept) {
      var crossT = backwardRsqrt.cross(t);
      return this.quaternionFromBaseVectors(tRsqrt, crossT, backwardRsqrt.unaryMinus());
    } else {
      return this.IDENTITY;
    }
  };
  protoOf(Companion_56).fromLookDirection = function (lookDirection, up, $super) {
    up = up === VOID ? Companion_getInstance_61().UP : up;
    return this.b2d(lookDirection, up);
  };
  protoOf(Companion_56).c2d = function (lookDirection, up) {
    var t = lookDirection.cross(up).normalize();
    var crossT = t.cross(lookDirection);
    return this.quaternionFromBaseVectors(t, crossT, lookDirection);
  };
  protoOf(Companion_56).fromLookDirectionUnsafe = function (lookDirection, up, $super) {
    up = up === VOID ? Companion_getInstance_61().UP : up;
    return this.c2d(lookDirection, up);
  };
  protoOf(Companion_56).quaternionFromBaseVectors = function (right, up, forward) {
    var m00 = right.X;
    var m10 = right.Y;
    var m20 = right.Z;
    var m01 = up.X;
    var m11 = up.Y;
    var m21 = up.Z;
    var m02 = -forward.X;
    var m12 = -forward.Y;
    var m22 = -forward.Z;
    var trace = m00 + m11 + m22;
    if (trace > 0.0) {
      // Inline function 'kotlin.math.sqrt' call
      var x = trace + 1.0;
      var S = Math.sqrt(x) * 2;
      var qw = 0.25 * S;
      var qx = (m21 - m12) / S;
      var qy = (m02 - m20) / S;
      var qz = (m10 - m01) / S;
      return QuaternionFromDouble(qw, qx, qy, qz).normalize();
    } else if (!!(m00 > m11 & m00 > m22)) {
      // Inline function 'kotlin.math.sqrt' call
      var x_0 = 1.0 + m00 - m11 - m22;
      var S_0 = Math.sqrt(x_0) * 2;
      var qw_0 = (m21 - m12) / S_0;
      var qx_0 = 0.25 * S_0;
      var qy_0 = (m01 + m10) / S_0;
      var qz_0 = (m02 + m20) / S_0;
      return QuaternionFromDouble(qw_0, qx_0, qy_0, qz_0).normalize();
    } else if (m11 > m22) {
      // Inline function 'kotlin.math.sqrt' call
      var x_1 = 1.0 + m11 - m00 - m22;
      var S_1 = Math.sqrt(x_1) * 2;
      var qw_1 = (m02 - m20) / S_1;
      var qx_1 = (m01 + m10) / S_1;
      var qy_1 = 0.25 * S_1;
      var qz_1 = (m12 + m21) / S_1;
      return QuaternionFromDouble(qw_1, qx_1, qy_1, qz_1).normalize();
    } else {
      // Inline function 'kotlin.math.sqrt' call
      var x_2 = 1.0 + m22 - m00 - m11;
      var S_2 = Math.sqrt(x_2) * 2;
      var qw_2 = (m10 - m01) / S_2;
      var qx_2 = (m02 + m20) / S_2;
      var qy_2 = (m12 + m21) / S_2;
      var qz_2 = 0.25 * S_2;
      return QuaternionFromDouble(qw_2, qx_2, qy_2, qz_2).normalize();
    }
  };
  protoOf(Companion_56).fromAxisAngle = function (axis, angle) {
    if (axis.equals(Companion_getInstance_61().ZERO) ? true : angle.value === 0.0)
      return this.IDENTITY;
    var normalizedAxis = axis.normalize();
    // Inline function 'kotlin.math.sin' call
    var x = angle.value / 2;
    var s = Math.sin(x);
    var x_0 = normalizedAxis.X * s;
    var y = normalizedAxis.Y * s;
    var z = normalizedAxis.Z * s;
    // Inline function 'kotlin.math.cos' call
    var x_1 = angle.value / 2;
    var w = Math.cos(x_1);
    return QuaternionFromDouble(w, x_0, y, z).normalize();
  };
  protoOf(Companion_56).fromEulerDegreesVector = function (angles) {
    return this.fromEuler(new Radians(angles.X * 0.017453292519943295), new Radians(angles.Y * 0.017453292519943295), new Radians(angles.Z * 0.017453292519943295));
  };
  protoOf(Companion_56).d2d = function (xAngle, yAngle, zAngle) {
    return this.fromEuler(xAngle.toRadian(), yAngle.toRadian(), zAngle.toRadian());
  };
  protoOf(Companion_56).fromEulerDegrees = function (xAngle, yAngle, zAngle, $super) {
    xAngle = xAngle === VOID ? new Degrees(0.0) : xAngle;
    yAngle = yAngle === VOID ? new Degrees(0.0) : yAngle;
    zAngle = zAngle === VOID ? new Degrees(0.0) : zAngle;
    return this.d2d(xAngle, yAngle, zAngle);
  };
  protoOf(Companion_56).fromEulerDegreesRadians = function (radians) {
    return this.fromEuler(new Radians(radians.X), new Radians(radians.Y), new Radians(radians.Z));
  };
  protoOf(Companion_56).e2d = function (xAngle, yAngle, zAngle) {
    // Inline function 'kotlin.math.cos' call
    var x = xAngle.value / 2;
    var c1 = Math.cos(x);
    // Inline function 'kotlin.math.cos' call
    var x_0 = yAngle.value / 2;
    var c2 = Math.cos(x_0);
    // Inline function 'kotlin.math.cos' call
    var x_1 = zAngle.value / 2;
    var c3 = Math.cos(x_1);
    // Inline function 'kotlin.math.sin' call
    var x_2 = xAngle.value / 2;
    var s1 = Math.sin(x_2);
    // Inline function 'kotlin.math.sin' call
    var x_3 = yAngle.value / 2;
    var s2 = Math.sin(x_3);
    // Inline function 'kotlin.math.sin' call
    var x_4 = zAngle.value / 2;
    var s3 = Math.sin(x_4);
    var x_5 = s1 * c2 * c3 + c1 * s2 * s3;
    var y = c1 * s2 * c3 - s1 * c2 * s3;
    var z = c1 * c2 * s3 - s1 * s2 * c3;
    var w = c1 * c2 * c3 + s1 * s2 * s3;
    return QuaternionFromDouble(w, x_5, y, z).normalize();
  };
  protoOf(Companion_56).fromEuler = function (xAngle, yAngle, zAngle, $super) {
    xAngle = xAngle === VOID ? new Radians(0.0) : xAngle;
    yAngle = yAngle === VOID ? new Radians(0.0) : yAngle;
    zAngle = zAngle === VOID ? new Radians(0.0) : zAngle;
    return this.e2d(xAngle, yAngle, zAngle);
  };
  protoOf(Companion_56).l17 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance_56;
  function Companion_getInstance_57() {
    if (Companion_instance_56 == null)
      new Companion_56();
    return Companion_instance_56;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Quaternion', this, 5);
    tmp0_serialDesc.cv('w', false);
    tmp0_serialDesc.cv('x', false);
    tmp0_serialDesc.cv('y', false);
    tmp0_serialDesc.cv('z', false);
    tmp0_serialDesc.cv('isIdentity', true);
    this.f2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ok = function () {
    return this.f2d_1;
  };
  protoOf($serializer_4).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_4).qk = function (decoder) {
    var tmp0_desc = this.f2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = false;
    var tmp10_input = decoder.nn(tmp0_desc);
    if (tmp10_input.do()) {
      tmp4_local0 = tmp10_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.vn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.vn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.vn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.pn(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.vn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.vn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.vn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.pn(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.on(tmp0_desc);
    return Quaternion_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_4).g2d = function (encoder, value) {
    var tmp0_desc = this.f2d_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ap(tmp0_desc, 0, value.w);
    tmp1_output.ap(tmp0_desc, 1, value.x);
    tmp1_output.ap(tmp0_desc, 2, value.y);
    tmp1_output.ap(tmp0_desc, 3, value.z);
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.isIdentity === (((value.w === 1.0 ? value.x === 0.0 : false) ? value.y === 0.0 : false) ? value.z === 0.0 : false))) {
      tmp1_output.uo(tmp0_desc, 4, value.isIdentity);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_4).pk = function (encoder, value) {
    return this.g2d(encoder, value instanceof Quaternion ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function Quaternion_init_$Init$_1(seen1, w, x, y, z, isIdentity, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_4().f2d_1);
    }
    $this.w = w;
    $this.x = x;
    $this.y = y;
    $this.z = z;
    $this.w2c_1 = false;
    if (0 === (seen1 & 16))
      $this.isIdentity = (($this.w === 1.0 ? $this.x === 0.0 : false) ? $this.y === 0.0 : false) ? $this.z === 0.0 : false;
    else
      $this.isIdentity = isIdentity;
    return $this;
  }
  function Quaternion_init_$Create$(seen1, w, x, y, z, isIdentity, serializationConstructorMarker) {
    return Quaternion_init_$Init$_1(seen1, w, x, y, z, isIdentity, serializationConstructorMarker, objectCreate(protoOf(Quaternion)));
  }
  function Quaternion$toEuler$lambda(value, min, max) {
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.min' call
    var b = Math.min(max, value);
    return Math.max(min, b);
  }
  function Quaternion(w, x, y, z, normalized) {
    Companion_getInstance_57();
    normalized = normalized === VOID ? false : normalized;
    this.w = w;
    this.x = x;
    this.y = y;
    this.z = z;
    this.w2c_1 = normalized;
    this.isIdentity = ((this.w === 1.0 ? this.x === 0.0 : false) ? this.y === 0.0 : false) ? this.z === 0.0 : false;
  }
  protoOf(Quaternion).h2d = function () {
    return this.w;
  };
  protoOf(Quaternion).i2d = function () {
    return this.x;
  };
  protoOf(Quaternion).j2d = function () {
    return this.y;
  };
  protoOf(Quaternion).k2d = function () {
    return this.z;
  };
  protoOf(Quaternion).times = function (q) {
    var tmp;
    if (this.isIdentity) {
      tmp = q;
    } else if (q.isIdentity) {
      tmp = this;
    } else {
      var q1 = q;
      var q2 = this;
      var x = q1.x * q2.w + q1.y * q2.z - q1.z * q2.y + q1.w * q2.x;
      var y = -q1.x * q2.z + q1.y * q2.w + q1.z * q2.x + q1.w * q2.y;
      var z = q1.x * q2.y - q1.y * q2.x + q1.z * q2.w + q1.w * q2.z;
      var w = -q1.x * q2.x - q1.y * q2.y - q1.z * q2.z + q1.w * q2.w;
      tmp = QuaternionFromDouble(w, x, y, z).normalize();
    }
    return tmp;
  };
  protoOf(Quaternion).conjugate = function () {
    return QuaternionFromDouble(this.w, -this.x, -this.y, -this.z);
  };
  protoOf(Quaternion).magnitude = function () {
    // Inline function 'kotlin.math.sqrt' call
    var x = this.w * this.w + this.x * this.x + this.y * this.y + this.z * this.z;
    return Math.sqrt(x);
  };
  protoOf(Quaternion).normalize = function () {
    var tmp;
    if (this.w2c_1) {
      tmp = this;
    } else {
      var magnitude = this.magnitude();
      tmp = new Quaternion(this.w / magnitude, this.x / magnitude, this.y / magnitude, this.z / magnitude, true);
    }
    return tmp;
  };
  protoOf(Quaternion).div = function (scalar) {
    return QuaternionFromDouble(this.w / scalar, this.x / scalar, this.y / scalar, this.z / scalar);
  };
  protoOf(Quaternion).inverse = function () {
    var tmp;
    if (this.isIdentity) {
      tmp = this;
    } else {
      tmp = this.conjugate().div(this.magnitude());
    }
    return tmp;
  };
  protoOf(Quaternion).unaryMinus = function () {
    return this.inverse();
  };
  protoOf(Quaternion).l2d = function (floatingPoints) {
    var w2 = round(floatingPoints * this.w) / floatingPoints;
    var x2 = round(floatingPoints * this.x) / floatingPoints;
    var y2 = round(floatingPoints * this.y) / floatingPoints;
    var z2 = round(floatingPoints * this.z) / floatingPoints;
    return QuaternionFromDouble(w2 === -0.0 ? 0.0 : w2, x2 === -0.0 ? 0.0 : x2, y2 === -0.0 ? 0.0 : y2, z2 === -0.0 ? 0.0 : z2);
  };
  protoOf(Quaternion).round = function (floatingPoints, $super) {
    floatingPoints = floatingPoints === VOID ? 1000.0 : floatingPoints;
    return this.l2d(floatingPoints);
  };
  protoOf(Quaternion).toEulerDegrees = function () {
    var euler = this.toEuler();
    return new Vector(euler.X * 57.29577951308232, euler.Y * 57.29577951308232, euler.Z * 57.29577951308232);
  };
  protoOf(Quaternion).m2d = function () {
    return this.toEulerDegrees();
  };
  protoOf(Quaternion).toEuler = function () {
    var clamp = Quaternion$toEuler$lambda;
    var te = toRotationMatrix(this);
    var m11 = te[0];
    var m13 = te[8];
    var m21 = te[1];
    var m22 = te[5];
    var m23 = te[9];
    var m31 = te[2];
    var m33 = te[10];
    // Inline function 'kotlin.math.asin' call
    var x = -clamp(m23, -1.0, 1.0);
    var eulerX = Math.asin(x);
    var eulerZ;
    var eulerY;
    // Inline function 'kotlin.math.abs' call
    if (Math.abs(m23) < 0.9999999) {
      // Inline function 'kotlin.math.atan2' call
      eulerY = Math.atan2(m13, m33);
      // Inline function 'kotlin.math.atan2' call
      eulerZ = Math.atan2(m21, m22);
    } else {
      // Inline function 'kotlin.math.atan2' call
      var y = -m31;
      eulerY = Math.atan2(y, m11);
      eulerZ = 0.0;
    }
    return new Vector(eulerX, eulerY, eulerZ);
  };
  protoOf(Quaternion).toString = function () {
    var euler = this.toEulerDegrees();
    return 'Euler(' + euler.X + '\xB0, ' + euler.Y + '\xB0, ' + euler.Z + '\xB0) Q:(' + this.w + ',' + this.x + ',' + this.y + ',' + this.z + ')';
  };
  protoOf(Quaternion).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Quaternion))
      THROW_CCE();
    return this.almostEquals(other);
  };
  protoOf(Quaternion).n2d = function (other, epsilon) {
    var w0 = this.af();
    var x0 = this.bf();
    var y0 = this.g1k();
    var z0 = this.h1k();
    var w1 = other.af();
    var x1 = other.bf();
    var y1 = other.g1k();
    var z1 = other.h1k();
    var diff = (w0 < w1 ? w1 - w0 : w0 - w1) + (x0 < x1 ? x1 - x0 : x0 - x1) + (y0 < y1 ? y1 - y0 : y0 - y1) + (z0 < z1 ? z1 - z0 : z0 - z1);
    if (diff < epsilon)
      return true;
    w1 = -w1;
    x1 = -x1;
    y1 = -y1;
    z1 = -z1;
    diff = (w0 < w1 ? w1 - w0 : w0 - w1) + (x0 < x1 ? x1 - x0 : x0 - x1) + (y0 < y1 ? y1 - y0 : y0 - y1) + (z0 < z1 ? z1 - z0 : z0 - z1);
    if (diff < epsilon)
      return true;
    return false;
  };
  protoOf(Quaternion).almostEquals = function (other, epsilon, $super) {
    epsilon = epsilon === VOID ? 0.01 : epsilon;
    return this.n2d(other, epsilon);
  };
  protoOf(Quaternion).hashCode = function () {
    return 0;
  };
  protoOf(Quaternion).o2d = function () {
    return this.isIdentity;
  };
  protoOf(Quaternion).af = function () {
    return this.w;
  };
  protoOf(Quaternion).bf = function () {
    return this.x;
  };
  protoOf(Quaternion).g1k = function () {
    return this.y;
  };
  protoOf(Quaternion).h1k = function () {
    return this.z;
  };
  protoOf(Quaternion).p2d = function (w, x, y, z, normalized) {
    return new Quaternion(w, x, y, z, normalized);
  };
  protoOf(Quaternion).copy = function (w, x, y, z, normalized, $super) {
    w = w === VOID ? this.w : w;
    x = x === VOID ? this.x : x;
    y = y === VOID ? this.y : y;
    z = z === VOID ? this.z : z;
    normalized = normalized === VOID ? this.w2c_1 : normalized;
    return this.p2d(w, x, y, z, normalized);
  };
  function Radians(value) {
    this.value = value;
  }
  protoOf(Radians).u2 = function () {
    return this.value;
  };
  protoOf(Radians).toDegree = function () {
    return new Degrees(this.value / get_PI() * 180);
  };
  protoOf(Radians).af = function () {
    return this.value;
  };
  protoOf(Radians).t2b = function (value) {
    return new Radians(value);
  };
  protoOf(Radians).copy = function (value, $super) {
    value = value === VOID ? this.value : value;
    return this.t2b(value);
  };
  protoOf(Radians).toString = function () {
    return 'Radians(value=' + this.value + ')';
  };
  protoOf(Radians).hashCode = function () {
    return getNumberHashCode(this.value);
  };
  protoOf(Radians).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Radians))
      return false;
    var tmp0_other_with_cast = other instanceof Radians ? other : THROW_CCE();
    if (!equals(this.value, tmp0_other_with_cast.value))
      return false;
    return true;
  };
  function RelativeBoxOffset(relativeTo, offsetVector) {
    offsetVector = offsetVector === VOID ? Companion_getInstance_61().ZERO : offsetVector;
    this.relativeTo = relativeTo;
    this.offsetVector = offsetVector;
  }
  protoOf(RelativeBoxOffset).q2d = function () {
    return this.relativeTo;
  };
  protoOf(RelativeBoxOffset).r2d = function () {
    return this.offsetVector;
  };
  protoOf(RelativeBoxOffset).applyToBox = function (aabb) {
    var tmp;
    switch (this.relativeTo.xKotlinEnum.x9_1) {
      case 0:
        tmp = aabb.min.X + this.offsetVector.X;
        break;
      case 2:
        tmp = aabb.max.X + this.offsetVector.X;
        break;
      default:
        tmp = this.offsetVector.X;
        break;
    }
    var tmp_0;
    switch (this.relativeTo.yKotlinEnum.x9_1) {
      case 2:
        tmp_0 = aabb.max.Y + this.offsetVector.Y;
        break;
      case 0:
        tmp_0 = aabb.min.Y + this.offsetVector.Y;
        break;
      default:
        tmp_0 = this.offsetVector.Y;
        break;
    }
    var tmp0 = this.relativeTo.zKotlinEnum.x9_1;
    return new Vector(tmp, tmp_0, tmp0 === 0 ? aabb.min.Z + this.offsetVector.Z : tmp0 === 2 ? aabb.max.Z + this.offsetVector.Z : this.offsetVector.Z);
  };
  protoOf(RelativeBoxOffset).af = function () {
    return this.relativeTo;
  };
  protoOf(RelativeBoxOffset).bf = function () {
    return this.offsetVector;
  };
  protoOf(RelativeBoxOffset).s2d = function (relativeTo, offsetVector) {
    return new RelativeBoxOffset(relativeTo, offsetVector);
  };
  protoOf(RelativeBoxOffset).copy = function (relativeTo, offsetVector, $super) {
    relativeTo = relativeTo === VOID ? this.relativeTo : relativeTo;
    offsetVector = offsetVector === VOID ? this.offsetVector : offsetVector;
    return this.s2d(relativeTo, offsetVector);
  };
  protoOf(RelativeBoxOffset).toString = function () {
    return 'RelativeBoxOffset(relativeTo=' + this.relativeTo + ', offsetVector=' + this.offsetVector + ')';
  };
  protoOf(RelativeBoxOffset).hashCode = function () {
    var result = this.relativeTo.hashCode();
    result = imul(result, 31) + this.offsetVector.hashCode() | 0;
    return result;
  };
  protoOf(RelativeBoxOffset).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeBoxOffset))
      return false;
    var tmp0_other_with_cast = other instanceof RelativeBoxOffset ? other : THROW_CCE();
    if (!this.relativeTo.equals(tmp0_other_with_cast.relativeTo))
      return false;
    if (!this.offsetVector.equals(tmp0_other_with_cast.offsetVector))
      return false;
    return true;
  };
  var RelationOriginAlongX_LEFT_instance;
  var RelationOriginAlongX_CENTER_instance;
  var RelationOriginAlongX_RIGHT_instance;
  function values_5() {
    return [RelationOriginAlongX_LEFT_getInstance(), RelationOriginAlongX_CENTER_getInstance(), RelationOriginAlongX_RIGHT_getInstance()];
  }
  function valueOf_5(value) {
    switch (value) {
      case 'LEFT':
        return RelationOriginAlongX_LEFT_getInstance();
      case 'CENTER':
        return RelationOriginAlongX_CENTER_getInstance();
      case 'RIGHT':
        return RelationOriginAlongX_RIGHT_getInstance();
      default:
        RelationOriginAlongX_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RelationOriginAlongX_entriesInitialized;
  function RelationOriginAlongX_initEntries() {
    if (RelationOriginAlongX_entriesInitialized)
      return Unit_instance;
    RelationOriginAlongX_entriesInitialized = true;
    RelationOriginAlongX_LEFT_instance = new RelationOriginAlongX('LEFT', 0);
    RelationOriginAlongX_CENTER_instance = new RelationOriginAlongX('CENTER', 1);
    RelationOriginAlongX_RIGHT_instance = new RelationOriginAlongX('RIGHT', 2);
  }
  function RelationOriginAlongX(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RelationOriginAlongXImpostor() {
    RelationOriginAlongXImpostor_instance = this;
    this.LEFT = 0;
    this.CENTER = 1;
    this.RIGHT = 2;
    this.v2d_1 = values_5();
  }
  protoOf(RelationOriginAlongXImpostor).w2d = function () {
    return this.LEFT;
  };
  protoOf(RelationOriginAlongXImpostor).x2d = function () {
    return this.CENTER;
  };
  protoOf(RelationOriginAlongXImpostor).y2d = function () {
    return this.RIGHT;
  };
  protoOf(RelationOriginAlongXImpostor).toEnum = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var indexedObject = this.v2d_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.math.RelationOriginAlongXImpostor.toEnum.<anonymous>' call
        if (element.x9_1 === value) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Array contains no element matching the predicate.');
    }
    return tmp$ret$1;
  };
  var RelationOriginAlongXImpostor_instance;
  function RelationOriginAlongXImpostor_getInstance() {
    if (RelationOriginAlongXImpostor_instance == null)
      new RelationOriginAlongXImpostor();
    return RelationOriginAlongXImpostor_instance;
  }
  var RelationOriginAlongY_BOTTOM_instance;
  var RelationOriginAlongY_CENTER_instance;
  var RelationOriginAlongY_TOP_instance;
  function values_6() {
    return [RelationOriginAlongY_BOTTOM_getInstance(), RelationOriginAlongY_CENTER_getInstance(), RelationOriginAlongY_TOP_getInstance()];
  }
  function valueOf_6(value) {
    switch (value) {
      case 'BOTTOM':
        return RelationOriginAlongY_BOTTOM_getInstance();
      case 'CENTER':
        return RelationOriginAlongY_CENTER_getInstance();
      case 'TOP':
        return RelationOriginAlongY_TOP_getInstance();
      default:
        RelationOriginAlongY_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RelationOriginAlongY_entriesInitialized;
  function RelationOriginAlongY_initEntries() {
    if (RelationOriginAlongY_entriesInitialized)
      return Unit_instance;
    RelationOriginAlongY_entriesInitialized = true;
    RelationOriginAlongY_BOTTOM_instance = new RelationOriginAlongY('BOTTOM', 0);
    RelationOriginAlongY_CENTER_instance = new RelationOriginAlongY('CENTER', 1);
    RelationOriginAlongY_TOP_instance = new RelationOriginAlongY('TOP', 2);
  }
  function RelationOriginAlongY(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RelationOriginAlongYImpostor() {
    RelationOriginAlongYImpostor_instance = this;
    this.BOTTOM = 0;
    this.CENTER = 1;
    this.TOP = 2;
    this.b2e_1 = values_6();
  }
  protoOf(RelationOriginAlongYImpostor).c2e = function () {
    return this.BOTTOM;
  };
  protoOf(RelationOriginAlongYImpostor).x2d = function () {
    return this.CENTER;
  };
  protoOf(RelationOriginAlongYImpostor).d2e = function () {
    return this.TOP;
  };
  protoOf(RelationOriginAlongYImpostor).toEnum = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var indexedObject = this.b2e_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.math.RelationOriginAlongYImpostor.toEnum.<anonymous>' call
        if (element.x9_1 === value) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Array contains no element matching the predicate.');
    }
    return tmp$ret$1;
  };
  var RelationOriginAlongYImpostor_instance;
  function RelationOriginAlongYImpostor_getInstance() {
    if (RelationOriginAlongYImpostor_instance == null)
      new RelationOriginAlongYImpostor();
    return RelationOriginAlongYImpostor_instance;
  }
  var RelationOriginAlongZ_BACK_instance;
  var RelationOriginAlongZ_CENTER_instance;
  var RelationOriginAlongZ_FRONT_instance;
  function values_7() {
    return [RelationOriginAlongZ_BACK_getInstance(), RelationOriginAlongZ_CENTER_getInstance(), RelationOriginAlongZ_FRONT_getInstance()];
  }
  function valueOf_7(value) {
    switch (value) {
      case 'BACK':
        return RelationOriginAlongZ_BACK_getInstance();
      case 'CENTER':
        return RelationOriginAlongZ_CENTER_getInstance();
      case 'FRONT':
        return RelationOriginAlongZ_FRONT_getInstance();
      default:
        RelationOriginAlongZ_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RelationOriginAlongZ_entriesInitialized;
  function RelationOriginAlongZ_initEntries() {
    if (RelationOriginAlongZ_entriesInitialized)
      return Unit_instance;
    RelationOriginAlongZ_entriesInitialized = true;
    RelationOriginAlongZ_BACK_instance = new RelationOriginAlongZ('BACK', 0);
    RelationOriginAlongZ_CENTER_instance = new RelationOriginAlongZ('CENTER', 1);
    RelationOriginAlongZ_FRONT_instance = new RelationOriginAlongZ('FRONT', 2);
  }
  function RelationOriginAlongZ(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RelationOriginAlongZImpostor() {
    RelationOriginAlongZImpostor_instance = this;
    this.BACK = 0;
    this.CENTER = 1;
    this.FRONT = 2;
    this.g2e_1 = values_7();
  }
  protoOf(RelationOriginAlongZImpostor).h2e = function () {
    return this.BACK;
  };
  protoOf(RelationOriginAlongZImpostor).x2d = function () {
    return this.CENTER;
  };
  protoOf(RelationOriginAlongZImpostor).i2e = function () {
    return this.FRONT;
  };
  protoOf(RelationOriginAlongZImpostor).toEnum = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var indexedObject = this.g2e_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.math.RelationOriginAlongZImpostor.toEnum.<anonymous>' call
        if (element.x9_1 === value) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Array contains no element matching the predicate.');
    }
    return tmp$ret$1;
  };
  var RelationOriginAlongZImpostor_instance;
  function RelationOriginAlongZImpostor_getInstance() {
    if (RelationOriginAlongZImpostor_instance == null)
      new RelationOriginAlongZImpostor();
    return RelationOriginAlongZImpostor_instance;
  }
  function Companion_57() {
    Companion_instance_57 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j2e_1 = [createSimpleEnumSerializer('com.ikea.core.math.RelationOriginAlongX', values_5()), createSimpleEnumSerializer('com.ikea.core.math.RelationOriginAlongY', values_6()), createSimpleEnumSerializer('com.ikea.core.math.RelationOriginAlongZ', values_7())];
  }
  protoOf(Companion_57).l17 = function () {
    return $serializer_getInstance_5();
  };
  var Companion_instance_57;
  function Companion_getInstance_58() {
    if (Companion_instance_57 == null)
      new Companion_57();
    return Companion_instance_57;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.RelationOrigin', this, 3);
    tmp0_serialDesc.cv('x', true);
    tmp0_serialDesc.cv('y', true);
    tmp0_serialDesc.cv('z', true);
    this.k2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ok = function () {
    return this.k2e_1;
  };
  protoOf($serializer_5).rv = function () {
    var tmp0_cached = Companion_getInstance_58().j2e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2]];
  };
  protoOf($serializer_5).qk = function (decoder) {
    var tmp0_desc = this.k2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    var tmp8_cached = Companion_getInstance_58().j2e_1;
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.zn(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zn(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zn(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zn(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return RelationOrigin_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_5).l2e = function (encoder, value) {
    var tmp0_desc = this.k2e_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_58().j2e_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !value.xKotlinEnum.equals(RelationOriginAlongX_CENTER_getInstance())) {
      tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.xKotlinEnum);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !value.yKotlinEnum.equals(RelationOriginAlongY_CENTER_getInstance())) {
      tmp1_output.ep(tmp0_desc, 1, tmp2_cached[1], value.yKotlinEnum);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !value.zKotlinEnum.equals(RelationOriginAlongZ_CENTER_getInstance())) {
      tmp1_output.ep(tmp0_desc, 2, tmp2_cached[2], value.zKotlinEnum);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_5).pk = function (encoder, value) {
    return this.l2e(encoder, value instanceof RelationOrigin ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function RelationOrigin_init_$Init$(seen1, x, y, z, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_5().k2e_1);
    }
    if (0 === (seen1 & 1))
      $this.xKotlinEnum = RelationOriginAlongX_CENTER_getInstance();
    else
      $this.xKotlinEnum = x;
    if (0 === (seen1 & 2))
      $this.yKotlinEnum = RelationOriginAlongY_CENTER_getInstance();
    else
      $this.yKotlinEnum = y;
    if (0 === (seen1 & 4))
      $this.zKotlinEnum = RelationOriginAlongZ_CENTER_getInstance();
    else
      $this.zKotlinEnum = z;
    return $this;
  }
  function RelationOrigin_init_$Create$(seen1, x, y, z, serializationConstructorMarker) {
    return RelationOrigin_init_$Init$(seen1, x, y, z, serializationConstructorMarker, objectCreate(protoOf(RelationOrigin)));
  }
  function RelationOrigin(x, y, z) {
    Companion_getInstance_58();
    x = x === VOID ? RelationOriginAlongX_CENTER_getInstance() : x;
    y = y === VOID ? RelationOriginAlongY_CENTER_getInstance() : y;
    z = z === VOID ? RelationOriginAlongZ_CENTER_getInstance() : z;
    this.xKotlinEnum = x;
    this.yKotlinEnum = y;
    this.zKotlinEnum = z;
  }
  protoOf(RelationOrigin).m2e = function () {
    return this.xKotlinEnum;
  };
  protoOf(RelationOrigin).n2e = function () {
    return this.yKotlinEnum;
  };
  protoOf(RelationOrigin).o2e = function () {
    return this.zKotlinEnum;
  };
  protoOf(RelationOrigin).i2d = function () {
    return this.xKotlinEnum.x9_1;
  };
  protoOf(RelationOrigin).j2d = function () {
    return this.yKotlinEnum.x9_1;
  };
  protoOf(RelationOrigin).k2d = function () {
    return this.zKotlinEnum.x9_1;
  };
  protoOf(RelationOrigin).toString = function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.arrayOf' call
    var tmp;
    switch (this.xKotlinEnum.x9_1) {
      case 0:
        tmp = 'left';
        break;
      case 2:
        tmp = 'right';
        break;
      default:
        tmp = '';
        break;
    }
    var tmp_0;
    switch (this.yKotlinEnum.x9_1) {
      case 2:
        tmp_0 = 'top';
        break;
      case 0:
        tmp_0 = 'bottom';
        break;
      default:
        tmp_0 = '';
        break;
    }
    var tmp0 = this.zKotlinEnum.x9_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = [tmp, tmp_0, tmp0 === 2 ? 'front' : tmp0 === 0 ? 'back' : ''];
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.math.RelationOrigin.toString.<anonymous>' call
      if (!(element === '')) {
        destination.q(element);
      }
    }
    return joinToString(destination, '-');
  };
  protoOf(RelationOrigin).af = function () {
    return this.xKotlinEnum;
  };
  protoOf(RelationOrigin).bf = function () {
    return this.yKotlinEnum;
  };
  protoOf(RelationOrigin).g1k = function () {
    return this.zKotlinEnum;
  };
  protoOf(RelationOrigin).p2e = function (x, y, z) {
    return new RelationOrigin(x, y, z);
  };
  protoOf(RelationOrigin).copy = function (x, y, z, $super) {
    x = x === VOID ? this.xKotlinEnum : x;
    y = y === VOID ? this.yKotlinEnum : y;
    z = z === VOID ? this.zKotlinEnum : z;
    return this.p2e(x, y, z);
  };
  protoOf(RelationOrigin).hashCode = function () {
    var result = this.xKotlinEnum.hashCode();
    result = imul(result, 31) + this.yKotlinEnum.hashCode() | 0;
    result = imul(result, 31) + this.zKotlinEnum.hashCode() | 0;
    return result;
  };
  protoOf(RelationOrigin).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelationOrigin))
      return false;
    var tmp0_other_with_cast = other instanceof RelationOrigin ? other : THROW_CCE();
    if (!this.xKotlinEnum.equals(tmp0_other_with_cast.xKotlinEnum))
      return false;
    if (!this.yKotlinEnum.equals(tmp0_other_with_cast.yKotlinEnum))
      return false;
    if (!this.zKotlinEnum.equals(tmp0_other_with_cast.zKotlinEnum))
      return false;
    return true;
  };
  function RelationOriginAlongX_LEFT_getInstance() {
    RelationOriginAlongX_initEntries();
    return RelationOriginAlongX_LEFT_instance;
  }
  function RelationOriginAlongX_CENTER_getInstance() {
    RelationOriginAlongX_initEntries();
    return RelationOriginAlongX_CENTER_instance;
  }
  function RelationOriginAlongX_RIGHT_getInstance() {
    RelationOriginAlongX_initEntries();
    return RelationOriginAlongX_RIGHT_instance;
  }
  function RelationOriginAlongY_BOTTOM_getInstance() {
    RelationOriginAlongY_initEntries();
    return RelationOriginAlongY_BOTTOM_instance;
  }
  function RelationOriginAlongY_CENTER_getInstance() {
    RelationOriginAlongY_initEntries();
    return RelationOriginAlongY_CENTER_instance;
  }
  function RelationOriginAlongY_TOP_getInstance() {
    RelationOriginAlongY_initEntries();
    return RelationOriginAlongY_TOP_instance;
  }
  function RelationOriginAlongZ_BACK_getInstance() {
    RelationOriginAlongZ_initEntries();
    return RelationOriginAlongZ_BACK_instance;
  }
  function RelationOriginAlongZ_CENTER_getInstance() {
    RelationOriginAlongZ_initEntries();
    return RelationOriginAlongZ_CENTER_instance;
  }
  function RelationOriginAlongZ_FRONT_getInstance() {
    RelationOriginAlongZ_initEntries();
    return RelationOriginAlongZ_FRONT_instance;
  }
  function Size_init_$Init$(vector, $this) {
    Size.call($this, vector.X, vector.Y, vector.Z);
    return $this;
  }
  function SizeFromVector(vector) {
    return Size_init_$Init$(vector, objectCreate(protoOf(Size)));
  }
  function Companion_58() {
    Companion_instance_58 = this;
    this.NONE = new Size();
  }
  protoOf(Companion_58).h22 = function () {
    return this.NONE;
  };
  protoOf(Companion_58).l17 = function () {
    return $serializer_getInstance_6();
  };
  var Companion_instance_58;
  function Companion_getInstance_59() {
    if (Companion_instance_58 == null)
      new Companion_58();
    return Companion_instance_58;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Size', this, 3);
    tmp0_serialDesc.cv('width', true);
    tmp0_serialDesc.cv('height', true);
    tmp0_serialDesc.cv('depth', true);
    this.q2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ok = function () {
    return this.q2e_1;
  };
  protoOf($serializer_6).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  protoOf($serializer_6).qk = function (decoder) {
    var tmp0_desc = this.q2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp8_input = decoder.nn(tmp0_desc);
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.vn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.vn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return Size_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_6).r2e = function (encoder, value) {
    var tmp0_desc = this.q2e_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !equals(value.s2e_1, 0.0)) {
      tmp1_output.ap(tmp0_desc, 0, value.s2e_1);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !equals(value.t2e_1, 0.0)) {
      tmp1_output.ap(tmp0_desc, 1, value.t2e_1);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !equals(value.u2e_1, 0.0)) {
      tmp1_output.ap(tmp0_desc, 2, value.u2e_1);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_6).pk = function (encoder, value) {
    return this.r2e(encoder, value instanceof Size ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function Size_init_$Init$_0(seen1, width, height, depth, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_6().q2e_1);
    }
    if (0 === (seen1 & 1))
      $this.s2e_1 = 0.0;
    else
      $this.s2e_1 = width;
    if (0 === (seen1 & 2))
      $this.t2e_1 = 0.0;
    else
      $this.t2e_1 = height;
    if (0 === (seen1 & 4))
      $this.u2e_1 = 0.0;
    else
      $this.u2e_1 = depth;
    $this.vector = new Vector($this.s2e_1, $this.t2e_1, $this.u2e_1);
    return $this;
  }
  function Size_init_$Create$(seen1, width, height, depth, serializationConstructorMarker) {
    return Size_init_$Init$_0(seen1, width, height, depth, serializationConstructorMarker, objectCreate(protoOf(Size)));
  }
  function Size(width, height, depth) {
    Companion_getInstance_59();
    width = width === VOID ? 0.0 : width;
    height = height === VOID ? 0.0 : height;
    depth = depth === VOID ? 0.0 : depth;
    this.s2e_1 = width;
    this.t2e_1 = height;
    this.u2e_1 = depth;
    this.vector = new Vector(this.s2e_1, this.t2e_1, this.u2e_1);
  }
  protoOf(Size).u2b = function () {
    return this.s2e_1;
  };
  protoOf(Size).v2b = function () {
    return this.t2e_1;
  };
  protoOf(Size).w2b = function () {
    return this.u2e_1;
  };
  protoOf(Size).times = function (s) {
    return new Size(this.s2e_1 * s, this.t2e_1 * s, this.u2e_1 * s);
  };
  protoOf(Size).v2e = function () {
    return this.vector;
  };
  protoOf(Size).af = function () {
    return this.s2e_1;
  };
  protoOf(Size).bf = function () {
    return this.t2e_1;
  };
  protoOf(Size).g1k = function () {
    return this.u2e_1;
  };
  protoOf(Size).w2e = function (width, height, depth) {
    return new Size(width, height, depth);
  };
  protoOf(Size).copy = function (width, height, depth, $super) {
    width = width === VOID ? this.s2e_1 : width;
    height = height === VOID ? this.t2e_1 : height;
    depth = depth === VOID ? this.u2e_1 : depth;
    return this.w2e(width, height, depth);
  };
  protoOf(Size).toString = function () {
    return 'Size(width=' + this.s2e_1 + ', height=' + this.t2e_1 + ', depth=' + this.u2e_1 + ')';
  };
  protoOf(Size).hashCode = function () {
    var result = getNumberHashCode(this.s2e_1);
    result = imul(result, 31) + getNumberHashCode(this.t2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u2e_1) | 0;
    return result;
  };
  protoOf(Size).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Size))
      return false;
    var tmp0_other_with_cast = other instanceof Size ? other : THROW_CCE();
    if (!equals(this.s2e_1, tmp0_other_with_cast.s2e_1))
      return false;
    if (!equals(this.t2e_1, tmp0_other_with_cast.t2e_1))
      return false;
    if (!equals(this.u2e_1, tmp0_other_with_cast.u2e_1))
      return false;
    return true;
  };
  function Companion_59() {
    Companion_instance_59 = this;
    this.IDENTITY = new Transform(Companion_getInstance_61().ZERO, Companion_getInstance_57().IDENTITY);
  }
  protoOf(Companion_59).x2c = function () {
    return this.IDENTITY;
  };
  protoOf(Companion_59).l17 = function () {
    return $serializer_getInstance_7();
  };
  var Companion_instance_59;
  function Companion_getInstance_60() {
    if (Companion_instance_59 == null)
      new Companion_59();
    return Companion_instance_59;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Transform', this, 2);
    tmp0_serialDesc.cv('position', false);
    tmp0_serialDesc.cv('rotation', true);
    this.x2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ok = function () {
    return this.x2e_1;
  };
  protoOf($serializer_7).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_8(), $serializer_getInstance_4()];
  };
  protoOf($serializer_7).qk = function (decoder) {
    var tmp0_desc = this.x2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return Transform_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_7).y2e = function (encoder, value) {
    var tmp0_desc = this.x2e_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance_8(), value.position);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !value.rotation.equals(Companion_getInstance_57().IDENTITY)) {
      tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_4(), value.rotation);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_7).pk = function (encoder, value) {
    return this.y2e(encoder, value instanceof Transform ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function Transform_init_$Init$(seen1, position, rotation, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_7().x2e_1);
    }
    $this.position = position;
    if (0 === (seen1 & 2))
      $this.rotation = Companion_getInstance_57().IDENTITY;
    else
      $this.rotation = rotation;
    return $this;
  }
  function Transform_init_$Create$(seen1, position, rotation, serializationConstructorMarker) {
    return Transform_init_$Init$(seen1, position, rotation, serializationConstructorMarker, objectCreate(protoOf(Transform)));
  }
  function Transform(position, rotation) {
    Companion_getInstance_60();
    rotation = rotation === VOID ? Companion_getInstance_57().IDENTITY : rotation;
    this.position = position;
    this.rotation = rotation;
  }
  protoOf(Transform).ct = function () {
    return this.position;
  };
  protoOf(Transform).v1k = function () {
    return this.rotation;
  };
  protoOf(Transform).z2e = function () {
    return this.transformVector(Companion_getInstance_61().FORWARD);
  };
  protoOf(Transform).a2f = function () {
    return this.transformVector(Companion_getInstance_61().UP);
  };
  protoOf(Transform).d2c = function () {
    return this.transformVector(Companion_getInstance_61().RIGHT);
  };
  protoOf(Transform).delta = function (other) {
    return new Transform(other.inverseTransformPosition(this.position), other.inverseTransformRotation(this.rotation));
  };
  protoOf(Transform).concatenate = function (next) {
    return new Transform(this.transformPosition(next.position), this.transformRotation(next.rotation));
  };
  protoOf(Transform).transformPosition = function (point) {
    return point.rotate(this.rotation).plus(this.position);
  };
  protoOf(Transform).transformVector = function (v) {
    return v.rotate(this.rotation);
  };
  protoOf(Transform).inverseTransformPosition = function (point) {
    return point.minus(this.position).rotate(this.rotation.unaryMinus());
  };
  protoOf(Transform).inverseTransformVector = function (v) {
    return v.rotate(this.rotation.unaryMinus());
  };
  protoOf(Transform).transformRotation = function (q) {
    return q.times(this.rotation);
  };
  protoOf(Transform).inverseTransformRotation = function (q) {
    return q.times(this.rotation.inverse());
  };
  protoOf(Transform).exactEquals = function (other) {
    return this.position.exact(other.position) ? this.rotation.equals(other.rotation) : false;
  };
  protoOf(Transform).b2f = function (other, epsilon) {
    var aPosition = this.position;
    var bPosition = other.position;
    var positionAlmostTheSame = aPosition.minus(bPosition).size < epsilon;
    var aRotation = this.rotation.toEuler();
    var bRotation = other.rotation.toEuler();
    var rotationAlmostTheSame = aRotation.minus(bRotation).size < epsilon;
    return positionAlmostTheSame ? rotationAlmostTheSame : false;
  };
  protoOf(Transform).almostEquals = function (other, epsilon, $super) {
    epsilon = epsilon === VOID ? 0.001 : epsilon;
    return this.b2f(other, epsilon);
  };
  protoOf(Transform).inverse = function () {
    return new Transform(this.inverseTransformVector(this.position).unaryMinus(), this.rotation.inverse());
  };
  protoOf(Transform).af = function () {
    return this.position;
  };
  protoOf(Transform).bf = function () {
    return this.rotation;
  };
  protoOf(Transform).c2f = function (position, rotation) {
    return new Transform(position, rotation);
  };
  protoOf(Transform).copy = function (position, rotation, $super) {
    position = position === VOID ? this.position : position;
    rotation = rotation === VOID ? this.rotation : rotation;
    return this.c2f(position, rotation);
  };
  protoOf(Transform).toString = function () {
    return 'Transform(position=' + this.position + ', rotation=' + this.rotation + ')';
  };
  protoOf(Transform).hashCode = function () {
    var result = this.position.hashCode();
    result = imul(result, 31) + this.rotation.hashCode() | 0;
    return result;
  };
  protoOf(Transform).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Transform))
      return false;
    var tmp0_other_with_cast = other instanceof Transform ? other : THROW_CCE();
    if (!this.position.equals(tmp0_other_with_cast.position))
      return false;
    if (!this.rotation.equals(tmp0_other_with_cast.rotation))
      return false;
    return true;
  };
  function get_zero() {
    _init_properties_Vector_kt__7ulyhp();
    return zero;
  }
  var zero;
  function Vector_init_$Init$(xInt, yInt, zInt, $this) {
    Vector.call($this, xInt, yInt, zInt);
    return $this;
  }
  function __VectorIntConstructorKotlin(xInt, yInt, zInt) {
    return Vector_init_$Init$(xInt, yInt, zInt, objectCreate(protoOf(Vector)));
  }
  function Companion_60() {
    Companion_instance_60 = this;
    this.LEFT = VectorConstants_getInstance().LEFT;
    this.RIGHT = VectorConstants_getInstance().RIGHT;
    this.DOWN = VectorConstants_getInstance().DOWN;
    this.UP = VectorConstants_getInstance().UP;
    this.FORWARD = VectorConstants_getInstance().FORWARD;
    this.BACK = VectorConstants_getInstance().BACK;
    this.ZERO = VectorConstants_getInstance().ZERO;
    this.INFINITY = VectorConstants_getInstance().INFINITY;
    this.ONE = VectorConstants_getInstance().ONE;
  }
  protoOf(Companion_60).w2d = function () {
    return this.LEFT;
  };
  protoOf(Companion_60).y2d = function () {
    return this.RIGHT;
  };
  protoOf(Companion_60).d2f = function () {
    return this.DOWN;
  };
  protoOf(Companion_60).e2f = function () {
    return this.UP;
  };
  protoOf(Companion_60).f2f = function () {
    return this.FORWARD;
  };
  protoOf(Companion_60).h2e = function () {
    return this.BACK;
  };
  protoOf(Companion_60).g2f = function () {
    return this.ZERO;
  };
  protoOf(Companion_60).h2f = function () {
    return this.INFINITY;
  };
  protoOf(Companion_60).i22 = function () {
    return this.ONE;
  };
  protoOf(Companion_60).l17 = function () {
    return $serializer_getInstance_8();
  };
  var Companion_instance_60;
  function Companion_getInstance_61() {
    if (Companion_instance_60 == null)
      new Companion_60();
    return Companion_instance_60;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Vector', this, 3);
    tmp0_serialDesc.cv('x', true);
    tmp0_serialDesc.cv('y', true);
    tmp0_serialDesc.cv('z', true);
    this.i2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ok = function () {
    return this.i2f_1;
  };
  protoOf($serializer_8).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  protoOf($serializer_8).qk = function (decoder) {
    var tmp0_desc = this.i2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.vn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.vn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return Vector_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_8).j2f = function (encoder, value) {
    var tmp0_desc = this.i2f_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !equals(value.X, 0.0)) {
      tmp1_output.ap(tmp0_desc, 0, value.X);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !equals(value.Y, 0.0)) {
      tmp1_output.ap(tmp0_desc, 1, value.Y);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !equals(value.Z, 0.0)) {
      tmp1_output.ap(tmp0_desc, 2, value.Z);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_8).pk = function (encoder, value) {
    return this.j2f(encoder, value instanceof Vector ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function Vector_init_$Init$_0(seen1, X, Y, Z, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_8().i2f_1);
    }
    if (0 === (seen1 & 1))
      $this.X = 0.0;
    else
      $this.X = X;
    if (0 === (seen1 & 2))
      $this.Y = 0.0;
    else
      $this.Y = Y;
    if (0 === (seen1 & 4))
      $this.Z = 0.0;
    else
      $this.Z = Z;
    return $this;
  }
  function Vector_init_$Create$(seen1, X, Y, Z, serializationConstructorMarker) {
    return Vector_init_$Init$_0(seen1, X, Y, Z, serializationConstructorMarker, objectCreate(protoOf(Vector)));
  }
  function Vector(X, Y, Z) {
    Companion_getInstance_61();
    X = X === VOID ? 0.0 : X;
    Y = Y === VOID ? 0.0 : Y;
    Z = Z === VOID ? 0.0 : Z;
    this.X = X;
    this.Y = Y;
    this.Z = Z;
  }
  protoOf(Vector).k2f = function () {
    return this.X;
  };
  protoOf(Vector).l2f = function () {
    return this.Y;
  };
  protoOf(Vector).m2f = function () {
    return this.Z;
  };
  protoOf(Vector).toJson = function () {
    return '{' + toJson(this.X, 'x') + ',' + toJson(this.Y, 'y') + ', ' + toJson(this.Z, 'z') + '}';
  };
  protoOf(Vector).u2b = function () {
    return this.X;
  };
  protoOf(Vector).v2b = function () {
    return this.Y;
  };
  protoOf(Vector).w2b = function () {
    return this.Z;
  };
  protoOf(Vector).n2f = function () {
    return new Vector(this.X, this.X, this.X);
  };
  protoOf(Vector).o2f = function () {
    return new Vector(this.X, this.X, this.Y);
  };
  protoOf(Vector).p2f = function () {
    return new Vector(this.X, this.X, this.Z);
  };
  protoOf(Vector).q2f = function () {
    return new Vector(this.X, this.Y, this.X);
  };
  protoOf(Vector).r2f = function () {
    return new Vector(this.X, this.Y, this.Y);
  };
  protoOf(Vector).s2f = function () {
    return new Vector(this.X, this.Y, this.Z);
  };
  protoOf(Vector).t2f = function () {
    return new Vector(this.X, this.Z, this.X);
  };
  protoOf(Vector).u2f = function () {
    return new Vector(this.X, this.Z, this.Y);
  };
  protoOf(Vector).v2f = function () {
    return new Vector(this.X, this.Z, this.Z);
  };
  protoOf(Vector).w2f = function () {
    return new Vector(this.Y, this.X, this.X);
  };
  protoOf(Vector).x2f = function () {
    return new Vector(this.Y, this.X, this.Y);
  };
  protoOf(Vector).y2f = function () {
    return new Vector(this.Y, this.X, this.Z);
  };
  protoOf(Vector).z2f = function () {
    return new Vector(this.Y, this.Y, this.X);
  };
  protoOf(Vector).a2g = function () {
    return new Vector(this.Y, this.Y, this.Y);
  };
  protoOf(Vector).b2g = function () {
    return new Vector(this.Y, this.Y, this.Z);
  };
  protoOf(Vector).c2g = function () {
    return new Vector(this.Y, this.Z, this.X);
  };
  protoOf(Vector).d2g = function () {
    return new Vector(this.Y, this.Z, this.Y);
  };
  protoOf(Vector).e2g = function () {
    return new Vector(this.Y, this.Z, this.Z);
  };
  protoOf(Vector).f2g = function () {
    return new Vector(this.Z, this.X, this.X);
  };
  protoOf(Vector).g2g = function () {
    return new Vector(this.Z, this.X, this.Y);
  };
  protoOf(Vector).h2g = function () {
    return new Vector(this.Z, this.X, this.Z);
  };
  protoOf(Vector).i2g = function () {
    return new Vector(this.Z, this.Y, this.X);
  };
  protoOf(Vector).j2g = function () {
    return new Vector(this.Z, this.Y, this.Y);
  };
  protoOf(Vector).k2g = function () {
    return new Vector(this.Z, this.Y, this.Z);
  };
  protoOf(Vector).l2g = function () {
    return new Vector(this.Z, this.Z, this.X);
  };
  protoOf(Vector).m2g = function () {
    return new Vector(this.Z, this.Z, this.Y);
  };
  protoOf(Vector).n2g = function () {
    return new Vector(this.Z, this.Z, this.Z);
  };
  protoOf(Vector).o2g = function () {
    return new Vector(this.X, this.X, 0.0);
  };
  protoOf(Vector).p2g = function () {
    return new Vector(this.X, this.Y, 0.0);
  };
  protoOf(Vector).q2g = function () {
    return new Vector(this.X, this.Z, 0.0);
  };
  protoOf(Vector).r2g = function () {
    return new Vector(this.X, 0.0, this.Z);
  };
  protoOf(Vector).s2g = function () {
    return new Vector(this.Y, this.X, 0.0);
  };
  protoOf(Vector).t2g = function () {
    return new Vector(this.Y, this.Y, 0.0);
  };
  protoOf(Vector).u2g = function () {
    return new Vector(this.Y, this.Z, 0.0);
  };
  protoOf(Vector).v2g = function () {
    return new Vector(this.Z, this.X, 0.0);
  };
  protoOf(Vector).w2g = function () {
    return new Vector(this.Z, this.Y, 0.0);
  };
  protoOf(Vector).x2g = function () {
    return new Vector(this.Z, this.Z, 0.0);
  };
  protoOf(Vector).plus = function (vector) {
    return new Vector(vector.X + this.X, vector.Y + this.Y, vector.Z + this.Z);
  };
  protoOf(Vector).__timesOperatorKotlin = function (vector) {
    return this.dot(vector);
  };
  protoOf(Vector).timesElementWise = function (vector) {
    return new Vector(this.X * vector.X, this.Y * vector.Y, this.Z * vector.Z);
  };
  protoOf(Vector).divideElementWise = function (vector) {
    return new Vector(this.X / vector.X, this.Y / vector.Y, this.Z / vector.Z);
  };
  protoOf(Vector).dot = function (vector) {
    return vector.X * this.X + vector.Y * this.Y + vector.Z * this.Z;
  };
  protoOf(Vector).cross = function (vector) {
    return new Vector(this.Y * vector.Z - this.Z * vector.Y, this.Z * vector.X - this.X * vector.Z, this.X * vector.Y - this.Y * vector.X);
  };
  protoOf(Vector).times = function (scalar) {
    return new Vector(scalar * this.X, scalar * this.Y, scalar * this.Z);
  };
  protoOf(Vector).__timesIntForKotlin = function (scalar) {
    return new Vector(scalar * this.X, scalar * this.Y, scalar * this.Z);
  };
  protoOf(Vector).minus = function (vector) {
    return new Vector(this.X - vector.X, this.Y - vector.Y, this.Z - vector.Z);
  };
  protoOf(Vector).div = function (scalar) {
    return new Vector(this.X / scalar, this.Y / scalar, this.Z / scalar);
  };
  protoOf(Vector).__divIntForKotlin = function (scalar) {
    return new Vector(this.X / scalar, this.Y / scalar, this.Z / scalar);
  };
  protoOf(Vector).unaryMinus = function () {
    return this.times(-1.0);
  };
  protoOf(Vector).rotateAroundPivot = function (rotation, pivot) {
    return this.minus(pivot).rotate(rotation).plus(pivot);
  };
  protoOf(Vector).rotateZ = function (theta) {
    return this.rotate(Companion_getInstance_57().fromAxisAngle(Companion_getInstance_61().BACK, theta.toRadian()));
  };
  protoOf(Vector).rotateY = function (theta) {
    return this.rotate(Companion_getInstance_57().fromAxisAngle(Companion_getInstance_61().UP, theta.toRadian()));
  };
  protoOf(Vector).rotateX = function (theta) {
    return this.rotate(Companion_getInstance_57().fromAxisAngle(Companion_getInstance_61().RIGHT, theta.toRadian()));
  };
  protoOf(Vector).rotateAroundAxis = function (axis, angle) {
    return this.rotate(Companion_getInstance_57().fromAxisAngle(axis, angle));
  };
  protoOf(Vector).rotate = function (quaternion) {
    var tmp;
    if (quaternion.isIdentity) {
      tmp = this;
    } else {
      var q = quaternion.normalize();
      var qDiff = q.w * q.w - (q.x * q.x + q.y * q.y + q.z * q.z);
      var thisTimesQ = 2 * (this.X * q.x + this.Y * q.y + this.Z * q.z);
      var twoQW = 2 * q.w;
      tmp = new Vector(this.X * qDiff + q.x * thisTimesQ + (q.y * this.Z - q.z * this.Y) * twoQW, this.Y * qDiff + q.y * thisTimesQ + (q.z * this.X - q.x * this.Z) * twoQW, this.Z * qDiff + q.z * thisTimesQ + (q.x * this.Y - q.y * this.X) * twoQW);
    }
    return tmp;
  };
  protoOf(Vector).distanceTo = function (otherPoint) {
    var xx = this.X - otherPoint.X;
    var yy = this.Y - otherPoint.Y;
    var zz = this.Z - otherPoint.Z;
    // Inline function 'kotlin.math.sqrt' call
    var x = xx * xx + yy * yy + zz * zz;
    return Math.sqrt(x);
  };
  protoOf(Vector).normalize = function () {
    var size = this.size;
    var tmp;
    if (size === 0.0) {
      tmp = this;
    } else {
      tmp = this.div(size);
    }
    return tmp;
  };
  protoOf(Vector).setSize = function (newSize) {
    return this.div(this.size).times(newSize);
  };
  protoOf(Vector).angle = function (other) {
    var cosValue = this.__timesOperatorKotlin(other) / (this.size * other.size);
    // Inline function 'kotlin.math.acos' call
    var result = Math.acos(cosValue);
    if (isNaN_0(result)) {
      return cosValue < -1.0 ? get_PI() : 0.0;
    }
    return result;
  };
  protoOf(Vector).y2g = function (other, up) {
    var unsignedAngle = this.angle(other);
    var perpendicular = this.cross(other);
    var dot = up.dot(perpendicular);
    // Inline function 'kotlin.math.sign' call
    var signedDot = sign(dot);
    if (signedDot === 0.0)
      return unsignedAngle;
    return signedDot * unsignedAngle;
  };
  protoOf(Vector).signedAngle = function (other, up, $super) {
    up = up === VOID ? Companion_getInstance_61().UP : up;
    return this.y2g(other, up);
  };
  protoOf(Vector).getRotationTo = function (other) {
    var angle = this.angle(other);
    var cross = this.cross(other);
    var tmp;
    if (cross.equals(Companion_getInstance_61().ZERO)) {
      tmp = Companion_getInstance_61().UP;
    } else {
      tmp = cross;
    }
    var axis = tmp;
    return Companion_getInstance_57().fromAxisAngle(axis, new Radians(angle));
  };
  protoOf(Vector).n = function () {
    var tmp;
    if ((this.X === 0.0 ? this.Y === 0.0 : false) ? this.Z === 0.0 : false) {
      tmp = 0.0;
    } else {
      // Inline function 'kotlin.math.sqrt' call
      var x = this.X * this.X + this.Y * this.Y + this.Z * this.Z;
      tmp = Math.sqrt(x);
    }
    return tmp;
  };
  protoOf(Vector).z2g = function () {
    // Inline function 'kotlin.math.abs' call
    var x = this.X;
    var tmp = Math.abs(x);
    // Inline function 'kotlin.math.abs' call
    var x_0 = this.Y;
    var tmp_0 = Math.abs(x_0);
    // Inline function 'kotlin.math.abs' call
    var x_1 = this.Z;
    var tmp$ret$2 = Math.abs(x_1);
    return new Vector(tmp, tmp_0, tmp$ret$2);
  };
  protoOf(Vector).equals = function (other) {
    var tmp;
    if (null == other) {
      tmp = true;
    } else {
      tmp = !(other instanceof Vector);
    }
    if (tmp)
      return false;
    return (almostEquals(other.X, this.X) ? almostEquals(other.Y, this.Y) : false) ? almostEquals(other.Z, this.Z) : false;
  };
  protoOf(Vector).hashCode = function () {
    return 0;
  };
  protoOf(Vector).projectOnPlaneFromPoints = function (p1, p2, p3) {
    var n = p3.minus(p2).cross(p1.minus(p2)).normalize();
    return this.projectOnPlane(n, p1);
  };
  protoOf(Vector).projectOnPlane = function (normal, pointOnPlane) {
    return this.minus(times(normal.__timesOperatorKotlin(this.minus(pointOnPlane)), normal));
  };
  protoOf(Vector).projectOn = function (direction) {
    var s = this.__timesOperatorKotlin(direction);
    return direction.times(s);
  };
  protoOf(Vector).project = function (ptSet, output) {
    var minAlong = 1.7976931348623157E308;
    var maxAlong = -1.7976931348623157E308;
    var inductionVariable = 0;
    var last = ptSet.length;
    while (inductionVariable < last) {
      var pt = ptSet[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var dotVal = pt.__timesOperatorKotlin(this);
      if (dotVal < minAlong)
        minAlong = dotVal;
      if (dotVal > maxAlong)
        maxAlong = dotVal;
    }
    output.first = minAlong;
    output.last = maxAlong;
  };
  protoOf(Vector).pointOnLine = function (p1, p2) {
    var p = this;
    var line = p2.minus(p1);
    var p1_p = p.minus(p1);
    var p_p2 = p2.minus(p);
    var segmentsSum = p1_p.size + p_p2.size;
    return almostEquals(line.size, segmentsSum, 1.0E-4);
  };
  protoOf(Vector).isZero = function () {
    return (this.X === 0.0 ? this.Y === 0.0 : false) ? this.Z === 0.0 : false;
  };
  protoOf(Vector).notZero = function () {
    return (!(this.X === 0.0) ? true : !(this.Y === 0.0)) ? true : !(this.Z === 0.0);
  };
  protoOf(Vector).exact = function (other) {
    return (this.X === other.X ? this.Y === other.Y : false) ? this.Z === other.Z : false;
  };
  protoOf(Vector).notExact = function (other) {
    return (!(this.X === other.X) ? true : !(this.Y === other.Y)) ? true : !(this.Z === other.Z);
  };
  protoOf(Vector).elementWiseInverse = function () {
    return new Vector(1.0 / this.X, 1.0 / this.Y, 1.0 / this.Z);
  };
  protoOf(Vector).a2h = function (x, y, z) {
    var tmp = x == null ? this.X : x;
    var tmp_0 = y == null ? this.Y : y;
    return new Vector(tmp, tmp_0, z == null ? this.Z : z);
  };
  protoOf(Vector).with = function (x, y, z, $super) {
    x = x === VOID ? null : x;
    y = y === VOID ? null : y;
    z = z === VOID ? null : z;
    return this.a2h(x, y, z);
  };
  protoOf(Vector).af = function () {
    return this.X;
  };
  protoOf(Vector).bf = function () {
    return this.Y;
  };
  protoOf(Vector).g1k = function () {
    return this.Z;
  };
  protoOf(Vector).w2e = function (X, Y, Z) {
    return new Vector(X, Y, Z);
  };
  protoOf(Vector).copy = function (X, Y, Z, $super) {
    X = X === VOID ? this.X : X;
    Y = Y === VOID ? this.Y : Y;
    Z = Z === VOID ? this.Z : Z;
    return this.w2e(X, Y, Z);
  };
  protoOf(Vector).toString = function () {
    return 'Vector(X=' + this.X + ', Y=' + this.Y + ', Z=' + this.Z + ')';
  };
  function get_geometricMean(_this__u8e3s4) {
    _init_properties_Vector_kt__7ulyhp();
    var mean = Companion_getInstance_61().ZERO;
    var num = 0;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var element = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.math.<get-geometricMean>.<anonymous>' call
      mean = mean.plus(element);
      num = num + 1 | 0;
    }
    mean = mean.times(1.0 / num);
    return mean;
  }
  function almostEquals(_this__u8e3s4, other, epsilon) {
    epsilon = epsilon === VOID ? 0.001 : epsilon;
    _init_properties_Vector_kt__7ulyhp();
    var tmp;
    if (_this__u8e3s4 === other) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x = _this__u8e3s4 - other;
      tmp = Math.abs(x) < epsilon;
    }
    return tmp;
  }
  function VectorConstants() {
    VectorConstants_instance = this;
    this.LEFT = __VectorIntConstructorKotlin(-1, 0, 0);
    this.RIGHT = __VectorIntConstructorKotlin(1, 0, 0);
    this.DOWN = __VectorIntConstructorKotlin(0, -1, 0);
    this.UP = __VectorIntConstructorKotlin(0, 1, 0);
    this.FORWARD = __VectorIntConstructorKotlin(0, 0, -1);
    this.BACK = __VectorIntConstructorKotlin(0, 0, 1);
    this.ZERO = __VectorIntConstructorKotlin(0, 0, 0);
    var tmp = this;
    tmp.INFINITY = new Vector(Infinity, Infinity, Infinity);
    this.ONE = __VectorIntConstructorKotlin(1, 1, 1);
  }
  protoOf(VectorConstants).w2d = function () {
    return this.LEFT;
  };
  protoOf(VectorConstants).y2d = function () {
    return this.RIGHT;
  };
  protoOf(VectorConstants).d2f = function () {
    return this.DOWN;
  };
  protoOf(VectorConstants).e2f = function () {
    return this.UP;
  };
  protoOf(VectorConstants).f2f = function () {
    return this.FORWARD;
  };
  protoOf(VectorConstants).h2e = function () {
    return this.BACK;
  };
  protoOf(VectorConstants).g2f = function () {
    return this.ZERO;
  };
  protoOf(VectorConstants).h2f = function () {
    return this.INFINITY;
  };
  protoOf(VectorConstants).i22 = function () {
    return this.ONE;
  };
  var VectorConstants_instance;
  function VectorConstants_getInstance() {
    if (VectorConstants_instance == null)
      new VectorConstants();
    return VectorConstants_instance;
  }
  var properties_initialized_Vector_kt_6ddpp7;
  function _init_properties_Vector_kt__7ulyhp() {
    if (!properties_initialized_Vector_kt_6ddpp7) {
      properties_initialized_Vector_kt_6ddpp7 = true;
      zero = new Vector(0.0, 0.0, 0.0);
    }
  }
  function times(_this__u8e3s4, other) {
    return other.times(_this__u8e3s4);
  }
  function InnerMeasurement$distance$delegate$lambda(this$0) {
    return function () {
      return this$0.start.point.distanceTo(this$0.end.point);
    };
  }
  function InnerMeasurement(start, end) {
    this.start = start;
    this.end = end;
    var tmp = this;
    tmp.b2h_1 = lazy(InnerMeasurement$distance$delegate$lambda(this));
  }
  protoOf(InnerMeasurement).s9 = function () {
    return this.start;
  };
  protoOf(InnerMeasurement).g23 = function () {
    return this.end;
  };
  protoOf(InnerMeasurement).c2h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b2h_1;
    distance$factory();
    return this_0.u2();
  };
  protoOf(InnerMeasurement).af = function () {
    return this.start;
  };
  protoOf(InnerMeasurement).bf = function () {
    return this.end;
  };
  protoOf(InnerMeasurement).d2h = function (start, end) {
    return new InnerMeasurement(start, end);
  };
  protoOf(InnerMeasurement).copy = function (start, end, $super) {
    start = start === VOID ? this.start : start;
    end = end === VOID ? this.end : end;
    return this.d2h(start, end);
  };
  protoOf(InnerMeasurement).toString = function () {
    return 'InnerMeasurement(start=' + this.start + ', end=' + this.end + ')';
  };
  protoOf(InnerMeasurement).hashCode = function () {
    var result = this.start.hashCode();
    result = imul(result, 31) + this.end.hashCode() | 0;
    return result;
  };
  protoOf(InnerMeasurement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InnerMeasurement))
      return false;
    var tmp0_other_with_cast = other instanceof InnerMeasurement ? other : THROW_CCE();
    if (!this.start.equals(tmp0_other_with_cast.start))
      return false;
    if (!this.end.equals(tmp0_other_with_cast.end))
      return false;
    return true;
  };
  function MeasurementUtils() {
    MeasurementUtils_instance = this;
    this.e2h_1 = LoggerState_getInstance().m1m('MeasurementUtils');
  }
  protoOf(MeasurementUtils).getOutsideMeasurementSingle = function (entity) {
    return get_axisAlignedBoundingBoxForHierarchy(entity);
  };
  protoOf(MeasurementUtils).getOutsideMeasurement = function (entities) {
    return Companion_instance_9.axisAlignedBoundingBoxForEntityHierarchies(entities);
  };
  protoOf(MeasurementUtils).getOutsideMeasurementSingleWithoutHierarchy = function (entity) {
    var tmp0_safe_receiver = get_collider(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
  };
  protoOf(MeasurementUtils).getOutsideMeasurementWithoutHierarchies = function (entities) {
    return Companion_instance_9.axisAlignedBoundingBoxForEntities(entities);
  };
  protoOf(MeasurementUtils).getLocalOutsideMeasurementForEntities = function (entities, baseWorldTransform) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var vertices = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = entities.length;
    while (inductionVariable < last) {
      var element = entities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.measuring.MeasurementUtils.getLocalOutsideMeasurementForEntities.<anonymous>' call
      var transform = get_worldTransform(element);
      var tmp0_safe_receiver = get_colliderShapeComponent(element);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.measuring.MeasurementUtils.getLocalOutsideMeasurementForEntities.<anonymous>.<anonymous>' call
        tmp = PolyhedronUtils_getInstance().transformAndExtractVerticesFromPolyhedron(tmp0_safe_receiver.polyhedron, transform);
      }
      var transformedVerticesForShape = tmp;
      if (!(transformedVerticesForShape == null)) {
        vertices.x(transformedVerticesForShape);
      }
    }
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = vertices.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.measuring.MeasurementUtils.getLocalOutsideMeasurementForEntities.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var i = checkIndexOverflow(tmp1);
      vertices.o(i, baseWorldTransform.inverseTransformPosition(item));
    }
    var tmp_0;
    if (vertices.b1()) {
      return null;
    } else {
      var tmp_1 = Companion_getInstance_93();
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$3 = copyToArray(vertices);
      tmp_0 = tmp_1.fromVertices(tmp$ret$3);
    }
    return tmp_0;
  };
  protoOf(MeasurementUtils).getInsideMeasurementLocalSpace = function (entity, root, directionLocalSpace) {
    var directionWorldSpace = get_worldTransform(entity).transformVector(directionLocalSpace);
    return this.getInsideMeasurementWorldSpace(entity, root, directionWorldSpace);
  };
  protoOf(MeasurementUtils).getInsideMeasurementWorldSpace = function (entity, root, directionWorldSpace) {
    var ray = new Ray(get_worldPosition(entity), directionWorldSpace);
    var tmp0_elvis_lhs = RaycastUtils_instance.raycast(ray, root, entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var outerHit = tmp;
    var epsilonOffset = directionWorldSpace.times(0.1);
    var reverseRayOrigin = outerHit.point.plus(epsilonOffset);
    var reverseRay = new Ray(reverseRayOrigin, directionWorldSpace.unaryMinus());
    var selfHit = RaycastUtils_instance.raycast(reverseRay, entity);
    if (selfHit == null ? true : selfHit.distance > outerHit.distance) {
      selfHit = new RaycastHit(get_worldPosition(entity), entity, reverseRay.origin.distanceTo(get_worldPosition(entity)), reverseRay.direction.normalize());
    }
    return new InnerMeasurement(selfHit, outerHit);
  };
  var MeasurementUtils_instance;
  function MeasurementUtils_getInstance() {
    if (MeasurementUtils_instance == null)
      new MeasurementUtils();
    return MeasurementUtils_instance;
  }
  function distance$factory() {
    return getPropertyCallableRef('distance', 1, KProperty1, function (receiver) {
      return receiver.distance;
    }, null);
  }
  function get_nothing() {
    throw IllegalStateException_init_$Create$('This should never really be accessed');
  }
  function Companion_61() {
    this.id = 15;
  }
  protoOf(Companion_61).s1k = function () {
    return this.id;
  };
  var Companion_instance_61;
  function Companion_getInstance_62() {
    return Companion_instance_61;
  }
  function DisplayNameComponent(name) {
    this.name = name;
  }
  protoOf(DisplayNameComponent).mb = function () {
    return this.name;
  };
  protoOf(DisplayNameComponent).x1k = function () {
    return 15;
  };
  protoOf(DisplayNameComponent).eq = function (other) {
    return (other instanceof DisplayNameComponent ? other : THROW_CCE()).name === this.name;
  };
  protoOf(DisplayNameComponent).equals = function (other) {
    var tmp;
    if (other instanceof DisplayNameComponent) {
      tmp = other.name === this.name;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DisplayNameComponent).hashCode = function () {
    return getStringHashCode(this.name);
  };
  protoOf(DisplayNameComponent).af = function () {
    return this.name;
  };
  protoOf(DisplayNameComponent).q1l = function (name) {
    return new DisplayNameComponent(name);
  };
  protoOf(DisplayNameComponent).copy = function (name, $super) {
    name = name === VOID ? this.name : name;
    return this.q1l(name);
  };
  protoOf(DisplayNameComponent).toString = function () {
    return 'DisplayNameComponent(name=' + this.name + ')';
  };
  function get_displayName(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.isDisposed) {
      tmp = 'Disposed entity ' + _this__u8e3s4.id;
    } else {
      var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(15);
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name;
    }
    return tmp;
  }
  function ProductUtils() {
  }
  protoOf(ProductUtils).productComponent = function (entity) {
    return get_productComponent(entity);
  };
  protoOf(ProductUtils).productRef = function (entity) {
    return get_productRef(entity);
  };
  protoOf(ProductUtils).productRefOrEmptyString = function (entity) {
    return get_productRefOrEmptyString(entity);
  };
  protoOf(ProductUtils).isConnectionRoot = function (entity) {
    return get_isConnectionRoot(entity);
  };
  protoOf(ProductUtils).connectionRootEntity = function (entity) {
    var tmp = HierarchyUtils_instance;
    return tmp.findWithComponentInUpwardsHierarchy(entity, 28);
  };
  protoOf(ProductUtils).immediateConnectionRootDescendants = function (entity) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = get_immediateConnectionRootDescendants(entity);
    return copyToArray(this_0);
  };
  protoOf(ProductUtils).partKey = function (entity) {
    return get_partKey(entity);
  };
  var ProductUtils_instance;
  function ProductUtils_getInstance() {
    return ProductUtils_instance;
  }
  function get_connectionRootEntity(_this__u8e3s4) {
    return ProductUtils_instance.connectionRootEntity(_this__u8e3s4);
  }
  function get_immediateConnectionRootDescendants(_this__u8e3s4) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = get_children(_this__u8e3s4);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.products.<get-immediateConnectionRootDescendants>.<anonymous>' call
      var list = get_isConnectionRoot(element) ? listOf(element) : get_immediateConnectionRootDescendants(element);
      addAll(destination, list);
    }
    return destination;
  }
  function ProppingComponent() {
  }
  protoOf(ProppingComponent).x1k = function () {
    return this.id;
  };
  protoOf(ProppingComponent).s1k = function () {
    return 7;
  };
  protoOf(ProppingComponent).eq = function (other) {
    return true;
  };
  var ProppingComponent_instance;
  function ProppingComponent_getInstance() {
    return ProppingComponent_instance;
  }
  function get_isPropping(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(ProppingComponent_instance.id);
  }
  function Companion_62() {
    this.id = 49;
  }
  protoOf(Companion_62).s1k = function () {
    return this.id;
  };
  var Companion_instance_62;
  function Companion_getInstance_63() {
    return Companion_instance_62;
  }
  function TemplateDataComponent(templateId, size, comSize, family, variant) {
    family = family === VOID ? '' : family;
    variant = variant === VOID ? null : variant;
    this.templateId = templateId;
    this.size = size;
    this.comSize = comSize;
    this.family = family;
    this.variant = variant;
  }
  protoOf(TemplateDataComponent).f2h = function () {
    return this.templateId;
  };
  protoOf(TemplateDataComponent).n = function () {
    return this.size;
  };
  protoOf(TemplateDataComponent).g2h = function () {
    return this.comSize;
  };
  protoOf(TemplateDataComponent).h2h = function () {
    return this.family;
  };
  protoOf(TemplateDataComponent).e1k = function () {
    return this.variant;
  };
  protoOf(TemplateDataComponent).x1k = function () {
    return 49;
  };
  protoOf(TemplateDataComponent).eq = function (other) {
    var otherC = other instanceof TemplateDataComponent ? other : THROW_CCE();
    return (((otherC.templateId === this.templateId ? otherC.size.equals(this.size) : false) ? otherC.comSize.equals(this.comSize) : false) ? otherC.family == this.family : false) ? otherC.variant == this.variant : false;
  };
  protoOf(TemplateDataComponent).equals = function (other) {
    var tmp;
    if (!(other instanceof TemplateDataComponent)) {
      tmp = true;
    } else {
      tmp = !(other.templateId === this.templateId);
    }
    if (tmp)
      return false;
    if (!(other.variant == this.variant))
      return false;
    return other.comSize.exact(this.comSize);
  };
  protoOf(TemplateDataComponent).hashCode = function () {
    return getStringHashCode(this.templateId);
  };
  protoOf(TemplateDataComponent).af = function () {
    return this.templateId;
  };
  protoOf(TemplateDataComponent).bf = function () {
    return this.size;
  };
  protoOf(TemplateDataComponent).g1k = function () {
    return this.comSize;
  };
  protoOf(TemplateDataComponent).h1k = function () {
    return this.family;
  };
  protoOf(TemplateDataComponent).i1k = function () {
    return this.variant;
  };
  protoOf(TemplateDataComponent).i2h = function (templateId, size, comSize, family, variant) {
    return new TemplateDataComponent(templateId, size, comSize, family, variant);
  };
  protoOf(TemplateDataComponent).copy = function (templateId, size, comSize, family, variant, $super) {
    templateId = templateId === VOID ? this.templateId : templateId;
    size = size === VOID ? this.size : size;
    comSize = comSize === VOID ? this.comSize : comSize;
    family = family === VOID ? this.family : family;
    variant = variant === VOID ? this.variant : variant;
    return this.i2h(templateId, size, comSize, family, variant);
  };
  protoOf(TemplateDataComponent).toString = function () {
    return 'TemplateDataComponent(templateId=' + this.templateId + ', size=' + this.size + ', comSize=' + this.comSize + ', family=' + this.family + ', variant=' + this.variant + ')';
  };
  function Companion_63() {
  }
  protoOf(Companion_63).createFromPoints = function (from, to) {
    var direction = to.minus(from).normalize();
    return new Ray(from, direction);
  };
  var Companion_instance_63;
  function Companion_getInstance_64() {
    return Companion_instance_63;
  }
  function Ray(origin, direction) {
    this.origin = origin;
    this.direction = direction;
  }
  protoOf(Ray).j2h = function () {
    return this.origin;
  };
  protoOf(Ray).o1z = function () {
    return this.direction;
  };
  protoOf(Ray).toString = function () {
    return 'Ray origin ' + this.origin + ' direction ' + this.direction;
  };
  protoOf(Ray).getPointAlongRay = function (distance) {
    return this.origin.plus(times(distance, this.direction));
  };
  protoOf(Ray).hitsPoint = function (point) {
    var directionToPoint = point.minus(this.origin);
    return directionToPoint.normalize().equals(this.direction.normalize());
  };
  protoOf(Ray).closestPointOnRay = function (point) {
    var rayDir = this.direction.normalize();
    var fromRayOriginToPoint = point.minus(this.origin);
    var weight = rayDir.dot(fromRayOriginToPoint);
    var tmp;
    if (weight < 0.0) {
      tmp = this.origin;
    } else {
      tmp = this.origin.plus(times(weight, rayDir));
    }
    return tmp;
  };
  protoOf(Ray).af = function () {
    return this.origin;
  };
  protoOf(Ray).bf = function () {
    return this.direction;
  };
  protoOf(Ray).u2c = function (origin, direction) {
    return new Ray(origin, direction);
  };
  protoOf(Ray).copy = function (origin, direction, $super) {
    origin = origin === VOID ? this.origin : origin;
    direction = direction === VOID ? this.direction : direction;
    return this.u2c(origin, direction);
  };
  protoOf(Ray).hashCode = function () {
    var result = this.origin.hashCode();
    result = imul(result, 31) + this.direction.hashCode() | 0;
    return result;
  };
  protoOf(Ray).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ray))
      return false;
    var tmp0_other_with_cast = other instanceof Ray ? other : THROW_CCE();
    if (!this.origin.equals(tmp0_other_with_cast.origin))
      return false;
    if (!this.direction.equals(tmp0_other_with_cast.direction))
      return false;
    return true;
  };
  function RaycastHit(point, entity, distance, surfaceNormal) {
    this.point = point;
    this.entity = entity;
    this.distance = distance;
    this.surfaceNormal = surfaceNormal;
  }
  protoOf(RaycastHit).g24 = function () {
    return this.point;
  };
  protoOf(RaycastHit).r23 = function () {
    return this.entity;
  };
  protoOf(RaycastHit).c2h = function () {
    return this.distance;
  };
  protoOf(RaycastHit).k2h = function () {
    return this.surfaceNormal;
  };
  protoOf(RaycastHit).asRaycastResult = function () {
    return new RaycastResult(this.point, this.surfaceNormal);
  };
  protoOf(RaycastHit).af = function () {
    return this.point;
  };
  protoOf(RaycastHit).bf = function () {
    return this.entity;
  };
  protoOf(RaycastHit).g1k = function () {
    return this.distance;
  };
  protoOf(RaycastHit).h1k = function () {
    return this.surfaceNormal;
  };
  protoOf(RaycastHit).l2h = function (point, entity, distance, surfaceNormal) {
    return new RaycastHit(point, entity, distance, surfaceNormal);
  };
  protoOf(RaycastHit).copy = function (point, entity, distance, surfaceNormal, $super) {
    point = point === VOID ? this.point : point;
    entity = entity === VOID ? this.entity : entity;
    distance = distance === VOID ? this.distance : distance;
    surfaceNormal = surfaceNormal === VOID ? this.surfaceNormal : surfaceNormal;
    return this.l2h(point, entity, distance, surfaceNormal);
  };
  protoOf(RaycastHit).toString = function () {
    return 'RaycastHit(point=' + this.point + ', entity=' + this.entity + ', distance=' + this.distance + ', surfaceNormal=' + this.surfaceNormal + ')';
  };
  protoOf(RaycastHit).hashCode = function () {
    var result = this.point.hashCode();
    result = imul(result, 31) + this.entity.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.distance) | 0;
    result = imul(result, 31) + this.surfaceNormal.hashCode() | 0;
    return result;
  };
  protoOf(RaycastHit).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RaycastHit))
      return false;
    var tmp0_other_with_cast = other instanceof RaycastHit ? other : THROW_CCE();
    if (!this.point.equals(tmp0_other_with_cast.point))
      return false;
    if (!this.entity.equals(tmp0_other_with_cast.entity))
      return false;
    if (!equals(this.distance, tmp0_other_with_cast.distance))
      return false;
    if (!this.surfaceNormal.equals(tmp0_other_with_cast.surfaceNormal))
      return false;
    return true;
  };
  function RaycastResult(point, surfaceNormal) {
    this.point = point;
    this.surfaceNormal = surfaceNormal;
  }
  protoOf(RaycastResult).g24 = function () {
    return this.point;
  };
  protoOf(RaycastResult).k2h = function () {
    return this.surfaceNormal;
  };
  protoOf(RaycastResult).af = function () {
    return this.point;
  };
  protoOf(RaycastResult).bf = function () {
    return this.surfaceNormal;
  };
  protoOf(RaycastResult).u2c = function (point, surfaceNormal) {
    return new RaycastResult(point, surfaceNormal);
  };
  protoOf(RaycastResult).copy = function (point, surfaceNormal, $super) {
    point = point === VOID ? this.point : point;
    surfaceNormal = surfaceNormal === VOID ? this.surfaceNormal : surfaceNormal;
    return this.u2c(point, surfaceNormal);
  };
  protoOf(RaycastResult).toString = function () {
    return 'RaycastResult(point=' + this.point + ', surfaceNormal=' + this.surfaceNormal + ')';
  };
  protoOf(RaycastResult).hashCode = function () {
    var result = this.point.hashCode();
    result = imul(result, 31) + this.surfaceNormal.hashCode() | 0;
    return result;
  };
  protoOf(RaycastResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RaycastResult))
      return false;
    var tmp0_other_with_cast = other instanceof RaycastResult ? other : THROW_CCE();
    if (!this.point.equals(tmp0_other_with_cast.point))
      return false;
    if (!this.surfaceNormal.equals(tmp0_other_with_cast.surfaceNormal))
      return false;
    return true;
  };
  function raycast$iterator($ray, closestHit, entity) {
    var tmp0_safe_receiver = get_collider(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.raycasting.RaycastUtils.raycast.iterator.<anonymous>' call
      var tmp0_safe_receiver_0 = tmp1_safe_receiver.raycast($ray);
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var hitDistance = $ray.origin.distanceTo(tmp0_safe_receiver_0.point);
        var tmp0_safe_receiver_1 = closestHit._v;
        var tmp1_elvis_lhs = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.distance;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          tmp_0 = Infinity;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var closestDistance = tmp_0;
        var tmp_1;
        if (hitDistance < closestDistance) {
          closestHit._v = new RaycastHit(tmp0_safe_receiver_0.point, entity, hitDistance, tmp0_safe_receiver_0.surfaceNormal);
          tmp_1 = Unit_instance;
        }
        tmp = Unit_instance;
      }
    }
  }
  function raycastAll$iterator($ray, hits, entity) {
    var tmp0_safe_receiver = get_collider(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.raycasting.RaycastUtils.raycastAll.iterator.<anonymous>' call
      var tmp0_safe_receiver_0 = tmp1_safe_receiver.raycast($ray);
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.raycasting.RaycastUtils.raycastAll.iterator.<anonymous>.<anonymous>' call
        var hitDistance = $ray.origin.distanceTo(tmp0_safe_receiver_0.point);
        tmp = hits.q(new RaycastHit(tmp0_safe_receiver_0.point, entity, hitDistance, tmp0_safe_receiver_0.surfaceNormal));
      }
    }
  }
  function RaycastUtils$raycast$iterator$ref($ray, $closestHit) {
    var l = function (p0) {
      raycast$iterator($ray, $closestHit, p0);
      return Unit_instance;
    };
    l.callableName = 'iterator';
    return l;
  }
  function RaycastUtils$raycast$iterator$ref_0($ray, $closestHit) {
    var l = function (p0) {
      raycast$iterator($ray, $closestHit, p0);
      return Unit_instance;
    };
    l.callableName = 'iterator';
    return l;
  }
  function RaycastUtils$raycastAll$iterator$ref($ray, $hits) {
    var l = function (p0) {
      raycastAll$iterator($ray, $hits, p0);
      return Unit_instance;
    };
    l.callableName = 'iterator';
    return l;
  }
  function RaycastUtils$raycastAll$iterator$ref_0($ray, $hits) {
    var l = function (p0) {
      raycastAll$iterator($ray, $hits, p0);
      return Unit_instance;
    };
    l.callableName = 'iterator';
    return l;
  }
  function RaycastUtils() {
  }
  protoOf(RaycastUtils).m2h = function (ray, root, hierarchyToIgnore) {
    var closestHit = {_v: null};
    if (hierarchyToIgnore == null) {
      forEachInHierarchy(root, RaycastUtils$raycast$iterator$ref(ray, closestHit));
    } else {
      forEachInHierarchyExceptHierarchyOfIgnored(root, hierarchyToIgnore, RaycastUtils$raycast$iterator$ref_0(ray, closestHit));
    }
    return closestHit._v;
  };
  protoOf(RaycastUtils).raycast = function (ray, root, hierarchyToIgnore, $super) {
    hierarchyToIgnore = hierarchyToIgnore === VOID ? null : hierarchyToIgnore;
    return this.m2h(ray, root, hierarchyToIgnore);
  };
  protoOf(RaycastUtils).n2h = function (ray, root, hierarchyToIgnore) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var hits = ArrayList_init_$Create$();
    if (hierarchyToIgnore == null) {
      forEachInHierarchy(root, RaycastUtils$raycastAll$iterator$ref(ray, hits));
    } else {
      forEachInHierarchyExceptHierarchyOfIgnored(root, hierarchyToIgnore, RaycastUtils$raycastAll$iterator$ref_0(ray, hits));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(hits);
  };
  protoOf(RaycastUtils).raycastAll = function (ray, root, hierarchyToIgnore, $super) {
    hierarchyToIgnore = hierarchyToIgnore === VOID ? null : hierarchyToIgnore;
    return this.n2h(ray, root, hierarchyToIgnore);
  };
  var RaycastUtils_instance;
  function RaycastUtils_getInstance() {
    return RaycastUtils_instance;
  }
  function Raycastable() {
  }
  function Companion_64() {
    this.id = 20;
  }
  protoOf(Companion_64).s1k = function () {
    return this.id;
  };
  protoOf(Companion_64).o2h = function (hasFinishedLoading) {
    return new LoadedModelInfoComponent(hasFinishedLoading);
  };
  protoOf(Companion_64).createForTest = function (hasFinishedLoading, $super) {
    hasFinishedLoading = hasFinishedLoading === VOID ? true : hasFinishedLoading;
    return this.o2h(hasFinishedLoading);
  };
  var Companion_instance_64;
  function Companion_getInstance_65() {
    return Companion_instance_64;
  }
  function LoadedModelInfoComponent(hasFinishedLoading, hasFailedLoading) {
    hasFinishedLoading = hasFinishedLoading === VOID ? true : hasFinishedLoading;
    hasFailedLoading = hasFailedLoading === VOID ? false : hasFailedLoading;
    this.hasFinishedLoading = hasFinishedLoading;
    this.hasFailedLoading = hasFailedLoading;
    this.p2h_1 = false;
  }
  protoOf(LoadedModelInfoComponent).q2h = function () {
    return this.hasFinishedLoading;
  };
  protoOf(LoadedModelInfoComponent).r2h = function () {
    return this.hasFailedLoading;
  };
  protoOf(LoadedModelInfoComponent).x1k = function () {
    return 20;
  };
  protoOf(LoadedModelInfoComponent).withFinishedLoading = function () {
    return new LoadedModelInfoComponent(true);
  };
  protoOf(LoadedModelInfoComponent).withFailedLoading = function () {
    return new LoadedModelInfoComponent(false, true);
  };
  protoOf(LoadedModelInfoComponent).eq = function (other) {
    var tmp;
    if ((other instanceof LoadedModelInfoComponent ? other : THROW_CCE()).hasFinishedLoading === this.hasFinishedLoading) {
      tmp = other.hasFailedLoading === this.hasFinishedLoading;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LoadedModelInfoComponent).a1l = function () {
    return this.p2h_1;
  };
  protoOf(LoadedModelInfoComponent).af = function () {
    return this.hasFinishedLoading;
  };
  protoOf(LoadedModelInfoComponent).bf = function () {
    return this.hasFailedLoading;
  };
  protoOf(LoadedModelInfoComponent).s2h = function (hasFinishedLoading, hasFailedLoading) {
    return new LoadedModelInfoComponent(hasFinishedLoading, hasFailedLoading);
  };
  protoOf(LoadedModelInfoComponent).copy = function (hasFinishedLoading, hasFailedLoading, $super) {
    hasFinishedLoading = hasFinishedLoading === VOID ? this.hasFinishedLoading : hasFinishedLoading;
    hasFailedLoading = hasFailedLoading === VOID ? this.hasFailedLoading : hasFailedLoading;
    return this.s2h(hasFinishedLoading, hasFailedLoading);
  };
  protoOf(LoadedModelInfoComponent).toString = function () {
    return 'LoadedModelInfoComponent(hasFinishedLoading=' + this.hasFinishedLoading + ', hasFailedLoading=' + this.hasFailedLoading + ')';
  };
  protoOf(LoadedModelInfoComponent).hashCode = function () {
    var result = getBooleanHashCode(this.hasFinishedLoading);
    result = imul(result, 31) + getBooleanHashCode(this.hasFailedLoading) | 0;
    return result;
  };
  protoOf(LoadedModelInfoComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadedModelInfoComponent))
      return false;
    var tmp0_other_with_cast = other instanceof LoadedModelInfoComponent ? other : THROW_CCE();
    if (!(this.hasFinishedLoading === tmp0_other_with_cast.hasFinishedLoading))
      return false;
    if (!(this.hasFailedLoading === tmp0_other_with_cast.hasFailedLoading))
      return false;
    return true;
  };
  function Companion_65() {
    this.id = 13;
  }
  protoOf(Companion_65).s1k = function () {
    return this.id;
  };
  var Companion_instance_65;
  function Companion_getInstance_66() {
    return Companion_instance_65;
  }
  function ModelInfoComponent(modelRootUrl, model, texture) {
    this.modelRootUrl = modelRootUrl;
    this.model = model;
    this.texture = texture;
    this.modelUrl = UrlHelper_instance.joinUrls(this.modelRootUrl, this.model);
  }
  protoOf(ModelInfoComponent).t2h = function () {
    return this.modelRootUrl;
  };
  protoOf(ModelInfoComponent).u2h = function () {
    return this.model;
  };
  protoOf(ModelInfoComponent).v2h = function () {
    return this.texture;
  };
  protoOf(ModelInfoComponent).x1k = function () {
    return 13;
  };
  protoOf(ModelInfoComponent).w2h = function () {
    return this.modelUrl;
  };
  protoOf(ModelInfoComponent).sameModel = function (other) {
    return (this.model == other.model ? this.modelRootUrl == other.modelRootUrl : false) ? this.texture == other.texture : false;
  };
  protoOf(ModelInfoComponent).eq = function (other) {
    return this.sameModel(other instanceof ModelInfoComponent ? other : THROW_CCE());
  };
  protoOf(ModelInfoComponent).af = function () {
    return this.modelRootUrl;
  };
  protoOf(ModelInfoComponent).bf = function () {
    return this.model;
  };
  protoOf(ModelInfoComponent).g1k = function () {
    return this.texture;
  };
  protoOf(ModelInfoComponent).x2h = function (modelRootUrl, model, texture) {
    return new ModelInfoComponent(modelRootUrl, model, texture);
  };
  protoOf(ModelInfoComponent).copy = function (modelRootUrl, model, texture, $super) {
    modelRootUrl = modelRootUrl === VOID ? this.modelRootUrl : modelRootUrl;
    model = model === VOID ? this.model : model;
    texture = texture === VOID ? this.texture : texture;
    return this.x2h(modelRootUrl, model, texture);
  };
  protoOf(ModelInfoComponent).toString = function () {
    return 'ModelInfoComponent(modelRootUrl=' + this.modelRootUrl + ', model=' + this.model + ', texture=' + this.texture + ')';
  };
  protoOf(ModelInfoComponent).hashCode = function () {
    var result = this.modelRootUrl == null ? 0 : getStringHashCode(this.modelRootUrl);
    result = imul(result, 31) + (this.model == null ? 0 : getStringHashCode(this.model)) | 0;
    result = imul(result, 31) + (this.texture == null ? 0 : getStringHashCode(this.texture)) | 0;
    return result;
  };
  protoOf(ModelInfoComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModelInfoComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ModelInfoComponent ? other : THROW_CCE();
    if (!(this.modelRootUrl == tmp0_other_with_cast.modelRootUrl))
      return false;
    if (!(this.model == tmp0_other_with_cast.model))
      return false;
    if (!(this.texture == tmp0_other_with_cast.texture))
      return false;
    return true;
  };
  function Companion_66() {
    Companion_instance_66 = this;
    this.ID = 'ModelLoaderSystem';
    this.y2h_1 = LoggerState_getInstance().m1m('ModelLoaderSystem');
  }
  protoOf(Companion_66).u1n = function () {
    return this.ID;
  };
  var Companion_instance_66;
  function Companion_getInstance_67() {
    if (Companion_instance_66 == null)
      new Companion_66();
    return Companion_instance_66;
  }
  function refreshModelsOnScene($this) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.h2i_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.refreshModelsOnScene.<anonymous>' call
      if (element.__getComponentForKotlin(13) == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.refreshModelsOnScene.<anonymous>.<anonymous>' call
        onModelInfoChanged($this, element);
      }
    }
  }
  function onModelInfoChanged($this, entity) {
    if (get_isInScene(entity)) {
      var oldViewerObject = entity.__getComponentForKotlin(Companion_instance_73.id);
      if (oldViewerObject == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        ModelUtils_getInstance().unloadModel(oldViewerObject.viewerObject, $this.i2i_1);
      }
      loadModel_0($this, entity);
    }
  }
  function loadModel_0($this, entity) {
    ModelUtils_getInstance().loadModelFromModelInfo(entity, $this.i2i_1);
  }
  function ModelLoaderSystem(entityManager, viewer) {
    Companion_getInstance_67();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [20];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['ViewerObjectVisibilitySystem', 'ViewerObjectTransformSystem'];
    SystemBase4.call(this, 'ModelLoaderSystem', 13, 5, 20, 123, tmp, null, tmp$ret$5);
    this.h2i_1 = entityManager;
    this.i2i_1 = viewer;
  }
  protoOf(ModelLoaderSystem).enable = function () {
    protoOf(SystemBase4).enable.call(this);
    refreshModelsOnScene(this);
  };
  protoOf(ModelLoaderSystem).onRegister = function () {
    protoOf(SystemBase4).onRegister.call(this);
    refreshModelsOnScene(this);
  };
  protoOf(ModelLoaderSystem).onAddComponent = function (entity, newComponent) {
    onModelInfoChanged(this, entity);
  };
  protoOf(ModelLoaderSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (!oldComponent.sameModel(newComponent) ? true : get_viewerObject(entity) == null) {
      onModelInfoChanged(this, entity);
    }
  };
  protoOf(ModelLoaderSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(ModelLoaderSystem).onAddComponent2 = function (entity, newComponent) {
    if (!entity.hasComponent(20)) {
      loadModel_0(this, entity);
    }
  };
  protoOf(ModelLoaderSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ModelLoaderSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(ModelLoaderSystem).onAddComponent3 = function (entity, newComponent) {
  };
  protoOf(ModelLoaderSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ModelLoaderSystem).onRemoveComponent3 = function (entity, oldComponent) {
    var viewerObject = get_viewerObject(entity);
    if (viewerObject == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      ModelUtils_getInstance().unloadModel(viewerObject, this.i2i_1);
    }
    entity.removeComponent(Companion_instance_73.id);
  };
  protoOf(ModelLoaderSystem).onAddComponent4 = function (entity, newComponent) {
    var tmp;
    var tmp0_safe_receiver = newComponent.entity;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = tmp0_safe_receiver.hasComponent(13);
    }
    var tmp1_elvis_lhs = tmp_0;
    if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
      tmp = get_isInScene(entity);
    } else {
      tmp = false;
    }
    var shouldHaveComponent = tmp;
    var tmp2_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      tmp_1 = tmp2_safe_receiver.hasComponent(20);
    }
    var didHaveComponent = tmp_1 === true;
    var modelWasRemoved = didHaveComponent ? !shouldHaveComponent : false;
    var modelWasAdded = !didHaveComponent ? shouldHaveComponent : false;
    var modelKept = didHaveComponent ? shouldHaveComponent : false;
    if (modelWasRemoved) {
      var tmp3_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getComponent(Companion_instance_73.id);
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.onAddComponent4.<anonymous>' call
        ModelUtils_getInstance().unloadModel(tmp4_safe_receiver.viewerObject, this.i2i_1);
        entity.removeComponent(20);
      }
    } else if (modelWasAdded) {
      loadModel_0(this, entity);
    } else if (modelKept) {
      var tmp5_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
      var tmp_2;
      if (tmp5_safe_receiver == null) {
        tmp_2 = null;
      } else {
        tmp_2 = tmp5_safe_receiver.getComponent(20);
      }
      var tmp6_safe_receiver = tmp_2;
      if (tmp6_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.onAddComponent4.<anonymous>' call
        entity.addComponentInternal(tmp6_safe_receiver);
      }
      var tmp7_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.getComponent(Companion_instance_73.id);
      if (tmp8_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.onAddComponent4.<anonymous>' call
        entity.addComponentInternal(tmp8_safe_receiver);
      }
    }
  };
  protoOf(ModelLoaderSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ModelLoaderSystem).onRemoveComponent4 = function (entity, oldComponent) {
  };
  function Companion_67() {
  }
  protoOf(Companion_67).s1k = function () {
    return 124;
  };
  var Companion_instance_67;
  function Companion_getInstance_68() {
    return Companion_instance_67;
  }
  function ModelTransformComponent(transform) {
    this.transform = transform;
  }
  protoOf(ModelTransformComponent).d1x = function () {
    return this.transform;
  };
  protoOf(ModelTransformComponent).x1k = function () {
    return Companion_instance_67.id;
  };
  protoOf(ModelTransformComponent).eq = function (other) {
    var tmp0_elvis_lhs = other instanceof ModelTransformComponent ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var that = tmp;
    return that.transform.equals(this.transform);
  };
  function ModelUtils$loadModelFromModelInfo$lambda$lambda() {
    return 'Loading of model was completed after the entity was disposed or the viewer object was deleted.';
  }
  function ModelUtils$loadModelFromModelInfo$lambda($entity, $viewer) {
    return function (viewerObject) {
      var tmp;
      if (!$entity.isDisposed ? $viewer.existsModel(viewerObject.getViewerObjectId()) : false) {
        var modelComponent = $entity.__getComponentForKotlin(20);
        if (modelComponent == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.rendering.ModelUtils.loadModelFromModelInfo.<anonymous>.<anonymous>' call
          $entity.addComponent(modelComponent.withFinishedLoading());
        }
        tmp = Unit_instance;
      } else {
        var tmp_0 = ModelUtils_getInstance().m2i_1;
        tmp_0.info(ModelUtils$loadModelFromModelInfo$lambda$lambda);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelUtils$loadModelFromModelInfo$o$lambda($entity) {
    return function () {
      return 'Failed to load model for ' + $entity + '. Listen to LoadedModelInfoComponent and check the hasFailedLoading property to handle this.';
    };
  }
  function ModelUtils$loadModelFromModelInfo$o($entity) {
    return function (_anonymous_parameter_0__qggqh8) {
      var tmp;
      if ($entity.isDisposed) {
        return Unit_instance;
      }
      var tmp_0 = ModelUtils_getInstance().m2i_1;
      tmp_0.warn(ModelUtils$loadModelFromModelInfo$o$lambda($entity));
      $entity.removeComponent(Companion_instance_73.id);
      var modelComponent = $entity.__getComponentForKotlin(20);
      if (modelComponent == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.rendering.ModelUtils.loadModelFromModelInfo.<no name provided>.<anonymous>' call
        $entity.addComponent(modelComponent.withFailedLoading());
      }
      return Unit_instance;
    };
  }
  function ModelUtils$unloadModel$lambda($viewerObject) {
    return function () {
      return 'not removing model that does not exist ' + toString($viewerObject.getViewerObjectId());
    };
  }
  function ModelUtils$hide$lambda(it) {
    it.removeComponent(RenderedComponent_instance.id);
    return Unit_instance;
  }
  function ModelUtils$show$lambda(it) {
    it.addComponent(RenderedComponent_instance);
    return Unit_instance;
  }
  function ModelUtils() {
    ModelUtils_instance = this;
    this.m2i_1 = LoggerState_getInstance().m1m('ModelUtils');
  }
  protoOf(ModelUtils).loadModelFromModelInfo = function (entity, viewer) {
    var tmp0_elvis_lhs = entity.__getComponentForKotlin(13);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var modelInfo = tmp;
    var tmp1_safe_receiver = entity.__getComponentForKotlin(Companion_instance_67.id);
    var modelTransform = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.transform;
    var onModelLoaded = ModelUtils$loadModelFromModelInfo$lambda(entity, viewer);
    var onModelLoadFailed = ModelUtils$loadModelFromModelInfo$o(entity);
    var loadingBox = this.getLoadingBox(entity, modelTransform);
    var tmp2_elvis_lhs = modelInfo.modelUrl;
    var tmp_0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = modelInfo.texture;
    var viewerObject = viewer.loadModel(entity, tmp_0, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs, onModelLoaded, onModelLoadFailed, loadingBox.size.equals(Companion_getInstance_61().ZERO) ? null : loadingBox.size, loadingBox.size.equals(Companion_getInstance_61().ZERO) ? null : loadingBox.center);
    viewerObject.setCastShadows(true);
    if (get_isPropping(entity)) {
      viewerObject.setOutlined(false);
      viewerObject.setBlockOutlined(false);
    }
    if (modelTransform == null) {
      entity.addComponent(new LoadedModelInfoComponent(false));
      entity.addComponent(new ViewerObjectComponent(viewerObject));
    } else {
      entity.addComponent(new LoadedModelInfoComponent(false));
      var transformNode = this.adjustModelTransform(entity, viewer, viewerObject, modelTransform);
      entity.addComponent(new ViewerObjectComponent(transformNode));
    }
  };
  protoOf(ModelUtils).getLoadingBox = function (entity, modelTransform) {
    var tmp;
    if (get_isPropping(entity)) {
      tmp = Companion_getInstance_93().EMPTY_AABB;
    } else {
      var tmp0_safe_receiver = get_colliderShapeComponent(entity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
      tmp = tmp2_elvis_lhs == null ? Companion_getInstance_93().EMPTY_AABB : tmp2_elvis_lhs;
    }
    var aabb = tmp;
    if (modelTransform == null)
      return aabb;
    return modelTransform.applyInverse(aabb);
  };
  protoOf(ModelUtils).unloadModel = function (viewerObject, viewer) {
    if (viewer.existsModel(viewerObject.getViewerObjectId())) {
      viewerObject.deleteObject();
    } else {
      this.m2i_1.warn(ModelUtils$unloadModel$lambda(viewerObject));
    }
  };
  protoOf(ModelUtils).adjustModelTransform = function (entity, viewer, viewerObject, modelTransform) {
    // Inline function 'kotlin.also' call
    var this_0 = viewer.createEmpty(entity);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.rendering.ModelUtils.adjustModelTransform.<anonymous>' call
    modelTransform.applyTo(viewerObject);
    viewerObject.setParent(this_0);
    return this_0;
  };
  protoOf(ModelUtils).hide = function (entity, traverseHierarchy) {
    if (traverseHierarchy) {
      var tmp = HierarchyUtils_instance;
      tmp.forEachInHierarchy(entity, ModelUtils$hide$lambda);
    } else {
      entity.removeComponent(RenderedComponent_instance.id);
    }
  };
  protoOf(ModelUtils).show = function (entity, traverseHierarchy) {
    if (traverseHierarchy) {
      var tmp = HierarchyUtils_instance;
      tmp.forEachInHierarchy(entity, ModelUtils$show$lambda);
    } else {
      entity.addComponent(RenderedComponent_instance);
    }
  };
  var ModelUtils_instance;
  function ModelUtils_getInstance() {
    if (ModelUtils_instance == null)
      new ModelUtils();
    return ModelUtils_instance;
  }
  function Companion_68() {
    this.id = 57;
  }
  protoOf(Companion_68).s1k = function () {
    return this.id;
  };
  var Companion_instance_68;
  function Companion_getInstance_69() {
    return Companion_instance_68;
  }
  function OutlineableComponent() {
  }
  protoOf(OutlineableComponent).x1k = function () {
    return 57;
  };
  protoOf(OutlineableComponent).eq = function (other) {
    return true;
  };
  function get_hasPausedViewerUpdates(_this__u8e3s4) {
    var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(90)) === true;
  }
  function Companion_69() {
    this.n2i_1 = 90;
  }
  var Companion_instance_69;
  function Companion_getInstance_70() {
    return Companion_instance_69;
  }
  function PauseViewerUpdatesComponent() {
  }
  protoOf(PauseViewerUpdatesComponent).x1k = function () {
    return 90;
  };
  protoOf(PauseViewerUpdatesComponent).eq = function (other) {
    return true;
  };
  function resumeViewerUpdatesOnDraggedEntity(sceneManager) {
    var tmp = sceneManager.scene;
    var tmp0_safe_receiver = tmp.__getComponentForKotlin(66);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.entity;
    if (tmp1_safe_receiver == null)
      null;
    else {
      resumeViewerUpdates(tmp1_safe_receiver);
    }
  }
  function pauseViewerUpdatesOnDraggedEntity(sceneManager) {
    var tmp = sceneManager.scene;
    var tmp0_safe_receiver = tmp.__getComponentForKotlin(66);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.entity;
    if (tmp1_safe_receiver == null)
      null;
    else {
      pauseViewerUpdates(tmp1_safe_receiver);
    }
  }
  function resumeViewerUpdates(_this__u8e3s4) {
    var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.removeComponent(90);
  }
  function pauseViewerUpdates(_this__u8e3s4) {
    var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.addComponent(new PauseViewerUpdatesComponent());
  }
  function Companion_70() {
    this.ID = 'RenderSystem';
  }
  protoOf(Companion_70).u1n = function () {
    return this.ID;
  };
  var Companion_instance_70;
  function Companion_getInstance_71() {
    return Companion_instance_70;
  }
  function RenderSystem() {
    SystemBase.call(this, 'RenderSystem', 5);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w2i_1 = [9];
  }
  protoOf(RenderSystem).w1o = function () {
    return this.w2i_1;
  };
  protoOf(RenderSystem).onAddComponent = function (entity, newComponent) {
    if (!entity.hasComponent(RenderedComponent_instance.id)) {
      entity.addComponent(RenderedComponent_instance);
      var tmp0_safe_receiver = get_parentComponent(entity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.rendering.RenderSystem.onAddComponent.<anonymous>' call
          this.onAddComponent(element, newComponent);
        }
      }
    }
  };
  protoOf(RenderSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(RenderSystem).onRemoveComponent = function (entity, oldComponent) {
    entity.removeComponent(RenderedComponent_instance.id);
    var tmp0_safe_receiver = get_parentComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.rendering.RenderSystem.onRemoveComponent.<anonymous>' call
        this.onRemoveComponent(element, oldComponent);
      }
    }
  };
  function RenderedComponent() {
  }
  protoOf(RenderedComponent).x1k = function () {
    return this.id;
  };
  protoOf(RenderedComponent).s1k = function () {
    return 9;
  };
  protoOf(RenderedComponent).eq = function (other) {
    return true;
  };
  var RenderedComponent_instance;
  function RenderedComponent_getInstance() {
    return RenderedComponent_instance;
  }
  function Viewer() {
  }
  function Companion_71() {
    this.ID = 82;
  }
  protoOf(Companion_71).u1n = function () {
    return this.ID;
  };
  var Companion_instance_71;
  function Companion_getInstance_72() {
    return Companion_instance_71;
  }
  function ViewerComponent(viewer) {
    this.viewer = viewer;
    this.k2j_1 = 82;
  }
  protoOf(ViewerComponent).l2j = function () {
    return this.viewer;
  };
  protoOf(ViewerComponent).x1k = function () {
    return this.k2j_1;
  };
  protoOf(ViewerComponent).eq = function (other) {
    var tmp;
    if (other instanceof ViewerComponent) {
      tmp = equals(this.viewer, other.viewer);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Companion_72() {
    this.id = 93;
  }
  protoOf(Companion_72).s1k = function () {
    return this.id;
  };
  var Companion_instance_72;
  function Companion_getInstance_73() {
    return Companion_instance_72;
  }
  function ViewerLineIdsComponent(lineIds) {
    this.lineIds = lineIds;
    this.m2j_1 = false;
  }
  protoOf(ViewerLineIdsComponent).n2j = function () {
    return this.lineIds;
  };
  protoOf(ViewerLineIdsComponent).x1k = function () {
    return 93;
  };
  protoOf(ViewerLineIdsComponent).eq = function (other) {
    return contentDeepEquals(this.lineIds, (other instanceof ViewerLineIdsComponent ? other : THROW_CCE()).lineIds);
  };
  protoOf(ViewerLineIdsComponent).a1l = function () {
    return this.m2j_1;
  };
  function ViewerObject() {
  }
  function Companion_73() {
  }
  protoOf(Companion_73).s1k = function () {
    return 35;
  };
  var Companion_instance_73;
  function Companion_getInstance_74() {
    return Companion_instance_73;
  }
  function ViewerObjectComponent(viewerObject) {
    this.viewerObject = viewerObject;
    this.j2i_1 = false;
  }
  protoOf(ViewerObjectComponent).p2j = function () {
    return this.viewerObject;
  };
  protoOf(ViewerObjectComponent).x1k = function () {
    return Companion_instance_73.id;
  };
  protoOf(ViewerObjectComponent).eq = function (other) {
    return equals((other instanceof ViewerObjectComponent ? other : THROW_CCE()).viewerObject, this.viewerObject);
  };
  protoOf(ViewerObjectComponent).a1l = function () {
    return this.j2i_1;
  };
  protoOf(ViewerObjectComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ViewerObjectComponent))
      THROW_CCE();
    return equals(this.viewerObject.getViewerObjectId(), other.viewerObject.getViewerObjectId());
  };
  protoOf(ViewerObjectComponent).hashCode = function () {
    return hashCode(this.viewerObject.getViewerObjectId());
  };
  protoOf(ViewerObjectComponent).af = function () {
    return this.viewerObject;
  };
  protoOf(ViewerObjectComponent).q2j = function (viewerObject) {
    return new ViewerObjectComponent(viewerObject);
  };
  protoOf(ViewerObjectComponent).copy = function (viewerObject, $super) {
    viewerObject = viewerObject === VOID ? this.viewerObject : viewerObject;
    return this.q2j(viewerObject);
  };
  protoOf(ViewerObjectComponent).toString = function () {
    return 'ViewerObjectComponent(viewerObject=' + this.viewerObject + ')';
  };
  function get_viewerObject(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_instance_73.id);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.viewerObject;
  }
  function updateViewerObjectTransform($this, entity) {
    var tmp0_elvis_lhs = get_viewerObject(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var viewerObject = tmp;
    updateViewerObjectTransform_0($this, viewerObject, entity);
  }
  function updateViewerObjectTransform_0($this, viewerObject, entity) {
    viewerObject.setPosition(get_worldPosition(entity));
    viewerObject.setRotation(get_worldRotation(entity));
  }
  function ViewerObjectTransformSystem() {
    var tmp = Companion_instance_73.id;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    SystemBase4.call(this, 'ViewerObjectTransformSystem', 10, tmp, 45, 123, tmp$ret$0, null, null);
  }
  protoOf(ViewerObjectTransformSystem).onAddComponent = function (entity, newComponent) {
    if (get_hasPausedViewerUpdates(entity))
      return Unit_instance;
    updateViewerObjectTransform(this, entity);
  };
  protoOf(ViewerObjectTransformSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (get_hasPausedViewerUpdates(entity))
      return Unit_instance;
    updateViewerObjectTransform(this, entity);
  };
  protoOf(ViewerObjectTransformSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(ViewerObjectTransformSystem).onAddComponent2 = function (entity, newComponent) {
    var viewerObject = newComponent.viewerObject;
    updateViewerObjectTransform_0(this, viewerObject, entity);
  };
  protoOf(ViewerObjectTransformSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    var viewerObject = newComponent.viewerObject;
    updateViewerObjectTransform_0(this, viewerObject, entity);
  };
  protoOf(ViewerObjectTransformSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(ViewerObjectTransformSystem).onAddComponent3 = function (entity, newComponent) {
  };
  protoOf(ViewerObjectTransformSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ViewerObjectTransformSystem).onRemoveComponent3 = function (entity, oldComponent) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_snapRootSubTree(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.rendering.ViewerObjectTransformSystem.onRemoveComponent3.<anonymous>' call
      updateViewerObjectTransform(this, element);
    }
  };
  protoOf(ViewerObjectTransformSystem).onAddComponent4 = function (entity, newComponent) {
    var tmp0_elvis_lhs = newComponent.entity;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newEntity = tmp;
    updateViewerObjectTransform(this, newEntity);
  };
  protoOf(ViewerObjectTransformSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ViewerObjectTransformSystem).onRemoveComponent4 = function (entity, oldComponent) {
  };
  function setVisibilityOfObject($this, entity, viewerObjectComponent) {
    if (entity.hasComponent(9)) {
      viewerObjectComponent.viewerObject.setVisible(true);
    } else {
      viewerObjectComponent.viewerObject.setVisible(false);
    }
  }
  function ViewerObjectVisibilitySystem() {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['RenderSystem'];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$4 = [];
    SystemBase3.call(this, 'ViewerObjectVisibilitySystem', 9, 35, 123, tmp, tmp_0, tmp$ret$4);
  }
  protoOf(ViewerObjectVisibilitySystem).onAddComponent = function (entity, newComponent) {
    var tmp0_safe_receiver = get_viewerObject(entity);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.setVisible(true);
  };
  protoOf(ViewerObjectVisibilitySystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(ViewerObjectVisibilitySystem).onRemoveComponent = function (entity, oldComponent) {
    var tmp0_safe_receiver = get_viewerObject(entity);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.setVisible(false);
  };
  protoOf(ViewerObjectVisibilitySystem).onAddComponent2 = function (entity, newComponent) {
    setVisibilityOfObject(this, entity, newComponent);
  };
  protoOf(ViewerObjectVisibilitySystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    setVisibilityOfObject(this, entity, newComponent);
  };
  protoOf(ViewerObjectVisibilitySystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(ViewerObjectVisibilitySystem).onAddComponent3 = function (entity, newComponent) {
    var tmp0_elvis_lhs = newComponent.entity;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newEntity = tmp;
    var tmp1_safe_receiver = newEntity.__getComponentForKotlin(Companion_instance_73.id);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      setVisibilityOfObject(this, newEntity, tmp1_safe_receiver);
    }
  };
  protoOf(ViewerObjectVisibilitySystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ViewerObjectVisibilitySystem).onRemoveComponent3 = function (entity, oldComponent) {
  };
  function registerAll($this, newViewer) {
    var modelLoaderSystem = new ModelLoaderSystem($this.z2j_1, newViewer);
    $this.z2j_1.registerSystem(modelLoaderSystem);
    $this.b2k_1 = modelLoaderSystem;
  }
  function unregisterAll($this) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.z2j_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.rendering.ViewerPresenceSystem.unregisterAll.<anonymous>' call
      $this.z2j_1.removeComponent(element, 20);
    }
    var tmp0_safe_receiver = $this.b2k_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.disable();
    }
    var tmp1_safe_receiver = $this.b2k_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.unregister($this.z2j_1);
    }
  }
  function ViewerPresenceSystem(entityManager) {
    SystemBase.call(this, 'ViewerPresenceSystem', 82);
    this.z2j_1 = entityManager;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.a2k_1 = [];
    this.b2k_1 = null;
  }
  protoOf(ViewerPresenceSystem).w1o = function () {
    return this.a2k_1;
  };
  protoOf(ViewerPresenceSystem).onAddComponent = function (entity, newComponent) {
    registerAll(this, newComponent.viewer);
  };
  protoOf(ViewerPresenceSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    unregisterAll(this);
    registerAll(this, newComponent.viewer);
  };
  protoOf(ViewerPresenceSystem).onRemoveComponent = function (entity, oldComponent) {
    unregisterAll(this);
  };
  function ViewerMock$triggerModelLoaded$lambda() {
    return Unit_instance;
  }
  function ViewerMock$triggerModelLoadFailed$lambda() {
    return Unit_instance;
  }
  function ViewerMock$loadModel$lambda(this$0, $url) {
    return function () {
      var oldVal = this$0.loadedModelCount.b3($url);
      var tmp;
      if (!(oldVal == null)) {
        var tmp_0;
        if (oldVal === 1) {
          this$0.loadedModelCount.v2($url);
          tmp_0 = Unit_instance;
        } else {
          var this_0 = this$0.loadedModelCount;
          var key = $url;
          var value = oldVal - 1 | 0;
          this_0.r2(key, value);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function ViewerMock$loadModel$lambda_0($modelLoaded, $viewerObjectMock) {
    return function () {
      var tmp0_safe_receiver = $modelLoaded;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($viewerObjectMock);
      return Unit_instance;
    };
  }
  function ViewerMock$loadModel$lambda_1($modelLoadFailed, $viewerObjectMock) {
    return function () {
      var tmp0_safe_receiver = $modelLoadFailed;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($viewerObjectMock);
      return Unit_instance;
    };
  }
  function ViewerMock() {
    var tmp = this;
    tmp.triggerModelLoaded = ViewerMock$triggerModelLoaded$lambda;
    var tmp_0 = this;
    tmp_0.triggerModelLoadFailed = ViewerMock$triggerModelLoadFailed$lambda;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.loadedModelCount = LinkedHashMap_init_$Create$_0();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.allViewerObjects = ArrayList_init_$Create$();
  }
  protoOf(ViewerMock).c2k = function (_set____db54di) {
    this.triggerModelLoaded = _set____db54di;
  };
  protoOf(ViewerMock).d2k = function () {
    return this.triggerModelLoaded;
  };
  protoOf(ViewerMock).e2k = function (_set____db54di) {
    this.triggerModelLoadFailed = _set____db54di;
  };
  protoOf(ViewerMock).f2k = function () {
    return this.triggerModelLoadFailed;
  };
  protoOf(ViewerMock).g2k = function () {
    return this.loadedModelCount;
  };
  protoOf(ViewerMock).h2k = function () {
    return this.allViewerObjects;
  };
  protoOf(ViewerMock).g2j = function (entity, url, textureFile, modelLoaded, modelLoadFailed, loadingBoxSize, loadingBoxCenter) {
    var viewerObjectMock = new ViewerObjectMock(this, ViewerMock$loadModel$lambda(this, url));
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.loadedModelCount.b3(url);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'com.ikea.core.rendering.mock.ViewerMock.loadModel.<anonymous>' call
      tmp = 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldVal = tmp;
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.loadedModelCount;
    var value = oldVal + 1 | 0;
    this_0.r2(url, value);
    var tmp_0 = this;
    tmp_0.triggerModelLoaded = ViewerMock$loadModel$lambda_0(modelLoaded, viewerObjectMock);
    var tmp_1 = this;
    tmp_1.triggerModelLoadFailed = ViewerMock$loadModel$lambda_1(modelLoadFailed, viewerObjectMock);
    return viewerObjectMock;
  };
  protoOf(ViewerMock).existsModel = function (objId) {
    return true;
  };
  protoOf(ViewerMock).i2j = function (entity) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).x2i = function (radius, entity) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).y2i = function (vo, entity) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).z2i = function (width, height, depth, entity) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).b2j = function (vertices, normal, entity) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).a2j = function (width, depth, entity) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).c2j = function (meshes, entity) {
    var parent = new ViewerObjectMock(this);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = meshes.length;
    while (inductionVariable < last) {
      var element = meshes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.rendering.mock.ViewerMock.groupMeshes.<anonymous>' call
      element.setParent(parent);
    }
    return parent;
  };
  protoOf(ViewerMock).createOpenBox = function (size, margin) {
    return new ViewerObjectMock(this);
  };
  protoOf(ViewerMock).resize = function () {
  };
  protoOf(ViewerMock).h2j = function (enable) {
  };
  protoOf(ViewerMock).i2k = function (modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize) {
    get_nothing();
  };
  protoOf(ViewerMock).j2j = function (modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize) {
    return this.i2k(modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize);
  };
  protoOf(ViewerMock).raycast = function (x, y) {
    get_nothing();
  };
  protoOf(ViewerMock).worldCoordToCanvas = function (x, y, z) {
    get_nothing();
  };
  protoOf(ViewerMock).d2j = function (start, end, color, thickness) {
    get_nothing();
  };
  protoOf(ViewerMock).e2j = function (start, end, color, thickness) {
    get_nothing();
  };
  protoOf(ViewerMock).j2k = function (id, start, end, color, thickness) {
    get_nothing();
  };
  protoOf(ViewerMock).f2j = function (id, start, end, color, thickness) {
    return this.j2k(id, start, end, color, thickness);
  };
  protoOf(ViewerMock).removeUiLine = function (id) {
    get_nothing();
  };
  protoOf(ViewerMock).uiLineExists = function (id) {
    get_nothing();
  };
  function Companion_74() {
    Companion_instance_74 = this;
    this.DEFAULT_CAMERA_POSITION = __VectorIntConstructorKotlin(0, 1000, 10000);
    this.DEFAULT_CAMERA_PLANE_NORMAL = __VectorIntConstructorKotlin(0, 0, 1);
  }
  protoOf(Companion_74).k2k = function () {
    return this.DEFAULT_CAMERA_POSITION;
  };
  protoOf(Companion_74).l2k = function () {
    return this.DEFAULT_CAMERA_PLANE_NORMAL;
  };
  var Companion_instance_74;
  function Companion_getInstance_75() {
    if (Companion_instance_74 == null)
      new Companion_74();
    return Companion_instance_74;
  }
  function MockDragGenerator(draggingPlane) {
    Companion_getInstance_75();
    this.draggingPlane = draggingPlane;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.onDragStartObservables = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.onDragObservables = ArrayList_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.onDragEndObservables = ArrayList_init_$Create$();
  }
  protoOf(MockDragGenerator).m2k = function () {
    return this.draggingPlane;
  };
  protoOf(MockDragGenerator).n2k = function () {
    return this.onDragStartObservables;
  };
  protoOf(MockDragGenerator).o2k = function () {
    return this.onDragObservables;
  };
  protoOf(MockDragGenerator).p2k = function () {
    return this.onDragEndObservables;
  };
  protoOf(MockDragGenerator).onDragStartObservable = function (a) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.onDragStartObservables.q(a);
  };
  protoOf(MockDragGenerator).onDragObservable = function (a) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.onDragObservables.q(a);
  };
  protoOf(MockDragGenerator).onDragEndObservable = function (a) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.onDragEndObservables.q(a);
  };
  protoOf(MockDragGenerator).drag = function (from, to) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.onDragStartObservables.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.rendering.mock.MockDragGenerator.drag.<anonymous>' call
      element(new ViewerDragEventComponent(from, this.draggingPlane, get_zero(), Companion_getInstance_75().DEFAULT_CAMERA_POSITION));
    }
    var distance = to.minus(from);
    var count = 3;
    var step = distance.size / count;
    var inductionVariable = 0;
    if (inductionVariable <= count)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var delta = distance.normalize().times(step).times(i);
        var point = from.plus(delta);
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = this.onDragObservables.t();
        while (tmp0_iterator_0.u()) {
          var element_0 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.rendering.mock.MockDragGenerator.drag.<anonymous>' call
          element_0(new ViewerDragEventComponent(point, this.draggingPlane, delta, Companion_getInstance_75().DEFAULT_CAMERA_POSITION));
        }
      }
       while (!(i === count));
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = this.onDragEndObservables.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.rendering.mock.MockDragGenerator.drag.<anonymous>' call
      element_1(new ViewerDragEventComponent(to, this.draggingPlane, get_zero(), Companion_getInstance_75().DEFAULT_CAMERA_POSITION));
    }
  };
  function throwErrorIfDeleted($this) {
    if ($this.isDeleted) {
      // Inline function 'kotlin.error' call
      var message = 'Error: No entry with id: ' + $this.r2k_1 + '. Trying to access deleted viewer object';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function Companion_75() {
    this.nextId = 0;
  }
  protoOf(Companion_75).y2k = function (_set____db54di) {
    this.nextId = _set____db54di;
  };
  protoOf(Companion_75).z2k = function () {
    return this.nextId;
  };
  var Companion_instance_75;
  function Companion_getInstance_76() {
    return Companion_instance_75;
  }
  function ViewerObjectMock(viewerMock, unloadCallback) {
    viewerMock = viewerMock === VOID ? null : viewerMock;
    unloadCallback = unloadCallback === VOID ? null : unloadCallback;
    this.viewerMock = viewerMock;
    this.unloadCallback = unloadCallback;
    this.q2k_1 = false;
    this.r2k_1 = Companion_instance_75.nextId;
    this.isDeleted = false;
    this.enabledOutlined = false;
    this.enabledBlockOutlined = false;
    this.setCastShadowCalls = 0;
    this.s2k_1 = false;
    this.t2k_1 = new Vector(0.0, 0.0, -1.0);
    this.mockDragGenerator = new MockDragGenerator(this.t2k_1);
    this.u2k_1 = Companion_getInstance_61().ZERO;
    this.v2k_1 = Companion_getInstance_57().IDENTITY;
    this.w2k_1 = Companion_getInstance_61().ONE;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.x2k_1 = ArrayList_init_$Create$();
    Companion_instance_75.nextId = Companion_instance_75.nextId + 1 | 0;
    var tmp1_safe_receiver = this.viewerMock;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.allViewerObjects;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.q(this);
  }
  protoOf(ViewerObjectMock).a2l = function () {
    return this.viewerMock;
  };
  protoOf(ViewerObjectMock).b2l = function () {
    return this.unloadCallback;
  };
  protoOf(ViewerObjectMock).c2l = function (_set____db54di) {
    this.isDeleted = _set____db54di;
  };
  protoOf(ViewerObjectMock).d2l = function () {
    return this.isDeleted;
  };
  protoOf(ViewerObjectMock).e2l = function (_set____db54di) {
    this.enabledOutlined = _set____db54di;
  };
  protoOf(ViewerObjectMock).f2l = function () {
    return this.enabledOutlined;
  };
  protoOf(ViewerObjectMock).g2l = function (_set____db54di) {
    this.enabledBlockOutlined = _set____db54di;
  };
  protoOf(ViewerObjectMock).h2l = function () {
    return this.enabledBlockOutlined;
  };
  protoOf(ViewerObjectMock).i2l = function (_set____db54di) {
    this.setCastShadowCalls = _set____db54di;
  };
  protoOf(ViewerObjectMock).j2l = function () {
    return this.setCastShadowCalls;
  };
  protoOf(ViewerObjectMock).k2l = function () {
    return this.s2k_1;
  };
  protoOf(ViewerObjectMock).l2l = function (_set____db54di) {
    this.mockDragGenerator = _set____db54di;
  };
  protoOf(ViewerObjectMock).m2l = function () {
    return this.mockDragGenerator;
  };
  protoOf(ViewerObjectMock).getEntity = function () {
    return null;
  };
  protoOf(ViewerObjectMock).getViewerObjectId = function () {
    return this.r2k_1;
  };
  protoOf(ViewerObjectMock).setVisible = function (visible) {
    throwErrorIfDeleted(this);
    this.s2k_1 = visible;
    return this;
  };
  protoOf(ViewerObjectMock).getVisible = function () {
    throwErrorIfDeleted(this);
    return this.s2k_1;
  };
  protoOf(ViewerObjectMock).setEnabled = function (enabled) {
    throwErrorIfDeleted(this);
  };
  protoOf(ViewerObjectMock).isEnabled = function () {
    throwErrorIfDeleted(this);
    return true;
  };
  protoOf(ViewerObjectMock).deleteObject = function () {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.x2k_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.rendering.mock.ViewerObjectMock.deleteObject.<anonymous>' call
      element.deleteObject();
    }
    var tmp0_safe_receiver = this.unloadCallback;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    this.isDeleted = true;
    var tmp1_safe_receiver = this.viewerMock;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.allViewerObjects;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.r(this);
  };
  protoOf(ViewerObjectMock).registerInputEvents = function () {
    throwErrorIfDeleted(this);
    this.q2k_1 = true;
  };
  protoOf(ViewerObjectMock).unregisterInputEvents = function () {
    throwErrorIfDeleted(this);
    this.q2k_1 = false;
  };
  protoOf(ViewerObjectMock).o2j = function () {
    return this.q2k_1;
  };
  protoOf(ViewerObjectMock).makeClickable = function (onClick) {
    throwErrorIfDeleted(this);
  };
  protoOf(ViewerObjectMock).setPositionPrimitive = function (x, y, z) {
    throwErrorIfDeleted(this);
    this.u2k_1 = new Vector(x, y, z);
    return this;
  };
  protoOf(ViewerObjectMock).getPosition = function () {
    throwErrorIfDeleted(this);
    return this.u2k_1;
  };
  protoOf(ViewerObjectMock).setRotation = function (q) {
    throwErrorIfDeleted(this);
    this.v2k_1 = q;
    return this;
  };
  protoOf(ViewerObjectMock).getRotation = function () {
    throwErrorIfDeleted(this);
    return this.v2k_1;
  };
  protoOf(ViewerObjectMock).setRotationEulerAngleDegrees = function (v) {
    throwErrorIfDeleted(this);
    this.v2k_1 = Companion_getInstance_57().fromEulerDegreesVector(v);
    return this;
  };
  protoOf(ViewerObjectMock).setRotationEulerAngleRadians = function (v) {
    throwErrorIfDeleted(this);
    this.v2k_1 = Companion_getInstance_57().fromEuler(new Radians(v.X), new Radians(v.Y), new Radians(v.Z));
    return this;
  };
  protoOf(ViewerObjectMock).setScaleV = function (v) {
    throwErrorIfDeleted(this);
    this.w2k_1 = v;
    return this;
  };
  protoOf(ViewerObjectMock).setScale = function (x, y, z) {
    throwErrorIfDeleted(this);
    return this.setScaleV(new Vector(x, y, z));
  };
  protoOf(ViewerObjectMock).getScale = function () {
    throwErrorIfDeleted(this);
    return this.w2k_1;
  };
  protoOf(ViewerObjectMock).setOutlined = function (outlined) {
    throwErrorIfDeleted(this);
    this.enabledOutlined = outlined;
    return this;
  };
  protoOf(ViewerObjectMock).setBlockOutlined = function (blockOutlined) {
    throwErrorIfDeleted(this);
    this.enabledBlockOutlined = blockOutlined;
    return this;
  };
  protoOf(ViewerObjectMock).setCastShadows = function (castShadows) {
    throwErrorIfDeleted(this);
    this.setCastShadowCalls = this.setCastShadowCalls + 1 | 0;
    return this;
  };
  protoOf(ViewerObjectMock).setReceiveShadows = function (receiveShadows) {
    throwErrorIfDeleted(this);
    return this;
  };
  protoOf(ViewerObjectMock).setBaseColor = function (r, g, b) {
    throwErrorIfDeleted(this);
    return this;
  };
  protoOf(ViewerObjectMock).setTransparency = function (alpha) {
    throwErrorIfDeleted(this);
    return this;
  };
  protoOf(ViewerObjectMock).setParent = function (parentMesh) {
    throwErrorIfDeleted(this);
    (parentMesh instanceof ViewerObjectMock ? parentMesh : THROW_CCE()).x2k_1.q(this);
    return this;
  };
  protoOf(ViewerObjectMock).setOutlinedObjectColor = function (r, g, b) {
    throwErrorIfDeleted(this);
    return this;
  };
  protoOf(ViewerObjectMock).removeOutlinedObjectColor = function () {
    throwErrorIfDeleted(this);
    return this;
  };
  function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda($oldEntity) {
    return function (it) {
      return hierarchyContains($oldEntity, it.hostConnectorEntity);
    };
  }
  function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_0($oldEntity) {
    return function (it) {
      return !hierarchyContains($oldEntity, it.guestConnectorEntity);
    };
  }
  function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_1(it) {
    return it.guestConnectionRoot;
  }
  function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_2($oldEntity, $newEntity) {
    return function (guestConnectionRoot) {
      var tmp0_safe_receiver = get_snapRoot(guestConnectionRoot);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
      var host = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hostConnectorEntity;
      var tmp;
      if (equals(host == null ? null : get_connectionRootEntity(host), $oldEntity)) {
        tmp = new Pair(guestConnectionRoot, $newEntity);
      } else {
        tmp = new Pair(guestConnectionRoot, host);
      }
      return tmp;
    };
  }
  function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_3($oldEntity) {
    return function (_name_for_destructuring_parameter_0__wldtmu) {
      var host = _name_for_destructuring_parameter_0__wldtmu.bf();
      return !equals(host, $oldEntity);
    };
  }
  function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_4($validationService) {
    return function (_name_for_destructuring_parameter_0__wldtmu) {
      var connectionRoot = _name_for_destructuring_parameter_0__wldtmu.af();
      var host = _name_for_destructuring_parameter_0__wldtmu.bf();
      var tmp0_safe_receiver = get_snapRoot(connectionRoot);
      var oldConnection = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
      return new EntityReplaceHelper(connectionRoot, oldConnection, host, $validationService, 0.0);
    };
  }
  function EntityReplaceHelper_init_$Init$(entity, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy, $this) {
    var tmp;
    if (allowedMovementsOfChildrenInMilliMeter === VOID) {
      tmp = 1.7976931348623157E308;
    } else {
      tmp = allowedMovementsOfChildrenInMilliMeter;
    }
    allowedMovementsOfChildrenInMilliMeter = tmp;
    snapSelectStrategy = snapSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : snapSelectStrategy;
    EntityReplaceHelper.call($this, entity, get_highestPriorityConnection(entity), host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy);
    return $this;
  }
  function EntityReplaceHelper_init_$Create$(entity, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy) {
    return EntityReplaceHelper_init_$Init$(entity, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy, objectCreate(protoOf(EntityReplaceHelper)));
  }
  function snap($this, host) {
    var tmp0_elvis_lhs = get_snapRoot($this.f1j_1);
    var entityRoot = tmp0_elvis_lhs == null ? $this.f1j_1 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = tryCreateCandidateToExactlyTheSameConnectors($this, entityRoot, host);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (isCandidateValid($this, tmp1_safe_receiver)) {
        tmp1_safe_receiver.createAction().perform();
        return Unit_instance;
      }
    }
    var epsilon = 1.0E-4;
    var settings = new SnapSettings(true, false, true, true);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.k1j_1.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(entityRoot, host, settings));
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
      if (element.movement.size <= $this.j1j_1 + epsilon) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
      if (isCandidateValid($this, element_0)) {
        destination_0.q(element_0);
      }
    }
    var candidates = destination_0;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = candidates.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
      if (element_1.hostConnector.key === $this.m1j_1) {
        destination_1.q(element_1);
      }
    }
    var candidateWithSameHostConnector = destination_1;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$11;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator_1 = candidateWithSameHostConnector.t();
      while (tmp0_iterator_1.u()) {
        var element_2 = tmp0_iterator_1.w();
        // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
        if (element_2.guestConnector.key === $this.n1j_1) {
          tmp$ret$11 = element_2;
          break $l$block;
        }
      }
      tmp$ret$11 = null;
    }
    var candidatesWithSameGuestConnector = tmp$ret$11;
    var tmp3_elvis_lhs = candidatesWithSameGuestConnector == null ? firstOrNull_1(candidateWithSameHostConnector) : candidatesWithSameGuestConnector;
    var candidate = tmp3_elvis_lhs == null ? firstOrNull_1(candidates) : tmp3_elvis_lhs;
    var tmp5_safe_receiver = candidate == null ? null : candidate.createAction();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.perform();
    }
  }
  function tryCreateCandidateToExactlyTheSameConnectors($this, guest, host) {
    if (!($this.g1j_1 == null) ? !(host == null) : false) {
      var sameHostConnector = findSameHostConnector($this, host);
      var sameGuestConnector = findSameGuestConnector($this, guest);
      if ((!(sameHostConnector == null) ? !(sameGuestConnector == null) : false) ? sameGuestConnector.hasMatchingTags(sameHostConnector) : false) {
        return SnapUtils_instance.createSnapCandidate(guest, sameGuestConnector, host, sameHostConnector);
      }
    }
    return null;
  }
  function findSameHostConnector($this, host) {
    var tmp0_safe_receiver = get_connectorsComponent(host);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp1_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.replace.EntityReplaceHelper.findSameHostConnector.<anonymous>' call
        if (element.key === $this.m1j_1) {
          return element;
        } else {
          if (element instanceof PointSeriesConnector) {
            // Inline function 'kotlin.sequences.find' call
            var this_0 = element.allSubConnectors;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.sequences.firstOrNull' call
              var tmp0_iterator_0 = this_0.t();
              while (tmp0_iterator_0.u()) {
                var element_0 = tmp0_iterator_0.w();
                // Inline function 'com.ikea.core.replace.EntityReplaceHelper.findSameHostConnector.<anonymous>.<anonymous>' call
                if (element_0.key === $this.m1j_1) {
                  tmp$ret$1 = element_0;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var foundSubConnector = tmp$ret$1;
            if (!(foundSubConnector == null))
              return foundSubConnector;
          }
        }
      }
    }
    return null;
  }
  function findSameGuestConnector($this, guest) {
    var tmp0_safe_receiver = get_connectorsComponent(guest);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp1_safe_receiver.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.core.replace.EntityReplaceHelper.findSameGuestConnector.<anonymous>' call
          if (element.key === $this.n1j_1) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    return tmp;
  }
  function isCandidateValid($this, candidate) {
    var tmp0_safe_receiver = $this.i1j_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.validateSnap(candidate);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.replace.EntityReplaceHelper.isCandidateValid.<anonymous>' call
          if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    }
    var tmp2_elvis_lhs = tmp;
    var isValid = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
    return isValid;
  }
  function Companion_76() {
  }
  protoOf(Companion_76).x1l = function (oldEntity, newEntity, validationService) {
    var tmp0_safe_receiver = get_connectionRootEntity(oldEntity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_hostedConnections(tmp0_safe_receiver);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : asSequence_0(tmp1_safe_receiver);
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = filter(tmp2_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda(oldEntity));
    }
    var tmp3_safe_receiver = tmp;
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = filter(tmp3_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_0(oldEntity));
    }
    var tmp4_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp4_safe_receiver == null) {
      tmp_1 = null;
    } else {
      tmp_1 = map(tmp4_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_1);
    }
    var tmp5_safe_receiver = tmp_1;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : distinct_0(tmp5_safe_receiver);
    var tmp_2;
    if (tmp6_safe_receiver == null) {
      tmp_2 = null;
    } else {
      tmp_2 = map(tmp6_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_2(oldEntity, newEntity));
    }
    var tmp7_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp7_safe_receiver == null) {
      tmp_3 = null;
    } else {
      tmp_3 = filter(tmp7_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_3(oldEntity));
    }
    var tmp8_safe_receiver = tmp_3;
    var tmp_4;
    if (tmp8_safe_receiver == null) {
      tmp_4 = null;
    } else {
      tmp_4 = map(tmp8_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_4(validationService));
    }
    var tmp9_safe_receiver = tmp_4;
    var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toList_0(tmp9_safe_receiver);
    return tmp10_elvis_lhs == null ? emptyList() : tmp10_elvis_lhs;
  };
  var Companion_instance_76;
  function Companion_getInstance_77() {
    return Companion_instance_76;
  }
  function EntityReplaceHelper(entity, oldConnection, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy) {
    var tmp;
    if (allowedMovementsOfChildrenInMilliMeter === VOID) {
      tmp = 1.7976931348623157E308;
    } else {
      tmp = allowedMovementsOfChildrenInMilliMeter;
    }
    allowedMovementsOfChildrenInMilliMeter = tmp;
    snapSelectStrategy = snapSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : snapSelectStrategy;
    this.f1j_1 = entity;
    this.g1j_1 = oldConnection;
    this.h1j_1 = host;
    this.i1j_1 = validationService;
    this.j1j_1 = allowedMovementsOfChildrenInMilliMeter;
    this.k1j_1 = snapSelectStrategy;
    var tmp_0 = this;
    var tmp0_safe_receiver = this.g1j_1;
    tmp_0.l1j_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectorEntity;
    var tmp_1 = this;
    var tmp0_safe_receiver_0 = this.g1j_1;
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.hostConnector;
    tmp_1.m1j_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.key;
    var tmp_2 = this;
    var tmp0_safe_receiver_1 = this.g1j_1;
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.guestConnector;
    tmp_2.n1j_1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.key;
  }
  protoOf(EntityReplaceHelper).v = function () {
    var worldTransform = get_worldTransform(this.f1j_1);
    ConnectionUtils_instance.disconnect(this.f1j_1);
    setParent(this.f1j_1, null);
    this.f1j_1.addComponent(new LocalTransformComponent(worldTransform));
  };
  protoOf(EntityReplaceHelper).n2l = function (checkIfDisposed) {
    if (checkIfDisposed ? this.f1j_1.isDisposed : false) {
      return Unit_instance;
    }
    if (this.h1j_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      snap(this, this.h1j_1);
    }
  };
  protoOf(EntityReplaceHelper).o2l = function (checkIfDisposed, $super) {
    checkIfDisposed = checkIfDisposed === VOID ? false : checkIfDisposed;
    var tmp;
    if ($super === VOID) {
      this.n2l(checkIfDisposed);
      tmp = Unit_instance;
    } else {
      tmp = $super.n2l.call(this, checkIfDisposed);
    }
    return tmp;
  };
  protoOf(EntityReplaceHelper).z1l = function () {
    if (this.l1j_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      snap(this, this.l1j_1);
    }
  };
  function entityGroupStuff($this, entityGroup, newEntity, oldEntity) {
    if (entityGroup == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      addAutomaticGroupMember(entityGroup, newEntity);
      removeAutomaticGroupMember(entityGroup, oldEntity);
      Companion_getInstance_40().setGroupMemberComponents(newEntity, entityGroup);
      Companion_getInstance_40().removeFromEntityGroup(oldEntity);
      Companion_getInstance_40().handleLockedMembersOfGroup(entityGroup);
    }
  }
  function replaceInScene($this, newEntity, oldEntity) {
    setParentMaintainWorldTransform(newEntity, get_parent(oldEntity));
    setParentMaintainWorldTransform(oldEntity, null);
  }
  function adoptChildren($this, newEntity, oldEntity) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_immediateConnectionRootDescendants(oldEntity);
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptChildren.<anonymous>' call
      if (get_isConnectionRoot(element)) {
        destination.q(element);
      }
    }
    var tmp0_iterator_0 = destination.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptChildren.<anonymous>' call
      setParent(element_0, newEntity);
    }
  }
  function adoptConnections($this, newEntity, oldEntity) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = get_guestConnections(oldEntity);
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptConnections.<anonymous>' call
      var tmp0_safe_receiver = createSimilarGuestConnection($this, newEntity, element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    var newGuestConnections = copyToArray(destination);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_1 = get_hostedConnections(oldEntity);
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptConnections.<anonymous>' call
      var tmp0_safe_receiver_0 = createSimilarHostConnection($this, newEntity, element_0);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver_0);
      }
    }
    var newHostConnections = copyToArray(destination_0);
    // Inline function 'kotlin.collections.set' call
    var this_2 = $this.p2l_1;
    Companion_getInstance_18();
    var value = oldEntity.__getComponentForKotlin(104);
    this_2.r2(oldEntity, value);
    Companion_getInstance_18();
    oldEntity.removeComponent(104);
    if (any(newGuestConnections)) {
      newEntity.addComponent(new GuestConnectionsComponent(newGuestConnections));
    } else {
      Companion_getInstance_18();
      newEntity.removeComponent(104);
    }
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_1 = 0;
    var last_1 = newHostConnections.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = newHostConnections[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptConnections.<anonymous>' call
      var tmp0_elvis_lhs = get_connectionRootEntity(element_1.guestConnectorEntity);
      var guest = tmp0_elvis_lhs == null ? element_1.guestConnectorEntity : tmp0_elvis_lhs;
      Companion_getInstance_18();
      var tmp1_safe_receiver = guest.__getComponentForKotlin(104);
      var newGuestConnectionsComponent = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.withReplacedConnection(element_1);
      if (!(newGuestConnectionsComponent == null)) {
        var wasPaused = guest.hasComponent(107);
        guest.addComponent(new TemporarilyPauseConnectionParentingComponent());
        // Inline function 'kotlin.collections.set' call
        var this_3 = $this.p2l_1;
        Companion_getInstance_18();
        var value_0 = guest.__getComponentForKotlin(104);
        this_3.r2(guest, value_0);
        guest.addComponent(newGuestConnectionsComponent);
        if (!wasPaused) {
          guest.removeComponent(107);
        }
      }
    }
  }
  function createSimilarGuestConnection($this, newEntity, connection) {
    var tmp0_safe_receiver = get_connectorsComponent(newEntity);
    var newGuestConnector = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey(connection.guestConnector.key);
    if (newGuestConnector == null) {
      // Inline function 'kotlin.collections.find' call
      var tmp = ConnectionUtils_instance;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [connection.hostConnectorEntity];
      var this_0 = tmp.calculateAllConnectionsToHierarchies(newEntity, tmp$ret$2);
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.replace.FastReplaceAction.createSimilarGuestConnection.<anonymous>' call
          if (element.hostConnectorEntity.equals(connection.hostConnectorEntity) ? element.hostConnector.key === connection.hostConnector.key : false) {
            tmp$ret$4 = element;
            break $l$block;
          }
        }
        tmp$ret$4 = null;
      }
      var tmp1_safe_receiver = tmp$ret$4;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp1_safe_receiver;
      }
      var tmp_0 = Companion_getInstance_78().q2l_1;
      tmp_0.warn(FastReplaceAction$createSimilarGuestConnection$lambda(connection, newEntity));
      return null;
    }
    return new Connection(newEntity, newGuestConnector, connection.hostConnectorEntity, connection.hostConnector, connection.hostGuestConnectorDeltaTransform);
  }
  function createSimilarHostConnection($this, newEntity, connection) {
    var tmp0_safe_receiver = get_connectorsComponent(newEntity);
    var newHostConnector = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey(connection.hostConnector.key);
    if (newHostConnector == null) {
      // Inline function 'kotlin.collections.find' call
      var tmp = ConnectionUtils_instance;
      var tmp_0 = connection.guestConnectionRoot;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [newEntity];
      var this_0 = tmp.calculateAllConnectionsToHierarchies(tmp_0, tmp$ret$2);
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.replace.FastReplaceAction.createSimilarHostConnection.<anonymous>' call
          if (element.guestConnectorEntity.equals(connection.guestConnectorEntity) ? element.guestConnector.key === connection.guestConnector.key : false) {
            tmp$ret$4 = element;
            break $l$block;
          }
        }
        tmp$ret$4 = null;
      }
      var tmp1_safe_receiver = tmp$ret$4;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp1_safe_receiver;
      }
      var tmp_1 = Companion_getInstance_78().q2l_1;
      tmp_1.warn(FastReplaceAction$createSimilarHostConnection$lambda(connection, newEntity));
      return null;
    }
    return new Connection(connection.guestConnectorEntity, connection.guestConnector, newEntity, newHostConnector, connection.hostGuestConnectorDeltaTransform);
  }
  function Companion_77() {
    Companion_instance_77 = this;
    this.q2l_1 = LoggerState_getInstance().m1m('FastReplaceAction');
  }
  var Companion_instance_77;
  function Companion_getInstance_78() {
    if (Companion_instance_77 == null)
      new Companion_77();
    return Companion_instance_77;
  }
  function FastReplaceAction$createSimilarGuestConnection$lambda($connection, $newEntity) {
    return function () {
      return 'Could not find corresponding guest connector to ' + $connection.guestConnector.key + ' on ' + get_displayName($newEntity);
    };
  }
  function FastReplaceAction$createSimilarHostConnection$lambda($connection, $newEntity) {
    return function () {
      return 'Could not find corresponding host connector to ' + $connection.hostConnector.key + ' on ' + get_displayName($newEntity);
    };
  }
  function FastReplaceAction(oldEntity, newEntity, entityManager, validationService, sceneManager) {
    Companion_getInstance_78();
    this.oldEntity = oldEntity;
    this.newEntity = newEntity;
    this.entityManager = entityManager;
    this.validationService = validationService;
    this.sceneManager = sceneManager;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.p2l_1 = LinkedHashMap_init_$Create$_0();
    this.entityGroup = get_automaticEntityGroup(this.oldEntity);
    this.newEntity.addComponent(new LocalTransformComponent(get_worldTransform(this.oldEntity)));
  }
  protoOf(FastReplaceAction).y1l = function () {
    return this.oldEntity;
  };
  protoOf(FastReplaceAction).e1j = function () {
    return this.newEntity;
  };
  protoOf(FastReplaceAction).p1i = function () {
    return this.entityManager;
  };
  protoOf(FastReplaceAction).w27 = function () {
    return this.validationService;
  };
  protoOf(FastReplaceAction).q1i = function () {
    return this.sceneManager;
  };
  protoOf(FastReplaceAction).r2l = function () {
    return this.entityGroup;
  };
  protoOf(FastReplaceAction).perform = function () {
    this.oldEntity.addComponent(new TemporarilyPauseConnectionParentingComponent());
    this.newEntity.addComponent(new TemporarilyPauseConnectionParentingComponent());
    replaceInScene(this, this.newEntity, this.oldEntity);
    adoptChildren(this, this.newEntity, this.oldEntity);
    adoptConnections(this, this.newEntity, this.oldEntity);
    entityGroupStuff(this, this.entityGroup, this.newEntity, this.oldEntity);
    this.oldEntity.removeComponent(107);
    this.newEntity.removeComponent(107);
  };
  protoOf(FastReplaceAction).toString = function () {
    return 'Fast Replace Action old ' + this.oldEntity + ' for new ' + this.newEntity;
  };
  function ReplaceAction(oldEntity, newEntity, allowedMovementsOfChildrenInMilliMeter, validationService, sceneManager) {
    this.oldEntity = oldEntity;
    this.newEntity = newEntity;
    this.allowedMovementsOfChildrenInMilliMeter = allowedMovementsOfChildrenInMilliMeter;
    this.validationService = validationService;
    this.sceneManager = sceneManager;
    this.newEntity.addComponent(new LocalTransformComponent(get_worldTransform(this.oldEntity)));
    this.s2l_1 = Companion_instance_76.x1l(this.oldEntity, this.newEntity, this.validationService);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_immediateConnectionRootDescendants(this.oldEntity);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.ReplaceAction.descendantEntityHelpers.<anonymous>' call
      var tmp$ret$0 = EntityReplaceHelper_init_$Create$(item, this.newEntity, this.validationService, this.allowedMovementsOfChildrenInMilliMeter);
      destination.q(tmp$ret$0);
    }
    tmp.t2l_1 = destination;
    this.u2l_1 = EntityReplaceHelper_init_$Create$(this.oldEntity, null, this.validationService);
    var tmp_0 = this;
    var tmp0_safe_receiver = get_snapRoot(this.oldEntity);
    var tmp_1 = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
    var tmp1_safe_receiver = get_snapRoot(this.oldEntity);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_highestPriorityConnection(tmp1_safe_receiver);
    tmp_0.v2l_1 = new EntityReplaceHelper(this.newEntity, tmp_1, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnectorEntity, this.validationService);
  }
  protoOf(ReplaceAction).y1l = function () {
    return this.oldEntity;
  };
  protoOf(ReplaceAction).e1j = function () {
    return this.newEntity;
  };
  protoOf(ReplaceAction).w2l = function () {
    return this.allowedMovementsOfChildrenInMilliMeter;
  };
  protoOf(ReplaceAction).w27 = function () {
    return this.validationService;
  };
  protoOf(ReplaceAction).q1i = function () {
    return this.sceneManager;
  };
  protoOf(ReplaceAction).perform = function () {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.s2l_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
      element.v();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.t2l_1.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
      element_0.v();
    }
    this.u2l_1.v();
    this.v2l_1.o2l();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = this.t2l_1.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
      element_1.n2l(true);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_2 = this.s2l_1.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
      element_2.o2l();
    }
  };
  protoOf(ReplaceAction).toString = function () {
    return 'Replace Action old ' + this.oldEntity + ' for new ' + this.newEntity;
  };
  function replacePartInAssembly($this, entityToAdd, entityToReplace) {
    connectPartToAssembly_1($this, entityToAdd);
    adoptAllChildrenParts($this, entityToReplace, entityToAdd, $this.x2l_1);
  }
  function removeAllConnectionRoots($this, newEntity) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_descendants(newEntity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.replace.ReplacePartAction.removeAllConnectionRoots.<anonymous>' call
      if (get_isConnectionRoot(element)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.removeAllConnectionRoots.<anonymous>' call
      $this.entityManager.disposeEntity(element_0);
    }
  }
  function connectPartToAssembly_1($this, entity) {
    Companion_instance.connectChildPart($this.y2l_1, entity, $this.x2l_1);
  }
  function adoptAllChildrenParts($this, entityToReplace, entityToAdd, assemblyPart) {
    var childrenParts = assemblyPart.children;
    if (childrenParts == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = childrenParts.length;
      while (inductionVariable < last) {
        var element = childrenParts[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        $l$block_0: {
          // Inline function 'com.ikea.core.replace.ReplacePartAction.adoptAllChildrenParts.<anonymous>' call
          // Inline function 'kotlin.collections.find' call
          var this_0 = get_children(entityToReplace);
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_0 = 0;
            var last_0 = this_0.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = this_0[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.replace.ReplacePartAction.adoptAllChildrenParts.<anonymous>.<anonymous>' call
              if (get_partKey(element_0) === element.partKey) {
                tmp$ret$1 = element_0;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$block_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var childEntity = tmp;
          Companion_instance.connectChildPart(entityToAdd, childEntity, element);
        }
      }
    }
  }
  function ReplacePartAction(oldEntity, newEntity, assemblyPart, parent, entityManager, validationService, sceneManager) {
    this.oldEntity = oldEntity;
    this.newEntity = newEntity;
    this.x2l_1 = assemblyPart;
    this.y2l_1 = parent;
    this.entityManager = entityManager;
    this.z2l_1 = validationService;
    this.sceneManager = sceneManager;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(this.oldEntity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.replace.ReplacePartAction.childEntityHelpers.<anonymous>' call
      if (get_isConnectionRoot(element)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.childEntityHelpers.<anonymous>' call
      var tmp$ret$3 = EntityReplaceHelper_init_$Create$(item, this.newEntity, this.z2l_1);
      destination_0.q(tmp$ret$3);
    }
    tmp.a2m_1 = destination_0;
    this.b2m_1 = Companion_instance_76.x1l(this.oldEntity, this.newEntity, this.z2l_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = get_immediateConnectionRootDescendants(this.oldEntity);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.t();
    while (tmp0_iterator_0.u()) {
      var item_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.descendantEntityHelpers.<anonymous>' call
      var tmp$ret$6 = EntityReplaceHelper_init_$Create$(item_0, this.newEntity, this.z2l_1, 1.7976931348623157E308);
      destination_1.q(tmp$ret$6);
    }
    tmp_0.c2m_1 = destination_1;
    this.d2m_1 = EntityReplaceHelper_init_$Create$(this.oldEntity, null, this.z2l_1);
    var tmp_1 = this;
    var tmp0_safe_receiver = get_connectionRootEntity(this.oldEntity);
    var tmp_2 = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
    var tmp1_safe_receiver = get_connectionRootEntity(this.oldEntity);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_highestPriorityConnection(tmp1_safe_receiver);
    tmp_1.e2m_1 = new EntityReplaceHelper(this.newEntity, tmp_2, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnectorEntity, this.z2l_1);
  }
  protoOf(ReplacePartAction).y1l = function () {
    return this.oldEntity;
  };
  protoOf(ReplacePartAction).e1j = function () {
    return this.newEntity;
  };
  protoOf(ReplacePartAction).p1i = function () {
    return this.entityManager;
  };
  protoOf(ReplacePartAction).q1i = function () {
    return this.sceneManager;
  };
  protoOf(ReplacePartAction).rollback = function () {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.b2m_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
      element.v();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.a2m_1.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
      element_0.v();
    }
    this.e2m_1.v();
    replacePartInAssembly(this, this.oldEntity, this.newEntity);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = this.c2m_1.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
      element_1.z1l();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_2 = this.b2m_1.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
      element_2.z1l();
    }
  };
  protoOf(ReplacePartAction).perform = function () {
    removeAllConnectionRoots(this, this.newEntity);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.b2m_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
      element.v();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.c2m_1.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
      element_0.v();
    }
    this.d2m_1.v();
    replacePartInAssembly(this, this.newEntity, this.oldEntity);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = this.c2m_1.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
      element_1.o2l();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_2 = this.b2m_1.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
      element_2.o2l();
    }
  };
  protoOf(ReplacePartAction).toString = function () {
    return 'Replace part Action old ' + this.oldEntity + ' for new ' + this.newEntity;
  };
  function Companion_78() {
    this.id = 86;
  }
  protoOf(Companion_78).s1k = function () {
    return this.id;
  };
  var Companion_instance_78;
  function Companion_getInstance_79() {
    return Companion_instance_78;
  }
  function ClickEventComponent(screenSpaceCoord) {
    this.screenSpaceCoord = screenSpaceCoord;
    this.f2m_1 = 86;
  }
  protoOf(ClickEventComponent).g2m = function () {
    return this.screenSpaceCoord;
  };
  protoOf(ClickEventComponent).x1k = function () {
    return this.f2m_1;
  };
  protoOf(ClickEventComponent).eq = function (other) {
    if (!(other instanceof ClickEventComponent))
      return false;
    return other.screenSpaceCoord.equals(this.screenSpaceCoord);
  };
  function triggerClickEvent(_this__u8e3s4, entityManager, screenSpaceCoord) {
    var event = new ClickEventComponent(screenSpaceCoord);
    entityManager.addComponent(_this__u8e3s4, event);
    entityManager.removeComponent(_this__u8e3s4, event.f2m_1);
  }
  function MultiSelectionEnabledComponent() {
  }
  protoOf(MultiSelectionEnabledComponent).x1k = function () {
    return this.id;
  };
  protoOf(MultiSelectionEnabledComponent).s1k = function () {
    return 56;
  };
  protoOf(MultiSelectionEnabledComponent).eq = function (other) {
    return true;
  };
  var MultiSelectionEnabledComponent_instance;
  function MultiSelectionEnabledComponent_getInstance() {
    return MultiSelectionEnabledComponent_instance;
  }
  function Companion_79() {
    this.id = 1;
  }
  protoOf(Companion_79).s1k = function () {
    return this.id;
  };
  var Companion_instance_79;
  function Companion_getInstance_80() {
    return Companion_instance_79;
  }
  function SelectableComponent() {
  }
  protoOf(SelectableComponent).x1k = function () {
    return 1;
  };
  protoOf(SelectableComponent).eq = function (other) {
    return true;
  };
  function get_selectableComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(1);
  }
  function get_isSelectable(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(1);
  }
  function SelectedComponent() {
  }
  protoOf(SelectedComponent).x1k = function () {
    return this.id;
  };
  protoOf(SelectedComponent).s1k = function () {
    return 0;
  };
  protoOf(SelectedComponent).eq = function (other) {
    return true;
  };
  var SelectedComponent_instance;
  function SelectedComponent_getInstance() {
    return SelectedComponent_instance;
  }
  function get_isSelected(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(SelectedComponent_instance.id);
  }
  function Companion_80() {
    Companion_instance_80 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2m_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
  }
  protoOf(Companion_80).l17 = function () {
    return $serializer_getInstance_9();
  };
  var Companion_instance_80;
  function Companion_getInstance_81() {
    if (Companion_instance_80 == null)
      new Companion_80();
    return Companion_instance_80;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.CatalogsHeader', this, 1);
    tmp0_serialDesc.cv('catalogs', false);
    this.i2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ok = function () {
    return this.i2m_1;
  };
  protoOf($serializer_9).rv = function () {
    var tmp0_cached = Companion_getInstance_81().h2m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0])];
  };
  protoOf($serializer_9).qk = function (decoder) {
    var tmp0_desc = this.i2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.nn(tmp0_desc);
    var tmp6_cached = Companion_getInstance_81().h2m_1;
    if (tmp5_input.do()) {
      tmp4_local0 = tmp5_input.bo(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.bo(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.on(tmp0_desc);
    return CatalogsHeader_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_9).j2m = function (encoder, value) {
    var tmp0_desc = this.i2m_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_81().h2m_1;
    tmp1_output.gp(tmp0_desc, 0, tmp2_cached[0], value.catalogs);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_9).pk = function (encoder, value) {
    return this.j2m(encoder, value instanceof CatalogsHeader ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function CatalogsHeader_init_$Init$(seen1, catalogs, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_9().i2m_1);
    }
    $this.catalogs = catalogs;
    return $this;
  }
  function CatalogsHeader_init_$Create$(seen1, catalogs, serializationConstructorMarker) {
    return CatalogsHeader_init_$Init$(seen1, catalogs, serializationConstructorMarker, objectCreate(protoOf(CatalogsHeader)));
  }
  function CatalogsHeader(catalogs) {
    Companion_getInstance_81();
    this.catalogs = catalogs;
  }
  protoOf(CatalogsHeader).d1m = function () {
    return this.catalogs;
  };
  protoOf(CatalogsHeader).af = function () {
    return this.catalogs;
  };
  protoOf(CatalogsHeader).k2m = function (catalogs) {
    return new CatalogsHeader(catalogs);
  };
  protoOf(CatalogsHeader).copy = function (catalogs, $super) {
    catalogs = catalogs === VOID ? this.catalogs : catalogs;
    return this.k2m(catalogs);
  };
  protoOf(CatalogsHeader).toString = function () {
    return 'CatalogsHeader(catalogs=' + this.catalogs + ')';
  };
  protoOf(CatalogsHeader).hashCode = function () {
    return this.catalogs == null ? 0 : hashCode(this.catalogs);
  };
  protoOf(CatalogsHeader).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CatalogsHeader))
      return false;
    var tmp0_other_with_cast = other instanceof CatalogsHeader ? other : THROW_CCE();
    if (!equals(this.catalogs, tmp0_other_with_cast.catalogs))
      return false;
    return true;
  };
  function ComponentDeserializer() {
  }
  function ComponentDeserializerRegistry() {
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.l2m_1 = [];
  }
  protoOf(ComponentDeserializerRegistry).m2m = function () {
    return this.l2m_1;
  };
  protoOf(ComponentDeserializerRegistry).register = function (componentDeserializer) {
    if (!componentDeserializer.thisClassIsGuaranteedToNotModifyOrQueryCoreState) {
      // Inline function 'kotlin.error' call
      var message = "You haven't read and accepted the class documentation for ComponentSerializer for " + componentDeserializer;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.l2m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [componentDeserializer];
    tmp.l2m_1 = tmp$ret$0.concat(tmp$ret$3);
  };
  protoOf(ComponentDeserializerRegistry).unregister = function (componentDeserializer) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = minus(toMutableList(this.l2m_1), componentDeserializer);
    tmp.l2m_1 = copyToArray(this_0);
  };
  function JsonSerializable() {
  }
  function JsonSerializer$Companion$StrictPretty$lambda($this$Json) {
    $this$Json.d16_1 = false;
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    $this$Json.c16_1 = true;
    return Unit_instance;
  }
  function JsonSerializer$Companion$NonStrictPretty$lambda($this$Json) {
    $this$Json.d16_1 = false;
    $this$Json.f16_1 = true;
    $this$Json.h16_1 = true;
    $this$Json.c16_1 = true;
    return Unit_instance;
  }
  function JsonSerializer$Companion$NonStrictPrettyIgnoreUnknownKeys$lambda($this$Json) {
    $this$Json.d16_1 = false;
    $this$Json.f16_1 = true;
    $this$Json.e16_1 = true;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function createANewCoreInstance($this, coreServices) {
    var tmpCore = coreServices.coreFactory.createNewCoreInstance();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = coreServices.productManager.catalogs;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.createANewCoreInstance.<anonymous>' call
      tmpCore.services.productManager.addCatalog(element);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = coreServices.componentDeserializerRegistry.componentSerializers;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.createANewCoreInstance.<anonymous>' call
      tmpCore.services.componentDeserializerRegistry.register(element_0);
    }
    return tmpCore;
  }
  function rebuildTreeFromScratch($this, coreServices, serializableTree) {
    var entityTreeBuilder = new EntityTreeBuilder(coreServices.entityManager, coreServices.productManager, coreServices.validations, coreServices.sceneManager);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = serializableTree.roots;
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.serialization.JsonSerializer.rebuildTreeFromScratch.<anonymous>' call
      var tmp0_safe_receiver = entityTreeBuilder.buildEntityTree(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    var newRoots = destination;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = newRoots.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.JsonSerializer.rebuildTreeFromScratch.<anonymous>' call
      serializableTree.afterRebuildTree(element_0, coreServices);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(newRoots);
  }
  function letCatalogsUpdateTreeWhenDone($this, catalogs, root) {
    var tmp0_safe_receiver = $this.n2m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.catalogs;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateTreeWhenDone.<anonymous>' call
        element.afterDeserializeComplete(root, catalogs.b3(element.rangeId()));
      }
    }
  }
  function letCatalogsUpdateTreeBeforeParsingComponents($this, catalogs, serializableTree) {
    var tmp0_safe_receiver = $this.n2m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.catalogs;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateTreeBeforeParsingComponents.<anonymous>' call
        element.beforeParsingComponents(serializableTree, catalogs.b3(element.rangeId()));
      }
    }
  }
  function letCatalogsUpdateTreeBeforeBuildingEntities($this, catalogs, serializableTree) {
    var tmp0_safe_receiver = $this.n2m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.catalogs;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateTreeBeforeBuildingEntities.<anonymous>' call
        element.beforeBuildingEntities(serializableTree, catalogs.b3(element.rangeId()));
      }
    }
  }
  function letCatalogsUpdateJSON($this, catalogs, bundle) {
    var newJson = bundle;
    var tmp0_safe_receiver = $this.n2m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.catalogs;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateJSON.<anonymous>' call
        newJson = element.beforeDeserialize(newJson, catalogs.b3(element.rangeId()));
      }
    }
    return newJson;
  }
  function catalogVersions($this, bundle) {
    var tmp;
    try {
      var tmp0_elvis_lhs = Companion_getInstance_82().NonStrictPrettyIgnoreUnknownKeys.j15(Companion_getInstance_81().l17(), bundle).catalogs;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.collections.mapOf' call
        tmp_0 = emptyMap();
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof SerializationException) {
        var se = $p;
        // Inline function 'kotlin.collections.mapOf' call
        tmp_1 = emptyMap();
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function fromJson($this, bundle) {
    var version = Companion_getInstance_82().NonStrictPrettyIgnoreUnknownKeys.j15(Companion_instance_86.l17(), bundle).version;
    return fromJson_0($this, version, bundle);
  }
  function fromJson_0($this, version, bundle) {
    var tmp;
    if (version === '1.3') {
      tmp = Companion_getInstance_82().NonStrictPretty.j15(Companion_getInstance_91().l17(), bundle);
    } else {
      throw IllegalStateException_init_$Create$('Can not deserialize version ' + version);
    }
    return tmp;
  }
  function Companion_81() {
    Companion_instance_81 = this;
    var tmp = this;
    tmp.StrictPretty = Json(VOID, JsonSerializer$Companion$StrictPretty$lambda);
    var tmp_0 = this;
    tmp_0.NonStrictPretty = Json(VOID, JsonSerializer$Companion$NonStrictPretty$lambda);
    var tmp_1 = this;
    tmp_1.NonStrictPrettyIgnoreUnknownKeys = Json(VOID, JsonSerializer$Companion$NonStrictPrettyIgnoreUnknownKeys$lambda);
  }
  protoOf(Companion_81).p2m = function () {
    return this.StrictPretty;
  };
  protoOf(Companion_81).q2m = function () {
    return this.NonStrictPretty;
  };
  protoOf(Companion_81).r2m = function () {
    return this.NonStrictPrettyIgnoreUnknownKeys;
  };
  var Companion_instance_81;
  function Companion_getInstance_82() {
    if (Companion_instance_81 == null)
      new Companion_81();
    return Companion_instance_81;
  }
  function JsonSerializer(productManager) {
    Companion_getInstance_82();
    productManager = productManager === VOID ? null : productManager;
    this.n2m_1 = productManager;
  }
  protoOf(JsonSerializer).deserializeToEntityHierarchies = function (json, coreServices) {
    var catalogs = catalogVersions(this, json);
    var updatedJson = letCatalogsUpdateJSON(this, catalogs, json);
    var serializableTree = fromJson(this, updatedJson);
    letCatalogsUpdateTreeBeforeParsingComponents(this, catalogs, serializableTree);
    serializableTree.deserializeComponents(coreServices);
    letCatalogsUpdateTreeBeforeBuildingEntities(this, catalogs, serializableTree);
    var tmpCore = createANewCoreInstance(this, coreServices);
    serializableTree.afterDeserialized(tmpCore.services);
    var newRoots = rebuildTreeFromScratch(this, coreServices, serializableTree);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = newRoots.length;
    while (inductionVariable < last) {
      var element = newRoots[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.deserializeToEntityHierarchies.<anonymous>' call
      element.addComponent(new LocalTransformComponent(get_worldTransform(element)));
      element.addComponent(new WorldTransformComponent(Companion_getInstance_60().IDENTITY));
      TransformUtils_instance.updateWorldTransform(element);
    }
    letCatalogsUpdateTreeWhenDone(this, catalogs, firstOrNull(newRoots));
    return newRoots;
  };
  protoOf(JsonSerializer).hierarchiesToJsonString = function (roots) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = roots.length;
    while (inductionVariable < last) {
      var element = roots[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.hierarchiesToJsonString.<anonymous>' call
      var list = toList_1(get_hierarchy(element));
      addAll(destination, list);
    }
    var allEntities = copyToArray(destination);
    return this.singleEntitiesToJsonString(allEntities);
  };
  protoOf(JsonSerializer).singleEntitiesToJsonString = function (entities) {
    return Companion_getInstance_91().buildTreeAndSerialize(entities, this.n2m_1);
  };
  protoOf(JsonSerializer).toJsonString = function (root) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [root];
    return this.hierarchiesToJsonString(tmp$ret$2);
  };
  function Companion_82() {
    this.id = 100;
  }
  protoOf(Companion_82).s1k = function () {
    return this.id;
  };
  var Companion_instance_82;
  function Companion_getInstance_83() {
    return Companion_instance_82;
  }
  function PreviouslySerializedIdComponent(serializedId) {
    this.serializedId = serializedId;
    this.s2m_1 = Companion_instance_82.id;
  }
  protoOf(PreviouslySerializedIdComponent).t2m = function () {
    return this.serializedId;
  };
  protoOf(PreviouslySerializedIdComponent).x1k = function () {
    return this.s2m_1;
  };
  protoOf(PreviouslySerializedIdComponent).eq = function (other) {
    var tmp0_safe_receiver = other instanceof PreviouslySerializedIdComponent ? other : null;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializedId) === this.serializedId;
  };
  function get_previousId(_this__u8e3s4) {
    var tmp0_safe_receiver = get_previousStringId(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
  }
  function get_previousStringId(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_instance_82.id);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializedId;
  }
  function SceneReloadingComponent() {
  }
  protoOf(SceneReloadingComponent).x1k = function () {
    return this.id;
  };
  protoOf(SceneReloadingComponent).s1k = function () {
    return 73;
  };
  protoOf(SceneReloadingComponent).eq = function (other) {
    return true;
  };
  var SceneReloadingComponent_instance;
  function SceneReloadingComponent_getInstance() {
    return SceneReloadingComponent_instance;
  }
  function SerializableCatalogInterceptor() {
  }
  function SerializableComponent() {
  }
  function SerializableEntity() {
  }
  function SerializableGuestConnectionsComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function Companion_83() {
  }
  protoOf(Companion_83).fromConnection = function (connection) {
    return new SerializableConnection(connection.guestConnectorEntity.id.toString(), connection.hostConnectorEntity.id.toString(), connection.guestConnector.key, connection.hostConnector.key);
  };
  protoOf(Companion_83).l17 = function () {
    return $serializer_getInstance_10();
  };
  var Companion_instance_83;
  function Companion_getInstance_84() {
    return Companion_instance_83;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.SerializableGuestConnectionsComponent.SerializableConnection', this, 4);
    tmp0_serialDesc.cv('guestId', false);
    tmp0_serialDesc.cv('hostId', false);
    tmp0_serialDesc.cv('guestConnector', false);
    tmp0_serialDesc.cv('hostConnector', false);
    this.b2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).ok = function () {
    return this.b2n_1;
  };
  protoOf($serializer_10).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_10).qk = function (decoder) {
    var tmp0_desc = this.b2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.xn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.xn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return SerializableConnection_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_10).c2n = function (encoder, value) {
    var tmp0_desc = this.b2n_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.guestId);
    tmp1_output.cp(tmp0_desc, 1, value.hostId);
    tmp1_output.cp(tmp0_desc, 2, value.guestConnector);
    tmp1_output.cp(tmp0_desc, 3, value.hostConnector);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_10).pk = function (encoder, value) {
    return this.c2n(encoder, value instanceof SerializableConnection ? value : THROW_CCE());
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function SerializableConnection_init_$Init$(seen1, guestId, hostId, guestConnector, hostConnector, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_10().b2n_1);
    }
    $this.guestId = guestId;
    $this.hostId = hostId;
    $this.guestConnector = guestConnector;
    $this.hostConnector = hostConnector;
    return $this;
  }
  function SerializableConnection_init_$Create$(seen1, guestId, hostId, guestConnector, hostConnector, serializationConstructorMarker) {
    return SerializableConnection_init_$Init$(seen1, guestId, hostId, guestConnector, hostConnector, serializationConstructorMarker, objectCreate(protoOf(SerializableConnection)));
  }
  function Companion_84() {
    Companion_instance_84 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2n_1 = [new ArrayListSerializer($serializer_getInstance_10()), null];
    this.id = 106;
    this.serializationKey = 'Connections';
    var tmp_0 = this;
    tmp_0.e2n_1 = Json(VOID, SerializableGuestConnectionsComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_84).s1k = function () {
    return this.id;
  };
  protoOf(Companion_84).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_84).fromConnectionsComponent = function (connectionsComponent) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = connectionsComponent.connections;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.Companion.fromConnectionsComponent.<anonymous>' call
      var tmp$ret$0 = Companion_instance_83.fromConnection(item);
      destination.q(tmp$ret$0);
    }
    return new SerializableGuestConnectionsComponent(destination);
  };
  protoOf(Companion_84).fromJson = function (json) {
    return this.e2n_1.l15(this.l17(), json);
  };
  protoOf(Companion_84).l17 = function () {
    return $serializer_getInstance_11();
  };
  var Companion_instance_84;
  function Companion_getInstance_85() {
    if (Companion_instance_84 == null)
      new Companion_84();
    return Companion_instance_84;
  }
  function SerializableConnection(guestId, hostId, guestConnector, hostConnector) {
    this.guestId = guestId;
    this.hostId = hostId;
    this.guestConnector = guestConnector;
    this.hostConnector = hostConnector;
  }
  protoOf(SerializableConnection).f2n = function () {
    return this.guestId;
  };
  protoOf(SerializableConnection).g2n = function () {
    return this.hostId;
  };
  protoOf(SerializableConnection).p1v = function () {
    return this.guestConnector;
  };
  protoOf(SerializableConnection).r1v = function () {
    return this.hostConnector;
  };
  protoOf(SerializableConnection).af = function () {
    return this.guestId;
  };
  protoOf(SerializableConnection).bf = function () {
    return this.hostId;
  };
  protoOf(SerializableConnection).g1k = function () {
    return this.guestConnector;
  };
  protoOf(SerializableConnection).h1k = function () {
    return this.hostConnector;
  };
  protoOf(SerializableConnection).h2n = function (guestId, hostId, guestConnector, hostConnector) {
    return new SerializableConnection(guestId, hostId, guestConnector, hostConnector);
  };
  protoOf(SerializableConnection).copy = function (guestId, hostId, guestConnector, hostConnector, $super) {
    guestId = guestId === VOID ? this.guestId : guestId;
    hostId = hostId === VOID ? this.hostId : hostId;
    guestConnector = guestConnector === VOID ? this.guestConnector : guestConnector;
    hostConnector = hostConnector === VOID ? this.hostConnector : hostConnector;
    return this.h2n(guestId, hostId, guestConnector, hostConnector);
  };
  protoOf(SerializableConnection).toString = function () {
    return 'SerializableConnection(guestId=' + this.guestId + ', hostId=' + this.hostId + ', guestConnector=' + this.guestConnector + ', hostConnector=' + this.hostConnector + ')';
  };
  protoOf(SerializableConnection).hashCode = function () {
    var result = getStringHashCode(this.guestId);
    result = imul(result, 31) + getStringHashCode(this.hostId) | 0;
    result = imul(result, 31) + getStringHashCode(this.guestConnector) | 0;
    result = imul(result, 31) + getStringHashCode(this.hostConnector) | 0;
    return result;
  };
  protoOf(SerializableConnection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializableConnection))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableConnection ? other : THROW_CCE();
    if (!(this.guestId === tmp0_other_with_cast.guestId))
      return false;
    if (!(this.hostId === tmp0_other_with_cast.hostId))
      return false;
    if (!(this.guestConnector === tmp0_other_with_cast.guestConnector))
      return false;
    if (!(this.hostConnector === tmp0_other_with_cast.hostConnector))
      return false;
    return true;
  };
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.SerializableGuestConnectionsComponent', this, 2);
    tmp0_serialDesc.cv('connections', false);
    tmp0_serialDesc.cv('typeId', true);
    this.i2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).ok = function () {
    return this.i2n_1;
  };
  protoOf($serializer_11).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_85().d2n_1[0], IntSerializer_getInstance()];
  };
  protoOf($serializer_11).qk = function (decoder) {
    var tmp0_desc = this.i2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.nn(tmp0_desc);
    var tmp7_cached = Companion_getInstance_85().d2n_1;
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.sn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.sn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return SerializableGuestConnectionsComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_11).j2n = function (encoder, value) {
    var tmp0_desc = this.i2n_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_85().d2n_1;
    tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.connections);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.k2n_1 === 106)) {
      tmp1_output.xo(tmp0_desc, 1, value.k2n_1);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_11).pk = function (encoder, value) {
    return this.j2n(encoder, value instanceof SerializableGuestConnectionsComponent ? value : THROW_CCE());
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function SerializableGuestConnectionsComponent_init_$Init$(seen1, connections, typeId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_11().i2n_1);
    }
    $this.connections = connections;
    if (0 === (seen1 & 2))
      $this.k2n_1 = 106;
    else
      $this.k2n_1 = typeId;
    return $this;
  }
  function SerializableGuestConnectionsComponent_init_$Create$(seen1, connections, typeId, serializationConstructorMarker) {
    return SerializableGuestConnectionsComponent_init_$Init$(seen1, connections, typeId, serializationConstructorMarker, objectCreate(protoOf(SerializableGuestConnectionsComponent)));
  }
  function SerializableGuestConnectionsComponent(connections) {
    Companion_getInstance_85();
    this.connections = connections;
    this.k2n_1 = 106;
  }
  protoOf(SerializableGuestConnectionsComponent).d1w = function () {
    return this.connections;
  };
  protoOf(SerializableGuestConnectionsComponent).toJson = function (parse) {
    return Companion_getInstance_85().e2n_1.k15(Companion_getInstance_85().l17(), this);
  };
  protoOf(SerializableGuestConnectionsComponent).serializationKey = function () {
    return 'Connections';
  };
  protoOf(SerializableGuestConnectionsComponent).x1k = function () {
    return this.k2n_1;
  };
  protoOf(SerializableGuestConnectionsComponent).eq = function (other) {
    var that = unsafeCast(other);
    return equals(this.connections, that.connections);
  };
  function SerializableTree() {
  }
  function toJsonString(_this__u8e3s4) {
    return (new JsonSerializer(null)).toJsonString(_this__u8e3s4);
  }
  function Serializer() {
  }
  function Companion_85() {
  }
  protoOf(Companion_85).s1k = function () {
    return 25;
  };
  var Companion_instance_85;
  function Companion_getInstance_86() {
    return Companion_instance_85;
  }
  function UnserializableEntityComponent() {
  }
  protoOf(UnserializableEntityComponent).x1k = function () {
    return Companion_instance_85.id;
  };
  protoOf(UnserializableEntityComponent).eq = function (other) {
    return true;
  };
  function Companion_86() {
  }
  protoOf(Companion_86).l17 = function () {
    return $serializer_getInstance_12();
  };
  var Companion_instance_86;
  function Companion_getInstance_87() {
    return Companion_instance_86;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.VersionHeader', this, 1);
    tmp0_serialDesc.cv('version', false);
    this.n2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).ok = function () {
    return this.n2n_1;
  };
  protoOf($serializer_12).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_12).qk = function (decoder) {
    var tmp0_desc = this.n2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.nn(tmp0_desc);
    if (tmp5_input.do()) {
      tmp4_local0 = tmp5_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.on(tmp0_desc);
    return VersionHeader_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_12).o2n = function (encoder, value) {
    var tmp0_desc = this.n2n_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.version);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_12).pk = function (encoder, value) {
    return this.o2n(encoder, value instanceof VersionHeader ? value : THROW_CCE());
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function VersionHeader_init_$Init$(seen1, version, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_12().n2n_1);
    }
    $this.version = version;
    return $this;
  }
  function VersionHeader_init_$Create$(seen1, version, serializationConstructorMarker) {
    return VersionHeader_init_$Init$(seen1, version, serializationConstructorMarker, objectCreate(protoOf(VersionHeader)));
  }
  function VersionHeader(version) {
    this.version = version;
  }
  protoOf(VersionHeader).m2n = function () {
    return this.version;
  };
  protoOf(VersionHeader).af = function () {
    return this.version;
  };
  protoOf(VersionHeader).q1l = function (version) {
    return new VersionHeader(version);
  };
  protoOf(VersionHeader).copy = function (version, $super) {
    version = version === VOID ? this.version : version;
    return this.q1l(version);
  };
  protoOf(VersionHeader).toString = function () {
    return 'VersionHeader(version=' + this.version + ')';
  };
  protoOf(VersionHeader).hashCode = function () {
    return getStringHashCode(this.version);
  };
  protoOf(VersionHeader).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VersionHeader))
      return false;
    var tmp0_other_with_cast = other instanceof VersionHeader ? other : THROW_CCE();
    if (!(this.version === tmp0_other_with_cast.version))
      return false;
    return true;
  };
  function findCorrectEntityGroupOrderFromConnectionGraph($this, shadowEntity) {
    var childrenLeft = toMutableList(get_children(shadowEntity));
    // Inline function 'kotlin.collections.mutableListOf' call
    var childrenInOrder = ArrayList_init_$Create$();
    var index = 0;
    $l$loop: while (true) {
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!childrenLeft.b1()) {
        tmp = index < childrenLeft.n();
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      var child = childrenLeft.f1(index);
      Companion_getInstance_85();
      var connectionsComponents = child.__getComponentForKotlin(106);
      var tmp1_safe_receiver = connectionsComponents == null ? null : connectionsComponents.connections;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$2;
        $l$block_3: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(tmp1_safe_receiver, Collection)) {
            tmp_1 = tmp1_safe_receiver.b1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$2 = false;
            break $l$block_3;
          }
          var tmp0_iterator = tmp1_safe_receiver.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrderFromConnectionGraph.<anonymous>' call
            var hostId = toInt(element.hostId);
            var tmp$ret$3;
            $l$block_2: {
              // Inline function 'kotlin.collections.any' call
              var tmp_2;
              if (isInterface(childrenLeft, Collection)) {
                tmp_2 = childrenLeft.b1();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$3 = false;
                break $l$block_2;
              }
              var tmp0_iterator_0 = childrenLeft.t();
              while (tmp0_iterator_0.u()) {
                var element_0 = tmp0_iterator_0.w();
                // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrderFromConnectionGraph.<anonymous>.<anonymous>' call
                var tmp_3;
                if (element_0.id === hostId) {
                  tmp_3 = true;
                } else {
                  var tmp$ret$5;
                  $l$block_1: {
                    // Inline function 'kotlin.sequences.any' call
                    var tmp0_iterator_1 = hierarchyExceptSubTreesWithComponentSequence(element_0, 28).t();
                    while (tmp0_iterator_1.u()) {
                      var element_1 = tmp0_iterator_1.w();
                      // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrderFromConnectionGraph.<anonymous>.<anonymous>.<anonymous>' call
                      if (element_1.id === hostId) {
                        tmp$ret$5 = true;
                        break $l$block_1;
                      }
                    }
                    tmp$ret$5 = false;
                  }
                  tmp_3 = tmp$ret$5;
                }
                if (tmp_3) {
                  tmp$ret$3 = true;
                  break $l$block_2;
                }
              }
              tmp$ret$3 = false;
            }
            if (tmp$ret$3) {
              tmp$ret$2 = true;
              break $l$block_3;
            }
          }
          tmp$ret$2 = false;
        }
        tmp_0 = tmp$ret$2;
      }
      var tmp2_elvis_lhs = tmp_0;
      var hasAnyConnectionsToOther = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
      index = index + 1 | 0;
      if (!hasAnyConnectionsToOther) {
        childrenInOrder.q(child);
        childrenLeft.r(child);
        index = 0;
      }
    }
    return childrenInOrder;
  }
  function Companion_87() {
  }
  protoOf(Companion_87).findCorrectEntityGroupOrder = function (shadowEntity) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = get_children(shadowEntity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrder.<anonymous>' call
        Companion_getInstance_85();
        if (element.hasComponent(106)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    var hasNewConnectionsComponent = tmp$ret$1;
    var tmp;
    if (hasNewConnectionsComponent) {
      var orderOfChildren = findCorrectEntityGroupOrderFromConnectionGraph(this, shadowEntity);
      tmp = orderOfChildren;
    } else {
      var childrenLeft = toMutableList(get_children(shadowEntity));
      // Inline function 'kotlin.collections.mutableListOf' call
      var childrenInOrder = ArrayList_init_$Create$();
      var index = 0;
      $l$loop: while (true) {
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!childrenLeft.b1()) {
          tmp_0 = index < childrenLeft.n();
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          break $l$loop;
        }
        var child = childrenLeft.f1(index);
        var tmp_1 = ConnectionUtils_instance;
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$4 = copyToArray(childrenLeft);
        var hasPossibleGuestConnections = tmp_1.calculateAllConnectionsToHierarchies(child, tmp$ret$4);
        index = index + 1 | 0;
        // Inline function 'kotlin.collections.isEmpty' call
        if (hasPossibleGuestConnections.length === 0) {
          childrenInOrder.q(child);
          childrenLeft.r(child);
          index = 0;
        }
      }
      return childrenInOrder;
    }
    return tmp;
  };
  var Companion_instance_87;
  function Companion_getInstance_88() {
    return Companion_instance_87;
  }
  function ConnectionGraphBuildOrder() {
  }
  function EntityTreeBuilder$InterceptingAssemblyPartCatalog$productSpecification$lambda($productRef) {
    return function (it) {
      return get_productRef(it) === $productRef;
    };
  }
  function modifyAssemblyComponentsIfNeeded($this, idMap, specification, shadowEntity) {
    var tmp;
    var tmp_0;
    if (specification == null) {
      tmp_0 = null;
    } else {
      tmp_0 = specification.hasComponent(12);
    }
    if (tmp_0 === true) {
      var withoutUnlockedChildren = removeNonLockedPartsFromAssemblyStructure($this, specification);
      var withPartsMap = addPartsMap($this, shadowEntity, withoutUnlockedChildren);
      tmp = addIdsMap($this, shadowEntity, idMap, withPartsMap);
    } else {
      tmp = specification;
    }
    return tmp;
  }
  function removeNonLockedPartsFromAssemblyStructure($this, specification) {
    var tmp0_elvis_lhs = specification._findComponentKt(12);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return specification;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var assemblyStructureComponent = tmp;
    var newParts = removeLockedChildren($this, assemblyStructureComponent.parts);
    var tmp_0;
    if (!(newParts == null)) {
      tmp_0 = specification.addComponent(new AssemblyStructureComponent(newParts));
    } else {
      tmp_0 = specification;
    }
    return tmp_0;
  }
  function addPartsMap($this, shadowEntity, specification) {
    var partsMap = ProductCatalogFunctions_instance.getPartsMap(shadowEntity);
    var tmp;
    // Inline function 'kotlin.collections.isEmpty' call
    if (partsMap.length === 0) {
      tmp = specification;
    } else {
      tmp = specification.addComponent(AssemblyPartsComponent_init_$Create$(partsMap));
    }
    return tmp;
  }
  function removeLockedChildren($this, parts) {
    if (parts == null)
      return null;
    // Inline function 'kotlin.collections.isEmpty' call
    if (parts.length === 0) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = parts.length;
    while (inductionVariable < last) {
      var element = parts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.removeLockedChildren.<anonymous>' call
      var tmp;
      if (element.locked) {
        tmp = element.copy(VOID, VOID, VOID, removeLockedChildren(Companion_getInstance_89(), element.children));
      } else {
        tmp = null;
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    return copyToArray(destination);
  }
  function addIdsMap($this, entity, idMap, specification) {
    if (specification == null)
      return null;
    // Inline function 'kotlin.collections.mapValues' call
    var this_0 = Companion_instance.partIdsMapForEntity(entity, true);
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$(mapCapacity(this_0.n()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp = element.t2();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.addIdsMap.<anonymous>' call
      // Inline function 'kotlin.collections.component2' call
      var shadowId = element.u2();
      var tmp$ret$2 = idMap(shadowId);
      destination.r2(tmp, tmp$ret$2);
    }
    var partsMap = destination;
    var tmp_0;
    if (partsMap.b1()) {
      tmp_0 = specification;
    } else {
      tmp_0 = specification.addComponent(new AssemblyPartIdsComponent(partsMap));
    }
    return tmp_0;
  }
  function mapShadowIdToRealId($this, shadowId) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.entityIdMap;
    var value = this_0.b3(shadowId);
    var tmp;
    if (value == null) {
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.mapShadowIdToRealId.<anonymous>' call
      var answer = $this.p2n_1.getNextId();
      this_0.r2(shadowId, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function buildAutomaticGroupEntityTree($this, groupShadowRoot) {
    var tmp0_elvis_lhs = createEntityFromShadow($this, groupShadowRoot);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var root = tmp;
    var newEntitiesWithChildren = buildEntityTreeInternal$default($this, groupShadowRoot, null);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = newEntitiesWithChildren.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>' call
      setParentMaintainWorldTransform(element.newEntity, root);
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var hosts = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = newEntitiesWithChildren.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>' call
      if (any_0(hosts)) {
        var snapSettings = new SnapSettings(true, true, false, true);
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        var tmp_0 = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE;
        var tmp_1 = SnapUtils_instance;
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$1 = copyToArray(hosts);
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = tmp_0.sortAndSelect(tmp_1.matchingSnapActionCandidatesMultipleHosts(element_0.newEntity, tmp$ret$1, snapSettings));
        var destination = ArrayList_init_$Create$();
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element_1 = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>.<anonymous>' call
          if (element_1.movement.equals(Companion_getInstance_61().ZERO) ? element_1.deltaRotation.equals(Companion_getInstance_57().IDENTITY) : false) {
            destination.q(element_1);
          }
        }
        var candidates = copyToArray(destination);
        var validCandidate = $this.r2n_1.getFirstValidSnapAction(candidates, false).af();
        var tmp2_safe_receiver = validCandidate == null ? null : validCandidate.createAction();
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.perform();
        }
      }
      hosts.q(element_0.newEntity);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = element_0.children.t();
      while (tmp0_iterator_1.u()) {
        var element_2 = tmp0_iterator_1.w();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>.<anonymous>' call
        $this.buildEntityTree(element_2.shadowEntity, element_0.newEntity);
      }
    }
    var group = get_automaticEntityGroup(first(newEntitiesWithChildren).newEntity);
    if (group == null)
      null;
    else {
      setParent(group, null);
    }
    return group;
  }
  function hasAnyEntityWithSerializedConnections($this, shadowRoot) {
    var tmp = HierarchyUtils_instance;
    return !(tmp.findInHierarchy(shadowRoot, EntityTreeBuilder$hasAnyEntityWithSerializedConnections$lambda) == null);
  }
  function ShadowEntityWithParent(shadowEntity, parent, existingChild) {
    existingChild = existingChild === VOID ? null : existingChild;
    this.shadowEntity = shadowEntity;
    this.parent = parent;
    this.existingChild = existingChild;
  }
  protoOf(ShadowEntityWithParent).u2n = function () {
    return this.shadowEntity;
  };
  protoOf(ShadowEntityWithParent).z27 = function () {
    return this.parent;
  };
  protoOf(ShadowEntityWithParent).v2n = function () {
    return this.existingChild;
  };
  protoOf(ShadowEntityWithParent).af = function () {
    return this.shadowEntity;
  };
  protoOf(ShadowEntityWithParent).bf = function () {
    return this.parent;
  };
  protoOf(ShadowEntityWithParent).g1k = function () {
    return this.existingChild;
  };
  protoOf(ShadowEntityWithParent).w2n = function (shadowEntity, parent, existingChild) {
    return new ShadowEntityWithParent(shadowEntity, parent, existingChild);
  };
  protoOf(ShadowEntityWithParent).copy = function (shadowEntity, parent, existingChild, $super) {
    shadowEntity = shadowEntity === VOID ? this.shadowEntity : shadowEntity;
    parent = parent === VOID ? this.parent : parent;
    existingChild = existingChild === VOID ? this.existingChild : existingChild;
    return this.w2n(shadowEntity, parent, existingChild);
  };
  protoOf(ShadowEntityWithParent).toString = function () {
    return 'ShadowEntityWithParent(shadowEntity=' + this.shadowEntity + ', parent=' + this.parent + ', existingChild=' + this.existingChild + ')';
  };
  protoOf(ShadowEntityWithParent).hashCode = function () {
    var result = this.shadowEntity.hashCode();
    result = imul(result, 31) + (this.parent == null ? 0 : this.parent.hashCode()) | 0;
    result = imul(result, 31) + (this.existingChild == null ? 0 : this.existingChild.hashCode()) | 0;
    return result;
  };
  protoOf(ShadowEntityWithParent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShadowEntityWithParent))
      return false;
    var tmp0_other_with_cast = other instanceof ShadowEntityWithParent ? other : THROW_CCE();
    if (!this.shadowEntity.equals(tmp0_other_with_cast.shadowEntity))
      return false;
    if (!equals(this.parent, tmp0_other_with_cast.parent))
      return false;
    if (!equals(this.existingChild, tmp0_other_with_cast.existingChild))
      return false;
    return true;
  };
  function NewEntityWithShadowChildren(newEntity, children) {
    this.newEntity = newEntity;
    this.children = children;
  }
  protoOf(NewEntityWithShadowChildren).e1j = function () {
    return this.newEntity;
  };
  protoOf(NewEntityWithShadowChildren).c1k = function () {
    return this.children;
  };
  protoOf(NewEntityWithShadowChildren).af = function () {
    return this.newEntity;
  };
  protoOf(NewEntityWithShadowChildren).bf = function () {
    return this.children;
  };
  protoOf(NewEntityWithShadowChildren).x2n = function (newEntity, children) {
    return new NewEntityWithShadowChildren(newEntity, children);
  };
  protoOf(NewEntityWithShadowChildren).copy = function (newEntity, children, $super) {
    newEntity = newEntity === VOID ? this.newEntity : newEntity;
    children = children === VOID ? this.children : children;
    return this.x2n(newEntity, children);
  };
  protoOf(NewEntityWithShadowChildren).toString = function () {
    return 'NewEntityWithShadowChildren(newEntity=' + this.newEntity + ', children=' + this.children + ')';
  };
  protoOf(NewEntityWithShadowChildren).hashCode = function () {
    var result = this.newEntity.hashCode();
    result = imul(result, 31) + hashCode(this.children) | 0;
    return result;
  };
  protoOf(NewEntityWithShadowChildren).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NewEntityWithShadowChildren))
      return false;
    var tmp0_other_with_cast = other instanceof NewEntityWithShadowChildren ? other : THROW_CCE();
    if (!this.newEntity.equals(tmp0_other_with_cast.newEntity))
      return false;
    if (!equals(this.children, tmp0_other_with_cast.children))
      return false;
    return true;
  };
  function buildEntityTreeInternal($this, shadowRoot, parent, preCreated) {
    var tmp;
    if (get_isAutomaticGroup(shadowRoot)) {
      var theSecretOrderOfTheShadowChildren = findCorrectEntityGroupOrder($this, shadowRoot);
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = theSecretOrderOfTheShadowChildren.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
        element.removeComponentInternal(17);
        Companion_getInstance_107();
        element.removeComponentInternal(6);
        var list = buildEntityTreeInternal$default($this, element, parent);
        addAll(destination, list);
      }
      var newChildren = destination;
      tmp = newChildren;
    } else if (get_isManualGroup(shadowRoot)) {
      var theSecretOrderOfTheShadowChildren_0 = findCorrectEntityGroupOrder($this, shadowRoot);
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = theSecretOrderOfTheShadowChildren_0.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
        element_0.removeComponentInternal(17);
        Companion_getInstance_107();
        element_0.removeComponentInternal(6);
        var list_0 = buildEntityTreeInternal$default($this, element_0, parent);
        addAll(destination_0, list_0);
      }
      var newChildren_0 = destination_0;
      var tmp_0;
      if (any_0(newChildren_0)) {
        var existingEntityGroup = preCreated == null ? $this.p2n_1.createEntityInternal(mapShadowIdToRealId($this, shadowRoot.id)) : preCreated;
        var tmp_1 = Companion_getInstance_43();
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newChildren_0, 10));
        var tmp0_iterator_1 = newChildren_0.t();
        while (tmp0_iterator_1.u()) {
          var item = tmp0_iterator_1.w();
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
          var tmp$ret$6 = item.newEntity;
          destination_1.q(tmp$ret$6);
        }
        var tmp$ret$9 = copyToArray(destination_1);
        var groupParent = tmp_1.createManualEntityGroup(tmp$ret$9, existingEntityGroup, $this.p2n_1, $this.s2n_1);
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_2 = ArrayList_init_$Create$();
        var tmp0_iterator_2 = newChildren_0.t();
        while (tmp0_iterator_2.u()) {
          var element_1 = tmp0_iterator_2.w();
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
          var list_1 = element_1.children;
          addAll(destination_2, list_1);
        }
        tmp_0 = listOf(new NewEntityWithShadowChildren(groupParent, destination_2));
      } else {
        tmp_0 = newChildren_0;
      }
      tmp = tmp_0;
    } else {
      var newEntity = buildEntityTreeNode($this, shadowRoot, parent, preCreated);
      var tmp_2;
      if (newEntity == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
        tmp_2 = listOf(newEntity);
      }
      var tmp2_elvis_lhs = tmp_2;
      tmp = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
    }
    var newChildren_1 = tmp;
    return newChildren_1;
  }
  function buildEntityTreeInternal$default($this, shadowRoot, parent, preCreated, $super) {
    parent = parent === VOID ? null : parent;
    preCreated = preCreated === VOID ? null : preCreated;
    return buildEntityTreeInternal($this, shadowRoot, parent, preCreated);
  }
  function buildEntityTreeNode($this, shadowEntity, parent, preCreated) {
    var tmp;
    if (!(preCreated == null)) {
      tmp = preCreated;
    } else {
      var tmp0_elvis_lhs = createEntityFromShadow($this, shadowEntity);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var entity = tmp_0;
      repositionAndAddComponentsToPartsOfAssembly($this, entity, shadowEntity);
      addSerializedComponents($this, shadowEntity, entity);
      placeNewEntity($this, shadowEntity, entity, parent);
      tmp = entity;
    }
    var newEntity = tmp;
    var children = buildChildren($this, shadowEntity, newEntity);
    return new NewEntityWithShadowChildren(newEntity, children);
  }
  function buildEntityTreeNode$default($this, shadowEntity, parent, preCreated, $super) {
    parent = parent === VOID ? null : parent;
    preCreated = preCreated === VOID ? null : preCreated;
    return buildEntityTreeNode($this, shadowEntity, parent, preCreated);
  }
  function buildChildren($this, shadowEntity, newEntity) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = immediateNonPartDescendants($this, shadowEntity);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildChildren.<anonymous>' call
      var childParent = findParentAmongCreatedEntities($this, item, newEntity);
      // Inline function 'kotlin.collections.find' call
      var this_1 = get_children(newEntity);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = this_1.length;
        while (inductionVariable < last) {
          var element = this_1[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildChildren.<anonymous>.<anonymous>' call
          var mappedShadowId = mapShadowIdToRealId($this, item.id);
          if (element.id === mappedShadowId) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var existingChild = tmp$ret$1;
      var tmp;
      if (!(existingChild == null)) {
        existingChild.addComponent(new LocalTransformComponent(get_localTransform(item)));
        tmp = new ShadowEntityWithParent(item, childParent, existingChild);
      } else {
        tmp = new ShadowEntityWithParent(item, childParent);
      }
      var tmp$ret$3 = tmp;
      destination.q(tmp$ret$3);
    }
    var children = destination;
    return children;
  }
  function findParentAmongCreatedEntities($this, shadowChild, newEntity) {
    var tmp0_safe_receiver = get_childComponent(shadowChild);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id;
    var shadowParentId = tmp2_elvis_lhs == null ? newEntity.id : tmp2_elvis_lhs;
    var mappedShadowParentId = mapShadowIdToRealId($this, shadowParentId);
    // Inline function 'kotlin.sequences.find' call
    var this_0 = get_hierarchySequence(newEntity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.findParentAmongCreatedEntities.<anonymous>' call
        if (element.id === mappedShadowParentId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp3_elvis_lhs = tmp$ret$1;
    return tmp3_elvis_lhs == null ? newEntity : tmp3_elvis_lhs;
  }
  function repositionAndAddComponentsToPartsOfAssembly($this, newEntity, shadowEntity) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_descendants(newEntity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.repositionAndAddComponentsToPartsOfAssembly.<anonymous>' call
      var shadowVersion = findInHierarchy(shadowEntity, EntityTreeBuilder$repositionAndAddComponentsToPartsOfAssembly$lambda($this, element));
      if (!(shadowVersion == null)) {
        TransformUtils_instance.setWorldTransform(element, get_worldTransform(shadowVersion));
        addSerializedComponents($this, shadowVersion, element);
      }
    }
  }
  function immediateNonPartDescendants($this, entity) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = get_children(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.immediateNonPartDescendants.<anonymous>' call
      var list = !get_isProductPart(element) ? listOf(element) : immediateNonPartDescendants($this, element);
      addAll(destination, list);
    }
    return destination;
  }
  function createEntityFromShadow($this, shadowEntity) {
    var tmp;
    if (shadowEntity.hasComponent(18)) {
      tmp = recreateProduct($this, shadowEntity);
    } else {
      var entityId = mapShadowIdToRealId($this, shadowEntity.id);
      tmp = $this.p2n_1.createEntityInternal(entityId);
    }
    var newEntity = tmp;
    if (newEntity == null)
      null;
    else
      newEntity.addComponent(new LocalTransformComponent(get_worldTransform(shadowEntity)));
    if (newEntity == null)
      null;
    else
      newEntity.addComponent(new WorldTransformComponent(get_worldTransform(shadowEntity)));
    return newEntity;
  }
  function addSerializedComponents($this, shadowEntity, newEntity) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = shadowEntity.components();
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.addSerializedComponents.<anonymous>' call
      if (element.serializable ? true : contains(Companion_getInstance_89().y2n_1, element.typeId)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.addSerializedComponents.<anonymous>' call
      var tmp;
      var tmp_0;
      var tmp_1;
      var tmp_2 = element_0.typeId;
      Companion_getInstance_110();
      if (!(tmp_2 === 10)) {
        var tmp_3 = element_0.typeId;
        Companion_getInstance_107();
        tmp_1 = !(tmp_3 === 6);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp_4 = element_0.typeId;
        tmp_0 = !(tmp_4 === 16);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp_5 = element_0.typeId;
        tmp = !(tmp_5 === 17);
      } else {
        tmp = false;
      }
      if (tmp) {
        destination_0.q(element_0);
      }
    }
    var tmp0_iterator_0 = destination_0.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.addSerializedComponents.<anonymous>' call
      newEntity.addComponent(element_1);
    }
  }
  function placeNewEntity($this, shadowEntity, newEntity, parent) {
    var hasShadowParent = !(get_parent(shadowEntity) == null);
    if (hasShadowParent ? true : !(parent == null)) {
      Companion_getInstance_85();
      var hadConnectionBefore = shadowEntity.hasComponent(106);
      var shouldResnap = ($this.t2n_1 ? hadConnectionBefore : false) ? true : !$this.t2n_1;
      if (shouldResnap) {
        resnapNewEntity($this, hasShadowParent, newEntity, parent);
      } else {
        setParentMaintainWorldTransform(newEntity, parent);
      }
    } else if (!get_localTransform(shadowEntity).rotation.isIdentity ? true : !get_localTransform(shadowEntity).position.isZero()) {
      newEntity.addComponent(new LocalTransformComponent(get_localTransform(shadowEntity)));
    }
  }
  function resnapNewEntity($this, hasShadowParent, newEntity, parent) {
    var candidates = findSnapsForNewEntity($this, hasShadowParent, newEntity, parent);
    var tmp;
    if (candidates == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp = !(candidates.length === 0);
    }
    if (tmp === true) {
      var validCandidate = $this.r2n_1.getFirstValidSnapAction(candidates, false).af();
      if (!(validCandidate == null)) {
        validCandidate.createAction().perform();
      } else {
        var tmp_0 = Companion_getInstance_89().logger;
        tmp_0.warn(EntityTreeBuilder$resnapNewEntity$lambda(newEntity));
        first_0(candidates).createAction().perform();
      }
    } else {
      setParentMaintainWorldTransform(newEntity, parent);
    }
  }
  function findSnapsForNewEntity($this, hasShadowParent, newEntity, parent) {
    var hasShadowParentSnapSettings = new SnapSettings(true, true, true, true);
    var nonNullParentSettings = new SnapSettings(true, true, false, true);
    var tmp;
    if (hasShadowParent ? !(parent == null) : false) {
      tmp = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(newEntity, parent, hasShadowParentSnapSettings));
    } else if (!(parent == null)) {
      var tmp_0 = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE;
      var tmp_1 = SnapUtils_instance;
      // Inline function 'kotlin.collections.plus' call
      var this_0 = get_upwardsHierarchy(parent);
      var elements = get_descendants(parent);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = this_0.concat(elements);
      tmp = tmp_0.sortAndSelect(tmp_1.matchingSnapActionCandidatesMultipleHosts(newEntity, tmp$ret$1, nonNullParentSettings));
    } else {
      tmp = null;
    }
    return tmp;
  }
  function recreateProduct($this, shadowEntity) {
    var specification = $this.q2n_1.productSpecification(get_productRefOrEmptyString(shadowEntity));
    var tmp = Companion_getInstance_89();
    var refinedSpecification = modifyAssemblyComponentsIfNeeded(tmp, EntityTreeBuilder$mapShadowIdToRealId$ref($this), specification, shadowEntity);
    var interceptorCatalog = new InterceptingAssemblyPartCatalog(shadowEntity, $this.q2n_1, EntityTreeBuilder$mapShadowIdToRealId$ref_0($this));
    $this.q2n_1.addCatalog(interceptorCatalog);
    var tmp_0;
    if (refinedSpecification == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>' call
      var entityId = mapShadowIdToRealId($this, shadowEntity.id);
      var product = $this.q2n_1.createFromSpecification(get_productRefOrEmptyString(shadowEntity), refinedSpecification, entityId);
      var tmp1_safe_receiver = product == null ? null : get_descendants(product);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
          Companion_getInstance_6();
          if (!element.hasComponent(44)) {
            destination.q(element);
          }
        }
        tmp_1 = destination;
      }
      var tmp2_safe_receiver = tmp_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = tmp2_safe_receiver.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
          $this.p2n_1.disposeEntity(element_0);
        }
      }
      $this.q2n_1.removeCatalog(interceptorCatalog);
      var tmp4_safe_receiver = product == null ? null : get_hierarchySequence(product);
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.sequences.forEach' call
        var tmp0_iterator_0 = tmp4_safe_receiver.t();
        while (tmp0_iterator_0.u()) {
          var element_1 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
          element_1.removeComponent(96);
        }
      }
      tmp_0 = product;
    }
    return tmp_0;
  }
  function InterceptingAssemblyPartCatalog(currentProductRoot, productManager, idMapper) {
    this.currentProductRoot = currentProductRoot;
    this.productManager = productManager;
    this.idMapper = idMapper;
    this.z2n_1 = true;
    this.a2o_1 = false;
  }
  protoOf(InterceptingAssemblyPartCatalog).a1m = function () {
    return this.z2n_1;
  };
  protoOf(InterceptingAssemblyPartCatalog).productSpecification = function (productRef) {
    if (this.a2o_1) {
      return null;
    }
    var tmp0_elvis_lhs = findInHierarchy(this.currentProductRoot, EntityTreeBuilder$InterceptingAssemblyPartCatalog$productSpecification$lambda(productRef));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entityToCreate = tmp;
    this.a2o_1 = true;
    var specification = this.productManager.productSpecification(productRef);
    this.a2o_1 = false;
    return modifyAssemblyComponentsIfNeeded(Companion_getInstance_89(), this.idMapper, specification, entityToCreate);
  };
  protoOf(InterceptingAssemblyPartCatalog).rangeId = function () {
    return 'InterceptingAssemblyPartCatalog';
  };
  protoOf(InterceptingAssemblyPartCatalog).rangeVersion = function () {
    return '1.0';
  };
  protoOf(InterceptingAssemblyPartCatalog).toString = function () {
    return this.rangeId() + this.rangeVersion();
  };
  protoOf(InterceptingAssemblyPartCatalog).allProductRefs = function () {
    // Inline function 'kotlin.emptyArray' call
    return [];
  };
  function findCorrectEntityGroupOrder($this, shadowEntity) {
    return Companion_instance_87.findCorrectEntityGroupOrder(shadowEntity);
  }
  function Companion_88() {
    Companion_instance_88 = this;
    this.logger = LoggerState_getInstance().m1m('EntityTreeBuilder');
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2n_1 = [41, 100];
  }
  protoOf(Companion_88).x1i = function () {
    return this.logger;
  };
  var Companion_instance_88;
  function Companion_getInstance_89() {
    if (Companion_instance_88 == null)
      new Companion_88();
    return Companion_instance_88;
  }
  function EntityTreeBuilder$hasAnyEntityWithSerializedConnections$lambda(it) {
    Companion_getInstance_85();
    return it.hasComponent(106);
  }
  function EntityTreeBuilder$repositionAndAddComponentsToPartsOfAssembly$lambda(this$0, $newEntityPart) {
    return function (shadowEntity) {
      var mappedShadowId = mapShadowIdToRealId(this$0, shadowEntity.id);
      return mappedShadowId === $newEntityPart.id;
    };
  }
  function EntityTreeBuilder$resnapNewEntity$lambda($newEntity) {
    return function () {
      return 'Could not find a valid snap, for ' + $newEntity + ' with product ref ' + get_productRefOrEmptyString($newEntity) + ', when rebuilding scene. Will use the first non valid snap.';
    };
  }
  function EntityTreeBuilder$mapShadowIdToRealId$ref($boundThis) {
    var l = function (p0) {
      return mapShadowIdToRealId($boundThis, p0);
    };
    l.callableName = 'mapShadowIdToRealId';
    return l;
  }
  function EntityTreeBuilder$mapShadowIdToRealId$ref_0($boundThis) {
    var l = function (p0) {
      return mapShadowIdToRealId($boundThis, p0);
    };
    l.callableName = 'mapShadowIdToRealId';
    return l;
  }
  function EntityTreeBuilder(entityManager, productManager, validationService, sceneManager) {
    Companion_getInstance_89();
    this.p2n_1 = entityManager;
    this.q2n_1 = productManager;
    this.r2n_1 = validationService;
    this.s2n_1 = sceneManager;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.entityIdMap = LinkedHashMap_init_$Create$_0();
    this.t2n_1 = false;
  }
  protoOf(EntityTreeBuilder).b2o = function () {
    return this.entityIdMap;
  };
  protoOf(EntityTreeBuilder).c2o = function (shadowRoot, parent) {
    this.t2n_1 = hasAnyEntityWithSerializedConnections(this, shadowRoot);
    if (get_isAutomaticGroup(shadowRoot))
      return buildAutomaticGroupEntityTree(this, shadowRoot);
    // Inline function 'kotlin.collections.mutableListOf' call
    var remainingToBuild = ArrayList_init_$Create$();
    remainingToBuild.q(new ShadowEntityWithParent(shadowRoot, parent));
    var root = null;
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!remainingToBuild.b1()) {
        break $l$loop;
      }
      var next = removeFirst(remainingToBuild);
      var newEntitiesWithChildren = buildEntityTreeInternal$default(this, next.shadowEntity, next.parent);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = newEntitiesWithChildren.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTree.<anonymous>' call
        remainingToBuild.x(element.children);
      }
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!newEntitiesWithChildren.b1()) {
        tmp = root == null;
      } else {
        tmp = false;
      }
      if (tmp) {
        root = newEntitiesWithChildren.f1(0).newEntity;
      }
    }
    return root;
  };
  protoOf(EntityTreeBuilder).buildEntityTree = function (shadowRoot, parent, $super) {
    parent = parent === VOID ? null : parent;
    return this.c2o(shadowRoot, parent);
  };
  function Companion_89() {
    Companion_instance_89 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2o_1 = [null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance())];
  }
  protoOf(Companion_89).l17 = function () {
    return $serializer_getInstance_13();
  };
  var Companion_instance_89;
  function Companion_getInstance_90() {
    if (Companion_instance_89 == null)
      new Companion_89();
    return Companion_instance_89;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.v13.SerializableEntityV13', this, 5);
    tmp0_serialDesc.cv('id', true);
    tmp0_serialDesc.cv('ref', true);
    tmp0_serialDesc.cv('parent', true);
    tmp0_serialDesc.cv('needsResnap', true);
    tmp0_serialDesc.cv('c', true);
    this.e2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).ok = function () {
    return this.e2o_1;
  };
  protoOf($serializer_13).rv = function () {
    var tmp0_cached = Companion_getInstance_90().d2o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[4])];
  };
  protoOf($serializer_13).qk = function (decoder) {
    var tmp0_desc = this.e2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp10_input = decoder.nn(tmp0_desc);
    var tmp11_cached = Companion_getInstance_90().d2o_1;
    if (tmp10_input.do()) {
      tmp4_local0 = tmp10_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.pn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.bo(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.pn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.bo(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.on(tmp0_desc);
    return SerializableEntityV13_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_13).f2o = function (encoder, value) {
    var tmp0_desc = this.e2o_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_90().d2o_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.g2o_1 === 'N/A')) {
      tmp1_output.cp(tmp0_desc, 0, value.g2o_1);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.h2o_1 === '')) {
      tmp1_output.cp(tmp0_desc, 1, value.h2o_1);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.i2o_1 == null)) {
      tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.i2o_1);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.needsResnap === false)) {
      tmp1_output.uo(tmp0_desc, 3, value.needsResnap);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.j2o_1 == null)) {
      tmp1_output.gp(tmp0_desc, 4, tmp2_cached[4], value.j2o_1);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_13).pk = function (encoder, value) {
    return this.f2o(encoder, value instanceof SerializableEntityV13 ? value : THROW_CCE());
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function SerializableEntityV13_init_$Init$(seen1, id, ref, parent, needsResnap, serializedComponents, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_13().e2o_1);
    }
    if (0 === (seen1 & 1))
      $this.g2o_1 = 'N/A';
    else
      $this.g2o_1 = id;
    if (0 === (seen1 & 2))
      $this.h2o_1 = '';
    else
      $this.h2o_1 = ref;
    if (0 === (seen1 & 4))
      $this.i2o_1 = null;
    else
      $this.i2o_1 = parent;
    if (0 === (seen1 & 8))
      $this.needsResnap = false;
    else
      $this.needsResnap = needsResnap;
    if (0 === (seen1 & 16))
      $this.j2o_1 = null;
    else
      $this.j2o_1 = serializedComponents;
    $this.k2o_1 = null;
    return $this;
  }
  function SerializableEntityV13_init_$Create$(seen1, id, ref, parent, needsResnap, serializedComponents, serializationConstructorMarker) {
    return SerializableEntityV13_init_$Init$(seen1, id, ref, parent, needsResnap, serializedComponents, serializationConstructorMarker, objectCreate(protoOf(SerializableEntityV13)));
  }
  function init$add(base, $parse, c) {
    var serializable = unsafeCast(c);
    // Inline function 'kotlin.collections.set' call
    var key = serializable.serializationKey();
    var value = serializable.toJson($parse);
    base.r2(key, value);
  }
  function SerializableEntityV13() {
    Companion_getInstance_90();
    this.g2o_1 = 'N/A';
    this.h2o_1 = '';
    this.i2o_1 = null;
    this.needsResnap = false;
    this.j2o_1 = null;
    this.k2o_1 = null;
  }
  protoOf(SerializableEntityV13).u2m = function (_set____db54di) {
    this.g2o_1 = _set____db54di;
  };
  protoOf(SerializableEntityV13).s1k = function () {
    return this.g2o_1;
  };
  protoOf(SerializableEntityV13).v2m = function (_set____db54di) {
    this.h2o_1 = _set____db54di;
  };
  protoOf(SerializableEntityV13).w2m = function () {
    return this.h2o_1;
  };
  protoOf(SerializableEntityV13).x2m = function (_set____db54di) {
    this.i2o_1 = _set____db54di;
  };
  protoOf(SerializableEntityV13).z27 = function () {
    return this.i2o_1;
  };
  protoOf(SerializableEntityV13).l2o = function (_set____db54di) {
    this.needsResnap = _set____db54di;
  };
  protoOf(SerializableEntityV13).m2o = function () {
    return this.needsResnap;
  };
  protoOf(SerializableEntityV13).y2m = function (_set____db54di) {
    this.j2o_1 = _set____db54di;
  };
  protoOf(SerializableEntityV13).z2m = function () {
    return this.j2o_1;
  };
  protoOf(SerializableEntityV13).a2n = function (_set____db54di) {
    this.k2o_1 = _set____db54di;
  };
  protoOf(SerializableEntityV13).j1m = function () {
    return this.k2o_1;
  };
  protoOf(SerializableEntityV13).init = function (entity, parse) {
    this.g2o_1 = entity.id.toString();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var base = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = entity.components();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityV13.init.<anonymous>' call
      if (element.serializable) {
        init$add(base, parse, element);
      } else {
        var tmp = element.typeId;
        if (tmp === 18) {
          var tmp_0 = this;
          tmp_0.h2o_1 = (element instanceof ProductComponent ? element : THROW_CCE()).productRef;
        }
      }
    }
    this.j2o_1 = base;
  };
  protoOf(SerializableEntityV13).setParent = function (parent, needsResnap) {
    this.i2o_1 = parent.id.toString();
    this.needsResnap = needsResnap;
  };
  function deserializeComponentsForEntity($this, entityDO, serializers) {
    var tmp0_safe_receiver = entityDO.j2o_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = tmp0_safe_receiver.q2().t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.serialization.v13.SerializableTreeV13.deserializeComponentsForEntity.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.t2();
        // Inline function 'kotlin.collections.component2' call
        var value = element.u2();
        var tmp0_safe_receiver_0 = deserializeComponent($this, key, value, serializers);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver_0);
        }
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    var components = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    var tmp_0 = entityDO;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = copyToArray(components);
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$11 = [new PreviouslySerializedIdComponent(entityDO.g2o_1)];
    tmp_0.k2o_1 = this_0.concat(tmp$ret$11);
  }
  function deserializeComponent($this, key, json, serializers) {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = serializers.length;
      while (inductionVariable < last) {
        var element = serializers[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.v13.SerializableTreeV13.deserializeComponent.<anonymous>' call
        if (element.canHandle(key)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var found = tmp$ret$1;
    if (found == null) {
      var tmp = Companion_getInstance_91().logger;
      tmp.warn(SerializableTreeV13$deserializeComponent$lambda(key));
    }
    return found == null ? null : found.deserialize(key, json);
  }
  function Companion_90() {
    Companion_instance_90 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2m_1 = [new ArrayListSerializer($serializer_getInstance_13()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), null];
    this.logger = LoggerState_getInstance().m1m('SerializableTreeV13');
  }
  protoOf(Companion_90).buildTreeAndSerialize = function (roots, productManager) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filterNot' call
    // Inline function 'kotlin.collections.filterNotTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = roots.length;
    while (inductionVariable < last) {
      var element = roots[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.Companion.buildTreeAndSerialize.<anonymous>' call
      if (!element.hasComponent(Companion_instance_85.id)) {
        destination.q(element);
      }
    }
    var cleanedEntities = copyToArray(destination);
    var serializableEntities = Companion_getInstance_92().serializeForest(cleanedEntities);
    var serializableCatalogs = Companion_getInstance_92().serializeCatalogs(productManager);
    return Companion_getInstance_82().StrictPretty.i15(this.l17(), new SerializableTreeV13(toMutableList_0(serializableEntities), serializableCatalogs));
  };
  protoOf(Companion_90).x1i = function () {
    return this.logger;
  };
  protoOf(Companion_90).l17 = function () {
    return $serializer_getInstance_14();
  };
  var Companion_instance_90;
  function Companion_getInstance_91() {
    if (Companion_instance_90 == null)
      new Companion_90();
    return Companion_instance_90;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.v13.SerializableTreeV13', this, 3);
    tmp0_serialDesc.cv('entities', true);
    tmp0_serialDesc.cv('catalogs', false);
    tmp0_serialDesc.cv('version', true);
    this.n2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).ok = function () {
    return this.n2o_1;
  };
  protoOf($serializer_14).rv = function () {
    var tmp0_cached = Companion_getInstance_91().o2m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], StringSerializer_getInstance()];
  };
  protoOf($serializer_14).qk = function (decoder) {
    var tmp0_desc = this.n2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    var tmp9_cached = Companion_getInstance_91().o2m_1;
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.zn(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zn(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return SerializableTreeV13_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_14).o2o = function (encoder, value) {
    var tmp0_desc = this.n2o_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_91().o2m_1;
    var tmp;
    if (tmp1_output.kp(tmp0_desc, 0)) {
      tmp = true;
    } else {
      var tmp_0 = value.p2o_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$0 = ArrayList_init_$Create$();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.p2o_1);
    }
    tmp1_output.ep(tmp0_desc, 1, tmp2_cached[1], value.catalogs);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.r2o_1 === '1.3')) {
      tmp1_output.cp(tmp0_desc, 2, value.r2o_1);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_14).pk = function (encoder, value) {
    return this.o2o(encoder, value instanceof SerializableTreeV13 ? value : THROW_CCE());
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function SerializableTreeV13_init_$Init$(seen1, entities, catalogs, version, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen1))) {
      throwMissingFieldException(seen1, 2, $serializer_getInstance_14().n2o_1);
    }
    if (0 === (seen1 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp.p2o_1 = ArrayList_init_$Create$();
    } else
      $this.p2o_1 = entities;
    $this.catalogs = catalogs;
    var tmp_0 = $this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.q2o_1 = [];
    if (0 === (seen1 & 4))
      $this.r2o_1 = '1.3';
    else
      $this.r2o_1 = version;
    return $this;
  }
  function SerializableTreeV13_init_$Create$(seen1, entities, catalogs, version, serializationConstructorMarker) {
    return SerializableTreeV13_init_$Init$(seen1, entities, catalogs, version, serializationConstructorMarker, objectCreate(protoOf(SerializableTreeV13)));
  }
  function SerializableTreeV13$deserializeComponent$lambda($key) {
    return function () {
      return 'There is no deserializer for ' + $key;
    };
  }
  function SerializableTreeV13$removeEntity$lambda($id) {
    return function (it) {
      return it.g2o_1 === $id;
    };
  }
  function SerializableTreeV13(entities, catalogs) {
    Companion_getInstance_91();
    var tmp;
    if (entities === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = entities;
    }
    entities = tmp;
    this.p2o_1 = entities;
    this.catalogs = catalogs;
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.q2o_1 = [];
    this.r2o_1 = '1.3';
  }
  protoOf(SerializableTreeV13).s2o = function (_set____db54di) {
    this.p2o_1 = _set____db54di;
  };
  protoOf(SerializableTreeV13).o24 = function () {
    return this.p2o_1;
  };
  protoOf(SerializableTreeV13).d1m = function () {
    return this.catalogs;
  };
  protoOf(SerializableTreeV13).l2n = function () {
    return this.q2o_1;
  };
  protoOf(SerializableTreeV13).m2n = function () {
    return this.r2o_1;
  };
  protoOf(SerializableTreeV13).deserializeComponents = function (coreServices) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.p2o_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializableTreeV13.deserializeComponents.<anonymous>' call
      deserializeComponentsForEntity(this, element, coreServices.componentDeserializerRegistry.componentSerializers);
      element.j2o_1 = null;
    }
  };
  protoOf(SerializableTreeV13).afterDeserialized = function (coreServices) {
    var serializer = new SerializerV13(coreServices.entityManager, coreServices.productManager);
    this.q2o_1 = serializer.rebuildEntities(this.p2o_1);
  };
  protoOf(SerializableTreeV13).afterRebuildTree = function (root, coreServices) {
    Companion_getInstance_92().cleanUp(root);
  };
  protoOf(SerializableTreeV13).removeEntity = function (id) {
    var tmp = this.p2o_1;
    removeAll(tmp, SerializableTreeV13$removeEntity$lambda(id));
  };
  protoOf(SerializableTreeV13).af = function () {
    return this.p2o_1;
  };
  protoOf(SerializableTreeV13).bf = function () {
    return this.catalogs;
  };
  protoOf(SerializableTreeV13).t2o = function (entities, catalogs) {
    return new SerializableTreeV13(entities, catalogs);
  };
  protoOf(SerializableTreeV13).copy = function (entities, catalogs, $super) {
    entities = entities === VOID ? this.p2o_1 : entities;
    catalogs = catalogs === VOID ? this.catalogs : catalogs;
    return this.t2o(entities, catalogs);
  };
  protoOf(SerializableTreeV13).toString = function () {
    return 'SerializableTreeV13(entities=' + this.p2o_1 + ', catalogs=' + this.catalogs + ')';
  };
  protoOf(SerializableTreeV13).hashCode = function () {
    var result = hashCode(this.p2o_1);
    result = imul(result, 31) + hashCode(this.catalogs) | 0;
    return result;
  };
  protoOf(SerializableTreeV13).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializableTreeV13))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableTreeV13 ? other : THROW_CCE();
    if (!equals(this.p2o_1, tmp0_other_with_cast.p2o_1))
      return false;
    if (!equals(this.catalogs, tmp0_other_with_cast.catalogs))
      return false;
    return true;
  };
  function createSerializableEntitiesWithRelations($this, entity, parentProductRoot) {
    var realParent = get_parent(entity);
    var needsResnap = !equals(realParent, parentProductRoot);
    Companion_getInstance_18();
    var tmp0_safe_receiver = entity.__getComponentForKotlin(104);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
      entity.addComponentInternal(Companion_getInstance_85().fromConnectionsComponent(tmp0_safe_receiver));
    }
    // Inline function 'kotlin.apply' call
    var this_0 = new SerializableEntityV13();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
    this_0.init(entity, Json$parseToJsonElement$ref(Companion_getInstance_82().NonStrictPretty));
    var currentSerializedEntity = this_0;
    if (!(parentProductRoot == null)) {
      currentSerializedEntity.setParent(parentProductRoot, needsResnap);
    }
    Companion_getInstance_85();
    entity.removeComponentInternal(106);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_1 = get_children(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_1.length;
    while (inductionVariable < last) {
      var element = this_1[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
      var list = createSerializableEntitiesWithRelations(Companion_getInstance_92(), element, entity);
      addAll(destination, list);
    }
    var children = destination;
    return plus_1(children, new Pair(entity, currentSerializedEntity));
  }
  function Json$parseToJsonElement$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.m15(p0);
    };
    l.callableName = 'parseToJsonElement';
    return l;
  }
  function SerializerV13$Companion$cleanUp$lambda(it) {
    Companion_getInstance_85();
    it.removeComponentInternal(106);
    return Unit_instance;
  }
  function deserializeId($this, stringId) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.entityIdMapper;
    var value = this_0.b3(stringId);
    var tmp;
    if (value == null) {
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.deserializeId.<anonymous>' call
      var answer = $this.u2o_1.getNextId();
      this_0.r2(stringId, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function ProductRefLevel(ref, level) {
    this.ref = ref;
    this.level = level;
  }
  protoOf(ProductRefLevel).w2o = function (ref, level) {
    return new ProductRefLevel(ref, level);
  };
  protoOf(ProductRefLevel).copy = function (ref, level, $super) {
    ref = ref === VOID ? this.ref : ref;
    level = level === VOID ? this.level : level;
    return this.w2o(ref, level);
  };
  protoOf(ProductRefLevel).toString = function () {
    return 'ProductRefLevel(ref=' + this.ref + ', level=' + this.level + ')';
  };
  protoOf(ProductRefLevel).hashCode = function () {
    var result = getStringHashCode(this.ref);
    result = imul(result, 31) + this.level | 0;
    return result;
  };
  protoOf(ProductRefLevel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductRefLevel))
      return false;
    var tmp0_other_with_cast = other instanceof ProductRefLevel ? other : THROW_CCE();
    if (!(this.ref === tmp0_other_with_cast.ref))
      return false;
    if (!(this.level === tmp0_other_with_cast.level))
      return false;
    return true;
  };
  function extractAssemblyParts($this, entityDOs, components) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var parts = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var childToParentMap = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var parentToChildMap = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = entityDOs.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.<anonymous>' call
      var tmp0_safe_receiver = element.i2o_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var parentId = deserializeId($this, tmp0_safe_receiver);
        var entityId = deserializeId($this, element.g2o_1);
        // Inline function 'kotlin.collections.set' call
        childToParentMap.r2(entityId, parentId);
        // Inline function 'kotlin.collections.getOrPut' call
        var value = parentToChildMap.b3(parentId);
        var tmp;
        if (value == null) {
          // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.mutableSetOf' call
          var answer = LinkedHashSet_init_$Create$();
          parentToChildMap.r2(parentId, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        tmp.q(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator_0 = entityDOs.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.<anonymous>' call
      if (element_0.i2o_1 == null) {
        destination.q(element_0);
      }
    }
    var tmp0_iterator_1 = destination.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.<anonymous>' call
      extractAssemblyParts$checkComponents($this, parentToChildMap, components, childToParentMap, entityDOs, parts, element_1);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(parts.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = parts.q2().t();
    while (tmp0_iterator_2.u()) {
      var item = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.<anonymous>' call
      var tmp_0 = item.t2();
      // Inline function 'kotlin.collections.map' call
      var this_0 = item.u2();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(this_0.n());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_3 = this_0.q2().t();
      while (tmp0_iterator_3.u()) {
        var item_0 = tmp0_iterator_3.w();
        // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.<anonymous>.<anonymous>' call
        var tmp$ret$12 = new Pair(item_0.t2(), item_0.u2().ref);
        destination_1.q(tmp$ret$12);
      }
      var tmp$ret$15 = new Pair(tmp_0, new AssemblyPartsComponent(toMap(destination_1)));
      destination_0.q(tmp$ret$15);
    }
    return toMap(destination_0);
  }
  function createEntity_0($this, entityDO, partKeyComponents, assemblyParts) {
    var entity = createProductWithoutProductRootChildren($this, entityDO, $this.v2o_1, partKeyComponents, assemblyParts);
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = entityDO.h2o_1;
    if (charSequenceLength(this_0) > 0) {
      tmp = entity == null;
    } else {
      tmp = false;
    }
    if (tmp) {
      throw IllegalStateException_init_$Create$('Tried loading entity ' + entityDO.g2o_1 + ' with reference that is not present in catalog, product reference ' + entityDO.h2o_1);
    }
    if (entity == null ? entityDO.h2o_1 === '' : false) {
      var entityId = deserializeId($this, entityDO.g2o_1);
      entity = $this.u2o_1.createEntityInternal(entityId);
    }
    var tmp0_safe_receiver = entity;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.createEntity.<anonymous>' call
      tmp_0 = new EntityAndDO(tmp0_safe_receiver, entityDO);
    }
    return tmp_0;
  }
  function asList_0($this, entityDO) {
    var tmp0_safe_receiver = entityDO.k2o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : asList(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function addComponents($this, entityAndDO, components) {
    if (components == null)
      null;
    else {
      // Inline function 'kotlin.collections.onEach' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.onEach.<anonymous>' call
      var tmp0_iterator = components.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.serialization.v13.SerializerV13.addComponents.<anonymous>' call
        if (element instanceof SerializableGuestConnectionsComponent) {
          // Inline function 'kotlin.collections.map' call
          var this_0 = element.connections;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
          var tmp0_iterator_0 = this_0.t();
          while (tmp0_iterator_0.u()) {
            var item = tmp0_iterator_0.w();
            // Inline function 'com.ikea.core.serialization.v13.SerializerV13.addComponents.<anonymous>.<anonymous>' call
            var tmp$ret$0 = item.copy(deserializeId($this, item.guestId).toString(), deserializeId($this, item.hostId).toString());
            destination.q(tmp$ret$0);
          }
          var newConnections = destination;
          $this.u2o_1.addComponent(entityAndDO.entity, new SerializableGuestConnectionsComponent(newConnections));
        } else {
          $this.u2o_1.addComponent(entityAndDO.entity, element);
        }
      }
    }
  }
  function fixProductPartComponents($this, entity, connectionRoot, partKeyComponents) {
    var tmp;
    if (!(connectionRoot == null)) {
      Companion_getInstance_6();
      tmp = entity.hasComponent(44);
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = entity.components();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.v13.SerializerV13.fixProductPartComponents.<anonymous>' call
        var tmp_0;
        var tmp_1;
        var tmp_2;
        var tmp_3;
        if (!element.serializable) {
          var tmp_4 = element.typeId;
          tmp_3 = !(tmp_4 === 16);
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          var tmp_5 = element.typeId;
          tmp_2 = !(tmp_5 === 17);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = !(element.typeId === Companion_instance_73.id);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp_6 = element.typeId;
          Companion_getInstance_107();
          tmp_0 = !(tmp_6 === 6);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          entity.removeComponentInternal(element.typeId);
        }
      }
      var toAdd = partKeyComponents.b3(new EntityPartKey(connectionRoot.id, ensureNotNull(get_partKey(entity))));
      if (toAdd == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = toAdd.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.serialization.v13.SerializerV13.fixProductPartComponents.<anonymous>' call
          if (!entity.hasComponent(element_0.typeId)) {
            entity.addComponent(element_0);
          }
        }
      }
    }
    var tmp_7;
    if (entity.hasComponent(28)) {
      tmp_7 = entity;
    } else {
      tmp_7 = connectionRoot;
    }
    var meRoot = tmp_7;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = get_children(entity);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_1 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.fixProductPartComponents.<anonymous>' call
      if (!element_1.isDisposed) {
        fixProductPartComponents($this, element_1, meRoot, partKeyComponents);
      }
    }
  }
  function buildProductRootHierarchy($this, entityAndDO, entities) {
    var entity = entityAndDO.af();
    var serializableEntity = entityAndDO.bf();
    var tmp1_elvis_lhs = serializableEntity.i2o_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentId = tmp;
    var deserializedParentID = deserializeId($this, parentId);
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = entities.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.serialization.v13.SerializerV13.buildProductRootHierarchy.<anonymous>' call
        if (element.id === deserializedParentID) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp2_safe_receiver = tmp$ret$1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.buildProductRootHierarchy.<anonymous>' call
      setParentMaintainWorldTransform(entity, tmp2_safe_receiver);
      var tmp0_safe_receiver = get_parentComponent(tmp2_safe_receiver);
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.addChild(entity);
      var tmp_0;
      if (tmp1_elvis_lhs_0 == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [entity];
        tmp_0 = new ParentComponent(tmp$ret$5);
      } else {
        tmp_0 = tmp1_elvis_lhs_0;
      }
      var pc = tmp_0;
      $this.u2o_1.addComponent(tmp2_safe_receiver, pc);
    }
  }
  function createProductWithoutProductRootChildren($this, entityDO, productManager, partKeyComponents, partKeyProducts) {
    var entityId = deserializeId($this, entityDO.g2o_1);
    var tmp0_safe_receiver = productManager.productSpecification(entityDO.h2o_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.createProductWithoutProductRootChildren.<anonymous>' call
      var spec = tmp0_safe_receiver;
      var tmp0_safe_receiver_0 = partKeyProducts.b3(entityId);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        spec = tmp0_safe_receiver.addComponent(tmp0_safe_receiver_0);
      }
      var entity = productManager.createFromSpecificationInternal(entityDO.h2o_1, spec, entityId);
      var tmp2_safe_receiver = entity == null ? null : get_descendants(entity);
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp2_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp2_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.serialization.v13.SerializerV13.createProductWithoutProductRootChildren.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver_1 = get_partKey(element);
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_0 = new EntityPartKey(entityId, tmp0_safe_receiver_1);
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var this_0 = element.components();
            var destination = ArrayList_init_$Create$();
            var inductionVariable_0 = 0;
            var last_0 = this_0.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = this_0[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.serialization.v13.SerializerV13.createProductWithoutProductRootChildren.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              if (!element_0.serializable) {
                destination.q(element_0);
              }
            }
            partKeyComponents.r2(tmp_0, destination);
          }
        }
      }
      var tmp4_safe_receiver = entity == null ? null : get_descendants(entity);
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = tmp4_safe_receiver.length;
        while (inductionVariable_1 < last_1) {
          var element_1 = tmp4_safe_receiver[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.serialization.v13.SerializerV13.createProductWithoutProductRootChildren.<anonymous>.<anonymous>' call
          if (!element_1.isDisposed) {
            $this.u2o_1.removeAllComponents(element_1);
            $this.u2o_1.disposeEntity(element_1);
          }
        }
      }
      tmp = entity;
    }
    return tmp;
  }
  function Companion_91() {
    Companion_instance_91 = this;
    this.logger = LoggerState_getInstance().m1m('SerializerV13');
  }
  protoOf(Companion_91).x1i = function () {
    return this.logger;
  };
  protoOf(Companion_91).serializeCatalogs = function (productManager) {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp1_safe_receiver = productManager == null ? null : productManager.catalogs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(tmp1_safe_receiver.length), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$(capacity);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'com.ikea.core.serialization.v13.Companion.serializeCatalogs.<anonymous>' call
        var pair = new Pair(element.rangeId(), element.rangeVersion());
        destination.r2(pair.ye_1, pair.ze_1);
      }
      tmp = destination;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  };
  protoOf(Companion_91).serializeTree = function (root) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = createSerializableEntitiesWithRelations(this, root, null);
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeTree.<anonymous>' call
      var entity = element.af();
      if (!entity.hasComponent(Companion_instance_85.id)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.t();
    while (tmp0_iterator_0.u()) {
      var item = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeTree.<anonymous>' call
      var serializableEntity = item.bf();
      destination_0.q(serializableEntity);
    }
    return destination_0;
  };
  protoOf(Companion_91).serializeForest = function (entities) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = entities.length;
    while (inductionVariable < last) {
      var element = entities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      if (get_parent(element) == null ? true : !contains(entities, get_parent(element))) {
        destination.q(element);
      }
    }
    var roots = destination;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = roots.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      var list = createSerializableEntitiesWithRelations(Companion_getInstance_92(), element_0, null);
      addAll(destination_0, list);
    }
    var serializableEntities = destination_0;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.distinctBy' call
    var this_0 = serializableEntities;
    var set = HashSet_init_$Create$();
    var list_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = this_0.t();
    while (tmp0_iterator_0.u()) {
      var e = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      var key = e.ye_1;
      if (set.q(key)) {
        list_0.q(e);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = list_0.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      var entity = element_1.af();
      if (contains(entities, entity)) {
        destination_1.q(element_1);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_2 = destination_1.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      var entity_0 = element_2.af();
      if (!entity_0.hasComponent(Companion_instance_85.id)) {
        destination_2.q(element_2);
      }
    }
    serializableEntities = destination_2;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_3 = serializableEntities.t();
    while (tmp0_iterator_3.u()) {
      var element_3 = tmp0_iterator_3.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      var serializableEntity = element_3.bf();
      var parentId = serializableEntity.i2o_1;
      // Inline function 'kotlin.collections.find' call
      var this_1 = serializableEntities;
      var tmp$ret$15;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_4 = this_1.t();
        while (tmp0_iterator_4.u()) {
          var element_4 = tmp0_iterator_4.w();
          // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>.<anonymous>' call
          if (element_4.ze_1.g2o_1 === parentId) {
            tmp$ret$15 = element_4;
            break $l$block;
          }
        }
        tmp$ret$15 = null;
      }
      var parent = tmp$ret$15;
      if (parent == null)
        serializableEntity.i2o_1 = null;
    }
    // Inline function 'kotlin.collections.map' call
    var this_2 = serializableEntities;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_5 = this_2.t();
    while (tmp0_iterator_5.u()) {
      var item = tmp0_iterator_5.w();
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
      var serializableEntity_0 = item.bf();
      destination_3.q(serializableEntity_0);
    }
    return destination_3;
  };
  protoOf(Companion_91).cleanUp = function (root) {
    forEachInHierarchy(root, SerializerV13$Companion$cleanUp$lambda);
  };
  var Companion_instance_91;
  function Companion_getInstance_92() {
    if (Companion_instance_91 == null)
      new Companion_91();
    return Companion_instance_91;
  }
  function EntityAndDO(entity, entityDO) {
    this.entity = entity;
    this.entityDO = entityDO;
  }
  protoOf(EntityAndDO).r23 = function () {
    return this.entity;
  };
  protoOf(EntityAndDO).x2o = function () {
    return this.entityDO;
  };
  protoOf(EntityAndDO).af = function () {
    return this.entity;
  };
  protoOf(EntityAndDO).bf = function () {
    return this.entityDO;
  };
  protoOf(EntityAndDO).y2o = function (entity, entityDO) {
    return new EntityAndDO(entity, entityDO);
  };
  protoOf(EntityAndDO).copy = function (entity, entityDO, $super) {
    entity = entity === VOID ? this.entity : entity;
    entityDO = entityDO === VOID ? this.entityDO : entityDO;
    return this.y2o(entity, entityDO);
  };
  protoOf(EntityAndDO).toString = function () {
    return 'EntityAndDO(entity=' + this.entity + ', entityDO=' + this.entityDO + ')';
  };
  protoOf(EntityAndDO).hashCode = function () {
    var result = this.entity.hashCode();
    result = imul(result, 31) + hashCode(this.entityDO) | 0;
    return result;
  };
  protoOf(EntityAndDO).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityAndDO))
      return false;
    var tmp0_other_with_cast = other instanceof EntityAndDO ? other : THROW_CCE();
    if (!this.entity.equals(tmp0_other_with_cast.entity))
      return false;
    if (!equals(this.entityDO, tmp0_other_with_cast.entityDO))
      return false;
    return true;
  };
  function EntityPartKey(entityId, partKey) {
    this.entityId = entityId;
    this.partKey = partKey;
  }
  protoOf(EntityPartKey).z2o = function () {
    return this.entityId;
  };
  protoOf(EntityPartKey).z1j = function () {
    return this.partKey;
  };
  protoOf(EntityPartKey).af = function () {
    return this.entityId;
  };
  protoOf(EntityPartKey).bf = function () {
    return this.partKey;
  };
  protoOf(EntityPartKey).a2p = function (entityId, partKey) {
    return new EntityPartKey(entityId, partKey);
  };
  protoOf(EntityPartKey).copy = function (entityId, partKey, $super) {
    entityId = entityId === VOID ? this.entityId : entityId;
    partKey = partKey === VOID ? this.partKey : partKey;
    return this.a2p(entityId, partKey);
  };
  protoOf(EntityPartKey).toString = function () {
    return 'EntityPartKey(entityId=' + this.entityId + ', partKey=' + this.partKey + ')';
  };
  protoOf(EntityPartKey).hashCode = function () {
    var result = this.entityId;
    result = imul(result, 31) + getStringHashCode(this.partKey) | 0;
    return result;
  };
  protoOf(EntityPartKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityPartKey))
      return false;
    var tmp0_other_with_cast = other instanceof EntityPartKey ? other : THROW_CCE();
    if (!(this.entityId === tmp0_other_with_cast.entityId))
      return false;
    if (!(this.partKey === tmp0_other_with_cast.partKey))
      return false;
    return true;
  };
  function extractAssemblyParts$checkComponents(this$0, parentToChildMap, $components, childToParentMap, $entityDOs, parts, me) {
    var entityId = deserializeId(this$0, me.g2o_1);
    var tmp0_safe_receiver = parentToChildMap.b3(entityId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp0_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.checkComponents.<anonymous>' call
        extractAssemblyParts$checkComponents(this$0, parentToChildMap, $components, childToParentMap, $entityDOs, parts, element);
      }
    }
    var tmp1_safe_receiver = $components.b3(entityId);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_iterator_0 = tmp1_safe_receiver.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.checkComponents.<anonymous>.<anonymous>' call
        if (element_0 instanceof ProductPartComponent) {
          var rootie = childToParentMap.b3(entityId);
          var level = 0;
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator_1 = $entityDOs.t();
            while (tmp0_iterator_1.u()) {
              var element_1 = tmp0_iterator_1.w();
              // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.checkComponents.<anonymous>.<anonymous>.<anonymous>' call
              if (element_1.g2o_1 === me.g2o_1) {
                tmp$ret$1 = element_1;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp$ret$2 = tmp$ret$1;
          var productRef = ensureNotNull(tmp$ret$2).h2o_1;
          while (!(rootie == null)) {
            // Inline function 'kotlin.collections.getOrPut' call
            var key = rootie;
            var value = parts.b3(key);
            var tmp;
            if (value == null) {
              // Inline function 'com.ikea.core.serialization.v13.SerializerV13.extractAssemblyParts.checkComponents.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.collections.mutableMapOf' call
              var answer = LinkedHashMap_init_$Create$_0();
              parts.r2(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var map = tmp;
            var there = map.b3(element_0.partKey);
            if (there == null) {
              // Inline function 'kotlin.collections.set' call
              var key_0 = element_0.partKey;
              var value_0 = new ProductRefLevel(productRef, level);
              map.r2(key_0, value_0);
              rootie = childToParentMap.b3(rootie);
            } else {
              if (there.level > level) {
                // Inline function 'kotlin.collections.set' call
                var key_1 = element_0.partKey;
                var value_1 = new ProductRefLevel(productRef, level);
                map.r2(key_1, value_1);
              }
              rootie = null;
            }
            level = level + 1 | 0;
          }
        }
      }
    }
  }
  function SerializerV13(entityManager, productManager) {
    Companion_getInstance_92();
    this.u2o_1 = entityManager;
    this.v2o_1 = productManager;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.entityIdMapper = LinkedHashMap_init_$Create$_0();
  }
  protoOf(SerializerV13).rebuildEntities = function (entityDOs) {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(entityDOs, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = entityDOs.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      var entityId = deserializeId(this, element.g2o_1);
      var pair = to(entityId, asList_0(this, element));
      destination.r2(pair.ye_1, pair.ze_1);
    }
    var components = destination;
    var assemblyParts = extractAssemblyParts(this, entityDOs, components);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = entityDOs.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      var parentID = element_0.i2o_1;
      if (!(parentID == null)) {
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp;
          if (isInterface(entityDOs, Collection)) {
            tmp = entityDOs.b1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
          var tmp0_iterator_1 = entityDOs.t();
          while (tmp0_iterator_1.u()) {
            var element_1 = tmp0_iterator_1.w();
            // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>.<anonymous>' call
            if (element_1.g2o_1 === parentID) {
              tmp$ret$3 = false;
              break $l$block_0;
            }
          }
          tmp$ret$3 = true;
        }
        if (tmp$ret$3) {
          throw IllegalStateException_init_$Create$('Did not find parent ' + parentID + ' for entity ' + element_0.g2o_1 + ' with reference ' + element_0.h2o_1 + ' in deserialized json.');
        }
      }
    }
    // Inline function 'kotlin.collections.mutableMapOf' call
    var partKeyComponents = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_2 = entityDOs.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      // Inline function 'kotlin.collections.find' call
      var this_0 = this.u2o_1.entities;
      var tmp$ret$7;
      $l$block_1: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element_3 = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>.<anonymous>' call
          if (element_3.id === deserializeId(this, element_2.g2o_1)) {
            tmp$ret$7 = element_3;
            break $l$block_1;
          }
        }
        tmp$ret$7 = null;
      }
      var found = tmp$ret$7;
      var tmp0_safe_receiver = found == null ? createEntity_0(this, element_2, partKeyComponents, assemblyParts) : new EntityAndDO(found, element_2);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver);
      }
    }
    var entityAndDOs = destination_0;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(entityAndDOs, 10));
    var tmp0_iterator_3 = entityAndDOs.t();
    while (tmp0_iterator_3.u()) {
      var item = tmp0_iterator_3.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      var entity = item.af();
      destination_1.q(entity);
    }
    var entities = destination_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_4 = entityAndDOs.t();
    while (tmp0_iterator_4.u()) {
      var element_4 = tmp0_iterator_4.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      addComponents(this, element_4, components.b3(element_4.entity.id));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_5 = entityAndDOs.t();
    while (tmp0_iterator_5.u()) {
      var element_5 = tmp0_iterator_5.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      buildProductRootHierarchy(this, element_5, entities);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_6 = entities.t();
    while (tmp0_iterator_6.u()) {
      var element_6 = tmp0_iterator_6.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      if (get_parent(element_6) == null) {
        destination_2.q(element_6);
      }
    }
    var roots = destination_2;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_7 = roots.t();
    while (tmp0_iterator_7.u()) {
      var element_7 = tmp0_iterator_7.w();
      // Inline function 'com.ikea.core.serialization.v13.SerializerV13.rebuildEntities.<anonymous>' call
      fixProductPartComponents(this, element_7, null, partKeyComponents);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(roots);
  };
  function Companion_92() {
    Companion_instance_92 = this;
    var tmp = this;
    var tmp_0 = new Vector(-Infinity, -Infinity, -Infinity);
    tmp.INFINITE_AABB = new AxisAlignedBox(tmp_0, new Vector(Infinity, Infinity, Infinity));
    this.EMPTY_AABB = new AxisAlignedBox(Companion_getInstance_61().ZERO, Companion_getInstance_61().ZERO);
  }
  protoOf(Companion_92).b2p = function () {
    return this.INFINITE_AABB;
  };
  protoOf(Companion_92).c2p = function () {
    return this.EMPTY_AABB;
  };
  protoOf(Companion_92).fromVertices = function (vertices) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (vertices.length === 0) {
      throw IllegalArgumentException_init_$Create$('Can not create an axis aligned box from zero vertices');
    }
    var xMin = Infinity;
    var xMax = -Infinity;
    var yMin = Infinity;
    var yMax = -Infinity;
    var zMin = Infinity;
    var zMax = -Infinity;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = vertices.length;
    while (inductionVariable < last) {
      var element = vertices[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.fromVertices.<anonymous>' call
      if (element.X < xMin)
        xMin = element.X;
      if (element.X > xMax)
        xMax = element.X;
      if (element.Y < yMin)
        yMin = element.Y;
      if (element.Y > yMax)
        yMax = element.Y;
      if (element.Z < zMin)
        zMin = element.Z;
      if (element.Z > zMax)
        zMax = element.Z;
    }
    return new AxisAlignedBox(new Vector(xMin, yMin, zMin), new Vector(xMax, yMax, zMax));
  };
  protoOf(Companion_92).d2p = function (size, center) {
    return new AxisAlignedBox(size.unaryMinus().__divIntForKotlin(2).plus(center), size.__divIntForKotlin(2).plus(center));
  };
  protoOf(Companion_92).fromSize = function (size, center, $super) {
    center = center === VOID ? Companion_getInstance_61().ZERO : center;
    return this.d2p(size, center);
  };
  var Companion_instance_92;
  function Companion_getInstance_93() {
    if (Companion_instance_92 == null)
      new Companion_92();
    return Companion_instance_92;
  }
  function AxisAlignedBox(min, max) {
    Companion_getInstance_93();
    this.min = min;
    this.max = max;
  }
  protoOf(AxisAlignedBox).e2p = function () {
    return this.min;
  };
  protoOf(AxisAlignedBox).f2p = function () {
    return this.max;
  };
  protoOf(AxisAlignedBox).g2p = function () {
    return this.max.plus(this.min).times(0.5);
  };
  protoOf(AxisAlignedBox).u2b = function () {
    return this.size.X;
  };
  protoOf(AxisAlignedBox).v2b = function () {
    return this.size.Y;
  };
  protoOf(AxisAlignedBox).w2b = function () {
    return this.size.Z;
  };
  protoOf(AxisAlignedBox).n = function () {
    return this.max.minus(this.min);
  };
  protoOf(AxisAlignedBox).containsPoint = function (point) {
    return ((((this.min.X <= point.X ? this.min.Y <= point.Y : false) ? this.min.Z <= point.Z : false) ? this.max.X >= point.X : false) ? this.max.Y >= point.Y : false) ? this.max.Z >= point.Z : false;
  };
  protoOf(AxisAlignedBox).doIntersectWith = function (otherAABB) {
    return ((this.min.X <= otherAABB.max.X ? this.max.X >= otherAABB.min.X : false) ? this.min.Y <= otherAABB.max.Y ? this.max.Y >= otherAABB.min.Y : false : false) ? this.min.Z <= otherAABB.max.Z ? this.max.Z >= otherAABB.min.Z : false : false;
  };
  protoOf(AxisAlignedBox).createCombined = function (otherAABB) {
    if (otherAABB == null)
      return this;
    if (equals(otherAABB, this))
      return this;
    var tmp = Companion_getInstance_93();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [this.min, this.max, otherAABB.min, otherAABB.max];
    return tmp.fromVertices(tmp$ret$2);
  };
  protoOf(AxisAlignedBox).af = function () {
    return this.min;
  };
  protoOf(AxisAlignedBox).bf = function () {
    return this.max;
  };
  protoOf(AxisAlignedBox).u2c = function (min, max) {
    return new AxisAlignedBox(min, max);
  };
  protoOf(AxisAlignedBox).copy = function (min, max, $super) {
    min = min === VOID ? this.min : min;
    max = max === VOID ? this.max : max;
    return this.u2c(min, max);
  };
  protoOf(AxisAlignedBox).toString = function () {
    return 'AxisAlignedBox(min=' + this.min + ', max=' + this.max + ')';
  };
  protoOf(AxisAlignedBox).hashCode = function () {
    var result = this.min.hashCode();
    result = imul(result, 31) + this.max.hashCode() | 0;
    return result;
  };
  protoOf(AxisAlignedBox).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AxisAlignedBox))
      return false;
    var tmp0_other_with_cast = other instanceof AxisAlignedBox ? other : THROW_CCE();
    if (!this.min.equals(tmp0_other_with_cast.min))
      return false;
    if (!this.max.equals(tmp0_other_with_cast.max))
      return false;
    return true;
  };
  function convexPolyhedronPenetration($this, other) {
    var minDistance = {_v: 1.7976931348623157E308};
    var penetrationAxis = {_v: get_zero()};
    var shape1 = new DualDouble(0.0, 0.0);
    var shape2 = new DualDouble(0.0, 0.0);
    var tmp;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = $this.unsignedNormals;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.convexPolyhedronPenetration.<anonymous>' call
        if (convexPolyhedronPenetration$isSeparatingPlane(other, shape2, $this, shape1, minDistance, penetrationAxis, element)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    if (tmp$ret$1) {
      tmp = true;
    } else {
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var indexedObject_0 = other.unsignedNormals;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject_0.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = indexedObject_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.convexPolyhedronPenetration.<anonymous>' call
          if (convexPolyhedronPenetration$isSeparatingPlane(other, shape2, $this, shape1, minDistance, penetrationAxis, element_0)) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      tmp = tmp$ret$3;
    }
    if (tmp) {
      return null;
    }
    // Inline function 'kotlin.math.abs' call
    var x = minDistance._v;
    var tmp_0 = Math.abs(x);
    if (tmp_0 < 0.1)
      return null;
    var indexedObject_1 = $this.edgeDirections;
    var inductionVariable_1 = 0;
    var last_1 = indexedObject_1.length;
    while (inductionVariable_1 < last_1) {
      var edge1 = indexedObject_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var indexedObject_2 = other.edgeDirections;
      var inductionVariable_2 = 0;
      var last_2 = indexedObject_2.length;
      while (inductionVariable_2 < last_2) {
        var edge2 = indexedObject_2[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var cross = edge1.cross(edge2);
        if (!almostEquals(cross.size, 0.0) ? convexPolyhedronPenetration$isSeparatingPlane(other, shape2, $this, shape1, minDistance, penetrationAxis, cross) : false)
          return null;
      }
    }
    return penetrationAxis._v.normalize().times(minDistance._v);
  }
  function distance($this, min1, max1, min2, max2) {
    var d1 = max2 - min1;
    var d2 = max1 - min2;
    var tmp;
    // Inline function 'kotlin.math.abs' call
    var tmp_0 = Math.abs(d1);
    // Inline function 'kotlin.math.abs' call
    if (tmp_0 < Math.abs(d2)) {
      tmp = -d1;
    } else {
      tmp = d2;
    }
    return tmp;
  }
  function overlaps($this, min1, max1, min2, max2) {
    return isBetweenOrdered($this, min2, min1, max1) ? true : isBetweenOrdered($this, min1, min2, max2);
  }
  function isBetweenOrdered($this, value, lowerBound, upperBound) {
    return lowerBound <= value ? value <= upperBound : false;
  }
  function raycastEachFaceIndividually($this, ray) {
    var closestHit = null;
    var hitPlaneNormal = Companion_getInstance_61().ZERO;
    var closestDistance = Infinity;
    var inductionVariable = 0;
    var last = $this.faces.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var faceIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = $this.faces[faceIndex].indices;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(this_0.length);
        var inductionVariable_0 = 0;
        var last_0 = this_0.length;
        while (inductionVariable_0 < last_0) {
          var item = this_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.raycastEachFaceIndividually.<anonymous>' call
          var tmp$ret$0 = $this.vertices[item];
          destination.q(tmp$ret$0);
        }
        var faceVertices = copyToArray(destination);
        var facePolygon = Companion_instance_55.createPolygonAndCalculateNormal(faceVertices);
        var tmp2_safe_receiver = facePolygon == null ? null : facePolygon.raycast(ray);
        var hit = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.point;
        if (hit == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var distance = ray.origin.distanceTo(hit);
          var tmp;
          if (distance < closestDistance) {
            closestHit = hit;
            hitPlaneNormal = facePolygon.normal;
            closestDistance = distance;
            tmp = Unit_instance;
          }
        }
      }
       while (inductionVariable <= last);
    var tmp4_safe_receiver = closestHit;
    var tmp_0;
    if (tmp4_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.raycastEachFaceIndividually.<anonymous>' call
      tmp_0 = new RaycastResult(tmp4_safe_receiver, hitPlaneNormal);
    }
    return tmp_0;
  }
  function Companion_93() {
    Companion_instance_93 = this;
    this.i2p_1 = LoggerState_getInstance().m1m('ConvexPolyhedron');
  }
  protoOf(Companion_93).scaleVertices = function (vertices, scaleAmount) {
    // Inline function 'com.ikea.core.utils.mapToArray' call
    // Inline function 'kotlin.arrayOfNulls' call
    var size = vertices.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = vertices.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.Companion.scaleVertices.<anonymous>' call
        arr[i] = vertices[i].timesElementWise(scaleAmount);
      }
       while (inductionVariable <= last);
    return isArray(arr) ? arr : THROW_CCE();
  };
  protoOf(Companion_93).scaleNormals = function (normals, scaleAmount) {
    var inverseScale = new Vector(1 / scaleAmount.X, 1 / scaleAmount.Y, 1 / scaleAmount.Y);
    // Inline function 'com.ikea.core.utils.mapToArray' call
    // Inline function 'kotlin.arrayOfNulls' call
    var size = normals.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = normals.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.Companion.scaleNormals.<anonymous>' call
        arr[i] = normals[i].timesElementWise(inverseScale).normalize();
      }
       while (inductionVariable <= last);
    return isArray(arr) ? arr : THROW_CCE();
  };
  protoOf(Companion_93).scaleEdgeDirections = function (edgeDirections, scaleAmount) {
    var inverseScale = new Vector(1 / scaleAmount.X, 1 / scaleAmount.Y, 1 / scaleAmount.Y);
    // Inline function 'com.ikea.core.utils.mapToArray' call
    // Inline function 'kotlin.arrayOfNulls' call
    var size = edgeDirections.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = edgeDirections.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.Companion.scaleEdgeDirections.<anonymous>' call
        arr[i] = edgeDirections[i].timesElementWise(inverseScale).normalize();
      }
       while (inductionVariable <= last);
    return isArray(arr) ? arr : THROW_CCE();
  };
  var Companion_instance_93;
  function Companion_getInstance_94() {
    if (Companion_instance_93 == null)
      new Companion_93();
    return Companion_instance_93;
  }
  function convexPolyhedronPenetration$isSeparatingPlane($other, shape2, this$0, shape1, minDistance, penetrationAxis, planeNormal) {
    planeNormal.project($other.vertices, shape2);
    planeNormal.project(this$0.vertices, shape1);
    if (!overlaps(this$0, shape1.first, shape1.last, shape2.first, shape2.last)) {
      return true;
    }
    var d = distance(this$0, shape1.first, shape1.last, shape2.first, shape2.last);
    // Inline function 'kotlin.math.abs' call
    var tmp = Math.abs(d);
    // Inline function 'kotlin.math.abs' call
    var x = minDistance._v;
    if (tmp < Math.abs(x)) {
      minDistance._v = d;
      penetrationAxis._v = planeNormal;
    }
    return false;
  }
  function ConvexPolyhedron$axisAlignedBoundingBox$delegate$lambda(this$0) {
    return function () {
      return Companion_getInstance_93().fromVertices(this$0.vertices);
    };
  }
  function ConvexPolyhedron(normals, vertices, faces, edgeDirections) {
    Companion_getInstance_94();
    this.normals = normals;
    this.vertices = vertices;
    this.faces = faces;
    this.edgeDirections = edgeDirections;
    var tmp = this;
    tmp.h2p_1 = lazy(ConvexPolyhedron$axisAlignedBoundingBox$delegate$lambda(this));
  }
  protoOf(ConvexPolyhedron).j2p = function () {
    return this.normals;
  };
  protoOf(ConvexPolyhedron).b23 = function () {
    return this.vertices;
  };
  protoOf(ConvexPolyhedron).k2p = function () {
    return this.faces;
  };
  protoOf(ConvexPolyhedron).l2p = function () {
    return this.edgeDirections;
  };
  protoOf(ConvexPolyhedron).m2p = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h2p_1;
    axisAlignedBoundingBox$factory();
    return this_0.u2();
  };
  protoOf(ConvexPolyhedron).center = function () {
    var x = 0.0;
    var y = 0.0;
    var z = 0.0;
    var indexedObject = this.vertices;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var v = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      x = x + v.X;
      y = y + v.Y;
      z = z + v.Z;
    }
    return new Vector(x / this.vertices.length, y / this.vertices.length, z / this.vertices.length);
  };
  protoOf(ConvexPolyhedron).transform = function (transform) {
    return this.rotate(transform.rotation).move(transform.position);
  };
  protoOf(ConvexPolyhedron).rotate = function (quaternion) {
    if (quaternion.isIdentity)
      return this;
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.normals;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.rotate.<anonymous>' call
        arr[i] = this_0[i].rotate(quaternion);
      }
       while (inductionVariable <= last);
    var tmp0_normals = isArray(arr) ? arr : THROW_CCE();
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_1 = this.vertices;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_0 = this_1.length;
    var arr_0 = fillArrayVal(Array(size_0), null);
    var inductionVariable_0 = 0;
    var last_0 = this_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.rotate.<anonymous>' call
        arr_0[i_0] = this_1[i_0].rotate(quaternion);
      }
       while (inductionVariable_0 <= last_0);
    var tmp1_vertices = isArray(arr_0) ? arr_0 : THROW_CCE();
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_2 = this.edgeDirections;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_1 = this_2.length;
    var arr_1 = fillArrayVal(Array(size_1), null);
    var inductionVariable_1 = 0;
    var last_1 = this_2.length - 1 | 0;
    if (inductionVariable_1 <= last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.rotate.<anonymous>' call
        arr_1[i_1] = this_2[i_1].rotate(quaternion);
      }
       while (inductionVariable_1 <= last_1);
    var tmp2_edgeDirections = isArray(arr_1) ? arr_1 : THROW_CCE();
    var tmp3_faces = this.faces;
    return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
  };
  protoOf(ConvexPolyhedron).move = function (displacement) {
    if (displacement.equals(Companion_getInstance_61().ZERO))
      return this;
    var tmp0_normals = this.normals;
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.vertices;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.move.<anonymous>' call
        arr[i] = this_0[i].plus(displacement);
      }
       while (inductionVariable <= last);
    var tmp1_vertices = isArray(arr) ? arr : THROW_CCE();
    var tmp2_edgeDirections = this.edgeDirections;
    var tmp3_faces = this.faces;
    return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
  };
  protoOf(ConvexPolyhedron).scaleUniform = function (scaleAmount) {
    var tmp0_normals = this.normals;
    var tmp1_vertices = Companion_getInstance_94().scaleVertices(this.vertices, times(scaleAmount, Companion_getInstance_61().ONE));
    var tmp2_edgeDirections = this.edgeDirections;
    var tmp3_faces = this.faces;
    return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
  };
  protoOf(ConvexPolyhedron).scale = function (scaleAmount) {
    var tmp0_normals = Companion_getInstance_94().scaleNormals(this.normals, scaleAmount);
    var tmp1_vertices = Companion_getInstance_94().scaleVertices(this.vertices, scaleAmount);
    var tmp2_edgeDirections = Companion_getInstance_94().scaleEdgeDirections(this.edgeDirections, scaleAmount);
    var tmp3_faces = this.faces;
    return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
  };
  protoOf(ConvexPolyhedron).n2p = function () {
    return this.normals;
  };
  protoOf(ConvexPolyhedron).penetration = function (other) {
    if (!this.hasCoarseCollision(other))
      return null;
    var tmp;
    if (other instanceof ConvexPolyhedron) {
      tmp = convexPolyhedronPenetration(this, other);
    } else {
      var tmp1_safe_receiver = other.penetration(this);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.penetration.<anonymous>' call
        tmp_0 = tmp1_safe_receiver.unaryMinus();
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ConvexPolyhedron).penetrationAlongAxis = function (other, axis) {
    var tmp0_safe_receiver = this.penetration(other);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.penetration.<anonymous>' call
      tmp = tmp0_safe_receiver.size > axis.size ? axis : tmp0_safe_receiver;
    }
    return tmp;
  };
  protoOf(ConvexPolyhedron).hasCoarseCollision = function (otherShape) {
    return this.axisAlignedBoundingBox.doIntersectWith(otherShape.axisAlignedBoundingBox);
  };
  protoOf(ConvexPolyhedron).hashCode = function () {
    return hashCode(this.vertices);
  };
  protoOf(ConvexPolyhedron).raycast = function (ray) {
    if (this.faces.length < 4) {
      return raycastEachFaceIndividually(this, ray);
    }
    var nearPlaneNormal = null;
    var near = -Infinity;
    var far = Infinity;
    var inductionVariable = 0;
    var last = this.faces.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var faceIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var pointInPlane = this.vertices[this.faces[faceIndex].indices[1]];
        var planeNormal = this.normals[faceIndex];
        var planeD = -(pointInPlane.X * planeNormal.X + pointInPlane.Y * planeNormal.Y + pointInPlane.Z * planeNormal.Z);
        var vN = planeD + planeNormal.__timesOperatorKotlin(ray.origin);
        var vD = planeNormal.__timesOperatorKotlin(ray.direction);
        if (almostEquals(vD, 0.0)) {
          if (vN > 0.0) {
            return null;
          }
        } else {
          var distanceToPlane = -vN / vD;
          if (vD < 0.0) {
            if (distanceToPlane > near) {
              near = distanceToPlane;
              nearPlaneNormal = planeNormal;
            }
          } else {
            if (distanceToPlane < far) {
              far = distanceToPlane;
            }
          }
          if (near > far)
            return null;
        }
      }
       while (inductionVariable <= last);
    if (near < 0.0 ? true : nearPlaneNormal == null)
      return null;
    return new RaycastResult(ray.direction.times(near).plus(ray.origin), nearPlaneNormal);
  };
  protoOf(ConvexPolyhedron).equals = function (other) {
    var tmp;
    if (other instanceof ConvexPolyhedron) {
      var tmp_0;
      if (other.vertices.length === this.vertices.length) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var this_0 = zip(other.vertices, this.vertices);
          var tmp_1;
          if (isInterface(this_0, Collection)) {
            tmp_1 = this_0.b1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.equals.<anonymous>' call
            if (!element.ye_1.equals(element.ze_1)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        tmp_0 = tmp$ret$0;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function axisAlignedBoundingBox$factory() {
    return getPropertyCallableRef('axisAlignedBoundingBox', 1, KProperty1, function (receiver) {
      return receiver.axisAlignedBoundingBox;
    }, null);
  }
  function Face(indices) {
    this.indices = indices;
  }
  protoOf(Face).o2p = function () {
    return this.indices;
  };
  protoOf(Face).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    return contentEquals(this.indices, (other instanceof Face ? other : THROW_CCE()).indices);
  };
  protoOf(Face).hashCode = function () {
    return contentHashCode(this.indices);
  };
  protoOf(Face).af = function () {
    return this.indices;
  };
  protoOf(Face).p2p = function (indices) {
    return new Face(indices);
  };
  protoOf(Face).copy = function (indices, $super) {
    indices = indices === VOID ? this.indices : indices;
    return this.p2p(indices);
  };
  protoOf(Face).toString = function () {
    return 'Face(indices=' + toString(this.indices) + ')';
  };
  function calcNormals($this) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new Vector(1.0, 0.0, 0.0), new Vector(-1.0, 0.0, 0.0), new Vector(0.0, 1.0, 0.0), new Vector(0.0, -1.0, 0.0), new Vector(0.0, 0.0, 1.0), new Vector(0.0, 0.0, -1.0)];
  }
  function calcVertices($this, size) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new Vector(size.width / 2, size.height / 2, size.depth / 2), new Vector(size.width / 2, size.height / 2, -size.depth / 2), new Vector(size.width / 2, -size.height / 2, size.depth / 2), new Vector(size.width / 2, -size.height / 2, -size.depth / 2), new Vector(-size.width / 2, size.height / 2, size.depth / 2), new Vector(-size.width / 2, size.height / 2, -size.depth / 2), new Vector(-size.width / 2, -size.height / 2, size.depth / 2), new Vector(-size.width / 2, -size.height / 2, -size.depth / 2)];
  }
  function calcVertices_0($this, size, center) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new Vector(size.width / 2 + center.X, size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(size.width / 2 + center.X, size.height / 2 + center.Y, -size.depth / 2 + center.Z), new Vector(size.width / 2 + center.X, -size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(size.width / 2 + center.X, -size.height / 2 + center.Y, -size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, size.height / 2 + center.Y, -size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, -size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, -size.height / 2 + center.Y, -size.depth / 2 + center.Z)];
  }
  function Cuboid_init_$Init$(size, $this) {
    Cuboid.call($this, calcVertices(Companion_getInstance_95(), size));
    return $this;
  }
  function CuboidFromSize(size) {
    return Cuboid_init_$Init$(size, objectCreate(protoOf(Cuboid)));
  }
  function Cuboid_init_$Init$_0(size, center, $this) {
    Cuboid.call($this, calcVertices_0(Companion_getInstance_95(), size, center));
    return $this;
  }
  function CuboidFromSizeAndCenter(size, center) {
    return Cuboid_init_$Init$_0(size, center, objectCreate(protoOf(Cuboid)));
  }
  function Companion_94() {
    Companion_instance_94 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [0, 2, 3, 1];
    tmp.y1m_1 = new Face(tmp$ret$2);
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [5, 7, 6, 4];
    tmp_0.z1m_1 = new Face(tmp$ret$5);
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [1, 5, 4, 0];
    tmp_1.a1n_1 = new Face(tmp$ret$8);
    var tmp_2 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$11 = [3, 2, 6, 7];
    tmp_2.b1n_1 = new Face(tmp$ret$11);
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = [4, 6, 2, 0];
    tmp_3.c1n_1 = new Face(tmp$ret$14);
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$17 = [1, 3, 7, 5];
    tmp_4.d1n_1 = new Face(tmp$ret$17);
    var tmp_5 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_5.e1n_1 = [new Vector(1.0), new Vector(VOID, 1.0), new Vector(VOID, VOID, 1.0)];
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.f1n_1 = [this.y1m_1, this.z1m_1, this.a1n_1, this.b1n_1, this.c1n_1, this.d1n_1];
    this.ZERO = CuboidFromSize(new Vector(0.0, 0.0, 0.0));
  }
  protoOf(Companion_94).fromNonCuboidVertices = function (vertices) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (vertices.length === 0) {
      throw IllegalArgumentException_init_$Create$('Can not create an axis aligned box from zero vertices');
    }
    return this.fromAABB(Companion_getInstance_93().fromVertices(vertices));
  };
  protoOf(Companion_94).fromAABB = function (aabb) {
    return CuboidFromSizeAndCenter(aabb.size, aabb.center);
  };
  protoOf(Companion_94).g2f = function () {
    return this.ZERO;
  };
  var Companion_instance_94;
  function Companion_getInstance_95() {
    if (Companion_instance_94 == null)
      new Companion_94();
    return Companion_instance_94;
  }
  function Cuboid$size$delegate$lambda($vertices) {
    return function () {
      // Inline function 'kotlin.math.abs' call
      var x = $vertices[0].X - $vertices[4].X;
      var tmp = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = $vertices[0].Y - $vertices[2].Y;
      var tmp_0 = Math.abs(x_0);
      // Inline function 'kotlin.math.abs' call
      var x_1 = $vertices[0].Z - $vertices[1].Z;
      var tmp$ret$2 = Math.abs(x_1);
      return new Vector(tmp, tmp_0, tmp$ret$2);
    };
  }
  function Cuboid(vertices) {
    Companion_getInstance_95();
    var tmp0_edgeDirections = Companion_getInstance_95().e1n_1;
    var tmp1_normals = calcNormals(Companion_getInstance_95());
    var tmp2_faces = Companion_getInstance_95().f1n_1;
    ConvexPolyhedron.call(this, tmp1_normals, vertices, tmp2_faces, tmp0_edgeDirections);
    var tmp = this;
    tmp.r2p_1 = lazy(Cuboid$size$delegate$lambda(vertices));
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.s2p_1 = [this.normals[0], this.normals[2], this.normals[4]];
  }
  protoOf(Cuboid).n = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r2p_1;
    size$factory();
    return this_0.u2();
  };
  protoOf(Cuboid).applyMargin = function (margin) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var newVertices = [new Vector(this.vertices[0].X + margin.right, this.vertices[0].Y + margin.top, this.vertices[0].Z + margin.front), new Vector(this.vertices[1].X + margin.right, this.vertices[1].Y + margin.top, this.vertices[1].Z - margin.back), new Vector(this.vertices[2].X + margin.right, this.vertices[2].Y - margin.bottom, this.vertices[2].Z + margin.front), new Vector(this.vertices[3].X + margin.right, this.vertices[3].Y - margin.bottom, this.vertices[3].Z - margin.back), new Vector(this.vertices[4].X - margin.left, this.vertices[4].Y + margin.top, this.vertices[4].Z + margin.front), new Vector(this.vertices[5].X - margin.left, this.vertices[5].Y + margin.top, this.vertices[5].Z - margin.back), new Vector(this.vertices[6].X - margin.left, this.vertices[6].Y - margin.bottom, this.vertices[6].Z + margin.front), new Vector(this.vertices[7].X - margin.left, this.vertices[7].Y - margin.bottom, this.vertices[7].Z - margin.back)];
    return new Cuboid(newVertices);
  };
  protoOf(Cuboid).move = function (displacement) {
    if (displacement.equals(Companion_getInstance_61().ZERO))
      return this;
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.vertices;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.Cuboid.move.<anonymous>' call
        arr[i] = this_0[i].plus(displacement);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return new Cuboid(tmp$ret$2);
  };
  protoOf(Cuboid).scale = function (scaleAmount) {
    return new Cuboid(Companion_getInstance_94().scaleVertices(this.vertices, scaleAmount));
  };
  protoOf(Cuboid).scaleUniform = function (scaleAmount) {
    return new Cuboid(Companion_getInstance_94().scaleVertices(this.vertices, Companion_getInstance_61().ONE.times(scaleAmount)));
  };
  protoOf(Cuboid).n2p = function () {
    return this.s2p_1;
  };
  function size$factory() {
    return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
      return receiver.size;
    }, null);
  }
  function Polyhedron() {
  }
  function calcAxisAlignedBoundingBox($this) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.polyhedra;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.calcAxisAlignedBoundingBox.<anonymous>' call
      var tmp$ret$0 = item.axisAlignedBoundingBox;
      destination.q(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.calcAxisAlignedBoundingBox.<anonymous>' call
      var list = listOf_0([element.min, element.max]);
      addAll(destination_0, list);
    }
    var axisAlignedVertices = copyToArray(destination_0);
    return Companion_getInstance_93().fromVertices(axisAlignedVertices);
  }
  function penetration$check(maxSize, max, v) {
    if (v == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var itSize = v.size;
      var tmp;
      if (itSize > maxSize._v) {
        max._v = v;
        maxSize._v = itSize;
        tmp = Unit_instance;
      }
    }
  }
  function PolyhedronGroup$axisAlignedBoundingBox$delegate$lambda(this$0) {
    return function () {
      return calcAxisAlignedBoundingBox(this$0);
    };
  }
  function PolyhedronGroup(polyhedra) {
    this.polyhedra = polyhedra;
    var tmp = this;
    tmp.t2p_1 = lazy(PolyhedronGroup$axisAlignedBoundingBox$delegate$lambda(this));
  }
  protoOf(PolyhedronGroup).u2p = function () {
    return this.polyhedra;
  };
  protoOf(PolyhedronGroup).m2p = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t2p_1;
    axisAlignedBoundingBox$factory_0();
    return this_0.u2();
  };
  protoOf(PolyhedronGroup).rotate = function (quaternion) {
    if (quaternion.isIdentity)
      return this;
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.polyhedra;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronGroup.rotate.<anonymous>' call
        arr[i] = this_0[i].rotate(quaternion);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return new PolyhedronGroup(tmp$ret$2);
  };
  protoOf(PolyhedronGroup).move = function (displacement) {
    if (displacement.equals(Companion_getInstance_61().ZERO))
      return this;
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.polyhedra;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronGroup.move.<anonymous>' call
        arr[i] = this_0[i].move(displacement);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return new PolyhedronGroup(tmp$ret$2);
  };
  protoOf(PolyhedronGroup).scaleUniform = function (scaleAmount) {
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.polyhedra;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronGroup.scaleUniform.<anonymous>' call
        arr[i] = this_0[i].scaleUniform(scaleAmount);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return new PolyhedronGroup(tmp$ret$2);
  };
  protoOf(PolyhedronGroup).scale = function (scaleAmount) {
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.polyhedra;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronGroup.scale.<anonymous>' call
        arr[i] = this_0[i].scale(scaleAmount);
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return new PolyhedronGroup(tmp$ret$2);
  };
  protoOf(PolyhedronGroup).penetration = function (other) {
    if (!this.hasCoarseCollision(other))
      return null;
    var max = {_v: null};
    var maxSize = {_v: -1.0};
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.polyhedra;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
      if (other instanceof PolyhedronGroup) {
        var tmp1_safe_receiver = other.penetration(element);
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          penetration$check(maxSize, max, tmp1_safe_receiver.unaryMinus());
        }
      } else {
        penetration$check(maxSize, max, element.penetration(other));
      }
    }
    return max._v;
  };
  protoOf(PolyhedronGroup).penetrationAlongAxis = function (other, axis) {
    if (!this.hasCoarseCollision(other))
      return null;
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = this.polyhedra;
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
        var tmp;
        if (other instanceof PolyhedronGroup) {
          var tmp1_safe_receiver = other.penetrationAlongAxis(element, axis.unaryMinus());
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>.<anonymous>' call
            tmp_0 = tmp1_safe_receiver.unaryMinus();
          }
          tmp = tmp_0;
        } else {
          tmp = element.penetrationAlongAxis(other, axis);
        }
        var tmp0_safe_receiver = tmp;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver);
        }
      }
      var iterator = destination.t();
      if (!iterator.u()) {
        tmp$ret$6 = null;
        break $l$block_0;
      }
      var maxElem = iterator.w();
      if (!iterator.u()) {
        tmp$ret$6 = maxElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
      var maxValue = maxElem.size;
      do {
        var e = iterator.w();
        // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
        var v = e.size;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$6 = maxElem;
    }
    return tmp$ret$6;
  };
  protoOf(PolyhedronGroup).hasCoarseCollision = function (otherShape) {
    return this.axisAlignedBoundingBox.doIntersectWith(otherShape.axisAlignedBoundingBox);
  };
  protoOf(PolyhedronGroup).raycast = function (ray) {
    var closestDistance = Infinity;
    var closestHit = null;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.polyhedra;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.raycast.<anonymous>' call
      var tmp0_safe_receiver = isInterface(element, Raycastable) ? element : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.raycast(ray);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var hitDistance = ray.origin.distanceTo(tmp0_safe_receiver_0.point);
          var tmp;
          if (hitDistance < closestDistance) {
            closestHit = tmp0_safe_receiver_0;
            closestDistance = hitDistance;
            tmp = Unit_instance;
          }
        }
      }
    }
    return closestHit;
  };
  function merge(_this__u8e3s4) {
    return new PolyhedronGroup(_this__u8e3s4);
  }
  function axisAlignedBoundingBox$factory_0() {
    return getPropertyCallableRef('axisAlignedBoundingBox', 1, KProperty1, function (receiver) {
      return receiver.axisAlignedBoundingBox;
    }, null);
  }
  function isConcaveVertex($this, p1, p2, p3, normal) {
    var vertexNormal = $this.generateNormalFromCounterClockwiseTriangle(p1, p2, p3);
    return vertexNormal.dot(normal) < 0.0;
  }
  function isConvexVertex($this, p1, p2, p3, normal) {
    var vertexNormal = $this.generateNormalFromCounterClockwiseTriangle(p1, p2, p3);
    return vertexNormal.dot(normal) > 0.0;
  }
  function isPlanarPointContainedInTriangle($this, p1, p2, p3, testPoint) {
    var f1 = p1.minus(testPoint);
    var f2 = p2.minus(testPoint);
    var f3 = p3.minus(testPoint);
    var va = p1.minus(p2).cross(p1.minus(p3));
    var va1 = f2.cross(f3);
    var va2 = f3.cross(f1);
    var va3 = f1.cross(f2);
    var triangleArea = va.size;
    var tmp = va1.size / triangleArea;
    // Inline function 'kotlin.math.sign' call
    var this_0 = va.dot(va1);
    var uvFactor1 = tmp * sign(this_0);
    var tmp_0 = va2.size / triangleArea;
    // Inline function 'kotlin.math.sign' call
    var this_1 = va.dot(va2);
    var uvFactor2 = tmp_0 * sign(this_1);
    var tmp_1 = va3.size / triangleArea;
    // Inline function 'kotlin.math.sign' call
    var this_2 = va.dot(va3);
    var uvFactor3 = tmp_1 * sign(this_2);
    var uv1 = new Vector(0.0, 0.0);
    var uv2 = new Vector(1.0, 0.0);
    var uv3 = new Vector(0.0, 1.0);
    var pointCoordinate = uv1.times(uvFactor1).plus(uv2.times(uvFactor2)).plus(uv3.times(uvFactor3));
    return (((pointCoordinate.X >= 0.0 ? pointCoordinate.X <= 1.0 : false) ? pointCoordinate.Y >= 0.0 : false) ? pointCoordinate.Y <= 1.0 : false) ? pointCoordinate.X + pointCoordinate.Y <= 1.0 : false;
  }
  function getVerticesFromSinglePolyhedron($this, polyhedron) {
    var tmp;
    if (polyhedron instanceof ConvexPolyhedron) {
      tmp = new Pair(polyhedron.vertices, polyhedron.faces);
    } else {
      // Inline function 'kotlin.emptyArray' call
      var tmp_0 = [];
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$1 = [];
      tmp = new Pair(tmp_0, tmp$ret$1);
    }
    return tmp;
  }
  function earClipTriangulation$isNotCornerAndNotInsideTriangle(p1, p2, p3, testPoint) {
    if ((!(testPoint === p1) ? !(testPoint === p2) : false) ? !(testPoint === p3) : false) {
      return isPlanarPointContainedInTriangle(PolyhedronUtils_getInstance(), p1, p2, p3, testPoint);
    }
    return false;
  }
  function earClipTriangulation$findValidEar(remainingVertices, shapeNormal) {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = remainingVertices.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.shapes.PolyhedronUtils.earClipTriangulation.findValidEar.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var currentVertexIndex = checkIndexOverflow(tmp1);
      var previousVertexIndex = PolyhedronUtils_getInstance().circularIndex(currentVertexIndex - 1 | 0, remainingVertices.n());
      var nextVertexIndex = PolyhedronUtils_getInstance().circularIndex(currentVertexIndex + 1 | 0, remainingVertices.n());
      var previousVertex = remainingVertices.f1(previousVertexIndex);
      var nextVertex = remainingVertices.f1(nextVertexIndex);
      var tmp;
      if (isConvexVertex(PolyhedronUtils_getInstance(), previousVertex, item, nextVertex, shapeNormal)) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_0;
          if (isInterface(remainingVertices, Collection)) {
            tmp_0 = remainingVertices.b1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var tmp0_iterator_0 = remainingVertices.t();
          while (tmp0_iterator_0.u()) {
            var element = tmp0_iterator_0.w();
            // Inline function 'com.ikea.core.shapes.PolyhedronUtils.earClipTriangulation.findValidEar.<anonymous>.<anonymous>' call
            if (earClipTriangulation$isNotCornerAndNotInsideTriangle(previousVertex, item, nextVertex, element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = [previousVertex, item, nextVertex];
        return new Pair(currentVertexIndex, tmp$ret$4);
      }
    }
    return null;
  }
  function PolyhedronUtils$singleSidedPolyhedronFromPolygon$lambda() {
    return 'Unsupported amount of vertices supplied to generateSurfaceCollider, will return empty Collider';
  }
  function PolyhedronUtils$polyhedronFromPolygon$lambda() {
    return 'Less than three vertices supplied to generateSurfaceCollider, will return empty Collider';
  }
  function PolyhedronUtils$polyhedronFromPolygon$lambda_0() {
    return 'Invalid amount of edge vertices, will return empty collider';
  }
  function PolyhedronUtils$polyhedronFromPolygon$lambda_1() {
    return 'Invalid vertex, will return empty collider';
  }
  function PolyhedronUtils$pointInPolygon$lambda(projectionLambda) {
    return projectionLambda.YZ;
  }
  function PolyhedronUtils$pointInPolygon$lambda_0(projectionLambda) {
    return projectionLambda.XZ;
  }
  function PolyhedronUtils$pointInPolygon$lambda_1(projectionLambda) {
    return projectionLambda.XY;
  }
  function PolyhedronUtils$flatPolyhedronFromConvexPolygon$lambda() {
    return 'Unsupported amount of vertices supplied to generateSurfaceCollider, will return empty Collider';
  }
  function PolyhedronUtils$transformAndExtractVerticesFromPolyhedron$lambda($poly) {
    return function () {
      return 'Shape not supported by getLocalOutsideMeasurementForEntities! ' + $poly;
    };
  }
  function PolyhedronUtils() {
    PolyhedronUtils_instance = this;
    this.v2p_1 = LoggerState_getInstance().m1m('PolyhedronUtils');
  }
  protoOf(PolyhedronUtils).createFromPolygon = function (vertices) {
    var tmp;
    if (this.isConvexPolygon(vertices)) {
      tmp = this.flatPolyhedronFromConvexPolygon(vertices);
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.earClipTriangulation(vertices);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.length);
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var item = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronUtils.createFromPolygon.<anonymous>' call
        var tmp$ret$0 = PolyhedronUtils_getInstance().flatPolyhedronFromConvexPolygon(item);
        destination.q(tmp$ret$0);
      }
      var all = destination;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$3 = copyToArray(all);
      tmp = new PolyhedronGroup(tmp$ret$3);
    }
    return tmp;
  };
  protoOf(PolyhedronUtils).w2p = function (size, margin, padding, compartment) {
    var outerWidth = size.s2e_1 - margin.left - margin.right;
    var outerDepth = size.u2e_1 - margin.front - margin.back;
    var innerHeight = size.t2e_1 - (margin.top + margin.bottom + padding.top + padding.bottom);
    var innerWidth = size.s2e_1 - (margin.left + margin.right + padding.left + padding.right);
    var innerDepth = size.u2e_1 - (margin.front + margin.back + padding.front + padding.back);
    var innerDx = (margin.left - margin.right + padding.left - padding.right) / 2;
    var innerDy = (-margin.top + margin.bottom - padding.top + padding.bottom) / 2;
    var innerDz = -(margin.front - margin.back + padding.front - padding.back) / 2;
    var outerDz = -(margin.front - margin.back) / 2;
    var outerDx = (margin.left - margin.right) / 2;
    var topY = size.t2e_1 / 2.0 - margin.top - padding.top / 2.0;
    var bottomY = -size.t2e_1 / 2.0 + margin.bottom + padding.bottom / 2.0;
    var leftX = -size.s2e_1 / 2.0 + margin.left + padding.left / 2.0;
    var rightX = size.s2e_1 / 2.0 - margin.right - padding.right / 2.0;
    var frontZ = size.u2e_1 / 2.0 - margin.front - padding.front / 2.0;
    var backZ = -size.u2e_1 / 2.0 + margin.back + padding.back / 2.0;
    var compartmentWidth = (!(compartment == null) ? compartment.s2e_1 > 0.0 : false) ? compartment.s2e_1 : innerWidth;
    var compartmentHeight = (!(compartment == null) ? compartment.t2e_1 > 0.0 : false) ? compartment.t2e_1 : innerHeight;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableListOf' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.shapes.PolyhedronUtils.createFramePolyhedrons.<anonymous>' call
    if (padding.top > 0.0) {
      this_0.q(CuboidFromSizeAndCenter(new Vector(outerWidth, padding.top, outerDepth), new Vector(outerDx, topY, outerDz)));
    }
    if (padding.bottom > 0.0) {
      this_0.q(CuboidFromSizeAndCenter(new Vector(outerWidth, padding.bottom, outerDepth), new Vector(outerDx, bottomY, outerDz)));
    }
    if (padding.left > 0.0) {
      this_0.q(CuboidFromSizeAndCenter(new Vector(padding.left, innerHeight, outerDepth), new Vector(leftX, innerDy, outerDz)));
    }
    if (padding.right > 0.0) {
      this_0.q(CuboidFromSizeAndCenter(new Vector(padding.right, innerHeight, outerDepth), new Vector(rightX, innerDy, outerDz)));
    }
    if (padding.front > 0.0) {
      this_0.q(CuboidFromSizeAndCenter(new Vector(innerWidth, innerHeight, padding.front), new Vector(innerDx, innerDy, frontZ)));
    }
    if (padding.back > 0.0) {
      this_0.q(CuboidFromSizeAndCenter(new Vector(innerWidth, innerHeight, padding.back), new Vector(innerDx, innerDy, backZ)));
    }
    var outerCuboids = copyToArray(this_0);
    var horizontalCompartmentCount = numberToInt(innerWidth / compartmentWidth);
    var verticalComparmentCount = numberToInt(innerHeight / compartmentHeight);
    var horizontalGap = (innerWidth - compartmentWidth * horizontalCompartmentCount) / (horizontalCompartmentCount - 1 | 0);
    var verticalGap = (innerHeight - compartmentHeight * verticalComparmentCount) / (verticalComparmentCount - 1 | 0);
    var tmp;
    if (compartment == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.shapes.PolyhedronUtils.createFramePolyhedrons.<anonymous>' call
      // Inline function 'kotlin.collections.mutableListOf' call
      var dividerCuboids = ArrayList_init_$Create$();
      var dividerDx = compartmentWidth + horizontalGap;
      var dividerDy = compartmentHeight + verticalGap;
      var currentDividerX = innerDx - innerWidth / 2 + compartmentWidth + horizontalGap / 2;
      var currentDividerY = innerDy - innerHeight / 2 + compartmentHeight + verticalGap / 2;
      if (horizontalCompartmentCount > 1) {
        var inductionVariable = 0;
        var last = horizontalCompartmentCount - 1 | 0;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            dividerCuboids.q(CuboidFromSizeAndCenter(new Vector(horizontalGap, innerHeight, innerDepth), new Vector(currentDividerX, innerDy, innerDz)));
            currentDividerX = currentDividerX + dividerDx;
          }
           while (inductionVariable < last);
      }
      if (verticalComparmentCount > 1) {
        currentDividerX = innerDx - innerWidth / 2 + compartmentWidth / 2;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < horizontalCompartmentCount)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var inductionVariable_1 = 0;
            var last_0 = verticalComparmentCount - 1 | 0;
            if (inductionVariable_1 < last_0)
              do {
                var j = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dividerCuboids.q(CuboidFromSizeAndCenter(new Vector(compartmentWidth, verticalGap, innerDepth), new Vector(currentDividerX, currentDividerY, innerDz)));
                currentDividerY = currentDividerY + dividerDy;
              }
               while (inductionVariable_1 < last_0);
            currentDividerX = currentDividerX + dividerDx;
            currentDividerY = innerDy - innerHeight / 2 + compartmentHeight + verticalGap / 2;
          }
           while (inductionVariable_0 < horizontalCompartmentCount);
      }
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_1 = plus_2(dividerCuboids, outerCuboids);
      tmp = copyToArray(this_1);
    }
    var tmp1_elvis_lhs = tmp;
    var cuboids = tmp1_elvis_lhs == null ? outerCuboids : tmp1_elvis_lhs;
    return cuboids;
  };
  protoOf(PolyhedronUtils).createFramePolyhedrons = function (size, margin, padding, compartment, $super) {
    compartment = compartment === VOID ? null : compartment;
    return this.w2p(size, margin, padding, compartment);
  };
  protoOf(PolyhedronUtils).singleSidedPolyhedronFromPolygon = function (vertices) {
    if (vertices.length < 3) {
      this.v2p_1.warn(PolyhedronUtils$singleSidedPolyhedronFromPolygon$lambda);
      return Companion_getInstance_95().ZERO;
    }
    var normal = this.surfaceNormal(vertices);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = toList(get_indices(vertices));
    var tmp$ret$0 = copyToArray(this_0);
    var face = new Face(tmp$ret$0);
    // Inline function 'kotlin.collections.mutableListOf' call
    var edgeDirections = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = get_lastIndex(vertices);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        edgeDirections.q(vertices[this.circularIndex(i, vertices.length)].minus(vertices[this.circularIndex(i + 1 | 0, vertices.length)]).normalize());
      }
       while (!(i === last));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [normal];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [face];
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$8 = copyToArray(edgeDirections);
    return new ConvexPolyhedron(tmp, vertices, tmp_0, tmp$ret$8);
  };
  protoOf(PolyhedronUtils).circularIndex = function (index, length) {
    var tmp;
    if (index >= length) {
      tmp = index % length | 0;
    } else if (index < 0) {
      tmp = (index % length | 0) + length | 0;
    } else {
      tmp = index;
    }
    return tmp;
  };
  protoOf(PolyhedronUtils).polyhedronFromPolygon = function (points, thickness) {
    if (points.length < 3) {
      this.v2p_1.warn(PolyhedronUtils$polyhedronFromPolygon$lambda);
      return Companion_getInstance_95().ZERO;
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var faceIndices = ArrayList_init_$Create$();
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$1 = points.length;
    var size = imul(tmp$ret$1, 2);
    var vertices = fillArrayVal(Array(size), null);
    var negativeFaceNormal = this.generateNormalFromCounterClockwiseTriangle(points[0], points[1], points[2]).unaryMinus();
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = toList(get_indices(points));
    var frontFaceIndices = copyToArray(this_0);
    faceIndices.q(frontFaceIndices);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.count' call
    var tmp = points.length;
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$5 = points.length;
    var this_1 = toList(reversed(until(tmp, imul(tmp$ret$5, 2))));
    var backfaceIndicesReversed = copyToArray(this_1);
    faceIndices.q(backfaceIndicesReversed);
    var inductionVariable = 0;
    var last = get_lastIndex(points);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        vertices[i] = points[i];
        vertices[points.length + i | 0] = points[i].plus(negativeFaceNormal.times(thickness));
        var j = i + points.length | 0;
        var k = (i + 1 | 0) % points.length | 0;
        var l = k + points.length | 0;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$9 = [i, j, l, k];
        faceIndices.q(tmp$ret$9);
      }
       while (!(i === last));
    // Inline function 'kotlin.collections.mutableListOf' call
    var polyhedronNormals = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.mutableListOf' call
    var polyhedronFaces = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.mutableListOf' call
    var polyhedronEdgeDirections = ArrayList_init_$Create$();
    var tmp1_iterator = faceIndices.t();
    while (tmp1_iterator.u()) {
      var face = tmp1_iterator.w();
      var triangleVertex1 = vertices[face[0]];
      var triangleVertex2 = vertices[face[1]];
      var triangleVertex3 = vertices[face[2]];
      if ((!(triangleVertex1 == null) ? !(triangleVertex2 == null) : false) ? !(triangleVertex3 == null) : false) {
        var currentFaceNormal = this.generateNormalFromCounterClockwiseTriangle(triangleVertex1, triangleVertex2, triangleVertex3);
        polyhedronNormals.q(currentFaceNormal);
        polyhedronFaces.q(new Face(face));
        var nextFaceIndex = get_lastIndex(face);
        var inductionVariable_0 = 0;
        var last_0 = get_lastIndex(face);
        if (inductionVariable_0 <= last_0)
          do {
            var index = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var fromVertex = vertices[nextFaceIndex];
            var toVertex = vertices[index];
            if (!(toVertex == null) ? !(fromVertex == null) : false) {
              polyhedronEdgeDirections.q(toVertex.minus(fromVertex));
            }
            nextFaceIndex = index;
          }
           while (!(index === last_0));
      } else {
        this.v2p_1.warn(PolyhedronUtils$polyhedronFromPolygon$lambda_0);
        return Companion_getInstance_95().ZERO;
      }
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var polyhedronVertices = ArrayList_init_$Create$();
    var inductionVariable_1 = 0;
    // Inline function 'kotlin.collections.count' call
    var tmp$ret$14 = points.length;
    var last_1 = imul(tmp$ret$14, 2);
    if (inductionVariable_1 < last_1)
      do {
        var i_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var vertex = vertices[i_0];
        if (!(vertex == null)) {
          polyhedronVertices.q(vertex);
        } else {
          this.v2p_1.warn(PolyhedronUtils$polyhedronFromPolygon$lambda_1);
          return Companion_getInstance_95().ZERO;
        }
      }
       while (inductionVariable_1 < last_1);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp_0 = copyToArray(polyhedronNormals);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp_1 = copyToArray(polyhedronVertices);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp_2 = copyToArray(polyhedronFaces);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$18 = copyToArray(polyhedronEdgeDirections);
    return new ConvexPolyhedron(tmp_0, tmp_1, tmp_2, tmp$ret$18);
  };
  protoOf(PolyhedronUtils).pointInPolygon = function (point, vertices, normal) {
    // Inline function 'kotlin.math.abs' call
    var x = point.minus(vertices[0]).dot(normal);
    if (Math.abs(x) > 0.1)
      return false;
    // Inline function 'kotlin.math.abs' call
    var x_0 = normal.X;
    var absX = Math.abs(x_0);
    // Inline function 'kotlin.math.abs' call
    var x_1 = normal.Y;
    var absY = Math.abs(x_1);
    // Inline function 'kotlin.math.abs' call
    var x_2 = normal.Z;
    var absZ = Math.abs(x_2);
    var tmp;
    if (absX >= absY ? absX >= absZ : false) {
      tmp = PolyhedronUtils$pointInPolygon$lambda;
    } else if (absY >= absX ? absY >= absZ : false) {
      tmp = PolyhedronUtils$pointInPolygon$lambda_0;
    } else {
      tmp = PolyhedronUtils$pointInPolygon$lambda_1;
    }
    var projectionLambda = tmp;
    var projectedPoint = projectionLambda(point);
    var crossings = 0;
    // Inline function 'kotlin.collections.count' call
    var j = vertices.length - 1 | 0;
    var inductionVariable = 0;
    // Inline function 'kotlin.collections.count' call
    var last = vertices.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var point1 = projectionLambda(vertices[i]);
        var point2 = projectionLambda(vertices[j]);
        if (!(point1.Y > projectedPoint.Y === point2.Y > projectedPoint.Y) ? projectedPoint.X < (point2.X - point1.X) * (projectedPoint.Y - point1.Y) / (point2.Y - point1.Y) + point1.X : false) {
          crossings = crossings + 1 | 0;
        }
        j = i;
      }
       while (inductionVariable < last);
    return !((crossings % 2 | 0) === 0);
  };
  protoOf(PolyhedronUtils).flatPolyhedronFromConvexPolygon = function (vertices) {
    if (vertices.length < 3) {
      this.v2p_1.warn(PolyhedronUtils$flatPolyhedronFromConvexPolygon$lambda);
      return Companion_getInstance_95().ZERO;
    }
    var normal = this.generateNormalFromClockwiseTriangle(vertices[0], vertices[1], vertices[2]);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = toList(get_indices(vertices));
    var tmp$ret$0 = copyToArray(this_0);
    var face = new Face(tmp$ret$0);
    // Inline function 'kotlin.collections.mutableListOf' call
    var edgeDirections = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = get_lastIndex(vertices);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        edgeDirections.q(vertices[this.circularIndex(i, vertices.length)].minus(vertices[this.circularIndex(i + 1 | 0, vertices.length)]).normalize());
      }
       while (!(i === last));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [normal];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [face];
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$8 = copyToArray(edgeDirections);
    return new ConvexPolyhedron(tmp, vertices, tmp_0, tmp$ret$8);
  };
  protoOf(PolyhedronUtils).isConvexPolygon = function (vertices) {
    var normal = this.generateNormalFromCounterClockwiseTriangle(vertices[0], vertices[1], vertices[2]);
    var inductionVariable = 0;
    var last = vertices.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var previousIndex = this.circularIndex(i - 1 | 0, vertices.length);
        var nextIndex = this.circularIndex(i + 1 | 0, vertices.length);
        if (isConcaveVertex(this, vertices[previousIndex], vertices[i], vertices[nextIndex], normal)) {
          return false;
        }
      }
       while (inductionVariable <= last);
    return true;
  };
  protoOf(PolyhedronUtils).surfaceNormal = function (vertices) {
    var surfaceX = 0.0;
    var surfaceY = 0.0;
    var surfaceZ = 0.0;
    var inductionVariable = 0;
    var last = vertices.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.mod' call
        var this_0 = i + 1 | 0;
        var other = vertices.length;
        var r = this_0 % other | 0;
        var j = r + (other & ((r ^ other) & (r | (-r | 0))) >> 31) | 0;
        surfaceX = surfaceX + (vertices[i].Y - vertices[j].Y) * (vertices[i].Z + vertices[j].Z);
        surfaceY = surfaceY + (vertices[i].Z - vertices[j].Z) * (vertices[i].X + vertices[j].X);
        surfaceZ = surfaceZ + (vertices[i].X - vertices[j].X) * (vertices[i].Y + vertices[j].Y);
      }
       while (!(i === last));
    return (new Vector(surfaceX, surfaceY, surfaceZ)).normalize();
  };
  protoOf(PolyhedronUtils).generateNormalFromClockwiseTriangle = function (previous, middle, next) {
    return next.minus(middle).cross(middle.minus(previous)).normalize();
  };
  protoOf(PolyhedronUtils).generateNormalFromCounterClockwiseTriangle = function (previous, middle, next) {
    return middle.minus(previous).cross(next.minus(middle)).normalize();
  };
  protoOf(PolyhedronUtils).isPointContainedInTriangle = function (p1, p2, p3, testPoint) {
    var normal = this.generateNormalFromCounterClockwiseTriangle(p1, p2, p3);
    var plane = new Plane(p1, normal);
    if (plane.contains(testPoint, 0.01)) {
      return isPlanarPointContainedInTriangle(this, p1, p2, p3, testPoint);
    }
    return false;
  };
  protoOf(PolyhedronUtils).getVerticesFromPolyhedrons = function (polyhedrons) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var faceList = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = polyhedrons.length;
    while (inductionVariable < last) {
      var element = polyhedrons[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronUtils.getVerticesFromPolyhedrons.<anonymous>' call
      if (element instanceof PolyhedronGroup) {
        addAll_1(faceList, PolyhedronUtils_getInstance().getVerticesFromPolyhedrons(element.polyhedra));
      } else {
        faceList.q(getVerticesFromSinglePolyhedron(PolyhedronUtils_getInstance(), element));
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(faceList);
  };
  protoOf(PolyhedronUtils).getPolygonsFromPolyhedrons = function (polyhedrons) {
    var surfaces = this.getVerticesFromPolyhedrons(polyhedrons);
    // Inline function 'kotlin.collections.mutableListOf' call
    var polygons = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = surfaces.length;
    while (inductionVariable < last) {
      var element = surfaces[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronUtils.getPolygonsFromPolyhedrons.<anonymous>' call
      var vertices = element.af();
      var faces = element.bf();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = faces.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = faces[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronUtils.getPolygonsFromPolyhedrons.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = element_0.indices;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(this_0.length);
        var inductionVariable_1 = 0;
        var last_1 = this_0.length;
        while (inductionVariable_1 < last_1) {
          var item = this_0[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.shapes.PolyhedronUtils.getPolygonsFromPolyhedrons.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$1 = vertices[item];
          destination.q(tmp$ret$1);
        }
        var faceVertices = copyToArray(destination);
        polygons.q(new Polygon(faceVertices, PolyhedronUtils_getInstance().surfaceNormal(faceVertices)));
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(polygons);
  };
  protoOf(PolyhedronUtils).earClipTriangulation = function (vertices) {
    var shapeNormal = this.surfaceNormal(vertices);
    // Inline function 'kotlin.collections.mutableListOf' call
    var triangles = ArrayList_init_$Create$();
    var remainingVertices = toMutableList(vertices);
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.count' call
      if (!(remainingVertices.n() > 2)) {
        break $l$loop;
      }
      var ear = earClipTriangulation$findValidEar(remainingVertices, shapeNormal);
      if (!(ear == null)) {
        var index = ear.af();
        var triangle = ear.bf();
        triangles.q(triangle);
        remainingVertices.h1(index);
      } else {
        throw IllegalStateException_init_$Create$('Core was unable to triangulate polygon, please supply a non-degenerate polygon.');
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(triangles);
  };
  protoOf(PolyhedronUtils).transformAndExtractVerticesFromPolyhedron = function (poly, worldTransform) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var vertices = ArrayList_init_$Create$();
    if (poly instanceof ConvexPolyhedron) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = poly.transform(worldTransform).vertices;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.shapes.PolyhedronUtils.transformAndExtractVerticesFromPolyhedron.<anonymous>' call
        vertices.q(element);
      }
    } else {
      if (poly instanceof PolyhedronGroup) {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_0 = poly.polyhedra;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject_0.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = indexedObject_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.shapes.PolyhedronUtils.transformAndExtractVerticesFromPolyhedron.<anonymous>' call
          vertices.x(PolyhedronUtils_getInstance().transformAndExtractVerticesFromPolyhedron(element_0, worldTransform));
        }
      } else {
        this.v2p_1.warn(PolyhedronUtils$transformAndExtractVerticesFromPolyhedron$lambda(poly));
      }
    }
    return vertices;
  };
  protoOf(PolyhedronUtils).isConvexPolyhedron = function (polyhedron) {
    return polyhedron instanceof ConvexPolyhedron;
  };
  protoOf(PolyhedronUtils).isCuboid = function (polyhedron) {
    return polyhedron instanceof Cuboid;
  };
  protoOf(PolyhedronUtils).isPolyhedronGroup = function (polyhedron) {
    return polyhedron instanceof PolyhedronGroup;
  };
  var PolyhedronUtils_instance;
  function PolyhedronUtils_getInstance() {
    if (PolyhedronUtils_instance == null)
      new PolyhedronUtils();
    return PolyhedronUtils_instance;
  }
  function Companion_95() {
  }
  protoOf(Companion_95).s1k = function () {
    return 68;
  };
  var Companion_instance_95;
  function Companion_getInstance_96() {
    return Companion_instance_95;
  }
  function MovedToCandidateSnapPositionComponent(snapActionCandidate) {
    this.snapActionCandidate = snapActionCandidate;
  }
  protoOf(MovedToCandidateSnapPositionComponent).x2p = function () {
    return this.snapActionCandidate;
  };
  protoOf(MovedToCandidateSnapPositionComponent).x1k = function () {
    return Companion_instance_95.id;
  };
  protoOf(MovedToCandidateSnapPositionComponent).eq = function (other) {
    return true;
  };
  function triggerMovedToCandidateSnapPositionComponent(_this__u8e3s4, snapActionCandidate) {
    _this__u8e3s4.addComponent(new MovedToCandidateSnapPositionComponent(snapActionCandidate));
    _this__u8e3s4.removeComponent(Companion_instance_95.id);
  }
  function Companion_96() {
    this.id = 45;
  }
  protoOf(Companion_96).s1k = function () {
    return this.id;
  };
  var Companion_instance_96;
  function Companion_getInstance_97() {
    return Companion_instance_96;
  }
  function MovedToValidSnapPositionComponent(snapActionCandidate) {
    this.snapActionCandidate = snapActionCandidate;
  }
  protoOf(MovedToValidSnapPositionComponent).x2p = function () {
    return this.snapActionCandidate;
  };
  protoOf(MovedToValidSnapPositionComponent).x1k = function () {
    return 45;
  };
  protoOf(MovedToValidSnapPositionComponent).eq = function (other) {
    return true;
  };
  function triggerMovedToValidSnapPositionComponent(_this__u8e3s4, snapActionCandidate) {
    _this__u8e3s4.addComponent(new MovedToValidSnapPositionComponent(snapActionCandidate));
    _this__u8e3s4.removeComponent(45);
  }
  function Companion_97() {
  }
  protoOf(Companion_97).s1k = function () {
    return 8;
  };
  var Companion_instance_97;
  function Companion_getInstance_98() {
    return Companion_instance_97;
  }
  function RestrictAllowedRequiredHostsComponent(allowedHosts) {
    this.allowedHosts = allowedHosts;
    this.w1x_1 = 0;
  }
  protoOf(RestrictAllowedRequiredHostsComponent).y2p = function () {
    return this.allowedHosts;
  };
  protoOf(RestrictAllowedRequiredHostsComponent).x1k = function () {
    return Companion_instance_97.id;
  };
  protoOf(RestrictAllowedRequiredHostsComponent).eq = function (other) {
    var otherC = other instanceof RestrictAllowedRequiredHostsComponent ? other : THROW_CCE();
    var tmp;
    if (otherC.allowedHosts.length === this.allowedHosts.length) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var indexedObject = otherC.allowedHosts;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.snapping.RestrictAllowedRequiredHostsComponent.eq.<anonymous>' call
          if (!contains(this.allowedHosts, element)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RestrictAllowedRequiredHostsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof RestrictAllowedRequiredHostsComponent))
      THROW_CCE();
    if (!contentEquals(this.allowedHosts, other.allowedHosts))
      return false;
    return true;
  };
  protoOf(RestrictAllowedRequiredHostsComponent).hashCode = function () {
    if (this.w1x_1 === 0)
      this.w1x_1 = contentHashCode(this.allowedHosts);
    return this.w1x_1;
  };
  protoOf(RestrictAllowedRequiredHostsComponent).af = function () {
    return this.allowedHosts;
  };
  protoOf(RestrictAllowedRequiredHostsComponent).v29 = function (allowedHosts) {
    return new RestrictAllowedRequiredHostsComponent(allowedHosts);
  };
  protoOf(RestrictAllowedRequiredHostsComponent).copy = function (allowedHosts, $super) {
    allowedHosts = allowedHosts === VOID ? this.allowedHosts : allowedHosts;
    return this.v29(allowedHosts);
  };
  protoOf(RestrictAllowedRequiredHostsComponent).toString = function () {
    return 'RestrictAllowedRequiredHostsComponent(allowedHosts=' + toString(this.allowedHosts) + ')';
  };
  function SnapAction_init_$Init$(candidate, $this) {
    SnapAction.call($this, candidate.host, candidate.guest, candidate.guestRoot, candidate.hostConnector, candidate.guestConnector, candidate.endTransform, candidate.initialTransform);
    return $this;
  }
  function SnapActionFromCandidate(candidate) {
    return SnapAction_init_$Init$(candidate, objectCreate(protoOf(SnapAction)));
  }
  function _get_nonDisposedGuest__7a6v6j($this) {
    var tmp;
    if ($this.guest.isDisposed) {
      tmp = null;
    } else {
      tmp = $this.guest;
    }
    return tmp;
  }
  function createConnections($this) {
    var connectorsDeltaTransform = $this.hostConnector.getDeltaTransformToGuestConnectorEntity($this.host, $this.guest, $this.guestConnector);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = getHierarchyWithComponent($this.guestRoot, 28);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapAction.createConnections.<anonymous>' call
      if (equals(element.entityManager.findEntity(element.id), element)) {
        ConnectionUtils_instance.refreshConnections(element, HierarchyUtils_instance.rootOf($this.host));
      }
    }
    var tmp0_safe_receiver = _get_nonDisposedGuest__7a6v6j($this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var connectionCausedDirectlyBySnap = new Connection(tmp0_safe_receiver, $this.guestConnector, $this.host, $this.hostConnector, connectorsDeltaTransform);
      var tmp;
      if (!hasConnectionThatCausedTheSnap($this, connectionCausedDirectlyBySnap)) {
        var tmp0_safe_receiver_0 = get_connectionRootEntity(tmp0_safe_receiver);
        var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : get_guestConnections(tmp0_safe_receiver_0);
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$3 = [connectionCausedDirectlyBySnap];
          tmp_0 = tmp1_safe_receiver.concat(tmp$ret$3);
        }
        var tmp2_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_1 = [connectionCausedDirectlyBySnap];
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var newConnections = tmp_1;
        var newGuestConnectionsComponent = new GuestConnectionsComponent(newConnections);
        var tmp3_safe_receiver = get_connectionRootEntity(tmp0_safe_receiver);
        if (tmp3_safe_receiver == null)
          null;
        else
          tmp3_safe_receiver.addComponent(newGuestConnectionsComponent);
        tmp = Unit_instance;
      }
    }
  }
  function getAffectedGroups($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = getHierarchyWithComponent($this.guestRoot, 28);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapAction.getAffectedGroups.<anonymous>' call
      var tmp$ret$0 = get_guestConnections(item);
      destination.q(tmp$ret$0);
    }
    var guestConnectionsAfterSnapping = destination;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = guestConnectionsAfterSnapping.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapping.SnapAction.getAffectedGroups.<anonymous>' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_1 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = element.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = element[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.snapping.SnapAction.getAffectedGroups.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = get_automaticEntityGroup(element_0.guestConnectionRoot);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_1.q(tmp0_safe_receiver);
        }
      }
      var list = destination_1;
      addAll(destination_0, list);
    }
    var entityGroups = distinct(destination_0);
    return entityGroups;
  }
  function hasConnectionThatCausedTheSnap($this, connection) {
    var tmp;
    var tmp_0 = connection.hostConnector;
    if (tmp_0 instanceof PointSeriesSubConnector) {
      var tmp0_safe_receiver = get_connectionRootEntity(connection.guestConnectorEntity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_guestConnections(tmp0_safe_receiver);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.snapping.SnapAction.hasConnectionThatCausedTheSnap.<anonymous>' call
            if (element.hostConnector.key === connection.hostConnector.key) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        tmp_1 = tmp$ret$1;
      }
      tmp = tmp_1 === true;
    } else {
      tmp = false;
    }
    if (tmp) {
      return true;
    }
    var tmp2_safe_receiver = get_connectionRootEntity(connection.guestConnectorEntity);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : get_guestConnections(tmp2_safe_receiver);
    return (tmp3_safe_receiver == null ? null : contains(tmp3_safe_receiver, connection)) === true;
  }
  function SnapAction(host, guest, guestRoot, hostConnector, guestConnector, endTransform, initialTransform) {
    SnapActionCandidateImpl.call(this, host, guest, guestRoot, hostConnector, guestConnector, initialTransform, endTransform);
  }
  protoOf(SnapAction).perform = function () {
    this.guest.addComponent(new SnapActionInProgressComponent());
    protoOf(SnapActionCandidateImpl).perform.call(this);
    createConnections(this);
    var entityGroups = getAffectedGroups(this);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = entityGroups.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapping.SnapAction.perform.<anonymous>' call
      setAutomaticGroupParentToHighestPrioConnectionOutsideGroup(element);
    }
    triggerMovedToValidSnapPositionComponent(this.guestRoot, this);
    var tmp0_safe_receiver = _get_nonDisposedGuest__7a6v6j(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.removeComponent(34);
    }
  };
  protoOf(SnapAction).withInitialTransform = function (io) {
    return new SnapAction(this.host, this.guest, this.guestRoot, this.hostConnector, this.guestConnector, this.endTransform, io);
  };
  protoOf(SnapAction).withNewPosition = function (newEndPosition) {
    return new SnapAction(this.host, this.guest, this.guestRoot, this.hostConnector, this.guestConnector, new Transform(newEndPosition, this.endTransform.rotation), this.initialTransform);
  };
  function SnapActionCandidate() {
  }
  function performMovement($this, productRoot) {
    TransformUtils_instance.setWorldTransform(productRoot, $this.endTransform);
  }
  function revertMovement($this) {
    TransformUtils_instance.setWorldTransform($this.guestRoot, $this.initialTransform);
  }
  function _get_inActivationDistance__r405b9($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.h2q_1;
    inActivationDistance$factory();
    return this_0.u2();
  }
  function SnapActionCandidateImpl$guestRootToGuestDeltaTransform$delegate$lambda(this$0) {
    return function () {
      return get_worldTransform(this$0.guest).delta(get_worldTransform(this$0.guestRoot));
    };
  }
  function SnapActionCandidateImpl$guestRootToGuestConnectorDeltaTransform$delegate$lambda(this$0) {
    return function () {
      return this$0.guestRootToGuestDeltaTransform.concatenate(this$0.guestConnector.transform);
    };
  }
  function SnapActionCandidateImpl$guestEndTransform$delegate$lambda(this$0) {
    return function () {
      return this$0.endTransform.concatenate(this$0.guestRootToGuestDeltaTransform);
    };
  }
  function SnapActionCandidateImpl$inActivationDistance$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.alignmentInitiatorCandidate;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnector;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.activationDistance;
      var hostActivationDistance = tmp2_elvis_lhs == null ? this$0.hostConnector.activationDistance : tmp2_elvis_lhs;
      var tmp3_safe_receiver = this$0.alignmentInitiatorCandidate;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.guestConnector;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.activationDistance;
      var guestActivationDistance = tmp5_elvis_lhs == null ? this$0.guestConnector.activationDistance : tmp5_elvis_lhs;
      var activationDistance = hostActivationDistance + guestActivationDistance;
      var tmp6_safe_receiver = this$0.alignmentInitiatorCandidate;
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.host;
      var hostOwner = tmp7_elvis_lhs == null ? this$0.host : tmp7_elvis_lhs;
      var tmp8_safe_receiver = this$0.alignmentInitiatorCandidate;
      var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.guest;
      var guestOwner = tmp9_elvis_lhs == null ? this$0.guest : tmp9_elvis_lhs;
      var tmp10_safe_receiver = this$0.alignmentInitiatorCandidate;
      var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.guestConnector;
      var guestConnectorWorldPos = (tmp11_elvis_lhs == null ? this$0.guestConnector : tmp11_elvis_lhs).getWorldPositionFromOwnerTransform(get_worldTransform(guestOwner));
      var tmp12_safe_receiver = this$0.alignmentInitiatorCandidate;
      var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.hostConnector;
      var hostConnectorWorldPos = (tmp13_elvis_lhs == null ? this$0.hostConnector : tmp13_elvis_lhs).closestWhenUsingTransform(get_worldTransform(hostOwner), guestConnectorWorldPos);
      var dist = hostConnectorWorldPos.minus(guestConnectorWorldPos).size;
      return dist <= activationDistance;
    };
  }
  function SnapActionCandidateImpl(host, guest, guestRoot, hostConnector, guestConnector, initialTransform, endTransform, overridePriority, alignmentInitiatorCandidate) {
    overridePriority = overridePriority === VOID ? null : overridePriority;
    alignmentInitiatorCandidate = alignmentInitiatorCandidate === VOID ? null : alignmentInitiatorCandidate;
    this.host = host;
    this.guest = guest;
    this.guestRoot = guestRoot;
    this.hostConnector = hostConnector;
    this.guestConnector = guestConnector;
    this.initialTransform = initialTransform;
    this.endTransform = endTransform;
    this.z2p_1 = alignmentInitiatorCandidate;
    this.a2q_1 = ActionState_NOT_DONE_getInstance();
    this.b2q_1 = this.endTransform.position.minus(this.initialTransform.position);
    this.c2q_1 = this.initialTransform.rotation.inverse().times(this.endTransform.rotation);
    var tmp = this;
    tmp.d2q_1 = overridePriority == null ? this.guestConnector.priority + this.hostConnector.priority | 0 : overridePriority;
    var tmp_0 = this;
    tmp_0.e2q_1 = lazy(SnapActionCandidateImpl$guestRootToGuestDeltaTransform$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.f2q_1 = lazy(SnapActionCandidateImpl$guestRootToGuestConnectorDeltaTransform$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.g2q_1 = lazy(SnapActionCandidateImpl$guestEndTransform$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.h2q_1 = lazy(SnapActionCandidateImpl$inActivationDistance$delegate$lambda(this));
  }
  protoOf(SnapActionCandidateImpl).i2q = function () {
    return this.host;
  };
  protoOf(SnapActionCandidateImpl).j2q = function () {
    return this.guest;
  };
  protoOf(SnapActionCandidateImpl).k2q = function () {
    return this.guestRoot;
  };
  protoOf(SnapActionCandidateImpl).r1v = function () {
    return this.hostConnector;
  };
  protoOf(SnapActionCandidateImpl).p1v = function () {
    return this.guestConnector;
  };
  protoOf(SnapActionCandidateImpl).l2q = function () {
    return this.initialTransform;
  };
  protoOf(SnapActionCandidateImpl).m2q = function () {
    return this.endTransform;
  };
  protoOf(SnapActionCandidateImpl).n2q = function () {
    return this.z2p_1;
  };
  protoOf(SnapActionCandidateImpl).f1i = function (_set____db54di) {
    this.a2q_1 = _set____db54di;
  };
  protoOf(SnapActionCandidateImpl).g1i = function () {
    return this.a2q_1;
  };
  protoOf(SnapActionCandidateImpl).o2q = function () {
    return this.b2q_1;
  };
  protoOf(SnapActionCandidateImpl).p2q = function () {
    return this.c2q_1;
  };
  protoOf(SnapActionCandidateImpl).v1v = function () {
    return this.d2q_1;
  };
  protoOf(SnapActionCandidateImpl).q2q = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e2q_1;
    guestRootToGuestDeltaTransform$factory();
    return this_0.u2();
  };
  protoOf(SnapActionCandidateImpl).r2q = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f2q_1;
    guestRootToGuestConnectorDeltaTransform$factory();
    return this_0.u2();
  };
  protoOf(SnapActionCandidateImpl).s2q = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g2q_1;
    guestEndTransform$factory();
    return this_0.u2();
  };
  protoOf(SnapActionCandidateImpl).perform = function () {
    performMovement(this, this.guestRoot);
    triggerMovedToCandidateSnapPositionComponent(this.guestRoot, this);
  };
  protoOf(SnapActionCandidateImpl).rollback = function () {
    revertMovement(this);
    triggerMovedToCandidateSnapPositionComponent(this.guestRoot, null);
  };
  protoOf(SnapActionCandidateImpl).createAction = function () {
    return SnapActionFromCandidate(this);
  };
  protoOf(SnapActionCandidateImpl).doInitialAssemblySnap = function () {
    TransformUtils_instance.setWorldTransform(this.guestRoot, this.endTransform);
    setParent(this.guestRoot, this.host);
  };
  protoOf(SnapActionCandidateImpl).toString = function () {
    if (!this.guestRoot.equals(this.guest)) {
      return 'Snap guest root ' + get_displayName(this.guestRoot) + ',' + this.guestRoot.id + ', ' + ('Guest ' + get_displayName(this.guest) + ',' + this.guest.id + ', ') + ('Host ' + get_displayName(this.host) + ',' + this.host.id);
    }
    return 'Snap,' + ('Guest ' + get_displayName(this.guest) + ', ' + this.guestConnector.key + ', ' + this.guest.id + ',') + ('Host ' + get_displayName(this.host) + ', ' + this.hostConnector.key + ', ' + this.host.id);
  };
  protoOf(SnapActionCandidateImpl).inActivationDistance = function () {
    return _get_inActivationDistance__r405b9(this);
  };
  protoOf(SnapActionCandidateImpl).withInitialTransform = function (io) {
    return new SnapActionCandidateImpl(this.host, this.guest, this.guestRoot, this.hostConnector, this.guestConnector, io, this.endTransform, VOID, this.alignmentInitiatorCandidate);
  };
  protoOf(SnapActionCandidateImpl).withNewPosition = function (newEndPosition) {
    return new SnapActionCandidateImpl(this.host, this.guest, this.guestRoot, this.hostConnector, this.guestConnector, this.initialTransform, new Transform(newEndPosition, this.endTransform.rotation));
  };
  function guestRootToGuestDeltaTransform$factory() {
    return getPropertyCallableRef('guestRootToGuestDeltaTransform', 1, KProperty1, function (receiver) {
      return receiver.guestRootToGuestDeltaTransform;
    }, null);
  }
  function guestRootToGuestConnectorDeltaTransform$factory() {
    return getPropertyCallableRef('guestRootToGuestConnectorDeltaTransform', 1, KProperty1, function (receiver) {
      return receiver.guestRootToGuestConnectorDeltaTransform;
    }, null);
  }
  function guestEndTransform$factory() {
    return getPropertyCallableRef('guestEndTransform', 1, KProperty1, function (receiver) {
      return receiver.guestEndTransform;
    }, null);
  }
  function inActivationDistance$factory() {
    return getPropertyCallableRef('inActivationDistance', 1, KProperty1, function (receiver) {
      return _get_inActivationDistance__r405b9(receiver);
    }, null);
  }
  function SnapActionCandidateSortAndSelectStrategies() {
    SnapActionCandidateSortAndSelectStrategies_instance = this;
    this.SELECT_ALL = SelectAll_instance;
    this.SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE = SortByPriorityInActivationDistanceThenDistance_instance;
    this.SORT_BY_DISTANCE = SortByDistance_instance;
    this.SORT_BY_PRIORITY_THEN_DISTANCE = SortByPriorityThenDistance_instance;
  }
  protoOf(SnapActionCandidateSortAndSelectStrategies).d2r = function () {
    return this.SELECT_ALL;
  };
  protoOf(SnapActionCandidateSortAndSelectStrategies).e2r = function () {
    return this.SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE;
  };
  protoOf(SnapActionCandidateSortAndSelectStrategies).f2r = function () {
    return this.SORT_BY_DISTANCE;
  };
  protoOf(SnapActionCandidateSortAndSelectStrategies).g2r = function () {
    return this.SORT_BY_PRIORITY_THEN_DISTANCE;
  };
  var SnapActionCandidateSortAndSelectStrategies_instance;
  function SnapActionCandidateSortAndSelectStrategies_getInstance() {
    if (SnapActionCandidateSortAndSelectStrategies_instance == null)
      new SnapActionCandidateSortAndSelectStrategies();
    return SnapActionCandidateSortAndSelectStrategies_instance;
  }
  function SnapActionCandidateSortAndSelectStrategy() {
  }
  function SelectAll() {
  }
  protoOf(SelectAll).sortAndSelect = function (snaps) {
    return snaps;
  };
  var SelectAll_instance;
  function SelectAll_getInstance() {
    return SelectAll_instance;
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this.h2r_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).u1j = function (a, b) {
    return this.h2r_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda(it) {
    return it.movement.size;
  }
  function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
    var tmp = b.priority;
    // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
    var tmp$ret$1 = a.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_1(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
    var tmp = b.priority;
    // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
    var tmp$ret$1 = a.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_2($minimumDistanceElement) {
    return function (it) {
      return minimumDistanceOrMovementDistance($minimumDistanceElement, it);
    };
  }
  function SortByPriorityInActivationDistanceThenDistance() {
  }
  protoOf(SortByPriorityInActivationDistanceThenDistance).sortAndSelect = function (snaps) {
    // Inline function 'kotlin.collections.partition' call
    var first = ArrayList_init_$Create$();
    var second = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = snaps.length;
    while (inductionVariable < last) {
      var element = snaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
      if (element.inActivationDistance()) {
        first.q(element);
      } else {
        second.q(element);
      }
    }
    var tmp0_container = new Pair(first, second);
    var snapsInActivationDistance = tmp0_container.af();
    var otherSnaps = tmp0_container.bf();
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = sortedByWithEpsilon(snapsInActivationDistance, VOID, SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_0;
    var tmp$ret$2 = new sam$kotlin_Comparator$0_2(tmp);
    var this_1 = sortedWith_0(this_0, tmp$ret$2);
    var result = copyToArray(this_1);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = otherSnaps.t();
      if (!iterator.u()) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var minElem = iterator.w();
      if (!iterator.u()) {
        tmp$ret$5 = minElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
      var minValue = minElem.movement.size;
      do {
        var e = iterator.w();
        // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
        var v = e.movement.size;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$5 = minElem;
    }
    var minimumDistanceElement = tmp$ret$5;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_0 = SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_1;
    var tmp$ret$8 = new sam$kotlin_Comparator$0_2(tmp_0);
    var tmp_1 = sortedWith_0(otherSnaps, tmp$ret$8);
    var this_2 = sortedByWithEpsilon(tmp_1, VOID, SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_2(minimumDistanceElement));
    var othersByDistance = copyToArray(this_2);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    return result.concat(othersByDistance);
  };
  var SortByPriorityInActivationDistanceThenDistance_instance;
  function SortByPriorityInActivationDistanceThenDistance_getInstance() {
    return SortByPriorityInActivationDistanceThenDistance_instance;
  }
  function sam$kotlin_Comparator$0_3(function_0) {
    this.i2r_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_3).u1j = function (a, b) {
    return this.i2r_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function SortByPriorityThenDistance$sortAndSelect$lambda(it) {
    return it.movement.size;
  }
  function SortByPriorityThenDistance$sortAndSelect$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.snapping.SortByPriorityThenDistance.sortAndSelect.<anonymous>' call
    var tmp = b.priority;
    // Inline function 'com.ikea.core.snapping.SortByPriorityThenDistance.sortAndSelect.<anonymous>' call
    var tmp$ret$1 = a.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function SortByPriorityThenDistance() {
  }
  protoOf(SortByPriorityThenDistance).sortAndSelect = function (snaps) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = sortedByWithEpsilon_0(snaps, VOID, SortByPriorityThenDistance$sortAndSelect$lambda);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = SortByPriorityThenDistance$sortAndSelect$lambda_0;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_3(tmp);
    var this_1 = sortedWith_0(this_0, tmp$ret$0);
    return copyToArray(this_1);
  };
  var SortByPriorityThenDistance_instance;
  function SortByPriorityThenDistance_getInstance() {
    return SortByPriorityThenDistance_instance;
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this.j2r_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_4).u1j = function (a, b) {
    return this.j2r_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function SortByDistance$sortAndSelect$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.snapping.SortByDistance.sortAndSelect.<anonymous>' call
    var tmp = b.priority;
    // Inline function 'com.ikea.core.snapping.SortByDistance.sortAndSelect.<anonymous>' call
    var tmp$ret$1 = a.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function SortByDistance$sortAndSelect$lambda_0(it) {
    return it.movement.size;
  }
  function SortByDistance() {
  }
  protoOf(SortByDistance).sortAndSelect = function (snaps) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = SortByDistance$sortAndSelect$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_4(tmp);
    var tmp_0 = sortedWith(snaps, tmp$ret$0);
    var this_0 = sortedByWithEpsilon(tmp_0, VOID, SortByDistance$sortAndSelect$lambda_0);
    return copyToArray(this_0);
  };
  var SortByDistance_instance;
  function SortByDistance_getInstance() {
    return SortByDistance_instance;
  }
  function sortedByWithEpsilon(_this__u8e3s4, epsilon, selector) {
    epsilon = epsilon === VOID ? 0.001 : epsilon;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = sortedByWithEpsilon$lambda(selector, epsilon);
    var tmp$ret$0 = new sam$kotlin_Comparator$0_5(tmp);
    return sortedWith_0(_this__u8e3s4, tmp$ret$0);
  }
  function minimumDistanceOrMovementDistance(minimumDistanceElement, it) {
    return (!(minimumDistanceElement == null) ? almostEquals(it.movement.size, minimumDistanceElement.movement.size) : false) ? minimumDistanceElement.movement.size : it.movement.size;
  }
  function sortedByWithEpsilon_0(_this__u8e3s4, epsilon, selector) {
    epsilon = epsilon === VOID ? 0.001 : epsilon;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = sortedByWithEpsilon$lambda_0(selector, epsilon);
    var tmp$ret$0 = new sam$kotlin_Comparator$0_6(tmp);
    return sortedWith(_this__u8e3s4, tmp$ret$0);
  }
  function sam$kotlin_Comparator$0_5(function_0) {
    this.k2r_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_5).u1j = function (a, b) {
    return this.k2r_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_6(function_0) {
    this.l2r_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_6).u1j = function (a, b) {
    return this.l2r_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_6).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sortedByWithEpsilon$lambda($selector, $epsilon) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
      var tmp = roundToInt($selector(a) / $epsilon);
      // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
      var tmp$ret$1 = roundToInt($selector(b) / $epsilon);
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function sortedByWithEpsilon$lambda_0($selector, $epsilon) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
      var tmp = roundToInt($selector(a) / $epsilon);
      // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
      var tmp$ret$1 = roundToInt($selector(b) / $epsilon);
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function Companion_98() {
    this.id = 34;
  }
  protoOf(Companion_98).s1k = function () {
    return this.id;
  };
  var Companion_instance_98;
  function Companion_getInstance_99() {
    return Companion_instance_98;
  }
  function SnapActionInProgressComponent() {
    this.m2r_1 = 34;
  }
  protoOf(SnapActionInProgressComponent).x1k = function () {
    return this.m2r_1;
  };
  protoOf(SnapActionInProgressComponent).eq = function (other) {
    return other instanceof SnapActionInProgressComponent;
  };
  function Companion_99() {
  }
  protoOf(Companion_99).s1k = function () {
    return 21;
  };
  var Companion_instance_99;
  function Companion_getInstance_100() {
    return Companion_instance_99;
  }
  function SnapCandidateComponent() {
  }
  protoOf(SnapCandidateComponent).x1k = function () {
    return Companion_instance_99.id;
  };
  protoOf(SnapCandidateComponent).eq = function (other) {
    return true;
  };
  function Companion_100() {
    this.id = 47;
  }
  protoOf(Companion_100).s1k = function () {
    return this.id;
  };
  var Companion_instance_100;
  function Companion_getInstance_101() {
    return Companion_instance_100;
  }
  function SnapRootComponent() {
  }
  protoOf(SnapRootComponent).x1k = function () {
    return 47;
  };
  protoOf(SnapRootComponent).eq = function (other) {
    return true;
  };
  function get_snappingHierarchyEntitiesList(_this__u8e3s4) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = hierarchyExceptSubTreesWithComponentArray(_this__u8e3s4, 47);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.<get-snappingHierarchyEntitiesList>.<anonymous>' call
      Companion_getInstance_23();
      if (element.hasComponent(11)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapping.<get-snappingHierarchyEntitiesList>.<anonymous>' call
      var tmp;
      var tmp0_safe_receiver = get_connectorsComponent(element_0);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
      if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
        tmp = true;
      } else {
        var tmp2_safe_receiver = get_connectorsComponent(element_0);
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
        tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
      }
      if (tmp) {
        destination_0.q(element_0);
      }
    }
    return destination_0;
  }
  function get_snappingHierarchyEntitiesSequence(_this__u8e3s4) {
    var tmp = hierarchyExceptSubTreesWithComponentSequence(_this__u8e3s4, 47);
    var tmp_0 = filter(tmp, _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj);
    return filter(tmp_0, _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj_0);
  }
  function get_snapRootSubTree(_this__u8e3s4) {
    var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_snappingHierarchyEntities(tmp0_safe_receiver);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function get_snappingHierarchyEntities(_this__u8e3s4) {
    return hierarchyExceptSubTreesWithComponentArray(_this__u8e3s4, 47);
  }
  function forEachSnappingHierarchyEntity(_this__u8e3s4, func) {
    forEachInHierarchyExceptSubHierarchiesWithComponent(_this__u8e3s4, 47, func);
  }
  function _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj(it) {
    Companion_getInstance_23();
    return it.hasComponent(11);
  }
  function _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj_0(it) {
    var tmp;
    var tmp0_safe_receiver = get_connectorsComponent(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
      tmp = true;
    } else {
      var tmp2_safe_receiver = get_connectorsComponent(it);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
      tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
    }
    return tmp;
  }
  function SnapSettings(includeAllSubConnectors, includeInternalConnectors, includeHostAssemblyParts, includeAlignmentConnectorsOutsideActivationDistance) {
    includeAllSubConnectors = includeAllSubConnectors === VOID ? false : includeAllSubConnectors;
    includeInternalConnectors = includeInternalConnectors === VOID ? false : includeInternalConnectors;
    includeHostAssemblyParts = includeHostAssemblyParts === VOID ? false : includeHostAssemblyParts;
    includeAlignmentConnectorsOutsideActivationDistance = includeAlignmentConnectorsOutsideActivationDistance === VOID ? false : includeAlignmentConnectorsOutsideActivationDistance;
    this.n2r_1 = includeAllSubConnectors;
    this.o2r_1 = includeInternalConnectors;
    this.p2r_1 = includeHostAssemblyParts;
    this.q2r_1 = includeAlignmentConnectorsOutsideActivationDistance;
  }
  protoOf(SnapSettings).r2r = function () {
    return this.n2r_1;
  };
  protoOf(SnapSettings).s2r = function () {
    return this.o2r_1;
  };
  protoOf(SnapSettings).t2r = function () {
    return this.p2r_1;
  };
  protoOf(SnapSettings).u2r = function () {
    return this.q2r_1;
  };
  function _get_logger__rkp4sl($this) {
    return LoggerState_getInstance().m1m('SnapUtils');
  }
  function findContinuousAlternativeToAlignment($this, alignmentSnapActionCandidate, continuousCandidates) {
    alignmentSnapActionCandidate.perform();
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = continuousCandidates.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.snapping.SnapUtils.findContinuousAlternativeToAlignment.<anonymous>' call
        if (element.hostConnector.containsConnector(get_worldTransform(element.host), get_worldTransform(element.guest), element.guestConnector) ? element.guestConnector.calculateRotation(get_worldTransform(element.host), element.hostConnector, get_worldTransform(element.guest)).almostEquals(Companion_getInstance_57().IDENTITY) : false) {
          destination.q(element);
        }
      }
      var iterator = destination.t();
      if (!iterator.u()) {
        tmp$ret$3 = null;
        break $l$block_0;
      }
      var maxElem = iterator.w();
      if (!iterator.u()) {
        tmp$ret$3 = maxElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.snapping.SnapUtils.findContinuousAlternativeToAlignment.<anonymous>' call
      var maxValue = maxElem.priority;
      do {
        var e = iterator.w();
        // Inline function 'com.ikea.core.snapping.SnapUtils.findContinuousAlternativeToAlignment.<anonymous>' call
        var v = e.priority;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$3 = maxElem;
    }
    var bestCandidate = tmp$ret$3;
    alignmentSnapActionCandidate.rollback();
    if (bestCandidate == null)
      return null;
    return new AlternativeSnapCandidate(bestCandidate.host, bestCandidate.guest, bestCandidate.hostConnector, bestCandidate.guestConnector);
  }
  function AlternativeSnapCandidate(hostEntity, guestEntity, hostConnector, guestConnector) {
    this.hostEntity = hostEntity;
    this.guestEntity = guestEntity;
    this.hostConnector = hostConnector;
    this.guestConnector = guestConnector;
  }
  protoOf(AlternativeSnapCandidate).v2r = function (hostEntity, guestEntity, hostConnector, guestConnector) {
    return new AlternativeSnapCandidate(hostEntity, guestEntity, hostConnector, guestConnector);
  };
  protoOf(AlternativeSnapCandidate).copy = function (hostEntity, guestEntity, hostConnector, guestConnector, $super) {
    hostEntity = hostEntity === VOID ? this.hostEntity : hostEntity;
    guestEntity = guestEntity === VOID ? this.guestEntity : guestEntity;
    hostConnector = hostConnector === VOID ? this.hostConnector : hostConnector;
    guestConnector = guestConnector === VOID ? this.guestConnector : guestConnector;
    return this.v2r(hostEntity, guestEntity, hostConnector, guestConnector);
  };
  protoOf(AlternativeSnapCandidate).toString = function () {
    return 'AlternativeSnapCandidate(hostEntity=' + this.hostEntity + ', guestEntity=' + this.guestEntity + ', hostConnector=' + this.hostConnector + ', guestConnector=' + this.guestConnector + ')';
  };
  protoOf(AlternativeSnapCandidate).hashCode = function () {
    var result = this.hostEntity.hashCode();
    result = imul(result, 31) + this.guestEntity.hashCode() | 0;
    result = imul(result, 31) + this.hostConnector.hashCode() | 0;
    result = imul(result, 31) + this.guestConnector.hashCode() | 0;
    return result;
  };
  protoOf(AlternativeSnapCandidate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AlternativeSnapCandidate))
      return false;
    var tmp0_other_with_cast = other instanceof AlternativeSnapCandidate ? other : THROW_CCE();
    if (!this.hostEntity.equals(tmp0_other_with_cast.hostEntity))
      return false;
    if (!this.guestEntity.equals(tmp0_other_with_cast.guestEntity))
      return false;
    if (!this.hostConnector.equals(tmp0_other_with_cast.hostConnector))
      return false;
    if (!this.guestConnector.equals(tmp0_other_with_cast.guestConnector))
      return false;
    return true;
  };
  function matchingSnapCandidatesOnHost$isCloseEnough($snapSettings, $hostEntity, guestConnector, snappingGuest, hostSubConnector) {
    var tmp;
    var tmp_0 = guestConnector.type;
    if (tmp_0 === 2) {
      tmp = $snapSettings.includeAlignmentConnectorsOutsideActivationDistance ? true : guestConnector.isInActivationDistance(get_worldTransform(snappingGuest), hostSubConnector, get_worldTransform($hostEntity));
    } else {
      tmp = true;
    }
    return tmp;
  }
  function matchingSnapCandidatesOnHost$isFree($hostEntity, snappingGuest, hostConnector) {
    if (!(hostConnector instanceof PointConnector))
      return true;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.none' call
      var indexedObject = get_hostedConnections($hostEntity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapCandidatesOnHost.isFree.<anonymous>' call
        if ((element.hostConnector.equals(hostConnector) ? get_isInScene(element.hostConnectorEntity) === get_isInScene(element.guestConnectorEntity) : false) ? !equals(get_snapRoot(snappingGuest), get_snapRoot(element.guestConnectorEntity)) : false) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function SnapUtils$matchingSnapCandidatesOnHost$lambda($snapSettings, $hostEntity, $matchingCandidates) {
    return function (snappingGuest) {
      var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapCandidatesOnHost.<anonymous>.<anonymous>' call
          var tmp;
          var tmp_0;
          var tmp_1 = element.type;
          if (!(tmp_1 === 1)) {
            tmp_0 = element.enabled;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp_2;
            if ($snapSettings.includeInternalConnectors) {
              tmp_2 = true;
            } else {
              var tmp_3 = element.type;
              tmp_2 = !(tmp_3 === 3);
            }
            tmp = tmp_2;
          } else {
            tmp = false;
          }
          if (tmp) {
            // Inline function 'kotlin.collections.forEach' call
            var indexedObject = get_connectors($hostEntity);
            var inductionVariable_0 = 0;
            var last_0 = indexedObject.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = indexedObject[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapCandidatesOnHost.<anonymous>.<anonymous>.<anonymous>' call
              if ((element_0.enabled ? element.hasMatchingTags(element_0) : false) ? matchingSnapCandidatesOnHost$isFree($hostEntity, snappingGuest, element_0) : false) {
                if (element_0.hasSubConnectors ? $snapSettings.includeAllSubConnectors : false) {
                  // Inline function 'kotlin.sequences.forEach' call
                  var tmp0_iterator = element_0.allSubConnectors.t();
                  while (tmp0_iterator.u()) {
                    var element_1 = tmp0_iterator.w();
                    // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapCandidatesOnHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    if (matchingSnapCandidatesOnHost$isCloseEnough($snapSettings, $hostEntity, element, snappingGuest, element_1)) {
                      $matchingCandidates.q(SnapUtils_instance.createCandidate(snappingGuest, element, $hostEntity, element_1));
                    }
                  }
                } else {
                  var tmp_4;
                  if (element_0.hasSubConnectors) {
                    tmp_4 = element_0.closestSubConnectorFromOwnerEntity($hostEntity, get_worldTransform(snappingGuest).transformPosition(element.transform.position));
                  } else {
                    tmp_4 = element_0;
                  }
                  var actualHostConnector = tmp_4;
                  if (matchingSnapCandidatesOnHost$isCloseEnough($snapSettings, $hostEntity, element, snappingGuest, actualHostConnector)) {
                    $matchingCandidates.q(SnapUtils_instance.createCandidate(snappingGuest, element, $hostEntity, actualHostConnector));
                  }
                }
              }
            }
          }
        }
      }
      return Unit_instance;
    };
  }
  function SnapUtils$matchingSnapActionCandidatesMultipleHosts$lambda() {
    return 'Trying to snap to an empty array of hosts will no longer result in snapping to the scene. If you want the old behaviour you need to call matchingSnapActionCandidatesInScene instead.';
  }
  function SnapUtils$matchingSnapActionCandidatesMultipleHosts$lambda_0($snapsList, $guestSnapRoot, $snapSettings) {
    return function (hostPart) {
      $snapsList.x(SnapUtils_instance.matchingSnapCandidatesOnHost($guestSnapRoot, hostPart, $snapSettings));
      return Unit_instance;
    };
  }
  function SnapUtils$createSnapCandidate$lambda() {
    return 'Cannot create snap action candidate, you are probably trying to snap connectors that do not have matching tags().';
  }
  function SnapUtils() {
  }
  protoOf(SnapUtils).w2r = function (guestSnapRoot, hostEntity, snapSettings) {
    if (hostEntity.equals(guestSnapRoot) ? true : isDescendantOf(hostEntity, guestSnapRoot)) {
      return emptyList();
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var matchingCandidates = ArrayList_init_$Create$();
    forEachSnappingHierarchyEntity(guestSnapRoot, SnapUtils$matchingSnapCandidatesOnHost$lambda(snapSettings, hostEntity, matchingCandidates));
    return matchingCandidates;
  };
  protoOf(SnapUtils).matchingSnapCandidatesOnHost = function (guestSnapRoot, hostEntity, snapSettings, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
    return this.w2r(guestSnapRoot, hostEntity, snapSettings);
  };
  protoOf(SnapUtils).x2r = function (guestSnapRoot, sceneManager, snapSettings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = sceneManager.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapActionCandidatesInScene.<anonymous>' call
      var tmp;
      if (!element.equals(guestSnapRoot)) {
        var tmp_0;
        var tmp0_safe_receiver = get_connectorsComponent(element);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
        if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
          tmp_0 = true;
        } else {
          var tmp2_safe_receiver = get_connectorsComponent(element);
          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
          tmp_0 = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = SnapUtils_instance.matchingSnapCandidatesOnHost(guestSnapRoot, element, snapSettings).t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapActionCandidatesInScene.<anonymous>.<anonymous>' call
          result.q(element_0);
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var snaps = copyToArray(result);
    this.replaceAlignmentSnapsWithRealSnapsWherePossible(snaps);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = snaps.length;
    while (inductionVariable_0 < last_0) {
      var element_1 = snaps[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapActionCandidatesInScene.<anonymous>' call
      if (!element_1.isAlignmentSnap) {
        destination.q(element_1);
      }
    }
    return copyToArray(destination);
  };
  protoOf(SnapUtils).matchingSnapActionCandidatesInScene = function (guestSnapRoot, sceneManager, snapSettings, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
    return this.x2r(guestSnapRoot, sceneManager, snapSettings);
  };
  protoOf(SnapUtils).y2r = function (guestSnapRoot, hostEntities, snapSettings) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (hostEntities.length === 0) {
      var tmp = _get_logger__rkp4sl(this);
      tmp.warn(SnapUtils$matchingSnapActionCandidatesMultipleHosts$lambda);
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var snapsList = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = hostEntities.length;
    while (inductionVariable < last) {
      var element = hostEntities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapActionCandidatesMultipleHosts.<anonymous>' call
      if (snapSettings.includeHostAssemblyParts) {
        forEachInHierarchyExceptSubHierarchiesWithComponent(element, 28, SnapUtils$matchingSnapActionCandidatesMultipleHosts$lambda_0(snapsList, guestSnapRoot, snapSettings));
      } else {
        snapsList.x(SnapUtils_instance.matchingSnapCandidatesOnHost(guestSnapRoot, element, snapSettings));
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var snaps = copyToArray(snapsList);
    this.replaceAlignmentSnapsWithRealSnapsWherePossible(snaps);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = snaps.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = snaps[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapUtils.matchingSnapActionCandidatesMultipleHosts.<anonymous>' call
      if (!element_0.isAlignmentSnap) {
        destination.q(element_0);
      }
    }
    return copyToArray(destination);
  };
  protoOf(SnapUtils).matchingSnapActionCandidatesMultipleHosts = function (guestSnapRoot, hostEntities, snapSettings, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
    return this.y2r(guestSnapRoot, hostEntities, snapSettings);
  };
  protoOf(SnapUtils).z2r = function (guestSnapRoot, hostEntity, snapSettings) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [hostEntity];
    return this.matchingSnapActionCandidatesMultipleHosts(guestSnapRoot, tmp$ret$2, snapSettings);
  };
  protoOf(SnapUtils).matchingSnapActionCandidates = function (guestSnapRoot, hostEntity, snapSettings, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
    return this.z2r(guestSnapRoot, hostEntity, snapSettings);
  };
  protoOf(SnapUtils).createSnapCandidate = function (snappingGuest, guestConnector, hostEntity, hostConnector) {
    if (guestConnector.hasMatchingTags(hostConnector))
      return this.createCandidate(snappingGuest, guestConnector, hostEntity, hostConnector);
    var tmp = _get_logger__rkp4sl(this);
    tmp.error(SnapUtils$createSnapCandidate$lambda);
    return null;
  };
  protoOf(SnapUtils).a2s = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey) {
    var tmp;
    if (!(connectorOnHostKey == null)) {
      var tmp0_safe_receiver = get_connectorsComponent(hostEntity);
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey(connectorOnHostKey);
    } else {
      tmp = null;
    }
    var hostBaseConnector = tmp;
    var tmp1_safe_receiver = get_connectorsComponent(guestEntity);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = tmp2_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp2_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.snapping.SnapUtils.createForcedSnapActionCandidate.<anonymous>' call
          if (element.key === connectorOnGuestKey) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_0 = tmp$ret$1;
    }
    var guestConnector = tmp_0;
    var guestTransform = get_worldTransform(guestEntity);
    var tmp_1;
    if (!(hostBaseConnector instanceof PointSeriesSubConnector)) {
      tmp_1 = hostBaseConnector == null ? null : hostBaseConnector.closestSubConnector(get_localTransform(guestEntity).position);
    } else {
      tmp_1 = hostBaseConnector;
    }
    var hostConnector = tmp_1;
    var tmp_2;
    if (hostConnector == null ? true : guestConnector == null) {
      tmp_2 = get_worldTransform(guestEntity);
    } else {
      var tmp5_hostTransform = get_worldTransform(hostEntity);
      tmp_2 = guestConnector.calculateEndTransform(tmp5_hostTransform, hostConnector, guestTransform, guestTransform);
    }
    var forcedEndTransform = tmp_2;
    var tmp6_elvis_lhs = get_snapRoot(guestEntity);
    var tmp_3 = tmp6_elvis_lhs == null ? guestEntity : tmp6_elvis_lhs;
    var tmp_4;
    if (hostConnector == null) {
      tmp_4 = new PointConnector('forced', 3, Companion_getInstance_60().IDENTITY);
    } else {
      tmp_4 = hostConnector;
    }
    var tmp_5 = tmp_4;
    var tmp_6;
    if (guestConnector == null) {
      tmp_6 = new PointConnector('forced', 3, Companion_getInstance_60().IDENTITY);
    } else {
      tmp_6 = guestConnector;
    }
    return new SnapActionCandidateImpl(hostEntity, guestEntity, tmp_3, tmp_5, tmp_6, guestTransform, forcedEndTransform);
  };
  protoOf(SnapUtils).createForcedSnapActionCandidate = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey, $super) {
    connectorOnHostKey = connectorOnHostKey === VOID ? '' : connectorOnHostKey;
    connectorOnGuestKey = connectorOnGuestKey === VOID ? '' : connectorOnGuestKey;
    return this.a2s(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey);
  };
  protoOf(SnapUtils).b2s = function (snappingGuest, guestConnector, hostEntity, hostConnector, forcedEndTransform, forcedPriority, alignmentInitiatorCandidate, initialTransform) {
    var tmp0_elvis_lhs = get_snapRoot(snappingGuest);
    var guestRoot = tmp0_elvis_lhs == null ? snappingGuest : tmp0_elvis_lhs;
    var endTransform = forcedEndTransform == null ? guestConnector.calculateEndTransform(get_worldTransform(hostEntity), hostConnector, get_worldTransform(snappingGuest), get_worldTransform(guestRoot)) : forcedEndTransform;
    return new SnapActionCandidateImpl(hostEntity, snappingGuest, guestRoot, hostConnector, guestConnector, initialTransform == null ? get_worldTransform(guestRoot) : initialTransform, endTransform, forcedPriority, alignmentInitiatorCandidate);
  };
  protoOf(SnapUtils).createCandidate = function (snappingGuest, guestConnector, hostEntity, hostConnector, forcedEndTransform, forcedPriority, alignmentInitiatorCandidate, initialTransform, $super) {
    forcedEndTransform = forcedEndTransform === VOID ? null : forcedEndTransform;
    forcedPriority = forcedPriority === VOID ? null : forcedPriority;
    alignmentInitiatorCandidate = alignmentInitiatorCandidate === VOID ? null : alignmentInitiatorCandidate;
    initialTransform = initialTransform === VOID ? null : initialTransform;
    return this.b2s(snappingGuest, guestConnector, hostEntity, hostConnector, forcedEndTransform, forcedPriority, alignmentInitiatorCandidate, initialTransform);
  };
  protoOf(SnapUtils).replaceAlignmentSnapsWithRealSnapsWherePossible = function (snaps) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = snaps.length;
    while (inductionVariable < last) {
      var element = snaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.SnapUtils.replaceAlignmentSnapsWithRealSnapsWherePossible.<anonymous>' call
      if (!element.isAlignmentSnap) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapping.SnapUtils.replaceAlignmentSnapsWithRealSnapsWherePossible.<anonymous>' call
      if (element_0.hostConnector.isContinuousConnector) {
        destination_0.q(element_0);
      }
    }
    var continuousCandidates = destination_0;
    var inductionVariable_0 = 0;
    var last_0 = snaps.length;
    while (inductionVariable_0 < last_0) {
      var i = inductionVariable_0;
      var snapCandidate = snaps[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (snapCandidate.isAlignmentSnap) {
        var tmp2_elvis_lhs = this.tryToReplaceAlignmentWithRealCandidate(snapCandidate, continuousCandidates);
        snaps[i] = tmp2_elvis_lhs == null ? snapCandidate : tmp2_elvis_lhs;
      }
    }
  };
  protoOf(SnapUtils).tryToReplaceAlignmentWithRealCandidate = function (alignmentSnapActionCandidate, continuousCandidates) {
    var alternativeRealCandidate = findContinuousAlternativeToAlignment(this, alignmentSnapActionCandidate, continuousCandidates);
    var tmp;
    if (alternativeRealCandidate == null) {
      tmp = null;
    } else {
      var forcedPriority = alignmentSnapActionCandidate.priority;
      tmp = this.createCandidate(alternativeRealCandidate.guestEntity, alternativeRealCandidate.guestConnector, alternativeRealCandidate.hostEntity, alternativeRealCandidate.hostConnector, alignmentSnapActionCandidate.endTransform, forcedPriority, alignmentSnapActionCandidate);
    }
    return tmp;
  };
  protoOf(SnapUtils).isNewPositionOnHostConnector = function (candidate, newPos) {
    return this.isNewTransformOnHostConnector(candidate, candidate.endTransform.copy(newPos));
  };
  protoOf(SnapUtils).isNewTransformOnHostConnector = function (candidate, newEndTransform) {
    var transformFromRootToConnectingEntity = get_worldTransform(candidate.guest).delta(get_worldTransform(candidate.guestRoot));
    var newConnectingEntityTransform = newEndTransform.concatenate(transformFromRootToConnectingEntity);
    var newPositionStillCanConnectToToSameConnector = candidate.hostConnector.containsConnector(get_worldTransform(candidate.host), newConnectingEntityTransform, candidate.guestConnector);
    return newPositionStillCanConnectToToSameConnector;
  };
  var SnapUtils_instance;
  function SnapUtils_getInstance() {
    return SnapUtils_instance;
  }
  function EntityState(entityId, components) {
    var tmp;
    if (components === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = components;
    }
    components = tmp;
    this.entityId = entityId;
    this.c2s_1 = new ComponentHolder();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = components.length;
    while (inductionVariable < last) {
      var element = components[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapshot.EntityState.<anonymous>' call
      this.c2s_1.addComponent(element);
    }
  }
  protoOf(EntityState).z2o = function () {
    return this.entityId;
  };
  protoOf(EntityState).components = function () {
    return this.c2s_1.components();
  };
  protoOf(EntityState).getComponent = function (componentId) {
    return this.c2s_1.__getComponentForKotlin(componentId);
  };
  protoOf(EntityState).hasComponent = function (componentId) {
    return this.c2s_1.hasComponent(componentId);
  };
  protoOf(EntityState).toString = function () {
    return 'Entity ' + this.entityId;
  };
  function Companion_101() {
  }
  protoOf(Companion_101).s1k = function () {
    return 36;
  };
  var Companion_instance_101;
  function Companion_getInstance_102() {
    return Companion_instance_101;
  }
  function IsLoadingSnapshotComponent() {
    this.d2s_1 = false;
  }
  protoOf(IsLoadingSnapshotComponent).x1k = function () {
    return Companion_instance_101.id;
  };
  protoOf(IsLoadingSnapshotComponent).a1l = function () {
    return this.d2s_1;
  };
  protoOf(IsLoadingSnapshotComponent).eq = function (other) {
    return true;
  };
  function Companion_102() {
    this.ID = 95;
  }
  protoOf(Companion_102).u1n = function () {
    return this.ID;
  };
  var Companion_instance_102;
  function Companion_getInstance_103() {
    return Companion_instance_102;
  }
  function SnapshotIgnoreComponent() {
    this.e2s_1 = Companion_instance_102.ID;
  }
  protoOf(SnapshotIgnoreComponent).x1k = function () {
    return this.e2s_1;
  };
  protoOf(SnapshotIgnoreComponent).eq = function (other) {
    return true;
  };
  function setExistingEntityStates($this, snapshot) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = snapshot.entityStates.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>' call
      var currentEntity = $this.entityManager.findEntity(element.entityId);
      var entityStateBeforeLoadingSnapshot = currentEntity == null ? null : new EntityState(element.entityId, currentEntity.components());
      var tmp1_safe_receiver = currentEntity == null ? null : currentEntity.components();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element_0 = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>.<anonymous>' call
          if (element_0.doStoreInSnapshot) {
            destination.q(element_0);
          }
        }
        tmp = destination;
      }
      var tmp2_safe_receiver = tmp;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = tmp2_safe_receiver.t();
        while (tmp0_iterator_0.u()) {
          var element_1 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>.<anonymous>' call
          currentEntity.removeComponentInternal(element_1.typeId);
        }
      }
      var entityAfterSnapshot = currentEntity == null ? $this.entityManager.createEntityInternal(element.entityId) : currentEntity;
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = element.components();
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_2 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>.<anonymous>' call
        entityAfterSnapshot.addComponentInternal(element_2);
      }
      entityAfterSnapshot.addComponent(new UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot, entityAfterSnapshot));
      entityAfterSnapshot.removeComponent(123);
    }
  }
  function removeEntitiesNoLongerPresent($this, snapshot) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.entityManager.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>' call
      if (!element.hasComponent(Companion_instance_102.ID)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>' call
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var this_1 = snapshot.entityStates;
        var tmp;
        if (isInterface(this_1, Collection)) {
          tmp = this_1.b1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
        var tmp0_iterator_0 = this_1.t();
        while (tmp0_iterator_0.u()) {
          var element_1 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>.<anonymous>' call
          if (element_1.entityId === element_0.id) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
        }
        tmp$ret$3 = true;
      }
      if (tmp$ret$3) {
        destination_0.q(element_0);
      }
    }
    var entitiesToRemove = destination_0;
    var tmp_0 = Companion_getInstance_104().logger;
    tmp_0.debug(SnapshotService$removeEntitiesNoLongerPresent$lambda(entitiesToRemove));
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = entitiesToRemove.t();
    while (tmp0_iterator_1.u()) {
      var element_2 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>' call
      element_2.addComponent(new UpdatedFromSnapshotEventComponent(createEntityState($this, element_2), null));
      element_2.removeComponent(123);
      $this.entityManager.removeEntityInternal(element_2);
    }
  }
  function createEntityState($this, entity) {
    return new EntityState(entity.id, entity.components());
  }
  function Companion_103() {
    Companion_instance_103 = this;
    this.logger = LoggerState_getInstance().m1m('SnapshotService');
  }
  protoOf(Companion_103).x1i = function () {
    return this.logger;
  };
  var Companion_instance_103;
  function Companion_getInstance_104() {
    if (Companion_instance_103 == null)
      new Companion_103();
    return Companion_instance_103;
  }
  function SnapshotService$removeEntitiesNoLongerPresent$lambda($entitiesToRemove) {
    return function () {
      // Inline function 'kotlin.collections.map' call
      var this_0 = $entitiesToRemove;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>.<anonymous>' call
        destination.q(item);
      }
      return 'Will remove entities when loading snapshot: ' + destination;
    };
  }
  function SnapshotService(entityManager, sceneManager) {
    Companion_getInstance_104();
    this.entityManager = entityManager;
    this.sceneManager = sceneManager;
  }
  protoOf(SnapshotService).p1i = function () {
    return this.entityManager;
  };
  protoOf(SnapshotService).q1i = function () {
    return this.sceneManager;
  };
  protoOf(SnapshotService).takeSnapshot = function (name) {
    if (this.sceneManager.root.hasComponent(Companion_instance_101.id)) {
      // Inline function 'kotlin.error' call
      var message = 'Not allowed to take snapshot while another snapshot is being loaded.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.entityManager.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapshot.SnapshotService.takeSnapshot.<anonymous>' call
      if (!element.hasComponent(Companion_instance_102.ID)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.snapshot.SnapshotService.takeSnapshot.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = item.components();
      var destination_1 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.snapshot.SnapshotService.takeSnapshot.<anonymous>.<anonymous>' call
        if (element_0.doStoreInSnapshot) {
          destination_1.q(element_0);
        }
      }
      var clonedComponents = copyToArray(destination_1);
      var tmp$ret$7 = new EntityState(item.id, clonedComponents);
      destination_0.q(tmp$ret$7);
    }
    var entityStates = destination_0;
    return new Snapshot(name, entityStates);
  };
  protoOf(SnapshotService).compare = function (snapshot1, snapshot2) {
    println(snapshot1);
    println(snapshot2);
  };
  protoOf(SnapshotService).loadSnapshot = function (snapshot) {
    this.sceneManager.root.addComponent(new IsLoadingSnapshotComponent());
    removeEntitiesNoLongerPresent(this, snapshot);
    setExistingEntityStates(this, snapshot);
    this.sceneManager.root.removeComponent(Companion_instance_101.id);
  };
  function Snapshot(name, entityStates) {
    this.name = name;
    this.entityStates = entityStates;
  }
  protoOf(Snapshot).mb = function () {
    return this.name;
  };
  protoOf(Snapshot).f2s = function () {
    return this.entityStates;
  };
  protoOf(Snapshot).g2s = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.entityStates;
    return copyToArray(this_0);
  };
  protoOf(Snapshot).af = function () {
    return this.name;
  };
  protoOf(Snapshot).bf = function () {
    return this.entityStates;
  };
  protoOf(Snapshot).h2s = function (name, entityStates) {
    return new Snapshot(name, entityStates);
  };
  protoOf(Snapshot).copy = function (name, entityStates, $super) {
    name = name === VOID ? this.name : name;
    entityStates = entityStates === VOID ? this.entityStates : entityStates;
    return this.h2s(name, entityStates);
  };
  protoOf(Snapshot).toString = function () {
    return 'Snapshot(name=' + this.name + ', entityStates=' + this.entityStates + ')';
  };
  protoOf(Snapshot).hashCode = function () {
    var result = getStringHashCode(this.name);
    result = imul(result, 31) + hashCode(this.entityStates) | 0;
    return result;
  };
  protoOf(Snapshot).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Snapshot))
      return false;
    var tmp0_other_with_cast = other instanceof Snapshot ? other : THROW_CCE();
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    if (!equals(this.entityStates, tmp0_other_with_cast.entityStates))
      return false;
    return true;
  };
  function Companion_104() {
    this.id = 123;
  }
  protoOf(Companion_104).s1k = function () {
    return this.id;
  };
  var Companion_instance_104;
  function Companion_getInstance_105() {
    return Companion_instance_104;
  }
  function UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot, entity) {
    this.entityStateBeforeLoadingSnapshot = entityStateBeforeLoadingSnapshot;
    this.entity = entity;
    this.k2i_1 = 123;
    this.l2i_1 = false;
  }
  protoOf(UpdatedFromSnapshotEventComponent).i2s = function () {
    return this.entityStateBeforeLoadingSnapshot;
  };
  protoOf(UpdatedFromSnapshotEventComponent).r23 = function () {
    return this.entity;
  };
  protoOf(UpdatedFromSnapshotEventComponent).x1k = function () {
    return this.k2i_1;
  };
  protoOf(UpdatedFromSnapshotEventComponent).eq = function (other) {
    return false;
  };
  protoOf(UpdatedFromSnapshotEventComponent).a1l = function () {
    return this.l2i_1;
  };
  protoOf(UpdatedFromSnapshotEventComponent).af = function () {
    return this.entityStateBeforeLoadingSnapshot;
  };
  protoOf(UpdatedFromSnapshotEventComponent).bf = function () {
    return this.entity;
  };
  protoOf(UpdatedFromSnapshotEventComponent).j2s = function (entityStateBeforeLoadingSnapshot, entity) {
    return new UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot, entity);
  };
  protoOf(UpdatedFromSnapshotEventComponent).copy = function (entityStateBeforeLoadingSnapshot, entity, $super) {
    entityStateBeforeLoadingSnapshot = entityStateBeforeLoadingSnapshot === VOID ? this.entityStateBeforeLoadingSnapshot : entityStateBeforeLoadingSnapshot;
    entity = entity === VOID ? this.entity : entity;
    return this.j2s(entityStateBeforeLoadingSnapshot, entity);
  };
  protoOf(UpdatedFromSnapshotEventComponent).toString = function () {
    return 'UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot=' + this.entityStateBeforeLoadingSnapshot + ', entity=' + this.entity + ')';
  };
  protoOf(UpdatedFromSnapshotEventComponent).hashCode = function () {
    var result = this.entityStateBeforeLoadingSnapshot == null ? 0 : hashCode(this.entityStateBeforeLoadingSnapshot);
    result = imul(result, 31) + (this.entity == null ? 0 : this.entity.hashCode()) | 0;
    return result;
  };
  protoOf(UpdatedFromSnapshotEventComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdatedFromSnapshotEventComponent))
      return false;
    var tmp0_other_with_cast = other instanceof UpdatedFromSnapshotEventComponent ? other : THROW_CCE();
    if (!equals(this.entityStateBeforeLoadingSnapshot, tmp0_other_with_cast.entityStateBeforeLoadingSnapshot))
      return false;
    if (!equals(this.entity, tmp0_other_with_cast.entity))
      return false;
    return true;
  };
  function ApiSystemIds() {
    this.CONNECTION_PARENTING_SYSTEM_ID = 'ConnectionParentingSystem';
    this.AUTOMATIC_GROUP_BUILDER_SYSTEM_ID = 'AutomaticGroupBuilderSystem';
    this.HIERARCHY_SYSTEM_ID = 'HierarchySystem';
    this.SCENE_GRAPH_SYSTEM_ID = 'SceneGraphSystem';
    this.TRANSFORM_SYSTEM_ID = 'TransformSystem';
    this.DISABLE_CONNECTORS_SYSTEM_ID = 'DisableConnectorsSystem';
    this.RENDER_SYSTEM_ID = 'RenderSystem';
    this.WORLD_COLLIDER_UPDATE_SYSTEM_ID = 'WorldColliderUpdateSystem';
    this.VIEWER_PRESENCE_SYSTEM_ID = 'ViewerPresenceSystem';
    this.MODEL_LOADER_SYSTEM_ID = 'ModelLoaderSystem';
    this.VIEWER_OBJECT_TRANSFORM_SYSTEM_ID = 'ViewerObjectTransformSystem';
    this.VIEWER_OBJECT_VISIBILITY_SYSTEM_ID = 'ViewerObjectVisibilitySystem';
  }
  protoOf(ApiSystemIds).k2s = function () {
    return this.CONNECTION_PARENTING_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).l2s = function () {
    return this.AUTOMATIC_GROUP_BUILDER_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).m2s = function () {
    return this.HIERARCHY_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).n2s = function () {
    return this.SCENE_GRAPH_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).o2s = function () {
    return this.TRANSFORM_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).p2s = function () {
    return this.DISABLE_CONNECTORS_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).q2s = function () {
    return this.RENDER_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).r2s = function () {
    return this.WORLD_COLLIDER_UPDATE_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).s2s = function () {
    return this.VIEWER_PRESENCE_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).t2s = function () {
    return this.MODEL_LOADER_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).u2s = function () {
    return this.VIEWER_OBJECT_TRANSFORM_SYSTEM_ID;
  };
  protoOf(ApiSystemIds).v2s = function () {
    return this.VIEWER_OBJECT_VISIBILITY_SYSTEM_ID;
  };
  var ApiSystemIds_instance;
  function ApiSystemIds_getInstance() {
    return ApiSystemIds_instance;
  }
  function AlwaysHangDownComponent() {
  }
  protoOf(AlwaysHangDownComponent).x1k = function () {
    return this.id;
  };
  protoOf(AlwaysHangDownComponent).s1k = function () {
    return 26;
  };
  protoOf(AlwaysHangDownComponent).eq = function (other) {
    return true;
  };
  var AlwaysHangDownComponent_instance;
  function AlwaysHangDownComponent_getInstance() {
    return AlwaysHangDownComponent_instance;
  }
  function get_isHanging(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(AlwaysHangDownComponent_instance.id);
  }
  function Companion_105() {
  }
  protoOf(Companion_105).l17 = function () {
    return $serializer_getInstance_15();
  };
  var Companion_instance_105;
  function Companion_getInstance_106() {
    return Companion_instance_105;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.transforms.LocalTransformComponent.Serialized', this, 2);
    tmp0_serialDesc.cv('p', false);
    tmp0_serialDesc.cv('r', false);
    this.w2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).ok = function () {
    return this.w2s_1;
  };
  protoOf($serializer_15).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_8(), $serializer_getInstance_4()];
  };
  protoOf($serializer_15).qk = function (decoder) {
    var tmp0_desc = this.w2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return Serialized_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_15).x2s = function (encoder, value) {
    var tmp0_desc = this.w2s_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance_8(), value.y2s_1);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_4(), value.z2s_1);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_15).pk = function (encoder, value) {
    return this.x2s(encoder, value instanceof Serialized_0 ? value : THROW_CCE());
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function Serialized_init_$Init$_0(seen1, p, r, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_15().w2s_1);
    }
    $this.y2s_1 = p;
    $this.z2s_1 = r;
    return $this;
  }
  function Serialized_init_$Create$_0(seen1, p, r, serializationConstructorMarker) {
    return Serialized_init_$Init$_0(seen1, p, r, serializationConstructorMarker, objectCreate(protoOf(Serialized_0)));
  }
  function LocalTransformComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function LocalTransformComponent_init_$Init$(pos, rot, $this) {
    LocalTransformComponent.call($this, new Transform(pos, rot));
    return $this;
  }
  function LocalTransformComponentFromPosAndRot(pos, rot) {
    return LocalTransformComponent_init_$Init$(pos, rot, objectCreate(protoOf(LocalTransformComponent)));
  }
  function Serialized_0(p, r) {
    this.y2s_1 = p;
    this.z2s_1 = r;
  }
  function Companion_106() {
    Companion_instance_106 = this;
    this.id = 6;
    this.IDENTITY = LocalTransformComponentFromPosAndRot(Companion_getInstance_61().ZERO, Companion_getInstance_57().IDENTITY);
    this.serializationKey = 'LocalTransformComponent';
    var tmp = this;
    tmp.v28_1 = Json(VOID, LocalTransformComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_106).s1k = function () {
    return this.id;
  };
  protoOf(Companion_106).x2c = function () {
    return this.IDENTITY;
  };
  protoOf(Companion_106).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_106).fromJson = function (json) {
    var result = this.v28_1.l15(Companion_instance_105.l17(), json);
    return new LocalTransformComponent(new Transform(result.y2s_1, result.z2s_1));
  };
  var Companion_instance_106;
  function Companion_getInstance_107() {
    if (Companion_instance_106 == null)
      new Companion_106();
    return Companion_instance_106;
  }
  function LocalTransformComponent(transform) {
    Companion_getInstance_107();
    this.transform = transform;
    this.a2t_1 = false;
  }
  protoOf(LocalTransformComponent).d1x = function () {
    return this.transform;
  };
  protoOf(LocalTransformComponent).toJson = function (parse) {
    return Companion_getInstance_107().v28_1.k15(Companion_instance_105.l17(), new Serialized_0(this.transform.position, this.transform.rotation));
  };
  protoOf(LocalTransformComponent).serializationKey = function () {
    return 'LocalTransformComponent';
  };
  protoOf(LocalTransformComponent).z1k = function () {
    return this.a2t_1;
  };
  protoOf(LocalTransformComponent).x1k = function () {
    return 6;
  };
  protoOf(LocalTransformComponent).hashCode = function () {
    return this.transform.hashCode();
  };
  protoOf(LocalTransformComponent).equals = function (other) {
    var tmp;
    if (other instanceof LocalTransformComponent) {
      tmp = this.transform.equals(other.transform);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LocalTransformComponent).eq = function (other) {
    var otherLoc = other instanceof LocalTransformComponent ? other : THROW_CCE();
    return this.transform.equals(otherLoc.transform);
  };
  protoOf(LocalTransformComponent).moveInParentSpace = function (v) {
    return LocalTransformComponentFromPosAndRot(this.transform.position.plus(v), this.transform.rotation);
  };
  protoOf(LocalTransformComponent).applyMoveInParentSpace = function (entity, v) {
    if (v.notZero()) {
      entity.addComponent(this.moveInParentSpace(v));
    }
    return entity;
  };
  protoOf(LocalTransformComponent).b2t = function (q) {
    return LocalTransformComponentFromPosAndRot(this.transform.position, this.transform.rotation.times(q));
  };
  protoOf(LocalTransformComponent).rotate = function (entity, q) {
    if (!q.isIdentity) {
      if (this.transform.rotation.isIdentity) {
        entity.addComponent(LocalTransformComponentFromPosAndRot(this.transform.position, q));
      } else {
        entity.addComponent(this.b2t(q));
      }
    }
    return entity;
  };
  protoOf(LocalTransformComponent).transformToWorld = function (me) {
    var tmp0_safe_receiver = get_parent(me);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.transforms.LocalTransformComponent.transformToWorld.<anonymous>' call
      var tmp_0;
      if (this.transform.position.isZero() ? this.transform.rotation.isIdentity : false) {
        tmp_0 = get_worldTransform(tmp0_safe_receiver);
      } else {
        var parentWorld = get_worldTransform(tmp0_safe_receiver);
        var worldPos = parentWorld.transformPosition(this.transform.position);
        var worldRot = this.transform.rotation.times(parentWorld.rotation);
        tmp_0 = new Transform(worldPos, worldRot);
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.transform : tmp1_elvis_lhs;
  };
  protoOf(LocalTransformComponent).af = function () {
    return this.transform;
  };
  protoOf(LocalTransformComponent).c2t = function (transform) {
    return new LocalTransformComponent(transform);
  };
  protoOf(LocalTransformComponent).copy = function (transform, $super) {
    transform = transform === VOID ? this.transform : transform;
    return this.c2t(transform);
  };
  protoOf(LocalTransformComponent).toString = function () {
    return 'LocalTransformComponent(transform=' + this.transform + ')';
  };
  function get_localTransform(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(6);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.transform;
    return tmp1_elvis_lhs == null ? Companion_getInstance_60().IDENTITY : tmp1_elvis_lhs;
  }
  function Companion_107() {
    this.ID = 'TransformSystem';
  }
  protoOf(Companion_107).u1n = function () {
    return this.ID;
  };
  var Companion_instance_107;
  function Companion_getInstance_108() {
    return Companion_instance_107;
  }
  function TransformSystem() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [10];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['HierarchySystem'];
    SystemBase.call(this, 'TransformSystem', 6, tmp, tmp$ret$5, null);
  }
  protoOf(TransformSystem).onAddComponent = function (entity, newComponent) {
    TransformUtils_instance.updateWorldTransform(entity);
  };
  protoOf(TransformSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    TransformUtils_instance.updateWorldTransform(entity);
  };
  protoOf(TransformSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  function TransformUtils() {
  }
  protoOf(TransformUtils).worldTransform = function (entity) {
    return get_worldTransform(entity);
  };
  protoOf(TransformUtils).localTransform = function (entity) {
    return get_localTransform(entity);
  };
  protoOf(TransformUtils).worldPosition = function (entity) {
    return get_worldPosition(entity);
  };
  protoOf(TransformUtils).localPosition = function (entity) {
    return get_localTransform(entity).position;
  };
  protoOf(TransformUtils).worldRotation = function (entity) {
    return get_worldRotation(entity);
  };
  protoOf(TransformUtils).rotate = function (entity, rotation) {
    var localTransform = get_localTransform(entity);
    localTransform = new Transform(localTransform.position, localTransform.rotation.times(rotation));
    var localTransformComponent = new LocalTransformComponent(localTransform);
    entity.addComponent(localTransformComponent);
  };
  protoOf(TransformUtils).moveInParentSpace = function (entity, v) {
    var localTransformComponent = LocalTransformComponentFromPosAndRot(get_localTransform(entity).position.plus(v), get_localTransform(entity).rotation);
    entity.addComponent(localTransformComponent);
  };
  protoOf(TransformUtils).moveInLocalSpace = function (entity, v) {
    var localV = v.rotate(get_localTransform(entity).rotation);
    var localTransformComponent = LocalTransformComponentFromPosAndRot(get_localTransform(entity).position.plus(localV), get_localTransform(entity).rotation);
    entity.addComponent(localTransformComponent);
  };
  protoOf(TransformUtils).moveInWorldSpace = function (entity, v) {
    var newWorldPos = get_worldPosition(entity).plus(v);
    this.setWorldTransform(entity, new Transform(newWorldPos, get_worldRotation(entity)));
  };
  protoOf(TransformUtils).updateWorldTransform = function (entity) {
    var newWorld = Companion_getInstance_110().calculate(entity);
    var tmp;
    Companion_getInstance_110();
    if (!entity.hasComponent(10)) {
      tmp = true;
    } else {
      tmp = !newWorld.transform.equals(get_worldTransform(entity));
    }
    if (tmp) {
      entity.addComponent(newWorld);
      var tmp0_safe_receiver = get_parentComponent(entity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allDescendants();
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.transforms.TransformUtils.updateWorldTransform.<anonymous>' call
          TransformUtils_instance.updateWorldTransform(element);
        }
      }
    }
  };
  protoOf(TransformUtils).applyWorldTransform = function (polyhedron, entity) {
    return polyhedron.transform(get_worldTransform(entity));
  };
  protoOf(TransformUtils).setLocalPosition = function (entity, position) {
    var old = get_localTransform(entity);
    this.setLocalTransform(entity, new Transform(position, old.rotation));
  };
  protoOf(TransformUtils).setLocalRotation = function (entity, rotation) {
    var old = get_localTransform(entity);
    this.setLocalTransform(entity, new Transform(old.position, rotation));
  };
  protoOf(TransformUtils).setLocalTransform = function (entity, transform) {
    entity.addComponent(new LocalTransformComponent(transform));
  };
  protoOf(TransformUtils).setWorldTransform = function (entity, transform) {
    var tmp0_safe_receiver = get_parent(entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
    var parentTransform = tmp1_elvis_lhs == null ? Companion_getInstance_60().IDENTITY : tmp1_elvis_lhs;
    var relativePosition = parentTransform.inverseTransformPosition(transform.position);
    var relativeRotation = transform.rotation.times(parentTransform.rotation.inverse());
    var newLocalTransform = new Transform(relativePosition, relativeRotation);
    this.setLocalTransform(entity, newLocalTransform);
  };
  protoOf(TransformUtils).setWorldPosition = function (entity, position) {
    this.setWorldTransform(entity, new Transform(position, get_worldRotation(entity)));
  };
  var TransformUtils_instance;
  function TransformUtils_getInstance() {
    return TransformUtils_instance;
  }
  function Companion_108() {
  }
  protoOf(Companion_108).l17 = function () {
    return $serializer_getInstance_16();
  };
  var Companion_instance_108;
  function Companion_getInstance_109() {
    return Companion_instance_108;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.transforms.WorldTransformComponent.Serialized', this, 2);
    tmp0_serialDesc.cv('p', false);
    tmp0_serialDesc.cv('r', false);
    this.d2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).ok = function () {
    return this.d2t_1;
  };
  protoOf($serializer_16).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_8(), $serializer_getInstance_4()];
  };
  protoOf($serializer_16).qk = function (decoder) {
    var tmp0_desc = this.d2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return Serialized_init_$Create$_1(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_16).e2t = function (encoder, value) {
    var tmp0_desc = this.d2t_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance_8(), value.f2t_1);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_4(), value.g2t_1);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_16).pk = function (encoder, value) {
    return this.e2t(encoder, value instanceof Serialized_1 ? value : THROW_CCE());
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function Serialized_init_$Init$_1(seen1, p, r, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_16().d2t_1);
    }
    $this.f2t_1 = p;
    $this.g2t_1 = r;
    return $this;
  }
  function Serialized_init_$Create$_1(seen1, p, r, serializationConstructorMarker) {
    return Serialized_init_$Init$_1(seen1, p, r, serializationConstructorMarker, objectCreate(protoOf(Serialized_1)));
  }
  function WorldTransformComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function WorldTransformComponent_init_$Init$(pos, rot, $this) {
    WorldTransformComponent.call($this, new Transform(pos, rot));
    return $this;
  }
  function WorldTransformComponentFromPosAndRot(pos, rot) {
    return WorldTransformComponent_init_$Init$(pos, rot, objectCreate(protoOf(WorldTransformComponent)));
  }
  function Serialized_1(p, r) {
    this.f2t_1 = p;
    this.g2t_1 = r;
  }
  function Companion_109() {
    Companion_instance_109 = this;
    this.id = 10;
    this.IDENTITY = WorldTransformComponentFromPosAndRot(Companion_getInstance_61().ZERO, Companion_getInstance_57().IDENTITY);
    this.serializationKey = 'WorldTransformComponent';
    var tmp = this;
    tmp.h2t_1 = Json(VOID, WorldTransformComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_109).s1k = function () {
    return this.id;
  };
  protoOf(Companion_109).x2c = function () {
    return this.IDENTITY;
  };
  protoOf(Companion_109).calculate = function (entity) {
    Companion_getInstance_107();
    var tmp0_elvis_lhs = entity.__getComponentForKotlin(6);
    var local = tmp0_elvis_lhs == null ? Companion_getInstance_107().IDENTITY : tmp0_elvis_lhs;
    var world = local.transformToWorld(entity);
    return new WorldTransformComponent(world);
  };
  protoOf(Companion_109).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_109).fromJson = function (json) {
    var result = this.h2t_1.l15(Companion_instance_108.l17(), json);
    return new WorldTransformComponent(new Transform(result.f2t_1, result.g2t_1));
  };
  var Companion_instance_109;
  function Companion_getInstance_110() {
    if (Companion_instance_109 == null)
      new Companion_109();
    return Companion_instance_109;
  }
  function WorldTransformComponent(transform) {
    Companion_getInstance_110();
    this.transform = transform;
  }
  protoOf(WorldTransformComponent).d1x = function () {
    return this.transform;
  };
  protoOf(WorldTransformComponent).x1k = function () {
    return 10;
  };
  protoOf(WorldTransformComponent).toJson = function (parse) {
    return Companion_getInstance_110().h2t_1.k15(Companion_instance_108.l17(), new Serialized_1(this.transform.position, this.transform.rotation));
  };
  protoOf(WorldTransformComponent).serializationKey = function () {
    return 'WorldTransformComponent';
  };
  protoOf(WorldTransformComponent).hashCode = function () {
    return this.transform.hashCode();
  };
  protoOf(WorldTransformComponent).equals = function (other) {
    var tmp;
    if (other instanceof WorldTransformComponent) {
      tmp = this.transform.equals(other.transform);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(WorldTransformComponent).eq = function (other) {
    return (other instanceof WorldTransformComponent ? other : THROW_CCE()).transform.equals(this.transform);
  };
  protoOf(WorldTransformComponent).toString = function () {
    return 'World :' + this.transform;
  };
  protoOf(WorldTransformComponent).af = function () {
    return this.transform;
  };
  protoOf(WorldTransformComponent).c2t = function (transform) {
    return new WorldTransformComponent(transform);
  };
  protoOf(WorldTransformComponent).copy = function (transform, $super) {
    transform = transform === VOID ? this.transform : transform;
    return this.c2t(transform);
  };
  function get_worldTransform(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(10);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.transform;
    return tmp1_elvis_lhs == null ? Companion_getInstance_60().IDENTITY : tmp1_elvis_lhs;
  }
  function get_worldRotation(_this__u8e3s4) {
    return get_worldTransform(_this__u8e3s4).rotation;
  }
  function get_worldPosition(_this__u8e3s4) {
    return get_worldTransform(_this__u8e3s4).position;
  }
  function Measurable() {
  }
  function Measurer() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.k2t_1 = LinkedHashMap_init_$Create$_0();
    this.l2t_1 = Monotonic_instance;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.m2t_1 = LinkedHashMap_init_$Create$_0();
  }
  protoOf(Measurer).clear = function () {
    this.k2t_1.z();
    this.m2t_1.z();
  };
  protoOf(Measurer).start = function (id) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.m2t_1;
    var value = new ValueTimeMark(this.l2t_1.da());
    this_0.r2(id, value);
  };
  protoOf(Measurer).stop = function (id) {
    var tmp0_safe_receiver = this.m2t_1.b3(id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.utils.Measurer.stop.<anonymous>' call
      var duration = tmp0_safe_receiver.di();
      $l$block: {
        // Inline function 'com.ikea.core.utils.orElse' call
        var tmp0_safe_receiver_0 = this.k2t_1.b3(id);
        if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.q(new Duration(duration))) == null) {
          var this_0 = this.k2t_1;
          var value = mutableListOf([new Duration(duration)]);
          this_0.r2(id, value);
          break $l$block;
        }
      }
    }
  };
  protoOf(Measurer).getMeasurements = function () {
    return this.k2t_1;
  };
  protoOf(Measurer).getMeasurementsFormatted = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.k2t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.utils.Measurer.getMeasurementsFormatted.<anonymous>' call
      var tmp$ret$2 = new Triple(item.t2(), new Duration(sum(item.u2())), item.u2().n());
      destination.q(tmp$ret$2);
    }
    var idSumCalls = destination;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(idSumCalls, 10));
    var tmp0_iterator_0 = idSumCalls.t();
    while (tmp0_iterator_0.u()) {
      var item_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.utils.Measurer.getMeasurementsFormatted.<anonymous>' call
      var tmp$ret$5 = item_0.ui_1.zh_1;
      destination_0.q(new Duration(tmp$ret$5));
    }
    var total = sum(destination_0);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = idSumCalls.t();
    while (tmp0_iterator_1.u()) {
      var element = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.utils.Measurer.getMeasurementsFormatted.<anonymous>' call
      result.q(element.ti_1 + ' ' + element.ui_1 + ' (' + numberToLong(100).aa(_Duration___get_inWholeNanoseconds__impl__r5x4mr(element.ui_1.zh_1)).z9(_Duration___get_inWholeNanoseconds__impl__r5x4mr(total)).toString() + '%) calls: ' + element.vi_1);
    }
    sort(result);
    result.w1(0, 'Total: ' + new Duration(total));
    return result;
  };
  function sum(_this__u8e3s4) {
    var sum = Companion_getInstance().ja_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = _this__u8e3s4.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w().zh_1;
      // Inline function 'com.ikea.core.utils.sum.<anonymous>' call
      sum = Duration__plus_impl_yu9v8f(sum, element);
    }
    return sum;
  }
  function MutableStack(items) {
    this.n2t_1 = toMutableList(items);
  }
  protoOf(MutableStack).push = function (element) {
    return this.n2t_1.q(element);
  };
  protoOf(MutableStack).peek = function () {
    return last(this.n2t_1);
  };
  protoOf(MutableStack).pop = function () {
    return this.n2t_1.h1(this.n2t_1.n() - 1 | 0);
  };
  protoOf(MutableStack).isEmpty = function () {
    return this.n2t_1.b1();
  };
  protoOf(MutableStack).size = function () {
    return this.n2t_1.n();
  };
  protoOf(MutableStack).clear = function () {
    return this.n2t_1.z();
  };
  protoOf(MutableStack).toString = function () {
    return 'MutableStack(' + joinToString(this.n2t_1) + ')';
  };
  function mutableStackOf(elements) {
    return new MutableStack(elements.slice());
  }
  function UrlHelper() {
  }
  protoOf(UrlHelper).joinUrls = function (baseurl, url) {
    if (baseurl == null)
      return url;
    if (url == null)
      return baseurl;
    var urlDetails = this.getUrlDetails(url);
    if (!(urlDetails.protocolAndServer == null))
      return url;
    var baseUrlDetails = this.getUrlDetails(baseurl);
    var tmp0_safe_receiver = urlDetails.path;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, '/');
    if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
      var tmp2_elvis_lhs = baseUrlDetails.protocolAndServer;
      var protocolAndServer = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      return protocolAndServer + urlDetails.path;
    }
    var slash = endsWith(baseurl, '/') ? '' : '/';
    return baseurl + slash + url;
  };
  protoOf(UrlHelper).getUrlDetails = function (url) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var lowerUrl = url.toLowerCase();
    if (startsWith(lowerUrl, 'http')) {
      var endOfProtocolPos = indexOf(url, '//');
      var startOfPath = indexOf(url, '/', endOfProtocolPos + 2 | 0);
      if (startOfPath === -1)
        startOfPath = url.length + 1 | 0;
      var protocolAndServer = substring(url, numberRangeToNumber(0, startOfPath - 1 | 0));
      // Inline function 'kotlin.text.substring' call
      var startIndex = startOfPath;
      // Inline function 'kotlin.js.asDynamic' call
      var path = url.substring(startIndex);
      return new UrlDetails(protocolAndServer, path);
    } else {
      return new UrlDetails(null, url);
    }
  };
  var UrlHelper_instance;
  function UrlHelper_getInstance() {
    return UrlHelper_instance;
  }
  function UrlDetails(protocolAndServer, path) {
    this.protocolAndServer = protocolAndServer;
    this.path = path;
  }
  protoOf(UrlDetails).o2t = function () {
    return this.protocolAndServer;
  };
  protoOf(UrlDetails).p2t = function () {
    return this.path;
  };
  protoOf(UrlDetails).af = function () {
    return this.protocolAndServer;
  };
  protoOf(UrlDetails).bf = function () {
    return this.path;
  };
  protoOf(UrlDetails).q2t = function (protocolAndServer, path) {
    return new UrlDetails(protocolAndServer, path);
  };
  protoOf(UrlDetails).copy = function (protocolAndServer, path, $super) {
    protocolAndServer = protocolAndServer === VOID ? this.protocolAndServer : protocolAndServer;
    path = path === VOID ? this.path : path;
    return this.q2t(protocolAndServer, path);
  };
  protoOf(UrlDetails).toString = function () {
    return 'UrlDetails(protocolAndServer=' + this.protocolAndServer + ', path=' + this.path + ')';
  };
  protoOf(UrlDetails).hashCode = function () {
    var result = this.protocolAndServer == null ? 0 : getStringHashCode(this.protocolAndServer);
    result = imul(result, 31) + (this.path == null ? 0 : getStringHashCode(this.path)) | 0;
    return result;
  };
  protoOf(UrlDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UrlDetails))
      return false;
    var tmp0_other_with_cast = other instanceof UrlDetails ? other : THROW_CCE();
    if (!(this.protocolAndServer == tmp0_other_with_cast.protocolAndServer))
      return false;
    if (!(this.path == tmp0_other_with_cast.path))
      return false;
    return true;
  };
  function toJson(_this__u8e3s4, key) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.utils.toJson.<anonymous>' call
    var it = toString(_this__u8e3s4);
    var tmp;
    if ((startsWith(it, '{') ? true : startsWith(it, '[')) ? true : startsWith(it, '"')) {
      tmp = '"' + key + '":' + it;
    } else {
      if (typeof _this__u8e3s4 === 'number') {
        tmp = '"' + key + '":' + it;
      } else {
        if (typeof _this__u8e3s4 === 'number') {
          tmp = '"' + key + '":' + it;
        } else {
          if (typeof _this__u8e3s4 === 'number') {
            tmp = '"' + key + '":' + it;
          } else {
            if (typeof _this__u8e3s4 === 'boolean') {
              tmp = '"' + key + '":' + it;
            } else {
              if (_this__u8e3s4 instanceof Long) {
                tmp = '"' + key + '":' + it;
              } else {
                tmp = '"' + key + '":"' + it + '"';
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function Companion_110() {
    this.ID = 'NoValidConnectorAvailableValidationResult';
  }
  protoOf(Companion_110).u1n = function () {
    return this.ID;
  };
  var Companion_instance_110;
  function Companion_getInstance_111() {
    return Companion_instance_110;
  }
  function NoValidConnectorAvailableValidationResult(productRef) {
    ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef);
  }
  protoOf(NoValidConnectorAvailableValidationResult).s1k = function () {
    return 'NoValidConnectorAvailableValidationResult';
  };
  protoOf(NoValidConnectorAvailableValidationResult).toString = function () {
    return 'Validation failed for ' + this.productRef + ': No valid connector available';
  };
  function Companion_111() {
    this.ID = 'UnknownErrorValidationResult';
  }
  protoOf(Companion_111).u1n = function () {
    return this.ID;
  };
  var Companion_instance_111;
  function Companion_getInstance_112() {
    return Companion_instance_111;
  }
  function UnknownErrorValidationResult(productRef) {
    ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef);
  }
  protoOf(UnknownErrorValidationResult).s1k = function () {
    return 'UnknownErrorValidationResult';
  };
  protoOf(UnknownErrorValidationResult).toString = function () {
    return 'Validation failed for ' + this.productRef + ' for unknown reasons. This could be a bug';
  };
  function Companion_112() {
  }
  protoOf(Companion_112).noSnappingEntity = function (guest) {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [Companion_instance_114.noSnappingEntity(guest)];
    return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
  };
  protoOf(Companion_112).noSnapCandidates = function (guest) {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [Companion_instance_114.noSnapCandidates(guest)];
    return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
  };
  var Companion_instance_112;
  function Companion_getInstance_113() {
    return Companion_instance_112;
  }
  function ValidSnapActionCandidateOrErrors(snapActionCandidate, warnings, errors) {
    var tmp;
    if (warnings === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = warnings;
    }
    warnings = tmp;
    var tmp_0;
    if (errors === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = errors;
    }
    errors = tmp_0;
    this.snapActionCandidate = snapActionCandidate;
    this.warnings = warnings;
    this.errors = errors;
  }
  protoOf(ValidSnapActionCandidateOrErrors).x2p = function () {
    return this.snapActionCandidate;
  };
  protoOf(ValidSnapActionCandidateOrErrors).r2t = function () {
    return this.warnings;
  };
  protoOf(ValidSnapActionCandidateOrErrors).s2t = function () {
    return this.errors;
  };
  protoOf(ValidSnapActionCandidateOrErrors).t2t = function () {
    return !(this.snapActionCandidate == null);
  };
  protoOf(ValidSnapActionCandidateOrErrors).combineFailures = function (other) {
    if (!(this.snapActionCandidate == null)) {
      return this;
    }
    if (!(other.snapActionCandidate == null)) {
      return other;
    }
    // Inline function 'kotlin.collections.plus' call
    var this_0 = this.warnings;
    var elements = other.warnings;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0.concat(elements);
    // Inline function 'kotlin.collections.plus' call
    var this_1 = this.errors;
    var elements_0 = other.errors;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this_1.concat(elements_0);
    return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
  };
  protoOf(ValidSnapActionCandidateOrErrors).af = function () {
    return this.snapActionCandidate;
  };
  protoOf(ValidSnapActionCandidateOrErrors).bf = function () {
    return this.warnings;
  };
  protoOf(ValidSnapActionCandidateOrErrors).g1k = function () {
    return this.errors;
  };
  protoOf(ValidSnapActionCandidateOrErrors).u2t = function (snapActionCandidate, warnings, errors) {
    return new ValidSnapActionCandidateOrErrors(snapActionCandidate, warnings, errors);
  };
  protoOf(ValidSnapActionCandidateOrErrors).copy = function (snapActionCandidate, warnings, errors, $super) {
    snapActionCandidate = snapActionCandidate === VOID ? this.snapActionCandidate : snapActionCandidate;
    warnings = warnings === VOID ? this.warnings : warnings;
    errors = errors === VOID ? this.errors : errors;
    return this.u2t(snapActionCandidate, warnings, errors);
  };
  protoOf(ValidSnapActionCandidateOrErrors).toString = function () {
    return 'ValidSnapActionCandidateOrErrors(snapActionCandidate=' + this.snapActionCandidate + ', warnings=' + toString(this.warnings) + ', errors=' + toString(this.errors) + ')';
  };
  protoOf(ValidSnapActionCandidateOrErrors).hashCode = function () {
    var result = this.snapActionCandidate == null ? 0 : hashCode(this.snapActionCandidate);
    result = imul(result, 31) + hashCode(this.warnings) | 0;
    result = imul(result, 31) + hashCode(this.errors) | 0;
    return result;
  };
  protoOf(ValidSnapActionCandidateOrErrors).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ValidSnapActionCandidateOrErrors))
      return false;
    var tmp0_other_with_cast = other instanceof ValidSnapActionCandidateOrErrors ? other : THROW_CCE();
    if (!equals(this.snapActionCandidate, tmp0_other_with_cast.snapActionCandidate))
      return false;
    if (!equals(this.warnings, tmp0_other_with_cast.warnings))
      return false;
    if (!equals(this.errors, tmp0_other_with_cast.errors))
      return false;
    return true;
  };
  function ValidationImpl() {
    this.x1n_1 = true;
  }
  protoOf(ValidationImpl).y1n = function () {
    return this.x1n_1;
  };
  protoOf(ValidationImpl).enable = function () {
    this.x1n_1 = true;
  };
  protoOf(ValidationImpl).disable = function () {
    this.x1n_1 = false;
  };
  function Validation() {
  }
  var ValidationResultType_WARNING_instance;
  var ValidationResultType_FAIL_instance;
  function values_8() {
    return [ValidationResultType_WARNING_getInstance(), ValidationResultType_FAIL_getInstance()];
  }
  function valueOf_8(value) {
    switch (value) {
      case 'WARNING':
        return ValidationResultType_WARNING_getInstance();
      case 'FAIL':
        return ValidationResultType_FAIL_getInstance();
      default:
        ValidationResultType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ValidationResultType_entriesInitialized;
  function ValidationResultType_initEntries() {
    if (ValidationResultType_entriesInitialized)
      return Unit_instance;
    ValidationResultType_entriesInitialized = true;
    ValidationResultType_WARNING_instance = new ValidationResultType('WARNING', 0);
    ValidationResultType_FAIL_instance = new ValidationResultType('FAIL', 1);
  }
  function ValidationResultType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_113() {
    this.GENERIC_FAILURE = 'Generic ValidationResultFail';
  }
  protoOf(Companion_113).x2t = function () {
    return this.GENERIC_FAILURE;
  };
  var Companion_instance_113;
  function Companion_getInstance_114() {
    return Companion_instance_113;
  }
  function ValidationResultFail(message, productRef, rule) {
    ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef, rule);
    this.message = message;
  }
  protoOf(ValidationResultFail).md = function () {
    return this.message;
  };
  protoOf(ValidationResultFail).s1k = function () {
    var tmp0_safe_receiver = this.failedRule;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id;
    return tmp1_elvis_lhs == null ? 'Generic ValidationResultFail' : tmp1_elvis_lhs;
  };
  protoOf(ValidationResultFail).toString = function () {
    return 'Validation failed: ' + this.message;
  };
  function ValidationResultWarning(message, productRef, rule) {
    ValidationResult.call(this, ValidationResultType_WARNING_getInstance(), productRef, rule);
    this.message = message;
  }
  protoOf(ValidationResultWarning).md = function () {
    return this.message;
  };
  protoOf(ValidationResultWarning).s1k = function () {
    return 'Generic ValidationResultWarning';
  };
  protoOf(ValidationResultWarning).toString = function () {
    return 'Validation warning: ' + this.message;
  };
  function ValidationResultType_WARNING_getInstance() {
    ValidationResultType_initEntries();
    return ValidationResultType_WARNING_instance;
  }
  function ValidationResultType_FAIL_getInstance() {
    ValidationResultType_initEntries();
    return ValidationResultType_FAIL_instance;
  }
  function Companion_114() {
  }
  protoOf(Companion_114).y2t = function (message, productRef, rule) {
    return new ValidationResultFail(message, productRef, rule);
  };
  protoOf(Companion_114).fail = function (message, productRef, rule, $super) {
    productRef = productRef === VOID ? null : productRef;
    rule = rule === VOID ? null : rule;
    return this.y2t(message, productRef, rule);
  };
  protoOf(Companion_114).z2t = function (message, productRef, rule) {
    return new ValidationResultWarning(message, productRef, rule);
  };
  protoOf(Companion_114).warning = function (message, productRef, rule, $super) {
    productRef = productRef === VOID ? null : productRef;
    rule = rule === VOID ? null : rule;
    return this.z2t(message, productRef, rule);
  };
  protoOf(Companion_114).noSnapCandidates = function (guest) {
    var tmp0_elvis_lhs = get_productRef(guest);
    return new ValidationResultFail('No snap candidates found', tmp0_elvis_lhs == null ? 'Entity ' + guest.id : tmp0_elvis_lhs, null);
  };
  protoOf(Companion_114).noSnappingEntity = function (guest) {
    var tmp0_elvis_lhs = get_productRef(guest);
    return new ValidationResultFail('No snapping entity found', tmp0_elvis_lhs == null ? 'Entity ' + guest.id : tmp0_elvis_lhs, null);
  };
  var Companion_instance_114;
  function Companion_getInstance_115() {
    return Companion_instance_114;
  }
  function ValidationResult(resultType, productRef, failedRule) {
    failedRule = failedRule === VOID ? null : failedRule;
    this.resultType = resultType;
    this.productRef = productRef;
    this.failedRule = failedRule;
  }
  protoOf(ValidationResult).b1o = function () {
    return this.resultType;
  };
  protoOf(ValidationResult).j1l = function () {
    return this.productRef;
  };
  protoOf(ValidationResult).c1o = function () {
    return this.failedRule;
  };
  protoOf(ValidationResult).toString = function () {
    var tmp;
    switch (this.resultType.x9_1) {
      case 1:
        tmp = 'Validation failed';
        break;
      case 0:
        tmp = 'Validation warned';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function ValidationService() {
  }
  function fastComponent(entity, componentId) {
    var tmp0_safe_receiver = entity.getComponent(componentId);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp0_safe_receiver;
    }
    return tmp;
  }
  function unsafeCast(obj) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return obj;
  }
  function echoStandardConsole(a) {
    console.log(a);
  }
  function getCoreVersion() {
    var tmp = require('../package.json').version;
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  }
  //region block: post-declaration
  defineProp(protoOf(ActionState), 'name', protoOf(ActionState).mb);
  defineProp(protoOf(ActionState), 'ordinal', protoOf(ActionState).nb);
  defineProp(protoOf(CoreServices), 'logger', protoOf(CoreServices).x1i);
  protoOf($serializer).sv = typeParametersSerializers;
  protoOf(AssemblyPartIdsComponent).z1k = get_serializable;
  protoOf(AssemblyPartIdsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AssemblyPartIdsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AssemblyPartIdsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AssemblyPartIdsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_0).sv = typeParametersSerializers;
  protoOf(AssemblyPartsComponent).z1k = get_serializable;
  protoOf(AssemblyPartsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AssemblyPartsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AssemblyPartsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AssemblyPartsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AssemblyStructureComponent).z1k = get_serializable;
  protoOf(AssemblyStructureComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AssemblyStructureComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AssemblyStructureComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AssemblyStructureComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_1).sv = typeParametersSerializers;
  protoOf(ProductPartComponent).z1k = get_serializable_0;
  protoOf(ProductPartComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ProductPartComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ProductPartComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ProductPartComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ProductComponent).z1k = get_serializable;
  protoOf(ProductComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ProductComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ProductComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ProductComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_8), 'id', protoOf(Companion_8).s1k);
  protoOf(ProductStructureComponent).z1k = get_serializable;
  protoOf(ProductStructureComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ProductStructureComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ProductStructureComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ProductStructureComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(CircularBuffer), 'size', protoOf(CircularBuffer).n);
  protoOf(ColliderComponent).z1k = get_serializable;
  protoOf(ColliderComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ColliderComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ColliderComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ColliderComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ColliderShapeComponent).z1k = get_serializable;
  protoOf(ColliderShapeComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ColliderShapeComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ColliderShapeComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ColliderShapeComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ValidationImpl).findRoot = findRoot;
  defineProp(protoOf(ValidationImpl), 'isEnabled', function () {
    return this.y1n();
  });
  defineProp(protoOf(ValidationImpl), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(ValidationResult), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(CollisionValidationResult), 'aabbOfAllCollidedWith', protoOf(CollisionValidationResult).a1o);
  defineProp(protoOf(EcsSystemImpl), 'isEnabled', function () {
    return this.y1n();
  });
  defineProp(protoOf(EcsSystemImpl), 'systemsBeforeMe', function () {
    return this.x1o();
  });
  defineProp(protoOf(EcsSystemImpl), 'systemsAfterMe', function () {
    return this.y1o();
  });
  defineProp(protoOf(EcsSystemImpl), 'ignoreEntitiesWithComponents', function () {
    return this.a1p();
  });
  defineProp(protoOf(EcsSystemImpl), 'mandatoryComponents', function () {
    return this.z1o();
  });
  defineProp(protoOf(EcsSystemImpl), 'doingChangesOnComponent', function () {
    return this.w1o();
  });
  defineProp(protoOf(EcsSystemImpl), 'componentListeners', function () {
    return this.b1p();
  });
  defineProp(protoOf(EcsSystemImpl), 'id', function () {
    return this.s1k();
  });
  defineProp(protoOf(Connection), 'guestConnectionRoot', protoOf(Connection).t1v);
  defineProp(protoOf(Connection), 'hostConnectionRoot', protoOf(Connection).u1v);
  defineProp(protoOf(Connection), 'priority', protoOf(Connection).v1v);
  defineProp(protoOf(Connection), 'guestIsConnectionRoot', protoOf(Connection).x1v);
  defineProp(protoOf(Connection), 'guestConnectorWorldPosition', protoOf(Connection).y1v);
  defineProp(protoOf(Connection), 'hostConnectorWorldPosition', protoOf(Connection).z1v);
  protoOf(ConnectionRootComponent).z1k = get_serializable;
  protoOf(ConnectionRootComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ConnectionRootComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ConnectionRootComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ConnectionRootComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(GuestConnectionsComponent).z1k = get_serializable;
  protoOf(GuestConnectionsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(GuestConnectionsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(GuestConnectionsComponent), 'hasMultipleHosts', protoOf(GuestConnectionsComponent).e1w);
  defineProp(protoOf(GuestConnectionsComponent), 'highestPriorityConnection', protoOf(GuestConnectionsComponent).f1w);
  defineProp(protoOf(GuestConnectionsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(GuestConnectionsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(HostConnectionsComponent).z1k = get_serializable;
  protoOf(HostConnectionsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(HostConnectionsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(HostConnectionsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(HostConnectionsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(TemporarilyPauseConnectionParentingComponent).z1k = get_serializable;
  protoOf(TemporarilyPauseConnectionParentingComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(TemporarilyPauseConnectionParentingComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(TemporarilyPauseConnectionParentingComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(TemporarilyPauseConnectionParentingComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Connector), 'key', function () {
    return this.t2();
  });
  defineProp(protoOf(Connector), 'type', function () {
    return this.a1x();
  });
  defineProp(protoOf(Connector), 'required', function () {
    return this.b1x();
  });
  defineProp(protoOf(Connector), 'worldSpaceOffsetOnHanging', function () {
    return this.c1x();
  });
  defineProp(protoOf(Connector), 'transform', function () {
    return this.d1x();
  });
  defineProp(protoOf(Connector), 'rotationalDegreeOfFreedom', function () {
    return this.e1x();
  });
  defineProp(protoOf(Connector), 'tagArray', function () {
    return this.g1x();
  }, function (value) {
    this.f1x(value);
  });
  defineProp(protoOf(Connector), 'offersArray', function () {
    return this.i1x();
  }, function (value) {
    this.h1x(value);
  });
  defineProp(protoOf(Connector), 'demandsArray', function () {
    return this.k1x();
  }, function (value) {
    this.j1x(value);
  });
  defineProp(protoOf(Connector), 'priority', function () {
    return this.v1v();
  });
  defineProp(protoOf(Connector), 'activationDistance', function () {
    return this.l1x();
  });
  defineProp(protoOf(Connector), 'enabled', function () {
    return this.m1x();
  });
  defineProp(protoOf(Connector), 'isContinuousConnector', function () {
    return this.n1x();
  });
  defineProp(protoOf(Connector), 'allSubConnectors', function () {
    return this.o1x();
  });
  defineProp(protoOf(Connector), 'hasSubConnectors', function () {
    return this.p1x();
  });
  protoOf(ConnectorsComponent).z1k = get_serializable;
  protoOf(ConnectorsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ConnectorsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ConnectorsComponent), 'tags', protoOf(ConnectorsComponent).c1y);
  defineProp(protoOf(ConnectorsComponent), 'hostConnectors', protoOf(ConnectorsComponent).d1y);
  defineProp(protoOf(ConnectorsComponent), 'guestConnectors', protoOf(ConnectorsComponent).e1y);
  defineProp(protoOf(ConnectorsComponent), 'alignmentConnectors', protoOf(ConnectorsComponent).f1y);
  defineProp(protoOf(ConnectorsComponent), 'requiredConnectors', protoOf(ConnectorsComponent).g1y);
  defineProp(protoOf(ConnectorsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ConnectorsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DisabledConnectorsComponent).z1k = get_serializable;
  protoOf(DisabledConnectorsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DisabledConnectorsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DisabledConnectorsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DisabledConnectorsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RelativeConnectorsComponent).z1k = get_serializable;
  protoOf(RelativeConnectorsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RelativeConnectorsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RelativeConnectorsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RelativeConnectorsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(RotationDegreeOfFreedom), 'name', protoOf(RotationDegreeOfFreedom).mb);
  defineProp(protoOf(RotationDegreeOfFreedom), 'ordinal', protoOf(RotationDegreeOfFreedom).nb);
  protoOf(DebugLinesComponent).z1k = get_serializable;
  protoOf(DebugLinesComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DebugLinesComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DebugLinesComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DebugLinesComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DebugSurfacesComponent).z1k = get_serializable;
  protoOf(DebugSurfacesComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DebugSurfacesComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DebugSurfacesComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DebugSurfacesComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DragSurfacesComponent).z1k = get_serializable;
  protoOf(DragSurfacesComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DragSurfacesComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DragSurfacesComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DragSurfacesComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DraggableComponent).z1k = get_serializable;
  protoOf(DraggableComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DraggableComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DraggableComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DraggableComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SomethingIsDraggedComponent).z1k = get_serializable;
  defineProp(protoOf(SomethingIsDraggedComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SomethingIsDraggedComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(SomethingIsDraggedComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DragType), 'name', protoOf(DragType).mb);
  defineProp(protoOf(DragType), 'ordinal', protoOf(DragType).nb);
  protoOf(ViewerDragEventComponent).z1k = get_serializable;
  defineProp(protoOf(ViewerDragEventComponent), 'rayFromCameraToDragEnd', protoOf(ViewerDragEventComponent).b24);
  defineProp(protoOf(ViewerDragEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ViewerDragEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ViewerDragEventComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(WorldDragSurfacesComponent).z1k = get_serializable;
  protoOf(WorldDragSurfacesComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(WorldDragSurfacesComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(WorldDragSurfacesComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(WorldDragSurfacesComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(WorldSpaceDragEventComponent).z1k = get_serializable;
  defineProp(protoOf(WorldSpaceDragEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(WorldSpaceDragEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(WorldSpaceDragEventComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(Entity), 'allComponents', protoOf(Entity).m24);
  defineProp(protoOf(Entity), 'isDisposed', protoOf(Entity).n24);
  defineProp(protoOf(EntityManagerImpl), 'entities', function () {
    return this.o24();
  });
  defineProp(protoOf(ComponentListenerImpl), 'ownerSystem', function () {
    return this.l24();
  });
  defineProp(protoOf(ComponentListenerImpl), 'componentId', function () {
    return this.v1o();
  });
  protoOf(AutomaticGroupComponent).z1k = get_serializable_0;
  protoOf(AutomaticGroupComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutomaticGroupComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutomaticGroupComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutomaticGroupComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutomaticGroupIdCountComponent).z1k = get_serializable;
  protoOf(AutomaticGroupIdCountComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutomaticGroupIdCountComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutomaticGroupIdCountComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutomaticGroupIdCountComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ManualGroupComponent).z1k = get_serializable_0;
  protoOf(ManualGroupComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ManualGroupComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ManualGroupComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ManualGroupComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ManualGroupIdCountComponent).z1k = get_serializable;
  protoOf(ManualGroupIdCountComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ManualGroupIdCountComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ManualGroupIdCountComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ManualGroupIdCountComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(StaticComponent).z1k = get_serializable;
  protoOf(StaticComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(StaticComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(StaticComponent), 'id', protoOf(StaticComponent).s1k);
  defineProp(protoOf(StaticComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(StaticComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ChildComponent).z1k = get_serializable;
  protoOf(ChildComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ChildComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ChildComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ChildComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(InSceneComponent).z1k = get_serializable;
  protoOf(InSceneComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(InSceneComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(InSceneComponent), 'id', protoOf(InSceneComponent).s1k);
  defineProp(protoOf(InSceneComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(InSceneComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ParentComponent).z1k = get_serializable;
  protoOf(ParentComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ParentComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ParentComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ParentComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SceneComponent).z1k = get_serializable;
  protoOf(SceneComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SceneComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SceneComponent), 'id', protoOf(SceneComponent).s1k);
  defineProp(protoOf(SceneComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SceneComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(HistoryEventType), 'name', protoOf(HistoryEventType).mb);
  defineProp(protoOf(HistoryEventType), 'ordinal', protoOf(HistoryEventType).nb);
  protoOf(HistoryChangedEventComponent).z1k = get_serializable;
  protoOf(HistoryChangedEventComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(HistoryChangedEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(HistoryChangedEventComponent), 'eventType', protoOf(HistoryChangedEventComponent).r2a);
  defineProp(protoOf(HistoryChangedEventComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(HistoryChangedEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(HistoryImpl).takeSnapshot = takeSnapshot;
  defineProp(protoOf(HistoryImpl), 'isPaused', function () {
    return this.g2a();
  });
  defineProp(protoOf(LogLevel), 'name', protoOf(LogLevel).mb);
  defineProp(protoOf(LogLevel), 'ordinal', protoOf(LogLevel).nb);
  protoOf(LoggerImpl).f2b = set_logLevel;
  protoOf(LoggerImpl).g2b = get_logLevel;
  defineProp(protoOf(LoggerImpl), 'level', function () {
    return this.e2b();
  }, function (value) {
    this.d2b(value);
  });
  defineProp(protoOf(LoggerImpl), 'logLevel', function () {
    return this.g2b();
  }, function (value) {
    this.f2b(value);
  });
  protoOf(LoggerWrap).f2b = set_logLevel;
  protoOf(LoggerWrap).g2b = get_logLevel;
  defineProp(protoOf(LoggerWrap), 'level', function () {
    return this.e2b();
  }, function (value) {
    this.d2b(value);
  });
  defineProp(protoOf(LoggerWrap), 'logLevel', function () {
    return this.g2b();
  }, function (value) {
    this.f2b(value);
  });
  protoOf(MockLogger).f2b = set_logLevel;
  protoOf(MockLogger).g2b = get_logLevel;
  defineProp(protoOf(MockLogger), 'level', function () {
    return this.e2b();
  }, function (value) {
    this.d2b(value);
  });
  defineProp(protoOf(MockLogger), 'logLevel', function () {
    return this.g2b();
  }, function (value) {
    this.f2b(value);
  });
  defineProp(protoOf(DualDouble), 'midPoint', protoOf(DualDouble).z2b);
  defineProp(protoOf(DualDouble), 'length', protoOf(DualDouble).a);
  protoOf($serializer_2).sv = typeParametersSerializers;
  defineProp(protoOf(Axis), 'name', protoOf(Axis).mb);
  defineProp(protoOf(Axis), 'ordinal', protoOf(Axis).nb);
  protoOf($serializer_3).sv = typeParametersSerializers;
  defineProp(protoOf(ModelTransform), 'transform', protoOf(ModelTransform).d1x);
  protoOf($serializer_4).sv = typeParametersSerializers;
  defineProp(protoOf(Quaternion), 'eulerDegrees', protoOf(Quaternion).m2d);
  defineProp(protoOf(RelationOriginAlongX), 'name', protoOf(RelationOriginAlongX).mb);
  defineProp(protoOf(RelationOriginAlongX), 'ordinal', protoOf(RelationOriginAlongX).nb);
  defineProp(protoOf(RelationOriginAlongY), 'name', protoOf(RelationOriginAlongY).mb);
  defineProp(protoOf(RelationOriginAlongY), 'ordinal', protoOf(RelationOriginAlongY).nb);
  defineProp(protoOf(RelationOriginAlongZ), 'name', protoOf(RelationOriginAlongZ).mb);
  defineProp(protoOf(RelationOriginAlongZ), 'ordinal', protoOf(RelationOriginAlongZ).nb);
  protoOf($serializer_5).sv = typeParametersSerializers;
  defineProp(protoOf(RelationOrigin), 'x', protoOf(RelationOrigin).i2d);
  defineProp(protoOf(RelationOrigin), 'y', protoOf(RelationOrigin).j2d);
  defineProp(protoOf(RelationOrigin), 'z', protoOf(RelationOrigin).k2d);
  protoOf($serializer_6).sv = typeParametersSerializers;
  protoOf(Size).alignBottom = alignBottom;
  protoOf(Size).alignTop = alignTop;
  protoOf(Size).alignRight = alignRight;
  protoOf(Size).alignLeft = alignLeft;
  protoOf(Size).alignFront = alignFront;
  protoOf(Size).alignBack = alignBack;
  defineProp(protoOf(Size), 'width', function () {
    return this.u2b();
  });
  defineProp(protoOf(Size), 'height', function () {
    return this.v2b();
  });
  defineProp(protoOf(Size), 'depth', function () {
    return this.w2b();
  });
  protoOf($serializer_7).sv = typeParametersSerializers;
  defineProp(protoOf(Transform), 'forward', protoOf(Transform).z2e);
  defineProp(protoOf(Transform), 'up', protoOf(Transform).a2f);
  defineProp(protoOf(Transform), 'right', protoOf(Transform).d2c);
  protoOf($serializer_8).sv = typeParametersSerializers;
  protoOf(Vector).alignBottom = alignBottom;
  protoOf(Vector).alignTop = alignTop;
  protoOf(Vector).alignRight = alignRight;
  protoOf(Vector).alignLeft = alignLeft;
  protoOf(Vector).alignFront = alignFront;
  protoOf(Vector).alignBack = alignBack;
  defineProp(protoOf(Vector), 'width', function () {
    return this.u2b();
  });
  defineProp(protoOf(Vector), 'height', function () {
    return this.v2b();
  });
  defineProp(protoOf(Vector), 'depth', function () {
    return this.w2b();
  });
  defineProp(protoOf(Vector), 'XXX', protoOf(Vector).n2f);
  defineProp(protoOf(Vector), 'XXY', protoOf(Vector).o2f);
  defineProp(protoOf(Vector), 'XXZ', protoOf(Vector).p2f);
  defineProp(protoOf(Vector), 'XYX', protoOf(Vector).q2f);
  defineProp(protoOf(Vector), 'XYY', protoOf(Vector).r2f);
  defineProp(protoOf(Vector), 'XYZ', protoOf(Vector).s2f);
  defineProp(protoOf(Vector), 'XZX', protoOf(Vector).t2f);
  defineProp(protoOf(Vector), 'XZY', protoOf(Vector).u2f);
  defineProp(protoOf(Vector), 'XZZ', protoOf(Vector).v2f);
  defineProp(protoOf(Vector), 'YXX', protoOf(Vector).w2f);
  defineProp(protoOf(Vector), 'YXY', protoOf(Vector).x2f);
  defineProp(protoOf(Vector), 'YXZ', protoOf(Vector).y2f);
  defineProp(protoOf(Vector), 'YYX', protoOf(Vector).z2f);
  defineProp(protoOf(Vector), 'YYY', protoOf(Vector).a2g);
  defineProp(protoOf(Vector), 'YYZ', protoOf(Vector).b2g);
  defineProp(protoOf(Vector), 'YZX', protoOf(Vector).c2g);
  defineProp(protoOf(Vector), 'YZY', protoOf(Vector).d2g);
  defineProp(protoOf(Vector), 'YZZ', protoOf(Vector).e2g);
  defineProp(protoOf(Vector), 'ZXX', protoOf(Vector).f2g);
  defineProp(protoOf(Vector), 'ZXY', protoOf(Vector).g2g);
  defineProp(protoOf(Vector), 'ZXZ', protoOf(Vector).h2g);
  defineProp(protoOf(Vector), 'ZYX', protoOf(Vector).i2g);
  defineProp(protoOf(Vector), 'ZYY', protoOf(Vector).j2g);
  defineProp(protoOf(Vector), 'ZYZ', protoOf(Vector).k2g);
  defineProp(protoOf(Vector), 'ZZX', protoOf(Vector).l2g);
  defineProp(protoOf(Vector), 'ZZY', protoOf(Vector).m2g);
  defineProp(protoOf(Vector), 'ZZZ', protoOf(Vector).n2g);
  defineProp(protoOf(Vector), 'XX', protoOf(Vector).o2g);
  defineProp(protoOf(Vector), 'XY', protoOf(Vector).p2g);
  defineProp(protoOf(Vector), 'XZ', protoOf(Vector).q2g);
  defineProp(protoOf(Vector), 'X0Z', protoOf(Vector).r2g);
  defineProp(protoOf(Vector), 'YX', protoOf(Vector).s2g);
  defineProp(protoOf(Vector), 'YY', protoOf(Vector).t2g);
  defineProp(protoOf(Vector), 'YZ', protoOf(Vector).u2g);
  defineProp(protoOf(Vector), 'ZX', protoOf(Vector).v2g);
  defineProp(protoOf(Vector), 'ZY', protoOf(Vector).w2g);
  defineProp(protoOf(Vector), 'ZZ', protoOf(Vector).x2g);
  defineProp(protoOf(Vector), 'size', protoOf(Vector).n);
  defineProp(protoOf(Vector), 'abs', protoOf(Vector).z2g);
  defineProp(protoOf(InnerMeasurement), 'distance', protoOf(InnerMeasurement).c2h);
  protoOf(DisplayNameComponent).z1k = get_serializable;
  protoOf(DisplayNameComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DisplayNameComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DisplayNameComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DisplayNameComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ProppingComponent).z1k = get_serializable;
  protoOf(ProppingComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ProppingComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ProppingComponent), 'id', protoOf(ProppingComponent).s1k);
  defineProp(protoOf(ProppingComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ProppingComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(TemplateDataComponent).z1k = get_serializable;
  protoOf(TemplateDataComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(TemplateDataComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(TemplateDataComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(TemplateDataComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(LoadedModelInfoComponent).z1k = get_serializable;
  defineProp(protoOf(LoadedModelInfoComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(LoadedModelInfoComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(LoadedModelInfoComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(ModelInfoComponent).z1k = get_serializable;
  protoOf(ModelInfoComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ModelInfoComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ModelInfoComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ModelInfoComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_67), 'id', protoOf(Companion_67).s1k);
  protoOf(ModelTransformComponent).z1k = get_serializable;
  protoOf(ModelTransformComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ModelTransformComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ModelTransformComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ModelTransformComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(OutlineableComponent).z1k = get_serializable;
  protoOf(OutlineableComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(OutlineableComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(OutlineableComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(OutlineableComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(PauseViewerUpdatesComponent).z1k = get_serializable;
  protoOf(PauseViewerUpdatesComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(PauseViewerUpdatesComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(PauseViewerUpdatesComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(PauseViewerUpdatesComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RenderedComponent).z1k = get_serializable;
  protoOf(RenderedComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RenderedComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RenderedComponent), 'id', protoOf(RenderedComponent).s1k);
  defineProp(protoOf(RenderedComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RenderedComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ViewerComponent).z1k = get_serializable;
  protoOf(ViewerComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ViewerComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ViewerComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ViewerComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ViewerLineIdsComponent).z1k = get_serializable;
  defineProp(protoOf(ViewerLineIdsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ViewerLineIdsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ViewerLineIdsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(Companion_73), 'id', protoOf(Companion_73).s1k);
  protoOf(ViewerObjectComponent).z1k = get_serializable;
  defineProp(protoOf(ViewerObjectComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ViewerObjectComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ViewerObjectComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(ViewerMock).loadModel = loadModel;
  protoOf(ViewerMock).createEmpty = createEmpty;
  protoOf(ViewerMock).createSphere = createSphere;
  protoOf(ViewerMock).cloneObject = cloneObject;
  protoOf(ViewerMock).createBox = createBox;
  protoOf(ViewerMock).createSurface = createSurface;
  protoOf(ViewerMock).createPlane = createPlane;
  protoOf(ViewerMock).groupMeshes = groupMeshes;
  protoOf(ViewerMock).debug = debug;
  protoOf(ViewerMock).createGhostModel = createGhostModel;
  protoOf(ViewerMock).createUiLine = createUiLine;
  protoOf(ViewerMock).createUiDashedLine = createUiDashedLine;
  protoOf(ViewerMock).updateUiLine = updateUiLine;
  protoOf(ViewerObjectMock).setPosition = setPosition;
  defineProp(protoOf(ViewerObjectMock), 'isVisible', protoOf(ViewerObjectMock).k2l);
  defineProp(protoOf(ViewerObjectMock), 'hasRegisteredInputEvents', function () {
    return this.o2j();
  });
  protoOf(ClickEventComponent).z1k = get_serializable;
  protoOf(ClickEventComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ClickEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ClickEventComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ClickEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(MultiSelectionEnabledComponent).z1k = get_serializable;
  protoOf(MultiSelectionEnabledComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(MultiSelectionEnabledComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(MultiSelectionEnabledComponent), 'id', protoOf(MultiSelectionEnabledComponent).s1k);
  defineProp(protoOf(MultiSelectionEnabledComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(MultiSelectionEnabledComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SelectableComponent).z1k = get_serializable;
  protoOf(SelectableComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SelectableComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SelectableComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SelectableComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SelectedComponent).z1k = get_serializable;
  protoOf(SelectedComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SelectedComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SelectedComponent), 'id', protoOf(SelectedComponent).s1k);
  defineProp(protoOf(SelectedComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SelectedComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_9).sv = typeParametersSerializers;
  defineProp(protoOf(ComponentDeserializerRegistry), 'componentSerializers', protoOf(ComponentDeserializerRegistry).m2m);
  protoOf(PreviouslySerializedIdComponent).z1k = get_serializable;
  protoOf(PreviouslySerializedIdComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(PreviouslySerializedIdComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(PreviouslySerializedIdComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(PreviouslySerializedIdComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SceneReloadingComponent).z1k = get_serializable;
  protoOf(SceneReloadingComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SceneReloadingComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SceneReloadingComponent), 'id', protoOf(SceneReloadingComponent).s1k);
  defineProp(protoOf(SceneReloadingComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SceneReloadingComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_10).sv = typeParametersSerializers;
  protoOf($serializer_11).sv = typeParametersSerializers;
  protoOf(SerializableGuestConnectionsComponent).z1k = get_serializable_0;
  protoOf(SerializableGuestConnectionsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SerializableGuestConnectionsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SerializableGuestConnectionsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SerializableGuestConnectionsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_85), 'id', protoOf(Companion_85).s1k);
  protoOf(UnserializableEntityComponent).z1k = get_serializable;
  protoOf(UnserializableEntityComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(UnserializableEntityComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(UnserializableEntityComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(UnserializableEntityComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_12).sv = typeParametersSerializers;
  protoOf(InterceptingAssemblyPartCatalog).createCustomAssembly = createCustomAssembly;
  protoOf(InterceptingAssemblyPartCatalog).createCustomAssemblySpecification = createCustomAssemblySpecification;
  protoOf(InterceptingAssemblyPartCatalog).beforeDeserialize = beforeDeserialize;
  protoOf(InterceptingAssemblyPartCatalog).beforeParsingComponents = beforeParsingComponents;
  protoOf(InterceptingAssemblyPartCatalog).beforeBuildingEntities = beforeBuildingEntities;
  protoOf(InterceptingAssemblyPartCatalog).afterDeserializeComplete = afterDeserializeComplete;
  defineProp(protoOf(InterceptingAssemblyPartCatalog), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
    return this.a1m();
  });
  protoOf($serializer_13).sv = typeParametersSerializers;
  protoOf(SerializableEntityV13).addComponent = addComponent;
  defineProp(protoOf(SerializableEntityV13), 'id', function () {
    return this.s1k();
  }, function (value) {
    this.u2m(value);
  });
  defineProp(protoOf(SerializableEntityV13), 'ref', function () {
    return this.w2m();
  }, function (value) {
    this.v2m(value);
  });
  defineProp(protoOf(SerializableEntityV13), 'parent', function () {
    return this.z27();
  }, function (value) {
    this.x2m(value);
  });
  defineProp(protoOf(SerializableEntityV13), 'serializedComponents', function () {
    return this.z2m();
  }, function (value) {
    this.y2m(value);
  });
  defineProp(protoOf(SerializableEntityV13), 'components', function () {
    return this.j1m();
  }, function (value) {
    this.a2n(value);
  });
  protoOf($serializer_14).sv = typeParametersSerializers;
  protoOf(SerializableTreeV13).entitiesArray = entitiesArray;
  defineProp(protoOf(SerializableTreeV13), 'entities', function () {
    return this.o24();
  }, function (value) {
    this.s2o(value);
  });
  defineProp(protoOf(SerializableTreeV13), 'roots', function () {
    return this.l2n();
  });
  defineProp(protoOf(SerializableTreeV13), 'version', function () {
    return this.m2n();
  });
  defineProp(protoOf(AxisAlignedBox), 'center', protoOf(AxisAlignedBox).g2p);
  defineProp(protoOf(AxisAlignedBox), 'width', protoOf(AxisAlignedBox).u2b);
  defineProp(protoOf(AxisAlignedBox), 'height', protoOf(AxisAlignedBox).v2b);
  defineProp(protoOf(AxisAlignedBox), 'depth', protoOf(AxisAlignedBox).w2b);
  defineProp(protoOf(AxisAlignedBox), 'size', protoOf(AxisAlignedBox).n);
  defineProp(protoOf(ConvexPolyhedron), 'axisAlignedBoundingBox', function () {
    return this.m2p();
  });
  defineProp(protoOf(ConvexPolyhedron), 'unsignedNormals', function () {
    return this.n2p();
  });
  defineProp(protoOf(Cuboid), 'size', protoOf(Cuboid).n);
  protoOf(PolyhedronGroup).transform = transform;
  defineProp(protoOf(PolyhedronGroup), 'axisAlignedBoundingBox', function () {
    return this.m2p();
  });
  defineProp(protoOf(Companion_95), 'id', protoOf(Companion_95).s1k);
  protoOf(MovedToCandidateSnapPositionComponent).z1k = get_serializable;
  protoOf(MovedToCandidateSnapPositionComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(MovedToCandidateSnapPositionComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(MovedToCandidateSnapPositionComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(MovedToCandidateSnapPositionComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(MovedToValidSnapPositionComponent).z1k = get_serializable;
  protoOf(MovedToValidSnapPositionComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(MovedToValidSnapPositionComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(MovedToValidSnapPositionComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(MovedToValidSnapPositionComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_97), 'id', protoOf(Companion_97).s1k);
  protoOf(RestrictAllowedRequiredHostsComponent).z1k = get_serializable;
  protoOf(RestrictAllowedRequiredHostsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RestrictAllowedRequiredHostsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RestrictAllowedRequiredHostsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RestrictAllowedRequiredHostsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SnapActionCandidateImpl).t2q = get_isAlignmentSnap;
  protoOf(SnapActionCandidateImpl).h1i = get_isDone;
  defineProp(protoOf(SnapActionCandidateImpl), 'alignmentInitiatorCandidate', function () {
    return this.n2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'state', function () {
    return this.g1i();
  }, function (value) {
    this.f1i(value);
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'movement', function () {
    return this.o2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'deltaRotation', function () {
    return this.p2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'priority', function () {
    return this.v1v();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'guestRootToGuestDeltaTransform', function () {
    return this.q2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'guestRootToGuestConnectorDeltaTransform', function () {
    return this.r2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'guestEndTransform', function () {
    return this.s2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'isAlignmentSnap', function () {
    return this.t2q();
  });
  defineProp(protoOf(SnapActionCandidateImpl), 'isDone', function () {
    return this.h1i();
  });
  defineProp(protoOf(SnapAction), 'isAlignmentSnap', function () {
    return this.t2q();
  });
  defineProp(protoOf(SnapAction), 'isDone', function () {
    return this.h1i();
  });
  protoOf(SnapActionInProgressComponent).z1k = get_serializable;
  protoOf(SnapActionInProgressComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SnapActionInProgressComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SnapActionInProgressComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SnapActionInProgressComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_99), 'id', protoOf(Companion_99).s1k);
  protoOf(SnapCandidateComponent).z1k = get_serializable;
  protoOf(SnapCandidateComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SnapCandidateComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SnapCandidateComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SnapCandidateComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(SnapRootComponent).z1k = get_serializable;
  protoOf(SnapRootComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SnapRootComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SnapRootComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SnapRootComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(SnapSettings), 'includeAllSubConnectors', function () {
    return this.r2r();
  });
  defineProp(protoOf(SnapSettings), 'includeInternalConnectors', function () {
    return this.s2r();
  });
  defineProp(protoOf(SnapSettings), 'includeHostAssemblyParts', function () {
    return this.t2r();
  });
  defineProp(protoOf(SnapSettings), 'includeAlignmentConnectorsOutsideActivationDistance', function () {
    return this.u2r();
  });
  defineProp(protoOf(Companion_101), 'id', protoOf(Companion_101).s1k);
  protoOf(IsLoadingSnapshotComponent).z1k = get_serializable;
  defineProp(protoOf(IsLoadingSnapshotComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(IsLoadingSnapshotComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(IsLoadingSnapshotComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(SnapshotIgnoreComponent).z1k = get_serializable;
  protoOf(SnapshotIgnoreComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(SnapshotIgnoreComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(SnapshotIgnoreComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(SnapshotIgnoreComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Snapshot), 'allEntityStates', protoOf(Snapshot).g2s);
  protoOf(UpdatedFromSnapshotEventComponent).z1k = get_serializable;
  defineProp(protoOf(UpdatedFromSnapshotEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(UpdatedFromSnapshotEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(UpdatedFromSnapshotEventComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(AlwaysHangDownComponent).z1k = get_serializable;
  protoOf(AlwaysHangDownComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AlwaysHangDownComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AlwaysHangDownComponent), 'id', protoOf(AlwaysHangDownComponent).s1k);
  defineProp(protoOf(AlwaysHangDownComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AlwaysHangDownComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_15).sv = typeParametersSerializers;
  protoOf(LocalTransformComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(LocalTransformComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(LocalTransformComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(LocalTransformComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_16).sv = typeParametersSerializers;
  protoOf(WorldTransformComponent).z1k = get_serializable_0;
  protoOf(WorldTransformComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(WorldTransformComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(WorldTransformComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(WorldTransformComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ValidSnapActionCandidateOrErrors), 'valid', protoOf(ValidSnapActionCandidateOrErrors).t2t);
  defineProp(protoOf(ValidationResultType), 'name', protoOf(ValidationResultType).mb);
  defineProp(protoOf(ValidationResultType), 'ordinal', protoOf(ValidationResultType).nb);
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  ProductCatalogFunctions_instance = new ProductCatalogFunctions();
  Companion_instance_6 = new Companion_6();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  Companion_instance_10 = new Companion_10();
  ColliderUtils_instance = new ColliderUtils();
  Companion_instance_11 = new Companion_11();
  CollisionUtils_instance = new CollisionUtils();
  Companion_instance_12 = new Companion_12();
  Companion_instance_13 = new Companion_13();
  Companion_instance_14 = new Companion_14();
  ComponentIdSpan_instance = new ComponentIdSpan();
  ComponentIds_instance = new ComponentIds();
  ComponentUtils_instance = new ComponentUtils();
  Companion_instance_15 = new Companion_15();
  Companion_instance_16 = new Companion_16();
  ConnectionUtils_instance = new ConnectionUtils();
  Companion_instance_18 = new Companion_18();
  Companion_instance_19 = new Companion_19();
  Companion_instance_20 = new Companion_20();
  Companion_instance_21 = new Companion_21();
  ConnectorTagConstants_instance = new ConnectorTagConstants();
  ConnectorType_instance = new ConnectorType();
  ConnectorUtils_instance = new ConnectorUtils();
  Companion_instance_23 = new Companion_23();
  Companion_instance_24 = new Companion_24();
  RelativeConnectorRepositioner_instance = new RelativeConnectorRepositioner();
  Companion_instance_25 = new Companion_25();
  RotationDegreeOfFreedomImpostor_instance = new RotationDegreeOfFreedomImpostor();
  Companion_instance_27 = new Companion_27();
  Companion_instance_28 = new Companion_28();
  Companion_instance_29 = new Companion_29();
  Companion_instance_30 = new Companion_30();
  Companion_instance_31 = new Companion_31();
  Companion_instance_32 = new Companion_32();
  Companion_instance_33 = new Companion_33();
  Companion_instance_34 = new Companion_34();
  Companion_instance_35 = new Companion_35();
  Companion_instance_41 = new Companion_41();
  EntityGroupUtils_instance = new EntityGroupUtils();
  Companion_instance_44 = new Companion_44();
  Companion_instance_45 = new Companion_45();
  Companion_instance_46 = new Companion_46();
  Companion_instance_48 = new Companion_48();
  HierarchyUtils_instance = new HierarchyUtils();
  InSceneComponent_instance = new InSceneComponent();
  Companion_instance_49 = new Companion_49();
  SceneComponent_instance = new SceneComponent();
  Companion_instance_50 = new Companion_50();
  HistoryEvent_instance = new HistoryEvent();
  Companion_instance_51 = new Companion_51();
  LogLevelJavascriptImpostor_instance = new LogLevelJavascriptImpostor();
  Companion_instance_52 = new Companion_52();
  Companion_instance_53 = new Companion_53();
  Companion_instance_54 = new Companion_54();
  Companion_instance_55 = new Companion_55();
  Companion_instance_61 = new Companion_61();
  ProductUtils_instance = new ProductUtils();
  ProppingComponent_instance = new ProppingComponent();
  Companion_instance_62 = new Companion_62();
  Companion_instance_63 = new Companion_63();
  RaycastUtils_instance = new RaycastUtils();
  Companion_instance_64 = new Companion_64();
  Companion_instance_65 = new Companion_65();
  Companion_instance_67 = new Companion_67();
  Companion_instance_68 = new Companion_68();
  Companion_instance_69 = new Companion_69();
  Companion_instance_70 = new Companion_70();
  RenderedComponent_instance = new RenderedComponent();
  Companion_instance_71 = new Companion_71();
  Companion_instance_72 = new Companion_72();
  Companion_instance_73 = new Companion_73();
  Companion_instance_75 = new Companion_75();
  Companion_instance_76 = new Companion_76();
  Companion_instance_78 = new Companion_78();
  MultiSelectionEnabledComponent_instance = new MultiSelectionEnabledComponent();
  Companion_instance_79 = new Companion_79();
  SelectedComponent_instance = new SelectedComponent();
  Companion_instance_82 = new Companion_82();
  SceneReloadingComponent_instance = new SceneReloadingComponent();
  Companion_instance_83 = new Companion_83();
  Companion_instance_85 = new Companion_85();
  Companion_instance_86 = new Companion_86();
  Companion_instance_87 = new Companion_87();
  Companion_instance_95 = new Companion_95();
  Companion_instance_96 = new Companion_96();
  Companion_instance_97 = new Companion_97();
  SelectAll_instance = new SelectAll();
  SortByPriorityInActivationDistanceThenDistance_instance = new SortByPriorityInActivationDistanceThenDistance();
  SortByPriorityThenDistance_instance = new SortByPriorityThenDistance();
  SortByDistance_instance = new SortByDistance();
  Companion_instance_98 = new Companion_98();
  Companion_instance_99 = new Companion_99();
  Companion_instance_100 = new Companion_100();
  SnapUtils_instance = new SnapUtils();
  Companion_instance_101 = new Companion_101();
  Companion_instance_102 = new Companion_102();
  Companion_instance_104 = new Companion_104();
  ApiSystemIds_instance = new ApiSystemIds();
  AlwaysHangDownComponent_instance = new AlwaysHangDownComponent();
  Companion_instance_105 = new Companion_105();
  Companion_instance_107 = new Companion_107();
  TransformUtils_instance = new TransformUtils();
  Companion_instance_108 = new Companion_108();
  UrlHelper_instance = new UrlHelper();
  Companion_instance_110 = new Companion_110();
  Companion_instance_111 = new Companion_111();
  Companion_instance_112 = new Companion_112();
  Companion_instance_113 = new Companion_113();
  Companion_instance_114 = new Companion_114();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$action = $com$ikea$core.action || ($com$ikea$core.action = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$action = $com$ikea$core.action || ($com$ikea$core.action = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$action = $com$ikea$core.action || ($com$ikea$core.action = {});
    $com$ikea$core$action.ActionState = ActionState;
    $com$ikea$core$action.ActionState.values = values;
    $com$ikea$core$action.ActionState.valueOf = valueOf;
    defineProp($com$ikea$core$action.ActionState, 'NOT_DONE', ActionState_NOT_DONE_getInstance);
    defineProp($com$ikea$core$action.ActionState, 'DONE', ActionState_DONE_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$api = $com$ikea$core.api || ($com$ikea$core.api = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$api = $com$ikea$core.api || ($com$ikea$core.api = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$api = $com$ikea$core.api || ($com$ikea$core.api = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$api = $com$ikea$core.api || ($com$ikea$core.api = {});
    $com$ikea$core$api.CoreServices = CoreServices;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$api = $com$ikea$core.api || ($com$ikea$core.api = {});
    $com$ikea$core$api.MissingCriticalModuleException = MissingCriticalModuleException;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.AddPartAction = AddPartAction;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.AssemblyBuilder = AssemblyBuilder;
    defineProp($com$ikea$core$assemblies.AssemblyBuilder, 'Companion', Companion_getInstance_0);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.AssemblyPart = AssemblyPart;
    $com$ikea$core$assemblies.AssemblyPartSnapInfo = AssemblyPartSnapInfo;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.AssemblyPartConnectorInfo = AssemblyPartConnectorInfo;
    defineProp($com$ikea$core$assemblies.AssemblyPartConnectorInfo, 'Companion', Companion_getInstance_1);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.AssemblyPartIdsComponent = AssemblyPartIdsComponent;
    defineProp($com$ikea$core$assemblies.AssemblyPartIdsComponent, 'Companion', Companion_getInstance_2);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.AssemblyStructureComponent = AssemblyStructureComponent;
    defineProp($com$ikea$core$assemblies.AssemblyStructureComponent, 'Companion', Companion_getInstance_4);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.PartPair = PartPair;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.ProductPartComponent = ProductPartComponent;
    defineProp($com$ikea$core$assemblies.ProductPartComponent, 'Companion', Companion_getInstance_6);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$assemblies = $com$ikea$core.assemblies || ($com$ikea$core.assemblies = {});
    $com$ikea$core$assemblies.RemovePartAction = RemovePartAction;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    defineProp($com$ikea$core$catalog, 'ProductCatalogFunctions', ProductCatalogFunctions_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductComponent = ProductComponent;
    defineProp($com$ikea$core$catalog.ProductComponent, 'Companion', Companion_getInstance_7);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductSpecification = ProductSpecification;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductStructureBuilder = ProductStructureBuilder;
    defineProp($com$ikea$core$catalog.ProductStructureBuilder, 'Companion', Companion_getInstance_8);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductStructureComponent = ProductStructureComponent;
    defineProp($com$ikea$core$catalog.ProductStructureComponent, 'Companion', Companion_getInstance_9);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductStructureConnection = ProductStructureConnection;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$catalog = $com$ikea$core.catalog || ($com$ikea$core.catalog = {});
    $com$ikea$core$catalog.ProductStructureItem = ProductStructureItem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collections = $com$ikea$core.collections || ($com$ikea$core.collections = {});
    $com$ikea$core$collections.CircularBuffer = CircularBuffer;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.ColliderComponent = ColliderComponent;
    defineProp($com$ikea$core$collision.ColliderComponent, 'Companion', Companion_getInstance_10);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.ColliderShapeComponent = ColliderShapeComponent;
    defineProp($com$ikea$core$collision.ColliderShapeComponent, 'Companion', Companion_getInstance_11);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    defineProp($com$ikea$core$collision, 'ColliderUtils', ColliderUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.Collision = Collision;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.CollisionConstants = CollisionConstants;
    defineProp($com$ikea$core$collision.CollisionConstants, 'Companion', Companion_getInstance_12);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    defineProp($com$ikea$core$collision, 'CollisionUtils', CollisionUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.CollisionValidation = CollisionValidation;
    defineProp($com$ikea$core$collision.CollisionValidation, 'Companion', Companion_getInstance_13);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.CollisionValidationResult = CollisionValidationResult;
    defineProp($com$ikea$core$collision.CollisionValidationResult, 'Companion', Companion_getInstance_14);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$collision = $com$ikea$core.collision || ($com$ikea$core.collision = {});
    $com$ikea$core$collision.WorldColliderUpdateSystem = WorldColliderUpdateSystem;
    defineProp($com$ikea$core$collision.WorldColliderUpdateSystem, 'Companion', Companion_getInstance_15);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$component = $com$ikea$core.component || ($com$ikea$core.component = {});
    defineProp($com$ikea$core$component, 'ComponentIdSpan', ComponentIdSpan_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$component = $com$ikea$core.component || ($com$ikea$core.component = {});
    defineProp($com$ikea$core$component, 'ComponentIds', ComponentIds_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$component = $com$ikea$core.component || ($com$ikea$core.component = {});
    defineProp($com$ikea$core$component, 'ComponentUtils', ComponentUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.AlignmentConnection = AlignmentConnection;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.ChildConnectionValidation = ChildConnectionValidation;
    defineProp($com$ikea$core$connections.ChildConnectionValidation, 'Companion', Companion_getInstance_16);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.Connection = Connection;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.ConnectionRootComponent = ConnectionRootComponent;
    defineProp($com$ikea$core$connections.ConnectionRootComponent, 'Companion', Companion_getInstance_17);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    defineProp($com$ikea$core$connections, 'ConnectionUtils', ConnectionUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.GuestConnectionsComponent = GuestConnectionsComponent;
    defineProp($com$ikea$core$connections.GuestConnectionsComponent, 'Companion', Companion_getInstance_18);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.HostConnectionsComponent = HostConnectionsComponent;
    defineProp($com$ikea$core$connections.HostConnectionsComponent, 'Companion', Companion_getInstance_19);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.TemporarilyPauseConnectionParentingComponent = TemporarilyPauseConnectionParentingComponent;
    defineProp($com$ikea$core$connections.TemporarilyPauseConnectionParentingComponent, 'Companion', Companion_getInstance_20);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.UpdateHostConnectionsSystem = UpdateHostConnectionsSystem;
    defineProp($com$ikea$core$connections.UpdateHostConnectionsSystem, 'Companion', Companion_getInstance_21);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connections = $com$ikea$core.connections || ($com$ikea$core.connections = {});
    $com$ikea$core$connections.closestOnEdge = closestOnEdge;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.Connector = Connector;
    defineProp($com$ikea$core$connectors.Connector, 'Companion', Companion_getInstance_22);
    $com$ikea$core$connectors.allSubConnectors$factory = allSubConnectors$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    defineProp($com$ikea$core$connectors, 'ConnectorTagConstants', ConnectorTagConstants_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    defineProp($com$ikea$core$connectors, 'ConnectorType', ConnectorType_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    defineProp($com$ikea$core$connectors, 'ConnectorUtils', ConnectorUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.ConnectorsComponent = ConnectorsComponent;
    defineProp($com$ikea$core$connectors.ConnectorsComponent, 'Companion', Companion_getInstance_23);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.DisableConnectorsSystem = DisableConnectorsSystem;
    defineProp($com$ikea$core$connectors.DisableConnectorsSystem, 'Companion', Companion_getInstance_24);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.DisabledConnectorsComponent = DisabledConnectorsComponent;
    defineProp($com$ikea$core$connectors.DisabledConnectorsComponent, 'Companion', Companion_getInstance_25);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.EdgeConnector = EdgeConnector;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.PointConnector = PointConnector;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.PointSeriesConnector = PointSeriesConnector;
    $com$ikea$core$connectors.direction$factory = direction$factory;
    $com$ikea$core$connectors.allSubConnectors$factory = allSubConnectors$factory_0;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.PointSeriesSubConnector = PointSeriesSubConnector;
    $com$ikea$core$connectors.series$factory = series$factory;
    $com$ikea$core$connectors.series$factory = series$factory_0;
    $com$ikea$core$connectors.series$factory = series$factory_1;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.RelativeConnectorData = RelativeConnectorData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    defineProp($com$ikea$core$connectors, 'RelativeConnectorRepositioner', RelativeConnectorRepositioner_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.RelativeConnectorsComponent = RelativeConnectorsComponent;
    defineProp($com$ikea$core$connectors.RelativeConnectorsComponent, 'Companion', Companion_getInstance_26);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.RotationDegreeOfFreedom = RotationDegreeOfFreedom;
    $com$ikea$core$connectors.RotationDegreeOfFreedom.values = values_0;
    $com$ikea$core$connectors.RotationDegreeOfFreedom.valueOf = valueOf_0;
    defineProp($com$ikea$core$connectors.RotationDegreeOfFreedom, 'NONE', RotationDegreeOfFreedom_NONE_getInstance);
    defineProp($com$ikea$core$connectors.RotationDegreeOfFreedom, 'ONE', RotationDegreeOfFreedom_ONE_getInstance);
    defineProp($com$ikea$core$connectors, 'RotationDegreeOfFreedomImpostor', RotationDegreeOfFreedomImpostor_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$connectors = $com$ikea$core.connectors || ($com$ikea$core.connectors = {});
    $com$ikea$core$connectors.SurfaceConnector = SurfaceConnector;
    defineProp($com$ikea$core$connectors.SurfaceConnector, 'Companion', Companion_getInstance_27);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$debugutils = $com$ikea$core.debugutils || ($com$ikea$core.debugutils = {});
    $com$ikea$core$debugutils.DebugLine = DebugLine;
    $com$ikea$core$debugutils.DebugLinesComponent = DebugLinesComponent;
    defineProp($com$ikea$core$debugutils.DebugLinesComponent, 'Companion', Companion_getInstance_28);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$debugutils = $com$ikea$core.debugutils || ($com$ikea$core.debugutils = {});
    $com$ikea$core$debugutils.DebugSurfacesComponent = DebugSurfacesComponent;
    defineProp($com$ikea$core$debugutils.DebugSurfacesComponent, 'Companion', Companion_getInstance_29);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.DragSurfacesComponent = DragSurfacesComponent;
    defineProp($com$ikea$core$dragging.DragSurfacesComponent, 'Companion', Companion_getInstance_30);
    $com$ikea$core$dragging.DragSurface = DragSurface;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.DraggableComponent = DraggableComponent;
    defineProp($com$ikea$core$dragging.DraggableComponent, 'Companion', Companion_getInstance_31);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.SomethingIsDraggedComponent = SomethingIsDraggedComponent;
    defineProp($com$ikea$core$dragging.SomethingIsDraggedComponent, 'Companion', Companion_getInstance_32);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.DragType = DragType;
    $com$ikea$core$dragging.DragType.values = values_1;
    $com$ikea$core$dragging.DragType.valueOf = valueOf_1;
    defineProp($com$ikea$core$dragging.DragType, 'DragStart', DragType_DragStart_getInstance);
    defineProp($com$ikea$core$dragging.DragType, 'DragMove', DragType_DragMove_getInstance);
    defineProp($com$ikea$core$dragging.DragType, 'DragEnd', DragType_DragEnd_getInstance);
    $com$ikea$core$dragging.ViewerDragEventComponent = ViewerDragEventComponent;
    defineProp($com$ikea$core$dragging.ViewerDragEventComponent, 'Companion', Companion_getInstance_33);
    $com$ikea$core$dragging.rayFromCameraToDragEnd$factory = rayFromCameraToDragEnd$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.WorldDragSurfaceUpdateSystem = WorldDragSurfaceUpdateSystem;
    defineProp($com$ikea$core$dragging.WorldDragSurfaceUpdateSystem, 'Companion', Companion_getInstance_34);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.WorldDragSurfacesComponent = WorldDragSurfacesComponent;
    defineProp($com$ikea$core$dragging.WorldDragSurfacesComponent, 'Companion', Companion_getInstance_35);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$dragging = $com$ikea$core.dragging || ($com$ikea$core.dragging = {});
    $com$ikea$core$dragging.WorldSpaceDragEventComponent = WorldSpaceDragEventComponent;
    defineProp($com$ikea$core$dragging.WorldSpaceDragEventComponent, 'Companion', Companion_getInstance_36);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    $com$ikea$core$ecs.ComponentHolder = ComponentHolder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    $com$ikea$core$ecs.Entity = Entity;
    defineProp($com$ikea$core$ecs.Entity, 'Companion', Companion_getInstance_37);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    $com$ikea$core$ecs.EntityManagerImpl = EntityManagerImpl;
    defineProp($com$ikea$core$ecs.EntityManagerImpl, 'Companion', Companion_getInstance_38);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    $com$ikea$core$ecs.EntityManagerWatcherList = EntityManagerWatcherList;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    $com$ikea$core$ecs.EcsSystemImpl = EcsSystemImpl;
    $com$ikea$core$ecs.ComponentListenerImpl = ComponentListenerImpl;
    $com$ikea$core$ecs.SystemBase = SystemBase;
    defineProp($com$ikea$core$ecs.SystemBase, 'Companion', Companion_getInstance_39);
    $com$ikea$core$ecs.SystemBase2 = SystemBase2;
    $com$ikea$core$ecs.SystemBase3 = SystemBase3;
    $com$ikea$core$ecs.SystemBase4 = SystemBase4;
    $com$ikea$core$ecs.SystemBase5 = SystemBase5;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$ecs = $com$ikea$core.ecs || ($com$ikea$core.ecs = {});
    defineProp($com$ikea$core$ecs, 'SystemGraphHelper', SystemGraphHelper_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.AutomaticGroupBuilderSystem = AutomaticGroupBuilderSystem;
    defineProp($com$ikea$core$groups.AutomaticGroupBuilderSystem, 'Companion', Companion_getInstance_40);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.AutomaticGroupComponent = AutomaticGroupComponent;
    defineProp($com$ikea$core$groups.AutomaticGroupComponent, 'Companion', Companion_getInstance_41);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.AutomaticGroupIdCountComponent = AutomaticGroupIdCountComponent;
    defineProp($com$ikea$core$groups.AutomaticGroupIdCountComponent, 'Companion', Companion_getInstance_42);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    defineProp($com$ikea$core$groups, 'EntityGroupUtils', EntityGroupUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.ManualEntityGroupBuilderService = ManualEntityGroupBuilderService;
    defineProp($com$ikea$core$groups.ManualEntityGroupBuilderService, 'Companion', Companion_getInstance_43);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.ManualGroupComponent = ManualGroupComponent;
    defineProp($com$ikea$core$groups.ManualGroupComponent, 'Companion', Companion_getInstance_44);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.ManualGroupConnectorValidation = ManualGroupConnectorValidation;
    defineProp($com$ikea$core$groups.ManualGroupConnectorValidation, 'Companion', Companion_getInstance_45);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    $com$ikea$core$groups.ManualGroupIdCountComponent = ManualGroupIdCountComponent;
    defineProp($com$ikea$core$groups.ManualGroupIdCountComponent, 'Companion', Companion_getInstance_46);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$groups = $com$ikea$core.groups || ($com$ikea$core.groups = {});
    defineProp($com$ikea$core$groups, 'StaticComponent', StaticComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.ChildComponent = ChildComponent;
    defineProp($com$ikea$core$hierarchies.ChildComponent, 'Companion', Companion_getInstance_47);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.ConnectionParentingSystem = ConnectionParentingSystem;
    defineProp($com$ikea$core$hierarchies.ConnectionParentingSystem, 'Companion', Companion_getInstance_48);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.HierarchySystem = HierarchySystem;
    defineProp($com$ikea$core$hierarchies.HierarchySystem, 'Companion', Companion_getInstance_49);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    defineProp($com$ikea$core$hierarchies, 'HierarchyUtils', HierarchyUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    defineProp($com$ikea$core$hierarchies, 'InSceneComponent', InSceneComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.ParentComponent = ParentComponent;
    $com$ikea$core$hierarchies.ParentComponent.generateHierarchy$default = generateHierarchy$default;
    defineProp($com$ikea$core$hierarchies.ParentComponent, 'Companion', Companion_getInstance_50);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    defineProp($com$ikea$core$hierarchies, 'SceneComponent', SceneComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    $com$ikea$core$hierarchies.SceneGraphSystem = SceneGraphSystem;
    defineProp($com$ikea$core$hierarchies.SceneGraphSystem, 'Companion', Companion_getInstance_51);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$hierarchies = $com$ikea$core.hierarchies || ($com$ikea$core.hierarchies = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$history = $com$ikea$core.history || ($com$ikea$core.history = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$history = $com$ikea$core.history || ($com$ikea$core.history = {});
    $com$ikea$core$history.HistoryEventType = HistoryEventType;
    $com$ikea$core$history.HistoryEventType.values = values_2;
    $com$ikea$core$history.HistoryEventType.valueOf = valueOf_2;
    defineProp($com$ikea$core$history.HistoryEventType, 'TAKE_SNAPSHOT', HistoryEventType_TAKE_SNAPSHOT_getInstance);
    defineProp($com$ikea$core$history.HistoryEventType, 'UNDO', HistoryEventType_UNDO_getInstance);
    defineProp($com$ikea$core$history.HistoryEventType, 'REDO', HistoryEventType_REDO_getInstance);
    defineProp($com$ikea$core$history.HistoryEventType, 'CLEAR', HistoryEventType_CLEAR_getInstance);
    defineProp($com$ikea$core$history.HistoryEventType, 'DISCARD_SNAPSHOT', HistoryEventType_DISCARD_SNAPSHOT_getInstance);
    defineProp($com$ikea$core$history, 'HistoryEvent', HistoryEvent_getInstance);
    $com$ikea$core$history.HistoryChangedEventComponent = HistoryChangedEventComponent;
    defineProp($com$ikea$core$history.HistoryChangedEventComponent, 'Companion', Companion_getInstance_52);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$history = $com$ikea$core.history || ($com$ikea$core.history = {});
    $com$ikea$core$history.HistoryImpl = HistoryImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$logging = $com$ikea$core.logging || ($com$ikea$core.logging = {});
    $com$ikea$core$logging.LogLevel = LogLevel;
    $com$ikea$core$logging.LogLevel.values = values_3;
    $com$ikea$core$logging.LogLevel.valueOf = valueOf_3;
    defineProp($com$ikea$core$logging.LogLevel, 'DEBUG', LogLevel_DEBUG_getInstance);
    defineProp($com$ikea$core$logging.LogLevel, 'INFO', LogLevel_INFO_getInstance);
    defineProp($com$ikea$core$logging.LogLevel, 'WARN', LogLevel_WARN_getInstance);
    defineProp($com$ikea$core$logging.LogLevel, 'ERROR', LogLevel_ERROR_getInstance);
    defineProp($com$ikea$core$logging.LogLevel, 'NONE', LogLevel_NONE_getInstance);
    defineProp($com$ikea$core$logging, 'LogLevelJavascriptImpostor', LogLevelJavascriptImpostor_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$logging = $com$ikea$core.logging || ($com$ikea$core.logging = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$logging = $com$ikea$core.logging || ($com$ikea$core.logging = {});
    $com$ikea$core$logging.LoggerImpl = LoggerImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$logging = $com$ikea$core.logging || ($com$ikea$core.logging = {});
    $com$ikea$core$logging.MockLogger = MockLogger;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.AxisAngle = AxisAngle;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Degrees = Degrees;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.DualDouble = DualDouble;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Margin = Margin;
    defineProp($com$ikea$core$math.Margin, 'Companion', Companion_getInstance_53);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    defineProp($com$ikea$core$math, 'MathUtils', MathUtils_getInstance);
    MathUtils.prototype.Axis = Axis;
    MathUtils.prototype.Axis.values = values_4;
    MathUtils.prototype.Axis.valueOf = valueOf_4;
    defineProp(MathUtils.prototype.Axis, 'X', Axis_X_getInstance);
    defineProp(MathUtils.prototype.Axis, 'Y', Axis_Y_getInstance);
    defineProp(MathUtils.prototype.Axis, 'Z', Axis_Z_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.ModelTransform = ModelTransform;
    defineProp($com$ikea$core$math.ModelTransform, 'Companion', Companion_getInstance_54);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Plane = Plane;
    defineProp($com$ikea$core$math.Plane, 'Companion', Companion_getInstance_55);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Polygon = Polygon;
    defineProp($com$ikea$core$math.Polygon, 'Companion', Companion_getInstance_56);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Quaternion = Quaternion;
    $com$ikea$core$math.Quaternion.QuaternionFromInts = QuaternionFromInts;
    $com$ikea$core$math.Quaternion.QuaternionFromDouble = QuaternionFromDouble;
    defineProp($com$ikea$core$math.Quaternion, 'Companion', Companion_getInstance_57);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Radians = Radians;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.RelativeBoxOffset = RelativeBoxOffset;
    $com$ikea$core$math.RelationOriginAlongX = RelationOriginAlongX;
    $com$ikea$core$math.RelationOriginAlongX.values = values_5;
    $com$ikea$core$math.RelationOriginAlongX.valueOf = valueOf_5;
    defineProp($com$ikea$core$math.RelationOriginAlongX, 'LEFT', RelationOriginAlongX_LEFT_getInstance);
    defineProp($com$ikea$core$math.RelationOriginAlongX, 'CENTER', RelationOriginAlongX_CENTER_getInstance);
    defineProp($com$ikea$core$math.RelationOriginAlongX, 'RIGHT', RelationOriginAlongX_RIGHT_getInstance);
    defineProp($com$ikea$core$math, 'RelationOriginAlongXImpostor', RelationOriginAlongXImpostor_getInstance);
    $com$ikea$core$math.RelationOriginAlongY = RelationOriginAlongY;
    $com$ikea$core$math.RelationOriginAlongY.values = values_6;
    $com$ikea$core$math.RelationOriginAlongY.valueOf = valueOf_6;
    defineProp($com$ikea$core$math.RelationOriginAlongY, 'BOTTOM', RelationOriginAlongY_BOTTOM_getInstance);
    defineProp($com$ikea$core$math.RelationOriginAlongY, 'CENTER', RelationOriginAlongY_CENTER_getInstance);
    defineProp($com$ikea$core$math.RelationOriginAlongY, 'TOP', RelationOriginAlongY_TOP_getInstance);
    defineProp($com$ikea$core$math, 'RelationOriginAlongYImpostor', RelationOriginAlongYImpostor_getInstance);
    $com$ikea$core$math.RelationOriginAlongZ = RelationOriginAlongZ;
    $com$ikea$core$math.RelationOriginAlongZ.values = values_7;
    $com$ikea$core$math.RelationOriginAlongZ.valueOf = valueOf_7;
    defineProp($com$ikea$core$math.RelationOriginAlongZ, 'BACK', RelationOriginAlongZ_BACK_getInstance);
    defineProp($com$ikea$core$math.RelationOriginAlongZ, 'CENTER', RelationOriginAlongZ_CENTER_getInstance);
    defineProp($com$ikea$core$math.RelationOriginAlongZ, 'FRONT', RelationOriginAlongZ_FRONT_getInstance);
    defineProp($com$ikea$core$math, 'RelationOriginAlongZImpostor', RelationOriginAlongZImpostor_getInstance);
    $com$ikea$core$math.RelationOrigin = RelationOrigin;
    defineProp($com$ikea$core$math.RelationOrigin, 'Companion', Companion_getInstance_58);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Size = Size;
    $com$ikea$core$math.Size.SizeFromVector = SizeFromVector;
    defineProp($com$ikea$core$math.Size, 'Companion', Companion_getInstance_59);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Transform = Transform;
    defineProp($com$ikea$core$math.Transform, 'Companion', Companion_getInstance_60);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.Vector = Vector;
    $com$ikea$core$math.Vector.__VectorIntConstructorKotlin = __VectorIntConstructorKotlin;
    defineProp($com$ikea$core$math.Vector, 'Companion', Companion_getInstance_61);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$math = $com$ikea$core.math || ($com$ikea$core.math = {});
    $com$ikea$core$math.times = times;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$measuring = $com$ikea$core.measuring || ($com$ikea$core.measuring = {});
    $com$ikea$core$measuring.InnerMeasurement = InnerMeasurement;
    defineProp($com$ikea$core$measuring, 'MeasurementUtils', MeasurementUtils_getInstance);
    $com$ikea$core$measuring.distance$factory = distance$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$nothing = $com$ikea$core.nothing || ($com$ikea$core.nothing = {});
    defineProp($com$ikea$core$nothing, 'nothing', get_nothing);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$products = $com$ikea$core.products || ($com$ikea$core.products = {});
    $com$ikea$core$products.DisplayNameComponent = DisplayNameComponent;
    defineProp($com$ikea$core$products.DisplayNameComponent, 'Companion', Companion_getInstance_62);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$products = $com$ikea$core.products || ($com$ikea$core.products = {});
    defineProp($com$ikea$core$products, 'ProductUtils', ProductUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$products = $com$ikea$core.products || ($com$ikea$core.products = {});
    defineProp($com$ikea$core$products, 'ProppingComponent', ProppingComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$products = $com$ikea$core.products || ($com$ikea$core.products = {});
    $com$ikea$core$products.TemplateDataComponent = TemplateDataComponent;
    defineProp($com$ikea$core$products.TemplateDataComponent, 'Companion', Companion_getInstance_63);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$raycasting = $com$ikea$core.raycasting || ($com$ikea$core.raycasting = {});
    $com$ikea$core$raycasting.Ray = Ray;
    defineProp($com$ikea$core$raycasting.Ray, 'Companion', Companion_getInstance_64);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$raycasting = $com$ikea$core.raycasting || ($com$ikea$core.raycasting = {});
    $com$ikea$core$raycasting.RaycastHit = RaycastHit;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$raycasting = $com$ikea$core.raycasting || ($com$ikea$core.raycasting = {});
    $com$ikea$core$raycasting.RaycastResult = RaycastResult;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$raycasting = $com$ikea$core.raycasting || ($com$ikea$core.raycasting = {});
    defineProp($com$ikea$core$raycasting, 'RaycastUtils', RaycastUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$raycasting = $com$ikea$core.raycasting || ($com$ikea$core.raycasting = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.LoadedModelInfoComponent = LoadedModelInfoComponent;
    defineProp($com$ikea$core$rendering.LoadedModelInfoComponent, 'Companion', Companion_getInstance_65);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ModelInfoComponent = ModelInfoComponent;
    defineProp($com$ikea$core$rendering.ModelInfoComponent, 'Companion', Companion_getInstance_66);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ModelLoaderSystem = ModelLoaderSystem;
    defineProp($com$ikea$core$rendering.ModelLoaderSystem, 'Companion', Companion_getInstance_67);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ModelTransformComponent = ModelTransformComponent;
    defineProp($com$ikea$core$rendering.ModelTransformComponent, 'Companion', Companion_getInstance_68);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    defineProp($com$ikea$core$rendering, 'ModelUtils', ModelUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.OutlineableComponent = OutlineableComponent;
    defineProp($com$ikea$core$rendering.OutlineableComponent, 'Companion', Companion_getInstance_69);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.RenderSystem = RenderSystem;
    defineProp($com$ikea$core$rendering.RenderSystem, 'Companion', Companion_getInstance_71);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    defineProp($com$ikea$core$rendering, 'RenderedComponent', RenderedComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ViewerComponent = ViewerComponent;
    defineProp($com$ikea$core$rendering.ViewerComponent, 'Companion', Companion_getInstance_72);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ViewerLineIdsComponent = ViewerLineIdsComponent;
    defineProp($com$ikea$core$rendering.ViewerLineIdsComponent, 'Companion', Companion_getInstance_73);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ViewerObjectComponent = ViewerObjectComponent;
    defineProp($com$ikea$core$rendering.ViewerObjectComponent, 'Companion', Companion_getInstance_74);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ViewerObjectTransformSystem = ViewerObjectTransformSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ViewerObjectVisibilitySystem = ViewerObjectVisibilitySystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    $com$ikea$core$rendering.ViewerPresenceSystem = ViewerPresenceSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    var $com$ikea$core$rendering$mock = $com$ikea$core$rendering.mock || ($com$ikea$core$rendering.mock = {});
    $com$ikea$core$rendering$mock.ViewerMock = ViewerMock;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$rendering = $com$ikea$core.rendering || ($com$ikea$core.rendering = {});
    var $com$ikea$core$rendering$mock = $com$ikea$core$rendering.mock || ($com$ikea$core$rendering.mock = {});
    $com$ikea$core$rendering$mock.MockDragGenerator = MockDragGenerator;
    defineProp($com$ikea$core$rendering$mock.MockDragGenerator, 'Companion', Companion_getInstance_75);
    $com$ikea$core$rendering$mock.ViewerObjectMock = ViewerObjectMock;
    defineProp($com$ikea$core$rendering$mock.ViewerObjectMock, 'Companion', Companion_getInstance_76);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$replace = $com$ikea$core.replace || ($com$ikea$core.replace = {});
    $com$ikea$core$replace.FastReplaceAction = FastReplaceAction;
    defineProp($com$ikea$core$replace.FastReplaceAction, 'Companion', Companion_getInstance_78);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$replace = $com$ikea$core.replace || ($com$ikea$core.replace = {});
    $com$ikea$core$replace.ReplaceAction = ReplaceAction;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$replace = $com$ikea$core.replace || ($com$ikea$core.replace = {});
    $com$ikea$core$replace.ReplacePartAction = ReplacePartAction;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$selection = $com$ikea$core.selection || ($com$ikea$core.selection = {});
    $com$ikea$core$selection.ClickEventComponent = ClickEventComponent;
    defineProp($com$ikea$core$selection.ClickEventComponent, 'Companion', Companion_getInstance_79);
    $com$ikea$core$selection.triggerClickEvent = triggerClickEvent;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$selection = $com$ikea$core.selection || ($com$ikea$core.selection = {});
    defineProp($com$ikea$core$selection, 'MultiSelectionEnabledComponent', MultiSelectionEnabledComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$selection = $com$ikea$core.selection || ($com$ikea$core.selection = {});
    $com$ikea$core$selection.SelectableComponent = SelectableComponent;
    defineProp($com$ikea$core$selection.SelectableComponent, 'Companion', Companion_getInstance_80);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$selection = $com$ikea$core.selection || ($com$ikea$core.selection = {});
    defineProp($com$ikea$core$selection, 'SelectedComponent', SelectedComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.CatalogsHeader = CatalogsHeader;
    defineProp($com$ikea$core$serialization.CatalogsHeader, 'Companion', Companion_getInstance_81);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.ComponentDeserializerRegistry = ComponentDeserializerRegistry;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.JsonSerializer = JsonSerializer;
    defineProp($com$ikea$core$serialization.JsonSerializer, 'Companion', Companion_getInstance_82);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.PreviouslySerializedIdComponent = PreviouslySerializedIdComponent;
    defineProp($com$ikea$core$serialization.PreviouslySerializedIdComponent, 'Companion', Companion_getInstance_83);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    defineProp($com$ikea$core$serialization, 'SceneReloadingComponent', SceneReloadingComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.SerializableGuestConnectionsComponent = SerializableGuestConnectionsComponent;
    defineProp($com$ikea$core$serialization.SerializableGuestConnectionsComponent, 'Companion', Companion_getInstance_85);
    $com$ikea$core$serialization.SerializableGuestConnectionsComponent.SerializableConnection = SerializableConnection;
    defineProp($com$ikea$core$serialization.SerializableGuestConnectionsComponent.SerializableConnection, 'Companion', Companion_getInstance_84);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.toJsonString = toJsonString;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.UnserializableEntityComponent = UnserializableEntityComponent;
    defineProp($com$ikea$core$serialization.UnserializableEntityComponent, 'Companion', Companion_getInstance_86);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    $com$ikea$core$serialization.VersionHeader = VersionHeader;
    defineProp($com$ikea$core$serialization.VersionHeader, 'Companion', Companion_getInstance_87);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com$ikea$core$serialization$entitytreebuilder = $com$ikea$core$serialization.entitytreebuilder || ($com$ikea$core$serialization.entitytreebuilder = {});
    $com$ikea$core$serialization$entitytreebuilder.ConnectionGraphBuildOrder = ConnectionGraphBuildOrder;
    defineProp($com$ikea$core$serialization$entitytreebuilder.ConnectionGraphBuildOrder, 'Companion', Companion_getInstance_88);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com$ikea$core$serialization$entitytreebuilder = $com$ikea$core$serialization.entitytreebuilder || ($com$ikea$core$serialization.entitytreebuilder = {});
    $com$ikea$core$serialization$entitytreebuilder.EntityTreeBuilder = EntityTreeBuilder;
    $com$ikea$core$serialization$entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal$default = buildEntityTreeInternal$default;
    $com$ikea$core$serialization$entitytreebuilder.EntityTreeBuilder.buildEntityTreeNode$default = buildEntityTreeNode$default;
    $com$ikea$core$serialization$entitytreebuilder.EntityTreeBuilder.ShadowEntityWithParent = ShadowEntityWithParent;
    $com$ikea$core$serialization$entitytreebuilder.EntityTreeBuilder.NewEntityWithShadowChildren = NewEntityWithShadowChildren;
    defineProp($com$ikea$core$serialization$entitytreebuilder.EntityTreeBuilder, 'Companion', Companion_getInstance_89);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com$ikea$core$serialization$v13 = $com$ikea$core$serialization.v13 || ($com$ikea$core$serialization.v13 = {});
    $com$ikea$core$serialization$v13.SerializableEntityV13 = SerializableEntityV13;
    defineProp($com$ikea$core$serialization$v13.SerializableEntityV13, 'Companion', Companion_getInstance_90);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$serialization = $com$ikea$core.serialization || ($com$ikea$core.serialization = {});
    var $com$ikea$core$serialization$v13 = $com$ikea$core$serialization.v13 || ($com$ikea$core$serialization.v13 = {});
    $com$ikea$core$serialization$v13.SerializableTreeV13 = SerializableTreeV13;
    defineProp($com$ikea$core$serialization$v13.SerializableTreeV13, 'Companion', Companion_getInstance_91);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$shapes = $com$ikea$core.shapes || ($com$ikea$core.shapes = {});
    $com$ikea$core$shapes.AxisAlignedBox = AxisAlignedBox;
    defineProp($com$ikea$core$shapes.AxisAlignedBox, 'Companion', Companion_getInstance_93);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$shapes = $com$ikea$core.shapes || ($com$ikea$core.shapes = {});
    $com$ikea$core$shapes.ConvexPolyhedron = ConvexPolyhedron;
    defineProp($com$ikea$core$shapes.ConvexPolyhedron, 'Companion', Companion_getInstance_94);
    $com$ikea$core$shapes.axisAlignedBoundingBox$factory = axisAlignedBoundingBox$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$shapes = $com$ikea$core.shapes || ($com$ikea$core.shapes = {});
    $com$ikea$core$shapes.Face = Face;
    $com$ikea$core$shapes.Cuboid = Cuboid;
    $com$ikea$core$shapes.Cuboid.CuboidFromSize = CuboidFromSize;
    $com$ikea$core$shapes.Cuboid.CuboidFromSizeAndCenter = CuboidFromSizeAndCenter;
    defineProp($com$ikea$core$shapes.Cuboid, 'Companion', Companion_getInstance_95);
    $com$ikea$core$shapes.size$factory = size$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$shapes = $com$ikea$core.shapes || ($com$ikea$core.shapes = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$shapes = $com$ikea$core.shapes || ($com$ikea$core.shapes = {});
    $com$ikea$core$shapes.PolyhedronGroup = PolyhedronGroup;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$shapes = $com$ikea$core.shapes || ($com$ikea$core.shapes = {});
    defineProp($com$ikea$core$shapes, 'PolyhedronUtils', PolyhedronUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.MovedToCandidateSnapPositionComponent = MovedToCandidateSnapPositionComponent;
    defineProp($com$ikea$core$snapping.MovedToCandidateSnapPositionComponent, 'Companion', Companion_getInstance_96);
    $com$ikea$core$snapping.triggerMovedToCandidateSnapPositionComponent = triggerMovedToCandidateSnapPositionComponent;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.MovedToValidSnapPositionComponent = MovedToValidSnapPositionComponent;
    defineProp($com$ikea$core$snapping.MovedToValidSnapPositionComponent, 'Companion', Companion_getInstance_97);
    $com$ikea$core$snapping.triggerMovedToValidSnapPositionComponent = triggerMovedToValidSnapPositionComponent;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.RestrictAllowedRequiredHostsComponent = RestrictAllowedRequiredHostsComponent;
    defineProp($com$ikea$core$snapping.RestrictAllowedRequiredHostsComponent, 'Companion', Companion_getInstance_98);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.SnapAction = SnapAction;
    $com$ikea$core$snapping.SnapAction.SnapActionFromCandidate = SnapActionFromCandidate;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.SnapActionCandidateImpl = SnapActionCandidateImpl;
    $com$ikea$core$snapping.guestRootToGuestDeltaTransform$factory = guestRootToGuestDeltaTransform$factory;
    $com$ikea$core$snapping.guestRootToGuestConnectorDeltaTransform$factory = guestRootToGuestConnectorDeltaTransform$factory;
    $com$ikea$core$snapping.guestEndTransform$factory = guestEndTransform$factory;
    $com$ikea$core$snapping.inActivationDistance$factory = inActivationDistance$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    defineProp($com$ikea$core$snapping, 'SnapActionCandidateSortAndSelectStrategies', SnapActionCandidateSortAndSelectStrategies_getInstance);
    defineProp($com$ikea$core$snapping, 'SelectAll', SelectAll_getInstance);
    defineProp($com$ikea$core$snapping, 'SortByPriorityInActivationDistanceThenDistance', SortByPriorityInActivationDistanceThenDistance_getInstance);
    defineProp($com$ikea$core$snapping, 'SortByPriorityThenDistance', SortByPriorityThenDistance_getInstance);
    defineProp($com$ikea$core$snapping, 'SortByDistance', SortByDistance_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.SnapActionInProgressComponent = SnapActionInProgressComponent;
    defineProp($com$ikea$core$snapping.SnapActionInProgressComponent, 'Companion', Companion_getInstance_99);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.SnapCandidateComponent = SnapCandidateComponent;
    defineProp($com$ikea$core$snapping.SnapCandidateComponent, 'Companion', Companion_getInstance_100);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.SnapRootComponent = SnapRootComponent;
    defineProp($com$ikea$core$snapping.SnapRootComponent, 'Companion', Companion_getInstance_101);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    $com$ikea$core$snapping.SnapSettings = SnapSettings;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapping = $com$ikea$core.snapping || ($com$ikea$core.snapping = {});
    defineProp($com$ikea$core$snapping, 'SnapUtils', SnapUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapshot = $com$ikea$core.snapshot || ($com$ikea$core.snapshot = {});
    $com$ikea$core$snapshot.EntityState = EntityState;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapshot = $com$ikea$core.snapshot || ($com$ikea$core.snapshot = {});
    $com$ikea$core$snapshot.IsLoadingSnapshotComponent = IsLoadingSnapshotComponent;
    defineProp($com$ikea$core$snapshot.IsLoadingSnapshotComponent, 'Companion', Companion_getInstance_102);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapshot = $com$ikea$core.snapshot || ($com$ikea$core.snapshot = {});
    $com$ikea$core$snapshot.SnapshotIgnoreComponent = SnapshotIgnoreComponent;
    defineProp($com$ikea$core$snapshot.SnapshotIgnoreComponent, 'Companion', Companion_getInstance_103);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapshot = $com$ikea$core.snapshot || ($com$ikea$core.snapshot = {});
    $com$ikea$core$snapshot.SnapshotService = SnapshotService;
    defineProp($com$ikea$core$snapshot.SnapshotService, 'Companion', Companion_getInstance_104);
    $com$ikea$core$snapshot.Snapshot = Snapshot;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$snapshot = $com$ikea$core.snapshot || ($com$ikea$core.snapshot = {});
    $com$ikea$core$snapshot.UpdatedFromSnapshotEventComponent = UpdatedFromSnapshotEventComponent;
    defineProp($com$ikea$core$snapshot.UpdatedFromSnapshotEventComponent, 'Companion', Companion_getInstance_105);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$system = $com$ikea$core.system || ($com$ikea$core.system = {});
    defineProp($com$ikea$core$system, 'ApiSystemIds', ApiSystemIds_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$transforms = $com$ikea$core.transforms || ($com$ikea$core.transforms = {});
    defineProp($com$ikea$core$transforms, 'AlwaysHangDownComponent', AlwaysHangDownComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$transforms = $com$ikea$core.transforms || ($com$ikea$core.transforms = {});
    $com$ikea$core$transforms.LocalTransformComponent = LocalTransformComponent;
    $com$ikea$core$transforms.LocalTransformComponent.LocalTransformComponentFromPosAndRot = LocalTransformComponentFromPosAndRot;
    defineProp($com$ikea$core$transforms.LocalTransformComponent, 'Companion', Companion_getInstance_107);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$transforms = $com$ikea$core.transforms || ($com$ikea$core.transforms = {});
    $com$ikea$core$transforms.TransformSystem = TransformSystem;
    defineProp($com$ikea$core$transforms.TransformSystem, 'Companion', Companion_getInstance_108);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$transforms = $com$ikea$core.transforms || ($com$ikea$core.transforms = {});
    defineProp($com$ikea$core$transforms, 'TransformUtils', TransformUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$transforms = $com$ikea$core.transforms || ($com$ikea$core.transforms = {});
    $com$ikea$core$transforms.WorldTransformComponent = WorldTransformComponent;
    $com$ikea$core$transforms.WorldTransformComponent.WorldTransformComponentFromPosAndRot = WorldTransformComponentFromPosAndRot;
    defineProp($com$ikea$core$transforms.WorldTransformComponent, 'Companion', Companion_getInstance_110);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$utils = $com$ikea$core.utils || ($com$ikea$core.utils = {});
    $com$ikea$core$utils.Measurer = Measurer;
    $com$ikea$core$utils.sum = sum;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$utils = $com$ikea$core.utils || ($com$ikea$core.utils = {});
    $com$ikea$core$utils.MutableStack = MutableStack;
    $com$ikea$core$utils.mutableStackOf = mutableStackOf;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$utils = $com$ikea$core.utils || ($com$ikea$core.utils = {});
    defineProp($com$ikea$core$utils, 'UrlHelper', UrlHelper_getInstance);
    $com$ikea$core$utils.UrlDetails = UrlDetails;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$validation = $com$ikea$core.validation || ($com$ikea$core.validation = {});
    $com$ikea$core$validation.NoValidConnectorAvailableValidationResult = NoValidConnectorAvailableValidationResult;
    defineProp($com$ikea$core$validation.NoValidConnectorAvailableValidationResult, 'Companion', Companion_getInstance_111);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$validation = $com$ikea$core.validation || ($com$ikea$core.validation = {});
    $com$ikea$core$validation.UnknownErrorValidationResult = UnknownErrorValidationResult;
    defineProp($com$ikea$core$validation.UnknownErrorValidationResult, 'Companion', Companion_getInstance_112);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$validation = $com$ikea$core.validation || ($com$ikea$core.validation = {});
    $com$ikea$core$validation.ValidSnapActionCandidateOrErrors = ValidSnapActionCandidateOrErrors;
    defineProp($com$ikea$core$validation.ValidSnapActionCandidateOrErrors, 'Companion', Companion_getInstance_113);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$validation = $com$ikea$core.validation || ($com$ikea$core.validation = {});
    $com$ikea$core$validation.ValidationImpl = ValidationImpl;
    $com$ikea$core$validation.ValidationResultType = ValidationResultType;
    $com$ikea$core$validation.ValidationResultType.values = values_8;
    $com$ikea$core$validation.ValidationResultType.valueOf = valueOf_8;
    defineProp($com$ikea$core$validation.ValidationResultType, 'WARNING', ValidationResultType_WARNING_getInstance);
    defineProp($com$ikea$core$validation.ValidationResultType, 'FAIL', ValidationResultType_FAIL_getInstance);
    $com$ikea$core$validation.ValidationResultFail = ValidationResultFail;
    defineProp($com$ikea$core$validation.ValidationResultFail, 'Companion', Companion_getInstance_114);
    $com$ikea$core$validation.ValidationResultWarning = ValidationResultWarning;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$validation = $com$ikea$core.validation || ($com$ikea$core.validation = {});
    $com$ikea$core$validation.ValidationResult = ValidationResult;
    defineProp($com$ikea$core$validation.ValidationResult, 'Companion', Companion_getInstance_115);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$validation = $com$ikea$core.validation || ($com$ikea$core.validation = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$utils = $com$ikea$core.utils || ($com$ikea$core.utils = {});
    $com$ikea$core$utils.getCoreVersion = getCoreVersion;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = CoreFactory;
  _.$_$.b = CoreModules;
  _.$_$.c = CoreServices;
  _.$_$.d = Core;
  _.$_$.e = AddPartAction;
  _.$_$.f = AssemblyPartSnapInfo;
  _.$_$.g = AssemblyPartsComponent;
  _.$_$.h = AssemblyPart;
  _.$_$.i = AssemblyStructureComponent;
  _.$_$.j = PartPair;
  _.$_$.k = ProductPartComponent;
  _.$_$.l = RemovePartAction;
  _.$_$.m = get_partKey;
  _.$_$.n = createCustomAssemblySpecification;
  _.$_$.o = createCustomAssembly;
  _.$_$.p = ProductCatalog;
  _.$_$.q = ProductComponent;
  _.$_$.r = ProductManager;
  _.$_$.s = ProductSpecification;
  _.$_$.t = ProductStructureComponent;
  _.$_$.u = ProductStructureConnection;
  _.$_$.v = ProductStructureItem;
  _.$_$.w = get_productRef;
  _.$_$.x = get_productRefOrEmptyString;
  _.$_$.y = ColliderShapeComponent;
  _.$_$.z = CollisionValidationResult;
  _.$_$.a1 = CollisionValidation;
  _.$_$.b1 = WorldColliderUpdateSystem;
  _.$_$.c1 = get_axisAlignedBoundingBoxForHierarchy;
  _.$_$.d1 = get_collider;
  _.$_$.e1 = get_colliderShapeComponent;
  _.$_$.f1 = get_objectOrientedBoundingBoxForHierarchy;
  _.$_$.g1 = get_draggableRootEntity;
  _.$_$.h1 = get_selectableRoot;
  _.$_$.i1 = get_snapRoot;
  _.$_$.j1 = ChildConnectionValidation;
  _.$_$.k1 = ConnectionRootComponent;
  _.$_$.l1 = Connection;
  _.$_$.m1 = GuestConnectionsComponent;
  _.$_$.n1 = HostConnectionsComponent;
  _.$_$.o1 = UpdateHostConnectionsSystem;
  _.$_$.p1 = centerOfConnections;
  _.$_$.q1 = get_guestConnections;
  _.$_$.r1 = get_guests;
  _.$_$.s1 = get_highestPriorityConnection;
  _.$_$.t1 = get_isConnectionRoot;
  _.$_$.u1 = ConnectorsComponent;
  _.$_$.v1 = Connector;
  _.$_$.w1 = DisableConnectorsSystem;
  _.$_$.x1 = DisabledConnectorsComponent;
  _.$_$.y1 = EdgeConnector;
  _.$_$.z1 = PointConnector;
  _.$_$.a2 = PointSeriesConnector;
  _.$_$.b2 = PointSeriesSubConnector;
  _.$_$.c2 = RelativeConnectorData;
  _.$_$.d2 = RelativeConnectorsComponent;
  _.$_$.e2 = valueOf_0;
  _.$_$.f2 = RotationDegreeOfFreedom;
  _.$_$.g2 = SurfaceConnector;
  _.$_$.h2 = get_connectorsComponent;
  _.$_$.i2 = get_guestConnectors;
  _.$_$.j2 = get_snappingEntitiesSequence;
  _.$_$.k2 = DebugLinesComponent;
  _.$_$.l2 = DebugLine;
  _.$_$.m2 = DebugSurfacesComponent;
  _.$_$.n2 = DragSurfacesComponent;
  _.$_$.o2 = DragSurface;
  _.$_$.p2 = valueOf_1;
  _.$_$.q2 = DraggableComponent;
  _.$_$.r2 = SomethingIsDraggedComponent;
  _.$_$.s2 = ViewerDragEventComponent;
  _.$_$.t2 = WorldDragSurfaceUpdateSystem;
  _.$_$.u2 = WorldSpaceDragEventComponent;
  _.$_$.v2 = get_doStoreInSnapshot;
  _.$_$.w2 = get_serializable;
  _.$_$.x2 = Component;
  _.$_$.y2 = EntityManagerImpl;
  _.$_$.z2 = EntityManagerWatcher;
  _.$_$.a3 = SystemBase2;
  _.$_$.b3 = SystemBase3;
  _.$_$.c3 = SystemBase4;
  _.$_$.d3 = SystemBase5;
  _.$_$.e3 = SystemBase;
  _.$_$.f3 = AutomaticGroupBuilderSystem;
  _.$_$.g3 = ManualEntityGroupBuilderService;
  _.$_$.h3 = ManualGroupConnectorValidation;
  _.$_$.i3 = get_isAutomaticGroup;
  _.$_$.j3 = ChildComponent;
  _.$_$.k3 = ConnectionParentingSystem;
  _.$_$.l3 = HierarchySystem;
  _.$_$.m3 = ParentComponent;
  _.$_$.n3 = SceneGraphSystem;
  _.$_$.o3 = SceneManager;
  _.$_$.p3 = get_children;
  _.$_$.q3 = get_descendants;
  _.$_$.r3 = filterInHierarchy;
  _.$_$.s3 = findInHierarchy;
  _.$_$.t3 = findWithComponentInUpwardsHierarchy;
  _.$_$.u3 = forEachInHierarchy;
  _.$_$.v3 = getHierarchyWithComponent;
  _.$_$.w3 = hasComponentInUpwardsHierarchy;
  _.$_$.x3 = get_hierarchy;
  _.$_$.y3 = hierarchyContains;
  _.$_$.z3 = hierarchyExceptSubTreeArray;
  _.$_$.a4 = hierarchyExceptSubTreesWithComponentArray;
  _.$_$.b4 = hierarchyExceptSubTreesWithComponentSequence;
  _.$_$.c4 = get_hierarchySequence;
  _.$_$.d4 = isDescendantOf;
  _.$_$.e4 = get_isInScene;
  _.$_$.f4 = get_parent;
  _.$_$.g4 = get_parentComponent;
  _.$_$.h4 = setParentMaintainWorldTransform;
  _.$_$.i4 = setParent;
  _.$_$.j4 = HistoryChangedEventComponent;
  _.$_$.k4 = valueOf_2;
  _.$_$.l4 = HistoryImpl;
  _.$_$.m4 = values_3;
  _.$_$.n4 = get_logLevel;
  _.$_$.o4 = set_logLevel;
  _.$_$.p4 = LoggerImpl;
  _.$_$.q4 = Logger;
  _.$_$.r4 = echoStandardConsole;
  _.$_$.s4 = Degrees;
  _.$_$.t4 = Margin;
  _.$_$.u4 = ModelTransform;
  _.$_$.v4 = Plane;
  _.$_$.w4 = Polygon;
  _.$_$.x4 = Radians;
  _.$_$.y4 = RelationOrigin;
  _.$_$.z4 = RelativeBoxOffset;
  _.$_$.a5 = Size;
  _.$_$.b5 = Transform;
  _.$_$.c5 = Vector;
  _.$_$.d5 = almostEquals;
  _.$_$.e5 = DisplayNameComponent;
  _.$_$.f5 = TemplateDataComponent;
  _.$_$.g5 = get_connectionRootEntity;
  _.$_$.h5 = get_displayName;
  _.$_$.i5 = get_immediateConnectionRootDescendants;
  _.$_$.j5 = get_isPropping;
  _.$_$.k5 = RaycastHit;
  _.$_$.l5 = RaycastResult;
  _.$_$.m5 = Ray;
  _.$_$.n5 = LoadedModelInfoComponent;
  _.$_$.o5 = ModelInfoComponent;
  _.$_$.p5 = ModelTransformComponent;
  _.$_$.q5 = OutlineableComponent;
  _.$_$.r5 = RenderSystem;
  _.$_$.s5 = ViewerComponent;
  _.$_$.t5 = ViewerLineIdsComponent;
  _.$_$.u5 = ViewerObjectComponent;
  _.$_$.v5 = ViewerObjectTransformSystem;
  _.$_$.w5 = ViewerObjectVisibilitySystem;
  _.$_$.x5 = ViewerPresenceSystem;
  _.$_$.y5 = pauseViewerUpdatesOnDraggedEntity;
  _.$_$.z5 = resumeViewerUpdatesOnDraggedEntity;
  _.$_$.a6 = get_viewerObject;
  _.$_$.b6 = FastReplaceAction;
  _.$_$.c6 = ReplaceAction;
  _.$_$.d6 = ReplacePartAction;
  _.$_$.e6 = ClickEventComponent;
  _.$_$.f6 = SelectableComponent;
  _.$_$.g6 = get_isSelected;
  _.$_$.h6 = ComponentDeserializerRegistry;
  _.$_$.i6 = ComponentDeserializer;
  _.$_$.j6 = JsonSerializable;
  _.$_$.k6 = JsonSerializer;
  _.$_$.l6 = afterDeserializeComplete;
  _.$_$.m6 = beforeDeserialize;
  _.$_$.n6 = beforeParsingComponents;
  _.$_$.o6 = get_serializable_0;
  _.$_$.p6 = SerializableComponent;
  _.$_$.q6 = UnserializableEntityComponent;
  _.$_$.r6 = AxisAlignedBox;
  _.$_$.s6 = ConvexPolyhedron;
  _.$_$.t6 = Face;
  _.$_$.u6 = PolyhedronGroup;
  _.$_$.v6 = merge;
  _.$_$.w6 = RestrictAllowedRequiredHostsComponent;
  _.$_$.x6 = SnapActionCandidateSortAndSelectStrategy;
  _.$_$.y6 = SnapCandidateComponent;
  _.$_$.z6 = SnapRootComponent;
  _.$_$.a7 = SnapSettings;
  _.$_$.b7 = get_snapRootSubTree;
  _.$_$.c7 = triggerMovedToValidSnapPositionComponent;
  _.$_$.d7 = IsLoadingSnapshotComponent;
  _.$_$.e7 = SnapshotIgnoreComponent;
  _.$_$.f7 = SnapshotService;
  _.$_$.g7 = LocalTransformComponent;
  _.$_$.h7 = TransformSystem;
  _.$_$.i7 = WorldTransformComponent;
  _.$_$.j7 = get_isHanging;
  _.$_$.k7 = get_localTransform;
  _.$_$.l7 = get_worldPosition;
  _.$_$.m7 = get_worldRotation;
  _.$_$.n7 = get_worldTransform;
  _.$_$.o7 = Measurer;
  _.$_$.p7 = getCoreVersion;
  _.$_$.q7 = NoValidConnectorAvailableValidationResult;
  _.$_$.r7 = UnknownErrorValidationResult;
  _.$_$.s7 = ValidSnapActionCandidateOrErrors;
  _.$_$.t7 = ValidationImpl;
  _.$_$.u7 = ValidationResultFail;
  _.$_$.v7 = ValidationResultWarning;
  _.$_$.w7 = ValidationResult;
  _.$_$.x7 = ValidationService;
  _.$_$.y7 = RotationDegreeOfFreedom_NONE_getInstance;
  _.$_$.z7 = RotationDegreeOfFreedom_ONE_getInstance;
  _.$_$.a8 = LogLevel_DEBUG_getInstance;
  _.$_$.b8 = LogLevel_ERROR_getInstance;
  _.$_$.c8 = LogLevel_INFO_getInstance;
  _.$_$.d8 = LogLevel_WARN_getInstance;
  _.$_$.e8 = RelationOriginAlongX_CENTER_getInstance;
  _.$_$.f8 = RelationOriginAlongX_LEFT_getInstance;
  _.$_$.g8 = RelationOriginAlongX_RIGHT_getInstance;
  _.$_$.h8 = RelationOriginAlongY_BOTTOM_getInstance;
  _.$_$.i8 = RelationOriginAlongY_CENTER_getInstance;
  _.$_$.j8 = RelationOriginAlongY_TOP_getInstance;
  _.$_$.k8 = RelationOriginAlongZ_BACK_getInstance;
  _.$_$.l8 = RelationOriginAlongZ_CENTER_getInstance;
  _.$_$.m8 = RelationOriginAlongZ_FRONT_getInstance;
  _.$_$.n8 = ValidationResultType_FAIL_getInstance;
  _.$_$.o8 = ValidationResultType_WARNING_getInstance;
  _.$_$.p8 = addHistoryModule;
  _.$_$.q8 = setLogModule;
  _.$_$.r8 = createEntityInternal;
  _.$_$.s8 = createEntity;
  _.$_$.t8 = createFromSpecificationInternal;
  _.$_$.u8 = createFromSpecification;
  _.$_$.v8 = evaluateSnapCandidates;
  _.$_$.w8 = evaluateSnapCandidate;
  _.$_$.x8 = getFirstValidSnapAction;
  _.$_$.y8 = validateCurrentState;
  _.$_$.z8 = validateSnaps;
  _.$_$.a9 = validateSnap;
  _.$_$.b9 = AssemblyPartsComponent_init_$Create$;
  _.$_$.c9 = QuaternionFromDouble;
  _.$_$.d9 = SizeFromVector;
  _.$_$.e9 = __VectorIntConstructorKotlin;
  _.$_$.f9 = CuboidFromSize;
  _.$_$.g9 = CuboidFromSizeAndCenter;
  _.$_$.h9 = LocalTransformComponentFromPosAndRot;
  _.$_$.i9 = Companion_instance;
  _.$_$.j9 = Companion_instance_1;
  _.$_$.k9 = Companion_getInstance_3;
  _.$_$.l9 = Companion_instance_3;
  _.$_$.m9 = Companion_getInstance_6;
  _.$_$.n9 = ProductCatalogFunctions_instance;
  _.$_$.o9 = Companion_instance_6;
  _.$_$.p9 = Companion_getInstance_8;
  _.$_$.q9 = Companion_instance_8;
  _.$_$.r9 = Companion_instance_9;
  _.$_$.s9 = Companion_instance_10;
  _.$_$.t9 = ColliderUtils_instance;
  _.$_$.u9 = CollisionUtils_instance;
  _.$_$.v9 = ComponentIdSpan_instance;
  _.$_$.w9 = ComponentIds_instance;
  _.$_$.x9 = ComponentUtils_instance;
  _.$_$.y9 = Companion_instance_15;
  _.$_$.z9 = Companion_instance_16;
  _.$_$.aa = ConnectionUtils_instance;
  _.$_$.ba = Companion_getInstance_18;
  _.$_$.ca = Companion_instance_20;
  _.$_$.da = Companion_instance_21;
  _.$_$.ea = ConnectorTagConstants_instance;
  _.$_$.fa = ConnectorType_instance;
  _.$_$.ga = ConnectorUtils_instance;
  _.$_$.ha = Companion_getInstance_23;
  _.$_$.ia = Companion_instance_24;
  _.$_$.ja = RelativeConnectorRepositioner_instance;
  _.$_$.ka = RotationDegreeOfFreedomImpostor_instance;
  _.$_$.la = Companion_instance_27;
  _.$_$.ma = Companion_instance_29;
  _.$_$.na = Companion_instance_30;
  _.$_$.oa = Companion_instance_31;
  _.$_$.pa = Companion_instance_32;
  _.$_$.qa = Companion_instance_34;
  _.$_$.ra = Companion_instance_35;
  _.$_$.sa = Companion_getInstance_39;
  _.$_$.ta = Companion_getInstance_41;
  _.$_$.ua = EntityGroupUtils_instance;
  _.$_$.va = Companion_getInstance_44;
  _.$_$.wa = StaticComponent_getInstance;
  _.$_$.xa = Companion_getInstance_48;
  _.$_$.ya = Companion_instance_48;
  _.$_$.za = HierarchyUtils_instance;
  _.$_$.ab = InSceneComponent_instance;
  _.$_$.bb = SceneComponent_instance;
  _.$_$.cb = Companion_instance_50;
  _.$_$.db = HistoryEvent_instance;
  _.$_$.eb = LogLevelJavascriptImpostor_instance;
  _.$_$.fb = LoggerState_getInstance;
  _.$_$.gb = MathUtils_getInstance;
  _.$_$.hb = $serializer_getInstance_3;
  _.$_$.ib = Companion_instance_54;
  _.$_$.jb = $serializer_getInstance_4;
  _.$_$.kb = Companion_getInstance_57;
  _.$_$.lb = Companion_getInstance_58;
  _.$_$.mb = RelationOriginAlongXImpostor_getInstance;
  _.$_$.nb = RelationOriginAlongYImpostor_getInstance;
  _.$_$.ob = RelationOriginAlongZImpostor_getInstance;
  _.$_$.pb = $serializer_getInstance_6;
  _.$_$.qb = $serializer_getInstance_7;
  _.$_$.rb = Companion_getInstance_60;
  _.$_$.sb = $serializer_getInstance_8;
  _.$_$.tb = Companion_getInstance_61;
  _.$_$.ub = VectorConstants_getInstance;
  _.$_$.vb = MeasurementUtils_getInstance;
  _.$_$.wb = ProductUtils_instance;
  _.$_$.xb = ProppingComponent_instance;
  _.$_$.yb = Companion_instance_62;
  _.$_$.zb = Companion_instance_63;
  _.$_$.ac = RaycastUtils_instance;
  _.$_$.bc = Companion_instance_64;
  _.$_$.cc = Companion_instance_65;
  _.$_$.dc = Companion_instance_67;
  _.$_$.ec = ModelUtils_getInstance;
  _.$_$.fc = RenderedComponent_instance;
  _.$_$.gc = Companion_instance_71;
  _.$_$.hc = Companion_instance_72;
  _.$_$.ic = Companion_instance_73;
  _.$_$.jc = Companion_instance_78;
  _.$_$.kc = MultiSelectionEnabledComponent_instance;
  _.$_$.lc = Companion_instance_79;
  _.$_$.mc = SelectedComponent_instance;
  _.$_$.nc = SceneReloadingComponent_instance;
  _.$_$.oc = Companion_getInstance_85;
  _.$_$.pc = Companion_getInstance_93;
  _.$_$.qc = PolyhedronUtils_getInstance;
  _.$_$.rc = Companion_instance_97;
  _.$_$.sc = SnapActionCandidateSortAndSelectStrategies_getInstance;
  _.$_$.tc = Companion_instance_99;
  _.$_$.uc = Companion_instance_100;
  _.$_$.vc = SnapUtils_instance;
  _.$_$.wc = Companion_instance_101;
  _.$_$.xc = Companion_instance_104;
  _.$_$.yc = ApiSystemIds_instance;
  _.$_$.zc = AlwaysHangDownComponent_instance;
  _.$_$.ad = Companion_getInstance_107;
  _.$_$.bd = Companion_instance_107;
  _.$_$.cd = TransformUtils_instance;
  _.$_$.dd = Companion_getInstance_110;
  _.$_$.ed = Companion_instance_112;
  _.$_$.fd = Companion_instance_114;
  //endregion
  return _;
}));

//# sourceMappingURL=core-core-api.js.map
